(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue-property-decorator"), require("vuex"), require("vue-i18n"), require("vue"), require("vue-class-component"));
	else if(typeof define === 'function' && define.amd)
		define(["vue-property-decorator", "vuex", "vue-i18n", "vue", "vue-class-component"], factory);
	else if(typeof exports === 'object')
		exports["mayday-editor"] = factory(require("vue-property-decorator"), require("vuex"), require("vue-i18n"), require("vue"), require("vue-class-component"));
	else
		root["mayday-editor"] = factory(root["vue-property-decorator"], root["vuex"], root["vue-i18n"], root["vue"], root["vue-class-component"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__01a6__, __WEBPACK_EXTERNAL_MODULE__5880__, __WEBPACK_EXTERNAL_MODULE__85b3__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_c93a__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "01a6":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__01a6__;

/***/ }),

/***/ "01b4":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "0323":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineBubbleMenu_vue_vue_type_style_index_0_id_6b46fe68_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3314");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineBubbleMenu_vue_vue_type_style_index_0_id_6b46fe68_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineBubbleMenu_vue_vue_type_style_index_0_id_6b46fe68_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "03a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TranslationPicker_vue_vue_type_style_index_0_id_c0580934_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fde");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TranslationPicker_vue_vue_type_style_index_0_id_c0580934_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TranslationPicker_vue_vue_type_style_index_0_id_c0580934_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIntegerOrInfinity = __webpack_require__("5926");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});


/***/ }),

/***/ "04d1":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var arraySlice = __webpack_require__("f36a");

var Function = global.Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "0613":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/store/actions.ts
var actions = __webpack_require__("fc60");

// CONCATENATED MODULE: ./src/store/getters.ts
var getters = {
  isLoading: function isLoading(_ref) {
    var filesAreUploading = _ref.filesAreUploading;
    return filesAreUploading;
  },
  nbFilesUploading: function nbFilesUploading(_ref2) {
    var _nbFilesUploading = _ref2.nbFilesUploading;
    return _nbFilesUploading;
  },
  filesAreUploading: function filesAreUploading(_ref3) {
    var _filesAreUploading = _ref3.filesAreUploading;
    return _filesAreUploading;
  },
  isFileUploadCallbackProvided: function isFileUploadCallbackProvided(_ref4) {
    var callbacks = _ref4.callbacks;
    return callbacks.handleFileUpload != null;
  }
};
/* harmony default export */ var store_getters = (getters);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./src/store/mutations-types.ts
var mutations_types = __webpack_require__("07cd");

// CONCATENATED MODULE: ./src/store/mutations.ts


var _types$SET_OPTIONAL_C;


/* harmony default export */ var mutations = (_types$SET_OPTIONAL_C = {}, Object(defineProperty["a" /* default */])(_types$SET_OPTIONAL_C, mutations_types["c" /* SET_OPTIONAL_CALLBACKS */], function (state) {
  var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  state.callbacks = callbacks;
}), Object(defineProperty["a" /* default */])(_types$SET_OPTIONAL_C, mutations_types["a" /* SET_FILES_ARE_UPLOADING */], function (state, loading) {
  state.filesAreUploading = loading;
}), Object(defineProperty["a" /* default */])(_types$SET_OPTIONAL_C, mutations_types["b" /* SET_FILES_NUMBER_UPLOADING */], function (state, nb) {
  state.nbFilesUploading = nb;
}), _types$SET_OPTIONAL_C);
// CONCATENATED MODULE: ./src/store/index.ts




var state = function state() {
  return {
    // plugin related
    callbacks: {},
    // image upload
    filesAreUploading: false,
    nbFilesUploading: 0
  };
};

var stateObj = state();
/* harmony default export */ var store = __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: store_getters,
  actions: actions["a" /* default */],
  mutations: mutations
});

/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "073e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formatter = __webpack_require__("5dbe")

var fault = create(Error)

module.exports = fault

fault.eval = create(EvalError)
fault.range = create(RangeError)
fault.reference = create(ReferenceError)
fault.syntax = create(SyntaxError)
fault.type = create(TypeError)
fault.uri = create(URIError)

fault.create = create

// Create a new `EConstructor`, with the formatted `format` as a first argument.
function create(EConstructor) {
  FormattedError.displayName = EConstructor.displayName || EConstructor.name

  return FormattedError

  function FormattedError(format) {
    if (format) {
      format = formatter.apply(null, arguments)
    }

    return new EConstructor(format)
  }
}


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "07cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_OPTIONAL_CALLBACKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_FILES_ARE_UPLOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_FILES_NUMBER_UPLOADING; });
var SET_OPTIONAL_CALLBACKS = "SET_OPTIONAL_CALLBACKS";
var SET_FILES_ARE_UPLOADING = "SET_FILES_ARE_UPLOADING";
var SET_FILES_NUMBER_UPLOADING = "SET_FILES_NUMBER_UPLOADING";

/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0a7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableOfContents_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableOfContents_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableOfContents_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d3b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "1020":
/***/ (function(module, exports) {

function deepFreeze(obj) {
    if (obj instanceof Map) {
        obj.clear = obj.delete = obj.set = function () {
            throw new Error('map is read-only');
        };
    } else if (obj instanceof Set) {
        obj.add = obj.clear = obj.delete = function () {
            throw new Error('set is read-only');
        };
    }

    // Freeze self
    Object.freeze(obj);

    Object.getOwnPropertyNames(obj).forEach(function (name) {
        var prop = obj[name];

        // Freeze prop if it is an object
        if (typeof prop == 'object' && !Object.isFrozen(prop)) {
            deepFreeze(prop);
        }
    });

    return obj;
}

var deepFreezeEs6 = deepFreeze;
var _default = deepFreeze;
deepFreezeEs6.default = _default;

/** @implements CallbackResponse */
class Response {
  /**
   * @param {CompiledMode} mode
   */
  constructor(mode) {
    // eslint-disable-next-line no-undefined
    if (mode.data === undefined) mode.data = {};

    this.data = mode.data;
    this.isMatchIgnored = false;
  }

  ignoreMatch() {
    this.isMatchIgnored = true;
  }
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHTML(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}

/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */
function inherit(original, ...objects) {
  /** @type Record<string,any> */
  const result = Object.create(null);

  for (const key in original) {
    result[key] = original[key];
  }
  objects.forEach(function(obj) {
    for (const key in obj) {
      result[key] = obj[key];
    }
  });
  return /** @type {T} */ (result);
}

/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */

/** @typedef {{kind?: string, sublanguage?: boolean}} Node */
/** @typedef {{walk: (r: Renderer) => void}} Tree */
/** */

const SPAN_CLOSE = '</span>';

/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */
const emitsWrappingTags = (node) => {
  return !!node.kind;
};

/** @type {Renderer} */
class HTMLRenderer {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(parseTree, options) {
    this.buffer = "";
    this.classPrefix = options.classPrefix;
    parseTree.walk(this);
  }

  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(text) {
    this.buffer += escapeHTML(text);
  }

  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(node) {
    if (!emitsWrappingTags(node)) return;

    let className = node.kind;
    if (!node.sublanguage) {
      className = `${this.classPrefix}${className}`;
    }
    this.span(className);
  }

  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(node) {
    if (!emitsWrappingTags(node)) return;

    this.buffer += SPAN_CLOSE;
  }

  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }

  // helpers

  /**
   * Builds a span element
   *
   * @param {string} className */
  span(className) {
    this.buffer += `<span class="${className}">`;
  }
}

/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */
/**  */

class TokenTree {
  constructor() {
    /** @type DataNode */
    this.rootNode = { children: [] };
    this.stack = [this.rootNode];
  }

  get top() {
    return this.stack[this.stack.length - 1];
  }

  get root() { return this.rootNode; }

  /** @param {Node} node */
  add(node) {
    this.top.children.push(node);
  }

  /** @param {string} kind */
  openNode(kind) {
    /** @type Node */
    const node = { kind, children: [] };
    this.add(node);
    this.stack.push(node);
  }

  closeNode() {
    if (this.stack.length > 1) {
      return this.stack.pop();
    }
    // eslint-disable-next-line no-undefined
    return undefined;
  }

  closeAllNodes() {
    while (this.closeNode());
  }

  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }

  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(builder) {
    // this does not
    return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
  }

  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(builder, node) {
    if (typeof node === "string") {
      builder.addText(node);
    } else if (node.children) {
      builder.openNode(node);
      node.children.forEach((child) => this._walk(builder, child));
      builder.closeNode(node);
    }
    return builder;
  }

  /**
   * @param {Node} node
   */
  static _collapse(node) {
    if (typeof node === "string") return;
    if (!node.children) return;

    if (node.children.every(el => typeof el === "string")) {
      // node.text = node.children.join("");
      // delete node.children;
      node.children = [node.children.join("")];
    } else {
      node.children.forEach((child) => {
        TokenTree._collapse(child);
      });
    }
  }
}

/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/

/**
 * @implements {Emitter}
 */
class TokenTreeEmitter extends TokenTree {
  /**
   * @param {*} options
   */
  constructor(options) {
    super();
    this.options = options;
  }

  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(text, kind) {
    if (text === "") { return; }

    this.openNode(kind);
    this.addText(text);
    this.closeNode();
  }

  /**
   * @param {string} text
   */
  addText(text) {
    if (text === "") { return; }

    this.add(text);
  }

  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(emitter, name) {
    /** @type DataNode */
    const node = emitter.root;
    node.kind = name;
    node.sublanguage = true;
    this.add(node);
  }

  toHTML() {
    const renderer = new HTMLRenderer(this, this.options);
    return renderer.value();
  }

  finalize() {
    return true;
  }
}

/**
 * @param {string} value
 * @returns {RegExp}
 * */
function escape(value) {
  return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => source(x)).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either(...args) {
  const joined = '(' + args.map((x) => source(x)).join("|") + ")";
  return joined;
}

/**
 * @param {RegExp} re
 * @returns {number}
 */
function countMatchGroups(re) {
  return (new RegExp(re.toString() + '|')).exec('').length - 1;
}

/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */
function startsWith(re, lexeme) {
  const match = re && re.exec(lexeme);
  return match && match.index === 0;
}

// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {string} separator
 * @returns {string}
 */
function join(regexps, separator = "|") {
  let numCaptures = 0;

  return regexps.map((regex) => {
    numCaptures += 1;
    const offset = numCaptures;
    let re = source(regex);
    let out = '';

    while (re.length > 0) {
      const match = BACKREF_RE.exec(re);
      if (!match) {
        out += re;
        break;
      }
      out += re.substring(0, match.index);
      re = re.substring(match.index + match[0].length);
      if (match[0][0] === '\\' && match[1]) {
        // Adjust the backreference.
        out += '\\' + String(Number(match[1]) + offset);
      } else {
        out += match[0];
        if (match[0] === '(') {
          numCaptures++;
        }
      }
    }
    return out;
  }).map(re => `(${re})`).join(separator);
}

// Common regexps
const MATCH_NOTHING_RE = /\b\B/;
const IDENT_RE = '[a-zA-Z]\\w*';
const UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/
const SHEBANG = (opts = {}) => {
  const beginShebang = /^#![ ]*\//;
  if (opts.binary) {
    opts.begin = concat(
      beginShebang,
      /.*\b/,
      opts.binary,
      /\b.*/);
  }
  return inherit({
    className: 'meta',
    begin: beginShebang,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (m, resp) => {
      if (m.index !== 0) resp.ignoreMatch();
    }
  }, opts);
};

// Common modes
const BACKSLASH_ESCAPE = {
  begin: '\\\\[\\s\\S]', relevance: 0
};
const APOS_STRING_MODE = {
  className: 'string',
  begin: '\'',
  end: '\'',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const QUOTE_STRING_MODE = {
  className: 'string',
  begin: '"',
  end: '"',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const PHRASAL_WORDS_MODE = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */
const COMMENT = function(begin, end, modeOptions = {}) {
  const mode = inherit(
    {
      className: 'comment',
      begin,
      end,
      contains: []
    },
    modeOptions
  );
  mode.contains.push(PHRASAL_WORDS_MODE);
  mode.contains.push({
    className: 'doctag',
    begin: '(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):',
    relevance: 0
  });
  return mode;
};
const C_LINE_COMMENT_MODE = COMMENT('//', '$');
const C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
const HASH_COMMENT_MODE = COMMENT('#', '$');
const NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE,
  relevance: 0
};
const C_NUMBER_MODE = {
  className: 'number',
  begin: C_NUMBER_RE,
  relevance: 0
};
const BINARY_NUMBER_MODE = {
  className: 'number',
  begin: BINARY_NUMBER_RE,
  relevance: 0
};
const CSS_NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE + '(' +
    '%|em|ex|ch|rem' +
    '|vw|vh|vmin|vmax' +
    '|cm|mm|in|pt|pc|px' +
    '|deg|grad|rad|turn' +
    '|s|ms' +
    '|Hz|kHz' +
    '|dpi|dpcm|dppx' +
    ')?',
  relevance: 0
};
const REGEXP_MODE = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: 'regexp',
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      BACKSLASH_ESCAPE,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [BACKSLASH_ESCAPE]
      }
    ]
  }]
};
const TITLE_MODE = {
  className: 'title',
  begin: IDENT_RE,
  relevance: 0
};
const UNDERSCORE_TITLE_MODE = {
  className: 'title',
  begin: UNDERSCORE_IDENT_RE,
  relevance: 0
};
const METHOD_GUARD = {
  // excludes method names from keyword processing
  begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
  relevance: 0
};

/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */
const END_SAME_AS_BEGIN = function(mode) {
  return Object.assign(mode,
    {
      /** @type {ModeCallback} */
      'on:begin': (m, resp) => { resp.data._beginMatch = m[1]; },
      /** @type {ModeCallback} */
      'on:end': (m, resp) => { if (resp.data._beginMatch !== m[1]) resp.ignoreMatch(); }
    });
};

var MODES = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: MATCH_NOTHING_RE,
    IDENT_RE: IDENT_RE,
    UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
    NUMBER_RE: NUMBER_RE,
    C_NUMBER_RE: C_NUMBER_RE,
    BINARY_NUMBER_RE: BINARY_NUMBER_RE,
    RE_STARTERS_RE: RE_STARTERS_RE,
    SHEBANG: SHEBANG,
    BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
    APOS_STRING_MODE: APOS_STRING_MODE,
    QUOTE_STRING_MODE: QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
    COMMENT: COMMENT,
    C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE: HASH_COMMENT_MODE,
    NUMBER_MODE: NUMBER_MODE,
    C_NUMBER_MODE: C_NUMBER_MODE,
    BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
    CSS_NUMBER_MODE: CSS_NUMBER_MODE,
    REGEXP_MODE: REGEXP_MODE,
    TITLE_MODE: TITLE_MODE,
    UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE,
    METHOD_GUARD: METHOD_GUARD,
    END_SAME_AS_BEGIN: END_SAME_AS_BEGIN
});

// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833

// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.

// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.

// ------

// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */
function skipIfhasPrecedingDot(match, response) {
  const before = match.input[match.index - 1];
  if (before === ".") {
    response.ignoreMatch();
  }
}


/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */
function beginKeywords(mode, parent) {
  if (!parent) return;
  if (!mode.beginKeywords) return;

  // for languages with keywords that include non-word characters checking for
  // a word boundary is not sufficient, so instead we check for a word boundary
  // or whitespace - this does no harm in any case since our keyword engine
  // doesn't allow spaces in keywords anyways and we still check for the boundary
  // first
  mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
  mode.__beforeBegin = skipIfhasPrecedingDot;
  mode.keywords = mode.keywords || mode.beginKeywords;
  delete mode.beginKeywords;

  // prevents double relevance, the keywords themselves provide
  // relevance, the mode doesn't need to double it
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 0;
}

/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */
function compileIllegal(mode, _parent) {
  if (!Array.isArray(mode.illegal)) return;

  mode.illegal = either(...mode.illegal);
}

/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */
function compileMatch(mode, _parent) {
  if (!mode.match) return;
  if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");

  mode.begin = mode.match;
  delete mode.match;
}

/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */
function compileRelevance(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 1;
}

// keywords that should have no default relevance value
const COMMON_KEYWORDS = [
  'of',
  'and',
  'for',
  'in',
  'not',
  'or',
  'if',
  'then',
  'parent', // common variable name
  'list', // common variable name
  'value' // common variable name
];

const DEFAULT_KEYWORD_CLASSNAME = "keyword";

/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */
function compileKeywords(rawKeywords, caseInsensitive, className = DEFAULT_KEYWORD_CLASSNAME) {
  /** @type KeywordDict */
  const compiledKeywords = {};

  // input can be a string of keywords, an array of keywords, or a object with
  // named keys representing className (which can then point to a string or array)
  if (typeof rawKeywords === 'string') {
    compileList(className, rawKeywords.split(" "));
  } else if (Array.isArray(rawKeywords)) {
    compileList(className, rawKeywords);
  } else {
    Object.keys(rawKeywords).forEach(function(className) {
      // collapse all our objects back into the parent object
      Object.assign(
        compiledKeywords,
        compileKeywords(rawKeywords[className], caseInsensitive, className)
      );
    });
  }
  return compiledKeywords;

  // ---

  /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} className
   * @param {Array<string>} keywordList
   */
  function compileList(className, keywordList) {
    if (caseInsensitive) {
      keywordList = keywordList.map(x => x.toLowerCase());
    }
    keywordList.forEach(function(keyword) {
      const pair = keyword.split('|');
      compiledKeywords[pair[0]] = [className, scoreForKeyword(pair[0], pair[1])];
    });
  }
}

/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */
function scoreForKeyword(keyword, providedScore) {
  // manual scores always win over common keywords
  // so you can force a score of 1 if you really insist
  if (providedScore) {
    return Number(providedScore);
  }

  return commonKeyword(keyword) ? 0 : 1;
}

/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */
function commonKeyword(keyword) {
  return COMMON_KEYWORDS.includes(keyword.toLowerCase());
}

// compilation

/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @param {{plugins: HLJSPlugin[]}} opts
 * @returns {CompiledLanguage}
 */
function compileLanguage(language, { plugins }) {
  /**
   * Builds a regex with the case sensativility of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */
  function langRe(value, global) {
    return new RegExp(
      source(value),
      'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
    );
  }

  /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */
  class MultiRegex {
    constructor() {
      this.matchIndexes = {};
      // @ts-ignore
      this.regexes = [];
      this.matchAt = 1;
      this.position = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      opts.position = this.position++;
      // @ts-ignore
      this.matchIndexes[this.matchAt] = opts;
      this.regexes.push([opts, re]);
      this.matchAt += countMatchGroups(re) + 1;
    }

    compile() {
      if (this.regexes.length === 0) {
        // avoids the need to check length every time exec is called
        // @ts-ignore
        this.exec = () => null;
      }
      const terminators = this.regexes.map(el => el[1]);
      this.matcherRe = langRe(join(terminators), true);
      this.lastIndex = 0;
    }

    /** @param {string} s */
    exec(s) {
      this.matcherRe.lastIndex = this.lastIndex;
      const match = this.matcherRe.exec(s);
      if (!match) { return null; }

      // eslint-disable-next-line no-undefined
      const i = match.findIndex((el, i) => i > 0 && el !== undefined);
      // @ts-ignore
      const matchData = this.matchIndexes[i];
      // trim off any earlier non-relevant match groups (ie, the other regex
      // match groups that make up the multi-matcher)
      match.splice(0, i);

      return Object.assign(match, matchData);
    }
  }

  /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */
  class ResumableMultiRegex {
    constructor() {
      // @ts-ignore
      this.rules = [];
      // @ts-ignore
      this.multiRegexes = [];
      this.count = 0;

      this.lastIndex = 0;
      this.regexIndex = 0;
    }

    // @ts-ignore
    getMatcher(index) {
      if (this.multiRegexes[index]) return this.multiRegexes[index];

      const matcher = new MultiRegex();
      this.rules.slice(index).forEach(([re, opts]) => matcher.addRule(re, opts));
      matcher.compile();
      this.multiRegexes[index] = matcher;
      return matcher;
    }

    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }

    considerAll() {
      this.regexIndex = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      this.rules.push([re, opts]);
      if (opts.type === "begin") this.count++;
    }

    /** @param {string} s */
    exec(s) {
      const m = this.getMatcher(this.regexIndex);
      m.lastIndex = this.lastIndex;
      let result = m.exec(s);

      // The following is because we have no easy way to say "resume scanning at the
      // existing position but also skip the current rule ONLY". What happens is
      // all prior rules are also skipped which can result in matching the wrong
      // thing. Example of matching "booger":

      // our matcher is [string, "booger", number]
      //
      // ....booger....

      // if "booger" is ignored then we'd really need a regex to scan from the
      // SAME position for only: [string, number] but ignoring "booger" (if it
      // was the first match), a simple resume would scan ahead who knows how
      // far looking only for "number", ignoring potential string matches (or
      // future "booger" matches that might be valid.)

      // So what we do: We execute two matchers, one resuming at the same
      // position, but the second full matcher starting at the position after:

      //     /--- resume first regex match here (for [number])
      //     |/---- full match here for [string, "booger", number]
      //     vv
      // ....booger....

      // Which ever results in a match first is then used. So this 3-4 step
      // process essentially allows us to say "match at this position, excluding
      // a prior rule that was ignored".
      //
      // 1. Match "booger" first, ignore. Also proves that [string] does non match.
      // 2. Resume matching for [number]
      // 3. Match at index + 1 for [string, "booger", number]
      // 4. If #2 and #3 result in matches, which came first?
      if (this.resumingScanAtSamePosition()) {
        if (result && result.index === this.lastIndex) ; else { // use the second matcher result
          const m2 = this.getMatcher(0);
          m2.lastIndex = this.lastIndex + 1;
          result = m2.exec(s);
        }
      }

      if (result) {
        this.regexIndex += result.position + 1;
        if (this.regexIndex === this.count) {
          // wrap-around to considering all matches again
          this.considerAll();
        }
      }

      return result;
    }
  }

  /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */
  function buildModeRegex(mode) {
    const mm = new ResumableMultiRegex();

    mode.contains.forEach(term => mm.addRule(term.begin, { rule: term, type: "begin" }));

    if (mode.terminatorEnd) {
      mm.addRule(mode.terminatorEnd, { type: "end" });
    }
    if (mode.illegal) {
      mm.addRule(mode.illegal, { type: "illegal" });
    }

    return mm;
  }

  /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */

  /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */
  function compileMode(mode, parent) {
    const cmode = /** @type CompiledMode */ (mode);
    if (mode.isCompiled) return cmode;

    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      compileMatch
    ].forEach(ext => ext(mode, parent));

    language.compilerExtensions.forEach(ext => ext(mode, parent));

    // __beforeBegin is considered private API, internal use only
    mode.__beforeBegin = null;

    [
      beginKeywords,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      compileIllegal,
      // default to 1 relevance if not specified
      compileRelevance
    ].forEach(ext => ext(mode, parent));

    mode.isCompiled = true;

    let keywordPattern = null;
    if (typeof mode.keywords === "object") {
      keywordPattern = mode.keywords.$pattern;
      delete mode.keywords.$pattern;
    }

    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
    }

    // both are not allowed
    if (mode.lexemes && keywordPattern) {
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    }

    // `mode.lexemes` was the old standard before we added and now recommend
    // using `keywords.$pattern` to pass the keyword pattern
    keywordPattern = keywordPattern || mode.lexemes || /\w+/;
    cmode.keywordPatternRe = langRe(keywordPattern, true);

    if (parent) {
      if (!mode.begin) mode.begin = /\B|\b/;
      cmode.beginRe = langRe(mode.begin);
      if (mode.endSameAsBegin) mode.end = mode.begin;
      if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
      if (mode.end) cmode.endRe = langRe(mode.end);
      cmode.terminatorEnd = source(mode.end) || '';
      if (mode.endsWithParent && parent.terminatorEnd) {
        cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
      }
    }
    if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ (mode.illegal));
    if (!mode.contains) mode.contains = [];

    mode.contains = [].concat(...mode.contains.map(function(c) {
      return expandOrCloneMode(c === 'self' ? mode : c);
    }));
    mode.contains.forEach(function(c) { compileMode(/** @type Mode */ (c), cmode); });

    if (mode.starts) {
      compileMode(mode.starts, parent);
    }

    cmode.matcher = buildModeRegex(cmode);
    return cmode;
  }

  if (!language.compilerExtensions) language.compilerExtensions = [];

  // self is not valid at the top-level
  if (language.contains && language.contains.includes('self')) {
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  }

  // we need a null object, which inherit will guarantee
  language.classNameAliases = inherit(language.classNameAliases || {});

  return compileMode(/** @type Mode */ (language));
}

/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */
function dependencyOnParent(mode) {
  if (!mode) return false;

  return mode.endsWithParent || dependencyOnParent(mode.starts);
}

/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */
function expandOrCloneMode(mode) {
  if (mode.variants && !mode.cachedVariants) {
    mode.cachedVariants = mode.variants.map(function(variant) {
      return inherit(mode, { variants: null }, variant);
    });
  }

  // EXPAND
  // if we have variants then essentially "replace" the mode with the variants
  // this happens in compileMode, where this function is called from
  if (mode.cachedVariants) {
    return mode.cachedVariants;
  }

  // CLONE
  // if we have dependencies on parents then we need a unique
  // instance of ourselves, so we can be reused with many
  // different parents without issue
  if (dependencyOnParent(mode)) {
    return inherit(mode, { starts: mode.starts ? inherit(mode.starts) : null });
  }

  if (Object.isFrozen(mode)) {
    return inherit(mode);
  }

  // no special dependency issues, just return ourselves
  return mode;
}

var version = "10.7.3";

// @ts-nocheck

function hasValueOrEmptyAttribute(value) {
  return Boolean(value || value === "");
}

function BuildVuePlugin(hljs) {
  const Component = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: false
      };
    },
    computed: {
      className() {
        if (this.unknownLanguage) return "";

        return "hljs " + this.detectedLanguage;
      },
      highlighted() {
        // no idea what language to use, return raw code
        if (!this.autoDetect && !hljs.getLanguage(this.language)) {
          console.warn(`The language "${this.language}" you specified could not be found.`);
          this.unknownLanguage = true;
          return escapeHTML(this.code);
        }

        let result = {};
        if (this.autoDetect) {
          result = hljs.highlightAuto(this.code);
          this.detectedLanguage = result.language;
        } else {
          result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
          this.detectedLanguage = this.language;
        }
        return result.value;
      },
      autoDetect() {
        return !this.language || hasValueOrEmptyAttribute(this.autodetect);
      },
      ignoreIllegals() {
        return true;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(createElement) {
      return createElement("pre", {}, [
        createElement("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };

  const VuePlugin = {
    install(Vue) {
      Vue.component('highlightjs', Component);
    }
  };

  return { Component, VuePlugin };
}

/* plugin itself */

/** @type {HLJSPlugin} */
const mergeHTMLPlugin = {
  "after:highlightElement": ({ el, result, text }) => {
    const originalStream = nodeStream(el);
    if (!originalStream.length) return;

    const resultNode = document.createElement('div');
    resultNode.innerHTML = result.value;
    result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
  }
};

/* Stream merging support functions */

/**
 * @typedef Event
 * @property {'start'|'stop'} event
 * @property {number} offset
 * @property {Node} node
 */

/**
 * @param {Node} node
 */
function tag(node) {
  return node.nodeName.toLowerCase();
}

/**
 * @param {Node} node
 */
function nodeStream(node) {
  /** @type Event[] */
  const result = [];
  (function _nodeStream(node, offset) {
    for (let child = node.firstChild; child; child = child.nextSibling) {
      if (child.nodeType === 3) {
        offset += child.nodeValue.length;
      } else if (child.nodeType === 1) {
        result.push({
          event: 'start',
          offset: offset,
          node: child
        });
        offset = _nodeStream(child, offset);
        // Prevent void elements from having an end tag that would actually
        // double them in the output. There are more void elements in HTML
        // but we list only those realistically expected in code display.
        if (!tag(child).match(/br|hr|img|input/)) {
          result.push({
            event: 'stop',
            offset: offset,
            node: child
          });
        }
      }
    }
    return offset;
  })(node, 0);
  return result;
}

/**
 * @param {any} original - the original stream
 * @param {any} highlighted - stream of the highlighted source
 * @param {string} value - the original source itself
 */
function mergeStreams(original, highlighted, value) {
  let processed = 0;
  let result = '';
  const nodeStack = [];

  function selectStream() {
    if (!original.length || !highlighted.length) {
      return original.length ? original : highlighted;
    }
    if (original[0].offset !== highlighted[0].offset) {
      return (original[0].offset < highlighted[0].offset) ? original : highlighted;
    }

    /*
    To avoid starting the stream just before it should stop the order is
    ensured that original always starts first and closes last:

    if (event1 == 'start' && event2 == 'start')
      return original;
    if (event1 == 'start' && event2 == 'stop')
      return highlighted;
    if (event1 == 'stop' && event2 == 'start')
      return original;
    if (event1 == 'stop' && event2 == 'stop')
      return highlighted;

    ... which is collapsed to:
    */
    return highlighted[0].event === 'start' ? original : highlighted;
  }

  /**
   * @param {Node} node
   */
  function open(node) {
    /** @param {Attr} attr */
    function attributeString(attr) {
      return ' ' + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
    }
    // @ts-ignore
    result += '<' + tag(node) + [].map.call(node.attributes, attributeString).join('') + '>';
  }

  /**
   * @param {Node} node
   */
  function close(node) {
    result += '</' + tag(node) + '>';
  }

  /**
   * @param {Event} event
   */
  function render(event) {
    (event.event === 'start' ? open : close)(event.node);
  }

  while (original.length || highlighted.length) {
    let stream = selectStream();
    result += escapeHTML(value.substring(processed, stream[0].offset));
    processed = stream[0].offset;
    if (stream === original) {
      /*
      On any opening or closing tag of the original markup we first close
      the entire highlighted node stack, then render the original tag along
      with all the following original tags at the same offset and then
      reopen all the tags on the highlighted stack.
      */
      nodeStack.reverse().forEach(close);
      do {
        render(stream.splice(0, 1)[0]);
        stream = selectStream();
      } while (stream === original && stream.length && stream[0].offset === processed);
      nodeStack.reverse().forEach(open);
    } else {
      if (stream[0].event === 'start') {
        nodeStack.push(stream[0].node);
      } else {
        nodeStack.pop();
      }
      render(stream.splice(0, 1)[0]);
    }
  }
  return result + escapeHTML(value.substr(processed));
}

/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/

/**
 * @type {Record<string, boolean>}
 */
const seenDeprecations = {};

/**
 * @param {string} message
 */
const error = (message) => {
  console.error(message);
};

/**
 * @param {string} message
 * @param {any} args
 */
const warn = (message, ...args) => {
  console.log(`WARN: ${message}`, ...args);
};

/**
 * @param {string} version
 * @param {string} message
 */
const deprecated = (version, message) => {
  if (seenDeprecations[`${version}/${message}`]) return;

  console.log(`Deprecated as of ${version}. ${message}`);
  seenDeprecations[`${version}/${message}`] = true;
};

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

const escape$1 = escapeHTML;
const inherit$1 = inherit;
const NO_MATCH = Symbol("nomatch");

/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */
const HLJS = function(hljs) {
  // Global internal variables used within the highlight.js library.
  /** @type {Record<string, Language>} */
  const languages = Object.create(null);
  /** @type {Record<string, string>} */
  const aliases = Object.create(null);
  /** @type {HLJSPlugin[]} */
  const plugins = [];

  // safe/production mode - swallows more errors, tries to keep running
  // even if a single syntax or parse hits a fatal error
  let SAFE_MODE = true;
  const fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
  const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
  /** @type {Language} */
  const PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: 'Plain text', contains: [] };

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  /** @type HLJSOptions */
  let options = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: TokenTreeEmitter
  };

  /* Utility functions */

  /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */
  function shouldNotHighlight(languageName) {
    return options.noHighlightRe.test(languageName);
  }

  /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */
  function blockLanguage(block) {
    let classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    const match = options.languageDetectRe.exec(classes);
    if (match) {
      const language = getLanguage(match[1]);
      if (!language) {
        warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
        warn("Falling back to no-highlight mode for this block.", block);
      }
      return language ? match[1] : 'no-highlight';
    }

    return classes
      .split(/\s+/)
      .find((_class) => shouldNotHighlight(_class) || getLanguage(_class));
  }

  /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrlanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode} [continuation] - current continuation mode, if any
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */
  function highlight(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
    let code = "";
    let languageName = "";
    if (typeof optionsOrCode === "object") {
      code = codeOrlanguageName;
      ignoreIllegals = optionsOrCode.ignoreIllegals;
      languageName = optionsOrCode.language;
      // continuation not supported at all via the new API
      // eslint-disable-next-line no-undefined
      continuation = undefined;
    } else {
      // old API
      deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
      deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
      languageName = codeOrlanguageName;
      code = optionsOrCode;
    }

    /** @type {BeforeHighlightContext} */
    const context = {
      code,
      language: languageName
    };
    // the plugin can change the desired language or the code to be highlighted
    // just be changing the object it was passed
    fire("before:highlight", context);

    // a before plugin can usurp the result completely by providing it's own
    // in which case we don't even need to call highlight
    const result = context.result
      ? context.result
      : _highlight(context.language, context.code, ignoreIllegals, continuation);

    result.code = context.code;
    // the plugin can change anything in result to suite it
    fire("after:highlight", result);

    return result;
  }

  /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */
  function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
    /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {RegExpMatchArray} match - regexp match data
     * @returns {KeywordData | false}
     */
    function keywordData(mode, match) {
      const matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
    }

    function processKeywords() {
      if (!top.keywords) {
        emitter.addText(modeBuffer);
        return;
      }

      let lastIndex = 0;
      top.keywordPatternRe.lastIndex = 0;
      let match = top.keywordPatternRe.exec(modeBuffer);
      let buf = "";

      while (match) {
        buf += modeBuffer.substring(lastIndex, match.index);
        const data = keywordData(top, match);
        if (data) {
          const [kind, keywordRelevance] = data;
          emitter.addText(buf);
          buf = "";

          relevance += keywordRelevance;
          if (kind.startsWith("_")) {
            // _ implied for relevance only, do not highlight
            // by applying a class name
            buf += match[0];
          } else {
            const cssClass = language.classNameAliases[kind] || kind;
            emitter.addKeyword(match[0], cssClass);
          }
        } else {
          buf += match[0];
        }
        lastIndex = top.keywordPatternRe.lastIndex;
        match = top.keywordPatternRe.exec(modeBuffer);
      }
      buf += modeBuffer.substr(lastIndex);
      emitter.addText(buf);
    }

    function processSubLanguage() {
      if (modeBuffer === "") return;
      /** @type HighlightResult */
      let result = null;

      if (typeof top.subLanguage === 'string') {
        if (!languages[top.subLanguage]) {
          emitter.addText(modeBuffer);
          return;
        }
        result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
        continuations[top.subLanguage] = /** @type {CompiledMode} */ (result.top);
      } else {
        result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
      }

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Use case in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      emitter.addSublanguage(result.emitter, result.language);
    }

    function processBuffer() {
      if (top.subLanguage != null) {
        processSubLanguage();
      } else {
        processKeywords();
      }
      modeBuffer = '';
    }

    /**
     * @param {Mode} mode - new mode to start
     */
    function startNewMode(mode) {
      if (mode.className) {
        emitter.openNode(language.classNameAliases[mode.className] || mode.className);
      }
      top = Object.create(mode, { parent: { value: top } });
      return top;
    }

    /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */
    function endOfMode(mode, match, matchPlusRemainder) {
      let matched = startsWith(mode.endRe, matchPlusRemainder);

      if (matched) {
        if (mode["on:end"]) {
          const resp = new Response(mode);
          mode["on:end"](match, resp);
          if (resp.isMatchIgnored) matched = false;
        }

        if (matched) {
          while (mode.endsParent && mode.parent) {
            mode = mode.parent;
          }
          return mode;
        }
      }
      // even if on:end fires an `ignore` it's still possible
      // that we might trigger the end node because of a parent mode
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, match, matchPlusRemainder);
      }
    }

    /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */
    function doIgnore(lexeme) {
      if (top.matcher.regexIndex === 0) {
        // no more regexs to potentially match here, so we move the cursor forward one
        // space
        modeBuffer += lexeme[0];
        return 1;
      } else {
        // no need to move the cursor, we still have additional regexes to try and
        // match at this very spot
        resumeScanAtSamePosition = true;
        return 0;
      }
    }

    /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */
    function doBeginMatch(match) {
      const lexeme = match[0];
      const newMode = match.rule;

      const resp = new Response(newMode);
      // first internal before callbacks, then the public ones
      const beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
      for (const cb of beforeCallbacks) {
        if (!cb) continue;
        cb(match, resp);
        if (resp.isMatchIgnored) return doIgnore(lexeme);
      }

      if (newMode && newMode.endSameAsBegin) {
        newMode.endRe = escape(lexeme);
      }

      if (newMode.skip) {
        modeBuffer += lexeme;
      } else {
        if (newMode.excludeBegin) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (!newMode.returnBegin && !newMode.excludeBegin) {
          modeBuffer = lexeme;
        }
      }
      startNewMode(newMode);
      // if (mode["after:begin"]) {
      //   let resp = new Response(mode);
      //   mode["after:begin"](match, resp);
      // }
      return newMode.returnBegin ? 0 : lexeme.length;
    }

    /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */
    function doEndMatch(match) {
      const lexeme = match[0];
      const matchPlusRemainder = codeToHighlight.substr(match.index);

      const endMode = endOfMode(top, match, matchPlusRemainder);
      if (!endMode) { return NO_MATCH; }

      const origin = top;
      if (origin.skip) {
        modeBuffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          modeBuffer = lexeme;
        }
      }
      do {
        if (top.className) {
          emitter.closeNode();
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== endMode.parent);
      if (endMode.starts) {
        if (endMode.endSameAsBegin) {
          endMode.starts.endRe = endMode.endRe;
        }
        startNewMode(endMode.starts);
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }

    function processContinuations() {
      const list = [];
      for (let current = top; current !== language; current = current.parent) {
        if (current.className) {
          list.unshift(current.className);
        }
      }
      list.forEach(item => emitter.openNode(item));
    }

    /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
    let lastMatch = {};

    /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceeding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */
    function processLexeme(textBeforeMatch, match) {
      const lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      modeBuffer += textBeforeMatch;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
        if (!SAFE_MODE) {
          /** @type {AnnotatedError} */
          const err = new Error('0 width match regex');
          err.languageName = languageName;
          err.badRule = lastMatch.rule;
          throw err;
        }
        return 1;
      }
      lastMatch = match;

      if (match.type === "begin") {
        return doBeginMatch(match);
      } else if (match.type === "illegal" && !ignoreIllegals) {
        // illegal match, we do not continue processing
        /** @type {AnnotatedError} */
        const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
        err.mode = top;
        throw err;
      } else if (match.type === "end") {
        const processed = doEndMatch(match);
        if (processed !== NO_MATCH) {
          return processed;
        }
      }

      // edge case for when illegal matches $ (end of line) which is technically
      // a 0 width match but not a begin/end match so it's not caught by the
      // first handler (when ignoreIllegals is true)
      if (match.type === "illegal" && lexeme === "") {
        // advance so we aren't stuck in an infinite loop
        return 1;
      }

      // infinite loops are BAD, this is a last ditch catch all. if we have a
      // decent number of iterations yet our index (cursor position in our
      // parsing) still 3x behind our index then something is very wrong
      // so we bail
      if (iterations > 100000 && iterations > match.index * 3) {
        const err = new Error('potential infinite loop, way more iterations than matches');
        throw err;
      }

      /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */

      modeBuffer += lexeme;
      return lexeme.length;
    }

    const language = getLanguage(languageName);
    if (!language) {
      error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
      throw new Error('Unknown language: "' + languageName + '"');
    }

    const md = compileLanguage(language, { plugins });
    let result = '';
    /** @type {CompiledMode} */
    let top = continuation || md;
    /** @type Record<string,CompiledMode> */
    const continuations = {}; // keep continuations for sub-languages
    const emitter = new options.__emitter(options);
    processContinuations();
    let modeBuffer = '';
    let relevance = 0;
    let index = 0;
    let iterations = 0;
    let resumeScanAtSamePosition = false;

    try {
      top.matcher.considerAll();

      for (;;) {
        iterations++;
        if (resumeScanAtSamePosition) {
          // only regexes not matched previously will now be
          // considered for a potential match
          resumeScanAtSamePosition = false;
        } else {
          top.matcher.considerAll();
        }
        top.matcher.lastIndex = index;

        const match = top.matcher.exec(codeToHighlight);
        // console.log("match", match[0], match.rule && match.rule.begin)

        if (!match) break;

        const beforeMatch = codeToHighlight.substring(index, match.index);
        const processedCount = processLexeme(beforeMatch, match);
        index = match.index + processedCount;
      }
      processLexeme(codeToHighlight.substr(index));
      emitter.closeAllNodes();
      emitter.finalize();
      result = emitter.toHTML();

      return {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(relevance),
        value: result,
        language: languageName,
        illegal: false,
        emitter: emitter,
        top: top
      };
    } catch (err) {
      if (err.message && err.message.includes('Illegal')) {
        return {
          illegal: true,
          illegalBy: {
            msg: err.message,
            context: codeToHighlight.slice(index - 100, index + 100),
            mode: err.mode
          },
          sofar: result,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter
        };
      } else if (SAFE_MODE) {
        return {
          illegal: false,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter,
          language: languageName,
          top: top,
          errorRaised: err
        };
      } else {
        throw err;
      }
    }
  }

  /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */
  function justTextHighlightResult(code) {
    const result = {
      relevance: 0,
      emitter: new options.__emitter(options),
      value: escape$1(code),
      illegal: false,
      top: PLAINTEXT_LANGUAGE
    };
    result.emitter.addText(code);
    return result;
  }

  /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */
  function highlightAuto(code, languageSubset) {
    languageSubset = languageSubset || options.languages || Object.keys(languages);
    const plaintext = justTextHighlightResult(code);

    const results = languageSubset.filter(getLanguage).filter(autoDetection).map(name =>
      _highlight(name, code, false)
    );
    results.unshift(plaintext); // plaintext is always an option

    const sorted = results.sort((a, b) => {
      // sort base on relevance
      if (a.relevance !== b.relevance) return b.relevance - a.relevance;

      // always award the tie to the base language
      // ie if C++ and Arduino are tied, it's more likely to be C++
      if (a.language && b.language) {
        if (getLanguage(a.language).supersetOf === b.language) {
          return 1;
        } else if (getLanguage(b.language).supersetOf === a.language) {
          return -1;
        }
      }

      // otherwise say they are equal, which has the effect of sorting on
      // relevance while preserving the original ordering - which is how ties
      // have historically been settled, ie the language that comes first always
      // wins in the case of a tie
      return 0;
    });

    const [best, secondBest] = sorted;

    /** @type {AutoHighlightResult} */
    const result = best;
    result.second_best = secondBest;

    return result;
  }

  /**
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

    @param {string} html
    @returns {string}
  */
  function fixMarkup(html) {
    if (!(options.tabReplace || options.useBR)) {
      return html;
    }

    return html.replace(fixMarkupRe, match => {
      if (match === '\n') {
        return options.useBR ? '<br>' : match;
      } else if (options.tabReplace) {
        return match.replace(/\t/g, options.tabReplace);
      }
      return match;
    });
  }

  /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */
  function updateClassName(element, currentLang, resultLang) {
    const language = currentLang ? aliases[currentLang] : resultLang;

    element.classList.add("hljs");
    if (language) element.classList.add(language);
  }

  /** @type {HLJSPlugin} */
  const brPlugin = {
    "before:highlightElement": ({ el }) => {
      if (options.useBR) {
        el.innerHTML = el.innerHTML.replace(/\n/g, '').replace(/<br[ /]*>/g, '\n');
      }
    },
    "after:highlightElement": ({ result }) => {
      if (options.useBR) {
        result.value = result.value.replace(/\n/g, "<br>");
      }
    }
  };

  const TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
  /** @type {HLJSPlugin} */
  const tabReplacePlugin = {
    "after:highlightElement": ({ result }) => {
      if (options.tabReplace) {
        result.value = result.value.replace(TAB_REPLACE_RE, (m) =>
          m.replace(/\t/g, options.tabReplace)
        );
      }
    }
  };

  /**
   * Applies highlighting to a DOM node containing code. Accepts a DOM node and
   * two optional parameters for fixMarkup.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */
  function highlightElement(element) {
    /** @type HTMLElement */
    let node = null;
    const language = blockLanguage(element);

    if (shouldNotHighlight(language)) return;

    // support for v10 API
    fire("before:highlightElement",
      { el: element, language: language });

    node = element;
    const text = node.textContent;
    const result = language ? highlight(text, { language, ignoreIllegals: true }) : highlightAuto(text);

    // support for v10 API
    fire("after:highlightElement", { el: element, result, text });

    element.innerHTML = result.value;
    updateClassName(element, language, result.language);
    element.result = {
      language: result.language,
      // TODO: remove with version 11.0
      re: result.relevance,
      relavance: result.relevance
    };
    if (result.second_best) {
      element.second_best = {
        language: result.second_best.language,
        // TODO: remove with version 11.0
        re: result.second_best.relevance,
        relavance: result.second_best.relevance
      };
    }
  }

  /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */
  function configure(userOptions) {
    if (userOptions.useBR) {
      deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
      deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
    }
    options = inherit$1(options, userOptions);
  }

  /**
   * Highlights to all <pre><code> blocks on a page
   *
   * @type {Function & {called?: boolean}}
   */
  // TODO: remove v12, deprecated
  const initHighlighting = () => {
    if (initHighlighting.called) return;
    initHighlighting.called = true;

    deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  };

  // Higlights all when DOMContentLoaded fires
  // TODO: remove v12, deprecated
  function initHighlightingOnLoad() {
    deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
    wantsHighlight = true;
  }

  let wantsHighlight = false;

  /**
   * auto-highlights all pre>code elements on the page
   */
  function highlightAll() {
    // if we are called too early in the loading process
    if (document.readyState === "loading") {
      wantsHighlight = true;
      return;
    }

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  }

  function boot() {
    // if a highlight was requested before DOM was loaded, do now
    if (wantsHighlight) highlightAll();
  }

  // make sure we are in the browser environment
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('DOMContentLoaded', boot, false);
  }

  /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */
  function registerLanguage(languageName, languageDefinition) {
    let lang = null;
    try {
      lang = languageDefinition(hljs);
    } catch (error$1) {
      error("Language definition for '{}' could not be registered.".replace("{}", languageName));
      // hard or soft error
      if (!SAFE_MODE) { throw error$1; } else { error(error$1); }
      // languages that have serious errors are replaced with essentially a
      // "plaintext" stand-in so that the code blocks will still get normal
      // css classes applied to them - and one bad language won't break the
      // entire highlighter
      lang = PLAINTEXT_LANGUAGE;
    }
    // give it a temporary name if it doesn't have one in the meta-data
    if (!lang.name) lang.name = languageName;
    languages[languageName] = lang;
    lang.rawDefinition = languageDefinition.bind(null, hljs);

    if (lang.aliases) {
      registerAliases(lang.aliases, { languageName });
    }
  }

  /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */
  function unregisterLanguage(languageName) {
    delete languages[languageName];
    for (const alias of Object.keys(aliases)) {
      if (aliases[alias] === languageName) {
        delete aliases[alias];
      }
    }
  }

  /**
   * @returns {string[]} List of language internal names
   */
  function listLanguages() {
    return Object.keys(languages);
  }

  /**
    intended usage: When one language truly requires another

    Unlike `getLanguage`, this will throw when the requested language
    is not available.

    @param {string} name - name of the language to fetch/require
    @returns {Language | never}
  */
  function requireLanguage(name) {
    deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
    deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");

    const lang = getLanguage(name);
    if (lang) { return lang; }

    const err = new Error('The \'{}\' language is required, but not loaded.'.replace('{}', name));
    throw err;
  }

  /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */
  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */
  function registerAliases(aliasList, { languageName }) {
    if (typeof aliasList === 'string') {
      aliasList = [aliasList];
    }
    aliasList.forEach(alias => { aliases[alias.toLowerCase()] = languageName; });
  }

  /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */
  function autoDetection(name) {
    const lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */
  function upgradePluginAPI(plugin) {
    // TODO: remove with v12
    if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
      plugin["before:highlightElement"] = (data) => {
        plugin["before:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
    if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
      plugin["after:highlightElement"] = (data) => {
        plugin["after:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
  }

  /**
   * @param {HLJSPlugin} plugin
   */
  function addPlugin(plugin) {
    upgradePluginAPI(plugin);
    plugins.push(plugin);
  }

  /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */
  function fire(event, args) {
    const cb = event;
    plugins.forEach(function(plugin) {
      if (plugin[cb]) {
        plugin[cb](args);
      }
    });
  }

  /**
  Note: fixMarkup is deprecated and will be removed entirely in v11

  @param {string} arg
  @returns {string}
  */
  function deprecateFixMarkup(arg) {
    deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
    deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");

    return fixMarkup(arg);
  }

  /**
   *
   * @param {HighlightedHTMLElement} el
   */
  function deprecateHighlightBlock(el) {
    deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
    deprecated("10.7.0", "Please use highlightElement now.");

    return highlightElement(el);
  }

  /* Interface definition */
  Object.assign(hljs, {
    highlight,
    highlightAuto,
    highlightAll,
    fixMarkup: deprecateFixMarkup,
    highlightElement,
    // TODO: Remove with v12 API
    highlightBlock: deprecateHighlightBlock,
    configure,
    initHighlighting,
    initHighlightingOnLoad,
    registerLanguage,
    unregisterLanguage,
    listLanguages,
    getLanguage,
    registerAliases,
    requireLanguage,
    autoDetection,
    inherit: inherit$1,
    addPlugin,
    // plugins for frameworks
    vuePlugin: BuildVuePlugin(hljs).VuePlugin
  });

  hljs.debugMode = function() { SAFE_MODE = false; };
  hljs.safeMode = function() { SAFE_MODE = true; };
  hljs.versionString = version;

  for (const key in MODES) {
    // @ts-ignore
    if (typeof MODES[key] === "object") {
      // @ts-ignore
      deepFreezeEs6(MODES[key]);
    }
  }

  // merge all the modes/regexs into our main object
  Object.assign(hljs, MODES);

  // built-in plugins, likely to be moved out of core in the future
  hljs.addPlugin(brPlugin); // slated to be removed in v11
  hljs.addPlugin(mergeHTMLPlugin);
  hljs.addPlugin(tabReplacePlugin);
  return hljs;
};

// export an "instance" of the highlighter
var highlight = HLJS({});

module.exports = highlight;


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "1148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var RangeError = global.RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var arraySlice = __webpack_require__("4dae");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");
var fails = __webpack_require__("d039");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "129f":
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "18a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmojiList_vue_vue_type_style_index_0_id_30ab6a7c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c7ff");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmojiList_vue_vue_type_style_index_0_id_30ab6a7c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_EmojiList_vue_vue_type_style_index_0_id_30ab6a7c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "18a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "18e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StreamWrapper_vue_vue_type_style_index_0_id_8ca2b728_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("24bb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StreamWrapper_vue_vue_type_style_index_0_id_8ca2b728_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StreamWrapper_vue_vue_type_style_index_0_id_8ca2b728_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isPrototypeOf = __webpack_require__("3a9b");

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1da1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e6cf");
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var TypeError = global.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23c1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2442":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenuCommandButton_vue_vue_type_style_index_0_id_1e0974c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5066");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenuCommandButton_vue_vue_type_style_index_0_id_1e0974c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenuCommandButton_vue_vue_type_style_index_0_id_1e0974c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "24bb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var correctIsRegExpLogic = __webpack_require__("ab13");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var isPrototypeOf = __webpack_require__("3a9b");
var $toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var regExpFlags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis(regExpFlags);

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2acd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2b3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("3ca3");
var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var defineProperties = __webpack_require__("37e8");
var redefine = __webpack_require__("6eeb");
var anInstance = __webpack_require__("19aa");
var hasOwn = __webpack_require__("1a2d");
var assign = __webpack_require__("60da");
var arrayFrom = __webpack_require__("4df4");
var arraySlice = __webpack_require__("4dae");
var codeAt = __webpack_require__("6547").codeAt;
var toASCII = __webpack_require__("5fb2");
var $toString = __webpack_require__("577e");
var setToStringTag = __webpack_require__("d44e");
var URLSearchParamsModule = __webpack_require__("9861");
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor('serialize', 'setHref'),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor('getOrigin'),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor('getProtocol', 'setProtocol'),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor('getUsername', 'setUsername'),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor('getPassword', 'setPassword'),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor('getHost', 'setHost'),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor('getHostname', 'setHostname'),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor('getPort', 'setPort'),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor('getPathname', 'setPathname'),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor('getSearch', 'setSearch'),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor('getSearchParams'),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor('getHash', 'setHash')
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return un$StartsWith
      ? un$StartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(isCallable(fn) ? fn : Function(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "2fb0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3314":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Attachment_vue_vue_type_style_index_0_id_04c470ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae9e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Attachment_vue_vue_type_style_index_0_id_04c470ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Attachment_vue_vue_type_style_index_0_id_04c470ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3add":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoadingBar_vue_vue_type_style_index_0_id_5de5e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cf91");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoadingBar_vue_vue_type_style_index_0_id_5de5e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LoadingBar_vue_vue_type_style_index_0_id_5de5e56a_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3ce4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var high = __webpack_require__("1020")
var fault = __webpack_require__("073e")

exports.highlight = highlight
exports.highlightAuto = highlightAuto
exports.registerLanguage = registerLanguage
exports.listLanguages = listLanguages
exports.registerAlias = registerAlias

Emitter.prototype.addText = text
Emitter.prototype.addKeyword = addKeyword
Emitter.prototype.addSublanguage = addSublanguage
Emitter.prototype.openNode = open
Emitter.prototype.closeNode = close
Emitter.prototype.closeAllNodes = noop
Emitter.prototype.finalize = noop
Emitter.prototype.toHTML = toHtmlNoop

var defaultPrefix = 'hljs-'

// Highlighting `value` in the language `name`.
function highlight(name, value, options) {
  var before = high.configure({})
  var settings = options || {}
  var prefix = settings.prefix
  var result

  if (typeof name !== 'string') {
    throw fault('Expected `string` for name, got `%s`', name)
  }

  if (!high.getLanguage(name)) {
    throw fault('Unknown language: `%s` is not registered', name)
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  high.configure({__emitter: Emitter, classPrefix: prefix})

  result = high.highlight(value, {language: name, ignoreIllegals: true})

  high.configure(before || {})

  /* istanbul ignore if - Highlight.js seems to use this (currently) for broken
   * grammars, so let’s keep it in there just to be sure. */
  if (result.errorRaised) {
    throw result.errorRaised
  }

  return {
    relevance: result.relevance,
    language: result.language,
    value: result.emitter.rootNode.children
  }
}

function highlightAuto(value, options) {
  var settings = options || {}
  var subset = settings.subset || high.listLanguages()
  var prefix = settings.prefix
  var length = subset.length
  var index = -1
  var result
  var secondBest
  var current
  var name

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  secondBest = {relevance: 0, language: null, value: []}
  result = {relevance: 0, language: null, value: []}

  while (++index < length) {
    name = subset[index]

    if (!high.getLanguage(name)) {
      continue
    }

    current = highlight(name, value, options)
    current.language = name

    if (current.relevance > secondBest.relevance) {
      secondBest = current
    }

    if (current.relevance > result.relevance) {
      secondBest = result
      result = current
    }
  }

  if (secondBest.language) {
    result.secondBest = secondBest
  }

  return result
}

// Register a language.
function registerLanguage(name, syntax) {
  high.registerLanguage(name, syntax)
}

// Get a list of all registered languages.
function listLanguages() {
  return high.listLanguages()
}

// Register more aliases for an already registered language.
function registerAlias(name, alias) {
  var map = name
  var key

  if (alias) {
    map = {}
    map[name] = alias
  }

  for (key in map) {
    high.registerAliases(map[key], {languageName: key})
  }
}

function Emitter(options) {
  this.options = options
  this.rootNode = {children: []}
  this.stack = [this.rootNode]
}

function addKeyword(value, name) {
  this.openNode(name)
  this.addText(value)
  this.closeNode()
}

function addSublanguage(other, name) {
  var stack = this.stack
  var current = stack[stack.length - 1]
  var results = other.rootNode.children
  var node = name
    ? {
        type: 'element',
        tagName: 'span',
        properties: {className: [name]},
        children: results
      }
    : results

  current.children = current.children.concat(node)
}

function text(value) {
  var stack = this.stack
  var current
  var tail

  if (value === '') return

  current = stack[stack.length - 1]
  tail = current.children[current.children.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += value
  } else {
    current.children.push({type: 'text', value: value})
  }
}

function open(name) {
  var stack = this.stack
  var className = this.options.classPrefix + name
  var current = stack[stack.length - 1]
  var child = {
    type: 'element',
    tagName: 'span',
    properties: {className: [className]},
    children: []
  }

  current.children.push(child)
  stack.push(child)
}

function close() {
  this.stack.pop()
}

function toHtmlNoop() {
  return ''
}

function noop() {}


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4069":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "429a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "4411":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4440":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var getMethod = __webpack_require__("dc4a");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "46bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenu_vue_vue_type_style_index_0_id_6583bc96_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a13f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenu_vue_vue_type_style_index_0_id_6583bc96_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenu_vue_vue_type_style_index_0_id_6583bc96_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "4973":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "49f8":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "edd4",
	"./fr.json": "f693"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";

/***/ }),

/***/ "4a6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableBubbleMenu_vue_vue_type_style_index_0_id_4917586a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("de73");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableBubbleMenu_vue_vue_type_style_index_0_id_4917586a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableBubbleMenu_vue_vue_type_style_index_0_id_4917586a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4a78":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0538");
var aConstructor = __webpack_require__("5087");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isPrototypeOf = __webpack_require__("3a9b");
var isRegExp = __webpack_require__("44e7");
var toString = __webpack_require__("577e");
var regExpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var enforceInternalState = __webpack_require__("69f3").enforce;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var getFlags = uncurryThis(regExpFlags);
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var isConstructor = __webpack_require__("68ee");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");

var Array = global.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e82":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var internalSort = __webpack_require__("addb");
var arrayMethodIsStrict = __webpack_require__("a640");
var FF = __webpack_require__("04d1");
var IE_OR_EDGE = __webpack_require__("d998");
var V8 = __webpack_require__("2d00");
var WEBKIT = __webpack_require__("512c");

var test = [];
var un$Sort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ "4ec9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "4fadd":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("d86b");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "4fde":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5066":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "512c":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "52dc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBubbleMenu_vue_vue_type_style_index_0_id_4bbd8443_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cab5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBubbleMenu_vue_vue_type_style_index_0_id_4bbd8443_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBubbleMenu_vue_vue_type_style_index_0_id_4bbd8443_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "53b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DividerBubbleMenu_vue_vue_type_style_index_0_id_3e922b62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("76d0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DividerBubbleMenu_vue_vue_type_style_index_0_id_3e922b62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DividerBubbleMenu_vue_vue_type_style_index_0_id_3e922b62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.20.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var classof = __webpack_require__("f5df");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "57e7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5880":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5880__;

/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var whitespaces = __webpack_require__("5899");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "58c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5926":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isRegExp = __webpack_require__("44e7");

var TypeError = global.TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5db7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ "5dbe":
/***/ (function(module, exports, __webpack_require__) {

//
// format - printf-like string formatting for JavaScript
// github.com/samsonjs/format
// @_sjs
//
// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
//
// MIT License
// http://sjs.mit-license.org
//

;(function() {

  //// Export the API
  var namespace;

  // CommonJS / Node module
  if (true) {
    namespace = module.exports = format;
  }

  // Browsers and other environments
  else {}

  namespace.format = format;
  namespace.vsprintf = vsprintf;

  if (typeof console !== 'undefined' && typeof console.log === 'function') {
    namespace.printf = printf;
  }

  function printf(/* ... */) {
    console.log(format.apply(null, arguments));
  }

  function vsprintf(fmt, replacements) {
    return format.apply(null, [fmt].concat(replacements));
  }

  function format(fmt) {
    var argIndex = 1 // skip initial format argument
      , args = [].slice.call(arguments)
      , i = 0
      , n = fmt.length
      , result = ''
      , c
      , escaped = false
      , arg
      , tmp
      , leadingZero = false
      , precision
      , nextArg = function() { return args[argIndex++]; }
      , slurpNumber = function() {
          var digits = '';
          while (/\d/.test(fmt[i])) {
            digits += fmt[i++];
            c = fmt[i];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        }
      ;
    for (; i < n; ++i) {
      c = fmt[i];
      if (escaped) {
        escaped = false;
        if (c == '.') {
          leadingZero = false;
          c = fmt[++i];
        }
        else if (c == '0' && fmt[i + 1] == '.') {
          leadingZero = true;
          i += 2;
          c = fmt[i];
        }
        else {
          leadingZero = true;
        }
        precision = slurpNumber();
        switch (c) {
        case 'b': // number in binary
          result += parseInt(nextArg(), 10).toString(2);
          break;
        case 'c': // character
          arg = nextArg();
          if (typeof arg === 'string' || arg instanceof String)
            result += arg;
          else
            result += String.fromCharCode(parseInt(arg, 10));
          break;
        case 'd': // number in decimal
          result += parseInt(nextArg(), 10);
          break;
        case 'f': // floating point number
          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
          result += leadingZero ? tmp : tmp.replace(/^0/, '');
          break;
        case 'j': // JSON
          result += JSON.stringify(nextArg());
          break;
        case 'o': // number in octal
          result += '0' + parseInt(nextArg(), 10).toString(8);
          break;
        case 's': // string
          result += nextArg();
          break;
        case 'x': // lowercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16);
          break;
        case 'X': // uppercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
          break;
        default:
          result += c;
          break;
        }
      } else if (c === '%') {
        escaped = true;
      } else {
        result += c;
      }
    }
    return result;
  }

}());


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5fb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var RangeError = global.RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object';


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var call = __webpack_require__("c65b");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "62c0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6566":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var create = __webpack_require__("7c73");
var redefineAll = __webpack_require__("e2cc");
var bind = __webpack_require__("0366");
var anInstance = __webpack_require__("19aa");
var iterate = __webpack_require__("2266");
var defineIterator = __webpack_require__("7dd0");
var setSpecies = __webpack_require__("2626");
var DESCRIPTORS = __webpack_require__("83ab");
var fastKey = __webpack_require__("f183").fastKey;
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ad0":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-element-loading v2.0.2
 * (c) 2019-present biig_pongsatorn <biig_pongsatorn@hotmail.com>
 * Released under the MIT License.
 */
!function(t,e){ true?module.exports=e():undefined}(this,function(){"use strict";var t={name:"spinner",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};function e(t,e,i,a,n,r,s,o,d,l){"function"==typeof s&&(d=o,o=s,s=!1);const u="function"==typeof i?i.options:i;let c;if(t&&t.render&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns,u._compiled=!0,n&&(u.functional=!0)),a&&(u._scopeId=a),r?(c=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),e&&e.call(this,d(t)),t&&t._registeredComponents&&t._registeredComponents.add(r)},u._ssrRegister=c):e&&(c=s?function(){e.call(this,l(this.$root.$options.shadowRoot))}:function(t){e.call(this,o(t))}),c)if(u.functional){const t=u.render;u.render=function(e,i){return c.call(i),t(e,i)}}else{const t=u.beforeCreate;u.beforeCreate=t?[].concat(t,c):[c]}return i}const i=t;t.__file="spinner.vue";var a=e({render:function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"loader-1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:this.size,height:this.size,viewBox:"0 0 50 50","xml:space":"preserve"}},[e("path",{attrs:{fill:this.color,d:"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"}},[e("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:this.duration,repeatCount:"indefinite"}})],1)])},staticRenderFns:[]},void 0,i,void 0,!1,void 0,void 0,void 0),n={name:"ring",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const r=n;n.__file="ring.vue";var s=e({render:function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{version:"1.1",id:"loader-1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:this.size,height:this.size,viewBox:"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[e("path",{attrs:{opacity:"0.2",fill:this.color,d:"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),this._v(" "),e("path",{attrs:{fill:this.color,d:"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n    C22.32,8.481,24.301,9.057,26.013,10.047z"}},[e("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 20 20",to:"360 20 20",dur:this.duration,repeatCount:"indefinite"}})],1)])},staticRenderFns:[]},void 0,r,void 0,!1,void 0,void 0,void 0),o={name:"mini-spinner",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const d=o;o.__file="mini-spinner.vue";var l=e({render:function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"loader-1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:this.size,height:this.size,viewBox:"0 0 50 50","xml:space":"preserve"}},[e("path",{attrs:{fill:this.color,d:"M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"}},[e("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:this.duration,repeatCount:"indefinite"}})],1)])},staticRenderFns:[]},void 0,d,void 0,!1,void 0,void 0,void 0),u={name:"line-wave",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const c=u;u.__file="line-wave.vue";var p=e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:t.size,height:t.size,viewBox:"0 0 24 30","xml:space":"preserve"}},[i("rect",{attrs:{x:"0",y:"0",width:"4",height:"10",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"translate",values:"0 0; 0 20; 0 0",begin:"0",dur:t.duration,repeatCount:"indefinite"}})],1),t._v(" "),i("rect",{attrs:{x:"10",y:"0",width:"4",height:"10",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"translate",values:"0 0; 0 20; 0 0",begin:"0.2s",dur:t.duration,repeatCount:"indefinite"}})],1),t._v(" "),i("rect",{attrs:{x:"20",y:"0",width:"4",height:"10",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"translate",values:"0 0; 0 20; 0 0",begin:"0.4s",dur:t.duration,repeatCount:"indefinite"}})],1)])},staticRenderFns:[]},void 0,c,void 0,!1,void 0,void 0,void 0),v={name:"line-scale",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const m=v;v.__file="line-scale.vue";var f=e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:t.size,height:t.size,viewBox:"0 0 24 30","xml:space":"preserve"}},[i("rect",{attrs:{x:"0",y:"13",width:"4",height:"5",fill:t.color}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"10",y:"13",width:"4",height:"5",fill:t.color}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"20",y:"13",width:"4",height:"5",fill:t.color}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:t.duration,repeatCount:"indefinite"}})])])},staticRenderFns:[]},void 0,m,void 0,!1,void 0,void 0,void 0),h={name:"line-down",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const y=h;h.__file="line-down.vue";var g=e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:t.size,height:t.size,viewBox:"0 0 24 24","xml:space":"preserve"}},[i("rect",{attrs:{x:"0",y:"0",width:"4",height:"7",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"scale",values:"1,1; 1,3; 1,1",begin:"0s",dur:t.duration,repeatCount:"indefinite"}})],1),t._v(" "),i("rect",{attrs:{x:"10",y:"0",width:"4",height:"7",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"scale",values:"1,1; 1,3; 1,1",begin:"0.2s",dur:t.duration,repeatCount:"indefinite"}})],1),t._v(" "),i("rect",{attrs:{x:"20",y:"0",width:"4",height:"7",fill:t.color}},[i("animateTransform",{attrs:{attributeType:"xml",attributeName:"transform",type:"scale",values:"1,1; 1,3; 1,1",begin:"0.4s",dur:t.duration,repeatCount:"indefinite"}})],1)])},staticRenderFns:[]},void 0,y,void 0,!1,void 0,void 0,void 0),x={name:"bar-fade",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const b=x;x.__file="bar-fade.vue";var w=e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:t.size,height:t.size,viewBox:"0 0 24 30","xml:space":"preserve"}},[i("rect",{attrs:{x:"0",y:"0",width:"4",height:"20",fill:t.color}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"1; .2; 1",begin:"0s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"7",y:"0",width:"4",height:"20",fill:t.color}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"1; .2; 1",begin:"0.2s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"14",y:"0",width:"4",height:"20",fill:t.color}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"1; .2; 1",begin:"0.4s",dur:t.duration,repeatCount:"indefinite"}})])])},staticRenderFns:[]},void 0,b,void 0,!1,void 0,void 0,void 0),_={name:"bar-fade-scale",props:{color:{type:String,default:"#CCC"},size:{type:String,default:"40px"},duration:{type:String,default:"0.6s"}}};const C=_;_.__file="bar-fade-scale.vue";var S=e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:"0px",y:"0px",width:t.size,height:t.size,viewBox:"0 0 24 30","xml:space":"preserve"}},[i("rect",{attrs:{x:"0",y:"10",width:"4",height:"10",fill:t.color,opacity:"0.2"}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"0.2; 1; .2",begin:"0s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"10; 20; 10",begin:"0s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"10; 5; 10",begin:"0s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"8",y:"10",width:"4",height:"10",fill:t.color,opacity:"0.2"}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"0.2; 1; .2",begin:"0.15s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"10; 20; 10",begin:"0.15s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"10; 5; 10",begin:"0.15s",dur:t.duration,repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"16",y:"10",width:"4",height:"10",fill:t.color,opacity:"0.2"}},[i("animate",{attrs:{attributeName:"opacity",attributeType:"XML",values:"0.2; 1; .2",begin:"0.3s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"10; 20; 10",begin:"0.3s",dur:t.duration,repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"10; 5; 10",begin:"0.3s",dur:t.duration,repeatCount:"indefinite"}})])])},staticRenderFns:[]},void 0,C,void 0,!1,void 0,void 0,void 0),T={name:"vue-element-loading",props:{active:Boolean,spinner:{type:String,default:"spinner"},text:{type:String,default:""},textStyle:{type:Object,default:function(){return{}}},color:{type:String,default:"#000"},isFullScreen:{type:Boolean,default:!1},backgroundColor:{type:String,default:"rgba(255, 255, 255, .9)"},size:{type:String,default:"40"},duration:{type:String,default:"0.6"},delay:{type:[String,Number],default:0}},data:function(){return{isActive:this.active||!1,isActiveDelay:!1}},mounted:function(){if(this.$refs.velmld.parentNode.classList.add("velmld-parent"),this.delay){var t=1e3*+this.delay;this.delayActive(t)}},methods:{delayActive:function(t){var e=this;this.isActiveDelay=!0,setTimeout(function(){e.isActiveDelay=!1},t)}},watch:{active:function(t){this.isActive=t,t&&this.$refs.velmld.parentNode.classList.add("velmld-parent")}},components:{Spinner:a,Ring:s,MiniSpinner:l,LineWave:p,LineScale:f,LineDown:g,BarFade:w,BarFadeScale:S}};const N="undefined"!=typeof navigator&&/msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());const z=document.head||document.getElementsByTagName("head")[0],L={};const k=T;T.__file="index.vue";return e({render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:"fade"}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive||t.isActiveDelay,expression:"isActive || isActiveDelay"}],ref:"velmld",staticClass:"velmld-overlay",class:{"velmld-full-screen":t.isFullScreen},style:{backgroundColor:t.backgroundColor}},[i("div",{staticClass:"velmld-spinner"},[t._t("default",[i(t.spinner,{tag:"component",attrs:{color:t.color,size:t.size+"px",duration:t.duration+"s"}})]),t._v(" "),t.text.length?i("div",{style:Object.assign({},{color:t.color},t.textStyle)},[t._v("\n        "+t._s(t.text)+"\n      ")]):t._e()],2)])])},staticRenderFns:[]},function(t){t&&(t("data-v-27234dc7_0",{source:".fade-enter-active[data-v-27234dc7],.fade-leave-active[data-v-27234dc7]{transition:opacity .3s}.fade-enter[data-v-27234dc7],.fade-leave-to[data-v-27234dc7]{opacity:0}.velmld-overlay[data-v-27234dc7]{position:absolute;z-index:3000;margin:0;top:0;right:0;bottom:0;left:0;transition:opacity .3s}.velmld-spinner[data-v-27234dc7]{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;text-align:center}.velmld-full-screen[data-v-27234dc7]{position:fixed}",map:void 0,media:void 0}),t("data-v-27234dc7_1",{source:".velmld-parent{position:relative!important}",map:void 0,media:void 0}))},k,"data-v-27234dc7",!1,void 0,function(t){return(t,e)=>(function(t,e){const i=N?e.media||"default":t,a=L[i]||(L[i]={ids:new Set,styles:[]});if(!a.ids.has(t)){a.ids.add(t);let i=e.source;if(e.map&&(i+="\n/*# sourceURL="+e.map.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e.map))))+" */"),a.element||(a.element=document.createElement("style"),a.element.type="text/css",e.media&&a.element.setAttribute("media",e.media),z.appendChild(a.element)),"styleSheet"in a.element)a.styles.push(i),a.element.styleSheet.cssText=a.styles.filter(Boolean).join("\n");else{const t=a.ids.size-1,e=document.createTextNode(i),n=a.element.childNodes;n[t]&&a.element.removeChild(n[t]),n.length?a.element.insertBefore(e,n[t]):a.element.appendChild(e)}}})(t,e)},void 0)});
//# sourceMappingURL=vue-element-loading.min.js.map


/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommandButton_vue_vue_type_style_index_0_id_7bdc44c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7ae9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommandButton_vue_vue_type_style_index_0_id_7bdc44c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommandButton_vue_vue_type_style_index_0_id_7bdc44c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var $propertyIsEnumerable = __webpack_require__("d1e7").f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "6f53a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "711f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableCell_vue_vue_type_style_index_0_id_2ae3809e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8428");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableCell_vue_vue_type_style_index_0_id_2ae3809e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableCell_vue_vue_type_style_index_0_id_2ae3809e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "73d9":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "766f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CellMenu_vue_vue_type_style_index_0_id_4609cdc8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("23c1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CellMenu_vue_vue_type_style_index_0_id_4609cdc8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CellMenu_vue_vue_type_style_index_0_id_4609cdc8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "76c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorPicker_vue_vue_type_style_index_0_id_0a5a0448_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff58");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorPicker_vue_vue_type_style_index_0_id_0a5a0448_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorPicker_vue_vue_type_style_index_0_id_0a5a0448_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "76d0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7ae9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7b09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("57e7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var requireObjectCoercible = __webpack_require__("1d80");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "841c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var sameValue = __webpack_require__("129f");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var regExpExec = __webpack_require__("14c3");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "8428":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "85b3":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__85b3__;

/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8cad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8ec4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenuCommandButton_vue_vue_type_style_index_0_id_f5944738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4440");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenuCommandButton_vue_vue_type_style_index_0_id_f5944738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContentMenuCommandButton_vue_vue_type_style_index_0_id_f5944738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9073":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9129":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ "9224":
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"2.8.31\"}");

/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "92e1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "9861":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("e260");
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var createIteratorConstructor = __webpack_require__("9ed3");
var InternalStateModule = __webpack_require__("69f3");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var bind = __webpack_require__("0366");
var classof = __webpack_require__("f5df");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var $toString = __webpack_require__("577e");
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var wellKnownSymbol = __webpack_require__("b622");
var arraySort = __webpack_require__("addb");

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var n$Fetch = getBuiltIn('fetch');
var N$Request = getBuiltIn('Request');
var Headers = getBuiltIn('Headers');
var RequestPrototype = N$Request && N$Request.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(n$Fetch)) {
    $({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(N$Request)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "98db":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && Object({"VUE_APP_UPLOAD_API_URL":"https://mayday-tiptap-upload-demo.herokuapp.com/upload","NODE_ENV":"production","BASE_URL":"/"}) && Object({"VUE_APP_UPLOAD_API_URL":"https://mayday-tiptap-upload-demo.herokuapp.com/upload","NODE_ENV":"production","BASE_URL":"/"})["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362"), __webpack_require__("c8ba")))

/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a13f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a1f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var createIteratorConstructor = __webpack_require__("9ed3");
var requireObjectCoercible = __webpack_require__("1d80");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var anObject = __webpack_require__("825a");
var classof = __webpack_require__("c6b6");
var isPrototypeOf = __webpack_require__("3a9b");
var isRegExp = __webpack_require__("44e7");
var regExpFlags = __webpack_require__("ad6d");
var getMethod = __webpack_require__("dc4a");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");
var InternalStateModule = __webpack_require__("69f3");
var IS_PURE = __webpack_require__("c430");

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;
var getFlags = uncurryThis(regExpFlags);
var stringIndexOf = uncurryThis(''.indexOf);
var un$MatchAll = uncurryThis(''.matchAll);

var WORKS_WITH_NON_GLOBAL_REGEX = !!un$MatchAll && !fails(function () {
  un$MatchAll('a', /./);
});

var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return { value: undefined, done: true };
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) return { value: undefined, done: state.done = true };
  if (state.global) {
    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return { value: match, done: false };
  }
  state.done = true;
  return { value: match, done: false };
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = toString(string);
  var C, flagsValue, flags, matcher, $global, fullUnicode;
  C = speciesConstructor(R, RegExp);
  flagsValue = R.flags;
  if (flagsValue === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype)) {
    flagsValue = getFlags(R);
  }
  flags = flagsValue === undefined ? '' : toString(flagsValue);
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf(flags, 'g');
  fullUnicode = !!~stringIndexOf(flags, 'u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (regexp != null) {
      if (isRegExp(regexp)) {
        flags = toString(requireObjectCoercible('flags' in RegExpPrototype
          ? regexp.flags
          : getFlags(regexp)
        ));
        if (!~stringIndexOf(flags, 'g')) throw TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher) return call(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
    S = toString(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var lengthOfArrayLike = __webpack_require__("07fa");
var bind = __webpack_require__("0366");

var TypeError = global.TypeError;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var arraySlice = __webpack_require__("f36a");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  redefine(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = call($replacer, this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return apply($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
    // TODO: improve hint logic
    return call(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var hasOwn = __webpack_require__("1a2d");
var inheritIfRequired = __webpack_require__("7156");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var thisNumberValue = __webpack_require__("408a");
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aa24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AttachmentBubbleMenu_vue_vue_type_style_index_0_id_5002d41a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8cad");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AttachmentBubbleMenu_vue_vue_type_style_index_0_id_5002d41a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AttachmentBubbleMenu_vue_vue_type_style_index_0_id_5002d41a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "addb":
/***/ (function(module, exports, __webpack_require__) {

var arraySlice = __webpack_require__("4dae");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "ade3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "ae9e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b012":
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineMention_vue_vue_type_style_index_0_id_0451d200_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("62c0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineMention_vue_vue_type_style_index_0_id_0451d200_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineMention_vue_vue_type_style_index_0_id_0451d200_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b636":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "b648":
/***/ (function(module, exports) {

module.exports = () => {
	// https://mths.be/emoji
	return /(?:[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2\uDED0-\uDED9\uDEE0-\uDEE7]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?))/g;
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b680":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var thisNumberValue = __webpack_require__("408a");
var $repeat = __webpack_require__("1148");
var fails = __webpack_require__("d039");

var RangeError = global.RangeError;
var String = global.String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var un$ToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b872":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Embed_vue_vue_type_style_index_0_id_d27a395e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dc61");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Embed_vue_vue_type_style_index_0_id_d27a395e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Embed_vue_vue_type_style_index_0_id_d27a395e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "bc35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextSelectionBubbleMenu_vue_vue_type_style_index_0_id_09b4f9e1_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4411");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextSelectionBubbleMenu_vue_vue_type_style_index_0_id_09b4f9e1_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextSelectionBubbleMenu_vue_vue_type_style_index_0_id_09b4f9e1_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bf19":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});


/***/ }),

/***/ "bf2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalloutBubbleMenu_vue_vue_type_style_index_0_id_5caec206_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f403");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalloutBubbleMenu_vue_vue_type_style_index_0_id_5caec206_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalloutBubbleMenu_vue_vue_type_style_index_0_id_5caec206_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c1f9":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var iterate = __webpack_require__("2266");
var createProperty = __webpack_require__("8418");

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c65b":
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageWrapper_vue_vue_type_style_index_0_id_0679bb89_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("92e1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageWrapper_vue_vue_type_style_index_0_id_0679bb89_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageWrapper_vue_vue_type_style_index_0_id_0679bb89_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c7ff":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "c93a":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_c93a__;

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cab5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "cd11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AiBadge_vue_vue_type_style_index_0_id_b3155bf4_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4973");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AiBadge_vue_vue_type_style_index_0_id_b3155bf4_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AiBadge_vue_vue_type_style_index_0_id_b3155bf4_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cd49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editorStore; });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("466d");
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match_all_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a1f0");
/* harmony import */ var core_js_modules_es_string_match_all_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_all_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0613");
/* harmony import */ var _store_mutations_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("07cd");
/* harmony import */ var _components_MaydayEditor_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("f4c5");
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("9224");
var _package_json__WEBPACK_IMPORTED_MODULE_11___namespace = /*#__PURE__*/__webpack_require__.t("9224", 1);











 // matchAll.shim();

var plugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var storeModuleName = "mayday-editor";
    console.log("[mayday-editor] Version ".concat(Object({"VUE_APP_UPLOAD_API_URL":"https://mayday-tiptap-upload-demo.herokuapp.com/upload","NODE_ENV":"production","BASE_URL":"/"}).npm_package_version || _package_json__WEBPACK_IMPORTED_MODULE_11__[/* version */ "a"]));

    if (options.store == null) {
      console.error("[mayday-editor] vuex store instance not provided, editor library loading aborted");
      return;
    }

    var store = options.store,
        callbacks = options.callbacks;

    if (!store.hasModule(storeModuleName)) {
      store.registerModule(storeModuleName, _store__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]);
      store.commit("".concat(storeModuleName, "/").concat(_store_mutations_types__WEBPACK_IMPORTED_MODULE_9__[/* SET_OPTIONAL_CALLBACKS */ "c"]), callbacks);
    } else {
      store.registerModule(storeModuleName, _store__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
        preserveState: false
      });
      store.commit("".concat(storeModuleName, "/").concat(_store_mutations_types__WEBPACK_IMPORTED_MODULE_9__[/* SET_OPTIONAL_CALLBACKS */ "c"]), callbacks);
    }

    if (options.i18n == null) {
      console.warn("[mayday-editor] vue-i18n instance not provided, translation might not work");
    } else {
      // use webpack to load all locales
      var locales = __webpack_require__("49f8");

      locales.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);

        if (matched && matched.length > 1) {
          var _options$i18n;

          var locale = matched[1];
          (_options$i18n = options.i18n) === null || _options$i18n === void 0 ? void 0 : _options$i18n.mergeLocaleMessage(locale, locales(key));
        }
      });
    }

    Vue.component("mayday-editor", _components_MaydayEditor_vue__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"]);
  }
}; // UMD auto-install when vue is found (eg. in browser via <script> tag)

var GlobalVue = null;

if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}

if (GlobalVue != null) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);
var editorStore = _store__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"];
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "cd71":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "cf91":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d199":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_1_id_15f57550_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("429a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_1_id_15f57550_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MaydayEditor_vue_vue_type_style_index_1_id_15f57550_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");
var global = __webpack_require__("da84");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("e330");
var redefine = __webpack_require__("6eeb");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d86b":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("d039");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "d998":
/***/ (function(module, exports, __webpack_require__) {

var UA = __webpack_require__("342f");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "dc61":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dda4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Callout_vue_vue_type_style_index_0_id_6c4f8964_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cd71");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Callout_vue_vue_type_style_index_0_id_6c4f8964_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Callout_vue_vue_type_style_index_0_id_6c4f8964_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "de2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkBubbleMenu_vue_vue_type_style_index_0_id_4d3ca2c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a78");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkBubbleMenu_vue_vue_type_style_index_0_id_4d3ca2c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkBubbleMenu_vue_vue_type_style_index_0_id_4d3ca2c4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "de73":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e217":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageAltMenu_vue_vue_type_style_index_0_id_7fa98356_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f5a5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageAltMenu_vue_vue_type_style_index_0_id_7fa98356_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageAltMenu_vue_vue_type_style_index_0_id_7fa98356_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("7dd0");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e330":
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e4e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeDragHandle_vue_vue_type_style_index_0_id_51de8275_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2acd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeDragHandle_vue_vue_type_style_index_0_id_51de8275_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NodeDragHandle_vue_vue_type_style_index_0_id_51de8275_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e677":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkTitleMenu_vue_vue_type_style_index_0_id_bd0aa9ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("58c2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkTitleMenu_vue_vue_type_style_index_0_id_bd0aa9ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkTitleMenu_vue_vue_type_style_index_0_id_bd0aa9ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var call = __webpack_require__("c65b");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';

var getInternalState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromisePrototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");

var Array = global.Array;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      for (var i = 0, l = arguments.length, args = Array(l); i < l; i++) args[i] = arguments[i];
      var result = apply($stringify, null, args);
      return typeof result == 'string' ? replace(result, tester, fix) : result;
    }
  });
}


/***/ }),

/***/ "edd4":
/***/ (function(module) {

module.exports = JSON.parse("{\"mayday-editor\":{\"placeholder\":{\"editor-is-empty\":\"Let's write something...\",\"node-is-empty\":\"Type '/' for commands\"},\"file\":{\"uploading\":\"Uploading file | Uploading files\",\"sizes\":[\"Bytes\",\"KB\",\"MB\",\"GB\",\"TB\",\"PB\",\"EB\",\"ZB\",\"YB\"]},\"attachment\":{\"unknown-file-size\":\"Unknown\",\"embed\":{\"no-support\":\"Your browser don't support embed contents. Please use a more modern browser like Chrome or Firefox.\",\"download\":\"Download file manually\"},\"loader\":\"Loading file...\"},\"inline-content\":{\"missing-content\":\"MISSING CONTENT\"},\"inline-mention\":{\"missing-user\":\"Missing user\",\"missing-role\":\"Missing role\"},\"embed\":{\"open-in-new-tab\":\"Click to enlarge\"},\"toc\":{\"empty\":\"Add headings to your document\",\"untitled\":\"Untitled\"},\"menu\":{\"text-selection\":{\"tooltip\":{\"bold\":\"Bold\",\"italic\":\"Italic\",\"underline\":\"Underline\",\"strike\":\"Strike\",\"code\":\"Code\",\"align-left\":\"Align left\",\"align-center\":\"Align center\",\"align-right\":\"Align right\",\"bullet-list\":\"Bullet list\",\"ordered-list\":\"Ordered list\",\"highlight\":\"Highlight\",\"color\":\"Color\",\"link\":\"Link\",\"translation\":\"Translate\",\"correction\":\"Correct\",\"tone\":\"Improve tone\",\"disabled\":\"Please select full words to use this feature\"}},\"cell\":{\"color\":\"Cell color\",\"add-row-before\":\"Add row before\",\"add-row-after\":\"Add row after\",\"add-column-before\":\"Add column before\",\"add-column-after\":\"Add column after\",\"delete-row\":\"Remove rows | Remove row\",\"delete-column\":\"Remove columns | Remove column\",\"merge-cells\":\"Merge cells\",\"split-cell\":\"Split cell\"},\"table\":{\"tooltip\":{\"activate-header-row\":\"Turn first row into header\",\"activate-header-column\":\"Turn first column into header\",\"deactivate-header-row\":\"Turn first row into normal cells\",\"deactivate-header-column\":\"Turn first column into normal cells\",\"delete-table\":\"Delete table\"}},\"slash\":{\"no-results\":\"No action possible\",\"title\":{\"paragraph\":\"Paragraph\",\"image\":\"Image\",\"attachment\":\"Attached file\",\"h1\":\"Heading 1\",\"h2\":\"Heading 2\",\"h3\":\"Heading 3\",\"h4\":\"Heading 4\",\"bullet-list\":\"Bullet list\",\"ordered-list\":\"Ordered list\",\"table\":\"Table\",\"blockquote\":\"Quote\",\"codeblock\":\"Code\",\"divider\":\"Divider\",\"callout\":\"Callout\",\"emoji\":\"Emoji\",\"inline-content\":\"Mayday content\",\"inline-mention\":\"Mayday user\",\"details\":\"Toggle list\",\"toc\":\"Table of content\",\"summary\":\"Summarize\",\"translate\":\"Translate\",\"correct\":\"Correct\",\"tone\":\"Improve tone\",\"action-items\":\"Action items\"},\"options\":{\"summary\":{\"short\":\"Short summary\",\"long\":\"Detailed summary\"},\"translate\":{\"fr-fr\":\"French\",\"en-us\":\"English\",\"es-es\":\"Spanish\",\"de-de\":\"German\",\"it-it\":\"Italian\",\"pt-pt\":\"Portuguese\",\"ru-ru\":\"Russian\",\"zh-cn\":\"Chinese\",\"nl-nl\":\"Dutch\"}},\"footer-description\":{\"paragraph\":\"Add a paragraph\",\"image\":\"Add an image\",\"attachment\":\"Insert attached file\",\"h1\":\"Add a Heading 1\",\"h2\":\"Add a Heading 2\",\"h3\":\"Add a Heading 3\",\"h4\":\"Add a Heading 4\",\"bullet-list\":\"Add a bullet list\",\"ordered-list\":\"Add an ordered list\",\"table\":\"Add a table\",\"blockquote\":\"Add a quote\",\"codeblock\":\"Add a code block\",\"divider\":\"Add a divider\",\"emoji\":\"Add an emoji\",\"callout\":\"Add a callout\",\"inline-content\":\"Redirect to Mayday Content\",\"inline-mention\":\"Mention to a Mayday user\",\"details\":\"Add a toggle list\",\"toc\":\"Add a table of content\",\"help\":\"Help\",\"no-results\":\"Type another search term\",\"summary\":\"Generate automatically a summary\",\"translate\":\"Translate the content\",\"correct\":\"Correct grammar\",\"tone\":\"Improve tone\",\"action-items\":\"Generate automatically action items\"}},\"emoji\":{\"smileys & emotion\":\"Smileys\",\"people & body\":\"People\",\"components\":\"Components\",\"animals & nature\":\"Animals and nature\",\"food & drink\":\"Food and drink\",\"travel & places\":\"Travel and places\",\"activities\":\"Activity\",\"objects\":\"Objects\",\"symbols\":\"Symbols\",\"flags\":\"Flags\",\"GitHub\":\"Others\"},\"inline-content\":{\"no-results\":\"No results\",\"empty-description\":\"Linked to product\",\"types\":{\"contents\":\"Contents\",\"users\":\"Users\",\"roles\":\"Roles\",\"cases\":\"Cases\"},\"tooltip\":{\"set-as-default\":\"Mention the content\",\"set-as-link\":\"Display as link\",\"set-as-embed\":\"Display as embed\",\"open-link\":\"Open link\",\"delete\":\"Delete mention\"}},\"divider\":{\"delete\":\"Delete divider\"},\"callout\":{\"info\":\"Info\",\"success\":\"Success\",\"danger\":\"Danger\",\"error\":\"Error\",\"delete\":\"Delete the callout\"},\"link\":{\"tooltip\":{\"open-link\":\"Open link\",\"open-embed\":\"Open embed\",\"url\":\"Change URL address\",\"title\":\"Changer link title\",\"make-link\":\"Turn into link\",\"make-embed\":\"Turn into embed\",\"open-in-modal\":\"Open in a window\",\"remove-link\":\"Remove link\",\"delete-embed\":\"Delete embed\",\"make-inline\":\"Mention the content\"},\"title-placeholder\":\"Link title\",\"close\":\"Close\"},\"translate\":{\"close\":\"Close\",\"title\":\"Translation\",\"run\":\"Translate selection\",\"replace\":\"Replace selection\",\"append\":\"Insert below selection\",\"cancel\":\"Cancel\",\"generating\":\"Generating...\",\"languages\":{\"fr-fr\":\"French\",\"en-us\":\"English\",\"es-es\":\"Spanish\",\"de-de\":\"German\",\"it-it\":\"Italian\",\"pt-pt\":\"Portuguese\",\"ru-ru\":\"Russian\",\"zh-cn\":\"Chinese\",\"ja-jp\":\"Japanese\",\"nl-nl\":\"Dutch\"},\"flags\":{\"fr-fr\":\"🇫🇷\",\"en-gb\":\"🇬🇧\",\"en-us\":\"🇺🇸\",\"es-es\":\"🇪🇸\",\"de-de\":\"🇩🇪\",\"it-it\":\"🇮🇹\",\"pt-pt\":\"🇵🇹\",\"ru-ru\":\"🇷🇺\",\"zh-cn\":\"🇨🇳\",\"ja-jp\":\"🇯🇵\",\"nl-nl\":\"🇳🇱\"}},\"image\":{\"alt-placeholder\":\"Alt image\",\"alt-tooltip\":\"Change alt attribute of the image\"},\"attachment\":{\"type\":{\"pdf\":\"PDF\",\"sheet\":\"Excel\",\"video\":\"Video\",\"other\":\"File\",\"doc\":\"Doc\",\"slide\":\"Slide\"},\"set-as-default\":\"Display as block\",\"set-as-link\":\"Display as link\",\"set-as-embed\":\"Display as embed\",\"title\":\"Change title\",\"download\":\"Download\",\"delete\":\"Delete attachment\"},\"options\":{\"copy\":\"Copy link to block\"}}}}");

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternalModule = __webpack_require__("057f");
var isExtensible = __webpack_require__("4fadd");
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f2e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenu_vue_vue_type_style_index_0_id_5b77ee18_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9073");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenu_vue_vue_type_style_index_0_id_5b77ee18_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SlashMenu_vue_vue_type_style_index_0_id_5b77ee18_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f403":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f4c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MaydayEditor.vue?vue&type=template&id=15f57550&scoped=true&
var MaydayEditorvue_type_template_id_15f57550_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editorContainer",staticClass:"mayday-editor"},[_c('Loader',{attrs:{"loading":_vm.isLoading,"label":_vm.isLoadingLabel}}),(_vm.menuOptions.fontOptions)?_c('TextSelectionBubbleMenu',{attrs:{"editor":_vm.editor,"options":_vm.options,"generate-translation":_vm.generateTranslation}}):_vm._e(),(_vm.menuOptions.tableOptions)?_c('TableBubbleMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.richOptions)?_c('DividerBubbleMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.tableOptions)?_c('CellMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.richOptions)?_c('SlashMenuCommandButton',{ref:"maydayEditorSlashMenu",attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.richOptions)?_c('CalloutBubbleMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.richOptions)?_c('AttachmentBubbleMenu',{attrs:{"editor":_vm.editor}}):_vm._e(),(_vm.menuOptions.richOptions)?_c('InlineBubbleMenu',{attrs:{"editor":_vm.editor,"isParametric":_vm.isParametric,"subdomain":_vm.subdomain}}):_vm._e(),(_vm.menuOptions.richOptions || _vm.menuOptions.messageOptions)?_c('LinkBubbleMenu',{attrs:{"editor":_vm.editor,"options":_vm.menuOptions,"subdomain":_vm.subdomain},on:{"open-link-in-modal":_vm.handleLinkModalOpening}}):_vm._e(),(_vm.menuOptions.richOptions || _vm.menuOptions.imageOptions)?_c('ImageBubbleMenu',{attrs:{"editor":_vm.editor},on:{"open-link-in-modal":_vm.handleLinkModalOpening}}):_vm._e(),(_vm.editor)?_c('editor-content',{staticClass:"mayday-editor__content",attrs:{"editor":_vm.editor},on:{"click:inline-content":function($event){return _vm.$emit('click:inline-content', $event)},"click:attached-file":function($event){return _vm.$emit('click:attached-file', $event)},"click:image":function($event){return _vm.$emit('click:image', $event)},"click:toc":function($event){return _vm.$emit('click:toc', $event)},"click:copy":function($event){return _vm.$emit('click:copy', $event)},"click:focus-hash":function($event){return _vm.$emit('click:focus-hash', $event)},"click:open-link":function($event){return _vm.$emit('click:open-link', $event)}}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/MaydayEditor.vue?vue&type=template&id=15f57550&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js


function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js





function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ./node_modules/reflect-metadata/Reflect.js
var reflect_metadata_Reflect = __webpack_require__("98db");

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: external "vue-class-component"
var external_vue_class_component_ = __webpack_require__("c93a");

// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__("5880");

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/bindings.js


var State = createBindingHelper('computed', external_vuex_["mapState"]);
var Getter = createBindingHelper('computed', external_vuex_["mapGetters"]);
var Action = createBindingHelper('methods', external_vuex_["mapActions"]);
var Mutation = createBindingHelper('methods', external_vuex_["mapMutations"]);
function bindings_namespace(namespace, helper) {
    function createNamespacedHelper(helper) {
        function namespacedHelper(a, b) {
            if (typeof b === 'string') {
                var key = b;
                var proto = a;
                return helper(key, { namespace: namespace })(proto, key);
            }
            var type = a;
            var options = bindings_merge(b || {}, { namespace: namespace });
            return helper(type, options);
        }
        return namespacedHelper;
    }
    if (helper) {
        console.warn('[vuex-class] passing the 2nd argument to `namespace` function is deprecated. pass only namespace string instead.');
        return createNamespacedHelper(helper);
    }
    return {
        State: createNamespacedHelper(State),
        Getter: createNamespacedHelper(Getter),
        Mutation: createNamespacedHelper(Mutation),
        Action: createNamespacedHelper(Action)
    };
}
function createBindingHelper(bindTo, mapFn) {
    function makeDecorator(map, namespace) {
        return Object(external_vue_class_component_["createDecorator"])(function (componentOptions, key) {
            if (!componentOptions[bindTo]) {
                componentOptions[bindTo] = {};
            }
            var mapObject = (_a = {}, _a[key] = map, _a);
            componentOptions[bindTo][key] = namespace !== undefined
                ? mapFn(namespace, mapObject)[key]
                : mapFn(mapObject)[key];
            var _a;
        });
    }
    function helper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return makeDecorator(key, undefined)(proto, key);
        }
        var namespace = extractNamespace(b);
        var type = a;
        return makeDecorator(type, namespace);
    }
    return helper;
}
function extractNamespace(options) {
    var n = options && options.namespace;
    if (typeof n !== 'string') {
        return undefined;
    }
    if (n[n.length - 1] !== '/') {
        return n + '/';
    }
    return n;
}
function bindings_merge(a, b) {
    var res = {};
    [a, b].forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            res[key] = obj[key];
        });
    });
    return res;
}

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/index.js


// CONCATENATED MODULE: ./node_modules/orderedmap/index.es.js
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

var orderedmap = OrderedMap;

/* harmony default export */ var index_es = (orderedmap);

// CONCATENATED MODULE: ./node_modules/prosemirror-model/dist/index.es.js


function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var Fragment = function Fragment(content, size) {
  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this.size += content[i].nodeSize; } }
};

var index_es_prototypeAccessors = { firstChild: { configurable: true },lastChild: { configurable: true },childCount: { configurable: true } };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// :: (number, number, ?string, ?union<string, (leafNode: Node) → string>) → string
// Extract the text between `from` and `to`. See the same method on
// [`Node`](#model.Node.textBetween).
Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += typeof leafText === 'function' ? leafText(node): leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
Fragment.prototype.cut = function cut (from, to) {
  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new Fragment(result, size)
};

Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
Fragment.prototype.addToStart = function addToStart (node) {
  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
Fragment.prototype.addToEnd = function addToEnd (node) {
  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
Fragment.prototype.eq = function eq (other) {
  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
index_es_prototypeAccessors.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
index_es_prototypeAccessors.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
index_es_prototypeAccessors.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Fragment.prototype.forEach = function forEach (f) {
  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
Fragment.prototype.findIndex = function findIndex (pos, round) {
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return retIndex(0, pos) }
  if (pos == this.size) { return retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return retIndex(i + 1, end) }
      return retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
Fragment.from = function from (nodes) {
  if (!nodes) { return Fragment.empty }
  if (nodes instanceof Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  if (nodes.attrs) { return new Fragment([nodes], nodes.nodeSize) }
  throw new RangeError("Can not convert " + nodes + " to a Fragment" +
                       (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""))
};

Object.defineProperties( Fragment.prototype, index_es_prototypeAccessors );

var index_es_found = {index: 0, offset: 0};
function retIndex(index, offset) {
  index_es_found.index = index;
  index_es_found.offset = offset;
  return index_es_found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
Fragment.empty = new Fragment([], 0);

function compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
Mark.prototype.addToSet = function addToSet (set) {
  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this.eq(other)) { return set }
    if (this.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
Mark.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
Mark.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
Mark.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return Mark.none }
  if (marks instanceof Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = ReplaceError.prototype;
  return err
}

ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var index_es_prototypeAccessors$1 = { size: { configurable: true } };

// :: number
// The size this slice would add when inserted into a document.
index_es_prototypeAccessors$1.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new Slice(content, this.openStart, this.openEnd)
};

Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new Slice(fragment, openStart, openEnd)
};

Object.defineProperties( Slice.prototype, index_es_prototypeAccessors$1 );

function removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
Slice.empty = new Slice(Fragment.empty, 0, 0);

function index_es_replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new ReplaceError("Inconsistent open depths") }
  return replaceOuter($from, $to, slice, 0)
}

function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return index_es_close(node, replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return index_es_close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return index_es_close(node, replaceThreeWay($from, start, end, $to, depth))
  }
}

function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function index_es_joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node
}

function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { addNode($end.nodeBefore, target); }
}

function index_es_close(node, content) {
  if (!node.type.validContent(content))
    { throw new ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && index_es_joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && index_es_joinable($end, $to, depth + 1);

  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(index_es_close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { addNode(index_es_close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
    addRange($start, $end, depth, content);
    if (openEnd)
      { addNode(index_es_close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = index_es_joinable($from, $to, depth + 1);
    addNode(index_es_close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$2 = { parent: { configurable: true },doc: { configurable: true },textOffset: { configurable: true },nodeAfter: { configurable: true },nodeBefore: { configurable: true } };

ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$2.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$2.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 1 and `p.index(1)` is 2.
ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `depth` is `this.depth + 1`, the original
// position.
ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `depth` is `this.depth + 1`.
ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$2.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$2.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$2.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: (number, ?number) → number
// Get the position at the given index in the parent node at the
// given depth (which defaults to `this.depth`).
ResolvedPos.prototype.posAtIndex = function posAtIndex (index, depth) {
  depth = this.resolveDepth(depth);
  var node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  for (var i = 0; i < index; i++) { pos += node.child(i).nodeSize; }
  return pos
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
  for (var depth = this.depth; depth > 0; depth--)
    { if (this.start(depth) <= pos && this.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
      { return new NodeRange(this, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

ResolvedPos.prototype.toString = function toString () {
  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1); }
  return str + ":" + this.parentOffset
};

ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new ResolvedPos(pos, path, parentOffset)
};

ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < resolveCache.length; i++) {
    var cached = resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result
};

Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$2 );

var resolveCache = [], resolveCachePos = 0, resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1 = { start: { configurable: true },end: { configurable: true },parent: { configurable: true },startIndex: { configurable: true },endIndex: { configurable: true } };

// :: number The position at the start of the range.
prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );

var emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var index_es_Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || Mark.none;
};

var index_es_prototypeAccessors$3 = { nodeSize: { configurable: true },childCount: { configurable: true },textContent: { configurable: true },firstChild: { configurable: true },lastChild: { configurable: true },isBlock: { configurable: true },isTextblock: { configurable: true },inlineContent: { configurable: true },isInline: { configurable: true },isText: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
index_es_prototypeAccessors$3.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
index_es_prototypeAccessors$3.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
index_es_Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
index_es_Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
index_es_Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
index_es_Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node, index: number) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
index_es_Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
index_es_prototypeAccessors$3.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?union<string, ?(leafNode: Node) -> string>) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted to separate text
// from different block nodes. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
index_es_Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
index_es_prototypeAccessors$3.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
index_es_prototypeAccessors$3.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
index_es_Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
index_es_Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
index_es_Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
    Mark.sameSet(this.marks, marks || Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
index_es_Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
index_es_Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
index_es_Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
index_es_Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
index_es_Node.prototype.replace = function replace$1 (from, to, slice) {
  return index_es_replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
index_es_Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
index_es_Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
index_es_Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
index_es_Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };

index_es_Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };

// :: (number, number, union<Mark, MarkType>) → bool
// Test whether a given mark or mark type occurs in this document
// between the two given positions.
index_es_Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
index_es_prototypeAccessors$3.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
index_es_prototypeAccessors$3.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node allows inline content.
index_es_prototypeAccessors$3.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
index_es_prototypeAccessors$3.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
index_es_prototypeAccessors$3.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
index_es_prototypeAccessors$3.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
index_es_prototypeAccessors$3.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
index_es_Node.prototype.toString = function toString () {
  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
index_es_Node.prototype.contentMatchAt = function contentMatchAt (index) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
  return match
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
index_es_Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    if ( replacement === void 0 ) replacement = Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
index_es_Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
index_es_Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
index_es_Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  var copy = Mark.none;
  for (var i = 0; i < this.marks.length; i++) { copy = this.marks[i].addToSet(copy); }
  if (!Mark.sameSet(copy, this.marks))
    { throw new RangeError(("Invalid collection of marks for node " + (this.type.name) + ": " + (this.marks.map(function (m) { return m.type.name; })))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
index_es_Node.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
index_es_Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( index_es_Node.prototype, index_es_prototypeAccessors$3 );

var TextNode = /*@__PURE__*/(function (Node) {
  function TextNode(type, attrs, content, marks) {
    Node.call(this, type, attrs, null, marks);

    if (!content) { throw new RangeError("Empty text nodes are not allowed") }

    this.text = content;
  }

  if ( Node ) TextNode.__proto__ = Node;
  TextNode.prototype = Object.create( Node && Node.prototype );
  TextNode.prototype.constructor = TextNode;

  var prototypeAccessors$1 = { textContent: { configurable: true },nodeSize: { configurable: true } };

  TextNode.prototype.toString = function toString () {
    if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
    return wrapMarks(this.marks, JSON.stringify(this.text))
  };

  prototypeAccessors$1.textContent.get = function () { return this.text };

  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };

  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };

  TextNode.prototype.mark = function mark (marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
  };

  TextNode.prototype.withText = function withText (text) {
    if (text == this.text) { return this }
    return new TextNode(this.type, this.attrs, text, this.marks)
  };

  TextNode.prototype.cut = function cut (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.text.length;

    if (from == 0 && to == this.text.length) { return this }
    return this.withText(this.text.slice(from, to))
  };

  TextNode.prototype.eq = function eq (other) {
    return this.sameMarkup(other) && this.text == other.text
  };

  TextNode.prototype.toJSON = function toJSON () {
    var base = Node.prototype.toJSON.call(this);
    base.text = this.text;
    return base
  };

  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );

  return TextNode;
}(index_es_Node));

function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var prototypeAccessors$4 = { inlineContent: { configurable: true },defaultType: { configurable: true },edgeCount: { configurable: true } };

ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new TokenStream(string, nodeTypes);
  if (stream.next == null) { return ContentMatch.empty }
  var expr = parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
ContentMatch.prototype.matchType = function matchType (type) {
  for (var i = 0; i < this.next.length; i += 2)
    { if (this.next[i] == type) { return this.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

prototypeAccessors$4.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
prototypeAccessors$4.defaultType.get = function () {
  for (var i = 0; i < this.next.length; i += 2) {
    var type = this.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

ContentMatch.prototype.compatible = function compatible (other) {
  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
ContentMatch.prototype.findWrapping = function findWrapping (target) {
  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this.wrapCache[i] == target) { return this.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
prototypeAccessors$4.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_​th outgoing edge from this node in the finite
// automaton that describes the content expression.
ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i >= this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( ContentMatch.prototype, prototypeAccessors$4 );

ContentMatch.empty = new ContentMatch(true);

var TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.shift(); }
};

var prototypeAccessors$1$2 = { next: { configurable: true } };

prototypeAccessors$1$2.next.get = function () { return this.tokens[this.pos] };

TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$2 );

function parseExpr(stream) {
  var exprs = [];
  do { exprs.push(parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function parseExprRange(stream, expr) {
  var min = parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function cmp(a, b) { return b - a }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);

  this.defaultAttrs = defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var prototypeAccessors$5 = { isInline: { configurable: true },isTextblock: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true },whitespace: { configurable: true } };

// :: bool
// True if this is an inline type.
prototypeAccessors$5.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
prototypeAccessors$5.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
prototypeAccessors$5.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
prototypeAccessors$5.isAtom.get = function () { return this.isLeaf || this.spec.atom };

// :: union<"pre", "normal">
// The node type's [whitespace](#view.NodeSpec.whitespace) option.
prototypeAccessors$5.whitespace.get = function () { return this.spec.whitespace || (this.spec.code ? "pre" : "normal") };

// :: () → bool
// Tells you whether this node type has any required attributes.
NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs () {
  for (var n in this.attrs) { if (this.attrs[n].isRequired) { return true } }
  return false
};

NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new index_es_Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new index_es_Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
  if (!after) { return null }
  return new index_es_Node(this, attrs, content.append(after), Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
NodeType.prototype.validContent = function validContent (content) {
  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
NodeType.prototype.allowsMarks = function allowsMarks (marks) {
  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
NodeType.prototype.allowedMarks = function allowedMarks (marks) {
  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : Mark.empty
};

NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( NodeType.prototype, prototypeAccessors$5 );

// Attribute descriptors

var Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var prototypeAccessors$1$3 = { isRequired: { configurable: true } };

prototypeAccessors$1$3.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( Attribute.prototype, prototypeAccessors$1$3 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = defaultAttrs(this.attrs);
  this.instance = defaults && new Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new Mark(this, computeAttrs(this.attrs, attrs))
};

MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
MarkType.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++) { if (set[i].type == this) {
    set = set.slice(0, i).concat(set.slice(i + 1));
    i--;
  } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
MarkType.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// SchemaSpec:: interface
// An object describing a schema, as passed to the [`Schema`](#model.Schema)
// constructor.
//
//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
//   The node types in this schema. Maps names to
//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
//   associated with that name. Their order is significant—it
//   determines which [parse rules](#model.NodeSpec.parseDOM) take
//   precedence by default, and which nodes come first in a given
//   [group](#model.NodeSpec.group).
//
//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
//   The mark types that exist in this schema. The order in which they
//   are provided determines the order in which [mark
//   sets](#model.Mark.addToSet) are sorted and in which [parse
//   rules](#model.MarkSpec.parseDOM) are tried.
//
//   topNode:: ?string
//   The name of the default top-level node for the schema. Defaults
//   to `"doc"`.

// NodeSpec:: interface
//
//   content:: ?string
//   The content expression for this node, as described in the [schema
//   guide](/docs/guide/#schema.content_expressions). When not given,
//   the node does not allow any content.
//
//   marks:: ?string
//   The marks that are allowed inside of this node. May be a
//   space-separated string referring to mark names or groups, `"_"`
//   to explicitly allow all marks, or `""` to disallow marks. When
//   not given, nodes with inline content default to allowing all
//   marks, other nodes default to not allowing marks.
//
//   group:: ?string
//   The group or space-separated groups to which this node belongs,
//   which can be referred to in the content expressions for the
//   schema.
//
//   inline:: ?bool
//   Should be set to true for inline nodes. (Implied for text nodes.)
//
//   atom:: ?bool
//   Can be set to true to indicate that, though this isn't a [leaf
//   node](#model.NodeType.isLeaf), it doesn't have directly editable
//   content and should be treated as a single unit in the view.
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that nodes of this type get.
//
//   selectable:: ?bool
//   Controls whether nodes of this type can be selected as a [node
//   selection](#state.NodeSelection). Defaults to true for non-text
//   nodes.
//
//   draggable:: ?bool
//   Determines whether nodes of this type can be dragged without
//   being selected. Defaults to false.
//
//   code:: ?bool
//   Can be used to indicate that this node contains code, which
//   causes some commands to behave differently.
//
//   whitespace:: ?union<"pre", "normal">
//   Controls way whitespace in this a node is parsed. The default is
//   `"normal"`, which causes the [DOM parser](#model.DOMParser) to
//   collapse whitespace in normal mode, and normalize it (replacing
//   newlines and such with spaces) otherwise. `"pre"` causes the
//   parser to preserve spaces inside the node. When this option isn't
//   given, but [`code`](#model.NodeSpec.code) is true, `whitespace`
//   will default to `"pre"`. Note that this option doesn't influence
//   the way the node is rendered—that should be handled by `toDOM`
//   and/or styling.
//
//   defining:: ?bool
//   Determines whether this node is considered an important parent
//   node during replace operations (such as paste). Non-defining (the
//   default) nodes get dropped when their entire content is replaced,
//   whereas defining nodes persist and wrap the inserted content.
//   Likewise, in _inserted_ content the defining parents of the
//   content are preserved when possible. Typically,
//   non-default-paragraph textblock types, and possibly list items,
//   are marked as defining.
//
//   isolating:: ?bool
//   When enabled (default is false), the sides of nodes of this type
//   count as boundaries that regular editing operations, like
//   backspacing or lifting, won't cross. An example of a node that
//   should probably have this enabled is a table cell.
//
//   toDOM:: ?(node: Node) → DOMOutputSpec
//   Defines the default way a node of this type should be serialized
//   to DOM/HTML (as used by
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
//   Should return a DOM node or an [array
//   structure](#model.DOMOutputSpec) that describes one, with an
//   optional number zero (“hole”) in it to indicate where the node's
//   content should be inserted.
//
//   For text nodes, the default is to create a text DOM node. Though
//   it is possible to create a serializer where text is rendered
//   differently, this is not supported inside the editor, so you
//   shouldn't override that in your text node spec.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this node, which can be
//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
//   automatically derive a parser. The `node` field in the rules is
//   implied (the name of this node will be filled in automatically).
//   If you supply your own parser, you do not need to also specify
//   parsing rules in your schema.
//
//   toDebugString:: ?(node: Node) -> string
//   Defines the default way a node of this type should be serialized
//   to a string representation for debugging (e.g. in error messages).

// MarkSpec:: interface
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that marks of this type get.
//
//   inclusive:: ?bool
//   Whether this mark should be active when the cursor is positioned
//   at its end (or at its start when that is also the start of the
//   parent node). Defaults to true.
//
//   excludes:: ?string
//   Determines which other marks this mark can coexist with. Should
//   be a space-separated strings naming other marks or groups of marks.
//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
//   that it excludes are removed in the process. If the set contains
//   any mark that excludes the new mark but is not, itself, excluded
//   by the new mark, the mark can not be added an the set. You can
//   use the value `"_"` to indicate that the mark excludes all
//   marks in the schema.
//
//   Defaults to only being exclusive with marks of the same type. You
//   can set it to an empty string (or any string not containing the
//   mark's own name) to allow multiple marks of a given type to
//   coexist (as long as they have different attributes).
//
//   group:: ?string
//   The group or space-separated groups to which this mark belongs.
//
//   spanning:: ?bool
//   Determines whether marks of this type can span multiple adjacent
//   nodes when serialized to DOM/HTML. Defaults to true.
//
//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
//   Defines the default way marks of this type should be serialized
//   to DOM/HTML. When the resulting spec contains a hole, that is
//   where the marked content is placed. Otherwise, it is appended to
//   the top node.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this mark (see the
//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
//   `mark` field in the rules is implied.

// AttributeSpec:: interface
//
// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
// marks.
//
//   default:: ?any
//   The default value for this attribute, to use when no explicit
//   value is provided. Attributes that have no default must be
//   provided whenever a node or mark of a type that has them is
//   created.

// ::- A document schema. Holds [node](#model.NodeType) and [mark
// type](#model.MarkType) objects for the nodes and marks that may
// occur in conforming documents, and provides functionality for
// creating and deserializing such documents.
var index_es_Schema = function Schema(spec) {
  // :: SchemaSpec
  // The [spec](#model.SchemaSpec) on which the schema is based,
  // with the added guarantee that its `nodes` and `marks`
  // properties are
  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
  // (not raw objects).
  this.spec = {};
  for (var prop in spec) { this.spec[prop] = spec[prop]; }
  this.spec.nodes = index_es.from(spec.nodes);
  this.spec.marks = index_es.from(spec.marks);

  // :: Object<NodeType>
  // An object mapping the schema's node names to node type objects.
  this.nodes = NodeType.compile(this.spec.nodes, this);

  // :: Object<MarkType>
  // A map from mark names to mark type objects.
  this.marks = MarkType.compile(this.spec.marks, this);

  var contentExprCache = Object.create(null);
  for (var prop$1 in this.nodes) {
    if (prop$1 in this.marks)
      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
    var type = this.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] ||
      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null :
      markExpr ? gatherMarks(this, markExpr.split(" ")) :
      markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this.marks) {
    var type$1 = this.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
  }

  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);

  // :: NodeType
  // The type of the [default top node](#model.SchemaSpec.topNode)
  // for this schema.
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];

  // :: Object
  // An object for storing whatever values modules may want to
  // compute and cache per schema. (If you want to store something
  // in it, try to use property names unlikely to clash.)
  this.cached = Object.create(null);
  this.cached.wrappings = Object.create(null);
};

// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a node in this schema. The `type` may be a string or a
// `NodeType` instance. Attributes will be extended
// with defaults, `content` may be a `Fragment`,
// `null`, a `Node`, or an array of nodes.
index_es_Schema.prototype.node = function node (type, attrs, content, marks) {
  if (typeof type == "string")
    { type = this.nodeType(type); }
  else if (!(type instanceof NodeType))
    { throw new RangeError("Invalid node type: " + type) }
  else if (type.schema != this)
    { throw new RangeError("Node type from different schema used (" + type.name + ")") }

  return type.createChecked(attrs, content, marks)
};

// :: (string, ?[Mark]) → Node
// Create a text node in the schema. Empty text nodes are not
// allowed.
index_es_Schema.prototype.text = function text (text$1, marks) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
};

// :: (union<string, MarkType>, ?Object) → Mark
// Create a mark with the given type and attributes.
index_es_Schema.prototype.mark = function mark (type, attrs) {
  if (typeof type == "string") { type = this.marks[type]; }
  return type.create(attrs)
};

// :: (Object) → Node
// Deserialize a node from its JSON representation. This method is
// bound.
index_es_Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
  return index_es_Node.fromJSON(this, json)
};

// :: (Object) → Mark
// Deserialize a mark from its JSON representation. This method is
// bound.
index_es_Schema.prototype.markFromJSON = function markFromJSON (json) {
  return Mark.fromJSON(this, json)
};

index_es_Schema.prototype.nodeType = function nodeType (name) {
  var found = this.nodes[name];
  if (!found) { throw new RangeError("Unknown node type: " + name) }
  return found
};

function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
          { found.push(ok = mark$1); }
      }
    }
    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
  }
  return found
}

// ParseOptions:: interface
// These are the options recognized by the
// [`parse`](#model.DOMParser.parse) and
// [`parseSlice`](#model.DOMParser.parseSlice) methods.
//
//   preserveWhitespace:: ?union<bool, "full">
//   By default, whitespace is collapsed as per HTML's rules. Pass
//   `true` to preserve whitespace, but normalize newlines to
//   spaces, and `"full"` to preserve whitespace entirely.
//
//   findPositions:: ?[{node: dom.Node, offset: number}]
//   When given, the parser will, beside parsing the content,
//   record the document positions of the given DOM positions. It
//   will do so by writing to the objects, adding a `pos` property
//   that holds the document position. DOM positions that are not
//   in the parsed content will not be written to.
//
//   from:: ?number
//   The child node index to start parsing from.
//
//   to:: ?number
//   The child node index to stop parsing at.
//
//   topNode:: ?Node
//   By default, the content is parsed into the schema's default
//   [top node type](#model.Schema.topNodeType). You can pass this
//   option to use the type and attributes from a different node
//   as the top container.
//
//   topMatch:: ?ContentMatch
//   Provide the starting content match that content parsed into the
//   top node is matched against.
//
//   context:: ?ResolvedPos
//   A set of additional nodes to count as
//   [context](#model.ParseRule.context) when parsing, above the
//   given [top node](#model.ParseOptions.topNode).

// ParseRule:: interface
// A value that describes how to parse a given DOM node or inline
// style as a ProseMirror node or mark.
//
//   tag:: ?string
//   A CSS selector describing the kind of DOM elements to match. A
//   single rule should have _either_ a `tag` or a `style` property.
//
//   namespace:: ?string
//   The namespace to match. This should be used with `tag`.
//   Nodes are only matched when the namespace matches or this property
//   is null.
//
//   style:: ?string
//   A CSS property name to match. When given, this rule matches
//   inline styles that list that property. May also have the form
//   `"property=value"`, in which case the rule only matches if the
//   property's value exactly matches the given value. (For more
//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
//   and return false to indicate that the match failed.) Rules
//   matching styles may only produce [marks](#model.ParseRule.mark),
//   not nodes.
//
//   priority:: ?number
//   Can be used to change the order in which the parse rules in a
//   schema are tried. Those with higher priority come first. Rules
//   without a priority are counted as having priority 50. This
//   property is only meaningful in a schema—when directly
//   constructing a parser, the order of the rule array is used.
//
//   consuming:: ?boolean
//   By default, when a rule matches an element or style, no further
//   rules get a chance to match it. By setting this to `false`, you
//   indicate that even when this rule matches, other rules that come
//   after it should also run.
//
//   context:: ?string
//   When given, restricts this rule to only match when the current
//   context—the parent nodes into which the content is being
//   parsed—matches this expression. Should contain one or more node
//   names or node group names followed by single or double slashes.
//   For example `"paragraph/"` means the rule only matches when the
//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
//   it to be in a paragraph that is inside a blockquote, and
//   `"section//"` matches any position inside a section—a double
//   slash matches any sequence of ancestor nodes. To allow multiple
//   different contexts, they can be separated by a pipe (`|`)
//   character, as in `"blockquote/|list_item/"`.
//
//   node:: ?string
//   The name of the node type to create when this rule matches. Only
//   valid for rules with a `tag` property, not for style rules. Each
//   rule should have one of a `node`, `mark`, or `ignore` property
//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
//   or `mark` property will be derived from its position).
//
//   mark:: ?string
//   The name of the mark type to wrap the matched content in.
//
//   ignore:: ?bool
//   When true, ignore content that matches this rule.
//
//   closeParent:: ?bool
//   When true, finding an element that matches this rule will close
//   the current node.
//
//   skip:: ?bool
//   When true, ignore the node that matches this rule, but do parse
//   its content.
//
//   attrs:: ?Object
//   Attributes for the node or mark created by this rule. When
//   `getAttrs` is provided, it takes precedence.
//
//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
//   A function used to compute the attributes for the node or mark
//   created by this rule. Can also be used to describe further
//   conditions the DOM element or style must match. When it returns
//   `false`, the rule won't match. When it returns null or undefined,
//   that is interpreted as an empty/default set of attributes.
//
//   Called with a DOM Element for `tag` rules, and with a string (the
//   style's value) for `style` rules.
//
//   contentElement:: ?union<string, (dom.Node) → dom.Node>
//   For `tag` rules that produce non-leaf nodes or marks, by default
//   the content of the DOM element is parsed as content of the mark
//   or node. If the child nodes are in a descendent node, this may be
//   a CSS selector string that the parser must use to find the actual
//   content element, or a function that returns the actual content
//   element to the parser.
//
//   getContent:: ?(dom.Node, schema: Schema) → Fragment
//   Can be used to override the content of a matched node. When
//   present, instead of parsing the node's child nodes, the result of
//   this function is used.
//
//   preserveWhitespace:: ?union<bool, "full">
//   Controls whether whitespace should be preserved when parsing the
//   content inside the matched element. `false` means whitespace may
//   be collapsed, `true` means that whitespace should be preserved
//   but newlines normalized to spaces, and `"full"` means that
//   newlines should also be preserved.

// ::- A DOM parser represents a strategy for parsing DOM content into
// a ProseMirror document conforming to a given schema. Its behavior
// is defined by an array of [rules](#model.ParseRule).
var DOMParser = function DOMParser(schema, rules) {
  var this$1 = this;

  // :: Schema
  // The schema into which the parser parses.
  this.schema = schema;
  // :: [ParseRule]
  // The set of [parse rules](#model.ParseRule) that the parser
  // uses, in order of precedence.
  this.rules = rules;
  this.tags = [];
  this.styles = [];

  rules.forEach(function (rule) {
    if (rule.tag) { this$1.tags.push(rule); }
    else if (rule.style) { this$1.styles.push(rule); }
  });

  // Only normalize list elements when lists in the schema can't directly contain themselves
  this.normalizeLists = !this.tags.some(function (r) {
    if (!/^(ul|ol)\b/.test(r.tag) || !r.node) { return false }
    var node = schema.nodes[r.node];
    return node.contentMatch.matchType(node)
  });
};

// :: (dom.Node, ?ParseOptions) → Node
// Parse a document from the content of a DOM node.
DOMParser.prototype.parse = function parse (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish()
};

// :: (dom.Node, ?ParseOptions) → Slice
// Parses the content of the given DOM node, like
// [`parse`](#model.DOMParser.parse), and takes the same set of
// options. But unlike that method, which produces a whole node,
// this one returns a slice that is open at the sides, meaning that
// the schema constraints aren't applied to the start of nodes to
// the left of the input and the end of nodes at the end.
DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish())
};

DOMParser.prototype.matchTag = function matchTag (dom, context, after) {
  for (var i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
    var rule = this.tags[i];
    if (index_es_matches(dom, rule.tag) &&
        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
        (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result = rule.getAttrs(dom);
        if (result === false) { continue }
        rule.attrs = result;
      }
      return rule
    }
  }
};

DOMParser.prototype.matchStyle = function matchStyle (prop, value, context, after) {
  for (var i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
    var rule = this.styles[i];
    if (rule.style.indexOf(prop) != 0 ||
        rule.context && !context.matchesContext(rule.context) ||
        // Test that the style string either precisely matches the prop,
        // or has an '=' sign after the prop, followed by the given
        // value.
        rule.style.length > prop.length &&
        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
      { continue }
    if (rule.getAttrs) {
      var result = rule.getAttrs(value);
      if (result === false) { continue }
      rule.attrs = result;
    }
    return rule
  }
};

// : (Schema) → [ParseRule]
DOMParser.schemaRules = function schemaRules (schema) {
  var result = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
    for (; i < result.length; i++) {
      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) { break }
    }
    result.splice(i, 0, rule);
  }

  var loop = function ( name ) {
    var rules = schema.marks[name].spec.parseDOM;
    if (rules) { rules.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.mark = name;
    }); }
  };

    for (var name in schema.marks) loop( name );
  var loop$1 = function ( name ) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) { rules$1.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.node = name$1;
    }); }
  };

    for (var name$1 in schema.nodes) loop$1();
  return result
};

// :: (Schema) → DOMParser
// Construct a DOM parser using the parsing rules listed in a
// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
// [priority](#model.ParseRule.priority).
DOMParser.fromSchema = function fromSchema (schema) {
  return schema.cached.domParser ||
    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
};

// : Object<bool> The block-level tags in HTML5
var blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;

function wsOptionsFor(type, preserveWhitespace, base) {
  if (preserveWhitespace != null) { return (preserveWhitespace ? OPT_PRESERVE_WS : 0) |
    (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0) }
  return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base & ~OPT_OPEN_LEFT
}

var NodeContext = function NodeContext(type, attrs, marks, pendingMarks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  // Marks applied to this node itself
  this.marks = marks;
  // Marks applied to its children
  this.activeMarks = Mark.none;
  // Marks that can't apply here, but will be used in children if possible
  this.pendingMarks = pendingMarks;
  // Nested Marks with same type
  this.stashMarks = [];
};

NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

NodeContext.prototype.popFromStashMark = function popFromStashMark (mark) {
  for (var i = this.stashMarks.length - 1; i >= 0; i--)
    { if (mark.eq(this.stashMarks[i])) { return this.stashMarks.splice(i, 1)[0] } }
};

NodeContext.prototype.applyPending = function applyPending (nextType) {
  for (var i = 0, pending = this.pendingMarks; i < pending.length; i++) {
    var mark = pending[i];
    if ((this.type ? this.type.allowsMarkType(mark.type) : markMayApply(mark.type, nextType)) &&
        !mark.isInSet(this.activeMarks)) {
      this.activeMarks = mark.addToSet(this.activeMarks);
      this.pendingMarks = mark.removeFromSet(this.pendingMarks);
    }
  }
};

NodeContext.prototype.inlineContext = function inlineContext (node) {
  if (this.type) { return this.type.inlineContent }
  if (this.content.length) { return this.content[0].isInline }
  return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase())
};

var ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new NodeContext(null, null, Mark.none, Mark.none, true, null, topOptions); }
  else
    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var prototypeAccessors$6 = { top: { configurable: true },currentPos: { configurable: true } };

prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
ParseContext.prototype.addDOM = function addDOM (dom) {
  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks = style ? this.readStyles(parseStyles(style)) : null, top = this.top;
    if (marks != null) { for (var i = 0; i < marks.length; i++) { this.addPendingMark(marks[i]); } }
    this.addElement(dom);
    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this.removePendingMark(marks[i$1], top); } }
  }
};

ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if (top.options & OPT_PRESERVE_WS_FULL ||
      top.inlineContext(dom) ||
      /[^ \t\r\n\u000c]/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/[ \t\r\n\u000c]+/g, " ");
      // If this starts with whitespace, and there is no node before it, or
      // a hard break, or a text node that ends with whitespace, strip the
      // leading space.
      if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore ||
            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
            (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
          { value = value.slice(1); }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    } else {
      value = value.replace(/\r\n?/g, "\n");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element, ?ParseRule)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
ParseContext.prototype.addElement = function addElement (dom, matchAfter) {
  var name = dom.nodeName.toLowerCase(), ruleID;
  if (listTags.hasOwnProperty(name) && this.parser.normalizeLists) { normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) ||
      (ruleID = this.parser.matchTag(dom, this, matchAfter));
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
    this.ignoreFallback(dom);
  } else if (!rule || rule.skip || rule.closeParent) {
    if (rule && rule.closeParent) { this.open = Math.max(0, this.open - 1); }
    else if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    } else if (!dom.firstChild) {
      this.leafFallback(dom);
      return
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : null);
  }
};

// Called for leaf DOM nodes that would otherwise be ignored
ParseContext.prototype.leafFallback = function leafFallback (dom) {
  if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
    { this.addTextNode(dom.ownerDocument.createTextNode("\n")); }
};

// Called for ignored nodes
ParseContext.prototype.ignoreFallback = function ignoreFallback (dom) {
  // Ignored BR nodes should at least create an inline context
  if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
    { this.findPlace(this.parser.schema.text("-")); }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
ParseContext.prototype.readStyles = function readStyles (styles) {
  var marks = Mark.none;
  style: for (var i = 0; i < styles.length; i += 2) {
    for (var after = null;;) {
      var rule = this.parser.matchStyle(styles[i], styles[i + 1], this, after);
      if (!rule) { continue style }
      if (rule.ignore) { return null }
      marks = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
      if (rule.consuming === false) { after = rule; }
      else { break }
    }
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule, continueAfter) {
    var this$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (!nodeType.isLeaf) {
      sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace);
    } else if (!this.insertNode(nodeType.create(rule.attrs))) {
      this.leafFallback(dom);
    }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (continueAfter) {
    this.addElement(dom, continueAfter);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark, startIn); }
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this.findAtPoint(parent, index);
    this.addDOM(dom);
    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
ParseContext.prototype.findPlace = function findPlace (node) {
  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enterInner(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    top.applyPending(node.type);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
    return true
  }
  return false
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) { this.enterInner(type, attrs, true, preserveWS); }
  return ok
};

// Open a node of the given type
ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.applyPending(type);
  top.match = top.match && top.match.matchType(type, attrs);
  var options = wsOptionsFor(type, preserveWS, top.options);
  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

ParseContext.prototype.sync = function sync (to) {
  for (var i = this.open; i >= 0; i--) { if (this.nodes[i] == to) {
    this.open = i;
    return
  } }
};

prototypeAccessors$6.currentPos.get = function () {
  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == parent && this.find[i].offset == offset)
      { this.find[i].pos = this.currentPos; }
  } }
};

ParseContext.prototype.findInside = function findInside (parent) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
      { this.find[i].pos = this.currentPos; }
  } }
};

ParseContext.prototype.findAround = function findAround (parent, content, before) {
  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
      var pos = content.compareDocumentPosition(this.find[i].node);
      if (pos & (before ? 2 : 4))
        { this.find[i].pos = this.currentPos; }
    }
  } }
};

ParseContext.prototype.findInText = function findInText (textNode) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == textNode)
      { this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

ParseContext.prototype.textblockFromContext = function textblockFromContext () {
  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this.parser.schema.nodes) {
    var type = this.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  var found = findSameMarkInSet(mark, this.top.pendingMarks);
  if (found) { this.top.stashMarks.push(found); }
  this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
};

ParseContext.prototype.removePendingMark = function removePendingMark (mark, upto) {
  for (var depth = this.open; depth >= 0; depth--) {
    var level = this.nodes[depth];
    var found = level.pendingMarks.lastIndexOf(mark);
    if (found > -1) {
      level.pendingMarks = mark.removeFromSet(level.pendingMarks);
    } else {
      level.activeMarks = mark.removeFromSet(level.activeMarks);
      var stashMark = level.popFromStashMark(mark);
      if (stashMark && level.type && level.type.allowsMarkType(stashMark.type))
        { level.activeMarks = stashMark.addToSet(level.activeMarks); }
    }
    if (level == upto) { break }
  }
};

Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// Apply a CSS selector.
function index_es_matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

function copy(obj) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  return copy
}

// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function markMayApply(markType, nodeType) {
  var nodes = nodeType.schema.nodes;
  var loop = function ( name ) {
    var parent = nodes[name];
    if (!parent.allowsMarkType(markType)) { return }
    var seen = [], scan = function (match) {
      seen.push(match);
      for (var i = 0; i < match.edgeCount; i++) {
        var ref = match.edge(i);
        var type = ref.type;
        var next = ref.next;
        if (type == nodeType) { return true }
        if (seen.indexOf(next) < 0 && scan(next)) { return true }
      }
    };
    if (scan(parent.contentMatch)) { return { v: true } }
  };

  for (var name in nodes) {
    var returned = loop( name );

    if ( returned ) return returned.v;
  }
}

function findSameMarkInSet(mark, set) {
  for (var i = 0; i < set.length; i++) {
    if (mark.eq(set[i])) { return set[i] }
  }
}

// DOMOutputSpec:: interface
// A description of a DOM structure. Can be either a string, which is
// interpreted as a text node, a DOM node, which is interpreted as
// itself, a `{dom: Node, contentDOM: ?Node}` object, or an array.
//
// An array describes a DOM element. The first value in the array
// should be a string—the name of the DOM element, optionally prefixed
// by a namespace URL and a space. If the second element is plain
// object, it is interpreted as a set of attributes for the element.
// Any elements after that (including the 2nd if it's not an attribute
// object) are interpreted as children of the DOM elements, and must
// either be valid `DOMOutputSpec` values, or the number zero.
//
// The number zero (pronounced “hole”) is used to indicate the place
// where a node's child nodes should be inserted. If it occurs in an
// output spec, it should be the only child element in its parent
// node.

// ::- A DOM serializer knows how to convert ProseMirror nodes and
// marks of various types to DOM nodes.
var DOMSerializer = function DOMSerializer(nodes, marks) {
  // :: Object<(node: Node) → DOMOutputSpec>
  // The node serialization functions.
  this.nodes = nodes || {};
  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
  // The mark serialization functions.
  this.marks = marks || {};
};

// :: (Fragment, ?Object) → dom.DocumentFragment
// Serialize the content of this fragment to a DOM fragment. When
// not in the browser, the `document` option, containing a DOM
// document, should be passed so that the serializer can create
// nodes.
DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  if (!target) { target = index_es_doc(options).createDocumentFragment(); }

  var top = target, active = null;
  fragment.forEach(function (node) {
    if (active || node.marks.length) {
      if (!active) { active = []; }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node.marks.length) {
        var next = node.marks[rendered];
        if (!this$1.marks[next.type.name]) { rendered++; continue }
        if (!next.eq(active[keep]) || next.type.spec.spanning === false) { break }
        keep += 2; rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node.marks.length) {
        var add = node.marks[rendered++];
        var markDOM = this$1.serializeMark(add, node.isInline, options);
        if (markDOM) {
          active.push(add, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1.serializeNodeInner(node, options));
  });

  return target
};

DOMSerializer.prototype.serializeNodeInner = function serializeNodeInner (node, options) {
    if ( options === void 0 ) options = {};

  var ref =
      DOMSerializer.renderSpec(index_es_doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;
  if (contentDOM) {
    if (node.isLeaf)
      { throw new RangeError("Content hole not allowed in a leaf node spec") }
    if (options.onContent)
      { options.onContent(node, contentDOM, options); }
    else
      { this.serializeFragment(node.content, options, contentDOM); }
  }
  return dom
};

// :: (Node, ?Object) → dom.Node
// Serialize this node to a DOM node. This can be useful when you
// need to serialize a part of a document, as opposed to the whole
// document. To serialize a whole document, use
// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
// its [content](#model.Node.content).
DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
    if ( options === void 0 ) options = {};

  var dom = this.serializeNodeInner(node, options);
  for (var i = node.marks.length - 1; i >= 0; i--) {
    var wrap = this.serializeMark(node.marks[i], node.isInline, options);
    if (wrap) {
(wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom
};

DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
    if ( options === void 0 ) options = {};

  var toDOM = this.marks[mark.type.name];
  return toDOM && DOMSerializer.renderSpec(index_es_doc(options), toDOM(mark, inline))
};

// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
// the spec has a hole (zero) in it, `contentDOM` will point at the
// node with the hole.
DOMSerializer.renderSpec = function renderSpec (doc, structure, xmlNS) {
    if ( xmlNS === void 0 ) xmlNS = null;

  if (typeof structure == "string")
    { return {dom: doc.createTextNode(structure)} }
  if (structure.nodeType != null)
    { return {dom: structure} }
  if (structure.dom && structure.dom.nodeType != null)
    { return structure }
  var tagName = structure[0], space = tagName.indexOf(" ");
  if (space > 0) {
    xmlNS = tagName.slice(0, space);
    tagName = tagName.slice(space + 1);
  }
  var contentDOM = null, dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
  var attrs = structure[1], start = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) { if (attrs[name] != null) {
      var space$1 = name.indexOf(" ");
      if (space$1 > 0) { dom.setAttributeNS(name.slice(0, space$1), name.slice(space$1 + 1), attrs[name]); }
      else { dom.setAttribute(name, attrs[name]); }
    } }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start)
        { throw new RangeError("Content hole must be the only child of its parent node") }
      return {dom: dom, contentDOM: dom}
    } else {
      var ref = DOMSerializer.renderSpec(doc, child, xmlNS);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) { throw new RangeError("Multiple content holes") }
        contentDOM = innerContent;
      }
    }
  }
  return {dom: dom, contentDOM: contentDOM}
};

// :: (Schema) → DOMSerializer
// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
// properties in a schema's node and mark specs.
DOMSerializer.fromSchema = function fromSchema (schema) {
  return schema.cached.domSerializer ||
    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
};

// : (Schema) → Object<(node: Node) → DOMOutputSpec>
// Gather the serializers in a schema's node specs into an object.
// This can be useful as a base to build a custom serializer from.
DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
  var result = gatherToDOM(schema.nodes);
  if (!result.text) { result.text = function (node) { return node.text; }; }
  return result
};

// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
// Gather the serializers in a schema's mark specs into an object.
DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
  return gatherToDOM(schema.marks)
};

function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) { result[name] = toDOM; }
  }
  return result
}

function index_es_doc(options) {
  // declare global: window
  return options.document || window.document
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-transform/dist/index.es.js


// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  if (!ranges.length && StepMap.empty) { return StepMap.empty }
  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = pos == (assoc < 0 ? start : end) ? null : makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

// :: StepMap
// A StepMap that contains no changed ranges.
StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this.mirror[i] == n) { return this.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// :: () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
  var deleted = false;

  for (var i = this.from; i < this.to; i++) {
    var map = this.maps[i], result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this.getMirror(i);
      if (corr != null && corr > i && corr < this.to) {
        i = corr;
        pos = this.maps[corr].recover(result.recover);
        continue
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var index_es_Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var dist_index_es_prototypeAccessors = { before: { configurable: true },docChanged: { configurable: true } };

// :: Node The starting document.
dist_index_es_prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
index_es_Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
index_es_Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
dist_index_es_prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

index_es_Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( index_es_Transform.prototype, dist_index_es_prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var index_es_Step = function Step () {};

index_es_Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
index_es_Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
index_es_Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
index_es_Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
index_es_Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
index_es_Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
index_es_Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
index_es_Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof ReplaceError) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var index_es_ReplaceStep = /*@__PURE__*/(function (Step) {
  function ReplaceStep(from, to, slice, structure) {
    Step.call(this);
    // :: number
    // The start position of the replaced range.
    this.from = from;
    // :: number
    // The end position of the replaced range.
    this.to = to;
    // :: Slice
    // The slice to insert.
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceStep.__proto__ = Step;
  ReplaceStep.prototype = Object.create( Step && Step.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure || this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? Slice.empty
          : new Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? Slice.empty
          : new Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(index_es_Step));

index_es_Step.jsonID("replace", index_es_ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var index_es_ReplaceAroundStep = /*@__PURE__*/(function (Step) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step.call(this);
    // :: number
    // The start position of the replaced range.
    this.from = from;
    // :: number
    // The end position of the replaced range.
    this.to = to;
    // :: number
    // The start of preserved range.
    this.gapFrom = gapFrom;
    // :: number
    // The end of preserved range.
    this.gapTo = gapTo;
    // :: Slice
    // The slice to insert.
    this.slice = slice;
    // :: number
    // The position in the slice where the preserved range should be
    // inserted.
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceAroundStep.__proto__ = Step;
  ReplaceAroundStep.prototype = Object.create( Step && Step.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(index_es_Step));

index_es_Step.jsonID("replaceAround", index_es_ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
index_es_Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = Fragment.from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = Fragment.from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new index_es_ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new Slice(before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
index_es_Transform.prototype.wrap = function(range, wrappers) {
  var content = Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--) {
    if (content.size) {
      var match = wrappers[i].type.contentMatch.matchFragment(content);
      if (!match || !match.validEnd)
        { throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper") }
    }
    content = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
  }

  var start = range.start, end = range.end;
  return this.step(new index_es_ReplaceAroundStep(start, end, start, end, new Slice(content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
index_es_Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new index_es_ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new Slice(Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
index_es_Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new index_es_ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new Slice(Fragment.from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
index_es_Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = Fragment.empty, after = Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new index_es_ReplaceStep(pos, pos, new Slice(before.append(after), depth, depth), true))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return dist_index_es_joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function dist_index_es_joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0), index = $pos.index(d);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      index++;
      after = $pos.node(d).maybeChild(index);
    } else {
      before = $pos.node(d).maybeChild(index - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && dist_index_es_joinable(before, after) &&
        $pos.node(d).canReplace(index, index + 1)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
index_es_Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new index_es_ReplaceStep(pos - depth, pos + depth, Slice.empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      var parent = $pos.node(d), fits = false;
      if (pass == 1) {
        fits = parent.canReplace(insertPos, insertPos, content);
      } else {
        var wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
        fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
      }
      if (fits)
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return Fragment.fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var index_es_AddMarkStep = /*@__PURE__*/(function (Step) {
  function AddMarkStep(from, to, mark) {
    Step.call(this);
    // :: number
    // The start of the marked range.
    this.from = from;
    // :: number
    // The end of the marked range.
    this.to = to;
    // :: Mark
    // The mark to add.
    this.mark = mark;
  }

  if ( Step ) AddMarkStep.__proto__ = Step;
  AddMarkStep.prototype = Object.create( Step && Step.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new Slice(mapFragment(oldSlice.content, function (node, parent) {
      if (!node.isAtom || !parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new index_es_RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(index_es_Step));

index_es_Step.jsonID("addMark", index_es_AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var index_es_RemoveMarkStep = /*@__PURE__*/(function (Step) {
  function RemoveMarkStep(from, to, mark) {
    Step.call(this);
    // :: number
    // The start of the unmarked range.
    this.from = from;
    // :: number
    // The end of the unmarked range.
    this.to = to;
    // :: Mark
    // The mark to remove.
    this.mark = mark;
  }

  if ( Step ) RemoveMarkStep.__proto__ = Step;
  RemoveMarkStep.prototype = Object.create( Step && Step.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new Slice(mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new index_es_AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(index_es_Step));

index_es_Step.jsonID("removeMark", index_es_RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
index_es_Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new index_es_RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new index_es_AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
index_es_Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof MarkType) {
      var set = node.marks, found;
      while (found = mark.isInSet(set)) {
(toRemove || (toRemove = [])).push(found);
        set = found.removeFromSet(set);
      }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new index_es_RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
index_es_Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new index_es_ReplaceStep(cur, end, Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this.step(new index_es_RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(Fragment.empty, true);
    this.replace(cur, cur, new Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = Slice.empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new index_es_ReplaceStep(from, to, slice) }
  return new index_es_Fitter($from, $to, slice).fit()
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
index_es_Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = Slice.empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
index_es_Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new Slice(Fragment.from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
index_es_Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, Slice.empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
index_es_Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
var index_es_Fitter = function Fitter($from, $to, slice) {
  this.$to = $to;
  this.$from = $from;
  this.unplaced = slice;

  this.frontier = [];
  for (var i = 0; i <= $from.depth; i++) {
    var node = $from.node(i);
    this.frontier.push({
      type: node.type,
      match: node.contentMatchAt($from.indexAfter(i))
    });
  }

  this.placed = Fragment.empty;
  for (var i$1 = $from.depth; i$1 > 0; i$1--)
    { this.placed = Fragment.from($from.node(i$1).copy(this.placed)); }
};

var dist_index_es_prototypeAccessors$1 = { depth: { configurable: true } };

dist_index_es_prototypeAccessors$1.depth.get = function () { return this.frontier.length - 1 };

index_es_Fitter.prototype.fit = function fit () {
  // As long as there's unplaced content, try to place some of it.
  // If that fails, either increase the open score of the unplaced
  // slice, or drop nodes from it, and then try again.
  while (this.unplaced.size) {
    var fit = this.findFittable();
    if (fit) { this.placeNodes(fit); }
    else { this.openMore() || this.dropNode(); }
  }
  // When there's inline content directly after the frontier _and_
  // directly after `this.$to`, we must generate a `ReplaceAround`
  // step that pulls that content into the node after the frontier.
  // That means the fitting must be done to the end of the textblock
  // node after `this.$to`, not `this.$to` itself.
  var moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
  var $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
  if (!$to) { return null }

  // If closing to `$to` succeeded, create a step
  var content = this.placed, openStart = $from.depth, openEnd = $to.depth;
  while (openStart && openEnd && content.childCount == 1) { // Normalize by dropping open parent nodes
    content = content.firstChild.content;
    openStart--; openEnd--;
  }
  var slice = new Slice(content, openStart, openEnd);
  if (moveInline > -1)
    { return new index_es_ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize) }
  if (slice.size || $from.pos != this.$to.pos) // Don't generate no-op steps
    { return new index_es_ReplaceStep($from.pos, $to.pos, slice) }
};

// Find a position on the start spine of `this.unplaced` that has
// content that can be moved somewhere on the frontier. Returns two
// depths, one for the slice and one for the frontier.
index_es_Fitter.prototype.findFittable = function findFittable () {
  // Only try wrapping nodes (pass 2) after finding a place without
  // wrapping failed.
  for (var pass = 1; pass <= 2; pass++) {
    for (var sliceDepth = this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
      var fragment = (void 0), parent = (void 0);
      if (sliceDepth) {
        parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
        fragment = parent.content;
      } else {
        fragment = this.unplaced.content;
      }
      var first = fragment.firstChild;
      for (var frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
        var ref = this.frontier[frontierDepth];
          var type = ref.type;
          var match = ref.match;
          var wrap = (void 0), inject = (void 0);
        // In pass 1, if the next node matches, or there is no next
        // node but the parents look compatible, we've found a
        // place.
        if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(Fragment.from(first), false))
                          : type.compatibleContent(parent.type)))
          { return {sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject} }
        // In pass 2, look for a set of wrapping nodes that make
        // `first` fit here.
        else if (pass == 2 && first && (wrap = match.findWrapping(first.type)))
          { return {sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, wrap: wrap} }
        // Don't continue looking further up if the parent node
        // would fit here.
        if (parent && match.matchType(parent.type)) { break }
      }
    }
  }
};

index_es_Fitter.prototype.openMore = function openMore () {
  var ref = this.unplaced;
    var content = ref.content;
    var openStart = ref.openStart;
    var openEnd = ref.openEnd;
  var inner = contentAt(content, openStart);
  if (!inner.childCount || inner.firstChild.isLeaf) { return false }
  this.unplaced = new Slice(content, openStart + 1,
                            Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
  return true
};

index_es_Fitter.prototype.dropNode = function dropNode () {
  var ref = this.unplaced;
    var content = ref.content;
    var openStart = ref.openStart;
    var openEnd = ref.openEnd;
  var inner = contentAt(content, openStart);
  if (inner.childCount <= 1 && openStart > 0) {
    var openAtEnd = content.size - openStart <= openStart + inner.size;
    this.unplaced = new Slice(dropFromFragment(content, openStart - 1, 1), openStart - 1,
                              openAtEnd ? openStart - 1 : openEnd);
  } else {
    this.unplaced = new Slice(dropFromFragment(content, openStart, 1), openStart, openEnd);
  }
};

// : ({sliceDepth: number, frontierDepth: number, parent: ?Node, wrap: ?[NodeType], inject: ?Fragment})
// Move content from the unplaced slice at `sliceDepth` to the
// frontier node at `frontierDepth`. Close that frontier node when
// applicable.
index_es_Fitter.prototype.placeNodes = function placeNodes (ref) {
    var sliceDepth = ref.sliceDepth;
    var frontierDepth = ref.frontierDepth;
    var parent = ref.parent;
    var inject = ref.inject;
    var wrap = ref.wrap;

  while (this.depth > frontierDepth) { this.closeFrontierNode(); }
  if (wrap) { for (var i = 0; i < wrap.length; i++) { this.openFrontierNode(wrap[i]); } }

  var slice = this.unplaced, fragment = parent ? parent.content : slice.content;
  var openStart = slice.openStart - sliceDepth;
  var taken = 0, add = [];
  var ref$1 = this.frontier[frontierDepth];
    var match = ref$1.match;
    var type = ref$1.type;
  if (inject) {
    for (var i$1 = 0; i$1 < inject.childCount; i$1++) { add.push(inject.child(i$1)); }
    match = match.matchFragment(inject);
  }
  // Computes the amount of (end) open nodes at the end of the
  // fragment. When 0, the parent is open, but no more. When
  // negative, nothing is open.
  var openEndCount = (fragment.size + sliceDepth) - (slice.content.size - slice.openEnd);
  // Scan over the fragment, fitting as many child nodes as
  // possible.
  while (taken < fragment.childCount) {
    var next = fragment.child(taken), matches = match.matchType(next.type);
    if (!matches) { break }
    taken++;
    if (taken > 1 || openStart == 0 || next.content.size) { // Drop empty open nodes
      match = matches;
      add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0,
                              taken == fragment.childCount ? openEndCount : -1));
    }
  }
  var toEnd = taken == fragment.childCount;
  if (!toEnd) { openEndCount = -1; }

  this.placed = addToFragment(this.placed, frontierDepth, Fragment.from(add));
  this.frontier[frontierDepth].match = match;

  // If the parent types match, and the entire node was moved, and
  // it's not open, close this frontier node right away.
  if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1)
    { this.closeFrontierNode(); }

  // Add new frontier nodes for any open nodes at the end.
  for (var i$2 = 0, cur = fragment; i$2 < openEndCount; i$2++) {
    var node = cur.lastChild;
    this.frontier.push({type: node.type, match: node.contentMatchAt(node.childCount)});
    cur = node.content;
  }

  // Update `this.unplaced`. Drop the entire node from which we
  // placed it we got to its end, otherwise just drop the placed
  // nodes.
  this.unplaced = !toEnd ? new Slice(dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd)
    : sliceDepth == 0 ? Slice.empty
    : new Slice(dropFromFragment(slice.content, sliceDepth - 1, 1),
                sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
};

index_es_Fitter.prototype.mustMoveInline = function mustMoveInline () {
  if (!this.$to.parent.isTextblock || this.$to.end() == this.$to.pos) { return -1 }
  var top = this.frontier[this.depth], level;
  if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) ||
      (this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth)) { return -1 }

  var ref = this.$to;
    var depth = ref.depth;
    var after = this.$to.after(depth);
  while (depth > 1 && after == this.$to.end(--depth)) { ++after; }
  return after
};

index_es_Fitter.prototype.findCloseLevel = function findCloseLevel ($to) {
  scan: for (var i = Math.min(this.depth, $to.depth); i >= 0; i--) {
    var ref = this.frontier[i];
      var match = ref.match;
      var type = ref.type;
    var dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
    var fit = contentAfterFits($to, i, type, match, dropInner);
    if (!fit) { continue }
    for (var d = i - 1; d >= 0; d--) {
      var ref$1 = this.frontier[d];
        var match$1 = ref$1.match;
        var type$1 = ref$1.type;
      var matches = contentAfterFits($to, d, type$1, match$1, true);
      if (!matches || matches.childCount) { continue scan }
    }
    return {depth: i, fit: fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to}
  }
};

index_es_Fitter.prototype.close = function close ($to) {
  var close = this.findCloseLevel($to);
  if (!close) { return null }

  while (this.depth > close.depth) { this.closeFrontierNode(); }
  if (close.fit.childCount) { this.placed = addToFragment(this.placed, close.depth, close.fit); }
  $to = close.move;
  for (var d = close.depth + 1; d <= $to.depth; d++) {
    var node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
    this.openFrontierNode(node.type, node.attrs, add);
  }
  return $to
};

index_es_Fitter.prototype.openFrontierNode = function openFrontierNode (type, attrs, content) {
  var top = this.frontier[this.depth];
  top.match = top.match.matchType(type);
  this.placed = addToFragment(this.placed, this.depth, Fragment.from(type.create(attrs, content)));
  this.frontier.push({type: type, match: type.contentMatch});
};

index_es_Fitter.prototype.closeFrontierNode = function closeFrontierNode () {
  var open = this.frontier.pop();
  var add = open.match.fillBefore(Fragment.empty, true);
  if (add.childCount) { this.placed = addToFragment(this.placed, this.frontier.length, add); }
};

Object.defineProperties( index_es_Fitter.prototype, dist_index_es_prototypeAccessors$1 );

function dropFromFragment(fragment, depth, count) {
  if (depth == 0) { return fragment.cutByIndex(count) }
  return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)))
}

function addToFragment(fragment, depth, content) {
  if (depth == 0) { return fragment.append(content) }
  return fragment.replaceChild(fragment.childCount - 1,
                               fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content)))
}

function contentAt(fragment, depth) {
  for (var i = 0; i < depth; i++) { fragment = fragment.firstChild.content; }
  return fragment
}

function closeNodeStart(node, openStart, openEnd) {
  if (openStart <= 0) { return node }
  var frag = node.content;
  if (openStart > 1)
    { frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0)); }
  if (openStart > 0) {
    frag = node.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0) { frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(Fragment.empty, true)); }
  }
  return node.copy(frag)
}

function contentAfterFits($to, depth, type, match, open) {
  var node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
  if (index == node.childCount && !type.compatibleContent(node.type)) { return null }
  var fit = match.fillBefore(node.content, true, index);
  return fit && !invalidMarks(type, node.content, index) ? fit : null
}

function invalidMarks(type, fragment, start) {
  for (var i = start; i < fragment.childCount; i++)
    { if (!type.allowsMarks(fragment.child(i).marks)) { return true } }
  return false
}

function definesContent(type) {
  return type.spec.defining || type.spec.definingForContent
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining as context](#model.NodeSpec.definingAsContext), or
// including an open parent node from the slice that _is_ marked as
// [defining its content](#model.NodeSpec.definingForContent).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
index_es_Transform.prototype.replaceRange = function(from, to, slice) {
  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new index_es_ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.definingAsContext || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && definesContent(leftNodes[preferredDepth - 1].type) &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 &&
           leftNodes[preferredDepth - 1].isTextblock &&
           definesContent(leftNodes[preferredDepth - 2].type) &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new Slice(closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  var startSteps = this.steps.length;
  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
    this.replace(from, to, slice);
    if (this.steps.length > startSteps) { break }
    var depth = targetDepths[i$2];
    if (depth < 0) { continue }
    from = $from.before(depth); to = $to.after(depth);
  }
  return this
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start = match.fillBefore(fragment).append(fragment);
    fragment = start.append(match.matchFragment(start).fillBefore(Fragment.empty, true));
  }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
index_es_Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new Slice(Fragment.from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
index_es_Transform.prototype.deleteRange = function(from, to) {
  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d)
      { return this.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d) ||
        (d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent &&
         d && $to.start(d - 1) == start - 1))
      { result.push(d); }
  }
  return result
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-state/dist/index.es.js



var classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var index_es_Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var prosemirror_state_dist_index_es_prototypeAccessors = { anchor: { configurable: true },head: { configurable: true },from: { configurable: true },to: { configurable: true },$from: { configurable: true },$to: { configurable: true },empty: { configurable: true } };

// :: number
// The selection's anchor, as an unresolved position.
prosemirror_state_dist_index_es_prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
prosemirror_state_dist_index_es_prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
prosemirror_state_dist_index_es_prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
prosemirror_state_dist_index_es_prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
prosemirror_state_dist_index_es_prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
prosemirror_state_dist_index_es_prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
prosemirror_state_dist_index_es_prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
index_es_Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
index_es_Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = Slice.empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? Slice.empty : content);
    if (i$1 == 0)
      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
index_es_Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
index_es_Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new index_es_TextSelection($pos)
      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
index_es_Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new index_es_AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
index_es_Selection.atStart = function atStart (doc) {
  return findSelectionIn(doc, doc, 0, 0, 1) || new index_es_AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
index_es_Selection.atEnd = function atEnd (doc) {
  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new index_es_AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
index_es_Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
index_es_Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
index_es_Selection.prototype.getBookmark = function getBookmark () {
  return index_es_TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( index_es_Selection.prototype, prosemirror_state_dist_index_es_prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
index_es_Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var index_es_TextSelection = /*@__PURE__*/(function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: { configurable: true } };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = Slice.empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == Slice.empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(index_es_Selection));

index_es_Selection.jsonID("text", index_es_TextSelection);

var TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map (mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
TextBookmark.prototype.resolve = function resolve (doc) {
  return index_es_TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var index_es_NodeSelection = /*@__PURE__*/(function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new Slice(Fragment.from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(index_es_Selection));

index_es_NodeSelection.prototype.visible = false;

index_es_Selection.jsonID("node", index_es_NodeSelection);

var NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
};
NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && index_es_NodeSelection.isSelectable(node)) { return new index_es_NodeSelection($pos) }
  return index_es_Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var index_es_AllSelection = /*@__PURE__*/(function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = Slice.empty;

    if (content == Slice.empty) {
      tr.delete(0, tr.doc.content.size);
      var sel = Selection.atStart(tr.doc);
      if (!sel.eq(tr.selection)) { tr.setSelection(sel); }
    } else {
      Selection.prototype.replace.call(this, tr, content);
    }
  };

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };

  return AllSelection;
}(index_es_Selection));

index_es_Selection.jsonID("all", index_es_AllSelection);

var AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new index_es_AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return index_es_TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && index_es_NodeSelection.isSelectable(child)) {
      return index_es_NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof index_es_ReplaceStep || step instanceof index_es_ReplaceAroundStep)) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(index_es_Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var index_es_Transaction = /*@__PURE__*/(function (Transform) {
  function Transaction(state) {
    Transform.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform ) Transaction.__proto__ = Transform;
  Transaction.prototype = Object.create( Transform && Transform.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: { configurable: true },selectionSet: { configurable: true },storedMarksSet: { configurable: true },isGeneric: { configurable: true },scrolledIntoView: { configurable: true } };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    if (selection.$from.doc != this.doc)
      { throw new RangeError("Selection passed to setSelection must point at the current document") }
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || Mark.none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      this.replaceRangeWith(from, to, schema.text(text, marks));
      if (!this.selection.empty) { this.setSelection(index_es_Selection.near(this.selection.$to)); }
      return this
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    for (var _ in this.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(index_es_Transform));

function bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
};

var baseFields = [
  new FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || index_es_Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var Configuration = function Configuration(schema, plugins) {
  var this$1 = this;

  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1.plugins.push(plugin);
    this$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var EditorState = function EditorState(config) {
  this.config = config;
};

var prosemirror_state_dist_index_es_prototypeAccessors$1 = { schema: { configurable: true },plugins: { configurable: true },tr: { configurable: true } };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
prosemirror_state_dist_index_es_prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
prosemirror_state_dist_index_es_prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → bool
EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }

  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
   for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
        var tr = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this, n: 0}); }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
EditorState.prototype.applyInner = function applyInner (tr) {
  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
prosemirror_state_dist_index_es_prototypeAccessors$1.tr.get = function () { return new index_es_Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use (only relevant if no `doc` is specified).
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
EditorState.create = function create (config) {
  var $config = new Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
  var instance = new EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   plugins:: [Plugin]
//   New set of active plugins.
EditorState.prototype.reconfigure = function reconfigure (config) {
  var $config = new Configuration(this.schema, config.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
EditorState.prototype.toJSON = function toJSON (pluginFields) {
  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new Configuration(config.schema, config.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = index_es_Node.fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = index_es_Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
//
// FIXME this is no longer needed as of prosemirror-view 1.9.0,
// though due to backwards-compat we should probably keep it around
// for a while (if only as a no-op)
EditorState.addApplyListener = function addApplyListener (f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = applyListeners.indexOf(f);
  if (found > -1) { applyListeners.splice(found, 1); }
};

Object.defineProperties( EditorState.prototype, prosemirror_state_dist_index_es_prototypeAccessors$1 );

var applyListeners = [];

// PluginSpec:: interface
//
// This is the type passed to the [`Plugin`](#state.Plugin)
// constructor. It provides a definition for a plugin.
//
//   props:: ?EditorProps
//   The [view props](#view.EditorProps) added by this plugin. Props
//   that are functions will be bound to have the plugin instance as
//   their `this` binding.
//
//   state:: ?StateField<any>
//   Allows a plugin to define a [state field](#state.StateField), an
//   extra slot in the state object in which it can keep its own data.
//
//   key:: ?PluginKey
//   Can be used to make this a keyed plugin. You can have only one
//   plugin with a given key in a given state, but it is possible to
//   access the plugin's configuration and state through the key,
//   without having access to the plugin instance object.
//
//   view:: ?(EditorView) → Object
//   When the plugin needs to interact with the editor view, or
//   set something up in the DOM, use this field. The function
//   will be called when the plugin's state is associated with an
//   editor view.
//
//     return::-
//     Should return an object with the following optional
//     properties:
//
//       update:: ?(view: EditorView, prevState: EditorState)
//       Called whenever the view's state is updated.
//
//       destroy:: ?()
//       Called when the view is destroyed or receives a state
//       with different plugins.
//
//   filterTransaction:: ?(Transaction, EditorState) → bool
//   When present, this will be called before a transaction is
//   applied by the state, allowing the plugin to cancel it (by
//   returning false).
//
//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
//   Allows the plugin to append another transaction to be applied
//   after the given array of transactions. When another plugin
//   appends a transaction after this was called, it is called again
//   with the new state and new transactions—but only the new
//   transactions, i.e. it won't be passed transactions that it
//   already saw.

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) { val = val.bind(self); }
    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
    target[prop] = val;
  }
  return target
}

// ::- Plugins bundle functionality that can be added to an editor.
// They are part of the [editor state](#state.EditorState) and
// may influence that state and the view that contains it.
var Plugin = function Plugin(spec) {
  // :: EditorProps
  // The [props](#view.EditorProps) exported by this plugin.
  this.props = {};
  if (spec.props) { bindProps(spec.props, this, this.props); }
  // :: Object
  // The plugin's [spec object](#state.PluginSpec).
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};

// :: (EditorState) → any
// Extract the plugin's state field from an editor state.
Plugin.prototype.getState = function getState (state) { return state[this.key] };

// StateField:: interface<T>
// A plugin spec may provide a state field (under its
// [`state`](#state.PluginSpec.state) property) of this type, which
// describes the state it wants to keep. Functions provided here are
// always called with the plugin instance as their `this` binding.
//
//   init:: (config: Object, instance: EditorState) → T
//   Initialize the value of the field. `config` will be the object
//   passed to [`EditorState.create`](#state.EditorState^create). Note
//   that `instance` is a half-initialized state instance, and will
//   not have values for plugin fields initialized after this one.
//
//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
//   Apply the given transaction to this state field, producing a new
//   field value. Note that the `newState` argument is again a partially
//   constructed state does not yet contain the state from plugins
//   coming after this one.
//
//   toJSON:: ?(value: T) → *
//   Convert this field to JSON. Optional, can be left off to disable
//   JSON serialization for the field.
//
//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
//   Deserialize the JSON representation of this field. Note that the
//   `state` argument is again a half-initialized state.

var index_es_keys = Object.create(null);

function createKey(name) {
  if (name in index_es_keys) { return name + "$" + ++index_es_keys[name] }
  index_es_keys[name] = 0;
  return name + "$"
}

// ::- A key is used to [tag](#state.PluginSpec.key)
// plugins in a way that makes it possible to find them, given an
// editor state. Assigning a key does mean only one plugin of that
// type can be active in a state.
var PluginKey = function PluginKey(name) {
if ( name === void 0 ) name = "key";
 this.key = createKey(name); };

// :: (EditorState) → ?Plugin
// Get the active plugin with this key, if any, from an editor
// state.
PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };

// :: (EditorState) → ?any
// Get the plugin's state from an editor state.
PluginKey.prototype.getState = function getState (state) { return state[this.key] };


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-commands/dist/index.es.js




// :: (EditorState, ?(tr: Transaction)) → bool
// Delete the selection, if there is one.
function deleteSelection(state, dispatch) {
  if (state.selection.empty) { return false }
  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and at the start of a textblock, try to
// reduce the distance between that block and the one before it—if
// there's a block directly before it that can be joined, join them.
// If not, try to move the selected block closer to the next one in
// the document structure by lifting it out of its parent or moving it
// into a parent of the previous block. Will use the view for accurate
// (bidi-aware) start-of-textblock detection if given.
function joinBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor);

  // If there is no node before this, try to lift
  if (!$cut) {
    var range = $cursor.blockRange(), target = range && liftTarget(range);
    if (target == null) { return false }
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  var before = $cut.nodeBefore;
  // Apply the joining algorithm
  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
    { return true }

  // If the node below has no content and the node above is
  // selectable, delete the node below and select the one above.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(before, "end") || index_es_NodeSelection.isSelectable(before))) {
    var delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch) {
        var tr = state.tr.step(delStep);
        tr.setSelection(textblockAt(before, "end") ? index_es_Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                        : index_es_NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
        dispatch(tr.scrollIntoView());
      }
      return true
    }
  }

  // If the node before is an atom, delete it
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
    return true
  }

  return false
}

function textblockAt(node, side, only) {
  for (; node; node = (side == "start" ? node.firstChild : node.lastChild)) {
    if (node.isTextblock) { return true }
    if (only && node.childCount != 1) { return false }
  }
  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the start of a textblock, select
// the node before that textblock, if possible. This is intended to be
// bound to keys like backspace, after
// [`joinBackward`](#commands.joinBackward) or other deleting
// commands, as a fall-back behavior when the schema doesn't allow
// deletion at the selected point.
function selectNodeBackward(state, dispatch, view) {
  var ref = state.selection;
  var $head = ref.$head;
  var empty = ref.empty;
  var $cut = $head;
  if (!empty) { return false }

  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) { return false }
    $cut = findCutBefore($head);
  }
  var node = $cut && $cut.nodeBefore;
  if (!node || !index_es_NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(index_es_NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
  return true
}

function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
    if ($pos.node(i).type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and the cursor is at the end of a
// textblock, try to reduce or remove the boundary between that block
// and the one after it, either by joining them or by moving the other
// block closer to this one in the tree structure. Will use the view
// for accurate start-of-textblock detection if given.
function joinForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor);

  // If there is no node after this, there's nothing to do
  if (!$cut) { return false }

  var after = $cut.nodeAfter;
  // Try the joining algorithm
  if (deleteBarrier(state, $cut, dispatch)) { return true }

  // If the node above has no content and the node below is
  // selectable, delete the node above and select the one below.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(after, "start") || index_es_NodeSelection.isSelectable(after))) {
    var delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch) {
        var tr = state.tr.step(delStep);
        tr.setSelection(textblockAt(after, "start") ? index_es_Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                        : index_es_NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
        dispatch(tr.scrollIntoView());
      }
      return true
    }
  }

  // If the next node is an atom, delete it
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
    return true
  }

  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the end of a textblock, select
// the node coming after that textblock, if possible. This is intended
// to be bound to keys like delete, after
// [`joinForward`](#commands.joinForward) and similar deleting
// commands, to provide a fall-back behavior when the schema doesn't
// allow deletion at the selected point.
function selectNodeForward(state, dispatch, view) {
  var ref = state.selection;
  var $head = ref.$head;
  var empty = ref.empty;
  var $cut = $head;
  if (!empty) { return false }
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size)
      { return false }
    $cut = findCutAfter($head);
  }
  var node = $cut && $cut.nodeAfter;
  if (!node || !index_es_NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(index_es_NodeSelection.create(state.doc, $cut.pos)).scrollIntoView()); }
  return true
}

function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
    if (parent.type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block or, if there is a text selection, the
// closest ancestor block of the selection that can be joined, with
// the sibling above it.
function joinUp(state, dispatch) {
  var sel = state.selection, nodeSel = sel instanceof index_es_NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.from)) { return false }
    point = sel.from;
  } else {
    point = joinPoint(state.doc, sel.from, -1);
    if (point == null) { return false }
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) { tr.setSelection(index_es_NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block, or the closest ancestor of the selection
// that can be joined, with the sibling after it.
function joinDown(state, dispatch) {
  var sel = state.selection, point;
  if (sel instanceof index_es_NodeSelection) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.to)) { return false }
    point = sel.to;
  } else {
    point = joinPoint(state.doc, sel.to, 1);
    if (point == null) { return false }
  }
  if (dispatch)
    { dispatch(state.tr.join(point).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Lift the selected block, or the closest ancestor block of the
// selection that can be lifted, out of its parent node.
function lift(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  var range = $from.blockRange($to), target = range && liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the selection is in a node whose type has a truthy
// [`code`](#model.NodeSpec.code) property in its spec, replace the
// selection with a newline character.
function newlineInCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
  return true
}

function defaultBlockAt(match) {
  for (var i = 0; i < match.edgeCount; i++) {
    var ref = match.edge(i);
    var type = ref.type;
    if (type.isTextblock && !type.hasRequiredAttrs()) { return type }
  }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// When the selection is in a node with a truthy
// [`code`](#model.NodeSpec.code) property in its spec, create a
// default block after the code block, and move the cursor there.
function exitCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  var above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after));
  if (!above.canReplaceWith(after, after, type)) { return false }
  if (dispatch) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(index_es_Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.
function createParagraphNear(state, dispatch) {
  var sel = state.selection;
  var $from = sel.$from;
  var $to = sel.$to;
  if (sel instanceof index_es_AllSelection || $from.parent.inlineContent || $to.parent.inlineContent) { return false }
  var type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
  if (!type || !type.isTextblock) { return false }
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(index_es_TextSelection.create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the cursor is in an empty textblock that can be lifted, lift the
// block.
function liftEmptyBlock(state, dispatch) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || $cursor.parent.content.size) { return false }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (canSplit(state.doc, before)) {
      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
      return true
    }
  }
  var range = $cursor.blockRange(), target = range && liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
function splitBlock(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if (state.selection instanceof index_es_NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) { return false }
    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
    return true
  }

  if (!$from.parent.isBlock) { return false }

  if (dispatch) {
    var atEnd = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof index_es_TextSelection || state.selection instanceof index_es_AllSelection) { tr.deleteSelection(); }
    var deflt = $from.depth == 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    var types = atEnd && deflt ? [{type: deflt}] : null;
    var can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
      types = [{type: deflt}];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt) {
        var first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
        if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt))
          { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
      }
    }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.
function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (function (tr) {
    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) { tr.ensureMarks(marks); }
    dispatch(tr);
  }))
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Move the selection to the node wrapping the current selection, if
// any. (Will not select the document node.)
function selectParentNode(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var to = ref.to;
  var pos;
  var same = $from.sharedDepth(to);
  if (same == 0) { return false }
  pos = $from.before(same);
  if (dispatch) { dispatch(state.tr.setSelection(index_es_NodeSelection.create(state.doc, pos))); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Select the whole document.
function selectAll(state, dispatch) {
  if (dispatch) { dispatch(state.tr.setSelection(new index_es_AllSelection(state.doc))); }
  return true
}

function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
    return true
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || canJoin(state.doc, $pos.pos)))
    { return false }
  if (dispatch)
    { dispatch(state.tr
             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
             .join($pos.pos)
             .scrollIntoView()); }
  return true
}

function deleteBarrier(state, $cut, dispatch) {
  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
  if (joinMaybeClear(state, $cut, dispatch)) { return true }

  var canDelAfter = $cut.parent.canReplace($cut.index(), $cut.index() + 1);
  if (canDelAfter &&
      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
      match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize, wrap = Fragment.empty;
      for (var i = conn.length - 1; i >= 0; i--)
        { wrap = Fragment.from(conn[i].create(null, wrap)); }
      wrap = Fragment.from(before.copy(wrap));
      var tr = state.tr.step(new index_es_ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new Slice(wrap, 1, 0), conn.length, true));
      var joinAt = end + 2 * conn.length;
      if (canJoin(tr.doc, joinAt)) { tr.join(joinAt); }
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  var selAfter = index_es_Selection.findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
    var at = before, wrap$1 = [];
    for (;;) {
      wrap$1.push(at);
      if (at.isTextblock) { break }
      at = at.lastChild;
    }
    var afterText = after, afterDepth = 1;
    for (; !afterText.isTextblock; afterText = afterText.firstChild) { afterDepth++; }
    if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
      if (dispatch) {
        var end$1 = Fragment.empty;
        for (var i$1 = wrap$1.length - 1; i$1 >= 0; i$1--) { end$1 = Fragment.from(wrap$1[i$1].copy(end$1)); }
        var tr$1 = state.tr.step(new index_es_ReplaceAroundStep($cut.pos - wrap$1.length, $cut.pos + after.nodeSize,
                                                     $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth,
                                                     new Slice(end$1, wrap$1.length, 0), 0, true));
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
  }

  return false
}

function selectTextblockSide(side) {
  return function(state, dispatch) {
    var sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
    var depth = $pos.depth;
    while ($pos.node(depth).isInline) {
      if (!depth) { return false }
      depth--;
    }
    if (!$pos.node(depth).isTextblock) { return false }
    if (dispatch)
      { dispatch(state.tr.setSelection(index_es_TextSelection.create(
        state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth)))); }
    return true
  }
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Moves the cursor to the start of current text block.
var selectTextblockStart = selectTextblockSide(-1);

// :: (EditorState, ?(tr: Transaction)) → bool
// Moves the cursor to the end of current text block.
var selectTextblockEnd = selectTextblockSide(1);

// Parameterized commands

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Wrap the selection in a node of the given type with the given
// attributes.
function wrapIn(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), wrapping = range && findWrapping(range, nodeType, attrs);
    if (!wrapping) { return false }
    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
    return true
  }
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that tries to set the selected textblocks to the
// given node type with the given attributes.
function setBlockType(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var from = ref.from;
    var to = ref.to;
    var applicable = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (applicable) { return false }
      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
      if (node.type == nodeType) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index = $pos.index();
        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
      }
    });
    if (!applicable) { return false }
    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
    return true
  }
}

function markApplies(doc, ranges, type) {
  var loop = function ( i ) {
    var ref = ranges[i];
    var $from = ref.$from;
    var $to = ref.$to;
    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) { return false }
      can = node.inlineContent && node.type.allowsMarkType(type);
    });
    if (can) { return { v: true } }
  };

  for (var i = 0; i < ranges.length; i++) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command function that toggles the given mark with the
// given attributes. Will return `false` when the current selection
// doesn't support that mark. This will remove the mark if any marks
// of that type exist in the selection, or add it otherwise. If the
// selection is empty, this applies to the [stored
// marks](#state.EditorState.storedMarks) instead of a range of the
// document.
function toggleMark(markType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var empty = ref.empty;
    var $cursor = ref.$cursor;
    var ranges = ref.ranges;
    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks()))
          { dispatch(state.tr.removeStoredMark(markType)); }
        else
          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
      } else {
        var has = false, tr = state.tr;
        for (var i = 0; !has && i < ranges.length; i++) {
          var ref$1 = ranges[i];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has) {
            tr.removeMark($from$1.pos, $to$1.pos, markType);
          } else {
            var from = $from$1.pos, to = $to$1.pos, start = $from$1.nodeAfter, end = $to$1.nodeBefore;
            var spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
            var spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
            if (from + spaceStart < to) { from += spaceStart; to -= spaceEnd; }
            tr.addMark(from, to, markType.create(attrs));
          }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true
  }
}

function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) { return dispatch(tr) }

    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++)
        { ranges[j] = map.map(ranges[j]); }
      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
    }

    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    var joinable = [];
    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
      var from = ranges[i$1], to = ranges[i$1 + 1];
      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) { break }
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after))
            { joinable.push(pos); }
        }
        pos += after.nodeSize;
      }
    }
    // Join the joinable points
    joinable.sort(function (a, b) { return a - b; });
    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
      if (canJoin(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
    }
    dispatch(tr);
  }
}

// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
// Wrap a command so that, when it produces a transform that causes
// two joinable nodes to end up next to each other, those are joined.
// Nodes are considered joinable when they are of the same type and
// when the `isJoinable` predicate returns true for them or, if an
// array of strings was passed, if their node type name is in that
// array.
function autoJoin(command, isJoinable) {
  if (Array.isArray(isJoinable)) {
    var types = isJoinable;
    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
  }
  return function (state, dispatch, view) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable), view); }
}

// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
// Combine a number of command functions into a single function (which
// calls them one by one until one returns true).
function chainCommands() {
  var commands = [], len = arguments.length;
  while ( len-- ) commands[ len ] = arguments[ len ];

  return function(state, dispatch, view) {
    for (var i = 0; i < commands.length; i++)
      { if (commands[i](state, dispatch, view)) { return true } }
    return false
  }
}

var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);

// :: Object
// A basic keymap containing bindings not specific to any schema.
// Binds the following keys (when multiple commands are listed, they
// are chained with [`chainCommands`](#commands.chainCommands)):
//
// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
// * **Mod-Enter** to `exitCode`
// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-a** to `selectAll`
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Shift-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};

// :: Object
// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
// Ctrl-Delete.
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"],
  "Ctrl-a": selectTextblockStart,
  "Ctrl-e": selectTextblockEnd
};
for (var index_es_key in pcBaseKeymap) { macBaseKeymap[index_es_key] = pcBaseKeymap[index_es_key]; }

// declare global: os, navigator
var mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform)
          : typeof os != "undefined" ? os.platform() == "darwin" : false;

// :: Object
// Depending on the detected platform, this will hold
// [`pcBasekeymap`](#commands.pcBaseKeymap) or
// [`macBaseKeymap`](#commands.macBaseKeymap).
var index_es_baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-schema-list/dist/index.es.js



var olDOM = ["ol", 0], ulDOM = ["ul", 0], liDOM = ["li", 0];

// :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.
var orderedList = {
  attrs: {order: {default: 1}},
  parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
    return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1}
  }}],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {start: node.attrs.order}, 0]
  }
};

// :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.
var bulletList = {
  parseDOM: [{tag: "ul"}],
  toDOM: function toDOM() { return ulDOM }
};

// :: NodeSpec
// A list item (`<li>`) spec.
var listItem = {
  parseDOM: [{tag: "li"}],
  toDOM: function toDOM() { return liDOM },
  defining: true
};

function index_es_add(obj, props) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  for (var prop$1 in props) { copy[prop$1] = props[prop$1]; }
  return copy
}

// :: (OrderedMap<NodeSpec>, string, ?string) → OrderedMap<NodeSpec>
// Convenience function for adding list-related node types to a map
// specifying the nodes for a schema. Adds
// [`orderedList`](#schema-list.orderedList) as `"ordered_list"`,
// [`bulletList`](#schema-list.bulletList) as `"bullet_list"`, and
// [`listItem`](#schema-list.listItem) as `"list_item"`.
//
// `itemContent` determines the content expression for the list items.
// If you want the commands defined in this module to apply to your
// list structure, it should have a shape like `"paragraph block*"` or
// `"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
// given to assign a group name to the list node types, for example
// `"block"`.
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: index_es_add(orderedList, {content: "list_item+", group: listGroup}),
    bullet_list: index_es_add(bulletList, {content: "list_item+", group: listGroup}),
    list_item: index_es_add(listItem, {content: itemContent})
  })
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), doJoin = false, outerRange = range;
    if (!range) { return false }
    // This is at the top of an existing list item
    if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
      // Don't do anything if this is the top of the list
      if ($from.index(range.depth - 1) == 0) { return false }
      var $insert = state.doc.resolve(range.start - 2);
      outerRange = new NodeRange($insert, $insert, range.depth);
      if (range.endIndex < range.parent.childCount)
        { range = new NodeRange($from, state.doc.resolve($to.end(range.depth)), range.depth); }
      doJoin = true;
    }
    var wrap = findWrapping(outerRange, listType, attrs, range);
    if (!wrap) { return false }
    if (dispatch) { dispatch(doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView()); }
    return true
  }
}

function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  tr.step(new index_es_ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end,
                                new Slice(content, 0, 0), wrappers.length, true));

  var found = 0;
  for (var i$1 = 0; i$1 < wrappers.length; i$1++) { if (wrappers[i$1].type == listType) { found = i$1 + 1; } }
  var splitDepth = wrappers.length - found;

  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (var i$2 = range.startIndex, e = range.endIndex, first = true; i$2 < e; i$2++, first = false) {
    if (!first && canSplit(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i$2).nodeSize;
  }
  return tr
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Build a command that splits a non-empty textblock at the top level
// of a list item by also splitting that list item.
function splitListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var node = ref.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) { return false }
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) { return false }
    if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType ||
          $from.index(-2) != $from.node(-2).childCount - 1) { return false }
      if (dispatch) {
        var wrap = Fragment.empty;
        var depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
        // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor
        for (var d = $from.depth - depthBefore; d >= $from.depth - 3; d--)
          { wrap = Fragment.from($from.node(d).copy(wrap)); }
        var depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1
            : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
        // Add a second list item with an empty default start node
        wrap = wrap.append(Fragment.from(itemType.createAndFill()));
        var start = $from.before($from.depth - (depthBefore - 1));
        var tr$1 = state.tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
        var sel = -1;
        tr$1.doc.nodesBetween(start, tr$1.doc.content.size, function (node, pos) {
          if (sel > -1) { return false }
          if (node.isTextblock && node.content.size == 0) { sel = pos + 1; }
        });
        if (sel > -1) { tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve(sel))); }
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
    var nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    var types = nextType && [null, {type: nextType}];
    if (!canSplit(tr.doc, $from.pos, 2, types)) { return false }
    if (dispatch) { dispatch(tr.split($from.pos, 2, types).scrollIntoView()); }
    return true
  }
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    if (!dispatch) { return true }
    if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
      { return liftToOuterList(state, dispatch, itemType, range) }
    else // Outer list node
      { return liftOutOfList(state, dispatch, range) }
  }
}

function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    // There are siblings after the lifted items, which must become
    // children of the last item
    tr.step(new index_es_ReplaceAroundStep(end - 1, endOfList, end, endOfList,
                                  new Slice(Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  dispatch(tr.lift(range, liftTarget(range)).scrollIntoView());
  return true
}

function liftOutOfList(state, dispatch, range) {
  var tr = state.tr, list = range.parent;
  // Merge the list items into a single big item
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
  if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) { return false }
  var atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1,
                         item.content.append(atEnd ? Fragment.empty : Fragment.from(list))))
    { return false }
  var start = $start.pos, end = start + item.nodeSize;
  // Strip off the surrounding list. At the sides where we're not at
  // the end of the list, the existing list is closed. At sides where
  // this is the end, it is overwritten to its end.
  tr.step(new index_es_ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1,
                                new Slice((atStart ? Fragment.empty : Fragment.from(list.copy(Fragment.empty)))
                                          .append(atEnd ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))),
                                          atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to sink the list item around the selection down
// into an inner list.
function sinkListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    var startIndex = range.startIndex;
    if (startIndex == 0) { return false }
    var parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) { return false }

    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = Fragment.from(nestedBefore ? itemType.create() : null);
      var slice = new Slice(Fragment.from(itemType.create(null, Fragment.from(parent.type.create(null, inner)))),
                            nestedBefore ? 3 : 1, 0);
      var before = range.start, after = range.end;
      dispatch(state.tr.step(new index_es_ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after,
                                                   before, after, slice, 1, true))
               .scrollIntoView());
    }
    return true
  }
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-view/dist/index.es.js




var index_es_result = {};

if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

  var ie = index_es_result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  index_es_result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  index_es_result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
  index_es_result.gecko_version = index_es_result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
  index_es_result.chrome = !!chrome;
  index_es_result.chrome_version = chrome && +chrome[1];
  // Is true for both iOS and iPadOS for convenience
  index_es_result.safari = !ie && /Apple Computer/.test(navigator.vendor);
  index_es_result.ios = index_es_result.safari && (/Mobile\/\w+/.test(navigator.userAgent) || navigator.maxTouchPoints > 2);
  index_es_result.mac = index_es_result.ios || /Mac/.test(navigator.platform);
  index_es_result.android = /Android \d/.test(navigator.userAgent);
  index_es_result.webkit = "webkitFontSmoothing" in document.documentElement.style;
  index_es_result.webkit_version = index_es_result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}

var domIndex = function(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) { return index }
  }
};

var parentNode = function(node) {
  var parent = node.assignedSlot || node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent
};

var reusedRange = null;

// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
var textRange = function(node, from, to) {
  var range = reusedRange || (reusedRange = document.createRange());
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range
};

// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
                        scanFor(node, off, targetNode, targetOff, 1))
};

var atomElements = /^(img|br|input|textarea|hr)$/i;

function scanFor(node, off, targetNode, targetOff, dir) {
  for (;;) {
    if (node == targetNode && off == targetOff) { return true }
    if (off == (dir < 0 ? 0 : nodeSize(node))) {
      var parent = node.parentNode;
      if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) ||
          node.contentEditable == "false")
        { return false }
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      if (node.contentEditable == "false") { return false }
      off = dir < 0 ? nodeSize(node) : 0;
    } else {
      return false
    }
  }
}

function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isOnEdge(node, offset, parent) {
  for (var atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
    if (node == parent) { return true }
    var index = domIndex(node);
    node = node.parentNode;
    if (!node) { return false }
    atStart = atStart && index == 0;
    atEnd = atEnd && index == nodeSize(node);
  }
}

function hasBlockDesc(dom) {
  var desc;
  for (var cur = dom; cur; cur = cur.parentNode) { if (desc = cur.pmViewDesc) { break } }
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom)
}

// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && index_es_result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
    { collapsed = false; }
  return collapsed
};

function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event
}

function windowRect(doc) {
  return {left: 0, right: doc.documentElement.clientWidth,
          top: 0, bottom: doc.documentElement.clientHeight}
}

function getSide(value, side) {
  return typeof value == "number" ? value : value[side]
}

function index_es_clientRect(node) {
  var rect = node.getBoundingClientRect();
  // Adjust for elements with style "transform: scale()"
  var scaleX = (rect.width / node.offsetWidth) || 1;
  var scaleY = (rect.height / node.offsetHeight) || 1;
  // Make sure scrollbar width isn't included in the rectangle
  return {left: rect.left, right: rect.left + node.clientWidth * scaleX,
          top: rect.top, bottom: rect.top + node.clientHeight * scaleY}
}

function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  var doc = view.dom.ownerDocument;
  for (var parent = startDOM || view.dom;; parent = parentNode(parent)) {
    if (!parent) { break }
    if (parent.nodeType != 1) { continue }
    var atTop = parent == doc.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(doc) : index_es_clientRect(parent);
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      { moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top")); }
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      { moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom"); }
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      { moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left")); }
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      { moveX = rect.right - bounding.right + getSide(scrollMargin, "right"); }
    if (moveX || moveY) {
      if (atTop) {
        doc.defaultView.scrollBy(moveX, moveY);
      } else {
        var startX = parent.scrollLeft, startY = parent.scrollTop;
        if (moveY) { parent.scrollTop += moveY; }
        if (moveX) { parent.scrollLeft += moveX; }
        var dX = parent.scrollLeft - startX, dY = parent.scrollTop - startY;
        rect = {left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY};
      }
    }
    if (atTop) { break }
  }
}

// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
       y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (dom == view.dom || !view.dom.contains(dom)) { continue }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break
    }
  }
  return {refDOM: refDOM, refTop: refTop, stack: scrollStack(view.dom)}
}

function scrollStack(dom) {
  var stack = [], doc = dom.ownerDocument;
  for (; dom; dom = parentNode(dom)) {
    stack.push({dom: dom, top: dom.scrollTop, left: dom.scrollLeft});
    if (dom == doc) { break }
  }
  return stack
}

// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos(ref) {
  var refDOM = ref.refDOM;
  var refTop = ref.refTop;
  var stack = ref.stack;

  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}

function restoreScrollStack(stack, dTop) {
  for (var i = 0; i < stack.length; i++) {
    var ref = stack[i];
    var dom = ref.dom;
    var top = ref.top;
    var left = ref.left;
    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
  }
}

var preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
  if (dom.setActive) { return dom.setActive() } // in IE
  if (preventScrollSupported) { return dom.focus(preventScrollSupported) }

  var stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = {preventScroll: true};
      return true
    }
  } : undefined);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}

function findOffsetInNode(node, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = (void 0);
    if (child.nodeType == 1) { rects = child.getClientRects(); }
    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
    else { continue }

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left
            : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
          if (child.nodeType == 1 && dx)
            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
          continue
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                       coords.left >= rect.left && coords.top >= rect.bottom))
        { offset = childIndex + 1; }
    }
  }
  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
  return findOffsetInNode(closest, coordsClosest)
}

function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) { continue }
    if (inRect(coords, rect))
      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
  }
  return {node: node, offset: 0}
}

function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1&&
    coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1
}

function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    { return parent }
  return dom
}

function posFromElement(view, elt, coords) {
  var ref = findOffsetInNode(elt, coords);
  var node = ref.node;
  var offset = ref.offset;
  var bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias)
}

function posFromCaret(view, node, offset, coords) {
  // Browser (in caretPosition/RangeFromPoint) will agressively
  // normalize towards nearby inline nodes. Since we are interested in
  // positions between block nodes too, we first walk up the hierarchy
  // of nodes to see if there are block nodes that the coordinates
  // fall outside of. If so, we take the position before/after that
  // block. If not, we call `posFromDOM` on the raw node/offset.
  var outside = -1;
  for (var cur = node;;) {
    if (cur == view.dom) { break }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) { return null }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
      else { break }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
}

function elementFromPoint(element, coords, box) {
  var len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (var startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
      var child = element.childNodes[i];
      if (child.nodeType == 1) {
        var rects = child.getClientRects();
        for (var j = 0; j < rects.length; j++) {
          var rect = rects[j];
          if (inRect(coords, rect)) { return elementFromPoint(child, coords, rect) }
        }
      }
      if ((i = (i + 1) % len) == startI) { break }
    }
  }
  return element
}

// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
  var assign, assign$1;

  var doc = view.dom.ownerDocument, node, offset;
  if (doc.caretPositionFromPoint) {
    try { // Firefox throws for this call in hard-to-predict circumstances (#994)
      var pos$1 = doc.caretPositionFromPoint(coords.left, coords.top);
      if (pos$1) { ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
    } catch (_) {}
  }
  if (!node && doc.caretRangeFromPoint) {
    var range = doc.caretRangeFromPoint(coords.left, coords.top);
    if (range) { ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
  }

  var elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top + 1), pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    var box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box)) { return null }
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt) { return null }
  }
  // Safari's caretRangeFromPoint returns nonsense when on a draggable element
  if (index_es_result.safari) {
    for (var p = elt; node && p; p = parentNode(p))
      { if (p.draggable) { node = offset = null; } }
  }
  elt = targetKludge(elt, coords);
  if (node) {
    if (index_es_result.gecko && node.nodeType == 1) {
      // Firefox will sometimes return offsets into <input> nodes, which
      // have no actual children, from caretPositionFromPoint (#953)
      offset = Math.min(offset, node.childNodes.length);
      // It'll also move the returned position before image nodes,
      // even if those are behind it.
      if (offset < node.childNodes.length) {
        var next = node.childNodes[offset], box$1;
        if (next.nodeName == "IMG" && (box$1 = next.getBoundingClientRect()).right <= coords.left &&
            box$1.bottom > coords.top)
          { offset++; }
      }
    }
    // Suspiciously specific kludge to work around caret*FromPoint
    // never returning a position at the end of the document
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
        coords.top > node.lastChild.getBoundingClientRect().bottom)
      { pos = view.state.doc.content.size; }
    // Ignore positions directly after a BR, since caret*FromPoint
    // 'round up' positions that would be more accurately placed
    // before the BR node.
    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
      { pos = posFromCaret(view, node, offset, coords); }
  }
  if (pos == null) { pos = posFromElement(view, elt, coords); }

  var desc = view.docView.nearestDesc(elt, true);
  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
}

var BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;

// : (EditorView, number, number) → {left: number, top: number, right: number, bottom: number}
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos, side) {
  var ref = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
  var node = ref.node;
  var offset = ref.offset;

  var supportEmptyRange = index_es_result.webkit || index_es_result.gecko;
  if (node.nodeType == 3) {
    // These browsers support querying empty text ranges. Prefer that in
    // bidi context or when at the end of a node.
    if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
      var rect = singleRect(textRange(node, offset, offset), side);
      // Firefox returns bad results (the position before the space)
      // when querying a position directly after line-broken
      // whitespace. Detect this situation and and kludge around it
      if (index_es_result.gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
        var rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
        if (rectBefore.top == rect.top) {
          var rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
          if (rectAfter.top != rect.top)
            { return flattenV(rectAfter, rectAfter.left < rectBefore.left) }
        }
      }
      return rect
    } else {
      var from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
      if (side < 0 && !offset) { to++; takeSide = -1; }
      else if (side >= 0 && offset == node.nodeValue.length) { from--; takeSide = 1; }
      else if (side < 0) { from--; }
      else { to ++; }
      return flattenV(singleRect(textRange(node, from, to), takeSide), takeSide < 0)
    }
  }

  // Return a horizontal line in block context
  if (!view.state.doc.resolve(pos).parent.inlineContent) {
    if (offset && (side < 0 || offset == nodeSize(node))) {
      var before = node.childNodes[offset - 1];
      if (before.nodeType == 1) { return flattenH(before.getBoundingClientRect(), false) }
    }
    if (offset < nodeSize(node)) {
      var after = node.childNodes[offset];
      if (after.nodeType == 1) { return flattenH(after.getBoundingClientRect(), true) }
    }
    return flattenH(node.getBoundingClientRect(), side >= 0)
  }

  // Inline, not in text node (this is not Bidi-safe)
  if (offset && (side < 0 || offset == nodeSize(node))) {
    var before$1 = node.childNodes[offset - 1];
    var target = before$1.nodeType == 3 ? textRange(before$1, nodeSize(before$1) - (supportEmptyRange ? 0 : 1))
        // BR nodes tend to only return the rectangle before them.
        // Only use them if they are the last element in their parent
        : before$1.nodeType == 1 && (before$1.nodeName != "BR" || !before$1.nextSibling) ? before$1 : null;
    if (target) { return flattenV(singleRect(target, 1), false) }
  }
  if (offset < nodeSize(node)) {
    var after$1 = node.childNodes[offset];
    while (after$1.pmViewDesc && after$1.pmViewDesc.ignoreForCoords) { after$1 = after$1.nextSibling; }
    var target$1 = !after$1 ? null : after$1.nodeType == 3 ? textRange(after$1, 0, (supportEmptyRange ? 0 : 1))
        : after$1.nodeType == 1 ? after$1 : null;
    if (target$1) { return flattenV(singleRect(target$1, -1), true) }
  }
  // All else failed, just try to get a rectangle for the target node
  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0)
}

function flattenV(rect, left) {
  if (rect.width == 0) { return rect }
  var x = left ? rect.left : rect.right;
  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
}

function flattenH(rect, top) {
  if (rect.height == 0) { return rect }
  var y = top ? rect.top : rect.bottom;
  return {top: y, bottom: y, left: rect.left, right: rect.right}
}

function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state) { view.updateState(state); }
  if (active != view.dom) { view.focus(); }
  try {
    return f()
  } finally {
    if (viewState != state) { view.updateState(viewState); }
    if (active != view.dom && active) { active.focus(); }
  }
}

// : (EditorView, number, number)
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$from : sel.$to;
  return withFlushedState(view, state, function () {
    var ref = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
    var dom = ref.node;
    for (;;) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest) { break }
      if (nearest.node.isBlock) { dom = nearest.dom; break }
      dom = nearest.dom.parentNode;
    }
    var coords = coordsAtPos(view, $pos.pos, 1);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = (void 0);
      if (child.nodeType == 1) { boxes = child.getClientRects(); }
      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
      else { continue }
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top + 1 &&
            (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2
             : box.bottom - coords.bottom > (coords.bottom - box.top) * 2))
          { return false }
      }
    }
    return true
  })
}

var maybeRTL = /[\u0590-\u08ac]/;

function endOfTextblockHorizontal(view, state, dir) {
  var ref = state.selection;
  var $head = ref.$head;
  if (!$head.parent.isTextblock) { return false }
  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
  var sel = view.root.getSelection();
  // If the textblock is all LTR, or the browser doesn't support
  // Selection.modify (Edge), fall back to a primitive approach
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    { return dir == "left" || dir == "backward" ? atStart : atEnd }

  return withFlushedState(view, state, function () {
    // This is a huge hack, but appears to be the best we can
    // currently do: use `Selection.modify` to move the selection by
    // one character, and see if that moves the cursor out of the
    // textblock (or doesn't move it at all, when at the start/end of
    // the document).
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    var oldBidiLevel = sel.caretBidiLevel; // Only for Firefox
    sel.modify("move", dir, "character");
    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    var result = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
    // Restore the previous selection
    sel.removeAllRanges();
    sel.addRange(oldRange);
    if (oldBidiLevel != null) { sel.caretBidiLevel = oldBidiLevel; }
    return result
  })
}

var cachedState = null, cachedDir = null, cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) { return cachedResult }
  cachedState = state; cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down"
    ? endOfTextblockVertical(view, state, dir)
    : endOfTextblockHorizontal(view, state, dir)
}

// NodeView:: interface
//
// By default, document nodes are rendered using the result of the
// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
// entirely by the editor. For some use cases, such as embedded
// node-specific editing interfaces, you want more control over
// the behavior of a node's in-editor representation, and need to
// [define](#view.EditorProps.nodeViews) a custom node view.
//
// Mark views only support `dom` and `contentDOM`, and don't support
// any of the node view methods.
//
// Objects returned as node views must conform to this interface.
//
//   dom:: ?dom.Node
//   The outer DOM node that represents the document node. When not
//   given, the default strategy is used to create a DOM node.
//
//   contentDOM:: ?dom.Node
//   The DOM node that should hold the node's content. Only meaningful
//   if the node view also defines a `dom` property and if its node
//   type is not a leaf node type. When this is present, ProseMirror
//   will take care of rendering the node's children into it. When it
//   is not present, the node view itself is responsible for rendering
//   (or deciding not to render) its child nodes.
//
//   update:: ?(node: Node, decorations: [Decoration], innerDecorations: DecorationSource) → bool
//   When given, this will be called when the view is updating itself.
//   It will be given a node (possibly of a different type), an array
//   of active decorations around the node (which are automatically
//   drawn, and the node view may ignore if it isn't interested in
//   them), and a [decoration source](#view.DecorationSource) that
//   represents any decorations that apply to the content of the node
//   (which again may be ignored). It should return true if it was
//   able to update to that node, and false otherwise. If the node
//   view has a `contentDOM` property (or no `dom` property), updating
//   its child nodes will be handled by ProseMirror.
//
//   selectNode:: ?()
//   Can be used to override the way the node's selected status (as a
//   node selection) is displayed.
//
//   deselectNode:: ?()
//   When defining a `selectNode` method, you should also provide a
//   `deselectNode` method to remove the effect again.
//
//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
//   This will be called to handle setting the selection inside the
//   node. The `anchor` and `head` positions are relative to the start
//   of the node. By default, a DOM selection will be created between
//   the DOM positions corresponding to those positions, but if you
//   override it you can do something else.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to prevent the editor view from trying to handle some
//   or all DOM events that bubble up from the node view. Events for
//   which this returns true are not handled by the editor.
//
//   ignoreMutation:: ?(dom.MutationRecord) → bool
//   Called when a DOM
//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
//   or a selection change happens within the view. When the change is
//   a selection change, the record will have a `type` property of
//   `"selection"` (which doesn't occur for native mutation records).
//   Return false if the editor should re-read the selection or
//   re-parse the range around the mutation, true if it can safely be
//   ignored.
//
//   destroy:: ?()
//   Called when the node view is removed from the editor or the whole
//   editor is destroyed. (Not available for marks.)

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.

var NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;

// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
var index_es_ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  // An expando property on the DOM node provides a link back to its
  // description.
  dom.pmViewDesc = this;
  // This is the node that holds the child views. It may be null for
  // descs that don't have children.
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};

var prosemirror_view_dist_index_es_prototypeAccessors = { size: { configurable: true },border: { configurable: true },posBefore: { configurable: true },posAtStart: { configurable: true },posAfter: { configurable: true },posAtEnd: { configurable: true },contentLost: { configurable: true },domAtom: { configurable: true },ignoreForCoords: { configurable: true } };

// Used to check whether a given description corresponds to a
// widget/mark/node.
index_es_ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
index_es_ViewDesc.prototype.matchesMark = function matchesMark () { return false };
index_es_ViewDesc.prototype.matchesNode = function matchesNode () { return false };
index_es_ViewDesc.prototype.matchesHack = function matchesHack (_nodeName) { return false };

// : () → ?ParseRule
// When parsing in-editor content (in domchange.js), we allow
// descriptions to determine the parse rules that should be used to
// parse them.
index_es_ViewDesc.prototype.parseRule = function parseRule () { return null };

// : (dom.Event) → bool
// Used by the editor's event handler to ignore events that come
// from certain descs.
index_es_ViewDesc.prototype.stopEvent = function stopEvent () { return false };

// The size of the content represented by this desc.
prosemirror_view_dist_index_es_prototypeAccessors.size.get = function () {
  var size = 0;
  for (var i = 0; i < this.children.length; i++) { size += this.children[i].size; }
  return size
};

// For block nodes, this represents the space taken up by their
// start/end tokens.
prosemirror_view_dist_index_es_prototypeAccessors.border.get = function () { return 0 };

index_es_ViewDesc.prototype.destroy = function destroy () {
  this.parent = null;
  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
  for (var i = 0; i < this.children.length; i++)
    { this.children[i].destroy(); }
};

index_es_ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
    var cur = this.children[i];
    if (cur == child) { return pos }
    pos += cur.size;
  }
};

prosemirror_view_dist_index_es_prototypeAccessors.posBefore.get = function () {
  return this.parent.posBeforeChild(this)
};

prosemirror_view_dist_index_es_prototypeAccessors.posAtStart.get = function () {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
};

prosemirror_view_dist_index_es_prototypeAccessors.posAfter.get = function () {
  return this.posBefore + this.size
};

prosemirror_view_dist_index_es_prototypeAccessors.posAtEnd.get = function () {
  return this.posAtStart + this.size - 2 * this.border
};

// : (dom.Node, number, ?number) → number
index_es_ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
  // If the DOM position is in the content, use the child desc after
  // it to figure out a position.
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset - 1];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
    }
  }
  // Otherwise, use various heuristics, falling back on the bias
  // parameter, to determine whether to return the position at the
  // start or at the end of this view desc.
  var atEnd;
  if (dom == this.dom && this.contentDOM) {
    atEnd = offset > domIndex(this.contentDOM);
  } else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
      if (search == this.dom) { atEnd = false; break }
      if (search.parentNode.firstChild != search) { break }
    } }
    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
      if (search$1 == this.dom) { atEnd = true; break }
      if (search$1.parentNode.lastChild != search$1) { break }
    } }
  }
  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
};

// Scan up the dom finding the first desc that is a descendant of
// this one.
index_es_ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      // If dom is outside of this desc's nodeDOM, don't count it.
      if (first && desc.nodeDOM &&
          !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : desc.nodeDOM == dom))
        { first = false; }
      else
        { return desc }
    }
  }
};

index_es_ViewDesc.prototype.getDesc = function getDesc (dom) {
  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) { if (cur == this) { return desc } }
};

index_es_ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
  for (var scan = dom; scan; scan = scan.parentNode) {
    var desc = this.getDesc(scan);
    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
  }
  return -1
};

// : (number) → ?NodeViewDesc
// Find the desc for the node after the given pos, if any. (When a
// parent node overrode rendering, there might not be one.)
index_es_ViewDesc.prototype.descAt = function descAt (pos) {
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == pos && end != offset) {
      while (!child.border && child.children.length) { child = child.children[0]; }
      return child
    }
    if (pos < end) { return child.descAt(pos - offset - child.border) }
    offset = end;
  }
};

// : (number, number) → {node: dom.Node, offset: number}
index_es_ViewDesc.prototype.domFromPos = function domFromPos (pos, side) {
  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
  // First find the position in the child array
  var i = 0, offset = 0;
  for (var curPos = 0; i < this.children.length; i++) {
    var child = this.children[i], end = curPos + child.size;
    if (end > pos || child instanceof TrailingHackViewDesc) { offset = pos - curPos; break }
    curPos = end;
  }
  // If this points into the middle of a child, call through
  if (offset) { return this.children[i].domFromPos(offset - this.children[i].border, side) }
  // Go back if there were any zero-length widgets with side >= 0 before this point
  for (var prev = (void 0); i && !(prev = this.children[i - 1]).size && prev instanceof WidgetViewDesc && prev.widget.type.side >= 0; i--) {}
  // Scan towards the first useable node
  if (side <= 0) {
    var prev$1, enter = true;
    for (;; i--, enter = false) {
      prev$1 = i ? this.children[i - 1] : null;
      if (!prev$1 || prev$1.dom.parentNode == this.contentDOM) { break }
    }
    if (prev$1 && side && enter && !prev$1.border && !prev$1.domAtom) { return prev$1.domFromPos(prev$1.size, side) }
    return {node: this.contentDOM, offset: prev$1 ? domIndex(prev$1.dom) + 1 : 0}
  } else {
    var next, enter$1 = true;
    for (;; i++, enter$1 = false) {
      next = i < this.children.length ? this.children[i] : null;
      if (!next || next.dom.parentNode == this.contentDOM) { break }
    }
    if (next && enter$1 && !next.border && !next.domAtom) { return next.domFromPos(0, side) }
    return {node: this.contentDOM, offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length}
  }
};

// Used to find a DOM range in a single parent for a given changed
// range.
index_es_ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
    if ( base === void 0 ) base = 0;

  if (this.children.length == 0)
    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }

  var fromOffset = -1, toOffset = -1;
  for (var offset = base, i = 0;; i++) {
    var child = this.children[i], end = offset + child.size;
    if (fromOffset == -1 && from <= end) {
      var childBase = offset + child.border;
      // FIXME maybe descend mark views to parse a narrower range?
      if (from >= childBase && to <= end - child.border && child.node &&
          child.contentDOM && this.contentDOM.contains(child.contentDOM))
        { return child.parseRange(from, to, childBase) }

      from = offset;
      for (var j = i; j > 0; j--) {
        var prev = this.children[j - 1];
        if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break
        }
        from -= prev.size;
      }
      if (fromOffset == -1) { fromOffset = 0; }
    }
    if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
      to = end;
      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
        var next = this.children[j$1];
        if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break
        }
        to += next.size;
      }
      if (toOffset == -1) { toOffset = this.contentDOM.childNodes.length; }
      break
    }
    offset = end;
  }
  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
};

index_es_ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
  if (this.border || !this.contentDOM || !this.children.length) { return false }
  var child = this.children[side < 0 ? 0 : this.children.length - 1];
  return child.size == 0 || child.emptyChildAt(side)
};

// : (number) → dom.Node
index_es_ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
  var ref = this.domFromPos(pos, 0);
    var node = ref.node;
    var offset = ref.offset;
  if (node.nodeType != 1 || offset == node.childNodes.length)
    { throw new RangeError("No node after pos " + pos) }
  return node.childNodes[offset]
};

// : (number, number, dom.Document)
// View descs are responsible for setting any selection that falls
// entirely inside of them, so that custom implementations can do
// custom things with the selection. Note that this falls apart when
// a selection starts in such a node and ends in another, in which
// case we just use whatever domFromPos produces as a best effort.
index_es_ViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
  // If the selection falls entirely in a child, give it to that child
  var from = Math.min(anchor, head), to = Math.max(anchor, head);
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (from > offset && to < end)
      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force) }
    offset = end;
  }

  var anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
  var headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
  var domSel = root.getSelection();

  var brKludge = false;
  // On Firefox, using Selection.collapse to put the cursor after a
  // BR node for some reason doesn't always work (#1073). On Safari,
  // the cursor sometimes inexplicable visually lags behind its
  // reported position in such situations (#1092).
  if ((index_es_result.gecko || index_es_result.safari) && anchor == head) {
    var node = anchorDOM.node;
      var offset$1 = anchorDOM.offset;
    if (node.nodeType == 3) {
      brKludge = offset$1 && node.nodeValue[offset$1 - 1] == "\n";
      // Issue #1128
      if (brKludge && offset$1 == node.nodeValue.length) {
        for (var scan = node, after = (void 0); scan; scan = scan.parentNode) {
          if (after = scan.nextSibling) {
            if (after.nodeName == "BR")
              { anchorDOM = headDOM = {node: after.parentNode, offset: domIndex(after) + 1}; }
            break
          }
          var desc = scan.pmViewDesc;
          if (desc && desc.node && desc.node.isBlock) { break }
        }
      }
    } else {
      var prev = node.childNodes[offset$1 - 1];
      brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
    }
  }
  // Firefox can act strangely when the selection is in front of an
  // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
  if (index_es_result.gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
    var after$1 = domSel.focusNode.childNodes[domSel.focusOffset];
    if (after$1 && after$1.contentEditable == "false") { force = true; }
  }

  if (!(force || brKludge && index_es_result.safari) &&
      isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
    { return }

  // Selection.extend can be used to create an 'inverted' selection
  // (one where the focus is before the anchor), but not all
  // browsers support it yet.
  var domSelExtended = false;
  if ((domSel.extend || anchor == head) && !brKludge) {
    domSel.collapse(anchorDOM.node, anchorDOM.offset);
    try {
      if (anchor != head) { domSel.extend(headDOM.node, headDOM.offset); }
      domSelExtended = true;
    } catch (err) {
      // In some cases with Chrome the selection is empty after calling
      // collapse, even when it should be valid. This appears to be a bug, but
      // it is difficult to isolate. If this happens fallback to the old path
      // without using extend.
      if (!(err instanceof DOMException)) { throw err }
      // declare global: DOMException
    }
  }
  if (!domSelExtended) {
    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
    var range = document.createRange();
    range.setEnd(headDOM.node, headDOM.offset);
    range.setStart(anchorDOM.node, anchorDOM.offset);
    domSel.removeAllRanges();
    domSel.addRange(range);
  }
};

// : (dom.MutationRecord) → bool
index_es_ViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
  return !this.contentDOM && mutation.type != "selection"
};

prosemirror_view_dist_index_es_prototypeAccessors.contentLost.get = function () {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
};

// Remove a subtree of the element tree that has been touched
// by a DOM change, so that the next update will redraw it.
index_es_ViewDesc.prototype.markDirty = function markDirty (from, to) {
  for (var offset = 0, i = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
      var startInside = offset + child.border, endInside = end - child.border;
      if (from >= startInside && to <= endInside) {
        this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from == startInside && to == endInside &&
            (child.contentLost || child.dom.parentNode != this.contentDOM)) { child.dirty = NODE_DIRTY; }
        else { child.markDirty(from - startInside, to - startInside); }
        return
      } else {
        child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length
          ? CONTENT_DIRTY : NODE_DIRTY;
      }
    }
    offset = end;
  }
  this.dirty = CONTENT_DIRTY;
};

index_es_ViewDesc.prototype.markParentsDirty = function markParentsDirty () {
  var level = 1;
  for (var node = this.parent; node; node = node.parent, level++) {
    var dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
    if (node.dirty < dirty) { node.dirty = dirty; }
  }
};

prosemirror_view_dist_index_es_prototypeAccessors.domAtom.get = function () { return false };

prosemirror_view_dist_index_es_prototypeAccessors.ignoreForCoords.get = function () { return false };

Object.defineProperties( index_es_ViewDesc.prototype, prosemirror_view_dist_index_es_prototypeAccessors );

// Reused array to avoid allocating fresh arrays for things that will
// stay empty anyway.
var nothing = [];

// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
var WidgetViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function WidgetViewDesc(parent, widget, view, pos) {
    var self, dom = widget.type.toDOM;
    if (typeof dom == "function") { dom = dom(view, function () {
      if (!self) { return pos }
      if (self.parent) { return self.parent.posBeforeChild(self) }
    }); }
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc.call(this, parent, nothing, dom, null);
    this.widget = widget;
    self = this;
  }

  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  WidgetViewDesc.prototype.constructor = WidgetViewDesc;

  var prototypeAccessors$1 = { domAtom: { configurable: true } };

  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
  };

  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };

  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
    var stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false
  };

  WidgetViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "selection" || this.widget.spec.ignoreSelection
  };

  WidgetViewDesc.prototype.destroy = function destroy () {
    this.widget.type.destroy(this.dom);
    ViewDesc.prototype.destroy.call(this);
  };

  prototypeAccessors$1.domAtom.get = function () { return true };

  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );

  return WidgetViewDesc;
}(index_es_ViewDesc));

var CompositionViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function CompositionViewDesc(parent, dom, textDOM, text) {
    ViewDesc.call(this, parent, nothing, dom, null);
    this.textDOM = textDOM;
    this.text = text;
  }

  if ( ViewDesc ) CompositionViewDesc.__proto__ = ViewDesc;
  CompositionViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  CompositionViewDesc.prototype.constructor = CompositionViewDesc;

  var prototypeAccessors$2 = { size: { configurable: true } };

  prototypeAccessors$2.size.get = function () { return this.text.length };

  CompositionViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset) {
    if (dom != this.textDOM) { return this.posAtStart + (offset ? this.size : 0) }
    return this.posAtStart + offset
  };

  CompositionViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.textDOM, offset: pos}
  };

  CompositionViewDesc.prototype.ignoreMutation = function ignoreMutation (mut) {
    return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue
   };

  Object.defineProperties( CompositionViewDesc.prototype, prototypeAccessors$2 );

  return CompositionViewDesc;
}(index_es_ViewDesc));

// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
var index_es_MarkViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function MarkViewDesc(parent, mark, dom, contentDOM) {
    ViewDesc.call(this, parent, [], dom, contentDOM);
    this.mark = mark;
  }

  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  MarkViewDesc.prototype.constructor = MarkViewDesc;

  MarkViewDesc.create = function create (parent, mark, inline, view) {
    var custom = view.nodeViews[mark.type.name];
    var spec = custom && custom(mark, view, inline);
    if (!spec || !spec.dom)
      { spec = DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
  };

  MarkViewDesc.prototype.parseRule = function parseRule () {
    if ((this.dirty & NODE_DIRTY) || this.mark.type.spec.reparseInView) { return null }
    return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM}
  };

  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };

  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
    ViewDesc.prototype.markDirty.call(this, from, to);
    // Move dirty info to nearest node view
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) { parent = parent.parent; }
      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
      this.dirty = NOT_DIRTY;
    }
  };

  MarkViewDesc.prototype.slice = function slice (from, to, view) {
    var copy = MarkViewDesc.create(this.parent, this.mark, true, view);
    var nodes = this.children, size = this.size;
    if (to < size) { nodes = replaceNodes(nodes, to, size, view); }
    if (from > 0) { nodes = replaceNodes(nodes, 0, from, view); }
    for (var i = 0; i < nodes.length; i++) { nodes[i].parent = copy; }
    copy.children = nodes;
    return copy
  };

  return MarkViewDesc;
}(index_es_ViewDesc));

// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
var index_es_NodeViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM;
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) { this.updateChildren(view, pos); }
  }

  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  NodeViewDesc.prototype.constructor = NodeViewDesc;

  var prototypeAccessors$3 = { size: { configurable: true },border: { configurable: true },domAtom: { configurable: true } };

  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
    var assign;

    var custom = view.nodeViews[node.type.name], descObj;
    var spec = custom && custom(node, view, function () {
      // (This is a function that allows the custom view to find its
      // own position)
      if (!descObj) { return pos }
      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
    }, outerDeco, innerDeco);

    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom) { dom = document.createTextNode(node.text); }
      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
    } else if (!dom) {
((assign = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
      if (!dom.hasAttribute("contenteditable")) { dom.contentEditable = false; }
      if (node.type.spec.draggable) { dom.draggable = true; }
    }

    var nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);

    if (spec)
      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM,
                                              spec, view, pos + 1) }
    else if (node.isText)
      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
    else
      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
  };

  NodeViewDesc.prototype.parseRule = function parseRule () {
    var this$1 = this;

    // Experimental kludge to allow opt-in re-parsing of nodes
    if (this.node.type.spec.reparseInView) { return null }
    // FIXME the assumption that this can always return the current
    // attrs means that if the user somehow manages to change the
    // attrs in the dom, that won't be picked up. Not entirely sure
    // whether this is a problem
    var rule = {node: this.node.type.name, attrs: this.node.attrs};
    if (this.node.type.whitespace == "pre") { rule.preserveWhitespace = "full"; }
    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
    else { rule.getContent = function () { return this$1.contentDOM ? Fragment.empty : this$1.node.content; }; }
    return rule
  };

  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
  };

  prototypeAccessors$3.size.get = function () { return this.node.nodeSize };

  prototypeAccessors$3.border.get = function () { return this.node.isLeaf ? 0 : 1 };

  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
    var this$1 = this;

    var inline = this.node.inlineContent, off = pos;
    var composition = view.composing && this.localCompositionInfo(view, pos);
    var localComposition = composition && composition.pos > -1 ? composition : null;
    var compositionInChild = composition && composition.pos < 0;
    var updater = new ViewTreeUpdater(this, localComposition && localComposition.node);
    iterDeco(this.node, this.innerDeco, function (widget, i, insideNode) {
      if (widget.spec.marks)
        { updater.syncToMarks(widget.spec.marks, inline, view); }
      else if (widget.type.side >= 0 && !insideNode)
        { updater.syncToMarks(i == this$1.node.childCount ? Mark.none : this$1.node.child(i).marks, inline, view); }
      // If the next node is a desc matching this widget, reuse it,
      // otherwise insert the widget as a new view desc.
      updater.placeWidget(widget, view, off);
    }, function (child, outerDeco, innerDeco, i) {
      // Make sure the wrapping mark descs match the node's marks.
      updater.syncToMarks(child.marks, inline, view);
      // Try several strategies for drawing this node
      var compIndex;
      if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ; else if (compositionInChild && view.state.selection.from > off &&
                 view.state.selection.to < off + child.nodeSize &&
                 (compIndex = updater.findIndexWithChild(composition.node)) > -1 &&
                 updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ; else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i)) ; else {
        // Add it as a new view
        updater.addNode(child, outerDeco, innerDeco, view, off);
      }
      off += child.nodeSize;
    });
    // Drop all remaining descs after the current position.
    updater.syncToMarks(nothing, inline, view);
    if (this.node.isTextblock) { updater.addTextblockHacks(); }
    updater.destroyRest();

    // Sync the DOM if anything changed
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      // May have to protect focused DOM from being changed if a composition is active
      if (localComposition) { this.protectLocalComposition(view, localComposition); }
      renderDescs(this.contentDOM, this.children, view);
      if (index_es_result.ios) { iosHacks(this.dom); }
    }
  };

  NodeViewDesc.prototype.localCompositionInfo = function localCompositionInfo (view, pos) {
    // Only do something if both the selection and a focused text node
    // are inside of this node
    var ref = view.state.selection;
    var from = ref.from;
    var to = ref.to;
    if (!(view.state.selection instanceof index_es_TextSelection) || from < pos || to > pos + this.node.content.size) { return }
    var sel = view.root.getSelection();
    var textNode = nearbyTextNode(sel.focusNode, sel.focusOffset);
    if (!textNode || !this.dom.contains(textNode.parentNode)) { return }

    if (this.node.inlineContent) {
      // Find the text in the focused node in the node, stop if it's not
      // there (may have been modified through other means, in which
      // case it should overwritten)
      var text = textNode.nodeValue;
      var textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);
      return textPos < 0 ? null : {node: textNode, pos: textPos, text: text}
    } else {
      return {node: textNode, pos: -1}
    }
  };

  NodeViewDesc.prototype.protectLocalComposition = function protectLocalComposition (view, ref) {
    var node = ref.node;
    var pos = ref.pos;
    var text = ref.text;

    // The node is already part of a local view desc, leave it there
    if (this.getDesc(node)) { return }

    // Create a composition view for the orphaned nodes
    var topNode = node;
    for (;; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM) { break }
      while (topNode.previousSibling) { topNode.parentNode.removeChild(topNode.previousSibling); }
      while (topNode.nextSibling) { topNode.parentNode.removeChild(topNode.nextSibling); }
      if (topNode.pmViewDesc) { topNode.pmViewDesc = null; }
    }
    var desc = new CompositionViewDesc(this, topNode, node, text);
    view.compositionNodes.push(desc);

    // Patch up this.children to contain the composition view
    this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
  };

  // : (Node, [Decoration], DecorationSource, EditorView) → bool
  // If this desc be updated to match the given node decoration,
  // do so and return true.
  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY ||
        !node.sameMarkup(this.node)) { return false }
    this.updateInner(node, outerDeco, innerDeco, view);
    return true
  };

  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
    this.dirty = NOT_DIRTY;
  };

  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
                              computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };

  // Mark this node as being the selected node.
  NodeViewDesc.prototype.selectNode = function selectNode () {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = true; }
  };

  // Remove selected node marking from this node.
  NodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.removeAttribute("draggable"); }
  };

  prototypeAccessors$3.domAtom.get = function () { return this.node.isAtom };

  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$3 );

  return NodeViewDesc;
}(index_es_ViewDesc));

// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc);
  return new index_es_NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
}

var TextViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
  }

  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  TextViewDesc.prototype.constructor = TextViewDesc;

  var prototypeAccessors$4 = { domAtom: { configurable: true } };

  TextViewDesc.prototype.parseRule = function parseRule () {
    var skip = this.nodeDOM.parentNode;
    while (skip && skip != this.dom && !skip.pmIsDeco) { skip = skip.parentNode; }
    return {skip: skip || true}
  };

  TextViewDesc.prototype.update = function update (node, outerDeco, _, view) {
    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
        !node.sameMarkup(this.node)) { return false }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
      this.nodeDOM.nodeValue = node.text;
      if (view.trackWrites == this.nodeDOM) { view.trackWrites = null; }
    }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true
  };

  TextViewDesc.prototype.inParent = function inParent () {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
    return false
  };

  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.nodeDOM, offset: pos}
  };

  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
  };

  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "characterData" && mutation.type != "selection"
  };

  TextViewDesc.prototype.slice = function slice (from, to, view) {
    var node = this.node.cut(from, to), dom = document.createTextNode(node.text);
    return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view)
  };

  TextViewDesc.prototype.markDirty = function markDirty (from, to) {
    NodeViewDesc.prototype.markDirty.call(this, from, to);
    if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length))
      { this.dirty = NODE_DIRTY; }
  };

  prototypeAccessors$4.domAtom.get = function () { return false };

  Object.defineProperties( TextViewDesc.prototype, prototypeAccessors$4 );

  return TextViewDesc;
}(index_es_NodeViewDesc));

// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
var TrailingHackViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function TrailingHackViewDesc () {
    ViewDesc.apply(this, arguments);
  }

  if ( ViewDesc ) TrailingHackViewDesc.__proto__ = ViewDesc;
  TrailingHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  TrailingHackViewDesc.prototype.constructor = TrailingHackViewDesc;

  var prototypeAccessors$5 = { domAtom: { configurable: true },ignoreForCoords: { configurable: true } };

  TrailingHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
  TrailingHackViewDesc.prototype.matchesHack = function matchesHack (nodeName) { return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName };
  prototypeAccessors$5.domAtom.get = function () { return true };
  prototypeAccessors$5.ignoreForCoords.get = function () { return this.dom.nodeName == "IMG" };

  Object.defineProperties( TrailingHackViewDesc.prototype, prototypeAccessors$5 );

  return TrailingHackViewDesc;
}(index_es_ViewDesc));

// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
var CustomNodeViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }

  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;

  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) { return false }
    if (this.spec.update) {
      var result = this.spec.update(node, outerDeco, innerDeco);
      if (result) { this.updateInner(node, outerDeco, innerDeco, view); }
      return result
    } else if (!this.contentDOM && !node.isLeaf) {
      return false
    } else {
      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
    }
  };

  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
  };

  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
  };

  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root)
      : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root, force);
  };

  CustomNodeViewDesc.prototype.destroy = function destroy () {
    if (this.spec.destroy) { this.spec.destroy(); }
    NodeViewDesc.prototype.destroy.call(this);
  };

  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
  };

  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
  };

  return CustomNodeViewDesc;
}(index_es_NodeViewDesc));

// : (dom.Node, [ViewDesc])
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs, view) {
  var dom = parentDOM.firstChild, written = false;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) { dom = rm(dom); written = true; }
      dom = dom.nextSibling;
    } else {
      written = true;
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof index_es_MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children, view);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) { dom = rm(dom); written = true; }
  if (written && view.trackWrites == parentDOM) { view.trackWrites = null; }
}

function OuterDecoLevel(nodeName) {
  if (nodeName) { this.nodeName = nodeName; }
}
OuterDecoLevel.prototype = Object.create(null);

var noDeco = [new OuterDecoLevel];

function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) { return noDeco }

  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result = [top];

  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs;
    if (!attrs) { continue }
    if (attrs.nodeName)
      { result.push(top = new OuterDecoLevel(attrs.nodeName)); }

    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) { continue }
      if (needsWrap && result.length == 1)
        { result.push(top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
      if (name == "class") { top.class = (top.class ? top.class + " " : "") + val; }
      else if (name == "style") { top.style = (top.style ? top.style + ";" : "") + val; }
      else if (name != "nodeName") { top[name] = val; }
    }
  }

  return result
}

function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  // Shortcut for trivial case
  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }

  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      var parent = (void 0);
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
          (parent = curDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.pmIsDeco = true;
        parent.appendChild(curDOM);
        prev = noDeco[0];
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM
}

function patchAttributes(dom, prev, cur) {
  for (var name in prev)
    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      { dom.removeAttribute(name); } }
  for (var name$1 in cur)
    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
      { dom.setAttribute(name$1, cur[name$1]); } }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ").filter(Boolean) : nothing;
    var curList = cur.class ? cur.class.split(" ").filter(Boolean) : nothing;
    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
      { dom.classList.remove(prevList[i]); } }
    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
      { dom.classList.add(curList[i$1]); } }
    if (dom.classList.length == 0)
      { dom.removeAttribute("class"); }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        { dom.style.removeProperty(m[1]); }
    }
    if (cur.style)
      { dom.style.cssText += cur.style; }
  }
}

function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
}

// : ([Decoration], [Decoration]) → bool
function sameOuterDeco(a, b) {
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
  return true
}

// Remove a DOM node and return its next sibling.
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next
}

// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
var ViewTreeUpdater = function ViewTreeUpdater(top, lockedNode) {
  this.top = top;
  this.lock = lockedNode;
  // Index into `this.top`'s child array, represents the current
  // update position.
  this.index = 0;
  // When entering a mark, the current top and index are pushed
  // onto this.
  this.stack = [];
  // Tracks whether anything was changed
  this.changed = false;

  this.preMatch = preMatch(top.node.content, top);
};

// Destroy and remove the children between the given indices in
// `this.top`.
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
  if (start == end) { return }
  for (var i = start; i < end; i++) { this.top.children[i].destroy(); }
  this.top.children.splice(start, end - start);
  this.changed = true;
};

// Destroy all remaining children in `this.top`.
ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
  this.destroyBetween(this.index, this.top.children.length);
};

// : ([Mark], EditorView)
// Sync the current stack of mark descs with the given array of
// marks, reusing existing mark descs when possible.
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks.length);
  while (keep < maxKeep &&
         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
    { keep++; }

  while (keep < depth) {
    this.destroyRest();
    this.top.dirty = NOT_DIRTY;
    this.index = this.stack.pop();
    this.top = this.stack.pop();
    depth--;
  }
  while (depth < marks.length) {
    this.stack.push(this.top, this.index + 1);
    var found = -1;
    for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
      if (this.top.children[i].matchesMark(marks[depth])) { found = i; break }
    }
    if (found > -1) {
      if (found > this.index) {
        this.changed = true;
        this.destroyBetween(this.index, found);
      }
      this.top = this.top.children[this.index];
    } else {
      var markDesc = index_es_MarkViewDesc.create(this.top, marks[depth], inline, view);
      this.top.children.splice(this.index, 0, markDesc);
      this.top = markDesc;
      this.changed = true;
    }
    this.index = 0;
    depth++;
  }
};

// : (Node, [Decoration], DecorationSource) → bool
// Try to find a node desc matching the given data. Skip over it and
// return true when successful.
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
  var found = -1, targetDesc;
  if (index >= this.preMatch.index &&
      (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top &&
      targetDesc.matchesNode(node, outerDeco, innerDeco)) {
    found = this.top.children.indexOf(targetDesc, this.index);
  } else {
    for (var i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
      var child = this.top.children[i];
      if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
        found = i;
        break
      }
    }
  }
  if (found < 0) { return false }
  this.destroyBetween(this.index, found);
  this.index++;
  return true
};

ViewTreeUpdater.prototype.updateNodeAt = function updateNodeAt (node, outerDeco, innerDeco, index, view) {
  var child = this.top.children[index];
  if (!child.update(node, outerDeco, innerDeco, view)) { return false }
  this.destroyBetween(this.index, index);
  this.index = index + 1;
  return true
};

ViewTreeUpdater.prototype.findIndexWithChild = function findIndexWithChild (domNode) {
  for (;;) {
    var parent = domNode.parentNode;
    if (!parent) { return -1 }
    if (parent == this.top.contentDOM) {
      var desc = domNode.pmViewDesc;
      if (desc) { for (var i = this.index; i < this.top.children.length; i++) {
        if (this.top.children[i] == desc) { return i }
      } }
      return -1
    }
    domNode = parent;
  }
};

// : (Node, [Decoration], DecorationSource, EditorView, Fragment, number) → bool
// Try to update the next node, if any, to the given data. Checks
// pre-matches to avoid overwriting nodes that could still be used.
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
  for (var i = this.index; i < this.top.children.length; i++) {
    var next = this.top.children[i];
    if (next instanceof index_es_NodeViewDesc) {
      var preMatch = this.preMatch.matched.get(next);
      if (preMatch != null && preMatch != index) { return false }
      var nextDOM = next.dom;

      // Can't update if nextDOM is or contains this.lock, except if
      // it's a text node whose content already matches the new text
      // and whose decorations match the new ones.
      var locked = this.lock && (nextDOM == this.lock || nextDOM.nodeType == 1 && nextDOM.contains(this.lock.parentNode)) &&
          !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text &&
            next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
      if (!locked && next.update(node, outerDeco, innerDeco, view)) {
        this.destroyBetween(this.index, i);
        if (next.dom != nextDOM) { this.changed = true; }
        this.index++;
        return true
      }
      break
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSource, EditorView)
// Insert the node as a newly created node desc.
ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, index_es_NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
  this.changed = true;
};

ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
  var next = this.index < this.top.children.length ? this.top.children[this.index] : null;
  if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) {
    this.index++;
  } else {
    var desc = new WidgetViewDesc(this.top, widget, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};

// Make sure a textblock looks and behaves correctly in
// contentEditable.
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof index_es_MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }

  if (!lastChild || // Empty textblock
      !(lastChild instanceof TextViewDesc) ||
      /\n$/.test(lastChild.node.text)) {
    // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
    if ((index_es_result.safari || index_es_result.chrome) && lastChild && lastChild.dom.contentEditable == "false")
      { this.addHackNode("IMG"); }
    this.addHackNode("BR");
  }
};

ViewTreeUpdater.prototype.addHackNode = function addHackNode (nodeName) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesHack(nodeName)) {
    this.index++;
  } else {
    var dom = document.createElement(nodeName);
    if (nodeName == "IMG") {
      dom.className = "ProseMirror-separator";
      dom.alt = "";
    }
    if (nodeName == "BR") { dom.className = "ProseMirror-trailingBreak"; }
    this.top.children.splice(this.index++, 0, new TrailingHackViewDesc(this.top, nothing, dom, null));
    this.changed = true;
  }
};

// : (Fragment, [ViewDesc]) → {index: number, matched: Map<ViewDesc, number>, matches: ViewDesc[]}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function preMatch(frag, parentDesc) {
  var curDesc = parentDesc, descI = curDesc.children.length;
  var fI = frag.childCount, matched = new Map, matches = [];
  outer: while (fI > 0) {
    var desc = (void 0);
    for (;;) {
      if (descI) {
        var next = curDesc.children[descI - 1];
        if (next instanceof index_es_MarkViewDesc) {
          curDesc = next;
          descI = next.children.length;
        } else {
          desc = next;
          descI--;
          break
        }
      } else if (curDesc == parentDesc) {
        break outer
      } else {
        // FIXME
        descI = curDesc.parent.children.indexOf(curDesc);
        curDesc = curDesc.parent;
      }
    }
    var node = desc.node;
    if (!node) { continue }
    if (node != frag.child(fI - 1)) { break }
    --fI;
    matched.set(desc, fI);
    matches.push(desc);
  }
  return {index: fI, matched: matched, matches: matches.reverse()}
}

function compareSide(a, b) { return a.type.side - b.type.side }

// : (ViewDesc, DecorationSource, (Decoration, number), (Node, [Decoration], DecorationSource, number))
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent), offset = 0;
  // Simple, cheap variant for when there are no local decorations
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return
  }

  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0;;) {
    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var widget = locals[decoIndex++], widgets = (void 0);
      while (decoIndex < locals.length && locals[decoIndex].to == offset)
        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex, !!restNode); }
      } else {
        onWidget(widget, parentIndex, !!restNode);
      }
    }

    var child$1 = (void 0), index = (void 0);
    if (restNode) {
      index = -1;
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index = parentIndex;
      child$1 = parent.child(parentIndex++);
    } else {
      break
    }

    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
    while (decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)
      { active.push(locals[decoIndex++]); }

    var end = offset + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
      if (cutAt < end) {
        restNode = child$1.cut(cutAt - offset);
        child$1 = child$1.cut(0, cutAt - offset);
        end = cutAt;
        index = -1;
      }
    }

    var outerDeco = !active.length ? nothing
        : child$1.isInline && !child$1.isLeaf ? active.filter(function (d) { return !d.inline; })
        : active.slice();
    onNode(child$1, outerDeco, deco.forChild(offset, child$1), index);
    offset = end;
  }
}

// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}

function nearbyTextNode(node, offset) {
  for (;;) {
    if (node.nodeType == 3) { return node }
    if (node.nodeType == 1 && offset > 0) {
      if (node.childNodes.length > offset && node.childNodes[offset].nodeType == 3)
        { return node.childNodes[offset] }
      node = node.childNodes[offset - 1];
      offset = nodeSize(node);
    } else if (node.nodeType == 1 && offset < node.childNodes.length) {
      node = node.childNodes[offset];
      offset = 0;
    } else {
      return null
    }
  }
}

// Find a piece of text in an inline fragment, overlapping from-to
function findTextInFragment(frag, text, from, to) {
  for (var i = 0, pos = 0; i < frag.childCount && pos <= to;) {
    var child = frag.child(i++), childStart = pos;
    pos += child.nodeSize;
    if (!child.isText) { continue }
    var str = child.text;
    while (i < frag.childCount) {
      var next = frag.child(i++);
      pos += next.nodeSize;
      if (!next.isText) { break }
      str += next.text;
    }
    if (pos >= from) {
      var found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
      if (found >= 0 && found + text.length + childStart >= from)
        { return childStart + found }
      if (from == to && str.length >= (to + text.length) - childStart &&
          str.slice(to - childStart, to - childStart + text.length) == text)
        { return to }
    }
  }
  return -1
}

// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function replaceNodes(nodes, from, to, view, replacement) {
  var result = [];
  for (var i = 0, off = 0; i < nodes.length; i++) {
    var child = nodes[i], start = off, end = off += child.size;
    if (start >= to || end <= from) {
      result.push(child);
    } else {
      if (start < from) { result.push(child.slice(0, from - start, view)); }
      if (replacement) {
        result.push(replacement);
        replacement = null;
      }
      if (end > to) { result.push(child.slice(to - start, child.size, view)); }
    }
  }
  return result
}

function selectionFromDOM(view, origin) {
  var domSel = view.root.getSelection(), doc = view.state.doc;
  if (!domSel.focusNode) { return null }
  var nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  var head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  if (head < 0) { return null }
  var $head = doc.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
    if (nearestDesc && nearestDesc.node.isAtom && index_es_NodeSelection.isSelectable(nearestDesc.node) && nearestDesc.parent
        && !(nearestDesc.node.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
      var pos = nearestDesc.posBefore;
      selection = new index_es_NodeSelection(head == pos ? $head : doc.resolve(pos));
    }
  } else {
    var anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
    if (anchor < 0) { return null }
    $anchor = doc.resolve(anchor);
  }

  if (!selection) {
    var bias = origin == "pointer" || (view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection
}

function editorOwnsSelection(view) {
  return view.editable ? view.hasFocus() :
    hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom)
}

function selectionToDOM(view, force) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);

  if (!editorOwnsSelection(view)) { return }

  // The delayed drag selection causes issues with Cell Selections
  // in Safari. And the drag selection delay is to workarond issues
  // which only present in Chrome.
  if (!force && view.mouseDown && view.mouseDown.allowDefault && index_es_result.chrome) {
    var domSel = view.root.getSelection(), curSel = view.domObserver.currentSelection;
    if (domSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset,
                                                  curSel.anchorNode, curSel.anchorOffset)) {
      view.mouseDown.delayedSelectionSync = true;
      view.domObserver.setCurSelection();
      return
    }
  }

  view.domObserver.disconnectSelection();

  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof index_es_TextSelection)) {
      if (!sel.$from.parent.inlineContent)
        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
      if (!sel.empty && !sel.$from.parent.inlineContent)
        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
    }
    view.docView.setSelection(anchor, head, view.root, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) { resetEditable(resetEditableFrom); }
      if (resetEditableTo) { resetEditable(resetEditableTo); }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
    }
  }

  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}

// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.

var brokenSelectBetweenUneditable = index_es_result.safari || index_es_result.chrome && index_es_result.chrome_version < 63;

function temporarilyEditableNear(view, pos) {
  var ref = view.docView.domFromPos(pos, 0);
  var node = ref.node;
  var offset = ref.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if (index_es_result.safari && after && after.contentEditable == "false") { return setEditable(after) }
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) { return setEditable(after) }
    else if (before) { return setEditable(before) }
  }
}

function setEditable(element) {
  element.contentEditable = "true";
  if (index_es_result.safari && element.draggable) { element.draggable = false; element.wasDraggable = true; }
  return element
}

function resetEditable(element) {
  element.contentEditable = "false";
  if (element.wasDraggable) { element.draggable = true; element.wasDraggable = null; }
}

function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node = domSel.anchorNode, offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
      setTimeout(function () {
        if (!editorOwnsSelection(view) || view.state.selection.visible)
          { view.dom.classList.remove("ProseMirror-hideselection"); }
      }, 20);
    }
  });
}

function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range = document.createRange();
  var node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
  if (img) { range.setEnd(node.parentNode, domIndex(node) + 1); }
  else { range.setEnd(node, 0); }
  range.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range);
  // Kludge to kill 'control selection' in IE11 when selecting an
  // invisible cursor wrapper, since that would result in those weird
  // resize handles and a selection that considers the absolutely
  // positioned wrapper, rather than the root editable node, the
  // focused element.
  if (!img && !view.state.selection.visible && index_es_result.ie && index_es_result.ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}

function syncNodeSelection(view, sel) {
  if (sel instanceof index_es_NodeSelection) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) { desc.selectNode(); }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}

// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent)
      { view.lastSelectedViewDesc.deselectNode(); }
    view.lastSelectedViewDesc = null;
  }
}

function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
    || index_es_TextSelection.between($anchor, $head, bias)
}

function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) { return false }
  return hasSelection(view)
}

function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) { return false }
  try {
    // Firefox will raise 'permission denied' errors when accessing
    // properties of `sel.anchorNode` when it's in a generated CSS
    // element.
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
      (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode))
  } catch(_) {
    return false
  }
}

function anchorInRightPlace(view) {
  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
  var domSel = view.root.getSelection();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset)
}

function moveSelectionBlock(state, dir) {
  var ref = state.selection;
  var $anchor = ref.$anchor;
  var $head = ref.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && index_es_Selection.findFrom($start, dir)
}

function index_es_apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true
}

function selectHorizontally(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof index_es_TextSelection) {
    if (!sel.empty || mods.indexOf("s") > -1) {
      return false
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && (next instanceof index_es_NodeSelection)) { return index_es_apply(view, next) }
      return false
    } else if (!(index_es_result.mac && mods.indexOf("m") > -1)) {
      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node || node.isText) { return false }
      var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
      if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) { return false }
      if (index_es_NodeSelection.isSelectable(node)) {
        return index_es_apply(view, new index_es_NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head))
      } else if (index_es_result.webkit) {
        // Chrome and Safari will introduce extra pointless cursor
        // positions around inline uneditable nodes, so we have to
        // take over and move the cursor past them (#937)
        return index_es_apply(view, new index_es_TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)))
      } else {
        return false
      }
    }
  } else if (sel instanceof index_es_NodeSelection && sel.node.isInline) {
    return index_es_apply(view, new index_es_TextSelection(dir > 0 ? sel.$to : sel.$from))
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) { return index_es_apply(view, next$1) }
    return false
  }
}

function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
}

// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var moveNode, moveOffset, force = false;
  // Gecko will do odd things when the selection is directly in front
  // of a non-editable node, so in that case, move it into the next
  // node if possible. Issue prosemirror/prosemirror#832.
  if (index_es_result.gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset])) { force = true; }
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        break
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else { break }
      }
    } else if (isBlockNode(node)) {
      break
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) { setSelFocus(view, sel, node, offset); }
  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) { break }
      var after = node.childNodes[offset];
      if (isIgnorable(after)) {
        moveNode = node;
        moveOffset = ++offset;
      }
      else { break }
    } else if (isBlockNode(node)) {
      break
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

function setSelFocus(view, sel, node, offset) {
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.domObserver.setCurSelection();
  var state = view.state;
  // If no state update ends up happening, reset the selection.
  setTimeout(function () {
    if (view.state == state) { selectionToDOM(view); }
  }, 50);
}

// : (EditorState, number)
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof index_es_TextSelection && !sel.empty || mods.indexOf("s") > -1) { return false }
  if (index_es_result.mac && mods.indexOf("m") > -1) { return false }
  var $from = sel.$from;
  var $to = sel.$to;

  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && (next instanceof index_es_NodeSelection))
      { return index_es_apply(view, next) }
  }
  if (!$from.parent.inlineContent) {
    var side = dir < 0 ? $from : $to;
    var beyond = sel instanceof index_es_AllSelection ? index_es_Selection.near(side, dir) : index_es_Selection.findFrom(side, dir);
    return beyond ? index_es_apply(view, beyond) : false
  }
  return false
}

function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof index_es_TextSelection)) { return true }
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var empty = ref.empty;
  if (!$head.sameParent($anchor)) { return true }
  if (!empty) { return false }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
    view.dispatch(tr);
    return true
  }
  return false
}

function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}

// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function safariDownArrowBug(view) {
  if (!index_es_result.safari || view.state.selection.$head.parentOffset > 0) { return }
  var ref = view.root.getSelection();
  var focusNode = ref.focusNode;
  var focusOffset = ref.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
      focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child = focusNode.firstChild;
    switchEditable(view, child, true);
    setTimeout(function () { return switchEditable(view, child, false); }, 20);
  }
}

// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.

function getMods(event) {
  var result = "";
  if (event.ctrlKey) { result += "c"; }
  if (event.metaKey) { result += "m"; }
  if (event.altKey) { result += "a"; }
  if (event.shiftKey) { result += "s"; }
  return result
}

function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || (index_es_result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 46 || (index_es_result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 13 || code == 27) { // Enter, Esc
    return true
  } else if (code == 37) { // Left arrow
    return selectHorizontally(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 39) { // Right arrow
    return selectHorizontally(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (code == 38) { // Up arrow
    return selectVertically(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 40) { // Down arrow
    return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (mods == (index_es_result.mac ? "m" : "c") &&
             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
    return true
  }
  return false
}

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, from_, to_) {
  var ref = view.docView.parseRange(from_, to_);
  var parent = ref.node;
  var fromOffset = ref.fromOffset;
  var toOffset = ref.toOffset;
  var from = ref.from;
  var to = ref.to;

  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{node: anchor, offset: domSel.anchorOffset}];
    if (!selectionCollapsed(domSel))
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
  }
  // Work around issue in Chrome where backspacing sometimes replaces
  // the deleted content with a random BR node (issues #799, #831)
  if (index_es_result.chrome && view.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node = parent.childNodes[off - 1], desc = node.pmViewDesc;
      if (node.nodeName == "BR" && !desc) { toOffset = off; break }
      if (!desc || desc.size) { break }
    }
  }
  var startDoc = view.state.doc;
  var parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);

  var sel = null, doc = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
    editableContent: true,
    findPositions: find,
    ruleFromNode: ruleFromNode,
    context: $from
  });
  if (find && find[0].pos != null) {
    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
    if (head == null) { head = anchor$1; }
    sel = {anchor: anchor$1 + from, head: head + from};
  }
  return {doc: doc, sel: sel, from: from, to: to}
}

function ruleFromNode(dom) {
  var desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule()
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    // Safari replaces the list item or table cell with a BR
    // directly in the list node (?!) if you delete the last
    // character in a list item or table cell (#708, #862)
    if (index_es_result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      var skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return {skip: skip}
    } else if (dom.parentNode.lastChild == dom || index_es_result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return {ignore: true}
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return {ignore: true}
  }
}

function readDOMChange(view, from, to, typeOver, addedNodes) {
  if (from < 0) {
    var origin = view.lastSelectionTime > Date.now() - 50 ? view.lastSelectionOrigin : null;
    var newSel = selectionFromDOM(view, origin);
    if (newSel && !view.state.selection.eq(newSel)) {
      var tr$1 = view.state.tr.setSelection(newSel);
      if (origin == "pointer") { tr$1.setMeta("pointer", true); }
      else if (origin == "key") { tr$1.scrollIntoView(); }
      view.dispatch(tr$1);
    }
    return
  }

  var $before = view.state.doc.resolve(from);
  var shared = $before.sharedDepth(to);
  from = $before.before(shared + 1);
  to = view.state.doc.resolve(to).after(shared + 1);

  var sel = view.state.selection;
  var parse = parseBetween(view, from, to);

  // Chrome sometimes leaves the cursor before the inserted text when
  // composing after a cursor wrapper. This moves it forward.
  if (index_es_result.chrome && view.cursorWrapper && parse.sel && parse.sel.anchor == view.cursorWrapper.deco.from) {
    var text = view.cursorWrapper.deco.type.toDOM.nextSibling;
    var size = text && text.nodeValue ? text.nodeValue.length : 1;
    parse.sel = {anchor: parse.sel.anchor + size, head: parse.sel.anchor + size};
  }

  var doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  // Prefer anchoring to end when Backspace is pressed
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;

  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (!change) {
    if (typeOver && sel instanceof index_es_TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) &&
        !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
      change = {start: sel.from, endA: sel.to, endB: sel.to};
    } else if ((index_es_result.ios && view.lastIOSEnter > Date.now() - 225 || index_es_result.android) &&
               addedNodes.some(function (n) { return n.nodeName == "DIV" || n.nodeName == "P"; }) &&
               view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); })) {
      view.lastIOSEnter = 0;
      return
    } else {
      if (parse.sel) {
        var sel$1 = resolveSelection(view, view.state.doc, parse.sel);
        if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
      }
      return
    }
  }
  view.domChangeCount++;
  // Handle the case where overwriting a selection by typing matches
  // the start or end of the selected content, creating a change
  // that's smaller than what was actually overwritten.
  if (view.state.selection.from < view.state.selection.to &&
      change.start == change.endB &&
      view.state.selection instanceof index_es_TextSelection) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 &&
        view.state.selection.from >= parse.from) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 &&
               view.state.selection.to <= parse.to) {
      change.endB += (view.state.selection.to - change.endA);
      change.endA = view.state.selection.to;
    }
  }

  // IE11 will insert a non-breaking space _ahead_ of the space after
  // the cursor space when adding a space before another space. When
  // that happened, adjust the change to cover the space instead.
  if (index_es_result.ie && index_es_result.ie_version <= 11 && change.endB == change.start + 1 &&
      change.endA == change.start && change.start > parse.from &&
      parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
    change.start--;
    change.endA--;
    change.endB--;
  }

  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var inlineChange = $from.sameParent($to) && $from.parent.inlineContent;
  var nextSel;
  // If this looks like the effect of pressing Enter (or was recorded
  // as being an iOS enter press), just dispatch an Enter key instead.
  if (((index_es_result.ios && view.lastIOSEnter > Date.now() - 225 &&
        (!inlineChange || addedNodes.some(function (n) { return n.nodeName == "DIV" || n.nodeName == "P"; }))) ||
       (!inlineChange && $from.pos < parse.doc.content.size &&
        (nextSel = index_es_Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
        nextSel.head == $to.pos)) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); })) {
    view.lastIOSEnter = 0;
    return
  }
  // Same for backspace
  if (view.state.selection.anchor > change.start &&
      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) {
    if (index_es_result.android && index_es_result.chrome) { view.domObserver.suppressSelectionUpdates(); } // #820
    return
  }

  // Chrome Android will occasionally, during composition, delete the
  // entire composition and then immediately insert it again. This is
  // used to detect that situation.
  if (index_es_result.chrome && index_es_result.android && change.toB == change.from)
    { view.lastAndroidDelete = Date.now(); }

  // This tries to detect Android virtual keyboard
  // enter-and-pick-suggestion action. That sometimes (see issue
  // #1059) first fires a DOM mutation, before moving the selection to
  // the newly created block. And then, because ProseMirror cleans up
  // the DOM selection, it gives up moving the selection entirely,
  // leaving the cursor in the wrong place. When that happens, we drop
  // the new paragraph from the initial change, and fire a simulated
  // enter key afterwards.
  if (index_es_result.android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth &&
      parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
    change.endB -= 2;
    $to = parse.doc.resolveNoCache(change.endB - parse.from);
    setTimeout(function () {
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); });
    }, 20);
  }

  var chFrom = change.start, chTo = change.endA;

  var tr, storedMarks, markChange, $from1;
  if (inlineChange) {
    if ($from.pos == $to.pos) { // Deletion
      // IE11 sometimes weirdly moves the DOM selection around after
      // backspacing out the first element in a textblock
      if (index_es_result.ie && index_es_result.ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(function () { return selectionToDOM(view); }, 20);
      }
      tr = view.state.tr.delete(chFrom, chTo);
      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
    } else if ( // Adding or removing a mark
      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
    ) {
      tr = view.state.tr;
      if (markChange.type == "add") { tr.addMark(chFrom, chTo, markChange.mark); }
      else { tr.removeMark(chFrom, chTo, markChange.mark); }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      // Both positions in the same text node -- simply insert text
      var text$1 = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function (f) { return f(view, chFrom, chTo, text$1); })) { return }
      tr = view.state.tr.insertText(text$1, chFrom, chTo);
    }
  }

  if (!tr)
    { tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
  if (parse.sel) {
    var sel$2 = resolveSelection(view, tr.doc, parse.sel);
    // Chrome Android will sometimes, during composition, report the
    // selection in the wrong place. If it looks like that is
    // happening, don't update the selection.
    // Edge just doesn't move the cursor forward when you start typing
    // in an empty block or between br nodes.
    if (sel$2 && !(index_es_result.chrome && index_es_result.android && view.composing && sel$2.empty &&
                 (change.start != change.endB || view.lastAndroidDelete < Date.now() - 100) &&
                 (sel$2.head == chFrom || sel$2.head == tr.mapping.map(chTo) - 1) ||
                 index_es_result.ie && sel$2.empty && sel$2.head == chFrom))
      { tr.setSelection(sel$2); }
  }
  if (storedMarks) { tr.ensureMarks(storedMarks); }
  view.dispatch(tr.scrollIntoView());
}

function resolveSelection(view, doc, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
  return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head))
}

// : (Fragment, Fragment) → ?{mark: Mark, type: string}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark, update;
  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
  } else {
    return null
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
  if (Fragment.from(updated).eq(cur)) { return {mark: mark, type: type} }
}

function looksLikeJoin(old, start, end, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock ||
      // The content must have shrunk
      end - start <= $newEnd.pos - $newStart.pos ||
      // newEnd must point directly at or after the end of the block that newStart points into
      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
    { return false }

  var $start = old.resolve(start);
  // Start must be at the end of a block
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    { return false }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  // The next textblock must start before end and end near it
  if (!$next.parent.isTextblock || $next.pos > end ||
      skipClosingAndOpening($next, true, false) < end)
    { return false }

  // The fragments after the join point must match
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
}

function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end
}

function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= move$1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {start: start, endA: endA, endB: endB}
}

function serializeForClipboard(view, slice) {
  var context = [];
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
    content = node.content;
  }

  var serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
  var doc = detachedDoc(), wrap = doc.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content, {document: doc}));

  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = doc.createElement(needsWrap[i]);
      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
      wrap.appendChild(wrapper);
      if (needsWrap[i] != "tbody") {
        openStart++;
        openEnd++;
      }
    }
    firstChild = wrap.firstChild;
  }

  if (firstChild && firstChild.nodeType == 1)
    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }

  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
      slice.content.textBetween(0, slice.content.size, "\n\n");

  return {dom: wrap, text: text}
}

// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice;
  if (!html && !text) { return null }
  var asText = text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function (f) { text = f(text, inCode || plainText); });
    if (inCode) { return text ? new Slice(Fragment.from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : Slice.empty }
    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context, plainText); });
    if (parsed) {
      slice = parsed;
    } else {
      var marks = $context.marks();
      var ref = view.state;
      var schema = ref.schema;
      var serializer = DOMSerializer.fromSchema(schema);
      dom = document.createElement("div");
      text.split(/(?:\r\n?|\n)+/).forEach(function (block) {
        var p = dom.appendChild(document.createElement("p"));
        if (block) { p.appendChild(serializer.serializeNode(schema.text(block, marks))); }
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) { html = f(html); });
    dom = readHTML(html);
    if (index_es_result.webkit) { restoreReplacedSpaces(dom); }
  }

  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {
      preserveWhitespace: !!(asText || sliceData),
      context: $context,
      ruleFromNode: function ruleFromNode(dom) {
        if (dom.nodeName == "BR" && !dom.nextSibling &&
            dom.parentNode && !inlineParents.test(dom.parentNode.nodeName)) { return {ignore: true} }
      }
    });
  }
  if (sliceData) {
    slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[3]);
  } else { // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
    slice = Slice.maxOpen(normalizeSiblings(slice.content, $context), true);
    if (slice.openStart || slice.openEnd) {
      var openStart = 0, openEnd = 0;
      for (var node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating;
           openStart++, node = node.firstChild) {}
      for (var node$1 = slice.content.lastChild; openEnd < slice.openEnd && !node$1.type.spec.isolating;
           openEnd++, node$1 = node$1.lastChild) {}
      slice = closeSlice(slice, openStart, openEnd);
    }
  }

  view.someProp("transformPasted", function (f) { slice = f(slice); });
  return slice
}

var inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;

// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) { return fragment }
  var loop = function ( d ) {
    var parent = $context.node(d);
    var match = parent.contentMatchAt($context.index(d));
    var lastWrap = (void 0), result = [];
    fragment.forEach(function (node) {
      if (!result) { return }
      var wrap = match.findWrapping(node.type), inLast;
      if (!wrap) { return result = null }
      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
        var wrapped = withWrappers(node, wrap);
        result.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result) { return { v: Fragment.from(result) } }
  };

  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop( d );

    if ( returned ) return returned.v;
  }
  return fragment
}

function withWrappers(node, wrap, from) {
  if ( from === void 0 ) from = 0;

  for (var i = wrap.length - 1; i >= from; i--)
    { node = wrap[i].create(null, Fragment.from(node)); }
  return node
}

// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
      { return sibling.copy(sibling.content.append(Fragment.from(withWrappers(node, wrap, depth + 1)))) }
  }
}

function closeRight(node, depth) {
  if (depth == 0) { return node }
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true);
  return node.copy(fragment.append(fill))
}

function closeRange(fragment, side, from, to, depth, openEnd) {
  var node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
  if (depth < to - 1) { inner = closeRange(inner, side, from, to, depth + 1, openEnd); }
  if (depth >= from)
    { inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, fragment.childCount > 1 || openEnd <= depth).append(inner)
      : inner.append(node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true)); }
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner))
}

function closeSlice(slice, openStart, openEnd) {
  if (openStart < slice.openStart)
    { slice = new Slice(closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd); }
  if (openEnd < slice.openEnd)
    { slice = new Slice(closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd); }
  return slice
}

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
var wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};

var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"))
}

function readHTML(html) {
  var metas = /^(\s*<meta [^>]*>)*/.exec(html);
  if (metas) { html = html.slice(metas[0].length); }
  var elt = detachedDoc().createElement("div");
  var firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()])
    { html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join(""); }
  elt.innerHTML = html;
  if (wrap) { for (var i = 0; i < wrap.length; i++) { elt = elt.querySelector(wrap[i]) || elt; } }
  return elt
}

// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function restoreReplacedSpaces(dom) {
  var nodes = dom.querySelectorAll(index_es_result.chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode)
      { node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node); }
  }
}

function addContext(slice, context) {
  if (!slice.size) { return slice }
  var schema = slice.content.firstChild.type.schema, array;
  try { array = JSON.parse(context); }
  catch(e) { return slice }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) { break }
    content = Fragment.from(type.create(array[i + 1], content));
    openStart++; openEnd++;
  }
  return new Slice(content, openStart, openEnd)
}

var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
var useCharData = index_es_result.ie && index_es_result.ie_version <= 11;

var SelectionState = function SelectionState() {
  this.anchorNode = this.anchorOffset = this.focusNode = this.focusOffset = null;
};

SelectionState.prototype.set = function set (sel) {
  this.anchorNode = sel.anchorNode; this.anchorOffset = sel.anchorOffset;
  this.focusNode = sel.focusNode; this.focusOffset = sel.focusOffset;
};

SelectionState.prototype.eq = function eq (sel) {
  return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset &&
    sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset
};

var DOMObserver = function DOMObserver(view, handleDOMChange) {
  var this$1 = this;

  this.view = view;
  this.handleDOMChange = handleDOMChange;
  this.queue = [];
  this.flushingSoon = -1;
  this.observer = window.MutationObserver &&
    new window.MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) { this$1.queue.push(mutations[i]); }
      // IE11 will sometimes (on backspacing out a single character
      // text node after a BR node) call the observer callback
      // before actually updating the DOM, which will cause
      // ProseMirror to miss the change (see #930)
      if (index_es_result.ie && index_es_result.ie_version <= 11 && mutations.some(
        function (m) { return m.type == "childList" && m.removedNodes.length ||
             m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length; }))
        { this$1.flushSoon(); }
      else
        { this$1.flush(); }
    });
  this.currentSelection = new SelectionState;
  if (useCharData) {
    this.onCharData = function (e) {
      this$1.queue.push({target: e.target, type: "characterData", oldValue: e.prevValue});
      this$1.flushSoon();
    };
  }
  this.onSelectionChange = this.onSelectionChange.bind(this);
  this.suppressingSelectionUpdates = false;
};

DOMObserver.prototype.flushSoon = function flushSoon () {
    var this$1 = this;

  if (this.flushingSoon < 0)
    { this.flushingSoon = window.setTimeout(function () { this$1.flushingSoon = -1; this$1.flush(); }, 20); }
};

DOMObserver.prototype.forceFlush = function forceFlush () {
  if (this.flushingSoon > -1) {
    window.clearTimeout(this.flushingSoon);
    this.flushingSoon = -1;
    this.flush();
  }
};

DOMObserver.prototype.start = function start () {
  if (this.observer)
    { this.observer.observe(this.view.dom, observeOptions); }
  if (useCharData)
    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
  this.connectSelection();
};

DOMObserver.prototype.stop = function stop () {
    var this$1 = this;

  if (this.observer) {
    var take = this.observer.takeRecords();
    if (take.length) {
      for (var i = 0; i < take.length; i++) { this.queue.push(take[i]); }
      window.setTimeout(function () { return this$1.flush(); }, 20);
    }
    this.observer.disconnect();
  }
  if (useCharData) { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
  this.disconnectSelection();
};

DOMObserver.prototype.connectSelection = function connectSelection () {
  this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.disconnectSelection = function disconnectSelection () {
  this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.suppressSelectionUpdates = function suppressSelectionUpdates () {
    var this$1 = this;

  this.suppressingSelectionUpdates = true;
  setTimeout(function () { return this$1.suppressingSelectionUpdates = false; }, 50);
};

DOMObserver.prototype.onSelectionChange = function onSelectionChange () {
  if (!hasFocusAndSelection(this.view)) { return }
  if (this.suppressingSelectionUpdates) { return selectionToDOM(this.view) }
  // Deletions on IE11 fire their events in the wrong order, giving
  // us a selection change event before the DOM changes are
  // reported.
  if (index_es_result.ie && index_es_result.ie_version <= 11 && !this.view.state.selection.empty) {
    var sel = this.view.root.getSelection();
    // Selection.isCollapsed isn't reliable on IE
    if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      { return this.flushSoon() }
  }
  this.flush();
};

DOMObserver.prototype.setCurSelection = function setCurSelection () {
  this.currentSelection.set(this.view.root.getSelection());
};

DOMObserver.prototype.ignoreSelectionChange = function ignoreSelectionChange (sel) {
  if (sel.rangeCount == 0) { return true }
  var container = sel.getRangeAt(0).commonAncestorContainer;
  var desc = this.view.docView.nearestDesc(container);
  if (desc && desc.ignoreMutation({type: "selection", target: container.nodeType == 3 ? container.parentNode : container})) {
    this.setCurSelection();
    return true
  }
};

DOMObserver.prototype.flush = function flush () {
  if (!this.view.docView || this.flushingSoon > -1) { return }
  var mutations = this.observer ? this.observer.takeRecords() : [];
  if (this.queue.length) {
    mutations = this.queue.concat(mutations);
    this.queue.length = 0;
  }

  var sel = this.view.root.getSelection();
  var newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasSelection(this.view) && !this.ignoreSelectionChange(sel);

  var from = -1, to = -1, typeOver = false, added = [];
  if (this.view.editable) {
    for (var i = 0; i < mutations.length; i++) {
      var result$1 = this.registerMutation(mutations[i], added);
      if (result$1) {
        from = from < 0 ? result$1.from : Math.min(result$1.from, from);
        to = to < 0 ? result$1.to : Math.max(result$1.to, to);
        if (result$1.typeOver) { typeOver = true; }
      }
    }
  }

  if (index_es_result.gecko && added.length > 1) {
    var brs = added.filter(function (n) { return n.nodeName == "BR"; });
    if (brs.length == 2) {
      var a = brs[0];
        var b = brs[1];
      if (a.parentNode && a.parentNode.parentNode == b.parentNode) { b.remove(); }
      else { a.remove(); }
    }
  }

  if (from > -1 || newSel) {
    if (from > -1) {
      this.view.docView.markDirty(from, to);
      checkCSS(this.view);
    }
    this.handleDOMChange(from, to, typeOver, added);
    if (this.view.docView && this.view.docView.dirty) { this.view.updateState(this.view.state); }
    else if (!this.currentSelection.eq(sel)) { selectionToDOM(this.view); }
    this.currentSelection.set(sel);
  }
};

DOMObserver.prototype.registerMutation = function registerMutation (mut, added) {
  // Ignore mutations inside nodes that were already noted as inserted
  if (added.indexOf(mut.target) > -1) { return null }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" &&
      (desc == this.view.docView || mut.attributeName == "contenteditable" ||
       // Firefox sometimes fires spurious events for null/empty styles
       (mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))))
    { return null }
  if (!desc || desc.ignoreMutation(mut)) { return null }

  if (mut.type == "childList") {
    for (var i = 0; i < mut.addedNodes.length; i++) { added.push(mut.addedNodes[i]); }
    if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target))
      { return {from: desc.posBefore, to: desc.posAfter} }
    var prev = mut.previousSibling, next = mut.nextSibling;
    if (index_es_result.ie && index_es_result.ie_version <= 11 && mut.addedNodes.length) {
      // IE11 gives us incorrect next/prev siblings for some
      // insertions, so if there are added nodes, recompute those
      for (var i$1 = 0; i$1 < mut.addedNodes.length; i$1++) {
        var ref = mut.addedNodes[i$1];
          var previousSibling = ref.previousSibling;
          var nextSibling = ref.nextSibling;
        if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) { prev = previousSibling; }
        if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) { next = nextSibling; }
      }
    }
    var fromOffset = prev && prev.parentNode == mut.target
        ? domIndex(prev) + 1 : 0;
    var from = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = next && next.parentNode == mut.target
        ? domIndex(next) : mut.target.childNodes.length;
    var to = desc.localPosFromDOM(mut.target, toOffset, 1);
    return {from: from, to: to}
  } else if (mut.type == "attributes") {
    return {from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border}
  } else { // "characterData"
    return {
      from: desc.posAtStart,
      to: desc.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: mut.target.nodeValue == mut.oldValue
    }
  }
};

var cssChecked = false;

function checkCSS(view) {
  if (cssChecked) { return }
  cssChecked = true;
  if (getComputedStyle(view.dom).whiteSpace == "normal")
    { console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."); }
}

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
var handlers = {}, editHandlers = {};

function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.lastClick = {time: 0, x: 0, y: 0, type: ""};
  view.lastSelectionOrigin = null;
  view.lastSelectionTime = 0;

  view.lastIOSEnter = 0;
  view.lastIOSEnterFallbackTimeout = null;
  view.lastAndroidDelete = 0;

  view.composing = false;
  view.composingTimeout = null;
  view.compositionNodes = [];
  view.compositionEndedAt = -2e8;

  view.domObserver = new DOMObserver(view, function (from, to, typeOver, added) { return readDOMChange(view, from, to, typeOver, added); });
  view.domObserver.start();
  // Used by hacks like the beforeinput handler to check whether anything happened in the DOM
  view.domChangeCount = 0;

  view.eventHandlers = Object.create(null);
  var loop = function ( event ) {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
          (view.editable || !(event.type in editHandlers)))
        { handler(view, event); }
    });
  };

  for (var event in handlers) loop( event );
  // On Safari, for reasons beyond my understanding, adding an input
  // event handler makes an issue where the composition vanishes when
  // you press enter go away.
  if (index_es_result.safari) { view.dom.addEventListener("input", function () { return null; }); }

  ensureListeners(view);
}

function setSelectionOrigin(view, origin) {
  view.lastSelectionOrigin = origin;
  view.lastSelectionTime = Date.now();
}

function destroyInput(view) {
  view.domObserver.stop();
  for (var type in view.eventHandlers)
    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
  clearTimeout(view.composingTimeout);
  clearTimeout(view.lastIOSEnterFallbackTimeout);
}

function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) { if (!view.eventHandlers[type])
      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
  });
}

function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false
  })
}

function eventBelongsToView(view, event) {
  if (!event.bubbles) { return true }
  if (event.defaultPrevented) { return false }
  for (var node = event.target; node != view.dom; node = node.parentNode)
    { if (!node || node.nodeType == 11 ||
        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
      { return false } }
  return true
}

function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] &&
      (view.editable || !(event.type in editHandlers)))
    { handlers[event.type](view, event); }
}

editHandlers.keydown = function (view, event) {
  view.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event)) { return }
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  // Suppress enter key events on Chrome Android, because those tend
  // to be part of a confused sequence of composition events fired,
  // and handling them eagerly tends to corrupt the input.
  if (index_es_result.android && index_es_result.chrome && event.keyCode == 13) { return }
  if (event.keyCode != 229) { view.domObserver.forceFlush(); }

  // On iOS, if we preventDefault enter key presses, the virtual
  // keyboard gets confused. So the hack here is to set a flag that
  // makes the DOM change code recognize that what just happens should
  // be replaced by whatever the Enter key handlers do.
  if (index_es_result.ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    var now = Date.now();
    view.lastIOSEnter = now;
    view.lastIOSEnterFallbackTimeout = setTimeout(function () {
      if (view.lastIOSEnter == now) {
        view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); });
        view.lastIOSEnter = 0;
      }
    }, 200);
  } else if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};

editHandlers.keyup = function (view, e) {
  if (e.keyCode == 16) { view.shiftKey = false; }
};

editHandlers.keypress = function (view, event) {
  if (inOrNearComposition(view, event) || !event.charCode ||
      event.ctrlKey && !event.altKey || index_es_result.mac && event.metaKey) { return }

  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
    event.preventDefault();
    return
  }

  var sel = view.state.selection;
  if (!(sel instanceof index_es_TextSelection) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
    event.preventDefault();
  }
};

function eventCoords(event) { return {left: event.clientX, top: event.clientY} }

function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100
}

function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside);
  var loop = function ( i ) {
    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
      { return { v: true } }
  };

  for (var i = $pos.depth + 1; i > 0; i--) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

function updateSelection(view, selection, origin) {
  if (!view.focused) { view.focus(); }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") { tr.setMeta("pointer", true); }
  view.dispatch(tr);
}

function selectClickedLeaf(view, inside) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && index_es_NodeSelection.isSelectable(node)) {
    updateSelection(view, new index_es_NodeSelection($pos), "pointer");
    return true
  }
  return false
}

function selectClickedNode(view, inside) {
  if (inside == -1) { return false }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof index_es_NodeSelection) { selectedNode = sel.node; }

  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (index_es_NodeSelection.isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 &&
          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        { selectAt = $pos.before(sel.$from.depth); }
      else
        { selectAt = $pos.before(i); }
      break
    }
  }

  if (selectAt != null) {
    updateSelection(view, index_es_NodeSelection.create(view.state.doc, selectAt), "pointer");
    return true
  } else {
    return false
  }
}

function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
}

function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
}

function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
    defaultTripleClick(view, inside, event)
}

function defaultTripleClick(view, inside, event) {
  if (event.button != 0) { return false }
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, index_es_TextSelection.create(doc, 0, doc.content.size), "pointer");
      return true
    }
    return false
  }

  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent)
      { updateSelection(view, index_es_TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
    else if (index_es_NodeSelection.isSelectable(node))
      { updateSelection(view, index_es_NodeSelection.create(doc, nodePos), "pointer"); }
    else
      { continue }
    return true
  }
}

function forceDOMFlush(view) {
  return endComposition(view)
}

var selectNodeModifier = index_es_result.mac ? "metaKey" : "ctrlKey";

handlers.mousedown = function (view, event) {
  view.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now = Date.now(), type = "singleClick";
  if (now - view.lastClick.time < 500 && isNear(event, view.lastClick) && !event[selectNodeModifier]) {
    if (view.lastClick.type == "singleClick") { type = "doubleClick"; }
    else if (view.lastClick.type == "doubleClick") { type = "tripleClick"; }
  }
  view.lastClick = {time: now, x: event.clientX, y: event.clientY, type: type};

  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) { return }

  if (type == "singleClick") {
    if (view.mouseDown) { view.mouseDown.done(); }
    view.mouseDown = new index_es_MouseDown(view, pos, event, flushed);
  } else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "pointer");
  }
};

var index_es_MouseDown = function MouseDown(view, pos, event, flushed) {
  var this$1 = this;

  this.view = view;
  this.startDoc = view.state.doc;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;
  this.delayedSelectionSync = false;

  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }

  this.mightDrag = null;

  var target = flushed ? null : event.target;
  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
  this.target = targetDesc ? targetDesc.dom : null;

  var ref = view.state;
  var selection = ref.selection;
  if (event.button == 0 &&
      targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
      selection instanceof index_es_NodeSelection && selection.from <= targetPos && selection.to > targetPos)
    { this.mightDrag = {node: targetNode,
                      pos: targetPos,
                      addAttr: this.target && !this.target.draggable,
                      setUneditable: this.target && index_es_result.gecko && !this.target.hasAttribute("contentEditable")}; }

  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = true; }
    if (this.mightDrag.setUneditable)
      { setTimeout(function () {
        if (this$1.view.mouseDown == this$1) { this$1.target.setAttribute("contentEditable", "false"); }
      }, 20); }
    this.view.domObserver.start();
  }

  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  setSelectionOrigin(view, "pointer");
};

index_es_MouseDown.prototype.done = function done () {
    var this$1 = this;

  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.removeAttribute("draggable"); }
    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
    this.view.domObserver.start();
  }
  if (this.delayedSelectionSync) { setTimeout(function () { return selectionToDOM(this$1.view); }); }
  this.view.mouseDown = null;
};

index_es_MouseDown.prototype.up = function up (event) {
  this.done();

  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
    { return }

  var pos = this.pos;
  if (this.view.state.doc != this.startDoc) { pos = this.view.posAtCoords(eventCoords(event)); }

  if (this.allowDefault || !pos) {
    setSelectionOrigin(this.view, "pointer");
  } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (event.button == 0 &&
             (this.flushed ||
              // Safari ignores clicks on draggable elements
              (index_es_result.safari && this.mightDrag && !this.mightDrag.node.isAtom) ||
              // Chrome will sometimes treat a node selection as a
              // cursor, but still report that the node is selected
              // when asked through getSelection. You'll then get a
              // situation where clicking at the point where that
              // (hidden) cursor is doesn't change the selection, and
              // thus doesn't get a reaction from ProseMirror. This
              // works around that.
              (index_es_result.chrome && !(this.view.state.selection instanceof index_es_TextSelection) &&
               Math.min(Math.abs(pos.pos - this.view.state.selection.from),
                        Math.abs(pos.pos - this.view.state.selection.to)) <= 2))) {
    updateSelection(this.view, index_es_Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
    event.preventDefault();
  } else {
    setSelectionOrigin(this.view, "pointer");
  }
};

index_es_MouseDown.prototype.move = function move (event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
                             Math.abs(this.event.y - event.clientY) > 4))
    { this.allowDefault = true; }
  setSelectionOrigin(this.view, "pointer");
  if (event.buttons == 0) { this.done(); }
};

handlers.touchdown = function (view) {
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};

handlers.contextmenu = function (view) { return forceDOMFlush(view); };

function inOrNearComposition(view, event) {
  if (view.composing) { return true }
  // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
  // On Japanese input method editors (IMEs), the Enter key is used to confirm character
  // selection. On Safari, when Enter is pressed, compositionend and keydown events are
  // emitted. The keydown event triggers newline insertion, which we don't want.
  // This method returns true if the keydown event should be ignored.
  // We only ignore it once, as pressing Enter a second time *should* insert a newline.
  // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
  // This guards against the case where compositionend is triggered without the keyboard
  // (e.g. character confirmation may be done with the mouse), and keydown is triggered
  // afterwards- we wouldn't want to ignore the keydown event in this case.
  if (index_es_result.safari && Math.abs(event.timeStamp - view.compositionEndedAt) < 500) {
    view.compositionEndedAt = -2e8;
    return true
  }
  return false
}

// Drop active composition after 5 seconds of inactivity on Android
var timeoutComposition = index_es_result.android ? 5000 : -1;

editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  if (!view.composing) {
    view.domObserver.flush();
    var state = view.state;
    var $pos = state.selection.$from;
    if (state.selection.empty &&
        (state.storedMarks ||
         (!$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(function (m) { return m.type.spec.inclusive === false; })))) {
      // Need to wrap the cursor in mark nodes different from the ones in the DOM context
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view);
      // In firefox, if the cursor is after but outside a marked node,
      // the inserted text won't inherit the marks. So this moves it
      // inside if necessary.
      if (index_es_result.gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        var sel = view.root.getSelection();
        for (var node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
          var before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
          if (!before) { break }
          if (before.nodeType == 3) {
            sel.collapse(before, before.nodeValue.length);
            break
          } else {
            node = before;
            offset = -1;
          }
        }
      }
    }
    view.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};

editHandlers.compositionend = function (view, event) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = event.timeStamp;
    scheduleComposeEnd(view, 20);
  }
};

function scheduleComposeEnd(view, delay) {
  clearTimeout(view.composingTimeout);
  if (delay > -1) { view.composingTimeout = setTimeout(function () { return endComposition(view); }, delay); }
}

function clearComposition(view) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = timestampFromCustomEvent();
  }
  while (view.compositionNodes.length > 0) { view.compositionNodes.pop().markParentsDirty(); }
}

function timestampFromCustomEvent() {
  var event = document.createEvent("Event");
  event.initEvent("event", true, true);
  return event.timeStamp
}

function endComposition(view, forceUpdate) {
  if (index_es_result.android && view.domObserver.flushingSoon >= 0) { return }
  view.domObserver.forceFlush();
  clearComposition(view);
  if (forceUpdate || view.docView && view.docView.dirty) {
    var sel = selectionFromDOM(view);
    if (sel && !sel.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel)); }
    else { view.updateState(view.state); }
    return true
  }
  return false
}

function captureCopy(view, dom) {
  // The extra wrapper is somehow necessary on IE/Edge to prevent the
  // content from being mangled when it is put onto the clipboard
  if (!view.dom.parentNode) { return }
  var wrap = view.dom.parentNode.appendChild(document.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range = document.createRange();
  range.selectNodeContents(dom);
  // Done because IE will fire a selectionchange moving the selection
  // to its start when removeAllRanges is called and the editor still
  // has focus (which will mess up the editor's selection state).
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
    view.focus();
  }, 50);
}

// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = (index_es_result.ie && index_es_result.ie_version < 15) ||
      (index_es_result.ios && index_es_result.webkit_version < 604);

handlers.copy = editHandlers.cut = function (view, e) {
  var sel = view.state.selection, cut = e.type == "cut";
  if (sel.empty) { return }

  // IE and Edge's clipboard interface is completely broken
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice = sel.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
};

function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
}

function capturePaste(view, e) {
  if (!view.dom.parentNode) { return }
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
  if (!plainText) { target.contentEditable = "true"; }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function () {
    view.focus();
    if (target.parentNode) { target.parentNode.removeChild(target); }
    if (plainText) { doPaste(view, target.value, null, e); }
    else { doPaste(view, target.textContent, target.innerHTML, e); }
  }, 50);
}

function doPaste(view, text, html, e) {
  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
  if (view.someProp("handlePaste", function (f) { return f(view, e, slice || Slice.empty); })) { return true }
  if (!slice) { return false }

  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true
}

editHandlers.paste = function (view, e) {
  // Handling paste from JavaScript during composition is very poorly
  // handled by browsers, so as a dodgy but preferable kludge, we just
  // let the browser do its native thing there, except on Android,
  // where the editor is almost always composing.
  if (view.composing && !index_es_result.android) { return }
  var data = brokenClipboardAPI ? null : e.clipboardData;
  if (data && doPaste(view, data.getData("text/plain"), data.getData("text/html"), e)) { e.preventDefault(); }
  else { capturePaste(view, e); }
};

var Dragging = function Dragging(slice, move) {
  this.slice = slice;
  this.move = move;
};

var dragCopyModifier = index_es_result.mac ? "altKey" : "ctrlKey";

handlers.dragstart = function (view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) { mouseDown.done(); }
  if (!e.dataTransfer) { return }

  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof index_es_NodeSelection ? sel.to - 1: sel.to)) ; else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(index_es_NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (desc && desc.node.type.spec.draggable && desc != view.docView)
      { view.dispatch(view.state.tr.setSelection(index_es_NodeSelection.create(view.state.doc, desc.posBefore))); }
  }
  var slice = view.state.selection.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  // See https://github.com/ProseMirror/prosemirror/issues/1156
  e.dataTransfer.effectAllowed = "copyMove";
  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
};

handlers.dragend = function (view) {
  var dragging = view.dragging;
  window.setTimeout(function () {
    if (view.dragging == dragging)  { view.dragging = null; }
  }, 50);
};

editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };

editHandlers.drop = function (view, e) {
  var dragging = view.dragging;
  view.dragging = null;

  if (!e.dataTransfer) { return }

  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) { return }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) { return }
  var slice = dragging && dragging.slice;
  if (slice) {
    view.someProp("transformPasted", function (f) { slice = f(slice); });
  } else {
    slice = parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
                               brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  }
  var move = dragging && !e[dragCopyModifier];
  if (view.someProp("handleDrop", function (f) { return f(view, e, slice || Slice.empty, move); })) {
    e.preventDefault();
    return
  }
  if (!slice) { return }

  e.preventDefault();
  var insertPos = slice ? dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) { insertPos = $mouse.pos; }

  var tr = view.state.tr;
  if (move) { tr.deleteSelection(); }

  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode)
    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
  else
    { tr.replaceRange(pos, pos, slice); }
  if (tr.doc.eq(beforeInsert)) { return }

  var $pos = tr.doc.resolve(pos);
  if (isNode && index_es_NodeSelection.isSelectable(slice.content.firstChild) &&
      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) {
    tr.setSelection(new index_es_NodeSelection($pos));
  } else {
    var end = tr.mapping.map(insertPos);
    tr.mapping.maps[tr.mapping.maps.length - 1].forEach(function (_from, _to, _newFrom, newTo) { return end = newTo; });
    tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end)));
  }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};

handlers.focus = function (view) {
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(function () {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.root.getSelection()))
        { selectionToDOM(view); }
    }, 20);
  }
};

handlers.blur = function (view, e) {
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    if (e.relatedTarget && view.dom.contains(e.relatedTarget))
      { view.domObserver.currentSelection.set({}); }
    view.focused = false;
  }
};

handlers.beforeinput = function (view, event) {
  // We should probably do more with beforeinput events, but support
  // is so spotty that I'm still waiting to see where they are going.

  // Very specific hack to deal with backspace sometimes failing on
  // Chrome Android when after an uneditable node.
  if (index_es_result.chrome && index_es_result.android && event.inputType == "deleteContentBackward") {
    view.domObserver.flushSoon();
    var domChangeCount = view.domChangeCount;
    setTimeout(function () {
      if (view.domChangeCount != domChangeCount) { return } // Event already had some effect
      // This bug tends to close the virtual keyboard, so we refocus
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) { return }
      var ref = view.state.selection;
      var $cursor = ref.$cursor;
      // Crude approximation of backspace behavior when no command handled it
      if ($cursor && $cursor.pos > 0) { view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView()); }
    }, 50);
  }
};

// Make sure all handlers get registered
for (var index_es_prop in editHandlers) { handlers[index_es_prop] = editHandlers[index_es_prop]; }

function compareObjs(a, b) {
  if (a == b) { return true }
  for (var p in a) { if (a[p] !== b[p]) { return false } }
  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  return true
}

var WidgetType = function WidgetType(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};

WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    var pos = ref.pos;
    var deleted = ref.deleted;
  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
};

WidgetType.prototype.valid = function valid () { return true };

WidgetType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof WidgetType &&
     (this.spec.key && this.spec.key == other.spec.key ||
      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
};

WidgetType.prototype.destroy = function destroy (node) {
  if (this.spec.destroy) { this.spec.destroy(node); }
};

var InlineType = function InlineType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
  return from >= to ? null : new Decoration(from, to, this)
};

InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };

InlineType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

InlineType.is = function is (span) { return span.type instanceof InlineType };

var index_es_NodeType = function NodeType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

index_es_NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.mapResult(span.from + oldOffset, 1);
  if (from.deleted) { return null }
  var to = mapping.mapResult(span.to + oldOffset, -1);
  if (to.deleted || to.pos <= from.pos) { return null }
  return new Decoration(from.pos - offset, to.pos - offset, this)
};

index_es_NodeType.prototype.valid = function valid (node, span) {
  var ref = node.content.findIndex(span.from);
    var index = ref.index;
    var offset = ref.offset;
    var child;
  return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to
};

index_es_NodeType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof index_es_NodeType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

// ::- Decoration objects can be provided to the view through the
// [`decorations` prop](#view.EditorProps.decorations). They come in
// several variants—see the static members of this class for details.
var Decoration = function Decoration(from, to, type) {
  // :: number
  // The start position of the decoration.
  this.from = from;
  // :: number
  // The end position. Will be the same as `from` for [widget
  // decorations](#view.Decoration^widget).
  this.to = to;
  this.type = type;
};

var prosemirror_view_dist_index_es_prototypeAccessors$1 = { spec: { configurable: true },inline: { configurable: true } };

Decoration.prototype.copy = function copy (from, to) {
  return new Decoration(from, to, this.type)
};

Decoration.prototype.eq = function eq (other, offset) {
    if ( offset === void 0 ) offset = 0;

  return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to
};

Decoration.prototype.map = function map (mapping, offset, oldOffset) {
  return this.type.map(mapping, this, offset, oldOffset)
};

// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
// Creates a widget decoration, which is a DOM node that's shown in
// the document at the given position. It is recommended that you
// delay rendering the widget by passing a function that will be
// called when the widget is actually drawn in a view, but you can
// also directly pass a DOM node. `getPos` can be used to find the
// widget's current document position.
//
// spec::- These options are supported:
//
//   side:: ?number
//   Controls which side of the document position this widget is
//   associated with. When negative, it is drawn before a cursor
//   at its position, and content inserted at that position ends
//   up after the widget. When zero (the default) or positive, the
//   widget is drawn after the cursor and content inserted there
//   ends up before the widget.
//
//   When there are multiple widgets at a given position, their
//   `side` values determine the order in which they appear. Those
//   with lower values appear first. The ordering of widgets with
//   the same `side` value is unspecified.
//
//   When `marks` is null, `side` also determines the marks that
//   the widget is wrapped in—those of the node before when
//   negative, those of the node after when positive.
//
//   marks:: ?[Mark]
//   The precise set of marks to draw around the widget.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to control which DOM events, when they bubble out
//   of this widget, the editor view should ignore.
//
//   ignoreSelection:: ?bool
//   When set (defaults to false), selection changes inside the
//   widget are ignored, and don't cause ProseMirror to try and
//   re-sync the selection with its selection state.
//
//   key:: ?string
//   When comparing decorations of this type (in order to decide
//   whether it needs to be redrawn), ProseMirror will by default
//   compare the widget DOM node by identity. If you pass a key,
//   that key will be compared instead, which can be useful when
//   you generate decorations on the fly and don't want to store
//   and reuse DOM nodes. Make sure that any widgets with the same
//   key are interchangeable—if widgets differ in, for example,
//   the behavior of some event handler, they should get
//   different keys.
//
//   destroy:: ?(node: dom.Node)
//   Called when the widget decoration is removed as a result of
//   mapping
Decoration.widget = function widget (pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates an inline decoration, which adds the given attributes to
// each inline node between `from` and `to`.
//
// spec::- These options are recognized:
//
//   inclusiveStart:: ?bool
//   Determines how the left side of the decoration is
//   [mapped](#transform.Position_Mapping) when content is
//   inserted directly at that position. By default, the decoration
//   won't include the new content, but you can set this to `true`
//   to make it inclusive.
//
//   inclusiveEnd:: ?bool
//   Determines how the right side of the decoration is mapped.
//   See
//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
Decoration.inline = function inline (from, to, attrs, spec) {
  return new Decoration(from, to, new InlineType(attrs, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates a node decoration. `from` and `to` should point precisely
// before and after a node in the document. That node, and only that
// node, will receive the given attributes.
//
// spec::-
//
// Optional information to store with the decoration. It
// is also used when comparing decorators for equality.
Decoration.node = function node (from, to, attrs, spec) {
  return new Decoration(from, to, new index_es_NodeType(attrs, spec))
};

// :: Object
// The spec provided when creating this decoration. Can be useful
// if you've stored extra information in that object.
prosemirror_view_dist_index_es_prototypeAccessors$1.spec.get = function () { return this.type.spec };

prosemirror_view_dist_index_es_prototypeAccessors$1.inline.get = function () { return this.type instanceof InlineType };

Object.defineProperties( Decoration.prototype, prosemirror_view_dist_index_es_prototypeAccessors$1 );

// DecorationAttrs:: interface
// A set of attributes to add to a decorated node. Most properties
// simply directly correspond to DOM attributes of the same name,
// which will be set to the property's value. These are exceptions:
//
//   class:: ?string
//   A CSS class name or a space-separated set of class names to be
//   _added_ to the classes that the node already had.
//
//   style:: ?string
//   A string of CSS to be _added_ to the node's existing `style` property.
//
//   nodeName:: ?string
//   When non-null, the target node is wrapped in a DOM element of
//   this type (and the other attributes are applied to this element).

var none = [], noSpec = {};

// :: class extends DecorationSource
// A collection of [decorations](#view.Decoration), organized in
// such a way that the drawing algorithm can efficiently use and
// compare them. This is a persistent data structure—it is not
// modified, updates create a new value.
var DecorationSet = function DecorationSet(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};

// :: (Node, [Decoration]) → DecorationSet
// Create a set of decorations, using the structure of the given
// document.
DecorationSet.create = function create (doc, decorations) {
  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : index_es_empty
};

// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
// Find all decorations in this set which touch the given range
// (including decorations that start or end directly at the
// boundaries) and match the given predicate on their spec. When
// `start` and `end` are omitted, all decorations in the set are
// considered. When `predicate` isn't given, all decorations are
// assumed to match.
DecorationSet.prototype.find = function find (start, end, predicate) {
  var result = [];
  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
  return result
};

DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
  for (var i = 0; i < this.local.length; i++) {
    var span = this.local[i];
    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
      { result.push(span.copy(span.from + offset, span.to + offset)); }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this.children[i$1] < end && this.children[i$1 + 1] > start) {
      var childOff = this.children[i$1] + 1;
      this.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
    }
  }
};

// :: (Mapping, Node, ?Object) → DecorationSet
// Map the set of decorations in response to a change in the
// document.
//
// options::- An optional set of options.
//
//   onRemove:: ?(decorationSpec: Object)
//   When given, this function will be called for each decoration
//   that gets dropped as a result of the mapping, passing the
//   spec of that decoration.
DecorationSet.prototype.map = function map (mapping, doc, options) {
  if (this == index_es_empty || mapping.maps.length == 0) { return this }
  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
};

DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
  var newLocal;
  for (var i = 0; i < this.local.length; i++) {
    var mapped = this.local[i].map(mapping, offset, oldOffset);
    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
    else if (options.onRemove) { options.onRemove(this.local[i].spec); }
  }

  if (this.children.length)
    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
  else
    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : index_es_empty }
};

// :: (Node, [Decoration]) → DecorationSet
// Add the given array of decorations to the ones in the set,
// producing a new set. Needs access to the current document to
// create the appropriate tree structure.
DecorationSet.prototype.add = function add (doc, decorations) {
  if (!decorations.length) { return this }
  if (this == index_es_empty) { return DecorationSet.create(doc, decorations) }
  return this.addInner(doc, decorations, 0)
};

DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
    var this$1 = this;

  var children, childIndex = 0;
  doc.forEach(function (childNode, childOffset) {
    var baseOffset = childOffset + offset, found;
    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }

    if (!children) { children = this$1.children.slice(); }
    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
    if (children[childIndex] == childOffset)
      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
    else
      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
    childIndex += 3;
  });

  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
  for (var i = 0; i < local.length; i++) { if (!local[i].type.valid(doc, local[i])) { local.splice(i--, 1); } }

  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
                           children || this.children)
};

// :: ([Decoration]) → DecorationSet
// Create a new set that contains the decorations in this set, minus
// the ones in the given array.
DecorationSet.prototype.remove = function remove (decorations) {
  if (decorations.length == 0 || this == index_es_empty) { return this }
  return this.removeInner(decorations, 0)
};

DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
  var children = this.children, local = this.local;
  for (var i = 0; i < children.length; i += 3) {
    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
      if (span.from > from && span.to < to) {
        decorations[j] = null
        ;(found || (found = [])).push(span);
      }
    } }
    if (!found) { continue }
    if (children == this.children) { children = this.children.slice(); }
    var removed = children[i + 2].removeInner(found, from + 1);
    if (removed != index_es_empty) {
      children[i + 2] = removed;
    } else {
      children.splice(i, 3);
      i -= 3;
    }
  }
  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].eq(span$1, offset)) {
      if (local == this.local) { local = this.local.slice(); }
      local.splice(j$1--, 1);
    } }
  } } }
  if (children == this.children && local == this.local) { return this }
  return local.length || children.length ? new DecorationSet(local, children) : index_es_empty
};

DecorationSet.prototype.forChild = function forChild (offset, node) {
  if (this == index_es_empty) { return this }
  if (node.isLeaf) { return DecorationSet.empty }

  var child, local;
  for (var i = 0; i < this.children.length; i += 3) { if (this.children[i] >= offset) {
    if (this.children[i] == offset) { child = this.children[i + 2]; }
    break
  } }
  var start = offset + 1, end = start + node.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this.local[i$1];
    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child ? new DecorationGroup([localSet, child]) : localSet
  }
  return child || index_es_empty
};

DecorationSet.prototype.eq = function eq (other) {
  if (this == other) { return true }
  if (!(other instanceof DecorationSet) ||
      this.local.length != other.local.length ||
      this.children.length != other.children.length) { return false }
  for (var i = 0; i < this.local.length; i++)
    { if (!this.local[i].eq(other.local[i])) { return false } }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
    { if (this.children[i$1] != other.children[i$1] ||
        this.children[i$1 + 1] != other.children[i$1 + 1] ||
        !this.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
  return true
};

DecorationSet.prototype.locals = function locals (node) {
  return removeOverlap(this.localsInner(node))
};

DecorationSet.prototype.localsInner = function localsInner (node) {
  if (this == index_es_empty) { return none }
  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
  var result = [];
  for (var i = 0; i < this.local.length; i++) {
    if (!(this.local[i].type instanceof InlineType))
      { result.push(this.local[i]); }
  }
  return result
};

// DecorationSource:: interface
// An object that can [provide](#view.EditorProps.decorations)
// decorations. Implemented by [`DecorationSet`](#view.DecorationSet),
// and passed to [node views](#view.EditorProps.nodeViews).
//
//   map:: (Mapping, Node) → DecorationSource
//   Map the set of decorations in response to a change in the
//   document.

var index_es_empty = new DecorationSet();

// :: DecorationSet
// The empty set of decorations.
DecorationSet.empty = index_es_empty;

DecorationSet.removeOverlap = removeOverlap;

// :- An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
var DecorationGroup = function DecorationGroup(members) {
  this.members = members;
};

DecorationGroup.prototype.map = function map (mapping, doc) {
  var mappedDecos = this.members.map(
    function (member) { return member.map(mapping, doc, noSpec); }
  );
  return DecorationGroup.from(mappedDecos)
};

DecorationGroup.prototype.forChild = function forChild (offset, child) {
  if (child.isLeaf) { return DecorationSet.empty }
  var found = [];
  for (var i = 0; i < this.members.length; i++) {
    var result = this.members[i].forChild(offset, child);
    if (result == index_es_empty) { continue }
    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
    else { found.push(result); }
  }
  return DecorationGroup.from(found)
};

DecorationGroup.prototype.eq = function eq (other) {
  if (!(other instanceof DecorationGroup) ||
      other.members.length != this.members.length) { return false }
  for (var i = 0; i < this.members.length; i++)
    { if (!this.members[i].eq(other.members[i])) { return false } }
  return true
};

DecorationGroup.prototype.locals = function locals (node) {
  var result, sorted = true;
  for (var i = 0; i < this.members.length; i++) {
    var locals = this.members[i].localsInner(node);
    if (!locals.length) { continue }
    if (!result) {
      result = locals;
    } else {
      if (sorted) {
        result = result.slice();
        sorted = false;
      }
      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
    }
  }
  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
};

// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
// Create a group for the given array of decoration sets, or return
// a single set when possible.
DecorationGroup.from = function from (members) {
  switch (members.length) {
    case 0: return index_es_empty
    case 1: return members[0]
    default: return new DecorationGroup(members)
  }
};

function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();

  // Mark the children that are directly touched by changes, and
  // move those that are after the changes.
  var shift = function (oldStart, oldEnd, newStart, newEnd) {
    for (var i = 0; i < children.length; i += 3) {
      var end = children[i + 1], dSize = (void 0);
      if (end < 0 || oldStart > end + oldOffset) { continue }
      var start = children[i] + oldOffset;
      if (oldEnd >= start) {
        children[i + 1] = oldStart <= start ? -2 : -1;
      } else if (newStart >= offset && (dSize = (newEnd - newStart) - (oldEnd - oldStart))) {
        children[i] += dSize;
        children[i + 1] += dSize;
      }
    }
  };
  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }

  // Find the child nodes that still correspond to a single node,
  // recursively call mapInner on them and update their positions.
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] < 0) { // Touched nodes
    if (children[i$1 + 1] == -2) {
      mustRebuild = true;
      children[i$1 + 1] = -1;
      continue
    }
    var from = mapping.map(oldChildren[i$1] + oldOffset), fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue
    }
    // Must read oldChildren because children was tagged with -1
    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
    var ref = node.content.findIndex(fromLocal);
    var index = ref.index;
    var childOffset = ref.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, oldChildren[i$1] + oldOffset + 1, options);
      if (mapped != index_es_empty) {
        children[i$1] = fromLocal;
        children[i$1 + 1] = toLocal;
        children[i$1 + 2] = mapped;
      } else {
        children[i$1 + 1] = -2;
        mustRebuild = true;
      }
    } else {
      mustRebuild = true;
    }
  } }

  // Remaining children must be collected and rebuilt into the appropriate structure
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping,
                                                       offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] < 0) {
      children.splice(i$2, 3);
      i$2 -= 3;
    } }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) { j += 3; }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }

  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
}

function moveSpans(spans, offset) {
  if (!offset || !spans.length) { return spans }
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result
}

function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
  // Gather all decorations from the remaining marked children
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) { decorations.push(mapped); }
      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
    }
    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
  }
  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
    { gather(children[i + 2], oldChildren[i] + oldOffset + 1); } }

  return decorations
}

function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) { return null }
  var end = offset + node.nodeSize, found = null;
  for (var i = 0, span = (void 0); i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
(found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found
}

function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++)
    { if (array[i] != null) { result.push(array[i]); } }
  return result
}

// : ([Decoration], Node, number) → DecorationSet
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
  var children = [], hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != index_es_empty)
        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) { options.onRemove(locals[i].spec); }
    locals.splice(i--, 1);
  } }
  return locals.length || children.length ? new DecorationSet(locals, children) : index_es_empty
}

// : (Decoration, Decoration) → number
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
  return a.from - b.from || a.to - b.to
}

// : ([Decoration]) → [Decoration]
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) { working = spans.slice(); }
          // Followed by a partially overlapping larger span. Split that
          // span.
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue
      } else {
        if (next.from < span.to) {
          if (working == spans) { working = spans.slice(); }
          // The end of this one overlaps with a subsequent span. Split
          // this one.
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break
      }
    } }
  }
  return working
}

function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
  array.splice(i, 0, deco);
}

// : (EditorView) → union<DecorationSet, DecorationGroup>
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != index_es_empty) { found.push(result); }
  });
  if (view.cursorWrapper)
    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
  return DecorationGroup.from(found)
}

// ::- An editor view manages the DOM structure that represents an
// editable document. Its state and behavior are determined by its
// [props](#view.DirectEditorProps).
var EditorView = function EditorView(place, props) {
  this._props = props;
  // :: EditorState
  // The view's current [state](#state.EditorState).
  this.state = props.state;

  this.directPlugins = props.plugins || [];
  this.directPlugins.forEach(checkStateComponent);

  this.dispatch = this.dispatch.bind(this);

  this._root = null;
  this.focused = false;
  // Kludge used to work around a Chrome bug
  this.trackWrites = null;

  // :: dom.Element
  // An editable DOM node containing the document. (You probably
  // should not directly interfere with its content.)
  this.dom = (place && place.mount) || document.createElement("div");
  if (place) {
    if (place.appendChild) { place.appendChild(this.dom); }
    else if (place.apply) { place(this.dom); }
    else if (place.mount) { this.mounted = true; }
  }

  // :: bool
  // Indicates whether the editor is currently [editable](#view.EditorProps.editable).
  this.editable = getEditable(this);
  this.markCursor = null;
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.nodeViews = buildNodeViews(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);

  this.lastSelectedViewDesc = null;
  // :: ?{slice: Slice, move: bool}
  // When editor content is being dragged, this object contains
  // information about the dragged slice and whether it is being
  // copied or moved. At any other time, it is null.
  this.dragging = null;

  initInput(this);

  this.prevDirectPlugins = [];
  this.pluginViews = [];
  this.updatePluginViews();
};

var index_es_prototypeAccessors$2 = { props: { configurable: true },root: { configurable: true },isDestroyed: { configurable: true } };

// composing:: boolean
// Holds `true` when a
// [composition](https://developer.mozilla.org/en-US/docs/Mozilla/IME_handling_guide)
// is active.

// :: DirectEditorProps
// The view's current [props](#view.EditorProps).
index_es_prototypeAccessors$2.props.get = function () {
  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) { this._props[name] = prev[name]; }
    this._props.state = this.state;
  }
  return this._props
};

// :: (DirectEditorProps)
// Update the view's props. Will immediately cause an update to
// the DOM.
EditorView.prototype.update = function update (props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
  this._props = props;
  if (props.plugins) {
    props.plugins.forEach(checkStateComponent);
    this.directPlugins = props.plugins;
  }
  this.updateStateInner(props.state, true);
};

// :: (DirectEditorProps)
// Update the view by updating existing props object with the object
// given as argument. Equivalent to `view.update(Object.assign({},
// view.props, props))`.
EditorView.prototype.setProps = function setProps (props) {
  var updated = {};
  for (var name in this._props) { updated[name] = this._props[name]; }
  updated.state = this.state;
  for (var name$1 in props) { updated[name$1] = props[name$1]; }
  this.update(updated);
};

// :: (EditorState)
// Update the editor's `state` prop, without touching any of the
// other props.
EditorView.prototype.updateState = function updateState (state) {
  this.updateStateInner(state, this.state.plugins != state.plugins);
};

EditorView.prototype.updateStateInner = function updateStateInner (state, reconfigured) {
    var this$1 = this;

  var prev = this.state, redraw = false, updateSel = false;
  // When stored marks are added, stop composition, so that they can
  // be displayed.
  if (state.storedMarks && this.composing) {
    clearComposition(this);
    updateSel = true;
  }
  this.state = state;
  if (reconfigured) {
    var nodeViews = buildNodeViews(this);
    if (changedNodeViews(nodeViews, this.nodeViews)) {
      this.nodeViews = nodeViews;
      redraw = true;
    }
    ensureListeners(this);
  }

  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);

  var scroll = reconfigured ? "reset"
      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  if (updateDoc || !state.selection.eq(prev.selection)) { updateSel = true; }
  var oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);

  if (updateSel) {
    this.domObserver.stop();
    // Work around an issue in Chrome, IE, and Edge where changing
    // the DOM around an active selection puts it into a broken
    // state where the thing the user sees differs from the
    // selection reported by the Selection object (#710, #973,
    // #1011, #1013, #1035).
    var forceSelUpdate = updateDoc && (index_es_result.ie || index_es_result.chrome) && !this.composing &&
        !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
    if (updateDoc) {
      // If the node that the selection points into is written to,
      // Chrome sometimes starts misreporting the selection, so this
      // tracks that and forces a selection reset when our update
      // did write to the node.
      var chromeKludge = index_es_result.chrome ? (this.trackWrites = this.root.getSelection().focusNode) : null;
      if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.updateOuterDeco([]);
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
      }
      if (chromeKludge && !this.trackWrites) { forceSelUpdate = true; }
    }
    // Work around for an issue where an update arriving right between
    // a DOM selection change and the "selectionchange" event for it
    // can cause a spurious DOM selection update, disrupting mouse
    // drag selection.
    if (forceSelUpdate ||
        !(this.mouseDown && this.domObserver.currentSelection.eq(this.root.getSelection()) && anchorInRightPlace(this))) {
      selectionToDOM(this, forceSelUpdate);
    } else {
      syncNodeSelection(this, state.selection);
      this.domObserver.setCurSelection();
    }
    this.domObserver.start();
  }

  this.updatePluginViews(prev);

  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    var startDOM = this.root.getSelection().focusNode;
    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
      ; // Handled
    else if (state.selection instanceof index_es_NodeSelection)
      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM); }
    else
      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head, 1), startDOM); }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};

EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
  var view;
  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
};

EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
  if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
    this.prevDirectPlugins = this.directPlugins;
    this.destroyPluginViews();
    for (var i = 0; i < this.directPlugins.length; i++) {
      var plugin = this.directPlugins[i];
      if (plugin.spec.view) { this.pluginViews.push(plugin.spec.view(this)); }
    }
    for (var i$1 = 0; i$1 < this.state.plugins.length; i$1++) {
      var plugin$1 = this.state.plugins[i$1];
      if (plugin$1.spec.view) { this.pluginViews.push(plugin$1.spec.view(this)); }
    }
  } else {
    for (var i$2 = 0; i$2 < this.pluginViews.length; i$2++) {
      var pluginView = this.pluginViews[i$2];
      if (pluginView.update) { pluginView.update(this, prevState); }
    }
  }
};

// :: (string, ?(prop: *) → *) → *
// Goes over the values of a prop, first those provided directly,
// then those from plugins given to the view, then from plugins in
// the state (in order), and calls `f` every time a non-undefined
// value is found. When `f` returns a truthy value, that is
// immediately returned. When `f` isn't provided, it is treated as
// the identity function (the prop value is returned directly).
EditorView.prototype.someProp = function someProp (propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) { return value }
  for (var i = 0; i < this.directPlugins.length; i++) {
    var prop$1 = this.directPlugins[i].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
  }
  var plugins = this.state.plugins;
  if (plugins) { for (var i$1 = 0; i$1 < plugins.length; i$1++) {
    var prop$2 = plugins[i$1].props[propName];
    if (prop$2 != null && (value = f ? f(prop$2) : prop$2)) { return value }
  } }
};

// :: () → bool
// Query whether the view has focus.
EditorView.prototype.hasFocus = function hasFocus () {
  return this.root.activeElement == this.dom
};

// :: ()
// Focus the editor.
EditorView.prototype.focus = function focus () {
  this.domObserver.stop();
  if (this.editable) { focusPreventScroll(this.dom); }
  selectionToDOM(this);
  this.domObserver.start();
};

// :: union<dom.Document, dom.DocumentFragment>
// Get the document root in which the editor exists. This will
// usually be the top-level `document`, but might be a [shadow
// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
// root if the editor is inside one.
index_es_prototypeAccessors$2.root.get = function () {
  var cached = this._root;
  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
    if (search.nodeType == 9 || (search.nodeType == 11 && search.host)) {
      if (!search.getSelection) { Object.getPrototypeOf(search).getSelection = function () { return document.getSelection(); }; }
      return this._root = search
    }
  } }
  return cached || document
};

// :: ({left: number, top: number}) → ?{pos: number, inside: number}
// Given a pair of viewport coordinates, return the document
// position that corresponds to them. May return null if the given
// coordinates aren't inside of the editor. When an object is
// returned, its `pos` property is the position nearest to the
// coordinates, and its `inside` property holds the position of the
// inner node that the position falls inside of, or -1 if it is at
// the top level, not in any node.
EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
  return posAtCoords(this, coords)
};

// :: (number, number) → {left: number, right: number, top: number, bottom: number}
// Returns the viewport rectangle at a given document position.
// `left` and `right` will be the same number, as this returns a
// flat cursor-ish rectangle. If the position is between two things
// that aren't directly adjacent, `side` determines which element is
// used. When < 0, the element before the position is used,
// otherwise the element after.
EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos, side) {
    if ( side === void 0 ) side = 1;

  return coordsAtPos(this, pos, side)
};

// :: (number, number) → {node: dom.Node, offset: number}
// Find the DOM position that corresponds to the given document
// position. When `side` is negative, find the position as close as
// possible to the content before the position. When positive,
// prefer positions close to the content after the position. When
// zero, prefer as shallow a position as possible.
//
// Note that you should **not** mutate the editor's internal DOM,
// only inspect it (and even that is usually not necessary).
EditorView.prototype.domAtPos = function domAtPos (pos, side) {
    if ( side === void 0 ) side = 0;

  return this.docView.domFromPos(pos, side)
};

// :: (number) → ?dom.Node
// Find the DOM node that represents the document node after the
// given position. May return `null` when the position doesn't point
// in front of a node or if the node is inside an opaque node view.
//
// This is intended to be able to call things like
// `getBoundingClientRect` on that DOM node. Do **not** mutate the
// editor DOM directly, or add styling this way, since that will be
// immediately overriden by the editor as it redraws the node.
EditorView.prototype.nodeDOM = function nodeDOM (pos) {
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null
};

// :: (dom.Node, number, ?number) → number
// Find the document position that corresponds to a given DOM
// position. (Whenever possible, it is preferable to inspect the
// document structure directly, rather than poking around in the
// DOM, but sometimes—for example when interpreting an event
// target—you don't have a choice.)
//
// The `bias` parameter can be used to influence which side of a DOM
// node to use when the position is inside a leaf node.
EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
    if ( bias === void 0 ) bias = -1;

  var pos = this.docView.posFromDOM(node, offset, bias);
  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
  return pos
};

// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
// Find out whether the selection is at the end of a textblock when
// moving in a given direction. When, for example, given `"left"`,
// it will return true if moving left from the current cursor
// position would leave that position's parent textblock. Will apply
// to the view's current state by default, but it is possible to
// pass a different state.
EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
  return endOfTextblock(this, state || this.state, dir)
};

// :: ()
// Removes the editor from the DOM and destroys all [node
// views](#view.NodeView).
EditorView.prototype.destroy = function destroy () {
  if (!this.docView) { return }
  destroyInput(this);
  this.destroyPluginViews();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};

// :: boolean
// This is true when the view has been
// [destroyed](#view.EditorView.destroy) (and thus should not be
// used anymore).
index_es_prototypeAccessors$2.isDestroyed.get = function () {
  return this.docView == null
};

// Used for testing.
EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
  return dispatchEvent(this, event)
};

// :: (Transaction)
// Dispatch a transaction. Will call
// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
// when given, and otherwise defaults to applying the transaction to
// the current state and calling
// [`updateState`](#view.EditorView.updateState) with the result.
// This method is bound to the view instance, so that it can be
// easily passed around.
EditorView.prototype.dispatch = function dispatch (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) { dispatchTransaction.call(this, tr); }
  else { this.updateState(this.state.apply(tr)); }
};

Object.defineProperties( EditorView.prototype, index_es_prototypeAccessors$2 );

function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);
  attrs.translate = "no";

  view.someProp("attributes", function (value) {
    if (typeof value == "function") { value = value(view.state); }
    if (value) { for (var attr in value) {
      if (attr == "class")
        { attrs.class += " " + value[attr]; }
      if (attr == "style") {
        attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
      }
      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
        { attrs[attr] = String(value[attr]); }
    } }
  });

  return [Decoration.node(0, view.state.doc.content.size, attrs)]
}

function updateCursorWrapper(view) {
  if (view.markCursor) {
    var dom = document.createElement("img");
    dom.className = "ProseMirror-separator";
    dom.setAttribute("mark-placeholder", "true");
    dom.setAttribute("alt", "");
    view.cursorWrapper = {dom: dom, deco: Decoration.widget(view.state.selection.head, dom, {raw: true, marks: view.markCursor})};
  } else {
    view.cursorWrapper = null;
  }
}

function getEditable(view) {
  return !view.someProp("editable", function (value) { return value(view.state) === false; })
}

function selectionContextChanged(sel1, sel2) {
  var depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth)
}

function buildNodeViews(view) {
  var result = {};
  view.someProp("nodeViews", function (obj) {
    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result, prop))
      { result[prop] = obj[prop]; } }
  });
  return result
}

function changedNodeViews(a, b) {
  var nA = 0, nB = 0;
  for (var prop in a) {
    if (a[prop] != b[prop]) { return true }
    nA++;
  }
  for (var _ in b) { nB++; }
  return nA != nB
}

function checkStateComponent(plugin) {
  if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction)
    { throw new RangeError("Plugins passed directly to the view must not have a state component") }
}

// EditorProps:: interface
//
// Props are configuration values that can be passed to an editor view
// or included in a plugin. This interface lists the supported props.
//
// The various event-handling functions may all return `true` to
// indicate that they handled the given event. The view will then take
// care to call `preventDefault` on the event, except with
// `handleDOMEvents`, where the handler itself is responsible for that.
//
// How a prop is resolved depends on the prop. Handler functions are
// called one at a time, starting with the base props and then
// searching through the plugins (in order of appearance) until one of
// them returns true. For some props, the first plugin that yields a
// value gets precedence.
//
//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
//   Can be an object mapping DOM event type names to functions that
//   handle them. Such functions will be called before any handling
//   ProseMirror does of events fired on the editable DOM element.
//   Contrary to the other event handling props, when returning true
//   from such a function, you are responsible for calling
//   `preventDefault` yourself (or not, if you want to allow the
//   default behavior).
//
//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Called when the editor receives a `keydown` event.
//
//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Handler for `keypress` events.
//
//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
//   Whenever the user directly input text, this handler is called
//   before the input is applied. If it returns `true`, the default
//   behavior of actually inserting the text is suppressed.
//
//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a click, from the inside out. The
//   `direct` flag will be true for the inner node.
//
//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is clicked, after `handleClickOn` handlers
//   have been called.
//
//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a double click.
//
//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
//
//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a triple click.
//
//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
//
//   handlePaste:: ?(view: EditorView, event: dom.ClipboardEvent, slice: Slice) → bool
//   Can be used to override the behavior of pasting. `slice` is the
//   pasted content parsed by the editor, but you can directly access
//   the event to get at the raw content.
//
//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
//   Called when something is dropped on the editor. `moved` will be
//   true if this drop moves from the current selection (which should
//   thus be deleted).
//
//   handleScrollToSelection:: ?(view: EditorView) → bool
//   Called when the view, after updating its state, tries to scroll
//   the selection into view. A handler function may return false to
//   indicate that it did not handle the scrolling and further
//   handlers or the default behavior should be tried.
//
//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
//   Can be used to override the way a selection is created when
//   reading a DOM selection between the given anchor and head.
//
//   domParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading editor changes
//   from the DOM. Defaults to calling
//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
//   editor's schema.
//
//   transformPastedHTML:: ?(html: string) → string
//   Can be used to transform pasted HTML text, _before_ it is parsed,
//   for example to clean it up.
//
//   clipboardParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading content from
//   the clipboard. When not given, the value of the
//   [`domParser`](#view.EditorProps.domParser) prop is used.
//
//   transformPastedText:: ?(text: string, plain: bool) → string
//   Transform pasted plain text. The `plain` flag will be true when
//   the text is pasted as plain text.
//
//   clipboardTextParser:: ?(text: string, $context: ResolvedPos, plain: bool) → Slice
//   A function to parse text from the clipboard into a document
//   slice. Called after
//   [`transformPastedText`](#view.EditorProps.transformPastedText).
//   The default behavior is to split the text into lines, wrap them
//   in `<p>` tags, and call
//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
//   The `plain` flag will be true when the text is pasted as plain text.
//
//   transformPasted:: ?(Slice) → Slice
//   Can be used to transform pasted content before it is applied to
//   the document.
//
//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration], innerDecorations: DecorationSource) → NodeView>
//   Allows you to pass custom rendering and behavior logic for nodes
//   and marks. Should map node and mark names to constructor
//   functions that produce a [`NodeView`](#view.NodeView) object
//   implementing the node's display behavior. For nodes, the third
//   argument `getPos` is a function that can be called to get the
//   node's current position, which can be useful when creating
//   transactions to update it. For marks, the third argument is a
//   boolean that indicates whether the mark's content is inline.
//
//   `decorations` is an array of node or inline decorations that are
//   active around the node. They are automatically drawn in the
//   normal way, and you will usually just want to ignore this, but
//   they can also be used as a way to provide context information to
//   the node view without adding it to the document itself.
//
//   `innerDecorations` holds the decorations for the node's content.
//   You can safely ignore this if your view has no content or a
//   `contentDOM` property, since the editor will draw the decorations
//   on the content. But if you, for example, want to create a nested
//   editor with the content, it may make sense to provide it with the
//   inner decorations.
//
//   clipboardSerializer:: ?DOMSerializer
//   The DOM serializer to use when putting content onto the
//   clipboard. If not given, the result of
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
//   will be used. This object will only have its
//   [`serializeFragment`](#model.DOMSerializer.serializeFragment)
//   method called, and you may provide an alternative object type
//   implementing a compatible method.
//
//   clipboardTextSerializer:: ?(Slice) → string
//   A function that will be called to get the text for the current
//   selection when copying text to the clipboard. By default, the
//   editor will use [`textBetween`](#model.Node.textBetween) on the
//   selected range.
//
//   decorations:: ?(state: EditorState) → ?DecorationSource
//   A set of [document decorations](#view.Decoration) to show in the
//   view.
//
//   editable:: ?(state: EditorState) → bool
//   When this returns false, the content of the view is not directly
//   editable.
//
//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
//   Control the DOM attributes of the editable element. May be either
//   an object or a function going from an editor state to an object.
//   By default, the element will get a class `"ProseMirror"`, and
//   will have its `contentEditable` attribute determined by the
//   [`editable` prop](#view.EditorProps.editable). Additional classes
//   provided here will be added to the class. For other attributes,
//   the value provided first (as in
//   [`someProp`](#view.EditorView.someProp)) will be used.
//
//   scrollThreshold:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the distance (in pixels) between the cursor and the
//   end of the visible viewport at which point, when scrolling the
//   cursor into view, scrolling takes place. Defaults to 0.
//
//   scrollMargin:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the extra space (in pixels) that is left above or
//   below the cursor when it is scrolled into view. Defaults to 5.

// DirectEditorProps:: interface extends EditorProps
//
// The props object given directly to the editor view supports two
// fields that can't be used in plugins:
//
//   state:: EditorState
//   The current state of the editor.
//
//   plugins:: [Plugin]
//   A set of plugins to use in the view, applying their [plugin
//   view](#state.PluginSpec.view) and
//   [props](#state.PluginSpec.props). Passing plugins with a state
//   component (a [state field](#state.PluginSpec.state) field or a
//   [transaction](#state.PluginSpec.filterTransaction) filter or
//   appender) will result in an error, since such plugins must be
//   present in the state to work.
//
//   dispatchTransaction:: ?(tr: Transaction)
//   The callback over which to send transactions (state updates)
//   produced by the view. If you specify this, you probably want to
//   make sure this ends up calling the view's
//   [`updateState`](#view.EditorView.updateState) method with a new
//   state that has the transaction
//   [applied](#state.EditorState.apply). The callback will be bound to have
//   the view instance as its `this` binding.


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/w3c-keyname/index.es.js
var index_es_base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  229: "q"
}

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\"",
  229: "Q"
}

var index_es_chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent)
var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor)
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent)
var index_es_mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
var index_es_ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent)
var brokenModifierNames = index_es_chrome && (index_es_mac || +index_es_chrome[1] < 57) || gecko && index_es_mac

// Fill in the digit keys
for (var index_es_i = 0; index_es_i < 10; index_es_i++) index_es_base[48 + index_es_i] = index_es_base[96 + index_es_i] = String(index_es_i)

// The function keys
for (var index_es_i = 1; index_es_i <= 24; index_es_i++) index_es_base[index_es_i + 111] = "F" + index_es_i

// And the alphabetic keys
for (var index_es_i = 65; index_es_i <= 90; index_es_i++) {
  index_es_base[index_es_i] = String.fromCharCode(index_es_i + 32)
  shift[index_es_i] = String.fromCharCode(index_es_i)
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in index_es_base) if (!shift.hasOwnProperty(code)) shift[code] = index_es_base[code]

function keyName(event) {
  // Don't trust event.key in Chrome when there are modifiers until
  // they fix https://bugs.chromium.org/p/chromium/issues/detail?id=633838
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
    (safari || index_es_ie) && event.shiftKey && event.key && event.key.length == 1
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : index_es_base)[event.keyCode] ||
    event.key || "Unidentified"
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape"
  if (name == "Del") name = "Delete"
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft"
  if (name == "Up") name = "ArrowUp"
  if (name == "Right") name = "ArrowRight"
  if (name == "Down") name = "ArrowDown"
  return name
}

// CONCATENATED MODULE: ./node_modules/prosemirror-keymap/dist/index.es.js



// declare global: navigator

var dist_index_es_mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space") { result = " "; }
  var alt, ctrl, shift, meta;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { meta = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else if (/^mod$/i.test(mod)) { if (dist_index_es_mac) { meta = true; } else { ctrl = true; } }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { result = "Alt-" + result; }
  if (ctrl) { result = "Ctrl-" + result; }
  if (meta) { result = "Meta-" + result; }
  if (shift) { result = "Shift-" + result; }
  return result
}

function index_es_normalize(map) {
  var copy = Object.create(null);
  for (var prop in map) { copy[normalizeKeyName(prop)] = map[prop]; }
  return copy
}

function index_es_modifiers(name, event, shift) {
  if (event.altKey) { name = "Alt-" + name; }
  if (event.ctrlKey) { name = "Ctrl-" + name; }
  if (event.metaKey) { name = "Meta-" + name; }
  if (shift !== false && event.shiftKey) { name = "Shift-" + name; }
  return name
}

// :: (Object) → Plugin
// Create a keymap plugin for the given set of bindings.
//
// Bindings should map key names to [command](#commands)-style
// functions, which will be called with `(EditorState, dispatch,
// EditorView)` arguments, and should return true when they've handled
// the key. Note that the view argument isn't part of the command
// protocol, but can be used as an escape hatch if a binding needs to
// directly interact with the UI.
//
// Key names may be strings like `"Shift-Ctrl-Enter"`—a key
// identifier prefixed with zero or more modifiers. Key identifiers
// are based on the strings that can appear in
// [`KeyEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
// Use lowercase letters to refer to letter keys (or uppercase letters
// if you want shift to be held). You may use `"Space"` as an alias
// for the `" "` name.
//
// Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
// `a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
// `Meta-`) are recognized. For characters that are created by holding
// shift, the `Shift-` prefix is implied, and should not be added
// explicitly.
//
// You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
// other platforms.
//
// You can add multiple keymap plugins to an editor. The order in
// which they appear determines their precedence (the ones early in
// the array get to dispatch first).
function keymap(bindings) {
  return new Plugin({props: {handleKeyDown: keydownHandler(bindings)}})
}

// :: (Object) → (view: EditorView, event: dom.Event) → bool
// Given a set of bindings (using the same format as
// [`keymap`](#keymap.keymap)), return a [keydown
// handler](#view.EditorProps.handleKeyDown) that handles them.
function keydownHandler(bindings) {
  var map = index_es_normalize(bindings);
  return function(view, event) {
    var name = keyName(event), isChar = name.length == 1 && name != " ", baseName;
    var direct = map[index_es_modifiers(name, event, !isChar)];
    if (direct && direct(view.state, view.dispatch, view)) { return true }
    if (isChar && (event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) &&
        (baseName = index_es_base[event.keyCode]) && baseName != name) {
      // Try falling back to the keyCode when there's a modifier
      // active or the character produced isn't ASCII, and our table
      // produces a different name from the the keyCode. See #668,
      // #1060
      var fromCode = map[index_es_modifiers(baseName, event, true)];
      if (fromCode && fromCode(view.state, view.dispatch, view)) { return true }
    } else if (isChar && event.shiftKey) {
      // Otherwise, if shift is active, also try the binding with the
      // Shift- prefix enabled. See #997
      var withShift = map[index_es_modifiers(name, event, true)];
      if (withShift && withShift(view.state, view.dispatch, view)) { return true }
    }
    return false
  }
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js








// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
    if (getType(value) !== 'Object') {
        return false;
    }
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
    const output = { ...target };
    if (isPlainObject(target) && isPlainObject(source)) {
        Object.keys(source).forEach(key => {
            if (isPlainObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                }
                else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}

function isFunction(value) {
    return typeof value === 'function';
}

/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */
function callOrReturn(value, context = undefined, ...props) {
    if (isFunction(value)) {
        if (context) {
            return value.bind(context)(...props);
        }
        return value(...props);
    }
    return value;
}

function getExtensionField(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) {
        return getExtensionField(extension.parent, field, context);
    }
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent
                ? getExtensionField(extension.parent, field, context)
                : null,
        });
        return value;
    }
    return extension.config[field];
}

class Extension {
    constructor(config = {}) {
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Extension(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.options = mergeDeep(this.options, options);
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Extension(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name
            ? extendedConfig.name
            : extension.parent.name;
        if (extendedConfig.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

function getTextBetween(startNode, range, options) {
    const { from, to } = range;
    const { blockSeparator = '\n\n', textSerializers = {}, } = options || {};
    let text = '';
    let separated = true;
    startNode.nodesBetween(from, to, (node, pos, parent, index) => {
        var _a;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (node.isBlock && !separated) {
                text += blockSeparator;
                separated = true;
            }
            text += textSerializer({
                node,
                pos,
                parent,
                index,
            });
        }
        else if (node.isText) {
            text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos);
            separated = false;
        }
        else if (node.isBlock && !separated) {
            text += blockSeparator;
            separated = true;
        }
    });
    return text;
}

function getTextSeralizersFromSchema(schema) {
    return Object.fromEntries(Object
        .entries(schema.nodes)
        .filter(([, node]) => node.spec.toText)
        .map(([name, node]) => [name, node.spec.toText]));
}

const ClipboardTextSerializer = Extension.create({
    name: 'clipboardTextSerializer',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: () => {
                        const { editor } = this;
                        const { state, schema } = editor;
                        const { doc, selection } = state;
                        const { ranges } = selection;
                        const from = Math.min(...ranges.map(range => range.$from.pos));
                        const to = Math.max(...ranges.map(range => range.$to.pos));
                        const textSerializers = getTextSeralizersFromSchema(schema);
                        const range = { from, to };
                        return getTextBetween(doc, range, {
                            textSerializers,
                        });
                    },
                },
            }),
        ];
    },
});

const tiptap_core_esm_blur = () => ({ editor, view }) => {
    requestAnimationFrame(() => {
        var _a;
        if (!editor.isDestroyed) {
            view.dom.blur();
            // Browsers should remove the caret on blur but safari does not.
            // See: https://github.com/ueberdosis/tiptap/issues/2405
            (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        }
    });
    return true;
};

var blur$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: tiptap_core_esm_blur
});

const clearContent = (emitUpdate = false) => ({ commands }) => {
    return commands.setContent('', emitUpdate);
};

var clearContent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clearContent: clearContent
});

const clearNodes = () => ({ state, tr, dispatch }) => {
    const { selection } = tr;
    const { ranges } = selection;
    if (!dispatch) {
        return true;
    }
    ranges.forEach(({ $from, $to }) => {
        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (node.type.isText) {
                return;
            }
            const { doc, mapping } = tr;
            const $mappedFrom = doc.resolve(mapping.map(pos));
            const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
            const nodeRange = $mappedFrom.blockRange($mappedTo);
            if (!nodeRange) {
                return;
            }
            const targetLiftDepth = liftTarget(nodeRange);
            if (node.type.isTextblock) {
                const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                tr.setNodeMarkup(nodeRange.start, defaultType);
            }
            if (targetLiftDepth || targetLiftDepth === 0) {
                tr.lift(nodeRange, targetLiftDepth);
            }
        });
    });
    return true;
};

var clearNodes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clearNodes: clearNodes
});

const tiptap_core_esm_command = fn => props => {
    return fn(props);
};

var command$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  command: tiptap_core_esm_command
});

const tiptap_core_esm_createParagraphNear = () => ({ state, dispatch }) => {
    return createParagraphNear(state, dispatch);
};

var createParagraphNear$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createParagraphNear: tiptap_core_esm_createParagraphNear
});

function getNodeType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) {
            throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}

const deleteNode = typeOrName => ({ tr, state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

var deleteNode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteNode: deleteNode
});

const deleteRange = range => ({ tr, dispatch }) => {
    const { from, to } = range;
    if (dispatch) {
        tr.delete(from, to);
    }
    return true;
};

var deleteRange$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteRange: deleteRange
});

const tiptap_core_esm_deleteSelection = () => ({ state, dispatch }) => {
    return deleteSelection(state, dispatch);
};

var deleteSelection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteSelection: tiptap_core_esm_deleteSelection
});

const enter = () => ({ commands }) => {
    return commands.keyboardShortcut('Enter');
};

var enter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  enter: enter
});

const tiptap_core_esm_exitCode = () => ({ state, dispatch }) => {
    return exitCode(state, dispatch);
};

var exitCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  exitCode: tiptap_core_esm_exitCode
});

function getMarkType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) {
            throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.marks[nameOrType];
    }
    return nameOrType;
}

function isRegExp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}

/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */
function objectIncludes(object1, object2, options = { strict: true }) {
    const keys = Object.keys(object2);
    if (!keys.length) {
        return true;
    }
    return keys.every(key => {
        if (options.strict) {
            return object2[key] === object1[key];
        }
        if (isRegExp(object2[key])) {
            return object2[key].test(object1[key]);
        }
        return object2[key] === object1[key];
    });
}

function findMarkInSet(marks, type, attributes = {}) {
    return marks.find(item => {
        return item.type === type && objectIncludes(item.attrs, attributes);
    });
}
function isMarkInSet(marks, type, attributes = {}) {
    return !!findMarkInSet(marks, type, attributes);
}
function getMarkRange($pos, type, attributes = {}) {
    if (!$pos || !type) {
        return;
    }
    const start = $pos.parent.childAfter($pos.parentOffset);
    if (!start.node) {
        return;
    }
    const mark = findMarkInSet(start.node.marks, type, attributes);
    if (!mark) {
        return;
    }
    let startIndex = $pos.index();
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    findMarkInSet(start.node.marks, type, attributes);
    while (startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)) {
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while (endIndex < $pos.parent.childCount
        && isMarkInSet($pos.parent.child(endIndex).marks, type, attributes)) {
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos,
    };
}

const extendMarkRange = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const type = getMarkType(typeOrName, state.schema);
    const { doc, selection } = tr;
    const { $from, from, to } = selection;
    if (dispatch) {
        const range = getMarkRange($from, type, attributes);
        if (range && range.from <= from && range.to >= to) {
            const newSelection = index_es_TextSelection.create(doc, range.from, range.to);
            tr.setSelection(newSelection);
        }
    }
    return true;
};

var extendMarkRange$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  extendMarkRange: extendMarkRange
});

const tiptap_core_esm_first = commands => props => {
    const items = typeof commands === 'function'
        ? commands(props)
        : commands;
    for (let i = 0; i < items.length; i += 1) {
        if (items[i](props)) {
            return true;
        }
    }
    return false;
};

var first$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  first: tiptap_core_esm_first
});

function isClass(value) {
    var _a;
    if (((_a = value.constructor) === null || _a === void 0 ? void 0 : _a.toString().substring(0, 5)) !== 'class') {
        return false;
    }
    return true;
}

function isObject(value) {
    return (value
        && typeof value === 'object'
        && !Array.isArray(value)
        && !isClass(value));
}

function isTextSelection(value) {
    return isObject(value) && value instanceof index_es_TextSelection;
}

function isiOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

function minMax(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc, position = null) {
    if (!position) {
        return null;
    }
    const selectionAtStart = index_es_Selection.atStart(doc);
    const selectionAtEnd = index_es_Selection.atEnd(doc);
    if (position === 'start' || position === true) {
        return selectionAtStart;
    }
    if (position === 'end') {
        return selectionAtEnd;
    }
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') {
        return index_es_TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
    }
    return index_es_TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

const tiptap_core_esm_focus = (position = null, options) => ({ editor, view, tr, dispatch, }) => {
    options = {
        scrollIntoView: true,
        ...options,
    };
    const delayedFocus = () => {
        // focus within `requestAnimationFrame` breaks focus on iOS
        // so we have to call this
        if (isiOS()) {
            view.dom.focus();
        }
        // For React we have to focus asynchronously. Otherwise wild things happen.
        // see: https://github.com/ueberdosis/tiptap/issues/1520
        requestAnimationFrame(() => {
            if (!editor.isDestroyed) {
                view.focus();
                if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
                    editor.commands.scrollIntoView();
                }
            }
        });
    };
    if ((view.hasFocus() && position === null) || position === false) {
        return true;
    }
    // we don’t try to resolve a NodeSelection or CellSelection
    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
        delayedFocus();
        return true;
    }
    const selection = resolveFocusPosition(editor.state.doc, position) || editor.state.selection;
    const isSameSelection = editor.state.selection.eq(selection);
    if (dispatch) {
        if (!isSameSelection) {
            tr.setSelection(selection);
        }
        // `tr.setSelection` resets the stored marks
        // so we’ll restore them if the selection is the same as before
        if (isSameSelection && tr.storedMarks) {
            tr.setStoredMarks(tr.storedMarks);
        }
        delayedFocus();
    }
    return true;
};

var focus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  focus: tiptap_core_esm_focus
});

const forEach = (items, fn) => props => {
    return items.every((item, index) => fn(item, { ...props, index }));
};

var forEach$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  forEach: forEach
});

const insertContent = (value, options) => ({ tr, commands }) => {
    return commands.insertContentAt({ from: tr.selection.from, to: tr.selection.to }, value, options);
};

var insertContent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  insertContent: insertContent
});

function elementFromString(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    return new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
}

function createNodeFromContent(content, schema, options) {
    options = {
        slice: true,
        parseOptions: {},
        ...options,
    };
    if (typeof content === 'object' && content !== null) {
        try {
            if (Array.isArray(content)) {
                return Fragment.fromArray(content.map(item => schema.nodeFromJSON(item)));
            }
            return schema.nodeFromJSON(content);
        }
        catch (error) {
            console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
            return createNodeFromContent('', schema, options);
        }
    }
    if (typeof content === 'string') {
        const parser = DOMParser.fromSchema(schema);
        return options.slice
            ? parser.parseSlice(elementFromString(content), options.parseOptions).content
            : parser.parse(elementFromString(content), options.parseOptions);
    }
    return createNodeFromContent('', schema, options);
}

// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function tiptap_core_esm_selectionToInsertionEnd(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) {
        return;
    }
    const step = tr.steps[last];
    if (!(step instanceof index_es_ReplaceStep || step instanceof index_es_ReplaceAroundStep)) {
        return;
    }
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo) => {
        if (end === 0) {
            end = newTo;
        }
    });
    tr.setSelection(index_es_Selection.near(tr.doc.resolve(end), bias));
}

const isFragment = (nodeOrFragment) => {
    return nodeOrFragment.toString().startsWith('<');
};
const insertContentAt = (position, value, options) => ({ tr, dispatch, editor }) => {
    if (dispatch) {
        options = {
            parseOptions: {},
            updateSelection: true,
            ...options,
        };
        const content = createNodeFromContent(value, editor.schema, {
            parseOptions: {
                preserveWhitespace: 'full',
                ...options.parseOptions,
            },
        });
        // don’t dispatch an empty fragment because this can lead to strange errors
        if (content.toString() === '<>') {
            return true;
        }
        let { from, to } = typeof position === 'number'
            ? { from: position, to: position }
            : position;
        let isOnlyTextContent = true;
        let isOnlyBlockContent = true;
        const nodes = isFragment(content)
            ? content
            : [content];
        nodes.forEach(node => {
            // check if added node is valid
            node.check();
            isOnlyTextContent = isOnlyTextContent
                ? node.isText && node.marks.length === 0
                : false;
            isOnlyBlockContent = isOnlyBlockContent
                ? node.isBlock
                : false;
        });
        // check if we can replace the wrapping node by
        // the newly inserted content
        // example:
        // replace an empty paragraph by an inserted image
        // instead of inserting the image below the paragraph
        if (from === to && isOnlyBlockContent) {
            const { parent } = tr.doc.resolve(from);
            const isEmptyTextBlock = parent.isTextblock
                && !parent.type.spec.code
                && !parent.childCount;
            if (isEmptyTextBlock) {
                from -= 1;
                to += 1;
            }
        }
        // if there is only plain text we have to use `insertText`
        // because this will keep the current marks
        if (isOnlyTextContent) {
            tr.insertText(value, from, to);
        }
        else {
            tr.replaceWith(from, to, content);
        }
        // set cursor at end of inserted content
        if (options.updateSelection) {
            tiptap_core_esm_selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
        }
    }
    return true;
};

var insertContentAt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  insertContentAt: insertContentAt
});

const tiptap_core_esm_joinBackward = () => ({ state, dispatch }) => {
    return joinBackward(state, dispatch);
};

var joinBackward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  joinBackward: tiptap_core_esm_joinBackward
});

const tiptap_core_esm_joinForward = () => ({ state, dispatch }) => {
    return joinForward(state, dispatch);
};

var joinForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  joinForward: tiptap_core_esm_joinForward
});

function isMacOS() {
    return typeof navigator !== 'undefined'
        ? /Mac/.test(navigator.platform)
        : false;
}

function tiptap_core_esm_normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') {
        result = ' ';
    }
    let alt;
    let ctrl;
    let shift;
    let meta;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) {
            meta = true;
        }
        else if (/^a(lt)?$/i.test(mod)) {
            alt = true;
        }
        else if (/^(c|ctrl|control)$/i.test(mod)) {
            ctrl = true;
        }
        else if (/^s(hift)?$/i.test(mod)) {
            shift = true;
        }
        else if (/^mod$/i.test(mod)) {
            if (isiOS() || isMacOS()) {
                meta = true;
            }
            else {
                ctrl = true;
            }
        }
        else {
            throw new Error(`Unrecognized modifier name: ${mod}`);
        }
    }
    if (alt) {
        result = `Alt-${result}`;
    }
    if (ctrl) {
        result = `Ctrl-${result}`;
    }
    if (meta) {
        result = `Meta-${result}`;
    }
    if (shift) {
        result = `Shift-${result}`;
    }
    return result;
}
const keyboardShortcut = name => ({ editor, view, tr, dispatch, }) => {
    const keys = tiptap_core_esm_normalizeKeyName(name).split(/-(?!$)/);
    const key = keys.find(item => !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item));
    const event = new KeyboardEvent('keydown', {
        key: key === 'Space'
            ? ' '
            : key,
        altKey: keys.includes('Alt'),
        ctrlKey: keys.includes('Ctrl'),
        metaKey: keys.includes('Meta'),
        shiftKey: keys.includes('Shift'),
        bubbles: true,
        cancelable: true,
    });
    const capturedTransaction = editor.captureTransaction(() => {
        view.someProp('handleKeyDown', f => f(view, event));
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(step => {
        const newStep = step.map(tr.mapping);
        if (newStep && dispatch) {
            tr.maybeStep(newStep);
        }
    });
    return true;
};

var keyboardShortcut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  keyboardShortcut: keyboardShortcut
});

function isNodeActive(state, typeOrName, attributes = {}) {
    const { from, to, empty } = state.selection;
    const type = typeOrName
        ? getNodeType(typeOrName, state.schema)
        : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.isText) {
            return;
        }
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node,
            from: relativeFrom,
            to: relativeTo,
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges
        .filter(nodeRange => {
        if (!type) {
            return true;
        }
        return type.name === nodeRange.node.type.name;
    })
        .filter(nodeRange => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
    if (empty) {
        return !!matchedNodeRanges.length;
    }
    const range = matchedNodeRanges
        .reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}

const tiptap_core_esm_lift = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (!isActive) {
        return false;
    }
    return lift(state, dispatch);
};

var lift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  lift: tiptap_core_esm_lift
});

const tiptap_core_esm_liftEmptyBlock = () => ({ state, dispatch }) => {
    return liftEmptyBlock(state, dispatch);
};

var liftEmptyBlock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  liftEmptyBlock: tiptap_core_esm_liftEmptyBlock
});

const tiptap_core_esm_liftListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return liftListItem(type)(state, dispatch);
};

var liftListItem$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  liftListItem: tiptap_core_esm_liftListItem
});

const tiptap_core_esm_newlineInCode = () => ({ state, dispatch }) => {
    return newlineInCode(state, dispatch);
};

var newlineInCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  newlineInCode: tiptap_core_esm_newlineInCode
});

function getSchemaTypeNameByName(name, schema) {
    if (schema.nodes[name]) {
        return 'node';
    }
    if (schema.marks[name]) {
        return 'mark';
    }
    return null;
}

/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */
function deleteProps(obj, propOrProps) {
    const props = typeof propOrProps === 'string'
        ? [propOrProps]
        : propOrProps;
    return Object
        .keys(obj)
        .reduce((newObj, prop) => {
        if (!props.includes(prop)) {
            newObj[prop] = obj[prop];
        }
        return newObj;
    }, {});
}

const resetAttributes = (typeOrName, attributes) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string'
        ? typeOrName
        : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach(range => {
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
                if (nodeType && nodeType === node.type) {
                    tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
                }
                if (markType && node.marks.length) {
                    node.marks.forEach(mark => {
                        if (markType === mark.type) {
                            tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
                        }
                    });
                }
            });
        });
    }
    return true;
};

var resetAttributes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  resetAttributes: resetAttributes
});

const scrollIntoView = () => ({ tr, dispatch }) => {
    if (dispatch) {
        tr.scrollIntoView();
    }
    return true;
};

var scrollIntoView$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  scrollIntoView: scrollIntoView
});

const tiptap_core_esm_selectAll = () => ({ tr, commands }) => {
    return commands.setTextSelection({
        from: 0,
        to: tr.doc.content.size,
    });
};

var selectAll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectAll: tiptap_core_esm_selectAll
});

const tiptap_core_esm_selectNodeBackward = () => ({ state, dispatch }) => {
    return selectNodeBackward(state, dispatch);
};

var selectNodeBackward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectNodeBackward: tiptap_core_esm_selectNodeBackward
});

const tiptap_core_esm_selectNodeForward = () => ({ state, dispatch }) => {
    return selectNodeForward(state, dispatch);
};

var selectNodeForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectNodeForward: tiptap_core_esm_selectNodeForward
});

const tiptap_core_esm_selectParentNode = () => ({ state, dispatch }) => {
    return selectParentNode(state, dispatch);
};

var selectParentNode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectParentNode: tiptap_core_esm_selectParentNode
});

// @ts-ignore
const tiptap_core_esm_selectTextblockEnd = () => ({ state, dispatch }) => {
    return selectTextblockEnd(state, dispatch);
};

var selectTextblockEnd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectTextblockEnd: tiptap_core_esm_selectTextblockEnd
});

// @ts-ignore
const tiptap_core_esm_selectTextblockStart = () => ({ state, dispatch }) => {
    return selectTextblockStart(state, dispatch);
};

var selectTextblockStart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectTextblockStart: tiptap_core_esm_selectTextblockStart
});

function createDocument(content, schema, parseOptions = {}) {
    return createNodeFromContent(content, schema, { slice: false, parseOptions });
}

const tiptap_core_esm_setContent = (content, emitUpdate = false, parseOptions = {}) => ({ tr, editor, dispatch }) => {
    const { doc } = tr;
    const document = createDocument(content, editor.schema, parseOptions);
    const selection = index_es_TextSelection.create(doc, 0, doc.content.size);
    if (dispatch) {
        tr.setSelection(selection)
            .replaceSelectionWith(document, false)
            .setMeta('preventUpdate', !emitUpdate);
    }
    return true;
};

var setContent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setContent: tiptap_core_esm_setContent
});

function getMarkAttributes(state, typeOrName) {
    const type = getMarkType(typeOrName, state.schema);
    const { from, to, empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) {
            marks.push(...state.storedMarks);
        }
        marks.push(...state.selection.$head.marks());
    }
    else {
        state.doc.nodesBetween(from, to, node => {
            marks.push(...node.marks);
        });
    }
    const mark = marks.find(markItem => markItem.type.name === type.name);
    if (!mark) {
        return {};
    }
    return { ...mark.attrs };
}

const setMark = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    const type = getMarkType(typeOrName, state.schema);
    if (dispatch) {
        if (empty) {
            const oldAttributes = getMarkAttributes(state, type);
            tr.addStoredMark(type.create({
                ...oldAttributes,
                ...attributes,
            }));
        }
        else {
            ranges.forEach(range => {
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos) => {
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find(mark => mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) {
                        node.marks.forEach(mark => {
                            if (type === mark.type) {
                                tr.addMark(trimmedFrom, trimmedTo, type.create({
                                    ...mark.attrs,
                                    ...attributes,
                                }));
                            }
                        });
                    }
                    else {
                        tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                    }
                });
            });
        }
    }
    return true;
};

var setMark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setMark: setMark
});

const setMeta = (key, value) => ({ tr }) => {
    tr.setMeta(key, value);
    return true;
};

var setMeta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setMeta: setMeta
});

const setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
    const type = getNodeType(typeOrName, state.schema);
    // TODO: use a fallback like insertContent?
    if (!type.isTextblock) {
        console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
        return false;
    }
    return chain()
        // try to convert node to default node if needed
        .command(({ commands }) => {
        const canSetBlock = setBlockType(type, attributes)(state);
        if (canSetBlock) {
            return true;
        }
        return commands.clearNodes();
    })
        .command(({ state: updatedState }) => {
        return setBlockType(type, attributes)(updatedState, dispatch);
    })
        .run();
};

var setNode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setNode: setNode
});

const setNodeSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const minPos = index_es_Selection.atStart(doc).from;
        const maxPos = index_es_Selection.atEnd(doc).to;
        const resolvedPos = minMax(position, minPos, maxPos);
        const selection = index_es_NodeSelection.create(doc, resolvedPos);
        tr.setSelection(selection);
    }
    return true;
};

var setNodeSelection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setNodeSelection: setNodeSelection
});

const setTextSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const { from, to } = typeof position === 'number'
            ? { from: position, to: position }
            : position;
        const minPos = index_es_TextSelection.atStart(doc).from;
        const maxPos = index_es_TextSelection.atEnd(doc).to;
        const resolvedFrom = minMax(from, minPos, maxPos);
        const resolvedEnd = minMax(to, minPos, maxPos);
        const selection = index_es_TextSelection.create(doc, resolvedFrom, resolvedEnd);
        tr.setSelection(selection);
    }
    return true;
};

var setTextSelection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setTextSelection: setTextSelection
});

const tiptap_core_esm_sinkListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return sinkListItem(type)(state, dispatch);
};

var sinkListItem$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sinkListItem: tiptap_core_esm_sinkListItem
});

function getSplittedAttributes(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object
        .entries(attributes)
        .filter(([name]) => {
        const extensionAttribute = extensionAttributes.find(item => {
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) {
            return false;
        }
        return extensionAttribute.attribute.keepOnSplit;
    }));
}

function defaultBlockAt$1(match) {
    for (let i = 0; i < match.edgeCount; i += 1) {
        const { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) {
            return type;
        }
    }
    return null;
}
function tiptap_core_esm_ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks
        || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) {
        const filteredMarks = marks.filter(mark => splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const tiptap_core_esm_splitBlock = ({ keepMarks = true } = {}) => ({ tr, state, dispatch, editor, }) => {
    const { selection, doc } = tr;
    const { $from, $to } = selection;
    const extensionAttributes = editor.extensionManager.attributes;
    const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    if (selection instanceof index_es_NodeSelection && selection.node.isBlock) {
        if (!$from.parentOffset || !canSplit(doc, $from.pos)) {
            return false;
        }
        if (dispatch) {
            if (keepMarks) {
                tiptap_core_esm_ensureMarks(state, editor.extensionManager.splittableMarks);
            }
            tr.split($from.pos).scrollIntoView();
        }
        return true;
    }
    if (!$from.parent.isBlock) {
        return false;
    }
    if (dispatch) {
        const atEnd = $to.parentOffset === $to.parent.content.size;
        if (selection instanceof index_es_TextSelection) {
            tr.deleteSelection();
        }
        const deflt = $from.depth === 0
            ? undefined
            : defaultBlockAt$1($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        let types = atEnd && deflt
            ? [{
                    type: deflt,
                    attrs: newAttributes,
                }]
            : undefined;
        let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types
            && !can
            && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : undefined)) {
            can = true;
            types = deflt
                ? [{
                        type: deflt,
                        attrs: newAttributes,
                    }]
                : undefined;
        }
        if (can) {
            tr.split(tr.mapping.map($from.pos), 1, types);
            if (deflt
                && !atEnd
                && !$from.parentOffset
                && $from.parent.type !== deflt) {
                const first = tr.mapping.map($from.before());
                const $first = tr.doc.resolve(first);
                if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
                    tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
        }
        if (keepMarks) {
            tiptap_core_esm_ensureMarks(state, editor.extensionManager.splittableMarks);
        }
        tr.scrollIntoView();
    }
    return true;
};

var splitBlock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  splitBlock: tiptap_core_esm_splitBlock
});

const tiptap_core_esm_splitListItem = typeOrName => ({ tr, state, dispatch, editor, }) => {
    var _a;
    const type = getNodeType(typeOrName, state.schema);
    const { $from, $to } = state.selection;
    // @ts-ignore
    // eslint-disable-next-line
    const node = state.selection.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) {
        return false;
    }
    const grandParent = $from.node(-1);
    if (grandParent.type !== type) {
        return false;
    }
    const extensionAttributes = editor.extensionManager.attributes;
    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
        // In an empty block. If this is a nested list, the wrapping
        // list item should be split. Otherwise, bail out and let next
        // command handle lifting.
        if ($from.depth === 2
            || $from.node(-3).type !== type
            || $from.index(-2) !== $from.node(-2).childCount - 1) {
            return false;
        }
        if (dispatch) {
            let wrap = Fragment.empty;
            // eslint-disable-next-line
            const depthBefore = $from.index(-1)
                ? 1
                : $from.index(-2)
                    ? 2
                    : 3;
            // Build a fragment containing empty versions of the structure
            // from the outer list item to the parent node of the cursor
            for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
                wrap = Fragment.from($from.node(d).copy(wrap));
            }
            // eslint-disable-next-line
            const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount
                ? 1
                : $from.indexAfter(-2) < $from.node(-3).childCount
                    ? 2
                    : 3;
            // Add a second list item with an empty default start node
            const newNextTypeAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
            const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
            wrap = wrap.append(Fragment.from(type.createAndFill(null, nextType) || undefined));
            const start = $from.before($from.depth - (depthBefore - 1));
            tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
            let sel = -1;
            tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos) => {
                if (sel > -1) {
                    return false;
                }
                if (n.isTextblock && n.content.size === 0) {
                    sel = pos + 1;
                }
            });
            if (sel > -1) {
                tr.setSelection(index_es_TextSelection.near(tr.doc.resolve(sel)));
            }
            tr.scrollIntoView();
        }
        return true;
    }
    const nextType = $to.pos === $from.end()
        ? grandParent.contentMatchAt(0).defaultType
        : null;
    const newTypeAttributes = getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs);
    const newNextTypeAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    tr.delete($from.pos, $to.pos);
    const types = nextType
        ? [{ type, attrs: newTypeAttributes }, { type: nextType, attrs: newNextTypeAttributes }]
        : [{ type, attrs: newTypeAttributes }];
    if (!canSplit(tr.doc, $from.pos, 2)) {
        return false;
    }
    if (dispatch) {
        tr.split($from.pos, 2, types).scrollIntoView();
    }
    return true;
};

var splitListItem$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  splitListItem: tiptap_core_esm_splitListItem
});

function findParentNodeClosestToPos($pos, predicate) {
    for (let i = $pos.depth; i > 0; i -= 1) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
}

function findParentNode(predicate) {
    return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}

function splitExtensions(extensions) {
    const baseExtensions = extensions.filter(extension => extension.type === 'extension');
    const nodeExtensions = extensions.filter(extension => extension.type === 'node');
    const markExtensions = extensions.filter(extension => extension.type === 'mark');
    return {
        baseExtensions,
        nodeExtensions,
        markExtensions,
    };
}

function isList(name, extensions) {
    const { nodeExtensions } = splitExtensions(extensions);
    const extension = nodeExtensions.find(item => item.name === name);
    if (!extension) {
        return false;
    }
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
    };
    const group = callOrReturn(getExtensionField(extension, 'group', context));
    if (typeof group !== 'string') {
        return false;
    }
    return group.split(' ').includes('list');
}

const joinListBackwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) {
        return true;
    }
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type)
        && canJoin(tr.doc, list.pos);
    if (!canJoinBackwards) {
        return true;
    }
    tr.join(list.pos);
    return true;
};
const joinListForwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) {
        return true;
    }
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type)
        && canJoin(tr.doc, after);
    if (!canJoinForwards) {
        return true;
    }
    tr.join(after);
    return true;
};
const toggleList = (listTypeOrName, itemTypeOrName) => ({ editor, tr, state, dispatch, chain, commands, can, }) => {
    const { extensions } = editor.extensionManager;
    const listType = getNodeType(listTypeOrName, state.schema);
    const itemType = getNodeType(itemTypeOrName, state.schema);
    const { selection } = state;
    const { $from, $to } = selection;
    const range = $from.blockRange($to);
    if (!range) {
        return false;
    }
    const parentList = findParentNode(node => isList(node.type.name, extensions))(selection);
    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
        // remove list
        if (parentList.node.type === listType) {
            return commands.liftListItem(itemType);
        }
        // change list type
        if (isList(parentList.node.type.name, extensions)
            && listType.validContent(parentList.node.content)
            && dispatch) {
            return chain()
                .command(() => {
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            })
                .command(() => joinListBackwards(tr, listType))
                .command(() => joinListForwards(tr, listType))
                .run();
        }
    }
    return chain()
        // try to convert node to default node if needed
        .command(() => {
        const canWrapInList = can().wrapInList(listType);
        if (canWrapInList) {
            return true;
        }
        return commands.clearNodes();
    })
        .wrapInList(listType)
        .command(() => joinListBackwards(tr, listType))
        .command(() => joinListForwards(tr, listType))
        .run();
};

var toggleList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toggleList: toggleList
});

function isMarkActive(state, typeOrName, attributes = {}) {
    const { empty, ranges } = state.selection;
    const type = typeOrName
        ? getMarkType(typeOrName, state.schema)
        : null;
    if (empty) {
        return !!(state.storedMarks || state.selection.$from.marks())
            .filter(mark => {
            if (!type) {
                return true;
            }
            return type.name === mark.type.name;
        })
            .find(mark => objectIncludes(mark.attrs, attributes, { strict: false }));
    }
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from, $to }) => {
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos) => {
            if (!node.isText && !node.marks.length) {
                return;
            }
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map(mark => ({
                mark,
                from: relativeFrom,
                to: relativeTo,
            })));
        });
    });
    if (selectionRange === 0) {
        return false;
    }
    // calculate range of matched mark
    const matchedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return type.name === markRange.mark.type.name;
    })
        .filter(markRange => objectIncludes(markRange.mark.attrs, attributes, { strict: false }))
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return markRange.mark.type !== type
            && markRange.mark.type.excludes(type);
    })
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0
        ? matchedRange + excludedRange
        : matchedRange;
    return range >= selectionRange;
}

const tiptap_core_esm_toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands }) => {
    const { extendEmptyMarkRange = false } = options;
    const type = getMarkType(typeOrName, state.schema);
    const isActive = isMarkActive(state, type, attributes);
    if (isActive) {
        return commands.unsetMark(type, { extendEmptyMarkRange });
    }
    return commands.setMark(type, attributes);
};

var toggleMark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toggleMark: tiptap_core_esm_toggleMark
});

const toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const toggleType = getNodeType(toggleTypeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (isActive) {
        return commands.setNode(toggleType);
    }
    return commands.setNode(type, attributes);
};

var toggleNode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toggleNode: toggleNode
});

const toggleWrap = (typeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (isActive) {
        return commands.lift(type);
    }
    return commands.wrapIn(type, attributes);
};

var toggleWrap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toggleWrap: toggleWrap
});

const undoInputRule = () => ({ state, dispatch }) => {
    const plugins = state.plugins;
    for (let i = 0; i < plugins.length; i += 1) {
        const plugin = plugins[i];
        let undoable;
        // @ts-ignore
        // eslint-disable-next-line
        if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
            if (dispatch) {
                const tr = state.tr;
                const toUndo = undoable.transform;
                for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) {
                    tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                }
                if (undoable.text) {
                    const marks = tr.doc.resolve(undoable.from).marks();
                    tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                }
                else {
                    tr.delete(undoable.from, undoable.to);
                }
            }
            return true;
        }
    }
    return false;
};

var undoInputRule$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  undoInputRule: undoInputRule
});

const unsetAllMarks = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    if (empty) {
        return true;
    }
    if (dispatch) {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
    }
    return true;
};

var unsetAllMarks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unsetAllMarks: unsetAllMarks
});

const unsetMark = (typeOrName, options = {}) => ({ tr, state, dispatch }) => {
    var _a;
    const { extendEmptyMarkRange = false } = options;
    const { selection } = tr;
    const type = getMarkType(typeOrName, state.schema);
    const { $from, empty, ranges } = selection;
    if (!dispatch) {
        return true;
    }
    if (empty && extendEmptyMarkRange) {
        let { from, to } = selection;
        const attrs = (_a = $from.marks().find(mark => mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
        const range = getMarkRange($from, type, attrs);
        if (range) {
            from = range.from;
            to = range.to;
        }
        tr.removeMark(from, to, type);
    }
    else {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
    }
    tr.removeStoredMark(type);
    return true;
};

var unsetMark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unsetMark: unsetMark
});

const updateAttributes = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string'
        ? typeOrName
        : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach(range => {
            const from = range.$from.pos;
            const to = range.$to.pos;
            state.doc.nodesBetween(from, to, (node, pos) => {
                if (nodeType && nodeType === node.type) {
                    tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        ...attributes,
                    });
                }
                if (markType && node.marks.length) {
                    node.marks.forEach(mark => {
                        if (markType === mark.type) {
                            const trimmedFrom = Math.max(pos, from);
                            const trimmedTo = Math.min(pos + node.nodeSize, to);
                            tr.addMark(trimmedFrom, trimmedTo, markType.create({
                                ...mark.attrs,
                                ...attributes,
                            }));
                        }
                    });
                }
            });
        });
    }
    return true;
};

var updateAttributes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  updateAttributes: updateAttributes
});

const tiptap_core_esm_wrapIn = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapIn(type, attributes)(state, dispatch);
};

var wrapIn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  wrapIn: tiptap_core_esm_wrapIn
});

const tiptap_core_esm_wrapInList = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapInList(type, attributes)(state, dispatch);
};

var wrapInList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  wrapInList: tiptap_core_esm_wrapInList
});

const Commands = Extension.create({
    name: 'commands',
    addCommands() {
        return {
            ...blur$1,
            ...clearContent$1,
            ...clearNodes$1,
            ...command$1,
            ...createParagraphNear$1,
            ...deleteNode$1,
            ...deleteRange$1,
            ...deleteSelection$1,
            ...enter$1,
            ...exitCode$1,
            ...extendMarkRange$1,
            ...first$1,
            ...focus$1,
            ...forEach$1,
            ...insertContent$1,
            ...insertContentAt$1,
            ...joinBackward$1,
            ...joinForward$1,
            ...keyboardShortcut$1,
            ...lift$1,
            ...liftEmptyBlock$1,
            ...liftListItem$1,
            ...newlineInCode$1,
            ...resetAttributes$1,
            ...scrollIntoView$1,
            ...selectAll$1,
            ...selectNodeBackward$1,
            ...selectNodeForward$1,
            ...selectParentNode$1,
            ...selectTextblockEnd$1,
            ...selectTextblockStart$1,
            ...setContent$1,
            ...setMark$1,
            ...setMeta$1,
            ...setNode$1,
            ...setNodeSelection$1,
            ...setTextSelection$1,
            ...sinkListItem$1,
            ...splitBlock$1,
            ...splitListItem$1,
            ...toggleList$1,
            ...toggleMark$1,
            ...toggleNode$1,
            ...toggleWrap$1,
            ...undoInputRule$1,
            ...unsetAllMarks$1,
            ...unsetMark$1,
            ...updateAttributes$1,
            ...wrapIn$1,
            ...wrapInList$1,
        };
    },
});

const Editable = Extension.create({
    name: 'editable',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('editable'),
                props: {
                    editable: () => this.editor.options.editable,
                },
            }),
        ];
    },
});

const FocusEvents = Extension.create({
    name: 'focusEvents',
    addProseMirrorPlugins() {
        const { editor } = this;
        return [
            new Plugin({
                key: new PluginKey('focusEvents'),
                props: {
                    handleDOMEvents: {
                        focus: (view, event) => {
                            editor.isFocused = true;
                            const transaction = editor.state.tr
                                .setMeta('focus', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event) => {
                            editor.isFocused = false;
                            const transaction = editor.state.tr
                                .setMeta('blur', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                    },
                },
            }),
        ];
    },
});

function createChainableState(config) {
    const { state, transaction } = config;
    let { selection } = transaction;
    let { doc } = transaction;
    let { storedMarks } = transaction;
    return {
        ...state,
        schema: state.schema,
        plugins: state.plugins,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks() {
            return storedMarks;
        },
        get selection() {
            return selection;
        },
        get doc() {
            return doc;
        },
        get tr() {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        },
    };
}

class CommandManager {
    constructor(props) {
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const { tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object
            .entries(rawCommands)
            .map(([name, command]) => {
            const method = (...args) => {
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) {
                    view.dispatch(tr);
                }
                return callback;
            };
            return [name, method];
        }));
    }
    get chain() {
        return () => this.createChain();
    }
    get can() {
        return () => this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = () => {
            if (!hasStartTransaction
                && shouldDispatch
                && !tr.getMeta('preventDispatch')
                && !this.hasCustomState) {
                view.dispatch(tr);
            }
            return callbacks.every(callback => callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                const chainedCommand = (...args) => {
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [name, chainedCommand];
            })),
            run,
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands, state } = this;
        const dispatch = undefined;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object
            .entries(rawCommands)
            .map(([name, command]) => {
            return [name, (...args) => command(...args)({ ...props, dispatch })];
        }));
        return {
            ...formattedCommands,
            chain: () => this.createChain(tr, dispatch),
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        if (state.storedMarks) {
            tr.setStoredMarks(state.storedMarks);
        }
        const props = {
            tr,
            editor,
            view,
            state: createChainableState({
                state,
                transaction: tr,
            }),
            dispatch: shouldDispatch
                ? () => undefined
                : undefined,
            chain: () => this.createChain(tr),
            can: () => this.createCan(tr),
            get commands() {
                return Object.fromEntries(Object
                    .entries(rawCommands)
                    .map(([name, command]) => {
                    return [name, (...args) => command(...args)(props)];
                }));
            },
        };
        return props;
    }
}

const Keymap = Extension.create({
    name: 'keymap',
    addKeyboardShortcuts() {
        const handleBackspace = () => this.editor.commands.first(({ commands }) => [
            () => commands.undoInputRule(),
            // maybe convert first text block node to default node
            () => commands.command(({ tr }) => {
                const { selection, doc } = tr;
                const { empty, $anchor } = selection;
                const { pos, parent } = $anchor;
                const isAtStart = index_es_Selection.atStart(doc).from === pos;
                if (!empty
                    || !isAtStart
                    || !parent.type.isTextblock
                    || parent.textContent.length) {
                    return false;
                }
                return commands.clearNodes();
            }),
            () => commands.deleteSelection(),
            () => commands.joinBackward(),
            () => commands.selectNodeBackward(),
        ]);
        const handleDelete = () => this.editor.commands.first(({ commands }) => [
            () => commands.deleteSelection(),
            () => commands.joinForward(),
            () => commands.selectNodeForward(),
        ]);
        const handleEnter = () => this.editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
        ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': () => this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': () => this.editor.commands.selectAll(),
        };
        const pcKeymap = {
            ...baseKeymap,
            Home: () => this.editor.commands.selectTextblockStart(),
            End: () => this.editor.commands.selectTextblockEnd(),
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': () => this.editor.commands.selectTextblockStart(),
            'Ctrl-e': () => this.editor.commands.selectTextblockEnd(),
        };
        if (isiOS() || isMacOS()) {
            return macKeymap;
        }
        return pcKeymap;
    },
    addProseMirrorPlugins() {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new Plugin({
                key: new PluginKey('clearDocument'),
                appendTransaction: (transactions, oldState, newState) => {
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    if (!docChanges) {
                        return;
                    }
                    const { empty, from, to } = oldState.selection;
                    const allFrom = index_es_Selection.atStart(oldState.doc).from;
                    const allEnd = index_es_Selection.atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    const isEmpty = newState.doc.textBetween(0, newState.doc.content.size, ' ', ' ').length === 0;
                    if (empty || !allWasSelected || !isEmpty) {
                        return;
                    }
                    const tr = newState.tr;
                    const state = createChainableState({
                        state: newState,
                        transaction: tr,
                    });
                    const { commands } = new CommandManager({
                        editor: this.editor,
                        state,
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
            }),
        ];
    },
});

const Tabindex = Extension.create({
    name: 'tabindex',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tabindex'),
                props: {
                    attributes: () => {
                        if (this.editor.isEditable) {
                            return {
                                tabindex: '0',
                            };
                        }
                    },
                },
            }),
        ];
    },
});

var tiptap_core_esm_extensions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: ClipboardTextSerializer,
  Commands: Commands,
  Editable: Editable,
  FocusEvents: FocusEvents,
  Keymap: Keymap,
  Tabindex: Tabindex
});

function getNodeAttributes(state, typeOrName) {
    const type = getNodeType(typeOrName, state.schema);
    const { from, to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, node => {
        nodes.push(node);
    });
    const node = nodes
        .reverse()
        .find(nodeItem => nodeItem.type.name === type.name);
    if (!node) {
        return {};
    }
    return { ...node.attrs };
}

function getAttributes(state, typeOrName) {
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string'
        ? typeOrName
        : typeOrName.name, state.schema);
    if (schemaType === 'node') {
        return getNodeAttributes(state, typeOrName);
    }
    if (schemaType === 'mark') {
        return getMarkAttributes(state, typeOrName);
    }
    return {};
}

function tiptap_core_esm_isActive(state, name, attributes = {}) {
    if (!name) {
        return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
    }
    const schemaType = getSchemaTypeNameByName(name, state.schema);
    if (schemaType === 'node') {
        return isNodeActive(state, name, attributes);
    }
    if (schemaType === 'mark') {
        return isMarkActive(state, name, attributes);
    }
    return false;
}

function getHTMLFromFragment(fragment, schema) {
    const documentFragment = DOMSerializer
        .fromSchema(schema)
        .serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}

function getText(node, options) {
    const range = {
        from: 0,
        to: node.content.size,
    };
    return getTextBetween(node, range, options);
}

function isNodeEmpty(node) {
    var _a;
    const defaultContent = (_a = node.type.createAndFill()) === null || _a === void 0 ? void 0 : _a.toJSON();
    const content = node.toJSON();
    return JSON.stringify(defaultContent) === JSON.stringify(content);
}

function createStyleTag(style) {
    const tipTapStyleTag = document.querySelector('style[data-tiptap-style]');
    if (tipTapStyleTag !== null) {
        return tipTapStyleTag;
    }
    const styleNode = document.createElement('style');
    styleNode.setAttribute('data-tiptap-style', '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}

class InputRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const inputRuleMatcherHandler = (text, find) => {
    if (isRegExp(find)) {
        return find.exec(text);
    }
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) {
        return null;
    }
    const result = [];
    result.push(inputRuleMatch.text);
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
            console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        }
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function run$1(config) {
    var _a;
    const { editor, from, to, text, rules, plugin, } = config;
    const { view } = editor;
    if (view.composing) {
        return false;
    }
    const $from = view.state.doc.resolve(from);
    if (
    // check for code node
    $from.parent.type.spec.code
        // check for code mark
        || !!((_a = ($from.nodeBefore || $from.nodeAfter)) === null || _a === void 0 ? void 0 : _a.marks.find(mark => mark.type.spec.code))) {
        return false;
    }
    let matched = false;
    const maxMatch = 500;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - maxMatch), $from.parentOffset, undefined, ' ') + text;
    rules.forEach(rule => {
        if (matched) {
            return;
        }
        const match = inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) {
            return;
        }
        const tr = view.state.tr;
        const state = createChainableState({
            state: view.state,
            transaction: tr,
        });
        const range = {
            from: from - (match[0].length - text.length),
            to,
        };
        const { commands, chain, can } = new CommandManager({
            editor,
            state,
        });
        const handler = rule.handler({
            state,
            range,
            match,
            commands,
            chain,
            can,
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) {
            return;
        }
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from,
            to,
            text,
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */
function inputRulesPlugin(props) {
    const { editor, rules } = props;
    const plugin = new Plugin({
        state: {
            init() {
                return null;
            },
            apply(tr, prev) {
                const stored = tr.getMeta(this);
                if (stored) {
                    return stored;
                }
                return tr.selectionSet || tr.docChanged
                    ? null
                    : prev;
            },
        },
        props: {
            handleTextInput(view, from, to, text) {
                return run$1({
                    editor,
                    from,
                    to,
                    text,
                    rules,
                    plugin,
                });
            },
            handleDOMEvents: {
                compositionend: view => {
                    setTimeout(() => {
                        const { $cursor } = view.state.selection;
                        if ($cursor) {
                            run$1({
                                editor,
                                from: $cursor.pos,
                                to: $cursor.pos,
                                text: '',
                                rules,
                                plugin,
                            });
                        }
                    });
                    return false;
                },
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown(view, event) {
                if (event.key !== 'Enter') {
                    return false;
                }
                const { $cursor } = view.state.selection;
                if ($cursor) {
                    return run$1({
                        editor,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: '\n',
                        rules,
                        plugin,
                    });
                }
                return false;
            },
        },
        // @ts-ignore
        isInputRules: true,
    });
    return plugin;
}

function isNumber(value) {
    return typeof value === 'number';
}

class PasteRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const pasteRuleMatcherHandler = (text, find) => {
    if (isRegExp(find)) {
        return [...text.matchAll(find)];
    }
    const matches = find(text);
    if (!matches) {
        return [];
    }
    return matches.map(pasteRuleMatch => {
        const result = [];
        result.push(pasteRuleMatch.text);
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
                console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            }
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function run(config) {
    const { editor, state, from, to, rule, } = config;
    const { commands, chain, can } = new CommandManager({
        editor,
        state,
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isTextblock || node.type.spec.code) {
            return;
        }
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = pasteRuleMatcherHandler(textToMatch, rule.find);
        matches.forEach(match => {
            if (match.index === undefined) {
                return;
            }
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end),
            };
            const handler = rule.handler({
                state,
                range,
                match,
                commands,
                chain,
                can,
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every(handler => handler !== null);
    return success;
}
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */
function pasteRulesPlugin(props) {
    const { editor, rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    const plugins = rules.map(rule => {
        return new Plugin({
            // we register a global drag handler to track the current drag source element
            view(view) {
                const handleDragstart = (event) => {
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))
                        ? view.dom.parentElement
                        : null;
                };
                window.addEventListener('dragstart', handleDragstart);
                return {
                    destroy() {
                        window.removeEventListener('dragstart', handleDragstart);
                    },
                };
            },
            props: {
                handleDOMEvents: {
                    drop: view => {
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        return false;
                    },
                    paste: (view, event) => {
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    },
                },
            },
            appendTransaction: (transactions, oldState, state) => {
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                if (!isPaste && !isDrop) {
                    return;
                }
                // stop if there is no changed range
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                if (!isNumber(from) || !to || from === to.b) {
                    return;
                }
                // build a chainable state
                // so we can use a single transaction for all paste rules
                const tr = state.tr;
                const chainableState = createChainableState({
                    state,
                    transaction: tr,
                });
                const handler = run({
                    editor,
                    state: chainableState,
                    from: Math.max(from - 1, 0),
                    to: to.b,
                    rule,
                });
                // stop if there are no changes
                if (!handler || !tr.steps.length) {
                    return;
                }
                return tr;
            },
        });
    });
    return plugins;
}

/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */
function getAttributesFromExtensions(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
    };
    extensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) {
            return;
        }
        // TODO: remove `as GlobalAttributes`
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach(globalAttribute => {
            globalAttribute.types.forEach(type => {
                Object
                    .entries(globalAttribute.attributes)
                    .forEach(([name, attribute]) => {
                    extensionAttributes.push({
                        type,
                        name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute,
                        },
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const addAttributes = getExtensionField(extension, 'addAttributes', context);
        if (!addAttributes) {
            return;
        }
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object
            .entries(attributes)
            .forEach(([name, attribute]) => {
            extensionAttributes.push({
                type: extension.name,
                name,
                attribute: {
                    ...defaultAttribute,
                    ...attribute,
                },
            });
        });
    });
    return extensionAttributes;
}

function mergeAttributes(...objects) {
    return objects
        .filter(item => !!item)
        .reduce((items, item) => {
        const mergedAttributes = { ...items };
        Object.entries(item).forEach(([key, value]) => {
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                mergedAttributes[key] = [mergedAttributes[key], value].join(' ');
            }
            else if (key === 'style') {
                mergedAttributes[key] = [mergedAttributes[key], value].join('; ');
            }
            else {
                mergedAttributes[key] = value;
            }
        });
        return mergedAttributes;
    }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
    return extensionAttributes
        .filter(item => item.attribute.rendered)
        .map(item => {
        if (!item.attribute.renderHTML) {
            return {
                [item.name]: nodeOrMark.attrs[item.name],
            };
        }
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    })
        .reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}

function isEmptyObject(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
        return Number(value);
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return value;
}

/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
    if (parseRule.style) {
        return parseRule;
    }
    return {
        ...parseRule,
        getAttrs: node => {
            const oldAttributes = parseRule.getAttrs
                ? parseRule.getAttrs(node)
                : parseRule.attrs;
            if (oldAttributes === false) {
                return false;
            }
            const newAttributes = extensionAttributes.reduce((items, item) => {
                const value = item.attribute.parseHTML
                    ? item.attribute.parseHTML(node)
                    : fromString(node.getAttribute(item.name));
                if (value === null || value === undefined) {
                    return items;
                }
                return {
                    ...items,
                    [item.name]: value,
                };
            }, {});
            return { ...oldAttributes, ...newAttributes };
        },
    };
}

function cleanUpSchemaItem(data) {
    return Object.fromEntries(Object.entries(data).filter(([key, value]) => {
        if (key === 'attrs' && isEmptyObject(value)) {
            return false;
        }
        return value !== null && value !== undefined;
    }));
}
function getSchemaByResolvedExtensions(extensions) {
    var _a;
    const allAttributes = getAttributesFromExtensions(extensions);
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const topNode = (_a = nodeExtensions.find(extension => getExtensionField(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const extraNodeFields = extensions.reduce((fields, e) => {
            const extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...(extendNodeSchema ? extendNodeSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraNodeFields,
            content: callOrReturn(getExtensionField(extension, 'content', context)),
            marks: callOrReturn(getExtensionField(extension, 'marks', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            inline: callOrReturn(getExtensionField(extension, 'inline', context)),
            atom: callOrReturn(getExtensionField(extension, 'atom', context)),
            selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
            draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            defining: callOrReturn(getExtensionField(extension, 'defining', context)),
            isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML
                .map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = node => renderHTML({
                node,
                HTMLAttributes: getRenderedAttributes(node, extensionAttributes),
            });
        }
        const renderText = getExtensionField(extension, 'renderText', context);
        if (renderText) {
            schema.toText = renderText;
        }
        return [extension.name, schema];
    }));
    const marks = Object.fromEntries(markExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const extraMarkFields = extensions.reduce((fields, e) => {
            const extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...(extendMarkSchema ? extendMarkSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
            excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML
                .map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = mark => renderHTML({
                mark,
                HTMLAttributes: getRenderedAttributes(mark, extensionAttributes),
            });
        }
        return [extension.name, schema];
    }));
    return new index_es_Schema({
        topNode,
        nodes,
        marks,
    });
}

function getSchemaTypeByName(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
    if (Array.isArray(enabled)) {
        return enabled.some(enabledExtension => {
            const name = typeof enabledExtension === 'string'
                ? enabledExtension
                : enabledExtension.name;
            return name === extension.name;
        });
    }
    return enabled;
}

function findDuplicates(items) {
    const filtered = items.filter((el, index) => items.indexOf(el) !== index);
    return [...new Set(filtered)];
}

class tiptap_core_esm_ExtensionManager {
    constructor(extensions, editor) {
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = tiptap_core_esm_ExtensionManager.resolve(extensions);
        this.schema = getSchemaByResolvedExtensions(this.extensions);
        this.extensions.forEach(extension => {
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) {
                    this.splittableMarks.push(extension.name);
                }
            }
            const onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);
            if (onBeforeCreate) {
                this.editor.on('beforeCreate', onBeforeCreate);
            }
            const onCreate = getExtensionField(extension, 'onCreate', context);
            if (onCreate) {
                this.editor.on('create', onCreate);
            }
            const onUpdate = getExtensionField(extension, 'onUpdate', context);
            if (onUpdate) {
                this.editor.on('update', onUpdate);
            }
            const onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);
            if (onSelectionUpdate) {
                this.editor.on('selectionUpdate', onSelectionUpdate);
            }
            const onTransaction = getExtensionField(extension, 'onTransaction', context);
            if (onTransaction) {
                this.editor.on('transaction', onTransaction);
            }
            const onFocus = getExtensionField(extension, 'onFocus', context);
            if (onFocus) {
                this.editor.on('focus', onFocus);
            }
            const onBlur = getExtensionField(extension, 'onBlur', context);
            if (onBlur) {
                this.editor.on('blur', onBlur);
            }
            const onDestroy = getExtensionField(extension, 'onDestroy', context);
            if (onDestroy) {
                this.editor.on('destroy', onDestroy);
            }
        });
    }
    static resolve(extensions) {
        const resolvedExtensions = tiptap_core_esm_ExtensionManager.sort(tiptap_core_esm_ExtensionManager.flatten(extensions));
        const duplicatedNames = findDuplicates(resolvedExtensions.map(extension => extension.name));
        if (duplicatedNames.length) {
            console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map(item => `'${item}'`).join(', ')}]. This can lead to issues.`);
        }
        return resolvedExtensions;
    }
    static flatten(extensions) {
        return extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
            };
            const addExtensions = getExtensionField(extension, 'addExtensions', context);
            if (addExtensions) {
                return [
                    extension,
                    ...this.flatten(addExtensions()),
                ];
            }
            return extension;
        })
            // `Infinity` will break TypeScript so we set a number that is probably high enough
            .flat(10);
    }
    static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b) => {
            const priorityA = getExtensionField(a, 'priority') || defaultPriority;
            const priorityB = getExtensionField(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) {
                return -1;
            }
            if (priorityA < priorityB) {
                return 1;
            }
            return 0;
        });
    }
    get commands() {
        return this.extensions.reduce((commands, extension) => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const addCommands = getExtensionField(extension, 'addCommands', context);
            if (!addCommands) {
                return commands;
            }
            return {
                ...commands,
                ...addCommands(),
            };
        }, {});
    }
    get plugins() {
        const { editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = tiptap_core_esm_ExtensionManager.sort([...this.extensions].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const plugins = [];
            const addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object
                    .entries(addKeyboardShortcuts())
                    .map(([shortcut, method]) => {
                    return [shortcut, () => method({ editor })];
                }));
                const keyMapPlugin = keymap(bindings);
                plugins.push(keyMapPlugin);
            }
            const addInputRules = getExtensionField(extension, 'addInputRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
                inputRules.push(...addInputRules());
            }
            const addPasteRules = getExtensionField(extension, 'addPasteRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
                pasteRules.push(...addPasteRules());
            }
            const addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        })
            .flat();
        return [
            inputRulesPlugin({
                editor,
                rules: inputRules,
            }),
            ...pasteRulesPlugin({
                editor,
                rules: pasteRules,
            }),
            ...allPlugins,
        ];
    }
    get attributes() {
        return getAttributesFromExtensions(this.extensions);
    }
    get nodeViews() {
        const { editor } = this;
        const { nodeExtensions } = splitExtensions(this.extensions);
        return Object.fromEntries(nodeExtensions
            .filter(extension => !!getExtensionField(extension, 'addNodeView'))
            .map(extension => {
            const extensionAttributes = this.attributes.filter(attribute => attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getNodeType(extension.name, this.schema),
            };
            const addNodeView = getExtensionField(extension, 'addNodeView', context);
            if (!addNodeView) {
                return [];
            }
            const nodeview = (node, view, getPos, decorations) => {
                const HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
                return addNodeView()({
                    editor,
                    node,
                    getPos,
                    decorations,
                    HTMLAttributes,
                    extension,
                });
            };
            return [extension.name, nodeview];
        }));
    }
}

class EventEmitter {
    constructor() {
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            callbacks.forEach(callback => callback.apply(this, args));
        }
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) {
                this.callbacks[event] = callbacks.filter(callback => callback !== fn);
            }
            else {
                delete this.callbacks[event];
            }
        }
        return this;
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}

const tiptap_core_esm_style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;

class tiptap_core_esm_Editor extends EventEmitter {
    constructor(options = {}) {
        super();
        this.isFocused = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            onBeforeCreate: () => null,
            onCreate: () => null,
            onUpdate: () => null,
            onSelectionUpdate: () => null,
            onTransaction: () => null,
            onFocus: () => null,
            onBlur: () => null,
            onDestroy: () => null,
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', { editor: this });
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        window.setTimeout(() => {
            if (this.isDestroyed) {
                return;
            }
            this.commands.focus(this.options.autofocus);
            this.emit('create', { editor: this });
        }, 0);
    }
    /**
     * Returns the editor storage.
     */
    get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */
    get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */
    chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */
    can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */
    injectCSS() {
        if (this.options.injectCSS && document) {
            this.css = createStyleTag(tiptap_core_esm_style);
        }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */
    setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options,
        };
        if (!this.view || !this.state || this.isDestroyed) {
            return;
        }
        if (this.options.editorProps) {
            this.view.setProps(this.options.editorProps);
        }
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */
    setEditable(editable) {
        this.setOptions({ editable });
    }
    /**
     * Returns whether the editor is editable.
     */
    get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable
            && this.view
            && this.view.editable;
    }
    /**
     * Returns the editor state.
     */
    get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     */
    registerPlugin(plugin, handlePlugins) {
        const plugins = isFunction(handlePlugins)
            ? handlePlugins(plugin, this.state.plugins)
            : [...this.state.plugins, plugin];
        const state = this.state.reconfigure({ plugins });
        this.view.updateState(state);
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKey The plugins name
     */
    unregisterPlugin(nameOrPluginKey) {
        if (this.isDestroyed) {
            return;
        }
        const name = typeof nameOrPluginKey === 'string'
            ? `${nameOrPluginKey}$`
            // @ts-ignore
            : nameOrPluginKey.key;
        const state = this.state.reconfigure({
            // @ts-ignore
            plugins: this.state.plugins.filter(plugin => !plugin.key.startsWith(name)),
        });
        this.view.updateState(state);
    }
    /**
     * Creates an extension manager.
     */
    createExtensionManager() {
        const coreExtensions = this.options.enableCoreExtensions
            ? Object.values(tiptap_core_esm_extensions)
            : [];
        const allExtensions = [...coreExtensions, ...this.options.extensions].filter(extension => {
            return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new tiptap_core_esm_ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */
    createCommandManager() {
        this.commandManager = new CommandManager({
            editor: this,
        });
    }
    /**
     * Creates a ProseMirror schema.
     */
    createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */
    createView() {
        const doc = createDocument(this.options.content, this.schema, this.options.parseOptions);
        const selection = resolveFocusPosition(doc, this.options.autofocus);
        this.view = new EditorView(this.options.element, {
            ...this.options.editorProps,
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: EditorState.create({
                doc,
                selection,
            }),
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins,
        });
        this.view.updateState(newState);
        this.createNodeViews();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */
    createNodeViews() {
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews,
        });
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */
    dispatchTransaction(transaction) {
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach(step => { var _a; return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step); });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction,
        });
        if (selectionHasChanged) {
            this.emit('selectionUpdate', {
                editor: this,
                transaction,
            });
        }
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) {
            this.emit('focus', {
                editor: this,
                event: focus.event,
                transaction,
            });
        }
        if (blur) {
            this.emit('blur', {
                editor: this,
                event: blur.event,
                transaction,
            });
        }
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
            return;
        }
        this.emit('update', {
            editor: this,
            transaction,
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */
    getAttributes(nameOrType) {
        return getAttributes(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string'
            ? nameOrAttributes
            : null;
        const attributes = typeof nameOrAttributes === 'string'
            ? attributesOrUndefined
            : nameOrAttributes;
        return tiptap_core_esm_isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */
    getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */
    getHTML() {
        return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */
    getText(options) {
        const { blockSeparator = '\n\n', textSerializers = {}, } = options || {};
        return getText(this.state.doc, {
            blockSeparator,
            textSerializers: {
                ...textSerializers,
                ...getTextSeralizersFromSchema(this.schema),
            },
        });
    }
    /**
     * Check if there is no content.
     */
    get isEmpty() {
        return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */
    getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */
    destroy() {
        this.emit('destroy');
        if (this.view) {
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */
    get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
}

class tiptap_core_esm_Node {
    constructor(config = {}) {
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new tiptap_core_esm_Node(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.options = mergeDeep(this.options, options);
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new tiptap_core_esm_Node(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name
            ? extendedConfig.name
            : extension.parent.name;
        if (extendedConfig.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

class tiptap_core_esm_Mark {
    constructor(config = {}) {
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new tiptap_core_esm_Mark(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend();
        extension.options = mergeDeep(this.options, options);
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new tiptap_core_esm_Mark(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name
            ? extendedConfig.name
            : extension.parent.name;
        if (extendedConfig.defaultOptions) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

class tiptap_core_esm_NodeView {
    constructor(component, props, options) {
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options,
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return null;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c;
        const { view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3
            ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]')
            : target.closest('[data-drag-handle]');
        if (!this.dom
            || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target))
            || !dragHandle) {
            return;
        }
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            x = handleBox.x - domBox.x + event.offsetX;
            y = handleBox.y - domBox.y + event.offsetY;
        }
        (_c = event.dataTransfer) === null || _c === void 0 ? void 0 : _c.setDragImage(this.dom, x, y);
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = index_es_NodeSelection.create(view.state.doc, this.getPos());
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) {
            return false;
        }
        if (typeof this.options.stopEvent === 'function') {
            return this.options.stopEvent({ event });
        }
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) {
            return false;
        }
        const isDropEvent = event.type === 'drop';
        const isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName)
            || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent) {
            return true;
        }
        const { isEditable } = this.editor;
        const { isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = index_es_NodeSelection.isSelectable(this.node);
        const isCopyEvent = event.type === 'copy';
        const isPasteEvent = event.type === 'paste';
        const isCutEvent = event.type === 'cut';
        const isClickEvent = event.type === 'mousedown';
        const isDragEvent = event.type.startsWith('drag');
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent) {
            event.preventDefault();
        }
        if (isDraggable && isDragEvent && !isDragging) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest('[data-drag-handle]');
            const isValidDragHandle = dragHandle
                && (this.dom === dragHandle || (this.dom.contains(dragHandle)));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener('dragend', () => {
                    this.isDragging = false;
                }, { once: true });
                document.addEventListener('mouseup', () => {
                    this.isDragging = false;
                }, { once: true });
            }
        }
        // these events are handled by prosemirror
        if (isDragging
            || isDropEvent
            || isCopyEvent
            || isPasteEvent
            || isCutEvent
            || (isClickEvent && isSelectable)) {
            return false;
        }
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) {
            return true;
        }
        if (typeof this.options.ignoreMutation === 'function') {
            return this.options.ignoreMutation({ mutation });
        }
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) {
            return true;
        }
        // ProseMirror should handle any selections
        if (mutation.type === 'selection') {
            return false;
        }
        // try to prevent a bug on iOS that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        if (this.dom.contains(mutation.target)
            && mutation.type === 'childList'
            && isiOS()
            && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes),
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every(node => node.isContentEditable)) {
                return false;
            }
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === 'attributes') {
            return true;
        }
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) {
            return false;
        }
        return true;
    }
    updateAttributes(attributes) {
        this.editor.commands.command(({ tr }) => {
            const pos = this.getPos();
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes,
            });
            return true;
        });
    }
    deleteNode() {
        const from = this.getPos();
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({ from, to });
    }
}

class Tracker {
    constructor(transaction) {
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps
            .slice(this.currentStep)
            .reduce((newPosition, step) => {
            const mapResult = step
                .getMap()
                .mapResult(newPosition);
            if (mapResult.deleted) {
                deleted = true;
            }
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted,
        };
    }
}

/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 */
function nodeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const { tr } = state;
            const start = range.from;
            let end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) {
                    matchStart = end;
                }
                else {
                    end = matchStart + match[1].length;
                }
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, config.type.create(attributes));
            }
            else if (match[0]) {
                tr.replaceWith(start, end, config.type.create(attributes));
            }
        },
    });
}

function getMarksBetween(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) {
        doc
            .resolve(from)
            .marks()
            .forEach(mark => {
            const $pos = doc.resolve(from - 1);
            const range = getMarkRange($pos, mark.type);
            if (!range) {
                return;
            }
            marks.push({
                mark,
                ...range,
            });
        });
    }
    else {
        doc.nodesBetween(from, to, (node, pos) => {
            marks.push(...node.marks.map(mark => ({
                from: pos,
                to: pos + node.nodeSize,
                mark,
            })));
        });
    }
    return marks;
}

/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 */
function markInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 */
function textblockTypeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const $start = state.doc.resolve(range.from);
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
                return null;
            }
            state.tr
                .delete(range.from, range.to)
                .setBlockType(range.from, range.from, config.type, attributes);
        },
    });
}

/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 */
function textInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 */
function wrappingInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && findWrapping(blockRange, config.type, attributes);
            if (!wrapping) {
                return null;
            }
            tr.wrap(blockRange, wrapping);
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before
                && before.type === config.type
                && canJoin(tr.doc, range.from - 1)
                && (!config.joinPredicate || config.joinPredicate(match, before))) {
                tr.join(range.from - 1);
            }
        },
    });
}

/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 */
function markPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 */
function textPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

// source: https://stackoverflow.com/a/6969486
function escapeForRegEx(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 */
function combineTransactionSteps(oldDoc, transactions) {
    const transform = new index_es_Transform(oldDoc);
    transactions.forEach(transaction => {
        transaction.steps.forEach(step => {
            transform.step(step);
        });
    });
    return transform;
}

function tiptap_core_esm_defaultBlockAt(match) {
    for (let i = 0; i < match.edgeCount; i += 1) {
        const { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) {
            return type;
        }
    }
    return null;
}

function findChildren(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Same as `findChildren` but searches only within a `range`.
 */
function findChildrenInRange(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

function getSchema(extensions) {
    const resolvedExtensions = tiptap_core_esm_ExtensionManager.resolve(extensions);
    return getSchemaByResolvedExtensions(resolvedExtensions);
}

function generateHTML(doc, extensions) {
    const schema = getSchema(extensions);
    const contentNode = index_es_Node.fromJSON(schema, doc);
    return getHTMLFromFragment(contentNode.content, schema);
}

function generateJSON(html, extensions) {
    const schema = getSchema(extensions);
    const dom = elementFromString(html);
    return DOMParser.fromSchema(schema)
        .parse(dom)
        .toJSON();
}

function generateText(doc, extensions, options) {
    const { blockSeparator = '\n\n', textSerializers = {}, } = options || {};
    const schema = getSchema(extensions);
    const contentNode = index_es_Node.fromJSON(schema, doc);
    return getText(contentNode, {
        blockSeparator,
        textSerializers: {
            ...textSerializers,
            ...getTextSeralizersFromSchema(schema),
        },
    });
}

/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */
function simplifyChangedRanges(changes) {
    const uniqueChanges = removeDuplicates(changes);
    return uniqueChanges.length === 1
        ? uniqueChanges
        : uniqueChanges.filter((change, index) => {
            const rest = uniqueChanges.filter((_, i) => i !== index);
            return !rest.some(otherChange => {
                return change.oldRange.from >= otherChange.oldRange.from
                    && change.oldRange.to <= otherChange.oldRange.to
                    && change.newRange.from >= otherChange.newRange.from
                    && change.newRange.to <= otherChange.newRange.to;
            });
        });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */
function getChangedRanges(transform) {
    const { mapping, steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index) => {
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from, to } = steps[index];
            if (from === undefined || to === undefined) {
                return;
            }
            ranges.push({ from, to });
        }
        else {
            stepMap.forEach((from, to) => {
                ranges.push({ from, to });
            });
        }
        ranges.forEach(({ from, to }) => {
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd,
                },
                newRange: {
                    from: newStart,
                    to: newEnd,
                },
            });
        });
    });
    return simplifyChangedRanges(changes);
}

function getDebugJSON(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map(mark => {
        const output = {
            type: mark.type.name,
        };
        if (Object.keys(mark.attrs).length) {
            output.attrs = { ...mark.attrs };
        }
        return output;
    });
    const attrs = { ...node.attrs };
    const output = {
        type: node.type.name,
        from,
        to,
    };
    if (Object.keys(attrs).length) {
        output.attrs = attrs;
    }
    if (marks.length) {
        output.marks = marks;
    }
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset) => {
            var _a;
            (_a = output.content) === null || _a === void 0 ? void 0 : _a.push(getDebugJSON(child, startOffset + offset + increment));
        });
    }
    if (node.text) {
        output.text = node.text;
    }
    return output;
}

function isNodeSelection(value) {
    return isObject(value) && value instanceof index_es_NodeSelection;
}

function posToDOMRect(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = minMax(from, minPos, maxPos);
    const resolvedEnd = minMax(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top,
        bottom,
        left,
        right,
        width,
        height,
        x,
        y,
    };
    return {
        ...data,
        toJSON: () => data,
    };
}


//# sourceMappingURL=tiptap-core.esm.js.map

// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle_getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle_getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle_getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle_getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var enums_bottom = 'bottom';
var enums_right = 'right';
var enums_left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, enums_bottom, enums_right, enums_left];
var enums_start = 'start';
var enums_end = 'end';
var enums_clippingParents = 'clippingParents';
var viewport = 'viewport';
var enums_popper = 'popper';
var enums_reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + enums_start, placement + "-" + enums_end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + enums_start, placement + "-" + enums_end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper_createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case enums_bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case enums_right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case enums_left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case enums_start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case enums_end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets_popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets_popperOffsets,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = enums_left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle_getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === enums_left || placement === enums_right) && variation === enums_end) {
      sideY = enums_bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === enums_left || (placement === enums_top || placement === enums_bottom) && variation === enums_end) {
      sideX = enums_right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [enums_left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [enums_left, enums_right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset_offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset_offset
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle_getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle_getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums_clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums_popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === enums_popper ? enums_reference : enums_popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums_popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums_popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums_right, enums_bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, enums_bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === enums_start;
    var isVertical = [enums_top, enums_bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums_right : enums_left : isStartVariation ? enums_bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : enums_left;
    var altSide = mainAxis === 'y' ? enums_bottom : enums_right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums_start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums_start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : enums_left;

    var _altSide = mainAxis === 'x' ? enums_bottom : enums_right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, enums_left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var arrow_toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow_arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [enums_left, enums_right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = arrow_toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : enums_left;
  var maxProp = axis === 'y' ? enums_bottom : enums_right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow_arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, enums_right, enums_bottom, enums_left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide_hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide_hide
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var popper_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.esm.js
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function tippy_esm_hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function tippy_esm_debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function tippy_esm_getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function tippy_esm_isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (tippy_esm_isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = tippy_esm_getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (false) {}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {}

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !tippy_esm_hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (tippy_esm_isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function tippy_esm_setContent(content, props) {
  if (tippy_esm_isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function tippy_esm_render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  tippy_esm_setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      tippy_esm_setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

tippy_esm_render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {}

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = popper_createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {}
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {}

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {}

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) { var isMoreThanOneReferenceElement, isSingleContentElement; }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return tippy_esm_isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, modifiers_applyStyles, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {}

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {}

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {}

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(tippy_esm_getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: tippy_esm_render
});

/* harmony default export */ var tippy_esm = (tippy);

//# sourceMappingURL=tippy.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bubble-menu/dist/tiptap-extension-bubble-menu.esm.js




class tiptap_extension_bubble_menu_esm_BubbleMenuView {
    constructor({ editor, element, view, tippyOptions = {}, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state, from, to, }) => {
            const { doc, selection } = state;
            const { empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length
                && isTextSelection(state.selection);
            if (!view.hasFocus()
                || empty
                || isEmptyTextBlock) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.dragstartHandler = () => {
            this.hide();
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget)
                && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            this.hide();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.addEventListener('dragstart', this.dragstartHandler);
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy_esm(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'top',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', event => {
                this.blurHandler({ event });
            });
        }
    }
    update(view, oldState) {
        var _a, _b;
        const { state, composing } = view;
        const { doc, selection } = state;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (composing || isSame) {
            return;
        }
        this.createTooltip();
        // support for CellSelections
        const { ranges } = selection;
        const from = Math.min(...ranges.map(range => range.$from.pos));
        const to = Math.max(...ranges.map(range => range.$to.pos));
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view,
            state,
            oldState,
            from,
            to,
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
            getReferenceClientRect: () => {
                if (isNodeSelection(state.selection)) {
                    const node = view.nodeDOM(from);
                    if (node) {
                        return node.getBoundingClientRect();
                    }
                }
                return posToDOMRect(view, from, to);
            },
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.removeEventListener('dragstart', this.dragstartHandler);
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const BubbleMenuPlugin = (options) => {
    return new Plugin({
        key: typeof options.pluginKey === 'string'
            ? new PluginKey(options.pluginKey)
            : options.pluginKey,
        view: view => new tiptap_extension_bubble_menu_esm_BubbleMenuView({ view, ...options }),
    });
};

const BubbleMenu = Extension.create({
    name: 'bubbleMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'bubbleMenu',
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            BubbleMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-bubble-menu.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-floating-menu/dist/tiptap-extension-floating-menu.esm.js




class tiptap_extension_floating_menu_esm_FloatingMenuView {
    constructor({ editor, element, view, tippyOptions = {}, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state }) => {
            const { selection } = state;
            const { $anchor, empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock
                && !$anchor.parent.type.spec.code
                && !$anchor.parent.textContent;
            if (!view.hasFocus()
                || !empty
                || !isRootDepth
                || !isEmptyTextBlock) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget)
                && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            this.hide();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy_esm(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'right',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', event => {
                this.blurHandler({ event });
            });
        }
    }
    update(view, oldState) {
        var _a, _b;
        const { state } = view;
        const { doc, selection } = state;
        const { from, to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) {
            return;
        }
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view,
            state,
            oldState,
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
            getReferenceClientRect: () => posToDOMRect(view, from, to),
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const FloatingMenuPlugin = (options) => {
    return new Plugin({
        key: typeof options.pluginKey === 'string'
            ? new PluginKey(options.pluginKey)
            : options.pluginKey,
        view: view => new tiptap_extension_floating_menu_esm_FloatingMenuView({ view, ...options }),
    });
};

const FloatingMenu = Extension.create({
    name: 'floatingMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'floatingMenu',
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            FloatingMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-floating-menu.esm.js.map

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/@tiptap/vue-2/dist/tiptap-vue-2.esm.js






const tiptap_vue_2_esm_BubbleMenu = {
    name: 'BubbleMenu',
    props: {
        pluginKey: {
            type: [String, Object],
            default: 'bubbleMenu',
        },
        editor: {
            type: Object,
            required: true,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        shouldShow: {
            type: Function,
            default: null,
        },
    },
    watch: {
        editor: {
            immediate: true,
            handler(editor) {
                if (!editor) {
                    return;
                }
                this.$nextTick(() => {
                    editor.registerPlugin(BubbleMenuPlugin({
                        pluginKey: this.pluginKey,
                        editor,
                        element: this.$el,
                        tippyOptions: this.tippyOptions,
                        shouldShow: this.shouldShow,
                    }));
                });
            },
        },
    },
    render(createElement) {
        return createElement('div', { style: { visibility: 'hidden' } }, this.$slots.default);
    },
    beforeDestroy() {
        this.editor.unregisterPlugin(this.pluginKey);
    },
};

class tiptap_vue_2_esm_Editor extends tiptap_core_esm_Editor {
    constructor() {
        super(...arguments);
        this.contentComponent = null;
    }
}

const EditorContent = {
    name: 'EditorContent',
    props: {
        editor: {
            default: null,
            type: Object,
        },
    },
    watch: {
        editor: {
            immediate: true,
            handler(editor) {
                if (editor && editor.options.element) {
                    this.$nextTick(() => {
                        const element = this.$el;
                        if (!element || !editor.options.element.firstChild) {
                            return;
                        }
                        element.append(...editor.options.element.childNodes);
                        editor.contentComponent = this;
                        editor.setOptions({
                            element,
                        });
                        editor.createNodeViews();
                    });
                }
            },
        },
    },
    render(createElement) {
        return createElement('div');
    },
    beforeDestroy() {
        const { editor } = this;
        if (!editor) {
            return;
        }
        if (!editor.isDestroyed) {
            editor.view.setProps({
                nodeViews: {},
            });
        }
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) {
            return;
        }
        const newElement = document.createElement('div');
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement,
        });
    },
};

const tiptap_vue_2_esm_FloatingMenu = {
    name: 'FloatingMenu',
    props: {
        pluginKey: {
            type: [String, Object],
            default: 'floatingMenu',
        },
        editor: {
            type: Object,
            required: true,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        shouldShow: {
            type: Function,
            default: null,
        },
    },
    watch: {
        editor: {
            immediate: true,
            handler(editor) {
                if (!editor) {
                    return;
                }
                this.$nextTick(() => {
                    editor.registerPlugin(FloatingMenuPlugin({
                        pluginKey: this.pluginKey,
                        editor,
                        element: this.$el,
                        tippyOptions: this.tippyOptions,
                        shouldShow: this.shouldShow,
                    }));
                });
            },
        },
    },
    render(createElement) {
        return createElement('div', { style: { visibility: 'hidden' } }, this.$slots.default);
    },
    beforeDestroy() {
        this.editor.unregisterPlugin(this.pluginKey);
    },
};

class tiptap_vue_2_esm_VueRenderer {
    constructor(component, props) {
        const Component = external_vue_default.a.extend(component);
        this.ref = new Component(props).$mount();
    }
    get element() {
        return this.ref.$el;
    }
    updateProps(props = {}) {
        if (!this.ref.$props) {
            return;
        }
        // prevents `Avoid mutating a prop directly` error message
        const originalSilent = external_vue_default.a.config.silent;
        external_vue_default.a.config.silent = true;
        Object
            .entries(props)
            .forEach(([key, value]) => {
            this.ref.$props[key] = value;
        });
        external_vue_default.a.config.silent = originalSilent;
    }
    destroy() {
        this.ref.$destroy();
    }
}

const nodeViewProps = {
    editor: {
        type: Object,
        required: true,
    },
    node: {
        type: Object,
        required: true,
    },
    decorations: {
        type: Object,
        required: true,
    },
    selected: {
        type: Boolean,
        required: true,
    },
    extension: {
        type: Object,
        required: true,
    },
    getPos: {
        type: Function,
        required: true,
    },
    updateAttributes: {
        type: Function,
        required: true,
    },
    deleteNode: {
        type: Function,
        required: true,
    },
};
class tiptap_vue_2_esm_VueNodeView extends tiptap_core_esm_NodeView {
    mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            selected: false,
            extension: this.extension,
            getPos: () => this.getPos(),
            updateAttributes: (attributes = {}) => this.updateAttributes(attributes),
            deleteNode: () => this.deleteNode(),
        };
        const onDragStart = this.onDragStart.bind(this);
        this.decorationClasses = external_vue_default.a.observable({
            value: this.getDecorationClasses(),
        });
        const Component = external_vue_default.a
            .extend(this.component)
            .extend({
            props: Object.keys(props),
            provide: () => {
                return {
                    onDragStart,
                    decorationClasses: this.decorationClasses,
                };
            },
        });
        this.renderer = new tiptap_vue_2_esm_VueRenderer(Component, {
            parent: this.editor.contentComponent,
            propsData: props,
        });
    }
    get dom() {
        if (!this.renderer.element.hasAttribute('data-node-view-wrapper')) {
            throw Error('Please use the NodeViewWrapper component for your node view.');
        }
        return this.renderer.element;
    }
    get contentDOM() {
        if (this.node.isLeaf) {
            return null;
        }
        const contentElement = this.dom.querySelector('[data-node-view-content]');
        return contentElement || this.dom;
    }
    update(node, decorations) {
        const updateProps = (props) => {
            this.decorationClasses.value = this.getDecorationClasses();
            this.renderer.updateProps(props);
        };
        if (typeof this.options.update === 'function') {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            this.node = node;
            this.decorations = decorations;
            return this.options.update({
                oldNode,
                oldDecorations,
                newNode: node,
                newDecorations: decorations,
                updateProps: () => updateProps({ node, decorations }),
            });
        }
        if (node.type !== this.node.type) {
            return false;
        }
        if (node === this.node && this.decorations === decorations) {
            return true;
        }
        this.node = node;
        this.decorations = decorations;
        updateProps({ node, decorations });
        return true;
    }
    selectNode() {
        this.renderer.updateProps({
            selected: true,
        });
    }
    deselectNode() {
        this.renderer.updateProps({
            selected: false,
        });
    }
    getDecorationClasses() {
        return this.decorations
            // @ts-ignore
            .map(item => item.type.attrs.class)
            .flat()
            .join(' ');
    }
    destroy() {
        this.renderer.destroy();
    }
}
function VueNodeViewRenderer(component, options) {
    return (props) => {
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) {
            return {};
        }
        return new tiptap_vue_2_esm_VueNodeView(component, props, options);
    };
}

const NodeViewWrapper = {
    props: {
        as: {
            type: String,
            default: 'div',
        },
    },
    inject: ['onDragStart', 'decorationClasses'],
    render(createElement) {
        return createElement(this.as, {
            class: this.decorationClasses.value,
            style: {
                whiteSpace: 'normal',
            },
            attrs: {
                'data-node-view-wrapper': '',
            },
            on: {
                dragstart: this.onDragStart,
            },
        }, this.$slots.default);
    },
};

const NodeViewContent = {
    props: {
        as: {
            type: String,
            default: 'div',
        },
    },
    render(createElement) {
        return createElement(this.as, {
            style: {
                whiteSpace: 'pre-wrap',
            },
            attrs: {
                'data-node-view-content': '',
            },
        });
    },
};


//# sourceMappingURL=tiptap-vue-2.esm.js.map

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-document/dist/tiptap-extension-document.esm.js


const Document = tiptap_core_esm_Node.create({
    name: 'doc',
    topNode: true,
    content: 'block+',
});


//# sourceMappingURL=tiptap-extension-document.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-paragraph/dist/tiptap-extension-paragraph.esm.js


const Paragraph = tiptap_core_esm_Node.create({
    name: 'paragraph',
    priority: 1000,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML() {
        return [
            { tag: 'p' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setParagraph: () => ({ commands }) => {
                return commands.setNode(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-0': () => this.editor.commands.setParagraph(),
        };
    },
});


//# sourceMappingURL=tiptap-extension-paragraph.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-text/dist/tiptap-extension-text.esm.js


const Text = tiptap_core_esm_Node.create({
    name: 'text',
    group: 'inline',
});


//# sourceMappingURL=tiptap-extension-text.esm.js.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-placeholder/dist/tiptap-extension-placeholder.esm.js




const Placeholder = Extension.create({
    name: 'placeholder',
    addOptions() {
        return {
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            placeholder: 'Write something …',
            showOnlyWhenEditable: true,
            showOnlyCurrent: true,
            includeChildren: false,
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    decorations: ({ doc, selection }) => {
                        const active = this.editor.isEditable || !this.options.showOnlyWhenEditable;
                        const { anchor } = selection;
                        const decorations = [];
                        if (!active) {
                            return;
                        }
                        doc.descendants((node, pos) => {
                            const hasAnchor = anchor >= pos && anchor <= (pos + node.nodeSize);
                            const isEmpty = !node.isLeaf && !node.childCount;
                            if ((hasAnchor || !this.options.showOnlyCurrent) && isEmpty) {
                                const classes = [this.options.emptyNodeClass];
                                if (this.editor.isEmpty) {
                                    classes.push(this.options.emptyEditorClass);
                                }
                                const decoration = Decoration.node(pos, pos + node.nodeSize, {
                                    class: classes.join(' '),
                                    'data-placeholder': typeof this.options.placeholder === 'function'
                                        ? this.options.placeholder({
                                            editor: this.editor,
                                            node,
                                            pos,
                                            hasAnchor,
                                        })
                                        : this.options.placeholder,
                                });
                                decorations.push(decoration);
                            }
                            return this.options.includeChildren;
                        });
                        return DecorationSet.create(doc, decorations);
                    },
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-placeholder.esm.js.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/NodeDragHandle.vue?vue&type=template&id=51de8275&scoped=true&
var NodeDragHandlevue_type_template_id_51de8275_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dragHandleElement",staticClass:"mayday-editor__drag-icon-container",staticStyle:{"visibility":"hidden"},style:({ width: _vm.width }),on:{"mouseleave":_vm.closeOnMouseLeave,"mouseenter":_vm.showDragIconOnMouseEnter}},[_c('div',{staticClass:"mayday-editor__drag-icon"},[_c('div',{staticClass:"mayday-editor__drag-icon__wrapper",on:{"click":_vm.handleOpenMenu}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDragIcon),expression:"showDragIcon"}],staticClass:"mayday-editor__drag-icon__wrapper__img",attrs:{"aria-hidden":"true"}}),(_vm.isNodePopulated)?_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDragIcon),expression:"!showDragIcon"}],staticClass:"mayday-editor__drag-icon__wrapper__node-icon",attrs:{"icon":['fas', _vm.icon]}}):_vm._e()],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menu),expression:"menu"}],staticClass:"mayday-editor__drag-options"},[_c('div',{staticClass:"mayday-editor__drag-options__wrapper"},[_c('button',{staticClass:"mayday-editor__drag-options__button",on:{"click":_vm.handleCopy}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'link']}}),_c('div',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.options.copy")))])],1)])])])}
var NodeDragHandlevue_type_template_id_51de8275_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/NodeDragHandle.vue?vue&type=template&id=51de8275&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/NodeDragHandle.vue?vue&type=script&lang=ts&











var NodeDragHandlevue_type_script_lang_ts_a, NodeDragHandlevue_type_script_lang_ts_b, NodeDragHandlevue_type_script_lang_ts_c;






var WIDTH = 36;

var NodeDragHandlevue_type_script_lang_ts_isPopulated = function isPopulated(node) {
  return node instanceof index_es_Node;
};

var icons = {
  paragraph: "paragraph",
  bulletList: "list-ul",
  orderedList: "list-ol",
  heading: ["h1", "h2", "h3", "h4"],
  image: "image",
  blockquote: "quote-right",
  codeBlock: "code",
  table: "table",
  callout: "lightbulb",
  embed: "window",
  attachment: "paperclip",
  details: "compress-alt",
  doc: "file-alt"
};

var NodeDragHandlevue_type_script_lang_ts_NodeDragHandle = /*#__PURE__*/function (_Vue) {
  _inherits(NodeDragHandle, _Vue);

  var _super = _createSuper(NodeDragHandle);

  function NodeDragHandle() {
    var _this;

    _classCallCheck(this, NodeDragHandle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "node", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "nodeDOM", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "width", "".concat(WIDTH, "px"));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "icons", icons);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "showDragIcon", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "menu", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    return _this;
  }

  _createClass(NodeDragHandle, [{
    key: "isDragging",
    get: function get() {
      return this.editor.view.dragging != null;
    }
  }, {
    key: "isNodePopulated",
    get: function get() {
      return NodeDragHandlevue_type_script_lang_ts_isPopulated(this.node);
    }
  }, {
    key: "nodeType",
    get: function get() {
      return NodeDragHandlevue_type_script_lang_ts_isPopulated(this.node) && this.isIconName(this.node.type.name) ? this.node.type.name : null;
    }
  }, {
    key: "icon",
    get: function get() {
      if (!NodeDragHandlevue_type_script_lang_ts_isPopulated(this.node)) {
        return "";
      }

      if (this.nodeType === "heading") {
        var idx = this.node.attrs.level - 1;
        return this.icons.heading[idx];
      }

      return this.nodeType != null ? this.icons[this.nodeType] : "";
    }
  }, {
    key: "created",
    value: function created() {
      window.addEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "isIconName",
    value: function isIconName(name) {
      return Object.keys(this.icons).some(function (iconName) {
        return iconName === name;
      });
    }
  }, {
    key: "showDragIconOnMouseEnter",
    value: function showDragIconOnMouseEnter() {
      var _this$nodeDOM, _this$nodeDOM$attribu, _this$nodeDOM$attribu2;

      this.showDragIcon = ((_this$nodeDOM = this.nodeDOM) === null || _this$nodeDOM === void 0 ? void 0 : (_this$nodeDOM$attribu = _this$nodeDOM.attributes) === null || _this$nodeDOM$attribu === void 0 ? void 0 : (_this$nodeDOM$attribu2 = _this$nodeDOM$attribu.getNamedItem("draggable")) === null || _this$nodeDOM$attribu2 === void 0 ? void 0 : _this$nodeDOM$attribu2.value) !== "false";
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.hideDragHandleElement();
    }
  }, {
    key: "closeOnMouseLeave",
    value: function closeOnMouseLeave() {
      this.menu = false;
      this.hideDragHandleElement();
    }
  }, {
    key: "hideDragHandleElement",
    value: function hideDragHandleElement() {
      var dragHandleElement = this.$refs.dragHandleElement;
      dragHandleElement.style.visibility = "hidden";
      this.showDragIcon = false;
    }
  }, {
    key: "uniqueId",
    get: function get() {
      var _this$node, _this$node$attrs;

      return (_this$node = this.node) === null || _this$node === void 0 ? void 0 : (_this$node$attrs = _this$node.attrs) === null || _this$node$attrs === void 0 ? void 0 : _this$node$attrs.uid;
    }
  }, {
    key: "handleOpenMenu",
    value: function handleOpenMenu() {
      if (this.uniqueId) this.menu = true;
    }
  }, {
    key: "handleCopy",
    value: function handleCopy() {
      this.menu = false;
      if (!this.uniqueId) return;
      this.$parent.$emit("click:copy", this.uniqueId);
    }
  }]);

  return NodeDragHandle;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], NodeDragHandlevue_type_script_lang_ts_NodeDragHandle.prototype, "node", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], NodeDragHandlevue_type_script_lang_ts_NodeDragHandle.prototype, "nodeDOM", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", typeof (NodeDragHandlevue_type_script_lang_ts_c = typeof tiptap_vue_2_esm_Editor !== "undefined" && tiptap_vue_2_esm_Editor) === "function" ? NodeDragHandlevue_type_script_lang_ts_c : Object)], NodeDragHandlevue_type_script_lang_ts_NodeDragHandle.prototype, "editor", void 0);

NodeDragHandlevue_type_script_lang_ts_NodeDragHandle = __decorate([external_vue_property_decorator_["Component"]], NodeDragHandlevue_type_script_lang_ts_NodeDragHandle);
/* harmony default export */ var NodeDragHandlevue_type_script_lang_ts_ = (NodeDragHandlevue_type_script_lang_ts_NodeDragHandle);
// CONCATENATED MODULE: ./src/components/NodeDragHandle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_NodeDragHandlevue_type_script_lang_ts_ = (NodeDragHandlevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/NodeDragHandle.vue?vue&type=style&index=0&id=51de8275&lang=scss&scoped=true&
var NodeDragHandlevue_type_style_index_0_id_51de8275_lang_scss_scoped_true_ = __webpack_require__("e4e9");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/NodeDragHandle.vue






/* normalize component */

var NodeDragHandle_component = normalizeComponent(
  components_NodeDragHandlevue_type_script_lang_ts_,
  NodeDragHandlevue_type_template_id_51de8275_scoped_true_render,
  NodeDragHandlevue_type_template_id_51de8275_scoped_true_staticRenderFns,
  false,
  null,
  "51de8275",
  null
  
)

/* harmony default export */ var components_NodeDragHandle = (NodeDragHandle_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/ImageWrapper.vue?vue&type=template&id=0679bb89&scoped=true&
var ImageWrappervue_type_template_id_0679bb89_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{class:_vm.imageWrapperClass,attrs:{"as":"span","draggable":"true"}},[_c('span',{staticClass:"mayday-editor__image-wrapper__container"},[(!_vm.isInTable)?_c('div',{staticClass:"mayday-editor__image-wrapper__container__handle mayday-editor__image-wrapper__container__handle--left",style:(_vm.handleStyle),on:{"mousedown":function($event){return _vm.handleStartResize($event, true)}}}):_vm._e(),_c('img',_vm._b({staticClass:"mayday-editor__image-wrapper__container__image",class:_vm.imageClass,style:(_vm.imageStyle),attrs:{"data-drag-handle":"","data-uid":_vm.node.attrs.uid},on:{"click":_vm.handleClickEvent}},'img',_vm.imageAttributes,false)),(!_vm.isInTable)?_c('div',{staticClass:"mayday-editor__image-wrapper__container__handle mayday-editor__image-wrapper__container__handle--right",style:(_vm.handleStyle),on:{"mousedown":function($event){return _vm.handleStartResize($event, false)}}}):_vm._e()])])}
var ImageWrappervue_type_template_id_0679bb89_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/ImageWrapper.vue?vue&type=template&id=0679bb89&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("1da1");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-image/dist/tiptap-extension-image.esm.js


const inputRegex = /(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;
const tiptap_extension_image_esm_Image = tiptap_core_esm_Node.create({
    name: 'image',
    addOptions() {
        return {
            inline: false,
            allowBase64: false,
            HTMLAttributes: {},
        };
    },
    inline() {
        return this.options.inline;
    },
    group() {
        return this.options.inline ? 'inline' : 'block';
    },
    draggable: true,
    addAttributes() {
        return {
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
            title: {
                default: null,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.allowBase64
                    ? 'img[src]'
                    : 'img[src]:not([src^="data:"])',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands() {
        return {
            setImage: options => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },
        };
    },
    addInputRules() {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: match => {
                    const [, , alt, src, title] = match;
                    return { src, alt, title };
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-image.esm.js.map

// EXTERNAL MODULE: ./src/store/actions.ts
var actions = __webpack_require__("fc60");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// CONCATENATED MODULE: ./src/extensions/Attachment/types.ts


var _typeNames, _mimeTypes;










var Type;

(function (Type) {
  Type[Type["SHEET"] = 1] = "SHEET";
  Type[Type["PDF"] = 2] = "PDF";
  Type[Type["VIDEO"] = 3] = "VIDEO";
  Type[Type["OTHER"] = 4] = "OTHER";
  Type[Type["DOC"] = 5] = "DOC";
  Type[Type["SLIDE"] = 6] = "SLIDE";
})(Type || (Type = {}));

var types_typeNames = (_typeNames = {}, Object(defineProperty["a" /* default */])(_typeNames, Type.SHEET, "sheet"), Object(defineProperty["a" /* default */])(_typeNames, Type.PDF, "pdf"), Object(defineProperty["a" /* default */])(_typeNames, Type.VIDEO, "video"), Object(defineProperty["a" /* default */])(_typeNames, Type.OTHER, "other"), Object(defineProperty["a" /* default */])(_typeNames, Type.DOC, "doc"), Object(defineProperty["a" /* default */])(_typeNames, Type.SLIDE, "slide"), _typeNames);
var types_mimeTypes = (_mimeTypes = {}, Object(defineProperty["a" /* default */])(_mimeTypes, Type.SHEET, [// xls
"application/vnd.ms-excel", // xlsx
"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsm
"application/vnd.ms-excel.sheet.macroEnabled.12", "application/vnd.ms-excel.sheet.macroenabled.12"]), Object(defineProperty["a" /* default */])(_mimeTypes, Type.PDF, ["application/pdf"]), Object(defineProperty["a" /* default */])(_mimeTypes, Type.VIDEO, ["video/mpeg", "video/mp4", "video/quicktime"]), Object(defineProperty["a" /* default */])(_mimeTypes, Type.OTHER, [// mp3 cross-browser
"audio/mpeg", "audio/mp3", // csv
"text/csv", // images
"image/png", "image/jpeg", "image/svg", "image/svg+xml", // zip
"application/zip", "application/x-7z-compressed", "application/x-zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"]), Object(defineProperty["a" /* default */])(_mimeTypes, Type.DOC, [// doc
"application/msword", // docx
"application/vnd.openxmlformats-officedocument.wordprocessingml.document"]), Object(defineProperty["a" /* default */])(_mimeTypes, Type.SLIDE, [// ppt
"application/vnd.ms-powerpoint", // pptx
"application/vnd.openxmlformats-officedocument.presentationml.presentation"]), _mimeTypes);
var authorizedMimeTypesList = Object.values(types_mimeTypes);
var authorizedMimeTypes = authorizedMimeTypesList.flat();
var computeAttachmentType = function computeAttachmentType(mimeType) {
  var idx = authorizedMimeTypesList.findIndex(function (types) {
    return Array.from(types).includes(mimeType);
  }); // if not found, return OTHER

  return (idx != -1 ? idx : 3) + 1;
};
var unknownExtensionMapping = {
  pbix: "application/octet-stream"
};
var unknownExtensions = Object.keys(unknownExtensionMapping);
// CONCATENATED MODULE: ./src/utils/hasFiles.ts
var hasFiles = function hasFiles(files) {
  return files != null && !!files.length;
};

/* harmony default export */ var utils_hasFiles = (hasFiles);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./src/utils/generateAttachmentList.ts











var generateAttachmentList_generateAttachmentList = function generateAttachmentList(files) {
  var shouldAcceptImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return Array.from(files || []).reduce(function (acc, file) {
    if (!file.type) {
      var extension = file.name.split(".").pop();

      if (extension && unknownExtensions.includes(extension)) {
        var newType = unknownExtensionMapping[extension];
        file = new File([file.slice(0, file.size, newType)], file.name, {
          type: newType
        });
      }
    }

    if (!shouldAcceptImage && imageTypeRegex.test(file.type)) {
      acc.nonAuthorizedFiles.push(file);
      return acc;
    }

    acc.validFiles.push(file);
    return acc;
  }, {
    validFiles: [],
    nonAuthorizedFiles: []
  });
};
// CONCATENATED MODULE: ./src/utils/generateImageList.ts





var imageTypeRegex = /image/i;
var generateImageList = function generateImageList(files) {
  return Array.from(files || []).reduce(function (acc, file) {
    if (imageTypeRegex.test(file.type)) {
      acc.validFiles.push(file);
    } else acc.nonAuthorizedFiles.push(file);

    return acc;
  }, {
    validFiles: [],
    nonAuthorizedFiles: []
  });
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./src/utils/resolveImage.ts



var resolveImage = function resolveImage(src) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return new Promise(function (resolve, reject) {
    var result = {
      complete: false,
      width: defaultValue,
      height: defaultValue,
      src: src
    };

    if (src == null) {
      reject(result);
      return;
    }

    var img = new Image();

    img.onload = function () {
      result.width = img.width;
      result.height = img.height;
      result.complete = true;
      resolve(result);
    };

    img.onerror = function () {
      resolve(result);
    };

    img.src = src;
  });
};

/* harmony default export */ var utils_resolveImage = (resolveImage);
// CONCATENATED MODULE: ./src/utils/computeNumberToPixels.ts



var computeNumberToPixels = function computeNumberToPixels(size) {
  if (typeof size === "number") return "".concat(size, "px");
  if (!size.includes("px")) return "".concat(size, "px");
  return size;
};

/* harmony default export */ var utils_computeNumberToPixels = (computeNumberToPixels);
// CONCATENATED MODULE: ./src/utils/dropAndPasteHandler.ts













var insertNode = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var view, file, extensionName, coordinates, isDragEvent, isAttachment, minSize, normalize, schema, url, name, mimeType, attributes, result, width, height, attrs, finalAttributes, node, transaction;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            view = _ref.view, file = _ref.file, extensionName = _ref.extensionName, coordinates = _ref.coordinates, isDragEvent = _ref.isDragEvent, isAttachment = _ref.isAttachment, minSize = _ref.minSize, normalize = _ref.normalize;
            schema = view.state.schema;
            url = file.url, name = file.name, mimeType = file.mimeType;
            attributes = isAttachment ? {
              type: computeAttachmentType(mimeType),
              href: url,
              name: name,
              title: name
            } : {
              src: url,
              alt: name,
              title: name,
              width: "",
              height: ""
            };

            if (!(!isAttachment && minSize != null)) {
              _context.next = 12;
              break;
            }

            _context.next = 7;
            return utils_resolveImage(url, minSize);

          case 7:
            result = _context.sent;
            width = result.width, height = result.height;
            attrs = attributes;
            attrs.width = utils_computeNumberToPixels(width);
            attrs.height = utils_computeNumberToPixels(height);

          case 12:
            finalAttributes = isAttachment ? attributes : normalize === null || normalize === void 0 ? void 0 : normalize(attributes);
            node = schema.nodes[extensionName].create(finalAttributes);

            if (!(isDragEvent && coordinates == null)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return");

          case 16:
            transaction = isDragEvent && coordinates != null ? view.state.tr.insert(coordinates.pos, node) : view.state.tr.replaceSelectionWith(node);
            view.dispatch(transaction);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function insertNode(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var dropAndPasteHandler_handler = function handler(view, event, isFileUploadCallbackProvided, extensionName, storeAction, minSize, normalize) {
  if (!isFileUploadCallbackProvided) {
    return false;
  }

  var isAttachment = extensionName === "attachment";
  var isDragEvent = event instanceof DragEvent;
  var source = isDragEvent ? event.dataTransfer : event.clipboardData;

  if (source == null || !utils_hasFiles(source.files)) {
    return false;
  }

  var files = isAttachment ? generateAttachmentList_generateAttachmentList(source.files, false) : generateImageList(source.files);

  if (files.validFiles.length === 0) {
    console.error("[mayday-editor] no ".concat(extensionName, " to insert"));
    return false;
  }

  var coordinates = null;

  if (isDragEvent) {
    coordinates = view.posAtCoords({
      left: event.clientX,
      top: event.clientY
    }) || null;

    if (coordinates == null) {
      console.error("[mayday-editor] Couldn't get editor coordinates");
      return false;
    }
  }

  event.preventDefault();
  storeAction(files.validFiles).then(function (uploadedFiles) {
    uploadedFiles.forEach( /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(file == null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                insertNode({
                  view: view,
                  file: file,
                  extensionName: extensionName,
                  coordinates: coordinates,
                  isDragEvent: isDragEvent,
                  isAttachment: isAttachment,
                  minSize: minSize,
                  normalize: normalize
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  }, function () {
    console.error("[mayday-editor] ".concat(extensionName, " not inserted because file upload failed"));
  });
  return true;
};

/* harmony default export */ var dropAndPasteHandler = (dropAndPasteHandler_handler);
// CONCATENATED MODULE: ./src/utils/computePixelsToNumber.ts




var computePixelsToNumber = function computePixelsToNumber(size) {
  var match = size.match(/\d+/);
  return match !== null && match !== void 0 && match[0] ? Number(match[0]) : 0;
};

/* harmony default export */ var utils_computePixelsToNumber = (computePixelsToNumber);
// CONCATENATED MODULE: ./src/extensions/Image.ts












var MIN_SIZE = 40;
var MAX_SIZE = 400;
var clampSize = function clampSize(minSize, maxSize) {
  return function (value) {
    if (value < minSize) {
      return minSize;
    }

    if (value > maxSize) {
      return maxSize;
    }

    return value;
  };
};
var Image_normalizeImageSizeAttributes = function normalizeImageSizeAttributes(clamp, minSize) {
  return function (attributes) {
    var _width = attributes.width != null ? utils_computePixelsToNumber(attributes.width) : minSize;

    var _height = attributes.height != null ? utils_computePixelsToNumber(attributes.height) : minSize;

    var aspectRatio = _width / _height;
    var width = clamp(_width);
    var height = Math.round(width / aspectRatio);
    Object.assign(attributes, {
      width: utils_computeNumberToPixels(width),
      height: utils_computeNumberToPixels(height)
    });
    return attributes;
  };
};

var Image_computeCustomImageNode = function computeCustomImageNode(isFileUploadCallbackProvided, storeAction, maxImageWidth) {
  return tiptap_extension_image_esm_Image.extend({
    addStorage: function addStorage() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        isResizing: false,
        minSize: MIN_SIZE,
        maxSize: maxImageWidth != null ? maxImageWidth : MAX_SIZE
      });
    },
    addOptions: function addOptions() {
      var _this$parent2;

      return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
        inline: true,
        minSize: MIN_SIZE,
        maxSize: maxImageWidth != null ? maxImageWidth : MAX_SIZE
      });
    },
    addAttributes: function addAttributes() {
      var _this$parent3;

      return _objectSpread2(_objectSpread2({}, (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)), {}, {
        width: {
          default: Math.ceil((maxImageWidth || MAX_SIZE) * 0.75) + "px",
          parseHTML: function parseHTML(element) {
            return element.getAttribute("width");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              width: attrs.width
            };
          }
        },
        height: {
          parseHTML: function parseHTML(element) {
            return element.getAttribute("height");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              height: attrs.height
            };
          }
        },
        alt: {
          parseHTML: function parseHTML(element) {
            return element.getAttribute("alt");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              alt: attrs.alt
            };
          }
        },
        uid: {
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-uid");
          },
          renderHTML: function renderHTML(attrs) {
            return Object(defineProperty["a" /* default */])({}, "data-uid", attrs.uid);
          }
        }
      });
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_ImageWrapper);
    },
    addCommands: function addCommands() {
      var _this$parent4,
          _this = this;

      var _this$storage = this.storage,
          minSize = _this$storage.minSize,
          maxSize = _this$storage.maxSize;
      var clamp = clampSize(minSize, maxSize);
      var normalize = Image_normalizeImageSizeAttributes(clamp, minSize);
      return _objectSpread2(_objectSpread2({}, ((_this$parent4 = this.parent) === null || _this$parent4 === void 0 ? void 0 : _this$parent4.call(this)) || {}), {}, {
        setAlt: function setAlt(alt) {
          return function (_ref2) {
            var commands = _ref2.commands;
            return commands.updateAttributes(_this.name, {
              alt: alt
            });
          };
        },
        insertImage: function insertImage(attributes) {
          return function (_ref3) {
            var commands = _ref3.commands;
            return commands.setImage(normalize(attributes));
          };
        }
      });
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var name = this.name;
      var _this$options = this.options,
          minSize = _this$options.minSize,
          maxSize = _this$options.maxSize;
      var clamp = clampSize(minSize, maxSize);
      var normalize = Image_normalizeImageSizeAttributes(clamp, minSize);

      var handler = function handler(view, event) {
        return dropAndPasteHandler(view, event, isFileUploadCallbackProvided, name, storeAction, minSize, normalize);
      };

      return [new Plugin({
        key: new PluginKey(name),
        props: {
          handleDOMEvents: {
            drop: handler,
            paste: handler
          }
        }
      })];
    }
  });
};

/* harmony default export */ var extensions_Image = (Image_computeCustomImageNode);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/BaseNodeView.vue?vue&type=script&lang=ts&













var BaseNodeViewvue_type_script_lang_ts_BaseNodeView =
/*#__PURE__*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function (_Vue) {
  _inherits(BaseNodeView, _Vue);

  var _super = _createSuper(BaseNodeView);

  function BaseNodeView() {
    var _this;

    _classCallCheck(this, BaseNodeView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "node", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selected", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "getPos", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "extension", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "decorations", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "deleteNode", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "updateAttributes", void 0);

    return _this;
  }

  _createClass(BaseNodeView, [{
    key: "triggerNodeSelection",
    value: function triggerNodeSelection() {
      var _this$editor$view$sta = this.editor.view.state,
          doc = _this$editor$view$sta.doc,
          tr = _this$editor$view$sta.tr;
      var selection = index_es_NodeSelection.create(doc, this.getPos());
      this.editor.view.dispatch(tr.setSelection(selection).scrollIntoView());
    }
  }, {
    key: "removeNodeSelection",
    value: function removeNodeSelection() {
      var _this$editor$view$sta2 = this.editor.view.state,
          doc = _this$editor$view$sta2.doc,
          tr = _this$editor$view$sta2.tr;
      this.editor.view.dispatch(tr.setSelection(index_es_TextSelection.create(doc, 0)));
    }
  }]);

  return BaseNodeView;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "editor", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "node", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "selected", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "getPos", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "extension", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "decorations", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "deleteNode", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseNodeViewvue_type_script_lang_ts_BaseNodeView.prototype, "updateAttributes", void 0);

BaseNodeViewvue_type_script_lang_ts_BaseNodeView = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    NodeViewWrapper: NodeViewWrapper,
    NodeViewContent: NodeViewContent
  }
}) // eslint-disable-next-line @typescript-eslint/no-explicit-any
], BaseNodeViewvue_type_script_lang_ts_BaseNodeView);
/* harmony default export */ var BaseNodeViewvue_type_script_lang_ts_ = (BaseNodeViewvue_type_script_lang_ts_BaseNodeView);
// CONCATENATED MODULE: ./src/components/nodes/BaseNodeView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_BaseNodeViewvue_type_script_lang_ts_ = (BaseNodeViewvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/nodes/BaseNodeView.vue
var BaseNodeView_render, BaseNodeView_staticRenderFns




/* normalize component */

var BaseNodeView_component = normalizeComponent(
  nodes_BaseNodeViewvue_type_script_lang_ts_,
  BaseNodeView_render,
  BaseNodeView_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var nodes_BaseNodeView = (BaseNodeView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/ImageWrapper.vue?vue&type=script&lang=ts&








var _excluded = ["textAlign", "uid"];














var imageWrapperClass = "mayday-editor__image-wrapper";
var IMAGE_HANDLE_SIZE = 17; // handle width + handle margin + flex column gap

var ImageWrappervue_type_script_lang_ts_ImageWrapper = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(ImageWrapper, _BaseNodeView);

  var _super = _createSuper(ImageWrapper);

  function ImageWrapper() {
    var _this;

    _classCallCheck(this, ImageWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isResizingBlocked", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "resizeState", {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      isLeftHandle: false
    });

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "originalSize", {
      width: 0,
      height: 0
    });

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "aspectRatio", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isInTable", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "imageWrapperClass", imageWrapperClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "computePixelsToNumber", utils_computePixelsToNumber);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "computeNumberToPixels", utils_computeNumberToPixels);

    return _this;
  }

  _createClass(ImageWrapper, [{
    key: "created",
    value: function () {
      var _created = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _selection$$from$node;

        var selection, attributes, width, img, aspectRatio, height;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selection = this.editor.state.selection;
                attributes = this.node.attrs;
                width = this.computePixelsToNumber(attributes.width); // as no default value is declared for height, we resolve it here when
                // height is null

                if (attributes.height) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return utils_resolveImage(attributes.src, 0);

              case 6:
                img = _context.sent;
                aspectRatio = img.height / img.width;
                attributes.height = this.computeNumberToPixels(width * aspectRatio);

              case 9:
                height = this.computePixelsToNumber(attributes.height);
                this.aspectRatio = width / height;
                this.originalSize = {
                  width: width,
                  height: height
                };
                this.isInTable = ((_selection$$from$node = selection.$from.node(1)) === null || _selection$$from$node === void 0 ? void 0 : _selection$$from$node.type.name) === "table";

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.isResizing) {
        this.stopResizing();
      }
    }
  }, {
    key: "clampSize",
    get: function get() {
      var _this$extension$optio = this.extension.options,
          minSize = _this$extension$optio.minSize,
          maxSize = _this$extension$optio.maxSize;
      return clampSize(minSize, maxSize);
    }
  }, {
    key: "isResizing",
    get: function get() {
      var isResizing = this.extension.storage.isResizing;
      return isResizing;
    },
    set: function set(value) {
      var storage = this.extension.storage;
      storage.isResizing = value;
    }
  }, {
    key: "shouldShowWrapper",
    get: function get() {
      var editor = this.editor,
          selected = this.selected,
          isResizing = this.isResizing;
      return (selected || isResizing) && editor.isEditable;
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "imageAttributes",
    get: function get() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$node$attrs = this.node.attrs,
          textAlign = _this$node$attrs.textAlign,
          uid = _this$node$attrs.uid,
          attrs = _objectWithoutProperties(_this$node$attrs, _excluded);

      return attrs;
    }
  }, {
    key: "imageSize",
    get: function get() {
      var _this$node$attrs2 = this.node.attrs,
          width = _this$node$attrs2.width,
          height = _this$node$attrs2.height;
      return {
        width: this.computePixelsToNumber(width),
        height: this.computePixelsToNumber(height)
      };
    }
  }, {
    key: "imageStyle",
    get: function get() {
      var width = this.node.attrs.width;
      this.shouldShowWrapper;
      return this.editor.isEditable ? {} : {
        maxWidth: this.computeNumberToPixels(width),
        width: "100%",
        height: "auto"
      };
    }
  }, {
    key: "handleStyle",
    get: function get() {
      var height = this.handleHeight,
          shouldShowWrapper = this.shouldShowWrapper;
      var visibility = shouldShowWrapper ? "visible" : "hidden";
      var opacity = shouldShowWrapper ? 1 : 0;
      return {
        height: height,
        visibility: visibility,
        opacity: opacity,
        flex: "none"
      };
    }
  }, {
    key: "handleHeight",
    get: function get() {
      var height = this.imageAttributes.width;
      var match = height.match(/\d+/);
      return match !== null && match !== void 0 && match[0] ? this.computeNumberToPixels(Number(match[0]) / this.aspectRatio * 0.3) : "160px";
    }
  }, {
    key: "imageClass",
    get: function get() {
      var _ref;

      var classPrefix = "mayday-editor__image-wrapper__container__image";
      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, "".concat(classPrefix, "--selected"), this.shouldShowWrapper), Object(defineProperty["a" /* default */])(_ref, "".concat(classPrefix, "--resize-blocked"), this.isResizing && this.isResizingBlocked), _ref;
    }
  }, {
    key: "handleStartResize",
    value: function handleStartResize(event) {
      var isLeftHandle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      event.preventDefault();
      event.stopImmediatePropagation();
      var maxWidth = this.extension.options.maxSize;
      var width = Math.min(this.imageSize.width, maxWidth);
      var height = Math.round(this.imageSize.width / this.aspectRatio); // save current image size

      this.resizeState.width = width;
      this.resizeState.height = height;
      this.resizeState.x = event.clientX;
      this.resizeState.y = event.clientY;
      this.resizeState.isLeftHandle = isLeftHandle; // start resizing

      this.isResizing = true;
      this.startResizing();
    }
  }, {
    key: "startResizing",
    value: function startResizing() {
      document.addEventListener("mousemove", this.handleMouseMove, true);
      document.addEventListener("mouseup", this.handleMouseUp, true);
    }
  }, {
    key: "stopResizing",
    value: function stopResizing() {
      document.removeEventListener("mousemove", this.handleMouseMove, true);
      document.removeEventListener("mouseup", this.handleMouseUp, true);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!this.isResizing) return;
      var _this$resizeState = this.resizeState,
          x = _this$resizeState.x,
          width = _this$resizeState.width,
          isLeftHandle = _this$resizeState.isLeftHandle;
      var _this$extension$optio2 = this.extension.options,
          minSize = _this$extension$optio2.minSize,
          maxSize = _this$extension$optio2.maxSize;
      var dx = (event.clientX - x) * (isLeftHandle ? -1 : 1);
      var newWidthWithoutClamp = width + dx;
      this.isResizingBlocked = newWidthWithoutClamp < minSize || newWidthWithoutClamp > maxSize;
      var newWidth = this.clampSize(newWidthWithoutClamp);
      var newHeight = this.isResizingBlocked ? this.computePixelsToNumber(this.node.attrs.height) : Math.round(newWidth / this.aspectRatio);
      this.updateAttributes({
        width: this.computeNumberToPixels(newWidth),
        height: this.computeNumberToPixels(newHeight)
      });
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!this.isResizing) return;
      this.isResizing = false;
      this.isResizingBlocked = false;
      this.resizeState = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        isLeftHandle: false
      };
      this.stopResizing();
      this.triggerNodeSelection();
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent() {
      if (!this.editor.isEditable) {
        this.$parent.$emit("click:image", this.imageAttributes);
      }
    }
  }]);

  return ImageWrapper;
}(nodes_BaseNodeView);

ImageWrappervue_type_script_lang_ts_ImageWrapper = __decorate([external_vue_property_decorator_["Component"]], ImageWrappervue_type_script_lang_ts_ImageWrapper);
/* harmony default export */ var ImageWrappervue_type_script_lang_ts_ = (ImageWrappervue_type_script_lang_ts_ImageWrapper);
// CONCATENATED MODULE: ./src/components/nodes/ImageWrapper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_ImageWrappervue_type_script_lang_ts_ = (ImageWrappervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/ImageWrapper.vue?vue&type=style&index=0&id=0679bb89&lang=scss&scoped=true&
var ImageWrappervue_type_style_index_0_id_0679bb89_lang_scss_scoped_true_ = __webpack_require__("c6ed");

// CONCATENATED MODULE: ./src/components/nodes/ImageWrapper.vue






/* normalize component */

var ImageWrapper_component = normalizeComponent(
  nodes_ImageWrappervue_type_script_lang_ts_,
  ImageWrappervue_type_template_id_0679bb89_scoped_true_render,
  ImageWrappervue_type_template_id_0679bb89_scoped_true_staticRenderFns,
  false,
  null,
  "0679bb89",
  null
  
)

/* harmony default export */ var nodes_ImageWrapper = (ImageWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Embed.vue?vue&type=template&id=d27a395e&scoped=true&
var Embedvue_type_template_id_d27a395e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{class:_vm.baseClass,attrs:{"as":"div","contenteditable":"false"}},[_c('div',{class:(_vm.baseClass + "__iframe-wrapper")},[_c('iframe',_vm._b({ref:"embed",class:(_vm.baseClass + "__content"),attrs:{"title":_vm.iFrameAttributes.src}},'iframe',_vm.iFrameAttributes,false)),(!_vm.isMaydayEmbed)?_c('a',{class:(_vm.baseClass + "__iframe-enlarge"),attrs:{"href":_vm.iFrameAttributes.src,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'external-link']}}),_c('span',{class:(_vm.baseClass + "__iframe-enlarge-text")},[_vm._v(" "+_vm._s(_vm.$t("mayday-editor.embed.open-in-new-tab"))+" ")])],1):_vm._e()])])}
var Embedvue_type_template_id_d27a395e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/Embed.vue?vue&type=template&id=d27a395e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/EmbedNodeView.vue?vue&type=script&lang=ts&












var EmbedNodeViewvue_type_script_lang_ts_EmbedNodeView =
/*#__PURE__*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function (_BaseNodeView) {
  _inherits(EmbedNodeView, _BaseNodeView);

  var _super = _createSuper(EmbedNodeView);

  function EmbedNodeView() {
    var _this;

    _classCallCheck(this, EmbedNodeView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    return _this;
  }

  _createClass(EmbedNodeView, [{
    key: "interceptClick",
    value: function interceptClick() {
      // check if iframe/object is not focused or already in NodeSelection
      if (document.activeElement !== this.$refs.embed || this.selected) {
        return;
      }

      this.triggerNodeSelection();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      window.addEventListener("blur", this.interceptClick);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener("blur", this.interceptClick);
    }
  }]);

  return EmbedNodeView;
}(nodes_BaseNodeView);

EmbedNodeViewvue_type_script_lang_ts_EmbedNodeView = __decorate([external_vue_property_decorator_["Component"] // eslint-disable-next-line @typescript-eslint/no-explicit-any
], EmbedNodeViewvue_type_script_lang_ts_EmbedNodeView);
/* harmony default export */ var EmbedNodeViewvue_type_script_lang_ts_ = (EmbedNodeViewvue_type_script_lang_ts_EmbedNodeView);
// CONCATENATED MODULE: ./src/components/nodes/EmbedNodeView.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_EmbedNodeViewvue_type_script_lang_ts_ = (EmbedNodeViewvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/nodes/EmbedNodeView.vue
var EmbedNodeView_render, EmbedNodeView_staticRenderFns




/* normalize component */

var EmbedNodeView_component = normalizeComponent(
  nodes_EmbedNodeViewvue_type_script_lang_ts_,
  EmbedNodeView_render,
  EmbedNodeView_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var nodes_EmbedNodeView = (EmbedNodeView_component.exports);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js








function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__("4ec9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./src/extensions/Link/customHostNames.ts
var customHostNames = ["support.ankorstore.com", "help.paris2024.org"];
// CONCATENATED MODULE: ./src/extensions/Link/ServiceEmbed.ts







var ServiceEmbed_excluded = ["base", "identifierLength", "linkBase", "isGoogle", "isMayday", "isSelfCare", "isCustomSelfCare", "isContent"];


















var services = [[/^https:\/\/(.+\.)mayday.fr\/\bknowledge\/(\bdefault|[a-zA-Z]{2}-[a-zA-Z]{2})?\/?\bcontent\/(\w{24})(\/\bstep\/)?(\w{24})?(?!.*\/case(?:s?)\/)(.*)?/, {
  base: "https://mayday.fr/desk/embed/default/contents/",
  linkBase: "",
  identifierLength: NaN,
  isMayday: true,
  isAdmin: true,
  isContent: true
}], [/^https:\/\/(.+\.)mayday.fr\/desk\/(?:embed\/|parametric\/)?(\bdefault|[a-zA-Z]{2}-[a-zA-Z]{2})?\/?(content?s?|knowledge?s?)\/(\w{24})(\/contents\/)?(\w{24})?(?!.*\/case(?:s?)\/)(.*)?/, {
  base: "https://mayday.fr/desk/embed/default/contents/",
  linkBase: "",
  identifierLength: NaN,
  isMayday: true,
  isDesk: true,
  isContent: true
}], [/^https:\/\/(.+\.)mayday.fr\/web\/\bknowledge\/(\w{24})\/(content|case)\/(\w{24})(\/step\/)?(\w{24})?(.*)?/, {
  base: "",
  linkBase: "",
  identifierLength: NaN,
  isMayday: true,
  isOldWeb: true
}], [/^https:\/\/(.+\.)mayday.cx\/contents\/(.+)$/, {
  base: "https://mayday.cx/embed",
  linkBase: "https://mayday.cx/contents/",
  identifierLength: NaN,
  isMayday: true,
  isSelfCare: true,
  isContent: true
}], [/^https:\/\/(.+\.)mayday.fr\/(web\/)?\b(knowledge|desk)\/(\bdefault|[a-zA-Z]{2}-[a-zA-Z]{2})?\/?(case(s)?|knowledges)?\/?(\w{24})(\/case(s)?\/)?(\w{24})?/, {
  base: "https://mayday.fr/desk/embed/default/contents/",
  linkBase: "",
  identifierLength: NaN,
  isMayday: true,
  isCase: true
}]].concat(_toConsumableArray(customHostNames.map(function (hostname) {
  var pattern = new RegExp("^https://".concat(hostname, "/contents/(.+)$"));
  return [pattern, {
    base: "https://".concat(hostname, "/embed"),
    linkBase: "https://".concat(hostname, "/contents/"),
    identifierLength: NaN,
    isCustomSelfCare: true,
    isMayday: true,
    isContent: true
  }];
})), [[/^https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch|embed\/)?(?:\?v=)?([\w-]{11})/i, {
  autoplay: 0,
  controls: 2,
  rel: 0,
  iv_load_policy: 3,
  base: "https://www.youtube.com/embed",
  linkBase: "https://www.youtube.com/watch?v=",
  identifierLength: 11
}], [/^https?:\/\/(?:www\.)?loom\.com\/(?:share|embed)\/(\w{32})/i, {
  base: "https://www.loom.com/embed",
  linkBase: "https://www.loom.com/share/",
  identifierLength: 32
}], [/^https?:\/\/(?:player\.)?vimeo\.com\/(?:video\/)?(\w{9})/i, {
  base: "https://player.vimeo.com/video",
  linkBase: "https://vimeo.com/",
  identifierLength: 9
}], [/^https?:\/\/(?:www\.)?airtable\.com\/(?:embed\/)?(\w{17})/i, {
  base: "https://airtable.com/embed",
  linkBase: "https://airtable.com/",
  identifierLength: 17
}], [/^https?:\/\/(?:form|admin)\.typeform\.com\/(?:to|form)\/(\w{6})/i, {
  base: "https://form.typeform.com/to",
  linkBase: "",
  identifierLength: 6
}], [/^https?:\/\/docs\.google\.com\/presentation\/d\/(\S{44})\/(?:edit|embed)(?:#slide=(\S*))?/i, {
  base: "https://docs.google.com/presentation/d",
  linkBase: "",
  identifierLength: 44,
  isGoogle: true
}], [/https?:\/\/.*\.sharepoint\.com\/(?::p:\/r\/)?personal\/\w+\/_layouts\/\d+\/Doc\.aspx\?.*/i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}], [/https?:\/\/.*\.(\S{2,3})\/embed\/.*-(\S{8})/i, {
  base: "",
  linkBase: "",
  identifierLength: 8
}], [/^https?:\/\/(?:www\.)?(?:google.com\/maps\/)(?:embed)/i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}], [/^https:\/\/(?:[^.]*)\.tango\.us\/app\/embed\//i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}], [/^https:\/\/(?:www\.)?iorad\.com\//i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}], [/^https:\/\/view\.officeapps\.live\.com\/op\/embed\.aspx\?src=/i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}], [/https:\/\/wiki\.axa-direct.com.*/i, {
  base: "",
  linkBase: "",
  identifierLength: NaN
}]]);
/**
 * Check if link can be transformed into embed
 * - Transform URL to support embed
 * - Transform embed src back into link URL
 *
 * @export
 * @class ServiceEmbed
 */

var ServiceEmbed_ServiceEmbed = /*#__PURE__*/function () {
  function ServiceEmbed() {
    _classCallCheck(this, ServiceEmbed);

    Object(defineProperty["a" /* default */])(this, "services", new Map(services));

    Object(defineProperty["a" /* default */])(this, "currentPattern", null);

    Object(defineProperty["a" /* default */])(this, "isGoogle", false);

    Object(defineProperty["a" /* default */])(this, "isMayday", false);

    Object(defineProperty["a" /* default */])(this, "isSelfCare", false);

    Object(defineProperty["a" /* default */])(this, "isCustomSelfCare", false);

    Object(defineProperty["a" /* default */])(this, "isContent", false);
  }

  _createClass(ServiceEmbed, [{
    key: "find",
    value: function find(link, subdomain) {
      var _iterator = _createForOfIteratorHelper(this.services),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              pattern = _step$value[0],
              desc = _step$value[1];

          if (pattern.test(link)) {
            return desc.isMayday && subdomain && !link.includes(subdomain) ? null : pattern;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
    /**
     * Transform link URL into embed src
     *
     * @param {string} link The link URL/href
     * @return {embedLink}  {(string | null)} The embed src
     * @memberof ServiceEmbed
     */

  }, {
    key: "generate",
    value: function generate(link, companySubdomain, maydayId) {
      this.currentPattern = this.find(link);

      if (this.currentPattern == null) {
        return null;
      }

      var matches = this.currentPattern.exec(link);

      if (matches == null) {
        return null;
      }

      var desc = this.services.get(this.currentPattern);

      if (desc == null) {
        return null;
      }

      var base = desc.base,
          identifierLength = desc.identifierLength,
          linkBase = desc.linkBase,
          isGoogle = desc.isGoogle,
          isMayday = desc.isMayday,
          isSelfCare = desc.isSelfCare,
          isCustomSelfCare = desc.isCustomSelfCare,
          isContent = desc.isContent,
          meta = _objectWithoutProperties(desc, ServiceEmbed_excluded);

      this.isGoogle = Boolean(isGoogle);
      this.isMayday = Boolean(isMayday);
      this.isSelfCare = Boolean(isSelfCare);
      this.isCustomSelfCare = Boolean(isCustomSelfCare);
      this.isContent = Boolean(isContent); // link may already be an embeddable one (eg. office 365)

      if (base.length === 0) {
        return link;
      }

      var params = Object.entries(meta).reduce(function (acc, _ref, idx) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return acc + "".concat(idx !== 0 ? "&" : "").concat(key, "=").concat(value);
      }, "");

      if (matches[1] == null) {
        return null;
      }

      var baseUrl = "".concat(base, "/").concat(matches[1]);

      if (this.isGoogle) {
        baseUrl += "/embed";

        if (matches[2] != null) {
          baseUrl += "#slide=".concat(matches[2]);
        }
      }

      if (this.isSelfCare) {
        var subdomain = matches[1];
        var identifier = matches[2];
        baseUrl = "".concat(base, "/").concat(identifier);

        if (subdomain) {
          desc.domain = "https://".concat(subdomain, "mayday.cx");
          desc.originalLink = link;
          return baseUrl = baseUrl.replace("mayday.cx", "".concat(subdomain, "mayday.cx"));
        }
      }

      if (this.isMayday && this.isContent) {
        var _subdomain = matches[1];
        baseUrl = "".concat(base).concat(maydayId);

        if (_subdomain) {
          baseUrl = baseUrl.replace("mayday.fr", "".concat(_subdomain, "mayday.fr"));
          desc.domain = "https://".concat(_subdomain, "mayday.fr");
          desc.originalLink = link;
        }

        if (companySubdomain !== desc.domain) return null;
        var language = desc.isAdmin || desc.isDesk ? matches[2] : "default";
        return baseUrl = language === "default" ? baseUrl : this.setMaydayLang(baseUrl, language);
      }

      if (this.isCustomSelfCare) {
        desc.identifierLength = matches[1].length;
      }

      return params.length !== 0 ? "".concat(baseUrl, "?").concat(params) : baseUrl;
    }
  }, {
    key: "getInlineId",
    value: function getInlineId(link) {
      this.currentPattern = this.find(link);
      if (!this.currentPattern) return;
      var matches = this.currentPattern.exec(link);
      var desc = this.services.get(this.currentPattern);
      if (!matches || !desc) return null;

      if (desc.isAdmin) {
        var step = matches[5];
        return step ? step : matches[3];
      }

      if (desc.isDesk) {
        var _step2 = matches[6];
        return _step2 ? _step2 : matches[4];
      }

      if (desc.isOldWeb) {
        var _step3 = matches[6];
        return _step3 ? _step3 : matches[4];
      }

      if (desc.isCase) {
        return matches[10] ? matches[10] : matches[7];
      }

      if (desc.isCustomSelfCare) {
        return matches[1];
      }

      if (desc.isSelfCare) {
        return matches[2];
      }

      return "";
    }
  }, {
    key: "setMaydayLang",
    value: function setMaydayLang(link, lang) {
      if (!lang) {
        lang = "default";
      } else if (lang !== "default") {
        link = link.replace("default", lang);
      }

      return link;
    }
  }, {
    key: "getMaydayLang",
    value: function getMaydayLang(link) {
      var matches = link.match(/\/(default|[a-zA-Z]{2}-[a-zA-Z]{2})\//);
      return matches ? matches[1] : "default";
    }
    /**
     * Transform embed src back into link URL
     *
     * @param {string} embedLink The embed src
     * @return {link}  {(string | null)} The link URL
     * @memberof ServiceEmbed
     */

  }, {
    key: "turnBack",
    value: function turnBack(embedLink) {
      var serviceMeta = null;

      var _iterator2 = _createForOfIteratorHelper(this.services.values()),
          _step4;

      try {
        for (_iterator2.s(); !(_step4 = _iterator2.n()).done;) {
          var meta = _step4.value;

          if (embedLink.startsWith(meta.base) || embedLink.startsWith(meta.domain)) {
            serviceMeta = meta;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (serviceMeta == null) {
        return null;
      }

      this.isGoogle = serviceMeta.isGoogle === true || false;
      this.isMayday = serviceMeta.isMayday === true || false;
      this.isSelfCare = serviceMeta.isSelfCare === true || false;
      if (this.isMayday) return embedLink.replace("/embed", "");

      if (this.isSelfCare || this.isCustomSelfCare) {
        return embedLink.replace("embed", "contents");
      } // link may already be an embeddable one (eg. typeform / office 365)


      if (serviceMeta.linkBase.length === 0) {
        return embedLink;
      }

      if (this.isGoogle) {
        return embedLink.replace("/embed", "/edit");
      }

      var _serviceMeta = serviceMeta,
          identifierLength = _serviceMeta.identifierLength,
          base = _serviceMeta.base,
          linkBase = _serviceMeta.linkBase;
      var identifier = embedLink.substr(base.length + 1, identifierLength);
      return "".concat(linkBase).concat(identifier);
    }
  }]);

  return ServiceEmbed;
}();
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Embed.vue?vue&type=script&lang=ts&












var embedClass = "mayday-editor__embed";

var Embedvue_type_script_lang_ts_Embed = /*#__PURE__*/function (_EmbedNodeView) {
  _inherits(Embed, _EmbedNodeView);

  var _super = _createSuper(Embed);

  function Embed() {
    var _this;

    _classCallCheck(this, Embed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", embedClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "serviceEmbed", new ServiceEmbed_ServiceEmbed());

    return _this;
  }

  _createClass(Embed, [{
    key: "iFrameAttributes",
    get: function get() {
      var _this$node$attrs = this.node.attrs,
          frameborder = _this$node$attrs.frameborder,
          allowfullscreen = _this$node$attrs.allowfullscreen,
          src = _this$node$attrs.src,
          loading = _this$node$attrs.loading;
      return {
        frameborder: frameborder,
        allowfullscreen: allowfullscreen,
        loading: loading,
        src: src
      };
    }
  }, {
    key: "containerClass",
    get: function get() {
      var _ref;

      var selected = this.selected,
          baseClass = this.baseClass,
          editor = this.editor;
      var showSelectedWrapper = selected && editor.isEditable;
      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, baseClass, true), Object(defineProperty["a" /* default */])(_ref, "".concat(baseClass, "--selected"), showSelectedWrapper), _ref;
    }
  }, {
    key: "isMaydayEmbed",
    get: function get() {
      return this.serviceEmbed.getInlineId(this.iFrameAttributes.src) || "";
    }
  }]);

  return Embed;
}(nodes_EmbedNodeView);

Embedvue_type_script_lang_ts_Embed = __decorate([external_vue_property_decorator_["Component"]], Embedvue_type_script_lang_ts_Embed);
/* harmony default export */ var Embedvue_type_script_lang_ts_ = (Embedvue_type_script_lang_ts_Embed);
// CONCATENATED MODULE: ./src/components/nodes/Embed.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_Embedvue_type_script_lang_ts_ = (Embedvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/Embed.vue?vue&type=style&index=0&id=d27a395e&lang=scss&scoped=true&
var Embedvue_type_style_index_0_id_d27a395e_lang_scss_scoped_true_ = __webpack_require__("b872");

// CONCATENATED MODULE: ./src/components/nodes/Embed.vue






/* normalize component */

var Embed_component = normalizeComponent(
  nodes_Embedvue_type_script_lang_ts_,
  Embedvue_type_template_id_d27a395e_scoped_true_render,
  Embedvue_type_template_id_d27a395e_scoped_true_staticRenderFns,
  false,
  null,
  "d27a395e",
  null
  
)

/* harmony default export */ var nodes_Embed = (Embed_component.exports);
// CONCATENATED MODULE: ./src/extensions/NodeDrag/helpers.ts







var HANDLER_GAP = 100;
var helpers_createComponentHandle = function createComponentHandle(editor) {
  var contentComponent = editor.contentComponent;
  return new tiptap_vue_2_esm_VueRenderer(components_NodeDragHandle, {
    parent: contentComponent,
    propsData: {
      node: undefined,
      nodeDOM: undefined,
      editor: editor
    }
  });
}; // create a custom DOMRect to position the drag handle at the left of top node

var helpers_createRect = function createRect(nodeDraggedElement) {
  var makeAdditionalCompute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var rect = nodeDraggedElement.getBoundingClientRect();
  var win = nodeDraggedElement.ownerDocument.defaultView;

  if (rect == null) {
    return null;
  }

  var newRect = {
    left: rect.left + document.body.scrollLeft,
    top: rect.top + document.body.scrollTop,
    width: rect.width,
    height: rect.height,
    bottom: 0,
    right: 0
  };
  newRect.bottom = newRect.top + newRect.height;
  newRect.right = newRect.left + newRect.width;

  if (makeAdditionalCompute && win != null) {
    var _win$getComputedStyle = win.getComputedStyle(nodeDraggedElement),
        marginLeft = _win$getComputedStyle.marginLeft,
        paddingTop = _win$getComputedStyle.paddingTop,
        marginTop = _win$getComputedStyle.marginTop;

    var convert = function convert(value) {
      return parseInt(value, 10);
    };

    var isCodeBlock = nodeDraggedElement instanceof HTMLPreElement;
    var isEmbed = nodeDraggedElement.classList.contains(embedClass);
    var additionalBoxSizing = isCodeBlock ? convert(paddingTop) - convert(marginTop) : convert(paddingTop) + convert(marginTop);
    newRect.left += win.scrollX - convert(marginLeft);

    if (!isEmbed) {
      newRect.top -= additionalBoxSizing;
      newRect.height += additionalBoxSizing;
    }
  }

  return newRect;
}; // determine top level node position on drag start

var blockPosAtCoords = function blockPosAtCoords(coords, view) {
  var pos = view.posAtCoords(coords);
  var nodeDOM = pos != null ? view.nodeDOM(pos.inside) : null;

  if (pos != null && nodeDOM != null) {
    var node = getDirectChild(nodeDOM);

    if (node && node.nodeType === Node.ELEMENT_NODE) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var docView = view.docView; // not in ProseMirror types or doc but exists

      var desc = docView.nearestDesc(node, true);

      if (!(desc == null || desc === docView)) {
        return desc.posBefore;
      }
    }
  }

  return null;
}; // Get the direct child of the Editor:
// To cover cases when the user is hovering nested nodes.

var getDirectChild = function getDirectChild(node) {
  while (node != null && node.parentElement != null) {
    if (node.classList.contains("ProseMirror") || node.parentElement.classList.contains("ProseMirror")) {
      break;
    }

    node = node.parentElement;
  }

  return node;
}; // Check if node has content.
// If not, the handler don't need to be shown.

var helpers_nodeHasContent = function nodeHasContent(view, inside) {
  var _firstParentNode$text;

  var firstParentNode = view.nodeDOM(inside);
  var hasTextContent = !!(firstParentNode !== null && firstParentNode !== void 0 && (_firstParentNode$text = firstParentNode.textContent) !== null && _firstParentNode$text !== void 0 && _firstParentNode$text.length && (firstParentNode === null || firstParentNode === void 0 ? void 0 : firstParentNode.textContent) !== "/");
  var isImage = !!(firstParentNode !== null && firstParentNode !== void 0 && firstParentNode.classList.contains(imageWrapperClass));
  var isEmbed = !!(firstParentNode !== null && firstParentNode !== void 0 && firstParentNode.classList.contains(embedClass));
  return hasTextContent || isImage || isEmbed;
};
var removeNode = function removeNode(node) {
  if (node != null && node.parentNode != null) {
    return node.parentNode.removeChild(node);
  }

  return undefined;
}; // store metadata about table on drag start to remove the old and empty one

var computeOldTableMeta = function computeOldTableMeta(view, nodeDraggedElement) {
  var rect = nodeDraggedElement.getBoundingClientRect();
  var pos = view.posAtCoords(rect);

  if (pos != null) {
    var count = view.dom.querySelectorAll(".tableWrapper").length;
    var $pos = view.state.doc.resolve(pos.pos);

    for (var d = $pos.depth; d > 0; d--) {
      var _$pos$node = $pos.node(d),
          type = _$pos$node.type,
          nodeSize = _$pos$node.nodeSize;

      if (type.spec.tableRole === "table") {
        return {
          pos: pos.pos,
          size: nodeSize,
          count: count
        };
      }
    }
  }

  return null;
}; // check if user has moved the table in another place
// leaving one at the old position

var tableHasBeenMoved = function tableHasBeenMoved(view, oldTableMeta) {
  var newCount = view.dom.querySelectorAll(".tableWrapper").length;
  return newCount === oldTableMeta.count + 1;
}; // delete the old table based on metadata

var deleteOldTable = function deleteOldTable(view, oldTableMeta, event) {
  var size = oldTableMeta.size,
      pos = oldTableMeta.pos;
  var coords = {
    left: event.clientX + HANDLER_GAP,
    top: event.clientY
  };
  var newPos = view.posAtCoords(coords);

  if (newPos == null || pos === newPos.pos) {
    return;
  }

  var nodeIsMovedUp = newPos.pos < pos;
  var posToResolve = nodeIsMovedUp ? pos + size : pos;
  var $newPos = view.state.doc.resolve(posToResolve);

  for (var d = $newPos.depth; d > 0; d--) {
    var _$newPos$node = $newPos.node(d),
        type = _$newPos$node.type;

    if (type.spec.tableRole === "table") {
      view.dispatch(view.state.tr.delete($newPos.before(d), $newPos.after(d)));
    }
  }
}; // set a simple text selection to remove the NodeSelection

var helpers_replaceSelection = function replaceSelection(view) {
  var state = view.state,
      dispatch = view.dispatch;
  var tr = state.tr,
      doc = state.doc,
      selection = state.selection;
  dispatch(tr.setSelection(new index_es_TextSelection(doc.resolve(selection.from))));
}; // find the top level ProseMirrorNode (indicator)

var determineFirstLevelNode = function determineFirstLevelNode(view, nodeDraggedElement) {
  var _$pos$nodeAfter;

  var rect = nodeDraggedElement.getBoundingClientRect();
  var pos = view.posAtCoords(rect);

  if (pos == null) {
    return undefined;
  }

  var $pos = view.state.doc.resolve(pos.pos);

  if ($pos.nodeAfter != null && ["image", "embed", "attachment"].includes((_$pos$nodeAfter = $pos.nodeAfter) === null || _$pos$nodeAfter === void 0 ? void 0 : _$pos$nodeAfter.type.name)) {
    return $pos.nodeAfter;
  }

  var depth = $pos.depth > 1 ? 1 : $pos.depth;
  return $pos.node(depth);
};
var hideDragHandle = function hideDragHandle(dragHandleElement) {
  if (dragHandleElement.style.visibility === "visible") {
    dragHandleElement.style.visibility = "hidden";
  }
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Slash/SlashMenuCommandButton.vue?vue&type=template&id=1e0974c4&scoped=true&
var SlashMenuCommandButtonvue_type_template_id_1e0974c4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.containerClasses,style:(_vm.style),on:{"click":_vm.toggleSlashMenu}},[_c('span',{class:_vm.innerContainerClass},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', _vm.icon]}})],1)])}
var SlashMenuCommandButtonvue_type_template_id_1e0974c4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenuCommandButton.vue?vue&type=template&id=1e0974c4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Slash/SlashMenuCommandButton.vue?vue&type=script&lang=ts&











var SlashMenuCommandButtonvue_type_script_lang_ts_WIDTH = 20;
var SlashMenuCommandButtonvue_type_script_lang_ts_baseClass = "mayday-editor__slash-menu-command-button";

var SlashMenuCommandButtonvue_type_script_lang_ts_SlashMenuCommandButton = /*#__PURE__*/function (_Vue) {
  _inherits(SlashMenuCommandButton, _Vue);

  var _super = _createSuper(SlashMenuCommandButton);

  function SlashMenuCommandButton() {
    var _this;

    _classCallCheck(this, SlashMenuCommandButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "width", "".concat(SlashMenuCommandButtonvue_type_script_lang_ts_WIDTH, "px"));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", SlashMenuCommandButtonvue_type_script_lang_ts_baseClass);

    return _this;
  }

  _createClass(SlashMenuCommandButton, [{
    key: "storage",
    get: function get() {
      var _this$editor;

      var storage = ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.storage) || {};
      var placeholderStorage = storage.placeholder;
      var slashMenuStorage = storage.slashMenu;
      return _objectSpread2(_objectSpread2({}, placeholderStorage), slashMenuStorage);
    }
  }, {
    key: "showCommandButton",
    get: function get() {
      var storage = this.storage;
      return storage.showCommandButton || storage.isSlashMenuOpen;
    }
  }, {
    key: "style",
    get: function get() {
      var width = this.width,
          storage = this.storage,
          showCommandButton = this.showCommandButton;
      var top = storage.top,
          left = storage.left;
      return {
        width: width,
        visibility: showCommandButton ? "visible" : "hidden",
        opacity: showCommandButton ? "1" : "0",
        top: top,
        left: left
      };
    }
  }, {
    key: "containerClasses",
    get: function get() {
      var _ref;

      var base = this.baseClass;
      var isSlashMenuOpen = this.storage.isSlashMenuOpen;
      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, base, true), Object(defineProperty["a" /* default */])(_ref, "".concat(base, "--is-open"), isSlashMenuOpen), _ref;
    }
  }, {
    key: "innerContainerClass",
    get: function get() {
      var base = this.baseClass;
      return "".concat(base, "__inner-circle");
    }
  }, {
    key: "icon",
    get: function get() {
      return this.storage.isSlashMenuOpen ? "times" : "plus";
    }
  }, {
    key: "toggleSlashMenu",
    value: function toggleSlashMenu() {
      if (this.editor == null) {
        return;
      }

      var isSlashMenuOpen = this.storage.isSlashMenuOpen;
      var chain = this.editor.chain().focus();

      if (isSlashMenuOpen) {
        chain.undo().run();
      } else {
        chain.insertContent("/").run();
      }
    }
  }]);

  return SlashMenuCommandButton;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], SlashMenuCommandButtonvue_type_script_lang_ts_SlashMenuCommandButton.prototype, "editor", void 0);

SlashMenuCommandButtonvue_type_script_lang_ts_SlashMenuCommandButton = __decorate([external_vue_property_decorator_["Component"]], SlashMenuCommandButtonvue_type_script_lang_ts_SlashMenuCommandButton);
/* harmony default export */ var SlashMenuCommandButtonvue_type_script_lang_ts_ = (SlashMenuCommandButtonvue_type_script_lang_ts_SlashMenuCommandButton);
// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenuCommandButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Slash_SlashMenuCommandButtonvue_type_script_lang_ts_ = (SlashMenuCommandButtonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Slash/SlashMenuCommandButton.vue?vue&type=style&index=0&id=1e0974c4&lang=scss&scoped=true&
var SlashMenuCommandButtonvue_type_style_index_0_id_1e0974c4_lang_scss_scoped_true_ = __webpack_require__("2442");

// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenuCommandButton.vue






/* normalize component */

var SlashMenuCommandButton_component = normalizeComponent(
  Slash_SlashMenuCommandButtonvue_type_script_lang_ts_,
  SlashMenuCommandButtonvue_type_template_id_1e0974c4_scoped_true_render,
  SlashMenuCommandButtonvue_type_template_id_1e0974c4_scoped_true_staticRenderFns,
  false,
  null,
  "1e0974c4",
  null
  
)

/* harmony default export */ var Slash_SlashMenuCommandButton = (SlashMenuCommandButton_component.exports);
// CONCATENATED MODULE: ./src/extensions/Placeholder/helpers.ts


var helpers_createPlaceholderRect = function createPlaceholderRect(element, vm) {
  var rect = helpers_createRect(element, false);
  var editorRect = vm.$el.getBoundingClientRect();

  if (rect != null) {
    return {
      top: rect.top - editorRect.top + "px",
      left: rect.left - editorRect.left - SlashMenuCommandButtonvue_type_script_lang_ts_WIDTH - 10 + "px"
    };
  }

  return null;
};
var shouldDoNothing = function shouldDoNothing(view, oldState) {
  var state = view.state,
      composing = view.composing;
  var doc = state.doc,
      selection = state.selection;
  var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
  return composing || isSame || !selection.empty;
};
var computeRectIfEmptyNode = function computeRectIfEmptyNode(view, vm) {
  var state = view.state;
  var selection = state.selection;
  var node = selection.$anchor.node();
  var pos = selection.$anchor.pos - 1;

  if (node.childCount === 0 && node.textContent.length === 0) {
    var nodeDOM = view.nodeDOM(pos);
    var rect = nodeDOM != null ? helpers_createPlaceholderRect(nodeDOM, vm) : null;
    return rect != null && nodeDOM.classList.contains("is-empty") ? rect : null;
  }

  return null;
};
// CONCATENATED MODULE: ./src/extensions/Placeholder/Placeholder.ts





var Placeholder_computePlaceholderExtension = function computePlaceholderExtension(vm) {
  return Placeholder.extend({
    addStorage: function addStorage() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        showCommandButton: false,
        top: "",
        left: ""
      });
    },
    addOptions: function addOptions() {
      var _this$parent2;

      return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
        placeholder: function placeholder() {
          var placeholder = vm.$props.placeholder;
          return placeholder || vm.$t("mayday-editor.placeholder.node-is-empty");
        }
      });
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var _this$parent3;

      var storage = this.storage;
      var plugins = ((_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)) || [];
      plugins.push(new Plugin({
        key: new PluginKey("placeholderSlashCommandButton"),
        view: function view() {
          return {
            update: function update(view, oldState) {
              if (shouldDoNothing(view, oldState)) {
                return;
              }

              var rect = computeRectIfEmptyNode(view, vm);

              if (rect != null) {
                storage.showCommandButton = true;
                storage.top = rect.top;
                storage.left = rect.left;
              } else {
                storage.showCommandButton = false;
              }
            }
          };
        }
      }));
      return plugins;
    }
  });
};

/* harmony default export */ var Placeholder_Placeholder = (Placeholder_computePlaceholderExtension);
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-code/dist/tiptap-extension-code.esm.js


const tiptap_extension_code_esm_inputRegex = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/;
const pasteRegex = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g;
const Code = tiptap_core_esm_Mark.create({
    name: 'code',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    excludes: '_',
    code: true,
    parseHTML() {
        return [
            { tag: 'code' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['code', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setCode: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleCode: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetCode: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-e': () => this.editor.commands.toggleCode(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: tiptap_extension_code_esm_inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-code.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-typography/dist/tiptap-extension-typography.esm.js


const emDash = textInputRule({
    find: /--$/,
    replace: '—',
});
const ellipsis = textInputRule({
    find: /\.\.\.$/,
    replace: '…',
});
const openDoubleQuote = textInputRule({
    find: /(?:^|[\s{[(<'"\u2018\u201C])(")$/,
    replace: '“',
});
const closeDoubleQuote = textInputRule({
    find: /"$/,
    replace: '”',
});
const openSingleQuote = textInputRule({
    find: /(?:^|[\s{[(<'"\u2018\u201C])(')$/,
    replace: '‘',
});
const closeSingleQuote = textInputRule({
    find: /'$/,
    replace: '’',
});
const leftArrow = textInputRule({
    find: /<-$/,
    replace: '←',
});
const rightArrow = textInputRule({
    find: /->$/,
    replace: '→',
});
const copyright = textInputRule({
    find: /\(c\)$/,
    replace: '©',
});
const trademark = textInputRule({
    find: /\(tm\)$/,
    replace: '™',
});
const registeredTrademark = textInputRule({
    find: /\(r\)$/,
    replace: '®',
});
const oneHalf = textInputRule({
    find: /1\/2$/,
    replace: '½',
});
const plusMinus = textInputRule({
    find: /\+\/-$/,
    replace: '±',
});
const notEqual = textInputRule({
    find: /!=$/,
    replace: '≠',
});
const laquo = textInputRule({
    find: /<<$/,
    replace: '«',
});
const raquo = textInputRule({
    find: />>$/,
    replace: '»',
});
const multiplication = textInputRule({
    find: /\d+\s?([*x])\s?\d+$/,
    replace: '×',
});
const superscriptTwo = textInputRule({
    find: /\^2$/,
    replace: '²',
});
const superscriptThree = textInputRule({
    find: /\^3$/,
    replace: '³',
});
const oneQuarter = textInputRule({
    find: /1\/4$/,
    replace: '¼',
});
const threeQuarters = textInputRule({
    find: /3\/4$/,
    replace: '¾',
});
const Typography = Extension.create({
    name: 'typography',
    addInputRules() {
        const rules = [];
        if (this.options.emDash !== false) {
            rules.push(emDash);
        }
        if (this.options.ellipsis !== false) {
            rules.push(ellipsis);
        }
        if (this.options.openDoubleQuote !== false) {
            rules.push(openDoubleQuote);
        }
        if (this.options.closeDoubleQuote !== false) {
            rules.push(closeDoubleQuote);
        }
        if (this.options.openSingleQuote !== false) {
            rules.push(openSingleQuote);
        }
        if (this.options.closeSingleQuote !== false) {
            rules.push(closeSingleQuote);
        }
        if (this.options.leftArrow !== false) {
            rules.push(leftArrow);
        }
        if (this.options.rightArrow !== false) {
            rules.push(rightArrow);
        }
        if (this.options.copyright !== false) {
            rules.push(copyright);
        }
        if (this.options.trademark !== false) {
            rules.push(trademark);
        }
        if (this.options.registeredTrademark !== false) {
            rules.push(registeredTrademark);
        }
        if (this.options.oneHalf !== false) {
            rules.push(oneHalf);
        }
        if (this.options.plusMinus !== false) {
            rules.push(plusMinus);
        }
        if (this.options.notEqual !== false) {
            rules.push(notEqual);
        }
        if (this.options.laquo !== false) {
            rules.push(laquo);
        }
        if (this.options.raquo !== false) {
            rules.push(raquo);
        }
        if (this.options.multiplication !== false) {
            rules.push(multiplication);
        }
        if (this.options.superscriptTwo !== false) {
            rules.push(superscriptTwo);
        }
        if (this.options.superscriptThree !== false) {
            rules.push(superscriptThree);
        }
        if (this.options.oneQuarter !== false) {
            rules.push(oneQuarter);
        }
        if (this.options.threeQuarters !== false) {
            rules.push(threeQuarters);
        }
        return rules;
    },
});


//# sourceMappingURL=tiptap-extension-typography.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-text-style/dist/tiptap-extension-text-style.esm.js


const TextStyle = tiptap_core_esm_Mark.create({
    name: 'textStyle',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span',
                getAttrs: element => {
                    const hasStyles = element.hasAttribute('style');
                    if (!hasStyles) {
                        return false;
                    }
                    return {};
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            removeEmptyTextStyle: () => ({ state, commands }) => {
                const attributes = getMarkAttributes(state, this.type);
                const hasStyles = Object.entries(attributes).some(([, value]) => !!value);
                if (hasStyles) {
                    return true;
                }
                return commands.unsetMark(this.name);
            },
        };
    },
});


//# sourceMappingURL=tiptap-extension-text-style.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bold/dist/tiptap-extension-bold.esm.js


const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/;
const starPasteRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g;
const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/;
const underscorePasteRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g;
const Bold = tiptap_core_esm_Mark.create({
    name: 'bold',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'strong',
            },
            {
                tag: 'b',
                getAttrs: node => node.style.fontWeight !== 'normal' && null,
            },
            {
                style: 'font-weight',
                getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['strong', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBold: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleBold: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetBold: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-b': () => this.editor.commands.toggleBold(),
            'Mod-B': () => this.editor.commands.toggleBold(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegex,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegex,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-bold.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-italic/dist/tiptap-extension-italic.esm.js


const tiptap_extension_italic_esm_starInputRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/;
const tiptap_extension_italic_esm_starPasteRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g;
const tiptap_extension_italic_esm_underscoreInputRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/;
const tiptap_extension_italic_esm_underscorePasteRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g;
const Italic = tiptap_core_esm_Mark.create({
    name: 'italic',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'em',
            },
            {
                tag: 'i',
                getAttrs: node => node.style.fontStyle !== 'normal' && null,
            },
            {
                style: 'font-style=italic',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setItalic: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleItalic: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetItalic: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-i': () => this.editor.commands.toggleItalic(),
            'Mod-I': () => this.editor.commands.toggleItalic(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: tiptap_extension_italic_esm_starInputRegex,
                type: this.type,
            }),
            markInputRule({
                find: tiptap_extension_italic_esm_underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: tiptap_extension_italic_esm_starPasteRegex,
                type: this.type,
            }),
            markPasteRule({
                find: tiptap_extension_italic_esm_underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-italic.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-underline/dist/tiptap-extension-underline.esm.js


const Underline = tiptap_core_esm_Mark.create({
    name: 'underline',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'u',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('underline') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['u', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setUnderline: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleUnderline: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetUnderline: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-u': () => this.editor.commands.toggleUnderline(),
            'Mod-U': () => this.editor.commands.toggleUnderline(),
        };
    },
});


//# sourceMappingURL=tiptap-extension-underline.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-strike/dist/tiptap-extension-strike.esm.js


const tiptap_extension_strike_esm_inputRegex = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/;
const tiptap_extension_strike_esm_pasteRegex = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g;
const Strike = tiptap_core_esm_Mark.create({
    name: 'strike',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 's',
            },
            {
                tag: 'del',
            },
            {
                tag: 'strike',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('line-through') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['s', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setStrike: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleStrike: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetStrike: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-x': () => this.editor.commands.toggleStrike(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: tiptap_extension_strike_esm_inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: tiptap_extension_strike_esm_pasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-strike.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-heading/dist/tiptap-extension-heading.esm.js


const Heading = tiptap_core_esm_Node.create({
    name: 'heading',
    addOptions() {
        return {
            levels: [1, 2, 3, 4, 5, 6],
            HTMLAttributes: {},
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes() {
        return {
            level: {
                default: 1,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return this.options.levels
            .map((level) => ({
            tag: `h${level}`,
            attrs: { level },
        }));
    },
    renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel
            ? node.attrs.level
            : this.options.levels[0];
        return [`h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.setNode(this.name, attributes);
            },
            toggleHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return this.options.levels.reduce((items, level) => ({
            ...items,
            ...{
                [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level }),
            },
        }), {});
    },
    addInputRules() {
        return this.options.levels.map(level => {
            return textblockTypeInputRule({
                find: new RegExp(`^(#{1,${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level,
                },
            });
        });
    },
});


//# sourceMappingURL=tiptap-extension-heading.esm.js.map

// CONCATENATED MODULE: ./src/extensions/Heading.ts


var customHeading = Heading.extend({
  name: "heading",
  addAttributes: function addAttributes() {
    var _this$parent;

    return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
      id: {
        default: null
      }
    });
  }
});
/* harmony default export */ var extensions_Heading = (customHeading);
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-text-align/dist/tiptap-extension-text-align.esm.js


const TextAlign = Extension.create({
    name: 'textAlign',
    addOptions() {
        return {
            types: [],
            alignments: ['left', 'center', 'right', 'justify'],
            defaultAlignment: 'left',
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: element => element.style.textAlign || this.options.defaultAlignment,
                        renderHTML: attributes => {
                            if (attributes.textAlign === this.options.defaultAlignment) {
                                return {};
                            }
                            return { style: `text-align: ${attributes.textAlign}` };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setTextAlign: (alignment) => ({ commands }) => {
                if (!this.options.alignments.includes(alignment)) {
                    return false;
                }
                return this.options.types.every(type => commands.updateAttributes(type, { textAlign: alignment }));
            },
            unsetTextAlign: () => ({ commands }) => {
                return this.options.types.every(type => commands.resetAttributes(type, 'textAlign'));
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-l': () => this.editor.commands.setTextAlign('left'),
            'Mod-Shift-e': () => this.editor.commands.setTextAlign('center'),
            'Mod-Shift-r': () => this.editor.commands.setTextAlign('right'),
            'Mod-Shift-j': () => this.editor.commands.setTextAlign('justify'),
        };
    },
});


//# sourceMappingURL=tiptap-extension-text-align.esm.js.map

// CONCATENATED MODULE: ./src/extensions/TextAlign.ts


var Alignments;

(function (Alignments) {
  Alignments["LEFT"] = "left";
  Alignments["CENTER"] = "center";
  Alignments["RIGHT"] = "right";
})(Alignments || (Alignments = {}));

var Types;

(function (Types) {
  Types["HEADING"] = "heading";
  Types["PARAGRAPH"] = "paragraph";
})(Types || (Types = {}));

var TextAlignExtension = TextAlign.extend({
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    return {};
  }
}).configure({
  types: Object.values(Types),
  alignments: Object.values(Alignments),
  defaultAlignment: Alignments.LEFT
});
/* harmony default export */ var extensions_TextAlign = (TextAlignExtension);
// CONCATENATED MODULE: ./src/extensions/Highlight.ts



var Highlight_inputRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))$/;
var Highlight_pasteRegex = /(?:^|\s)((?:==)((?:[^~]+))(?:==))/g;
var BANNED_COLORS = ["#ffffff", "rgb(255, 255, 255)", "white", "transparent"];
var Highlight = tiptap_core_esm_Mark.create({
  name: "highlight",
  addOptions: function addOptions() {
    return {
      multicolor: false,
      HTMLAttributes: {}
    };
  },
  addAttributes: function addAttributes() {
    if (!this.options.multicolor) {
      return {};
    }

    return {
      color: {
        default: null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute("data-color") || element.style.backgroundColor;
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes.color) {
            return {};
          }

          return {
            "data-color": attributes.color,
            style: "background-color: ".concat(attributes.color)
          };
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: "mark"
    }, {
      style: "background-color",
      getAttrs: function getAttrs(value) {
        return {
          color: value
        };
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    if (BANNED_COLORS.includes(HTMLAttributes["data-color"].toLowerCase())) return ["span"];
    return ["mark", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setHighlight: function setHighlight(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name, attributes);
        };
      },
      toggleHighlight: function toggleHighlight(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name, attributes);
        };
      },
      unsetHighlight: function unsetHighlight() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      "Mod-Shift-h": function ModShiftH() {
        return _this2.editor.commands.toggleHighlight();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: Highlight_inputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: Highlight_pasteRegex,
      type: this.type
    })];
  }
});
/* harmony default export */ var extensions_Highlight = (Highlight);
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-color/dist/tiptap-extension-color.esm.js



const Color = Extension.create({
    name: 'color',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    color: {
                        default: null,
                        parseHTML: element => element.style.color.replace(/['"]+/g, ''),
                        renderHTML: attributes => {
                            if (!attributes.color) {
                                return {};
                            }
                            return {
                                style: `color: ${attributes.color}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setColor: color => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { color })
                    .run();
            },
            unsetColor: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { color: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});


//# sourceMappingURL=tiptap-extension-color.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-ordered-list/dist/tiptap-extension-ordered-list.esm.js


const tiptap_extension_ordered_list_esm_inputRegex = /^(\d+)\.\s$/;
const OrderedList = tiptap_core_esm_Node.create({
    name: 'orderedList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes() {
        return {
            start: {
                default: 1,
                parseHTML: element => {
                    return element.hasAttribute('start')
                        ? parseInt(element.getAttribute('start') || '', 10)
                        : 1;
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'ol',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        const { start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1
            ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0]
            : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleOrderedList: () => ({ commands }) => {
                return commands.toggleList(this.name, this.options.itemTypeName);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-7': () => this.editor.commands.toggleOrderedList(),
        };
    },
    addInputRules() {
        return [
            wrappingInputRule({
                find: tiptap_extension_ordered_list_esm_inputRegex,
                type: this.type,
                getAttributes: match => ({ start: +match[1] }),
                joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-ordered-list.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bullet-list/dist/tiptap-extension-bullet-list.esm.js


const tiptap_extension_bullet_list_esm_inputRegex = /^\s*([-+*])\s$/;
const BulletList = tiptap_core_esm_Node.create({
    name: 'bulletList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML() {
        return [
            { tag: 'ul' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleBulletList: () => ({ commands }) => {
                return commands.toggleList(this.name, this.options.itemTypeName);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
        };
    },
    addInputRules() {
        return [
            wrappingInputRule({
                find: tiptap_extension_bullet_list_esm_inputRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-bullet-list.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-list-item/dist/tiptap-extension-list-item.esm.js


const ListItem = tiptap_core_esm_Node.create({
    name: 'listItem',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML() {
        return [
            {
                tag: 'li',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addKeyboardShortcuts() {
        return {
            Enter: () => this.editor.commands.splitListItem(this.name),
            Tab: () => this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': () => this.editor.commands.liftListItem(this.name),
        };
    },
});


//# sourceMappingURL=tiptap-extension-list-item.esm.js.map

// CONCATENATED MODULE: ./node_modules/linkifyjs/dist/linkify.module.js
/**
 * Finite State Machine generation utilities
 */

/**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 * @param {string|class} token to emit
 */
function linkify_module_State(token) {
  this.j = {}; // IMPLEMENTATION 1
  // this.j = []; // IMPLEMENTATION 2

  this.jr = [];
  this.jd = null;
  this.t = token;
}
/**
 * Take the transition from this state to the next one on the given input.
 * If this state does not exist deterministically, will create it.
 *
 * @param {string} input character or token to transition on
 * @param {string|class} [token] token or multi-token to emit when reaching
 * this state
 */

linkify_module_State.prototype = {
  /**
   * @param {State} state
   */
  accepts: function accepts() {
    return !!this.t;
  },

  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * @param {string} input character or token to transition on
   * @param {Token|State} tokenOrState transition to a matching state
   * @returns State taken after the given input
   */
  tt: function tt(input, tokenOrState) {
    if (tokenOrState && tokenOrState.j) {
      // State, default a basic transition
      this.j[input] = tokenOrState;
      return tokenOrState;
    } // See if there's a direct state transition (not regex or default)


    var token = tokenOrState;
    var nextState = this.j[input];

    if (nextState) {
      if (token) {
        nextState.t = token;
      } // overrwites previous token


      return nextState;
    } // Create a new state for this input


    nextState = makeState(); // Take the transition using the usual default mechanisms

    var templateState = takeT(this, input);

    if (templateState) {
      // Some default state transition, make a prime state based on this one
      Object.assign(nextState.j, templateState.j);
      nextState.jr.append(templateState.jr);
      nextState.jr = templateState.jd;
      nextState.t = token || templateState.t;
    } else {
      nextState.t = token;
    }

    this.j[input] = nextState;
    return nextState;
  }
};
/**
 * Utility function to create state without using new keyword (reduced file size
 * when minified)
 */

var makeState = function makeState() {
  return new linkify_module_State();
};
/**
 * Similar to previous except it is an accepting state that emits a token
 * @param {Token} token
 */

var makeAcceptingState = function makeAcceptingState(token) {
  return new linkify_module_State(token);
};
/**
 * Create a transition from startState to nextState via the given character
 * @param {State} startState transition from thie starting state
 * @param {Token} input via this input character or other concrete token type
 * @param {State} nextState to this next state
 */

var makeT = function makeT(startState, input, nextState) {
  // IMPLEMENTATION 1: Add to object (fast)
  if (!startState.j[input]) {
    startState.j[input] = nextState;
  } // IMPLEMENTATION 2: Add to array (slower)
  // startState.j.push([input, nextState]);

};
/**
 *
 * @param {State} startState stransition from this starting state
 * @param {RegExp} regex Regular expression to match on input
 * @param {State} nextState transition to this next state if there's are regex match
 */

var makeRegexT = function makeRegexT(startState, regex, nextState) {
  startState.jr.push([regex, nextState]);
};
/**
 * Follow the transition from the given character to the next state
 * @param {State} state
 * @param {Token} input character or other concrete token type to transition
 * @returns {?State} the next state, if any
 */

var takeT = function takeT(state, input) {
  // IMPLEMENTATION 1: Object key lookup (faster)
  var nextState = state.j[input];

  if (nextState) {
    return nextState;
  } // IMPLEMENTATION 2: List lookup (slower)
  // Loop through all the state transitions and see if there's a match
  // for (let i = 0; i < state.j.length; i++) {
  //	const val = state.j[i][0];
  //	const nextState = state.j[i][1];
  // 	if (input === val) { return nextState; }
  // }


  for (var i = 0; i < state.jr.length; i++) {
    var regex = state.jr[i][0];
    var _nextState = state.jr[i][1];

    if (regex.test(input)) {
      return _nextState;
    }
  } // Nowhere left to jump! Return default, if any


  return state.jd;
};
/**
 * Similar to makeT, but takes a list of characters that all transition to the
 * same nextState startState
 * @param {State} startState
 * @param {Array} chars
 * @param {State} nextState
 */

var makeMultiT = function makeMultiT(startState, chars, nextState) {
  for (var i = 0; i < chars.length; i++) {
    makeT(startState, chars[i], nextState);
  }
};
/**
 * Set up a list of multiple transitions at once. transitions is a list of
 * tuples, where the first element is the transitions character and the second
 * is the state to transition to
 * @param {State} startState
 * @param {Array} transitions
 */

var makeBatchT = function makeBatchT(startState, transitions) {
  for (var i = 0; i < transitions.length; i++) {
    var input = transitions[i][0];
    var nextState = transitions[i][1];
    makeT(startState, input, nextState);
  }
};
/**
 * For state machines that transition on characters only; given a non-empty
 * target string, generates states (if required) for each consecutive substring
 * of characters starting from the beginning of the string. The final state will
 * have a special value, as specified in options. All other "in between"
 * substrings will have a default end state.
 *
 * This turns the state machine into a Trie-like data structure (rather than a
 * intelligently-designed DFA).
 * @param {State} state
 * @param {string} str
 * @param {Token} endStateFactory
 * @param {Token} defaultStateFactory
 */

var makeChainT = function makeChainT(state, str, endState, defaultStateFactory) {
  var i = 0,
      len = str.length,
      nextState; // Find the next state without a jump to the next character

  while (i < len && (nextState = state.j[str[i]])) {
    state = nextState;
    i++;
  }

  if (i >= len) {
    return [];
  } // no new tokens were added


  while (i < len - 1) {
    nextState = defaultStateFactory();
    makeT(state, str[i], nextState);
    state = nextState;
    i++;
  }

  makeT(state, str[len - 1], endState);
};

/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/
// A valid web domain token
var DOMAIN = 'DOMAIN';
var LOCALHOST = 'LOCALHOST'; // special case of domain
// Valid top-level domain (see tlds.js)

var TLD = 'TLD'; // Any sequence of digits 0-9

var NUM = 'NUM'; // A web URL protocol. Supported types include
// - `http:`
// - `https:`
// - `ftp:`
// - `ftps:`
// - user-defined custom protocols

var PROTOCOL = 'PROTOCOL'; // Start of the email URI protocol

var MAILTO = 'MAILTO'; // mailto:
// Any number of consecutive whitespace characters that are not newline

var WS = 'WS'; // New line (unix style)

var NL = 'NL'; // \n
// Opening/closing bracket classes

var OPENBRACE = 'OPENBRACE'; // {

var OPENBRACKET = 'OPENBRACKET'; // [

var OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <

var OPENPAREN = 'OPENPAREN'; // (

var CLOSEBRACE = 'CLOSEBRACE'; // }

var CLOSEBRACKET = 'CLOSEBRACKET'; // ]

var CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >

var CLOSEPAREN = 'CLOSEPAREN'; // )
// Various symbols

var AMPERSAND = 'AMPERSAND'; // &

var APOSTROPHE = 'APOSTROPHE'; // '

var ASTERISK = 'ASTERISK'; // *

var AT = 'AT'; // @

var BACKSLASH = 'BACKSLASH'; // \

var BACKTICK = 'BACKTICK'; // `

var CARET = 'CARET'; // ^

var COLON = 'COLON'; // :

var COMMA = 'COMMA'; // ,

var DOLLAR = 'DOLLAR'; // $

var DOT = 'DOT'; // .

var EQUALS = 'EQUALS'; // =

var EXCLAMATION = 'EXCLAMATION'; // !

var HYPHEN = 'HYPHEN'; // -

var PERCENT = 'PERCENT'; // %

var PIPE = 'PIPE'; // |

var PLUS = 'PLUS'; // +

var POUND = 'POUND'; // #

var QUERY = 'QUERY'; // ?

var QUOTE = 'QUOTE'; // "

var SEMI = 'SEMI'; // ;

var SLASH = 'SLASH'; // /

var TILDE = 'TILDE'; // ~

var UNDERSCORE = 'UNDERSCORE'; // _
// Default token - anything that is not one of the above

var SYM = 'SYM';

var linkify_module_text = /*#__PURE__*/Object.freeze({
	__proto__: null,
	DOMAIN: DOMAIN,
	LOCALHOST: LOCALHOST,
	TLD: TLD,
	NUM: NUM,
	PROTOCOL: PROTOCOL,
	MAILTO: MAILTO,
	WS: WS,
	NL: NL,
	OPENBRACE: OPENBRACE,
	OPENBRACKET: OPENBRACKET,
	OPENANGLEBRACKET: OPENANGLEBRACKET,
	OPENPAREN: OPENPAREN,
	CLOSEBRACE: CLOSEBRACE,
	CLOSEBRACKET: CLOSEBRACKET,
	CLOSEANGLEBRACKET: CLOSEANGLEBRACKET,
	CLOSEPAREN: CLOSEPAREN,
	AMPERSAND: AMPERSAND,
	APOSTROPHE: APOSTROPHE,
	ASTERISK: ASTERISK,
	AT: AT,
	BACKSLASH: BACKSLASH,
	BACKTICK: BACKTICK,
	CARET: CARET,
	COLON: COLON,
	COMMA: COMMA,
	DOLLAR: DOLLAR,
	DOT: DOT,
	EQUALS: EQUALS,
	EXCLAMATION: EXCLAMATION,
	HYPHEN: HYPHEN,
	PERCENT: PERCENT,
	PIPE: PIPE,
	PLUS: PLUS,
	POUND: POUND,
	QUERY: QUERY,
	QUOTE: QUOTE,
	SEMI: SEMI,
	SLASH: SLASH,
	TILDE: TILDE,
	UNDERSCORE: UNDERSCORE,
	SYM: SYM
});

// NOTE: punycode versions of IDNs are not included here because these will not
// be as commonly used without the http prefix anyway and linkify will already
// force-encode those.
// To be updated with the values in this list
// http://data.iana.org/TLD/tlds-alpha-by-domain.txt
// Version 2021022800, Last Updated Sun Feb 28 07:07:01 2021 UTC
var tlds = 'aaa \
aarp \
abarth \
abb \
abbott \
abbvie \
abc \
able \
abogado \
abudhabi \
ac \
academy \
accenture \
accountant \
accountants \
aco \
actor \
ad \
adac \
ads \
adult \
ae \
aeg \
aero \
aetna \
af \
afamilycompany \
afl \
africa \
ag \
agakhan \
agency \
ai \
aig \
airbus \
airforce \
airtel \
akdn \
al \
alfaromeo \
alibaba \
alipay \
allfinanz \
allstate \
ally \
alsace \
alstom \
am \
amazon \
americanexpress \
americanfamily \
amex \
amfam \
amica \
amsterdam \
analytics \
android \
anquan \
anz \
ao \
aol \
apartments \
app \
apple \
aq \
aquarelle \
ar \
arab \
aramco \
archi \
army \
arpa \
art \
arte \
as \
asda \
asia \
associates \
at \
athleta \
attorney \
au \
auction \
audi \
audible \
audio \
auspost \
author \
auto \
autos \
avianca \
aw \
aws \
ax \
axa \
az \
azure \
ba \
baby \
baidu \
banamex \
bananarepublic \
band \
bank \
bar \
barcelona \
barclaycard \
barclays \
barefoot \
bargains \
baseball \
basketball \
bauhaus \
bayern \
bb \
bbc \
bbt \
bbva \
bcg \
bcn \
bd \
be \
beats \
beauty \
beer \
bentley \
berlin \
best \
bestbuy \
bet \
bf \
bg \
bh \
bharti \
bi \
bible \
bid \
bike \
bing \
bingo \
bio \
biz \
bj \
black \
blackfriday \
blockbuster \
blog \
bloomberg \
blue \
bm \
bms \
bmw \
bn \
bnpparibas \
bo \
boats \
boehringer \
bofa \
bom \
bond \
boo \
book \
booking \
bosch \
bostik \
boston \
bot \
boutique \
box \
br \
bradesco \
bridgestone \
broadway \
broker \
brother \
brussels \
bs \
bt \
budapest \
bugatti \
build \
builders \
business \
buy \
buzz \
bv \
bw \
by \
bz \
bzh \
ca \
cab \
cafe \
cal \
call \
calvinklein \
cam \
camera \
camp \
cancerresearch \
canon \
capetown \
capital \
capitalone \
car \
caravan \
cards \
care \
career \
careers \
cars \
casa \
case \
cash \
casino \
cat \
catering \
catholic \
cba \
cbn \
cbre \
cbs \
cc \
cd \
center \
ceo \
cern \
cf \
cfa \
cfd \
cg \
ch \
chanel \
channel \
charity \
chase \
chat \
cheap \
chintai \
christmas \
chrome \
church \
ci \
cipriani \
circle \
cisco \
citadel \
citi \
citic \
city \
cityeats \
ck \
cl \
claims \
cleaning \
click \
clinic \
clinique \
clothing \
cloud \
club \
clubmed \
cm \
cn \
co \
coach \
codes \
coffee \
college \
cologne \
com \
comcast \
commbank \
community \
company \
compare \
computer \
comsec \
condos \
construction \
consulting \
contact \
contractors \
cooking \
cookingchannel \
cool \
coop \
corsica \
country \
coupon \
coupons \
courses \
cpa \
cr \
credit \
creditcard \
creditunion \
cricket \
crown \
crs \
cruise \
cruises \
csc \
cu \
cuisinella \
cv \
cw \
cx \
cy \
cymru \
cyou \
cz \
dabur \
dad \
dance \
data \
date \
dating \
datsun \
day \
dclk \
dds \
de \
deal \
dealer \
deals \
degree \
delivery \
dell \
deloitte \
delta \
democrat \
dental \
dentist \
desi \
design \
dev \
dhl \
diamonds \
diet \
digital \
direct \
directory \
discount \
discover \
dish \
diy \
dj \
dk \
dm \
dnp \
do \
docs \
doctor \
dog \
domains \
dot \
download \
drive \
dtv \
dubai \
duck \
dunlop \
dupont \
durban \
dvag \
dvr \
dz \
earth \
eat \
ec \
eco \
edeka \
edu \
education \
ee \
eg \
email \
emerck \
energy \
engineer \
engineering \
enterprises \
epson \
equipment \
er \
ericsson \
erni \
es \
esq \
estate \
et \
etisalat \
eu \
eurovision \
eus \
events \
exchange \
expert \
exposed \
express \
extraspace \
fage \
fail \
fairwinds \
faith \
family \
fan \
fans \
farm \
farmers \
fashion \
fast \
fedex \
feedback \
ferrari \
ferrero \
fi \
fiat \
fidelity \
fido \
film \
final \
finance \
financial \
fire \
firestone \
firmdale \
fish \
fishing \
fit \
fitness \
fj \
fk \
flickr \
flights \
flir \
florist \
flowers \
fly \
fm \
fo \
foo \
food \
foodnetwork \
football \
ford \
forex \
forsale \
forum \
foundation \
fox \
fr \
free \
fresenius \
frl \
frogans \
frontdoor \
frontier \
ftr \
fujitsu \
fujixerox \
fun \
fund \
furniture \
futbol \
fyi \
ga \
gal \
gallery \
gallo \
gallup \
game \
games \
gap \
garden \
gay \
gb \
gbiz \
gd \
gdn \
ge \
gea \
gent \
genting \
george \
gf \
gg \
ggee \
gh \
gi \
gift \
gifts \
gives \
giving \
gl \
glade \
glass \
gle \
global \
globo \
gm \
gmail \
gmbh \
gmo \
gmx \
gn \
godaddy \
gold \
goldpoint \
golf \
goo \
goodyear \
goog \
google \
gop \
got \
gov \
gp \
gq \
gr \
grainger \
graphics \
gratis \
green \
gripe \
grocery \
group \
gs \
gt \
gu \
guardian \
gucci \
guge \
guide \
guitars \
guru \
gw \
gy \
hair \
hamburg \
hangout \
haus \
hbo \
hdfc \
hdfcbank \
health \
healthcare \
help \
helsinki \
here \
hermes \
hgtv \
hiphop \
hisamitsu \
hitachi \
hiv \
hk \
hkt \
hm \
hn \
hockey \
holdings \
holiday \
homedepot \
homegoods \
homes \
homesense \
honda \
horse \
hospital \
host \
hosting \
hot \
hoteles \
hotels \
hotmail \
house \
how \
hr \
hsbc \
ht \
hu \
hughes \
hyatt \
hyundai \
ibm \
icbc \
ice \
icu \
id \
ie \
ieee \
ifm \
ikano \
il \
im \
imamat \
imdb \
immo \
immobilien \
in \
inc \
industries \
infiniti \
info \
ing \
ink \
institute \
insurance \
insure \
int \
international \
intuit \
investments \
io \
ipiranga \
iq \
ir \
irish \
is \
ismaili \
ist \
istanbul \
it \
itau \
itv \
iveco \
jaguar \
java \
jcb \
je \
jeep \
jetzt \
jewelry \
jio \
jll \
jm \
jmp \
jnj \
jo \
jobs \
joburg \
jot \
joy \
jp \
jpmorgan \
jprs \
juegos \
juniper \
kaufen \
kddi \
ke \
kerryhotels \
kerrylogistics \
kerryproperties \
kfh \
kg \
kh \
ki \
kia \
kim \
kinder \
kindle \
kitchen \
kiwi \
km \
kn \
koeln \
komatsu \
kosher \
kp \
kpmg \
kpn \
kr \
krd \
kred \
kuokgroup \
kw \
ky \
kyoto \
kz \
la \
lacaixa \
lamborghini \
lamer \
lancaster \
lancia \
land \
landrover \
lanxess \
lasalle \
lat \
latino \
latrobe \
law \
lawyer \
lb \
lc \
lds \
lease \
leclerc \
lefrak \
legal \
lego \
lexus \
lgbt \
li \
lidl \
life \
lifeinsurance \
lifestyle \
lighting \
like \
lilly \
limited \
limo \
lincoln \
linde \
link \
lipsy \
live \
living \
lixil \
lk \
llc \
llp \
loan \
loans \
locker \
locus \
loft \
lol \
london \
lotte \
lotto \
love \
lpl \
lplfinancial \
lr \
ls \
lt \
ltd \
ltda \
lu \
lundbeck \
luxe \
luxury \
lv \
ly \
ma \
macys \
madrid \
maif \
maison \
makeup \
man \
management \
mango \
map \
market \
marketing \
markets \
marriott \
marshalls \
maserati \
mattel \
mba \
mc \
mckinsey \
md \
me \
med \
media \
meet \
melbourne \
meme \
memorial \
men \
menu \
merckmsd \
mg \
mh \
miami \
microsoft \
mil \
mini \
mint \
mit \
mitsubishi \
mk \
ml \
mlb \
mls \
mm \
mma \
mn \
mo \
mobi \
mobile \
moda \
moe \
moi \
mom \
monash \
money \
monster \
mormon \
mortgage \
moscow \
moto \
motorcycles \
mov \
movie \
mp \
mq \
mr \
ms \
msd \
mt \
mtn \
mtr \
mu \
museum \
mutual \
mv \
mw \
mx \
my \
mz \
na \
nab \
nagoya \
name \
nationwide \
natura \
navy \
nba \
nc \
ne \
nec \
net \
netbank \
netflix \
network \
neustar \
new \
news \
next \
nextdirect \
nexus \
nf \
nfl \
ng \
ngo \
nhk \
ni \
nico \
nike \
nikon \
ninja \
nissan \
nissay \
nl \
no \
nokia \
northwesternmutual \
norton \
now \
nowruz \
nowtv \
np \
nr \
nra \
nrw \
ntt \
nu \
nyc \
nz \
obi \
observer \
off \
office \
okinawa \
olayan \
olayangroup \
oldnavy \
ollo \
om \
omega \
one \
ong \
onl \
online \
onyourside \
ooo \
open \
oracle \
orange \
org \
organic \
origins \
osaka \
otsuka \
ott \
ovh \
pa \
page \
panasonic \
paris \
pars \
partners \
parts \
party \
passagens \
pay \
pccw \
pe \
pet \
pf \
pfizer \
pg \
ph \
pharmacy \
phd \
philips \
phone \
photo \
photography \
photos \
physio \
pics \
pictet \
pictures \
pid \
pin \
ping \
pink \
pioneer \
pizza \
pk \
pl \
place \
play \
playstation \
plumbing \
plus \
pm \
pn \
pnc \
pohl \
poker \
politie \
porn \
post \
pr \
pramerica \
praxi \
press \
prime \
pro \
prod \
productions \
prof \
progressive \
promo \
properties \
property \
protection \
pru \
prudential \
ps \
pt \
pub \
pw \
pwc \
py \
qa \
qpon \
quebec \
quest \
qvc \
racing \
radio \
raid \
re \
read \
realestate \
realtor \
realty \
recipes \
red \
redstone \
redumbrella \
rehab \
reise \
reisen \
reit \
reliance \
ren \
rent \
rentals \
repair \
report \
republican \
rest \
restaurant \
review \
reviews \
rexroth \
rich \
richardli \
ricoh \
ril \
rio \
rip \
rmit \
ro \
rocher \
rocks \
rodeo \
rogers \
room \
rs \
rsvp \
ru \
rugby \
ruhr \
run \
rw \
rwe \
ryukyu \
sa \
saarland \
safe \
safety \
sakura \
sale \
salon \
samsclub \
samsung \
sandvik \
sandvikcoromant \
sanofi \
sap \
sarl \
sas \
save \
saxo \
sb \
sbi \
sbs \
sc \
sca \
scb \
schaeffler \
schmidt \
scholarships \
school \
schule \
schwarz \
science \
scjohnson \
scot \
sd \
se \
search \
seat \
secure \
security \
seek \
select \
sener \
services \
ses \
seven \
sew \
sex \
sexy \
sfr \
sg \
sh \
shangrila \
sharp \
shaw \
shell \
shia \
shiksha \
shoes \
shop \
shopping \
shouji \
show \
showtime \
si \
silk \
sina \
singles \
site \
sj \
sk \
ski \
skin \
sky \
skype \
sl \
sling \
sm \
smart \
smile \
sn \
sncf \
so \
soccer \
social \
softbank \
software \
sohu \
solar \
solutions \
song \
sony \
soy \
spa \
space \
sport \
spot \
spreadbetting \
sr \
srl \
ss \
st \
stada \
staples \
star \
statebank \
statefarm \
stc \
stcgroup \
stockholm \
storage \
store \
stream \
studio \
study \
style \
su \
sucks \
supplies \
supply \
support \
surf \
surgery \
suzuki \
sv \
swatch \
swiftcover \
swiss \
sx \
sy \
sydney \
systems \
sz \
tab \
taipei \
talk \
taobao \
target \
tatamotors \
tatar \
tattoo \
tax \
taxi \
tc \
tci \
td \
tdk \
team \
tech \
technology \
tel \
temasek \
tennis \
teva \
tf \
tg \
th \
thd \
theater \
theatre \
tiaa \
tickets \
tienda \
tiffany \
tips \
tires \
tirol \
tj \
tjmaxx \
tjx \
tk \
tkmaxx \
tl \
tm \
tmall \
tn \
to \
today \
tokyo \
tools \
top \
toray \
toshiba \
total \
tours \
town \
toyota \
toys \
tr \
trade \
trading \
training \
travel \
travelchannel \
travelers \
travelersinsurance \
trust \
trv \
tt \
tube \
tui \
tunes \
tushu \
tv \
tvs \
tw \
tz \
ua \
ubank \
ubs \
ug \
uk \
unicom \
university \
uno \
uol \
ups \
us \
uy \
uz \
va \
vacations \
vana \
vanguard \
vc \
ve \
vegas \
ventures \
verisign \
versicherung \
vet \
vg \
vi \
viajes \
video \
vig \
viking \
villas \
vin \
vip \
virgin \
visa \
vision \
viva \
vivo \
vlaanderen \
vn \
vodka \
volkswagen \
volvo \
vote \
voting \
voto \
voyage \
vu \
vuelos \
wales \
walmart \
walter \
wang \
wanggou \
watch \
watches \
weather \
weatherchannel \
webcam \
weber \
website \
wed \
wedding \
weibo \
weir \
wf \
whoswho \
wien \
wiki \
williamhill \
win \
windows \
wine \
winners \
wme \
wolterskluwer \
woodside \
work \
works \
world \
wow \
ws \
wtc \
wtf \
xbox \
xerox \
xfinity \
xihuan \
xin \
xxx \
xyz \
yachts \
yahoo \
yamaxun \
yandex \
ye \
yodobashi \
yoga \
yokohama \
you \
youtube \
yt \
yun \
za \
zappos \
zara \
zero \
zip \
zm \
zone \
zuerich \
zw \
vermögensberater-ctb \
vermögensberatung-pwb \
ελ \
ευ \
бг \
бел \
дети \
ею \
католик \
ком \
қаз \
мкд \
мон \
москва \
онлайн \
орг \
рус \
рф \
сайт \
срб \
укр \
გე \
հայ \
ישראל \
קום \
ابوظبي \
اتصالات \
ارامكو \
الاردن \
البحرين \
الجزائر \
السعودية \
العليان \
المغرب \
امارات \
ایران \
بارت \
بازار \
بھارت \
بيتك \
پاکستان \
ڀارت \
تونس \
سودان \
سورية \
شبكة \
عراق \
عرب \
عمان \
فلسطين \
قطر \
كاثوليك \
كوم \
مصر \
مليسيا \
موريتانيا \
موقع \
همراه \
कॉम \
नेट \
भारत \
भारतम् \
भारोत \
संगठन \
বাংলা \
ভারত \
ভাৰত \
ਭਾਰਤ \
ભારત \
ଭାରତ \
இந்தியா \
இலங்கை \
சிங்கப்பூர் \
భారత్ \
ಭಾರತ \
ഭാരതം \
ලංකා \
คอม \
ไทย \
ລາວ \
닷넷 \
닷컴 \
삼성 \
한국 \
アマゾン \
グーグル \
クラウド \
コム \
ストア \
セール \
ファッション \
ポイント \
みんな \
世界 \
中信 \
中国 \
中國 \
中文网 \
亚马逊 \
企业 \
佛山 \
信息 \
健康 \
八卦 \
公司 \
公益 \
台湾 \
台灣 \
商城 \
商店 \
商标 \
嘉里 \
嘉里大酒店 \
在线 \
大众汽车 \
大拿 \
天主教 \
娱乐 \
家電 \
广东 \
微博 \
慈善 \
我爱你 \
手机 \
招聘 \
政务 \
政府 \
新加坡 \
新闻 \
时尚 \
書籍 \
机构 \
淡马锡 \
游戏 \
澳門 \
点看 \
移动 \
组织机构 \
网址 \
网店 \
网站 \
网络 \
联通 \
诺基亚 \
谷歌 \
购物 \
通販 \
集团 \
電訊盈科 \
飞利浦 \
食品 \
餐厅 \
香格里拉 \
香港'.split(' ');

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/

var LETTER = /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/; // Any Unicode character with letter data type

var EMOJI = /(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDD-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6])/; // Any Unicode emoji character

var EMOJI_VARIATION = /\uFE0F/; // Variation selector, follows heart and others

var DIGIT = /\d/;
var SPACE = /\s/;
/**
 * Initialize the scanner character-based state machine for the given start state
 * @return {State} scanner starting state
 */

function init$2() {
  var customProtocols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Frequently used states
  var S_START = makeState();
  var S_NUM = makeAcceptingState(NUM);
  var S_DOMAIN = makeAcceptingState(DOMAIN);
  var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters

  var S_WS = makeAcceptingState(WS);
  var DOMAIN_REGEX_TRANSITIONS = [[DIGIT, S_DOMAIN], [LETTER, S_DOMAIN], [EMOJI, S_DOMAIN], [EMOJI_VARIATION, S_DOMAIN]]; // Create a state which emits a domain token

  var makeDomainState = function makeDomainState() {
    var state = makeAcceptingState(DOMAIN);
    state.j = {
      '-': S_DOMAIN_HYPHEN
    };
    state.jr = [].concat(DOMAIN_REGEX_TRANSITIONS);
    return state;
  }; // Create a state which does not emit a domain state but the usual alphanumeric
  // transitions are domains


  var makeNearDomainState = function makeNearDomainState(token) {
    var state = makeDomainState();
    state.t = token;
    return state;
  }; // States for special URL symbols that accept immediately after start


  makeBatchT(S_START, [["'", makeAcceptingState(APOSTROPHE)], ['{', makeAcceptingState(OPENBRACE)], ['[', makeAcceptingState(OPENBRACKET)], ['<', makeAcceptingState(OPENANGLEBRACKET)], ['(', makeAcceptingState(OPENPAREN)], ['}', makeAcceptingState(CLOSEBRACE)], [']', makeAcceptingState(CLOSEBRACKET)], ['>', makeAcceptingState(CLOSEANGLEBRACKET)], [')', makeAcceptingState(CLOSEPAREN)], ['&', makeAcceptingState(AMPERSAND)], ['*', makeAcceptingState(ASTERISK)], ['@', makeAcceptingState(AT)], ['`', makeAcceptingState(BACKTICK)], ['^', makeAcceptingState(CARET)], [':', makeAcceptingState(COLON)], [',', makeAcceptingState(COMMA)], ['$', makeAcceptingState(DOLLAR)], ['.', makeAcceptingState(DOT)], ['=', makeAcceptingState(EQUALS)], ['!', makeAcceptingState(EXCLAMATION)], ['-', makeAcceptingState(HYPHEN)], ['%', makeAcceptingState(PERCENT)], ['|', makeAcceptingState(PIPE)], ['+', makeAcceptingState(PLUS)], ['#', makeAcceptingState(POUND)], ['?', makeAcceptingState(QUERY)], ['"', makeAcceptingState(QUOTE)], ['/', makeAcceptingState(SLASH)], [';', makeAcceptingState(SEMI)], ['~', makeAcceptingState(TILDE)], ['_', makeAcceptingState(UNDERSCORE)], ['\\', makeAcceptingState(BACKSLASH)]]); // Whitespace jumps
  // Tokens of only non-newline whitespace are arbitrarily long

  makeT(S_START, '\n', makeAcceptingState(NL));
  makeRegexT(S_START, SPACE, S_WS); // If any whitespace except newline, more whitespace!

  makeT(S_WS, '\n', makeState()); // non-accepting state

  makeRegexT(S_WS, SPACE, S_WS); // Generates states for top-level domains
  // Note that this is most accurate when tlds are in alphabetical order

  for (var i = 0; i < tlds.length; i++) {
    makeChainT(S_START, tlds[i], makeNearDomainState(TLD), makeDomainState);
  } // Collect the states generated by different protocls


  var S_PROTOCOL_FILE = makeDomainState();
  var S_PROTOCOL_FTP = makeDomainState();
  var S_PROTOCOL_HTTP = makeDomainState();
  var S_MAILTO = makeDomainState();
  makeChainT(S_START, 'file', S_PROTOCOL_FILE, makeDomainState);
  makeChainT(S_START, 'ftp', S_PROTOCOL_FTP, makeDomainState);
  makeChainT(S_START, 'http', S_PROTOCOL_HTTP, makeDomainState);
  makeChainT(S_START, 'mailto', S_MAILTO, makeDomainState); // Protocol states

  var S_PROTOCOL_SECURE = makeDomainState();
  var S_FULL_PROTOCOL = makeAcceptingState(PROTOCOL); // Full protocol ends with COLON

  var S_FULL_MAILTO = makeAcceptingState(MAILTO); // Mailto ends with COLON
  // Secure protocols (end with 's')

  makeT(S_PROTOCOL_FTP, 's', S_PROTOCOL_SECURE);
  makeT(S_PROTOCOL_FTP, ':', S_FULL_PROTOCOL);
  makeT(S_PROTOCOL_HTTP, 's', S_PROTOCOL_SECURE);
  makeT(S_PROTOCOL_HTTP, ':', S_FULL_PROTOCOL); // Become protocol tokens after a COLON

  makeT(S_PROTOCOL_FILE, ':', S_FULL_PROTOCOL);
  makeT(S_PROTOCOL_SECURE, ':', S_FULL_PROTOCOL);
  makeT(S_MAILTO, ':', S_FULL_MAILTO); // Register custom protocols

  var S_CUSTOM_PROTOCOL = makeDomainState();

  for (var _i = 0; _i < customProtocols.length; _i++) {
    makeChainT(S_START, customProtocols[_i], S_CUSTOM_PROTOCOL, makeDomainState);
  }

  makeT(S_CUSTOM_PROTOCOL, ':', S_FULL_PROTOCOL); // Localhost

  makeChainT(S_START, 'localhost', makeNearDomainState(LOCALHOST), makeDomainState); // Everything else
  // DOMAINs make more DOMAINs
  // Number and character transitions

  makeRegexT(S_START, DIGIT, S_NUM);
  makeRegexT(S_START, LETTER, S_DOMAIN);
  makeRegexT(S_START, EMOJI, S_DOMAIN);
  makeRegexT(S_START, EMOJI_VARIATION, S_DOMAIN);
  makeRegexT(S_NUM, DIGIT, S_NUM);
  makeRegexT(S_NUM, LETTER, S_DOMAIN); // number becomes DOMAIN

  makeRegexT(S_NUM, EMOJI, S_DOMAIN); // number becomes DOMAIN

  makeRegexT(S_NUM, EMOJI_VARIATION, S_DOMAIN); // number becomes DOMAIN

  makeT(S_NUM, '-', S_DOMAIN_HYPHEN); // Default domain transitions

  makeT(S_DOMAIN, '-', S_DOMAIN_HYPHEN);
  makeT(S_DOMAIN_HYPHEN, '-', S_DOMAIN_HYPHEN);
  makeRegexT(S_DOMAIN, DIGIT, S_DOMAIN);
  makeRegexT(S_DOMAIN, LETTER, S_DOMAIN);
  makeRegexT(S_DOMAIN, EMOJI, S_DOMAIN);
  makeRegexT(S_DOMAIN, EMOJI_VARIATION, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, DIGIT, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, LETTER, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, EMOJI, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, EMOJI_VARIATION, S_DOMAIN); // Set default transition for start state (some symbol)

  S_START.jd = makeAcceptingState(SYM);
  return S_START;
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State} start scanner starting state
	@param {string} str input string to scan
	@return {{t: string, v: string, s: number, l: number}[]} list of tokens, each with a type and value
*/

function linkify_module_run$1(start, str) {
  // State machine is not case sensitive, so input is tokenized in lowercased
  // form (still returns the regular case though) Uses selective `toLowerCase`
  // is used because lowercasing the entire string causes the length and
  // character position to vary in some non-English strings with V8-based
  // runtimes.
  var iterable = stringToArray(str.replace(/[A-Z]/g, function (c) {
    return c.toLowerCase();
  }));
  var charCount = iterable.length; // <= len if there are emojis, etc

  var tokens = []; // return value
  // cursor through the string itself, accounting for characters that have
  // width with length 2 such as emojis

  var cursor = 0; // Cursor through the array-representation of the string

  var charCursor = 0; // Tokenize the string

  while (charCursor < charCount) {
    var state = start;
    var nextState = null;
    var tokenLength = 0;
    var latestAccepting = null;
    var sinceAccepts = -1;
    var charsSinceAccepts = -1;

    while (charCursor < charCount && (nextState = takeT(state, iterable[charCursor]))) {
      state = nextState; // Keep track of the latest accepting state

      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }

      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    } // Roll back to the latest accepting state


    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts; // No more jumps, just make a new token from the last accepting one
    // TODO: If possible, don't output v, instead output range where values ocur

    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.substr(cursor - tokenLength, tokenLength),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor // end index (excluding)

    });
  }

  return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */

function stringToArray(str) {
  var result = [];
  var len = str.length;
  var index = 0;

  while (index < len) {
    var first = str.charCodeAt(index);
    var second = void 0;
    var char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
    : str.slice(index, index + 2); // two-index characters

    result.push(char);
    index += char.length;
  }

  return result;
}

function linkify_module_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    linkify_module_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    linkify_module_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return linkify_module_typeof(obj);
}

/**
 * @property {string} defaultProtocol
 * @property {{[string]: (event) => void}]} [events]
 */
var defaults = {
  defaultProtocol: 'http',
  events: null,
  format: noop,
  formatHref: noop,
  nl2br: false,
  tagName: 'a',
  target: null,
  rel: null,
  validate: true,
  truncate: 0,
  className: null,
  attributes: null,
  ignoreTags: []
};
/**
 * @class Options
 * @param {Object} [opts] Set option properties besides the defaults
 */

function Options(opts) {
  opts = opts || {};
  this.defaultProtocol = 'defaultProtocol' in opts ? opts.defaultProtocol : defaults.defaultProtocol;
  this.events = 'events' in opts ? opts.events : defaults.events;
  this.format = 'format' in opts ? opts.format : defaults.format;
  this.formatHref = 'formatHref' in opts ? opts.formatHref : defaults.formatHref;
  this.nl2br = 'nl2br' in opts ? opts.nl2br : defaults.nl2br;
  this.tagName = 'tagName' in opts ? opts.tagName : defaults.tagName;
  this.target = 'target' in opts ? opts.target : defaults.target;
  this.rel = 'rel' in opts ? opts.rel : defaults.rel;
  this.validate = 'validate' in opts ? opts.validate : defaults.validate;
  this.truncate = 'truncate' in opts ? opts.truncate : defaults.truncate;
  this.className = 'className' in opts ? opts.className : defaults.className;
  this.attributes = opts.attributes || defaults.attributes;
  this.ignoreTags = []; // Make all tags names upper case

  var ignoredTags = 'ignoreTags' in opts ? opts.ignoreTags : defaults.ignoreTags;

  for (var i = 0; i < ignoredTags.length; i++) {
    this.ignoreTags.push(ignoredTags[i].toUpperCase());
  }
}
Options.prototype = {
  /**
   * Given the token, return all options for how it should be displayed
   */
  resolve: function resolve(token) {
    var href = token.toHref(this.defaultProtocol);
    return {
      formatted: this.get('format', token.toString(), token),
      formattedHref: this.get('formatHref', href, token),
      tagName: this.get('tagName', href, token),
      className: this.get('className', href, token),
      target: this.get('target', href, token),
      rel: this.get('rel', href, token),
      events: this.getObject('events', href, token),
      attributes: this.getObject('attributes', href, token),
      truncate: this.get('truncate', href, token)
    };
  },

  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options. By default,
   */
  check: function check(token) {
    return this.get('validate', token.toString(), token);
  },
  // Private methods

  /**
   * Resolve an option's value based on the value of the option and the given
   * params.
   * @param {string} key Name of option to use
   * @param operator will be passed to the target option if it's method
   * @param {MultiToken} token The token from linkify.tokenize
   */
  get: function get(key, operator, token) {
    var option = this[key];

    if (!option) {
      return option;
    }

    var optionValue;

    switch (linkify_module_typeof(option)) {
      case 'function':
        return option(operator, token.t);

      case 'object':
        optionValue = token.t in option ? option[token.t] : defaults[key];
        return typeof optionValue === 'function' ? optionValue(operator, token.t) : optionValue;
    }

    return option;
  },
  getObject: function getObject(key, operator, token) {
    var option = this[key];
    return typeof option === 'function' ? option(operator, token.t) : option;
  }
};

function noop(val) {
  return val;
}

var linkify_module_options = /*#__PURE__*/Object.freeze({
	__proto__: null,
	defaults: defaults,
	Options: Options
});

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

function inherits(parent, child) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var extended = Object.create(parent.prototype);

  for (var p in props) {
    extended[p] = props[p];
  }

  extended.constructor = child;
  child.prototype = extended;
  return child;
}
/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@param {string} value
	@param {{t: string, v: string, s: number, e: number}[]} tokens
	@abstract
*/


function MultiToken() {}
MultiToken.prototype = {
  /**
  	String representing the type for this token
  	@property t
  	@default 'token'
  */
  t: 'token',

  /**
  	Is this multitoken a link?
  	@property isLink
  	@default false
  */
  isLink: false,

  /**
  	Return the string this token represents.
  	@method toString
  	@return {string}
  */
  toString: function toString() {
    return this.v;
  },

  /**
  	What should the value for this token be in the `href` HTML attribute?
  	Returns the `.toString` value by default.
  		@method toHref
  	@return {string}
  */
  toHref: function toHref() {
    return this.toString();
  },

  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex: function startIndex() {
    return this.tk[0].s;
  },

  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex: function endIndex() {
    return this.tk[this.tk.length - 1].e;
  },

  /**
  	Returns a hash of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject: function toObject() {
    var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.defaultProtocol;
    return {
      type: this.t,
      value: this.v,
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  }
}; // Base token
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {(value: string, tokens: {t: string, v: string, s: number, e: number}) => MultiToken} new token class
 */

function createTokenClass(type, props) {
  function Token(value, tokens) {
    this.t = type;
    this.v = value;
    this.tk = tokens;
  }

  inherits(MultiToken, Token, props);
  return Token;
}
/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MailtoEmail
	@extends MultiToken
*/

var MailtoEmail = createTokenClass('email', {
  isLink: true
});
/**
	Represents a list of tokens making up a valid email address
	@class Email
	@extends MultiToken
*/

var Email = createTokenClass('email', {
  isLink: true,
  toHref: function toHref() {
    return 'mailto:' + this.toString();
  }
});
/**
	Represents some plain text
	@class Text
	@extends MultiToken
*/

var linkify_module_Text = createTokenClass('text');
/**
	Multi-linebreak token - represents a line break
	@class Nl
	@extends MultiToken
*/

var Nl = createTokenClass('nl');
/**
	Represents a list of text tokens making up a valid URL
	@class Url
	@extends MultiToken
*/

var Url = createTokenClass('url', {
  isLink: true,

  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@method href
  	@param {string} protocol
  	@return {string}
  */
  toHref: function toHref() {
    var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.defaultProtocol;
    var tokens = this.tk;
    var hasProtocol = false;
    var hasSlashSlash = false;
    var result = [];
    var i = 0; // Make the first part of the domain lowercase
    // Lowercase protocol

    while (tokens[i].t === PROTOCOL) {
      hasProtocol = true;
      result.push(tokens[i].v);
      i++;
    } // Skip slash-slash


    while (tokens[i].t === SLASH) {
      hasSlashSlash = true;
      result.push(tokens[i].v);
      i++;
    } // Continue pushing characters


    for (; i < tokens.length; i++) {
      result.push(tokens[i].v);
    }

    result = result.join('');

    if (!(hasProtocol || hasSlashSlash)) {
      result = "".concat(protocol, "://").concat(result);
    }

    return result;
  },
  hasProtocol: function hasProtocol() {
    return this.tk[0].t === PROTOCOL;
  }
});

var multi = /*#__PURE__*/Object.freeze({
	__proto__: null,
	MultiToken: MultiToken,
	Base: MultiToken,
	createTokenClass: createTokenClass,
	MailtoEmail: MailtoEmail,
	Email: Email,
	Text: linkify_module_Text,
	Nl: Nl,
	Url: Url
});

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/
/**
 * Generate the parser multi token-based state machine
 * @returns {State} the starting state
 */

function init$1() {
  // The universal starting state.
  var S_START = makeState(); // Intermediate states for URLs. Note that domains that begin with a protocol
  // are treated slighly differently from those that don't.

  var S_PROTOCOL = makeState(); // e.g., 'http:'

  var S_MAILTO = makeState(); // 'mailto:'

  var S_PROTOCOL_SLASH = makeState(); // e.g., 'http:/''

  var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g.,'http://'

  var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)

  var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT

  var S_TLD = makeAcceptingState(Url); // (A) Simplest possible URL with no query string

  var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)

  var S_TLD_PORT = makeAcceptingState(Url); // TLD followed by a port number

  var S_URL = makeAcceptingState(Url); // Long URL with optional port and maybe query string

  var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)

  var S_URL_OPENBRACE = makeState(); // URL followed by {

  var S_URL_OPENBRACKET = makeState(); // URL followed by [

  var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <

  var S_URL_OPENPAREN = makeState(); // URL followed by (

  var S_URL_OPENBRACE_Q = makeAcceptingState(Url); // URL followed by { and some symbols that the URL can end it

  var S_URL_OPENBRACKET_Q = makeAcceptingState(Url); // URL followed by [ and some symbols that the URL can end it

  var S_URL_OPENANGLEBRACKET_Q = makeAcceptingState(Url); // URL followed by < and some symbols that the URL can end it

  var S_URL_OPENPAREN_Q = makeAcceptingState(Url); // URL followed by ( and some symbols that the URL can end it

  var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it

  var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it

  var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it

  var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it

  var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)

  var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT

  var S_EMAIL = makeAcceptingState(Email); // (C) Possible email address (could have more tlds)

  var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)

  var S_EMAIL_PORT = makeAcceptingState(Email); // (C) Email address with a port

  var S_MAILTO_EMAIL = makeAcceptingState(MailtoEmail); // Email that begins with the mailto prefix (D)

  var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars

  var S_LOCALPART = makeState(); // Local part of the email address

  var S_LOCALPART_AT = makeState(); // Local part of the email address plus @

  var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)

  var S_NL = makeAcceptingState(Nl); // single new line
  // Make path from start to protocol (with '//')

  makeT(S_START, NL, S_NL);
  makeT(S_START, PROTOCOL, S_PROTOCOL);
  makeT(S_START, MAILTO, S_MAILTO);
  makeT(S_PROTOCOL, SLASH, S_PROTOCOL_SLASH);
  makeT(S_PROTOCOL_SLASH, SLASH, S_PROTOCOL_SLASH_SLASH); // The very first potential domain name

  makeT(S_START, TLD, S_DOMAIN);
  makeT(S_START, DOMAIN, S_DOMAIN);
  makeT(S_START, LOCALHOST, S_TLD);
  makeT(S_START, NUM, S_DOMAIN); // Force URL for protocol followed by anything sane

  makeT(S_PROTOCOL_SLASH_SLASH, TLD, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, DOMAIN, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, NUM, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, LOCALHOST, S_URL); // Account for dots and hyphens
  // hyphens are usually parts of domain names

  makeT(S_DOMAIN, DOT, S_DOMAIN_DOT);
  makeT(S_EMAIL_DOMAIN, DOT, S_EMAIL_DOMAIN_DOT); // Hyphen can jump back to a domain name
  // After the first domain and a dot, we can find either a URL or another domain

  makeT(S_DOMAIN_DOT, TLD, S_TLD);
  makeT(S_DOMAIN_DOT, DOMAIN, S_DOMAIN);
  makeT(S_DOMAIN_DOT, NUM, S_DOMAIN);
  makeT(S_DOMAIN_DOT, LOCALHOST, S_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, TLD, S_EMAIL);
  makeT(S_EMAIL_DOMAIN_DOT, DOMAIN, S_EMAIL_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, NUM, S_EMAIL_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, LOCALHOST, S_EMAIL_DOMAIN); // S_TLD accepts! But the URL could be longer, try to find a match greedily
  // The `run` function should be able to "rollback" to the accepting state

  makeT(S_TLD, DOT, S_DOMAIN_DOT);
  makeT(S_EMAIL, DOT, S_EMAIL_DOMAIN_DOT); // Become real URLs after `SLASH` or `COLON NUM SLASH`
  // Here PSS and non-PSS converge

  makeT(S_TLD, COLON, S_TLD_COLON);
  makeT(S_TLD, SLASH, S_URL);
  makeT(S_TLD_COLON, NUM, S_TLD_PORT);
  makeT(S_TLD_PORT, SLASH, S_URL);
  makeT(S_EMAIL, COLON, S_EMAIL_COLON);
  makeT(S_EMAIL_COLON, NUM, S_EMAIL_PORT); // Types of characters the URL can definitely end in

  var qsAccepting = [AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, DOMAIN, EQUALS, HYPHEN, LOCALHOST, NUM, PERCENT, PIPE, PLUS, POUND, PROTOCOL, SLASH, SYM, TILDE, TLD, UNDERSCORE]; // Types of tokens that can follow a URL and be part of the query string
  // but cannot be the very last characters
  // Characters that cannot appear in the URL at all should be excluded

  var qsNonAccepting = [APOSTROPHE, CLOSEANGLEBRACKET, CLOSEBRACE, CLOSEBRACKET, CLOSEPAREN, COLON, COMMA, DOT, EXCLAMATION, OPENANGLEBRACKET, OPENBRACE, OPENBRACKET, OPENPAREN, QUERY, QUOTE, SEMI]; // These states are responsible primarily for determining whether or not to
  // include the final round bracket.
  // URL, followed by an opening bracket

  makeT(S_URL, OPENBRACE, S_URL_OPENBRACE);
  makeT(S_URL, OPENBRACKET, S_URL_OPENBRACKET);
  makeT(S_URL, OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET);
  makeT(S_URL, OPENPAREN, S_URL_OPENPAREN); // URL with extra symbols at the end, followed by an opening bracket

  makeT(S_URL_NON_ACCEPTING, OPENBRACE, S_URL_OPENBRACE);
  makeT(S_URL_NON_ACCEPTING, OPENBRACKET, S_URL_OPENBRACKET);
  makeT(S_URL_NON_ACCEPTING, OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET);
  makeT(S_URL_NON_ACCEPTING, OPENPAREN, S_URL_OPENPAREN); // Closing bracket component. This character WILL be included in the URL

  makeT(S_URL_OPENBRACE, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN, CLOSEPAREN, S_URL);
  makeT(S_URL_OPENBRACE_Q, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET_Q, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET_Q, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN_Q, CLOSEPAREN, S_URL);
  makeT(S_URL_OPENBRACE_SYMS, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET_SYMS, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET_SYMS, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN_SYMS, CLOSEPAREN, S_URL); // URL that beings with an opening bracket, followed by a symbols.
  // Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
  // has a single opening bracket for some reason).

  makeMultiT(S_URL_OPENBRACE, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE, qsNonAccepting, S_URL_OPENBRACE_SYMS);
  makeMultiT(S_URL_OPENBRACKET, qsNonAccepting, S_URL_OPENBRACKET_SYMS);
  makeMultiT(S_URL_OPENANGLEBRACKET, qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
  makeMultiT(S_URL_OPENPAREN, qsNonAccepting, S_URL_OPENPAREN_SYMS); // URL that begins with an opening bracket, followed by some symbols

  makeMultiT(S_URL_OPENBRACE_Q, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_Q, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_Q, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_Q, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_Q, qsNonAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_Q, qsNonAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_Q, qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_Q, qsNonAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_SYMS, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_SYMS, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_SYMS, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_SYMS, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_SYMS, qsNonAccepting, S_URL_OPENBRACE_SYMS);
  makeMultiT(S_URL_OPENBRACKET_SYMS, qsNonAccepting, S_URL_OPENBRACKET_SYMS);
  makeMultiT(S_URL_OPENANGLEBRACKET_SYMS, qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
  makeMultiT(S_URL_OPENPAREN_SYMS, qsNonAccepting, S_URL_OPENPAREN_SYMS); // Account for the query string

  makeMultiT(S_URL, qsAccepting, S_URL);
  makeMultiT(S_URL_NON_ACCEPTING, qsAccepting, S_URL);
  makeMultiT(S_URL, qsNonAccepting, S_URL_NON_ACCEPTING);
  makeMultiT(S_URL_NON_ACCEPTING, qsNonAccepting, S_URL_NON_ACCEPTING); // Email address-specific state definitions
  // Note: We are not allowing '/' in email addresses since this would interfere
  // with real URLs
  // For addresses with the mailto prefix
  // 'mailto:' followed by anything sane is a valid email

  makeT(S_MAILTO, TLD, S_MAILTO_EMAIL);
  makeT(S_MAILTO, DOMAIN, S_MAILTO_EMAIL);
  makeT(S_MAILTO, NUM, S_MAILTO_EMAIL);
  makeT(S_MAILTO, LOCALHOST, S_MAILTO_EMAIL); // Greedily get more potential valid email values

  makeMultiT(S_MAILTO_EMAIL, qsAccepting, S_MAILTO_EMAIL);
  makeMultiT(S_MAILTO_EMAIL, qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
  makeMultiT(S_MAILTO_EMAIL_NON_ACCEPTING, qsAccepting, S_MAILTO_EMAIL);
  makeMultiT(S_MAILTO_EMAIL_NON_ACCEPTING, qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING); // For addresses without the mailto prefix
  // Tokens allowed in the localpart of the email

  var localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, CLOSEBRACE, DOLLAR, DOMAIN, EQUALS, HYPHEN, NUM, OPENBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, TLD, UNDERSCORE]; // Some of the tokens in `localpartAccepting` are already accounted for here and
  // will not be overwritten (don't worry)

  makeMultiT(S_DOMAIN, localpartAccepting, S_LOCALPART);
  makeT(S_DOMAIN, AT, S_LOCALPART_AT);
  makeMultiT(S_TLD, localpartAccepting, S_LOCALPART);
  makeT(S_TLD, AT, S_LOCALPART_AT);
  makeMultiT(S_DOMAIN_DOT, localpartAccepting, S_LOCALPART); // Now in localpart of address
  // TODO: IP addresses and what if the email starts with numbers?

  makeMultiT(S_LOCALPART, localpartAccepting, S_LOCALPART);
  makeT(S_LOCALPART, AT, S_LOCALPART_AT); // close to an email address now

  makeT(S_LOCALPART, DOT, S_LOCALPART_DOT);
  makeMultiT(S_LOCALPART_DOT, localpartAccepting, S_LOCALPART);
  makeT(S_LOCALPART_AT, TLD, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, DOMAIN, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, NUM, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, LOCALHOST, S_EMAIL); // States following `@` defined above

  return S_START;
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {{t: string, v: string, s: number, e: number}[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */

function linkify_module_run(start, input, tokens) {
  var len = tokens.length;
  var cursor = 0;
  var multis = [];
  var textTokens = [];

  while (cursor < len) {
    var state = start;
    var secondState = null;
    var nextState = null;
    var multiLength = 0;
    var latestAccepting = null;
    var sinceAccepts = -1;

    while (cursor < len && !(secondState = takeT(state, tokens[cursor].t))) {
      // Starting tokens with nowhere to jump to.
      // Consider these to be just plain text
      textTokens.push(tokens[cursor++]);
    }

    while (cursor < len && (nextState = secondState || takeT(state, tokens[cursor].t))) {
      // Get the next state
      secondState = null;
      state = nextState; // Keep track of the latest accepting state

      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }

      cursor++;
      multiLength++;
    }

    if (sinceAccepts < 0) {
      // No accepting state was found, part of a regular text token
      // Add all the tokens we looked at to the text tokens array
      for (var i = cursor - multiLength; i < cursor; i++) {
        textTokens.push(tokens[i]);
      }
    } else {
      // Accepting state!
      // First close off the textTokens (if available)
      if (textTokens.length > 0) {
        multis.push(parserCreateMultiToken(linkify_module_Text, input, textTokens));
        textTokens = [];
      } // Roll back to the latest accepting state


      cursor -= sinceAccepts;
      multiLength -= sinceAccepts; // Create a new multitoken

      var Multi = latestAccepting.t;
      var subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(parserCreateMultiToken(Multi, input, subtokens));
    }
  } // Finally close off the textTokens (if available)


  if (textTokens.length > 0) {
    multis.push(parserCreateMultiToken(linkify_module_Text, input, textTokens));
  }

  return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {Class<MultiToken>} Multi class to instantiate
 * @param {string} input original input string
 * @param {{t: string, v: string, s: number, e: number}[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */

function parserCreateMultiToken(Multi, input, tokens) {
  var startIdx = tokens[0].s;
  var endIdx = tokens[tokens.length - 1].e;
  var value = input.substr(startIdx, endIdx - startIdx);
  return new Multi(value, tokens);
}

var warn = typeof console !== 'undefined' && console && console.warn || function () {}; // Side-effect initialization state


var INIT = {
  scanner: null,
  parser: null,
  pluginQueue: [],
  customProtocols: [],
  initialized: false
};
/**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */

function linkify_module_reset() {
  INIT.scanner = null;
  INIT.parser = null;
  INIT.pluginQueue = [];
  INIT.customProtocols = [];
  INIT.initialized = false;
}
/**
 * Register a linkify extension plugin
 * @param {string} name of plugin to register
 * @param {Function} plugin function that accepts mutable linkify state
 */

function registerPlugin(name, plugin) {
  for (var i = 0; i < INIT.pluginQueue.length; i++) {
    if (name === INIT.pluginQueue[i][0]) {
      warn("linkifyjs: plugin \"".concat(name, "\" already registered - will be overwritten"));
      INIT.pluginQueue[i] = [name, plugin];
      return;
    }
  }

  INIT.pluginQueue.push([name, plugin]);

  if (INIT.initialized) {
    warn("linkifyjs: already initialized - will not register plugin \"".concat(name, "\" until you manually call linkify.init(). To avoid this warning, please register all plugins before invoking linkify the first time."));
  }
}
/**
 * Detect URLs with the following additional protocol. Anything following
 * "protocol:" will be considered a link.
 * @param {string} protocol
 */

function registerCustomProtocol(protocol) {
  if (INIT.initialized) {
    warn("linkifyjs: already initialized - will not register custom protocol \"".concat(protocol, "\" until you manually call linkify.init(). To avoid this warning, please register all custom protocols before invoking linkify the first time."));
  }

  if (!/^[a-z-]+$/.test(protocol)) {
    throw Error('linkifyjs: protocols containing characters other than a-z or - (hyphen) are not supported');
  }

  INIT.customProtocols.push(protocol);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */

function init() {
  // Initialize state machines
  INIT.scanner = {
    start: init$2(INIT.customProtocols),
    tokens: linkify_module_text
  };
  INIT.parser = {
    start: init$1(),
    tokens: multi
  };
  var utils = {
    createTokenClass: createTokenClass
  }; // Initialize plugins

  for (var i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser,
      utils: utils
    });
  }

  INIT.initialized = true;
}
/**
	Parse a string into tokens that represent linkable and non-linkable sub-components
	@param {string} str
	@return {MultiToken[]} tokens
*/

function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }

  return linkify_module_run(INIT.parser.start, str, linkify_module_run$1(INIT.scanner.start, str));
}
/**
	Find a list of linkable items in the given string.
	@param {string} str string to find links in
	@param {string} [type] (optional) only find links of a specific type, e.g.,
	'url' or 'email'
*/

function linkify_module_find(str) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tokens = tokenize(str);
  var filtered = [];

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (token.isLink && (!type || token.t === type)) {
      filtered.push(token.toObject());
    }
  }

  return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */

function test(str) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tokens = tokenize(str);
  return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}



// CONCATENATED MODULE: ./node_modules/@tiptap/extension-link/dist/tiptap-extension-link.esm.js




function autolink(options) {
    return new Plugin({
        key: new PluginKey('autolink'),
        appendTransaction: (transactions, oldState, newState) => {
            const docChanges = transactions.some(transaction => transaction.docChanged)
                && !oldState.doc.eq(newState.doc);
            const preventAutolink = transactions.some(transaction => transaction.getMeta('preventAutolink'));
            if (!docChanges || preventAutolink) {
                return;
            }
            const { tr } = newState;
            const transform = combineTransactionSteps(oldState.doc, transactions);
            const { mapping } = transform;
            const changes = getChangedRanges(transform);
            changes.forEach(({ oldRange, newRange }) => {
                // at first we check if we have to remove links
                getMarksBetween(oldRange.from, oldRange.to, oldState.doc)
                    .filter(item => item.mark.type === options.type)
                    .forEach(oldMark => {
                    const newFrom = mapping.map(oldMark.from);
                    const newTo = mapping.map(oldMark.to);
                    const newMarks = getMarksBetween(newFrom, newTo, newState.doc)
                        .filter(item => item.mark.type === options.type);
                    if (!newMarks.length) {
                        return;
                    }
                    const newMark = newMarks[0];
                    const oldLinkText = oldState.doc.textBetween(oldMark.from, oldMark.to, undefined, ' ');
                    const newLinkText = newState.doc.textBetween(newMark.from, newMark.to, undefined, ' ');
                    const wasLink = test(oldLinkText);
                    const isLink = test(newLinkText);
                    // remove only the link, if it was a link before too
                    // because we don’t want to remove links that were set manually
                    if (wasLink && !isLink) {
                        tr.removeMark(newMark.from, newMark.to, options.type);
                    }
                });
                // now let’s see if we can add new links
                findChildrenInRange(newState.doc, newRange, node => node.isTextblock)
                    .forEach(textBlock => {
                    // we need to define a placeholder for leaf nodes
                    // so that the link position can be calculated correctly
                    const text = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
                    linkify_module_find(text)
                        .filter(link => link.isLink)
                        // calculate link position
                        .map(link => ({
                        ...link,
                        from: textBlock.pos + link.start + 1,
                        to: textBlock.pos + link.end + 1,
                    }))
                        // check if link is within the changed range
                        .filter(link => {
                        const fromIsInRange = newRange.from >= link.from && newRange.from <= link.to;
                        const toIsInRange = newRange.to >= link.from && newRange.to <= link.to;
                        return fromIsInRange || toIsInRange;
                    })
                        // add link mark
                        .forEach(link => {
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href,
                        }));
                    });
                });
            });
            if (!tr.steps.length) {
                return;
            }
            return tr;
        },
    });
}

function clickHandler(options) {
    return new Plugin({
        key: new PluginKey('handleClickLink'),
        props: {
            handleClick: (view, pos, event) => {
                var _a;
                const attrs = getAttributes(view.state, options.type.name);
                const link = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a');
                if (link && attrs.href) {
                    window.open(attrs.href, attrs.target);
                    return true;
                }
                return false;
            },
        },
    });
}

function pasteHandler(options) {
    return new Plugin({
        key: new PluginKey('handlePasteLink'),
        props: {
            handlePaste: (view, event, slice) => {
                const { state } = view;
                const { selection } = state;
                const { empty } = selection;
                if (empty) {
                    return false;
                }
                let textContent = '';
                slice.content.forEach(node => {
                    textContent += node.textContent;
                });
                const link = linkify_module_find(textContent).find(item => item.isLink && item.value === textContent);
                if (!textContent || !link) {
                    return false;
                }
                options.editor.commands.setMark(options.type, {
                    href: link.href,
                });
                return true;
            },
        },
    });
}

const Link = tiptap_core_esm_Mark.create({
    name: 'link',
    priority: 1000,
    keepOnSplit: false,
    inclusive() {
        return this.options.autolink;
    },
    addOptions() {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer nofollow',
            },
        };
    },
    addAttributes() {
        return {
            href: {
                default: null,
            },
            target: {
                default: this.options.HTMLAttributes.target,
            },
        };
    },
    parseHTML() {
        return [
            { tag: 'a[href]' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'a',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
    addCommands() {
        return {
            setLink: attributes => ({ chain }) => {
                return chain()
                    .setMark(this.name, attributes)
                    .setMeta('preventAutolink', true)
                    .run();
            },
            toggleLink: attributes => ({ chain }) => {
                return chain()
                    .toggleMark(this.name, attributes, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
            unsetLink: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
        };
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: text => linkify_module_find(text)
                    .filter(link => link.isLink)
                    .map(link => ({
                    text: link.value,
                    index: link.start,
                    data: link,
                })),
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return ({
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    });
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        const plugins = [];
        if (this.options.autolink) {
            plugins.push(autolink({
                type: this.type,
            }));
        }
        if (this.options.openOnClick) {
            plugins.push(clickHandler({
                type: this.type,
            }));
        }
        if (this.options.linkOnPaste) {
            plugins.push(pasteHandler({
                editor: this.editor,
                type: this.type,
            }));
        }
        return plugins;
    },
});


//# sourceMappingURL=tiptap-extension-link.esm.js.map

// CONCATENATED MODULE: ./src/utils/computeFaviconUrl.ts






/* harmony default export */ var computeFaviconUrl = (function (url) {
  var base = "https://www.google.com/s2/favicons?domain_url=";

  if (url.startsWith("mailto:")) {
    return "".concat(base, "https://").concat(url.split("@")[1]);
  }

  if (url.startsWith("#")) {
    return "https://maydaystatic.blob.core.windows.net/assets/hash-icon.png";
  } // replace dev, staging, app in mayday url to display mayday favicon


  if (url.includes("mayday.fr")) {
    url = url.replace(/^^https:\/\/([\w-.]*)(.mayday.fr)\/(.*)/, "https://www$2/$3");
  }

  return "".concat(base).concat(url);
});
// CONCATENATED MODULE: ./src/extensions/Link/Link.ts











var predicate = function predicate(_ref) {
  var type = _ref.type;
  return type.name === "link";
};

var Link_key = new PluginKey("linkFavicon");

var Link_CustomLinkMark = function CustomLinkMark(vm) {
  return Link.extend({
    addAttributes: function addAttributes() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        favicon: {
          default: null,
          parseHTML: function parseHTML(el) {
            return el.getAttribute("data-favicon");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-favicon": attrs.favicon
            };
          }
        },
        isModalOpening: {
          default: false,
          parseHTML: function parseHTML(el) {
            return el.getAttribute("data-is-modal-open");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-is-modal-open": attrs.isModalOpening
            };
          }
        }
      });
    },
    parseHTML: function parseHTML() {
      return [{
        tag: "a[href]"
      }, // old editor input
      {
        tag: "a[src].embeddable-extension",
        getAttrs: function getAttrs(node) {
          var element = node;
          var href = element.getAttribute("src");
          var target = "_blank";
          var isModalOpening = true;
          return {
            href: href,
            target: target,
            isModalOpening: isModalOpening
          };
        }
      }];
    },
    addOptions: function addOptions() {
      return {
        HTMLAttributes: {
          class: "mayday-editor__content__ProseMirror__link"
        },
        // openOnClick is set to false in order to define our own proper
        // way to manage link onClick events
        openOnClick: false,
        linkOnPaste: true,
        autolink: false
      };
    },
    addCommands: function addCommands() {
      var _this$parent2;

      return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
        setLinkTitle: function setLinkTitle(href, title) {
          return function (_ref2) {
            var dispatch = _ref2.dispatch,
                state = _ref2.state,
                tr = _ref2.tr;

            if (dispatch == null) {
              return false;
            } // grab the current selection from transaction


            var selection = tr.selection;

            if (selection.empty) {
              return false;
            }

            var $anchor = selection.$anchor;
            var parentNode = $anchor.node();
            var startPos = $anchor.start();
            parentNode.descendants(function (node, position) {
              if (startPos + position + node.nodeSize < $anchor.pos) {
                return;
              }

              var matchingMark = node.marks.find(function (_ref3) {
                var attrs = _ref3.attrs;
                return attrs.href === href;
              });

              if (matchingMark != null) {
                // set the title
                var textNode = state.schema.text(title, node.marks); // replace

                dispatch(tr.replaceWith(selection.from, selection.to, textNode).scrollIntoView()); // stop looping through descendants

                return false;
              }
            });
            return true;
          };
        }
      });
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var _this$parent3,
          _this$editor$storage,
          _this = this;

      var plugins = ((_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)) || [];
      var oldState = null;
      var oldDecorationSet = DecorationSet.empty;
      var imageStorage = (_this$editor$storage = this.editor.storage) === null || _this$editor$storage === void 0 ? void 0 : _this$editor$storage.image;
      plugins.push(new Plugin({
        key: Link_key,
        props: {
          decorations: function decorations(state) {
            var doc = state.doc;
            var decorations = [];
            var isSame = oldState != null && oldState.doc.eq(doc) && oldDecorationSet !== DecorationSet.empty;

            if (isSame || imageStorage !== null && imageStorage !== void 0 && imageStorage.isResizing) {
              return oldDecorationSet;
            }

            doc.descendants(function (node, pos) {
              if (node.marks.length > 0) {
                var linkMark = node.marks.find(predicate);

                if (linkMark == null) {
                  return;
                }

                var image = document.createElement("img");
                var _linkMark$attrs = linkMark.attrs,
                    favicon = _linkMark$attrs.favicon,
                    href = _linkMark$attrs.href;
                image.loading = "lazy";
                image.src = favicon || computeFaviconUrl(href);
                image.classList.add("mayday-editor__content__ProseMirror__link-favicon");
                decorations.push(Decoration.widget(pos, image, {
                  href: href
                }));
              }
            });
            oldState = state;
            oldDecorationSet = decorations.length > 0 ? DecorationSet.create(doc, decorations) : DecorationSet.empty;
            return oldDecorationSet;
          }
        }
      }));
      plugins.unshift(new Plugin({
        key: new PluginKey("handleClickLink"),
        props: {
          handleDOMEvents: {
            click: function click(_view, event) {
              var _event$target;

              var linkClass = _this.options.HTMLAttributes.class;
              var link = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest("a.".concat(linkClass));

              if (link) {
                var _this$editor;

                event.preventDefault();
                var isEditable = ((_this$editor = _this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.isEditable) || false;
                var href = link === null || link === void 0 ? void 0 : link.getAttribute("href");
                var isModalOpening = (link === null || link === void 0 ? void 0 : link.getAttribute("data-is-modal-open")) === "true";

                if (href && !isEditable) {
                  if (isModalOpening === true) {
                    vm.$emit("open-link-modal", href);
                  } else {
                    if (href[0] === "#") {
                      vm.$emit("click:focus-hash", href);
                    } else {
                      vm.$emit("click:open-link", {
                        href: href
                      });
                    }
                  }
                }
              }

              return true;
            }
          }
        }
      }));
      return plugins;
    }
  });
};

/* harmony default export */ var Link_Link = (Link_CustomLinkMark);
// CONCATENATED MODULE: ./src/extensions/Embed.ts





var Embed_key = new PluginKey("embed");

var Embed_Embed = function Embed(subdomain) {
  return tiptap_core_esm_Node.create({
    name: "embed",
    group: "block",
    atom: true,
    selectable: true,
    draggable: true,
    addOptions: function addOptions() {
      return {
        allowFullscreen: true,
        loading: "lazy",
        HTMLAttributes: {
          class: "iframe-wrapper"
        },
        subdomain: subdomain || ""
      };
    },
    addAttributes: function addAttributes() {
      var _this = this;

      return {
        src: {
          default: null
        },
        frameborder: {
          default: 0
        },
        allowfullscreen: {
          default: this.options.allowFullscreen,
          parseHTML: function parseHTML() {
            return _this.options.allowFullscreen;
          }
        },
        loading: {
          default: this.options.loading,
          parseHTML: function parseHTML() {
            return _this.options.loading;
          }
        },
        isTypeform: {
          default: false,
          parseHTML: function parseHTML(el) {
            return el.getAttribute("data-is-typeform");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-is-typeform": attrs.isTypeform
            };
          }
        }
      };
    },
    parseHTML: function parseHTML() {
      return [{
        tag: "iframe"
      }];
    },
    renderHTML: function renderHTML(_ref) {
      var HTMLAttributes = _ref.HTMLAttributes;
      return ["div", this.options.HTMLAttributes, ["iframe", HTMLAttributes]];
    },
    renderText: function renderText(_ref2) {
      var node = _ref2.node;
      return "embed@".concat(node.attrs.src);
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_Embed);
    },
    addCommands: function addCommands() {
      var _this2 = this;

      return {
        setEmbed: function setEmbed(attributes) {
          return function (_ref3) {
            var tr = _ref3.tr,
                dispatch = _ref3.dispatch;
            var selection = tr.selection;

            var node = _this2.type.create(attributes);

            if (dispatch != null) {
              tr.replaceRangeWith(selection.from, selection.to, node);
              return true;
            }

            return false;
          };
        },
        highlightEmbed: function highlightEmbed(shouldHighlight) {
          return function (_ref4) {
            var state = _ref4.state,
                dispatch = _ref4.dispatch;

            if (dispatch != null) {
              dispatch(state.tr.setMeta(Embed_key, {
                isHighlighted: shouldHighlight
              }));
              return true;
            }

            return false;
          };
        },
        deleteEmbed: function deleteEmbed() {
          return function (_ref5) {
            var dispatch = _ref5.dispatch,
                tr = _ref5.tr;
            var selection = tr.selection;

            if (dispatch == null || !isNodeSelection(selection) || selection.node.type !== _this2.type) {
              return false;
            }

            dispatch(tr.deleteSelection());
            return true;
          };
        }
      };
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var type = this.type;
      return [new Plugin({
        key: Embed_key,
        state: {
          init: function init() {
            return {
              isHighlighted: false
            };
          },
          apply: function apply(tr, prev) {
            return Object.assign({}, prev, tr.getMeta(Embed_key));
          }
        },
        props: {
          decorations: function decorations(state) {
            var selection = state.selection;

            var _this$getState = this.getState(state),
                isHighlighted = _this$getState.isHighlighted;

            var isEmbed = isNodeSelection(selection) && selection.node.type === type;

            if (isEmbed && isHighlighted) {
              return DecorationSet.create(state.doc, [Decoration.node(selection.from, selection.to, {
                class: "highlight"
              })]);
            }

            return DecorationSet.empty;
          }
        }
      })];
    }
  });
};

/* harmony default export */ var extensions_Embed = (Embed_Embed);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/TableOfContents.vue?vue&type=template&id=4508c698&
var TableOfContentsvue_type_template_id_4508c698_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"toc",class:{ toc__selected: _vm.shouldShowWrapper },attrs:{"draggable":"true"}},[(_vm.headings.length)?_c('ul',{staticClass:"toc__list",attrs:{"data-drag-handle":""}},_vm._l((_vm.headings),function(heading,index){return _c('li',{key:index,staticClass:"toc__item",class:("toc__item--" + (heading.level))},[(_vm.nativeBehaviour)?_c('a',{staticClass:"toc__item__link",attrs:{"href":("#" + (heading.id))}},[_vm._v(" "+_vm._s(heading.name || _vm.$t("mayday-editor.toc.untitled"))+" ")]):_c('span',{staticClass:"toc__item__link",on:{"click":function($event){$event.stopPropagation();return _vm.$parent.$emit('click:toc', heading)}}},[_vm._v(" "+_vm._s(heading.name || _vm.$t("mayday-editor.toc.untitled"))+" ")])])}),0):_c('span',{staticClass:"toc__empty"},[_vm._v(_vm._s(_vm.$t("mayday-editor.toc.empty")))])])}
var TableOfContentsvue_type_template_id_4508c698_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/TableOfContents.vue?vue&type=template&id=4508c698&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// CONCATENATED MODULE: ./src/utils/stringToAlphaNumericLowerCase.ts



/* harmony default export */ var stringToAlphaNumericLowerCase = (function (text) {
  if (!text) return "";
  return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\W_]+/g, " ").trim().replace(/\s+/g, "-");
});
// CONCATENATED MODULE: ./src/utils/generateHeadings.ts













var convertNodeToText = function convertNodeToText(nodeContent, editor) {
  if (nodeContent.text) {
    return nodeContent.text;
  }

  if (nodeContent.type.name === "emoji") {
    var _editor$storage, _editor$storage$emoji, _editor$storage$emoji2;

    var emoji = (_editor$storage = editor.storage) === null || _editor$storage === void 0 ? void 0 : (_editor$storage$emoji = _editor$storage.emoji) === null || _editor$storage$emoji === void 0 ? void 0 : (_editor$storage$emoji2 = _editor$storage$emoji.emojis) === null || _editor$storage$emoji2 === void 0 ? void 0 : _editor$storage$emoji2.find(function (e) {
      return e.name === nodeContent.attrs.name || e.shortcodes.includes(nodeContent.attrs.name);
    });
    return emoji ? emoji.emoji : "";
  }

  return "";
};

var generateHeadings_generateHeadings = function generateHeadings(editor) {
  var headings = [];
  var _editor$state = editor.state,
      transaction = _editor$state.tr,
      doc = _editor$state.doc;
  doc.descendants(function (node, pos) {
    if (node.type.name === "heading") {
      var _node$content$content;

      var id = stringToAlphaNumericLowerCase(node.textContent);
      var formerId = id;

      if (headings.findIndex(function (h) {
        return h.id === id;
      }) > -1) {
        var count = headings.filter(function (h) {
          return h.formerId === id;
        }).length;
        id += "-".concat(count);
      }

      if (node.attrs.id !== id) {
        transaction === null || transaction === void 0 ? void 0 : transaction.setNodeMarkup(pos, undefined, _objectSpread2(_objectSpread2({}, node.attrs), {}, {
          id: id
        }));
      }

      var convertedText = (_node$content$content = node.content.content) === null || _node$content$content === void 0 ? void 0 : _node$content$content.map(function (nodeContent) {
        return convertNodeToText(nodeContent, editor);
      }).join("");
      headings.push({
        id: id,
        formerId: formerId,
        name: convertedText,
        level: node.attrs.level
      });
    }
  });
  return {
    headings: headings,
    transaction: transaction
  };
};

/* harmony default export */ var utils_generateHeadings = (generateHeadings_generateHeadings);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/TableOfContents.vue?vue&type=script&lang=ts&












var tocClass = "mayday-editor__toc";

var TableOfContentsvue_type_script_lang_ts_TableOfContents = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(TableOfContents, _BaseNodeView);

  var _super = _createSuper(TableOfContents);

  function TableOfContents() {
    var _this;

    _classCallCheck(this, TableOfContents);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "headings", []);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "nativeBehaviour", true);

    return _this;
  }

  _createClass(TableOfContents, [{
    key: "handleUpdate",
    value: function handleUpdate() {
      var _generateHeadings = utils_generateHeadings(this.editor),
          headings = _generateHeadings.headings,
          transaction = _generateHeadings.transaction;

      transaction.setMeta("addToHistory", false);
      transaction.setMeta("preventUpdate", true);
      this.editor.view.dispatch(transaction);
      this.headings = headings;
    }
  }, {
    key: "shouldShowWrapper",
    get: function get() {
      var editor = this.editor,
          selected = this.selected;
      return selected && editor.isEditable;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var isClickable = this.node.attrs.isClickable;
      this.nativeBehaviour = !isClickable;
      this.editor.on("update", this.handleUpdate);
      this.$nextTick(this.handleUpdate);
    }
  }]);

  return TableOfContents;
}(nodes_BaseNodeView);

TableOfContentsvue_type_script_lang_ts_TableOfContents = __decorate([external_vue_property_decorator_["Component"]], TableOfContentsvue_type_script_lang_ts_TableOfContents);
/* harmony default export */ var TableOfContentsvue_type_script_lang_ts_ = (TableOfContentsvue_type_script_lang_ts_TableOfContents);
// CONCATENATED MODULE: ./src/components/nodes/TableOfContents.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_TableOfContentsvue_type_script_lang_ts_ = (TableOfContentsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/TableOfContents.vue?vue&type=style&index=0&lang=scss&
var TableOfContentsvue_type_style_index_0_lang_scss_ = __webpack_require__("0a7e");

// CONCATENATED MODULE: ./src/components/nodes/TableOfContents.vue






/* normalize component */

var TableOfContents_component = normalizeComponent(
  nodes_TableOfContentsvue_type_script_lang_ts_,
  TableOfContentsvue_type_template_id_4508c698_render,
  TableOfContentsvue_type_template_id_4508c698_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var nodes_TableOfContents = (TableOfContents_component.exports);
// CONCATENATED MODULE: ./src/extensions/TableOfContents.ts





var TableOfContents_computeToc = function computeToc(isTocClickable) {
  return tiptap_core_esm_Node.create({
    name: "toc",
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        isClickable: {
          default: !!isTocClickable
        }
      });
    },
    parseHTML: function parseHTML() {
      return [{
        tag: "toc"
      }];
    },
    renderHTML: function renderHTML() {
      return ["toc"];
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_TableOfContents);
    }
  });
};

/* harmony default export */ var extensions_TableOfContents = (TableOfContents_computeToc);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Attachment.vue?vue&type=template&id=04c470ba&scoped=true&
var Attachmentvue_type_template_id_04c470ba_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{class:_vm.containerClass,attrs:{"as":"div","contenteditable":"false"}},[(_vm.isDefaultBlock)?_c('div',{class:(_vm.baseClass + "__wrapper")},[_c('div',{class:_vm.contentClass,on:{"click":function($event){$event.preventDefault();return _vm.handleOnClick.apply(null, arguments)}}},[_c('i',{staticClass:"type-icon",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"attachment-title"},[_vm._v(_vm._s(_vm.attachmentAttributes.title))])]),_c('div',{class:(_vm.baseClass + "__wrapper__footer")},[_c('a',{staticClass:"download-link",attrs:{"href":_vm.attachmentAttributes.href}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', 'arrow-to-bottom']}})],1)])]):_vm._e(),(_vm.isInlineLink)?[_c('i',{class:_vm.inlineTypeIconClass,attrs:{"aria-hidden":"true"}}),_c('a',{attrs:{"href":_vm.attachmentAttributes.href},on:{"click":function($event){$event.preventDefault();return _vm.handleOnClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.attachmentAttributes.title))])]:_vm._e(),(_vm.isEmbed)?[_c('div',{class:_vm.iframeWrapperClass},[_c('Loader',{attrs:{"loading":_vm.progress !== 1,"label":_vm.$t('mayday-editor.attachment.loader')}}),_c('iframe',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.embedIsReady),expression:"embedIsReady"}],ref:"embed",class:(_vm.baseClass + "__embed"),attrs:{"allow":"accelerometer; encrypted-media; gyroscope; picture-in-picture"}},'iframe',_vm.iFrameAttributes,false),[_vm._v(" "+_vm._s(_vm.$t("mayday-editor.attachment.embed.no-support"))),_c('br'),_c('a',{staticClass:"download-link",attrs:{"href":_vm.attachmentAttributes.href}},[_vm._v(_vm._s(_vm.$t("mayday-editor.attachment.embed.download")))])]),_c('a',{class:(_vm.baseClass + "__iframe-enlarge"),attrs:{"href":_vm.iFrameAttributes.src,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'external-link']}}),_c('span',{class:(_vm.baseClass + "__iframe-enlarge-text")},[_vm._v(" "+_vm._s(_vm.$t("mayday-editor.embed.open-in-new-tab"))+" ")])],1)],1)]:_vm._e()],2)}
var Attachmentvue_type_template_id_04c470ba_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/Attachment.vue?vue&type=template&id=04c470ba&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("9129");

// CONCATENATED MODULE: ./src/utils/resolveFileMetadata.ts


var error = new Error("Couldn't fetch file metadata");

var resolveFileMetadata = function resolveFileMetadata(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest(); //  to get only the header, uses HEAD verb

    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState === this.HEADERS_RECEIVED) {
        var contentLengthHeader = xhr.getResponseHeader("Content-Length");
        var contentTypeHeader = xhr.getResponseHeader("Content-Type");

        if (contentLengthHeader != null && contentTypeHeader != null) {
          resolve({
            contentLength: parseInt(contentLengthHeader, 10),
            contentType: contentTypeHeader
          });
        } else {
          reject(error);
        }
      }
    };

    xhr.onerror = function () {
      reject(error);
    };

    xhr.ontimeout = function () {
      reject(error);
    };

    xhr.send();
  });
};

/* harmony default export */ var utils_resolveFileMetadata = (resolveFileMetadata);
// CONCATENATED MODULE: ./src/utils/resolveFileData.ts




var resolveFileData_error = new Error("Couldn't fetch file data");

var resolveFileData = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, updateProgress) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            updateProgress(0);
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.addEventListener("progress", function (event) {
                if (event.lengthComputable) {
                  updateProgress(event.loaded / event.total);
                }
              });
              xhr.addEventListener("load", function () {
                if (xhr.readyState === xhr.DONE) {
                  resolve(xhr.response);
                }
              });
              xhr.addEventListener("error", function () {
                updateProgress(NaN);
                reject(resolveFileData_error);
              });
              xhr.addEventListener("abort", function () {
                updateProgress(NaN);
                reject(resolveFileData_error);
              });
              xhr.send();
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolveFileData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var utils_resolveFileData = (resolveFileData);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__("b680");

// CONCATENATED MODULE: ./src/filters/formatBytes.ts


var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return "0 Bytes";
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

/* harmony default export */ var filters_formatBytes = (formatBytes);
// CONCATENATED MODULE: ./src/filters/formatPercentage.ts


var formatPercentage = function formatPercentage(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (value === 0) return "0%";
  return (value * 100).toFixed(decimals) + "%";
};

/* harmony default export */ var filters_formatPercentage = (formatPercentage);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Loader.vue?vue&type=template&id=34748eb6&
var Loadervue_type_template_id_34748eb6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":_vm.isActive,"is-full-screen":_vm.isFullScreen,"text":_vm.label,"color":_vm.color,"spinner":"bar-fade-scale"}})}
var Loadervue_type_template_id_34748eb6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=template&id=34748eb6&

// EXTERNAL MODULE: ./node_modules/vue-element-loading/lib/vue-element-loading.min.js
var vue_element_loading_min = __webpack_require__("6ad0");
var vue_element_loading_min_default = /*#__PURE__*/__webpack_require__.n(vue_element_loading_min);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Loader.vue?vue&type=script&lang=ts&












var Loadervue_type_script_lang_ts_Loader = /*#__PURE__*/function (_Vue) {
  _inherits(Loader, _Vue);

  var _super = _createSuper(Loader);

  function Loader() {
    var _this;

    _classCallCheck(this, Loader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isActive", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isFullScreen", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "label", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "color", void 0);

    return _this;
  }

  return _createClass(Loader);
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["ModelSync"])("loading", "change"), __metadata("design:type", Boolean)], Loadervue_type_script_lang_ts_Loader.prototype, "isActive", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
}), __metadata("design:type", Boolean)], Loadervue_type_script_lang_ts_Loader.prototype, "isFullScreen", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: ""
}), __metadata("design:type", String)], Loadervue_type_script_lang_ts_Loader.prototype, "label", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: "#0081f9"
}), __metadata("design:type", String)], Loadervue_type_script_lang_ts_Loader.prototype, "color", void 0);

Loadervue_type_script_lang_ts_Loader = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    VueElementLoading: vue_element_loading_min_default.a
  }
})], Loadervue_type_script_lang_ts_Loader);
/* harmony default export */ var Loadervue_type_script_lang_ts_ = (Loadervue_type_script_lang_ts_Loader);
// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Loadervue_type_script_lang_ts_ = (Loadervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/Loader.vue





/* normalize component */

var Loader_component = normalizeComponent(
  components_Loadervue_type_script_lang_ts_,
  Loadervue_type_template_id_34748eb6_render,
  Loadervue_type_template_id_34748eb6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_Loader = (Loader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Attachment.vue?vue&type=script&lang=ts&

















var Attachmentvue_type_script_lang_ts_a;












var attachmentClass = "mayday-editor__attachment";

var Attachmentvue_type_script_lang_ts_Attachment = /*#__PURE__*/function (_EmbedNodeView) {
  _inherits(Attachment, _EmbedNodeView);

  var _super = _createSuper(Attachment);

  function Attachment() {
    var _this;

    _classCallCheck(this, Attachment);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", attachmentClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "resolveFileMetadata", utils_resolveFileMetadata);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "resolveFileData", utils_resolveFileData);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fileSize", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fileMimeType", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "typeNames", types_typeNames);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "progress", 0);

    return _this;
  }

  _createClass(Attachment, [{
    key: "attachmentAttributes",
    get: function get() {
      return this.node.attrs;
    }
  }, {
    key: "iFrameAttributes",
    get: function get() {
      return {
        frameborder: "0",
        allowfullscreen: "true",
        src: this.srcAttribute
      };
    }
  }, {
    key: "isOfficeLive",
    get: function get() {
      var _ref = this.attachmentAttributes || {},
          type = _ref.type;

      if (type == null) {
        return false;
      }

      return [Type.SHEET, Type.DOC, Type.SLIDE].includes(type);
    }
  }, {
    key: "srcAttribute",
    get: function get() {
      var _ref2 = this.attachmentAttributes || {},
          href = _ref2.href;

      if (href == null) {
        return "";
      }

      var prefix = "https://view.officeapps.live.com/op/embed.aspx?src=";
      return this.isOfficeLive ? prefix + href : href;
    }
  }, {
    key: "isDefaultBlock",
    get: function get() {
      return this.attachmentAttributes.mode === Mode.DEFAULT;
    }
  }, {
    key: "isInlineLink",
    get: function get() {
      return this.attachmentAttributes.mode === Mode.INLINE;
    }
  }, {
    key: "isEmbed",
    get: function get() {
      return this.attachmentAttributes.mode === Mode.EMBED;
    }
  }, {
    key: "containerClass",
    get: function get() {
      var _ref3, _ref4;

      var selected = this.selected,
          baseClass = this.baseClass,
          isDefaultBlock = this.isDefaultBlock,
          isInlineLink = this.isInlineLink,
          isEmbed = this.isEmbed,
          editor = this.editor;
      var showSelectedWrapper = selected && editor.isEditable;
      return isEmbed ? (_ref3 = {}, Object(defineProperty["a" /* default */])(_ref3, "".concat(baseClass, "--embed"), isEmbed), Object(defineProperty["a" /* default */])(_ref3, "".concat(baseClass, "--embed--selected"), showSelectedWrapper), _ref3) : (_ref4 = {}, Object(defineProperty["a" /* default */])(_ref4, baseClass, true), Object(defineProperty["a" /* default */])(_ref4, "".concat(baseClass, "--selected"), showSelectedWrapper), Object(defineProperty["a" /* default */])(_ref4, "".concat(baseClass, "--default"), isDefaultBlock), Object(defineProperty["a" /* default */])(_ref4, "".concat(baseClass, "--inline"), isInlineLink), Object(defineProperty["a" /* default */])(_ref4, "".concat(baseClass, "--embed"), isEmbed), _ref4);
    }
  }, {
    key: "iframeWrapperClass",
    get: function get() {
      var _ref5;

      var selected = this.selected,
          baseClass = this.baseClass,
          editor = this.editor;
      var showSelectedWrapper = selected && editor.isEditable;
      return _ref5 = {}, Object(defineProperty["a" /* default */])(_ref5, "".concat(baseClass, "__iframe-wrapper"), true), Object(defineProperty["a" /* default */])(_ref5, "".concat(baseClass, "__iframe-wrapper--selected"), showSelectedWrapper), _ref5;
    }
  }, {
    key: "contentClass",
    get: function get() {
      var _classes;

      var baseClass = this.baseClass,
          typeNames = this.typeNames;
      var type = this.attachmentAttributes.type;
      var base = "".concat(baseClass, "__wrapper__content");
      var classes = (_classes = {}, Object(defineProperty["a" /* default */])(_classes, base, true), Object(defineProperty["a" /* default */])(_classes, "is-read-only", !this.editor.isEditable), _classes);

      if (type != null) {
        Object.assign(classes, Object(defineProperty["a" /* default */])({}, "".concat(base, "--").concat(typeNames[type]), true));
      }

      return classes;
    }
  }, {
    key: "inlineTypeIconClass",
    get: function get() {
      var baseClass = this.baseClass,
          typeNames = this.typeNames;
      var type = this.attachmentAttributes.type;
      var base = "".concat(baseClass, "__inline-type-icon");

      var classes = Object(defineProperty["a" /* default */])({}, base, true);

      if (type != null) {
        Object.assign(classes, Object(defineProperty["a" /* default */])({}, "".concat(base, "--").concat(typeNames[type]), true));
      }

      return classes;
    }
  }, {
    key: "inlineTypeIconTestAttribute",
    get: function get() {
      var typeNames = this.typeNames;
      var type = this.attachmentAttributes.type;

      if (type == null) {
        return "";
      }

      return "link-".concat(typeNames[type]);
    }
  }, {
    key: "fileSizeIsLoading",
    get: function get() {
      return this.fileSize === 0;
    }
  }, {
    key: "fileSizeIsUnknown",
    get: function get() {
      return Number.isNaN(this.fileSize);
    }
  }, {
    key: "embedIsReady",
    get: function get() {
      var progress = this.progress;
      return progress === 1;
    }
  }, {
    key: "handleEmbedToggled",
    value: function () {
      var _handleEmbedToggled = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isEmbed) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isEmbed) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.$nextTick(function () {
                  _this2.iframeLoadingHandler();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleEmbedToggled(_x) {
        return _handleEmbedToggled.apply(this, arguments);
      }

      return handleEmbedToggled;
    }()
  }, {
    key: "handleOnClick",
    value: function handleOnClick() {
      if (!this.editor.isEditable) {
        this.$parent.$emit("click:attached-file", {
          href: this.attachmentAttributes.href,
          mode: this.attachmentAttributes.mode
        });
      }
    }
  }, {
    key: "iframeLoadingHandler",
    value: function iframeLoadingHandler() {
      var _this3 = this;

      var iframe = this.$refs["embed"];
      this.progress = 0;

      var handleLoad = function handleLoad() {
        _this3.progress = 1;
      };

      iframe === null || iframe === void 0 ? void 0 : iframe.addEventListener("load", handleLoad, true);
    }
  }, {
    key: "created",
    value: function () {
      var _created = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$this$resolveFi, contentLength, contentType;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.resolveFileMetadata(this.attachmentAttributes.href);

              case 3:
                _yield$this$resolveFi = _context2.sent;
                contentLength = _yield$this$resolveFi.contentLength;
                contentType = _yield$this$resolveFi.contentType;
                this.fileSize = contentLength;
                this.fileMimeType = contentType != null && !!contentType.length ? contentType : null;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                this.fileSize = NaN;
                this.fileMimeType = null;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      this.iframeLoadingHandler();
    }
  }]);

  return Attachment;
}(nodes_EmbedNodeView);

__decorate([Object(external_vue_property_decorator_["Watch"])("isEmbed", {
  immediate: true
}), __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", typeof (Attachmentvue_type_script_lang_ts_a = typeof Promise !== "undefined" && Promise) === "function" ? Attachmentvue_type_script_lang_ts_a : Object)], Attachmentvue_type_script_lang_ts_Attachment.prototype, "handleEmbedToggled", null);

Attachmentvue_type_script_lang_ts_Attachment = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    Loader: components_Loader
  },
  filters: {
    bytes: filters_formatBytes,
    percentage: filters_formatPercentage
  }
})], Attachmentvue_type_script_lang_ts_Attachment);
/* harmony default export */ var Attachmentvue_type_script_lang_ts_ = (Attachmentvue_type_script_lang_ts_Attachment);
// CONCATENATED MODULE: ./src/components/nodes/Attachment.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_Attachmentvue_type_script_lang_ts_ = (Attachmentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/Attachment.vue?vue&type=style&index=0&id=04c470ba&lang=scss&scoped=true&
var Attachmentvue_type_style_index_0_id_04c470ba_lang_scss_scoped_true_ = __webpack_require__("37bf");

// CONCATENATED MODULE: ./src/components/nodes/Attachment.vue






/* normalize component */

var Attachment_component = normalizeComponent(
  nodes_Attachmentvue_type_script_lang_ts_,
  Attachmentvue_type_template_id_04c470ba_scoped_true_render,
  Attachmentvue_type_template_id_04c470ba_scoped_true_staticRenderFns,
  false,
  null,
  "04c470ba",
  null
  
)

/* harmony default export */ var nodes_Attachment = (Attachment_component.exports);
// CONCATENATED MODULE: ./src/extensions/Attachment/commands.ts







var computeSetAttachment = function computeSetAttachment(type) {
  return function (attributes) {
    return function (_ref) {
      var dispatch = _ref.dispatch,
          tr = _ref.tr;
      var selection = tr.selection;
      var title = attributes.title != null && !!attributes.title.length ? attributes.title : attributes.name;
      var node = type.create(Object.assign(attributes, {
        title: title
      }));

      if (dispatch != null) {
        tr.replaceRangeWith(selection.from, selection.to, node);
        return true;
      }

      return false;
    };
  };
};
var commands_computeSetAttachmentAsInlineLink = function computeSetAttachmentAsInlineLink(name) {
  return function () {
    return function (_ref2) {
      var commands = _ref2.commands;
      return commands.updateAttributes(name, {
        mode: Mode.INLINE
      });
    };
  };
};
var commands_computeSetAttachmentAsDefault = function computeSetAttachmentAsDefault(name) {
  return function () {
    return function (_ref3) {
      var commands = _ref3.commands;
      return commands.updateAttributes(name, {
        mode: Mode.DEFAULT
      });
    };
  };
};
var commands_computeSetAttachmentAsEmbed = function computeSetAttachmentAsEmbed(name) {
  return function () {
    return function (_ref4) {
      var commands = _ref4.commands,
          editor = _ref4.editor;
      var type = editor.getAttributes(name).type;

      if (![Type.PDF, Type.VIDEO, Type.SHEET, Type.DOC, Type.SLIDE].includes(type)) {
        return false;
      }

      return commands.updateAttributes(name, {
        mode: Mode.EMBED
      });
    };
  };
};
var computeHighlightAttachment = function computeHighlightAttachment(key) {
  return function (shouldHighlight) {
    return function (_ref5) {
      var dispatch = _ref5.dispatch,
          tr = _ref5.tr;

      if (dispatch) {
        dispatch(tr.setMeta(key, {
          isHighlighted: shouldHighlight
        }));
        return true;
      }

      return false;
    };
  };
};
var commands_computeDeleteAttachment = function computeDeleteAttachment(type) {
  return function () {
    return function (_ref6) {
      var dispatch = _ref6.dispatch,
          tr = _ref6.tr;
      var selection = tr.selection;

      if (dispatch == null || !isNodeSelection(selection) || selection.node.type !== type) {
        return false;
      }

      dispatch(tr.deleteSelection());
      return true;
    };
  };
};
// CONCATENATED MODULE: ./src/extensions/Attachment/Attachment.ts











var Mode;

(function (Mode) {
  Mode[Mode["DEFAULT"] = 1] = "DEFAULT";
  Mode[Mode["INLINE"] = 2] = "INLINE";
  Mode[Mode["EMBED"] = 3] = "EMBED";
})(Mode || (Mode = {}));

var Attachment_key = new PluginKey("attachmentHighlighter");

var Attachment_computeAttachment = function computeAttachment(isFileUploadCallbackProvided, storeAction) {
  return tiptap_core_esm_Node.create({
    name: "attachment",
    // block(s) should be wrapped with a paragraph
    inline: true,
    group: "inline",
    selectable: true,
    draggable: true,
    atom: true,
    // disallows all marks
    marks: "",
    addAttributes: function addAttributes() {
      return {
        name: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-name");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-name": attrs.name
            };
          }
        },
        title: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-title");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-title": attrs.title
            };
          }
        },
        href: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-href");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-href": attrs.href
            };
          }
        },
        type: {
          default: null,
          parseHTML: function parseHTML(element) {
            var attribute = element.getAttribute("data-type");
            return attribute != null ? parseInt(attribute, 10) : null;
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-type": attrs.type
            };
          }
        },
        mode: {
          default: Mode.INLINE,
          parseHTML: function parseHTML(element) {
            var attribute = element.getAttribute("data-mode");
            return attribute != null ? parseInt(attribute, 10) : null;
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-mode": attrs.mode
            };
          }
        }
      };
    },
    parseHTML: function parseHTML() {
      var _this = this;

      return [{
        tag: "div",
        getAttrs: function getAttrs(node) {
          var element = node;

          var hasNodeType = element.hasAttribute("data-node-type") && element.getAttribute("data-node-type") === _this.name;

          if (!hasNodeType) {
            return false;
          }

          return null;
        }
      }, {
        tag: "span",
        getAttrs: function getAttrs(node) {
          var element = node;

          var hasNodeType = element.hasAttribute("data-node-type") && element.getAttribute("data-node-type") === _this.name;

          if (!hasNodeType) {
            return false;
          }

          return null;
        }
      }, // old editor input
      {
        tag: "span",
        getAttrs: function getAttrs(node) {
          var element = node;
          var isAttachment = element.classList.contains("inline-attachment");
          var srcAttribute = element.getAttribute("src");
          var typeAttribute = element.getAttribute("file-type");
          var label = element.getAttribute("label");

          if (!isAttachment || srcAttribute == null || typeAttribute == null) {
            return false;
          }

          var parts = srcAttribute.split("/");
          var name = parts[parts.length - 1];
          return {
            mode: Mode.INLINE,
            href: srcAttribute,
            type: computeAttachmentType(typeAttribute),
            name: name,
            title: label
          };
        }
      }];
    },
    renderHTML: function renderHTML(_ref) {
      var HTMLAttributes = _ref.HTMLAttributes;
      return ["span", mergeAttributes(HTMLAttributes, {
        "data-node-type": this.name
      })];
    },
    renderText: function renderText(_ref2) {
      var node = _ref2.node;
      return "attachment@".concat(node.attrs.href);
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_Attachment);
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var name = this.name;
      var type = this.type;

      var handler = function handler(view, event) {
        return dropAndPasteHandler(view, event, isFileUploadCallbackProvided, name, storeAction);
      };

      return [// handle drop and paste events
      new Plugin({
        key: new PluginKey(name),
        props: {
          handleDOMEvents: {
            drop: handler,
            paste: handler
          }
        }
      }), // highlighter plugin
      new Plugin({
        key: Attachment_key,
        state: {
          init: function init() {
            return {
              isHighlighted: false
            };
          },
          apply: function apply(tr, prev) {
            return Object.assign({}, prev, tr.getMeta(Attachment_key));
          }
        },
        props: {
          decorations: function decorations(state) {
            var selection = state.selection;

            var _this$getState = this.getState(state),
                isHighlighted = _this$getState.isHighlighted;

            var nodeInSelection = isNodeSelection(selection) ? selection.node : null;
            var isAttachment = nodeInSelection != null && nodeInSelection.type === type;

            if (isAttachment && isHighlighted) {
              return DecorationSet.create(state.doc, [Decoration.node(selection.from, selection.to, {
                class: "highlight"
              })]);
            }

            return DecorationSet.empty;
          }
        }
      })];
    },
    addCommands: function addCommands() {
      var type = this.type,
          name = this.name;
      return {
        setAttachment: computeSetAttachment(type),
        setAttachmentAsInlineLink: commands_computeSetAttachmentAsInlineLink(name),
        setAttachmentAsDefault: commands_computeSetAttachmentAsDefault(name),
        setAttachmentAsEmbed: commands_computeSetAttachmentAsEmbed(name),
        highlightAttachment: computeHighlightAttachment(Attachment_key),
        deleteAttachment: commands_computeDeleteAttachment(type)
      };
    }
  });
};

/* harmony default export */ var Attachment_Attachment = (Attachment_computeAttachment);
// CONCATENATED MODULE: ./node_modules/prosemirror-gapcursor/dist/index.es.js





// ::- Gap cursor selections are represented using this class. Its
// `$anchor` and `$head` properties both point at the cursor position.
var index_es_GapCursor = /*@__PURE__*/(function (Selection) {
  function GapCursor($pos) {
    Selection.call(this, $pos, $pos);
  }

  if ( Selection ) GapCursor.__proto__ = Selection;
  GapCursor.prototype = Object.create( Selection && Selection.prototype );
  GapCursor.prototype.constructor = GapCursor;

  GapCursor.prototype.map = function map (doc, mapping) {
    var $pos = doc.resolve(mapping.map(this.head));
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos)
  };

  GapCursor.prototype.content = function content () { return Slice.empty };

  GapCursor.prototype.eq = function eq (other) {
    return other instanceof GapCursor && other.head == this.head
  };

  GapCursor.prototype.toJSON = function toJSON () {
    return {type: "gapcursor", pos: this.head}
  };

  GapCursor.fromJSON = function fromJSON (doc, json) {
    if (typeof json.pos != "number") { throw new RangeError("Invalid input for GapCursor.fromJSON") }
    return new GapCursor(doc.resolve(json.pos))
  };

  GapCursor.prototype.getBookmark = function getBookmark () { return new GapBookmark(this.anchor) };

  GapCursor.valid = function valid ($pos) {
    var parent = $pos.parent;
    if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos)) { return false }
    var override = parent.type.spec.allowGapCursor;
    if (override != null) { return override }
    var deflt = parent.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock
  };

  GapCursor.findFrom = function findFrom ($pos, dir, mustMove) {
    search: for (;;) {
      if (!mustMove && GapCursor.valid($pos)) { return $pos }
      var pos = $pos.pos, next = null;
      // Scan up from this position
      for (var d = $pos.depth;; d--) {
        var parent = $pos.node(d);
        if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
          next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
          break
        } else if (d == 0) {
          return null
        }
        pos += dir;
        var $cur = $pos.doc.resolve(pos);
        if (GapCursor.valid($cur)) { return $cur }
      }

      // And then down into the next node
      for (;;) {
        var inside = dir > 0 ? next.firstChild : next.lastChild;
        if (!inside) {
          if (next.isAtom && !next.isText && !index_es_NodeSelection.isSelectable(next)) {
            $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
            mustMove = false;
            continue search
          }
          break
        }
        next = inside;
        pos += dir;
        var $cur$1 = $pos.doc.resolve(pos);
        if (GapCursor.valid($cur$1)) { return $cur$1 }
      }

      return null
    }
  };

  return GapCursor;
}(index_es_Selection));

index_es_GapCursor.prototype.visible = false;

index_es_Selection.jsonID("gapcursor", index_es_GapCursor);

var GapBookmark = function GapBookmark(pos) {
  this.pos = pos;
};
GapBookmark.prototype.map = function map (mapping) {
  return new GapBookmark(mapping.map(this.pos))
};
GapBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.pos);
  return index_es_GapCursor.valid($pos) ? new index_es_GapCursor($pos) : index_es_Selection.near($pos)
};

function closedBefore($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.index(d), parent = $pos.node(d);
    // At the start of this parent, look at next one
    if (index == 0) {
      if (parent.type.spec.isolating) { return true }
      continue
    }
    // See if the node before (or its first ancestor) is closed
    for (var before = parent.child(index - 1);; before = before.lastChild) {
      if ((before.childCount == 0 && !before.inlineContent) || before.isAtom || before.type.spec.isolating) { return true }
      if (before.inlineContent) { return false }
    }
  }
  // Hit start of document
  return true
}

function closedAfter($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.indexAfter(d), parent = $pos.node(d);
    if (index == parent.childCount) {
      if (parent.type.spec.isolating) { return true }
      continue
    }
    for (var after = parent.child(index);; after = after.firstChild) {
      if ((after.childCount == 0 && !after.inlineContent) || after.isAtom || after.type.spec.isolating) { return true }
      if (after.inlineContent) { return false }
    }
  }
  return true
}

// :: () → Plugin
// Create a gap cursor plugin. When enabled, this will capture clicks
// near and arrow-key-motion past places that don't have a normally
// selectable position nearby, and create a gap cursor selection for
// them. The cursor is drawn as an element with class
// `ProseMirror-gapcursor`. You can either include
// `style/gapcursor.css` from the package's directory or add your own
// styles to make it visible.
var gapCursor = function() {
  return new Plugin({
    props: {
      decorations: drawGapCursor,

      createSelectionBetween: function createSelectionBetween(_view, $anchor, $head) {
        if ($anchor.pos == $head.pos && index_es_GapCursor.valid($head)) { return new index_es_GapCursor($head) }
      },

      handleClick: handleClick,
      handleKeyDown: handleKeyDown,
      handleDOMEvents: {beforeinput: beforeinput}
    }
  })
};

var handleKeyDown = keydownHandler({
  "ArrowLeft": index_es_arrow("horiz", -1),
  "ArrowRight": index_es_arrow("horiz", 1),
  "ArrowUp": index_es_arrow("vert", -1),
  "ArrowDown": index_es_arrow("vert", 1)
});

function index_es_arrow(axis, dir) {
  var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
  return function(state, dispatch, view) {
    var sel = state.selection;
    var $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof index_es_TextSelection) {
      if (!view.endOfTextblock(dirStr) || $start.depth == 0) { return false }
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    var $found = index_es_GapCursor.findFrom($start, dir, mustMove);
    if (!$found) { return false }
    if (dispatch) { dispatch(state.tr.setSelection(new index_es_GapCursor($found))); }
    return true
  }
}

function handleClick(view, pos, event) {
  if (!view.editable) { return false }
  var $pos = view.state.doc.resolve(pos);
  if (!index_es_GapCursor.valid($pos)) { return false }
  var ref = view.posAtCoords({left: event.clientX, top: event.clientY});
  var inside = ref.inside;
  if (inside > -1 && index_es_NodeSelection.isSelectable(view.state.doc.nodeAt(inside))) { return false }
  view.dispatch(view.state.tr.setSelection(new index_es_GapCursor($pos)));
  return true
}

// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function beforeinput(view, event) {
  if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof index_es_GapCursor)) { return false }

  var ref = view.state.selection;
  var $from = ref.$from;
  var insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
  if (!insert) { return false }

  var frag = Fragment.empty;
  for (var i = insert.length - 1; i >= 0; i--) { frag = Fragment.from(insert[i].createAndFill(null, frag)); }
  var tr = view.state.tr.replace($from.pos, $from.pos, new Slice(frag, 0, 0));
  tr.setSelection(index_es_TextSelection.near(tr.doc.resolve($from.pos + 1)));
  view.dispatch(tr);
  return false
}

function drawGapCursor(state) {
  if (!(state.selection instanceof index_es_GapCursor)) { return null }
  var node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node, {key: "gapcursor"})])
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-gapcursor/dist/tiptap-extension-gapcursor.esm.js



const Gapcursor = Extension.create({
    name: 'gapCursor',
    addProseMirrorPlugins() {
        return [
            gapCursor(),
        ];
    },
    extendNodeSchema(extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        return {
            allowGapCursor: (_a = callOrReturn(getExtensionField(extension, 'allowGapCursor', context))) !== null && _a !== void 0 ? _a : null,
        };
    },
});


//# sourceMappingURL=tiptap-extension-gapcursor.esm.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-dropcursor/dist/index.es.js



// :: (options: ?Object) → Plugin
// Create a plugin that, when added to a ProseMirror instance,
// causes a decoration to show up at the drop position when something
// is dragged over the editor.
//
// Nodes may add a `disableDropCursor` property to their spec to
// control the showing of a drop cursor inside them. This may be a
// boolean or a function, which will be called with a view and a
// position, and should return a boolean.
//
//   options::- These options are supported:
//
//     color:: ?string
//     The color of the cursor. Defaults to `black`.
//
//     width:: ?number
//     The precise width of the cursor in pixels. Defaults to 1.
//
//     class:: ?string
//     A CSS class name to add to the cursor element.
function dropCursor(options) {
  if ( options === void 0 ) options = {};

  return new Plugin({
    view: function view(editorView) { return new DropCursorView(editorView, options) }
  })
}

var DropCursorView = function DropCursorView(editorView, options) {
  var this$1 = this;

  this.editorView = editorView;
  this.width = options.width || 1;
  this.color = options.color || "black";
  this.class = options.class;
  this.cursorPos = null;
  this.element = null;
  this.timeout = null;

  this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(function (name) {
    var handler = function (e) { return this$1[name](e); };
    editorView.dom.addEventListener(name, handler);
    return {name: name, handler: handler}
  });
};

DropCursorView.prototype.destroy = function destroy () {
    var this$1 = this;

  this.handlers.forEach(function (ref) {
      var name = ref.name;
      var handler = ref.handler;

      return this$1.editorView.dom.removeEventListener(name, handler);
    });
};

DropCursorView.prototype.update = function update (editorView, prevState) {
  if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
    if (this.cursorPos > editorView.state.doc.content.size) { this.setCursor(null); }
    else { this.updateOverlay(); }
  }
};

DropCursorView.prototype.setCursor = function setCursor (pos) {
  if (pos == this.cursorPos) { return }
  this.cursorPos = pos;
  if (pos == null) {
    this.element.parentNode.removeChild(this.element);
    this.element = null;
  } else {
    this.updateOverlay();
  }
};

DropCursorView.prototype.updateOverlay = function updateOverlay () {
  var $pos = this.editorView.state.doc.resolve(this.cursorPos), rect;
  if (!$pos.parent.inlineContent) {
    var before = $pos.nodeBefore, after = $pos.nodeAfter;
    if (before || after) {
      var nodeRect = this.editorView.nodeDOM(this.cursorPos - (before ?before.nodeSize : 0)).getBoundingClientRect();
      var top = before ? nodeRect.bottom : nodeRect.top;
      if (before && after)
        { top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2; }
      rect = {left: nodeRect.left, right: nodeRect.right, top: top - this.width / 2, bottom: top + this.width / 2};
    }
  }
  if (!rect) {
    var coords = this.editorView.coordsAtPos(this.cursorPos);
    rect = {left: coords.left - this.width / 2, right: coords.left + this.width / 2, top: coords.top, bottom: coords.bottom};
  }

  var parent = this.editorView.dom.offsetParent;
  if (!this.element) {
    this.element = parent.appendChild(document.createElement("div"));
    if (this.class) { this.element.className = this.class; }
    this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none; background-color: " + this.color;
  }
  var parentLeft, parentTop;
  if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
    parentLeft = -pageXOffset;
    parentTop = -pageYOffset;
  } else {
    var rect$1 = parent.getBoundingClientRect();
    parentLeft = rect$1.left - parent.scrollLeft;
    parentTop = rect$1.top - parent.scrollTop;
  }
  this.element.style.left = (rect.left - parentLeft) + "px";
  this.element.style.top = (rect.top - parentTop) + "px";
  this.element.style.width = (rect.right - rect.left) + "px";
  this.element.style.height = (rect.bottom - rect.top) + "px";
};

DropCursorView.prototype.scheduleRemoval = function scheduleRemoval (timeout) {
    var this$1 = this;

  clearTimeout(this.timeout);
  this.timeout = setTimeout(function () { return this$1.setCursor(null); }, timeout);
};

DropCursorView.prototype.dragover = function dragover (event) {
  if (!this.editorView.editable) { return }
  var pos = this.editorView.posAtCoords({left: event.clientX, top: event.clientY});

  var node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
  var disableDropCursor = node && node.type.spec.disableDropCursor;
  var disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos) : disableDropCursor;

  if (pos && !disabled) {
    var target = pos.pos;
    if (this.editorView.dragging && this.editorView.dragging.slice) {
      target = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
      if (target == null) { return this.setCursor(null) }
    }
    this.setCursor(target);
    this.scheduleRemoval(5000);
  }
};

DropCursorView.prototype.dragend = function dragend () {
  this.scheduleRemoval(20);
};

DropCursorView.prototype.drop = function drop () {
  this.scheduleRemoval(20);
};

DropCursorView.prototype.dragleave = function dragleave (event) {
  if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget))
    { this.setCursor(null); }
};


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-dropcursor/dist/tiptap-extension-dropcursor.esm.js



const Dropcursor = Extension.create({
    name: 'dropCursor',
    addOptions() {
        return {
            color: 'currentColor',
            width: 1,
            class: null,
        };
    },
    addProseMirrorPlugins() {
        return [
            dropCursor(this.options),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-dropcursor.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-hard-break/dist/tiptap-extension-hard-break.esm.js


const HardBreak = tiptap_core_esm_Node.create({
    name: 'hardBreak',
    addOptions() {
        return {
            keepMarks: true,
            HTMLAttributes: {},
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    parseHTML() {
        return [
            { tag: 'br' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['br', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    renderText() {
        return '\n';
    },
    addCommands() {
        return {
            setHardBreak: () => ({ commands, chain, state, editor, }) => {
                return commands.first([
                    () => commands.exitCode(),
                    () => commands.command(() => {
                        const { selection, storedMarks } = state;
                        if (selection.$from.parent.type.spec.isolating) {
                            return false;
                        }
                        const { keepMarks } = this.options;
                        const { splittableMarks } = editor.extensionManager;
                        const marks = storedMarks
                            || (selection.$to.parentOffset && selection.$from.marks());
                        return chain()
                            .insertContent({ type: this.name })
                            .command(({ tr, dispatch }) => {
                            if (dispatch && marks && keepMarks) {
                                const filteredMarks = marks
                                    .filter(mark => splittableMarks.includes(mark.type.name));
                                tr.ensureMarks(filteredMarks);
                            }
                            return true;
                        })
                            .run();
                    }),
                ]);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Enter': () => this.editor.commands.setHardBreak(),
            'Shift-Enter': () => this.editor.commands.setHardBreak(),
        };
    },
});


//# sourceMappingURL=tiptap-extension-hard-break.esm.js.map

// CONCATENATED MODULE: ./node_modules/rope-sequence/dist/index.es.js
var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

var ropeSequence = RopeSequence;

/* harmony default export */ var dist_index_es = (ropeSequence);

// CONCATENATED MODULE: ./node_modules/prosemirror-history/dist/index.es.js




// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)

// Used to schedule history compression
var max_empty_items = 500;

var Branch = function Branch(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};

// : (EditorState, bool) → ?{transform: Transform, selection: ?SelectionBookmark, remaining: Branch}
// Pop the latest event off the branch's history and apply it
// to a document transform.
Branch.prototype.popEvent = function popEvent (state, preserveItems) {
    var this$1 = this;

  if (this.eventCount == 0) { return null }

  var end = this.items.length;
  for (;; end--) {
    var next = this.items.get(end - 1);
    if (next.selection) { --end; break }
  }

  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];

  this.items.forEach(function (item, i) {
    if (!item.step) {
      if (!remap) {
        remap = this$1.remapping(end, i + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return
    }

    if (remap) {
      addBefore.push(new Item(item.map));
      var step = item.step.map(remap.slice(mapFrom)), map;

      if (step && transform.maybeStep(step).doc) {
        map = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
    } else {
      transform.maybeStep(item.step);
    }

    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
      return false
    }
  }, this.items.length, 0);

  return {remaining: remaining, transform: transform, selection: selection}
};

// : (Transform, ?SelectionBookmark, Object) → Branch
// Create a new branch with the given transform added.
Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;

  for (var i = 0; i < transform.steps.length; i++) {
    var step = transform.steps[i].invert(transform.docs[i]);
    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i) { newItems.pop(); }
      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) { lastItem = item; }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount)
};

Branch.prototype.remapping = function remapping (from, to) {
  var maps = new Mapping;
  this.items.forEach(function (item, i) {
    var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
        ? maps.maps.length - item.mirrorOffset : null;
    maps.appendMap(item.map, mirrorPos);
  }, from, to);
  return maps
};

Branch.prototype.addMaps = function addMaps (array) {
  if (this.eventCount == 0) { return this }
  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
};

// : (Transform, number)
// When the collab module receives remote changes, the history has
// to know about those, so that it can adjust the steps that were
// rebased on top of the remote changes, and include the position
// maps for the remote changes in its array of items.
Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
  if (!this.eventCount) { return this }

  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);

  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, start);

  var iRebased = rebasedCount;
  this.items.forEach(function (item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) { return }
    newUntil = Math.min(newUntil, pos);
    var map = mapping.maps[pos];
    if (item.step) {
      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
      if (selection) { eventCount++; }
      rebasedItems.push(new Item(map, step, selection));
    } else {
      rebasedItems.push(new Item(map));
    }
  }, start);

  var newMaps = [];
  for (var i = rebasedCount; i < newUntil; i++)
    { newMaps.push(new Item(mapping.maps[i])); }
  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);

  if (branch.emptyItemCount() > max_empty_items)
    { branch = branch.compress(this.items.length - rebasedItems.length); }
  return branch
};

Branch.prototype.emptyItemCount = function emptyItemCount () {
  var count = 0;
  this.items.forEach(function (item) { if (!item.step) { count++; } });
  return count
};

// Compressing a branch means rewriting it to push the air (map-only
// items) out. During collaboration, these naturally accumulate
// because each remote change adds one. The `upto` argument is used
// to ensure that only the items below a given level are compressed,
// because `rebased` relies on a clean, untouched set of items in
// order to associate old items with rebased steps.
Branch.prototype.compress = function compress (upto) {
    if ( upto === void 0 ) upto = this.items.length;

  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events = 0;
  this.items.forEach(function (item, i) {
    if (i >= upto) {
      items.push(item);
      if (item.selection) { events++; }
    } else if (item.step) {
      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
      if (step) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) { events++; }
        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem))
          { items[last] = merged; }
        else
          { items.push(newItem); }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(dist_index_es.from(items.reverse()), events)
};

Branch.empty = new Branch(dist_index_es.empty, 0);

function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && (n-- == 0)) {
      cutPoint = i;
      return false
    }
  });
  return items.slice(cutPoint)
}

var Item = function Item(map, step, selection, mirrorOffset) {
  // The (forward) step map for this item.
  this.map = map;
  // The inverted step
  this.step = step;
  // If this is non-null, this item is the start of a group, and
  // this selection is the starting selection for the group (the one
  // that was active before the first step was applied)
  this.selection = selection;
  // If this item is the inverse of a previous mapping on the stack,
  // this points at the inverse's offset
  this.mirrorOffset = mirrorOffset;
};

Item.prototype.merge = function merge (other) {
  if (this.step && other.step && !other.selection) {
    var step = other.step.merge(this.step);
    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
  }
};

// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
var HistoryState = function HistoryState(done, undone, prevRanges, prevTime) {
  this.done = done;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
};

var DEPTH_OVERFLOW = 20;

// : (HistoryState, EditorState, Transaction, Object)
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
  var historyTr = tr.getMeta(historyKey), rebased;
  if (historyTr) { return historyTr.historyState }

  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }

  var appended = tr.getMeta("appendedTransaction");

  if (tr.steps.length == 0) {
    return history
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      { return new HistoryState(history.done.addTransform(tr, null, options, mustPreserveItems(state)),
                              history.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime) }
    else
      { return new HistoryState(history.done, history.undone.addTransform(tr, null, options, mustPreserveItems(state)),
                              null, history.prevTime) }
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    // Group transforms that occur in quick succession into one event.
    var newGroup = history.prevTime == 0 || !appended && (history.prevTime < (tr.time || 0) - options.newGroupDelay ||
                                                          !isAdjacentTo(tr, history.prevRanges));
    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
                                                      options, mustPreserveItems(state)),
                            Branch.empty, prevRanges, tr.time)
  } else if (rebased = tr.getMeta("rebased")) {
    // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new HistoryState(history.done.rebased(tr, rebased),
                            history.undone.rebased(tr, rebased),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps),
                            history.undone.addMaps(tr.mapping.maps),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  }
}

function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) { return false }
  if (!transform.docChanged) { return true }
  var adjacent = false;
  transform.mapping.maps[0].forEach(function (start, end) {
    for (var i = 0; i < prevRanges.length; i += 2)
      { if (start <= prevRanges[i + 1] && end >= prevRanges[i])
        { adjacent = true; } }
  });
  return adjacent
}

function rangesFor(map) {
  var result = [];
  map.forEach(function (_from, _to, from, to) { return result.push(from, to); });
  return result
}

function mapRanges(ranges, mapping) {
  if (!ranges) { return null }
  var result = [];
  for (var i = 0; i < ranges.length; i += 2) {
    var from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
    if (from <= to) { result.push(from, to); }
  }
  return result
}

// : (HistoryState, EditorState, (tr: Transaction), bool)
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, dispatch, redo) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) { return }

  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
                                                                  histOptions, preserveItems);

  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, {redo: redo, historyState: newHist}).scrollIntoView());
}

var cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break
    } }
  }
  return cachedPreserveItems
}

// :: (Transaction) → Transaction
// Set a flag on the given transaction that will prevent further steps
// from being appended to an existing history event (so that they
// require a separate undo command to undo).
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true)
}

var historyKey = new PluginKey("history");
var closeHistoryKey = new PluginKey("closeHistory");

// :: (?Object) → Plugin
// Returns a plugin that enables the undo history for an editor. The
// plugin will track undo and redo stacks, which can be used with the
// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
//
// You can set an `"addToHistory"` [metadata
// property](#state.Transaction.setMeta) of `false` on a transaction
// to prevent it from being rolled back by undo.
//
//   config::-
//   Supports the following configuration options:
//
//     depth:: ?number
//     The amount of history events that are collected before the
//     oldest events are discarded. Defaults to 100.
//
//     newGroupDelay:: ?number
//     The delay between changes after which a new group should be
//     started. Defaults to 500 (milliseconds). Note that when changes
//     aren't adjacent, a new group is always started.
function index_es_history(config) {
  config = {depth: config && config.depth || 100,
            newGroupDelay: config && config.newGroupDelay || 500};
  return new Plugin({
    key: historyKey,

    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0)
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config)
      }
    },

    config: config,

    props: {
      handleDOMEvents: {
        beforeinput: function beforeinput(view, e) {
          var handled = e.inputType == "historyUndo" ? undo(view.state, view.dispatch) :
              e.inputType == "historyRedo" ? redo(view.state, view.dispatch) : false;
          if (handled) { e.preventDefault(); }
          return handled
        }
      }
    }
  })
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that undoes the last change, if any.
function undo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, false); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that redoes the last undone change, if any.
function redo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, true); }
  return true
}

// :: (EditorState) → number
// The amount of undoable events available in a given state.
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0
}

// :: (EditorState) → number
// The amount of redoable events available in a given editor state.
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-history/dist/tiptap-extension-history.esm.js



const History = Extension.create({
    name: 'history',
    addOptions() {
        return {
            depth: 100,
            newGroupDelay: 500,
        };
    },
    addCommands() {
        return {
            undo: () => ({ state, dispatch }) => {
                return undo(state, dispatch);
            },
            redo: () => ({ state, dispatch }) => {
                return redo(state, dispatch);
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            index_es_history(this.options),
        ];
    },
    addKeyboardShortcuts() {
        return {
            'Mod-z': () => this.editor.commands.undo(),
            'Mod-y': () => this.editor.commands.redo(),
            'Shift-Mod-z': () => this.editor.commands.redo(),
            // Russian keyboard layouts
            'Mod-я': () => this.editor.commands.undo(),
            'Shift-Mod-я': () => this.editor.commands.redo(),
        };
    },
});


//# sourceMappingURL=tiptap-extension-history.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-blockquote/dist/tiptap-extension-blockquote.esm.js


const tiptap_extension_blockquote_esm_inputRegex = /^\s*>\s$/;
const Blockquote = tiptap_core_esm_Node.create({
    name: 'blockquote',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseHTML() {
        return [
            { tag: 'blockquote' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['blockquote', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBlockquote: () => ({ commands }) => {
                return commands.wrapIn(this.name);
            },
            toggleBlockquote: () => ({ commands }) => {
                return commands.toggleWrap(this.name);
            },
            unsetBlockquote: () => ({ commands }) => {
                return commands.lift(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-b': () => this.editor.commands.toggleBlockquote(),
        };
    },
    addInputRules() {
        return [
            wrappingInputRule({
                find: tiptap_extension_blockquote_esm_inputRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-blockquote.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-code-block/dist/tiptap-extension-code-block.esm.js



const backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
const tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;
const CodeBlock = tiptap_core_esm_Node.create({
    name: 'codeBlock',
    addOptions() {
        return {
            languageClassPrefix: 'language-',
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            HTMLAttributes: {},
        };
    },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    addAttributes() {
        return {
            language: {
                default: null,
                parseHTML: element => {
                    var _a;
                    const { languageClassPrefix } = this.options;
                    const classNames = [...((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []];
                    const languages = classNames
                        .filter(className => className.startsWith(languageClassPrefix))
                        .map(className => className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) {
                        return null;
                    }
                    return language;
                },
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'pre',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            [
                'code',
                {
                    class: node.attrs.language
                        ? this.options.languageClassPrefix + node.attrs.language
                        : null,
                },
                0,
            ],
        ];
    },
    addCommands() {
        return {
            setCodeBlock: attributes => ({ commands }) => {
                return commands.setNode(this.name, attributes);
            },
            toggleCodeBlock: attributes => ({ commands }) => {
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-c': () => this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: () => {
                const { empty, $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) {
                    return false;
                }
                if (isAtStart || !$anchor.parent.textContent.length) {
                    return this.editor.commands.clearNodes();
                }
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor }) => {
                if (!this.options.exitOnTripleEnter) {
                    return false;
                }
                const { state } = editor;
                const { selection } = state;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');
                if (!isAtEnd || !endsWithDoubleNewline) {
                    return false;
                }
                return editor
                    .chain()
                    .command(({ tr }) => {
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                })
                    .exitCode()
                    .run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor }) => {
                if (!this.options.exitOnArrowDown) {
                    return false;
                }
                const { state } = editor;
                const { selection, doc } = state;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) {
                    return false;
                }
                const after = $from.after();
                if (after === undefined) {
                    return false;
                }
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) {
                    return false;
                }
                return editor.commands.exitCode();
            },
        };
    },
    addInputRules() {
        return [
            textblockTypeInputRule({
                find: backtickInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
            textblockTypeInputRule({
                find: tildeInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
        ];
    },
    addProseMirrorPlugins() {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new Plugin({
                key: new PluginKey('codeBlockVSCodeHandler'),
                props: {
                    handlePaste: (view, event) => {
                        if (!event.clipboardData) {
                            return false;
                        }
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) {
                            return false;
                        }
                        const text = event.clipboardData.getData('text/plain');
                        const vscode = event.clipboardData.getData('vscode-editor-data');
                        const vscodeData = vscode
                            ? JSON.parse(vscode)
                            : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) {
                            return false;
                        }
                        const { tr } = view.state;
                        // create an empty code block
                        tr.replaceSelectionWith(this.type.create({ language }));
                        // put cursor inside the newly created code block
                        tr.setSelection(index_es_TextSelection.near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        // add text to code block
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        tr.insertText(text.replace(/\r\n?/g, '\n'));
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta('paste', true);
                        view.dispatch(tr);
                        return true;
                    },
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-code-block.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-code-block-lowlight/dist/tiptap-extension-code-block-lowlight.esm.js





var core$1 = {};

function deepFreeze(obj) {
    if (obj instanceof Map) {
        obj.clear = obj.delete = obj.set = function () {
            throw new Error('map is read-only');
        };
    } else if (obj instanceof Set) {
        obj.add = obj.clear = obj.delete = function () {
            throw new Error('set is read-only');
        };
    }

    // Freeze self
    Object.freeze(obj);

    Object.getOwnPropertyNames(obj).forEach(function (name) {
        var prop = obj[name];

        // Freeze prop if it is an object
        if (typeof prop == 'object' && !Object.isFrozen(prop)) {
            deepFreeze(prop);
        }
    });

    return obj;
}

var deepFreezeEs6 = deepFreeze;
var _default = deepFreeze;
deepFreezeEs6.default = _default;

/** @implements CallbackResponse */
class Response {
  /**
   * @param {CompiledMode} mode
   */
  constructor(mode) {
    // eslint-disable-next-line no-undefined
    if (mode.data === undefined) mode.data = {};

    this.data = mode.data;
    this.isMatchIgnored = false;
  }

  ignoreMatch() {
    this.isMatchIgnored = true;
  }
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHTML(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}

/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */
function inherit(original, ...objects) {
  /** @type Record<string,any> */
  const result = Object.create(null);

  for (const key in original) {
    result[key] = original[key];
  }
  objects.forEach(function(obj) {
    for (const key in obj) {
      result[key] = obj[key];
    }
  });
  return /** @type {T} */ (result);
}

/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */

/** @typedef {{kind?: string, sublanguage?: boolean}} Node */
/** @typedef {{walk: (r: Renderer) => void}} Tree */
/** */

const SPAN_CLOSE = '</span>';

/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */
const emitsWrappingTags = (node) => {
  return !!node.kind;
};

/** @type {Renderer} */
class HTMLRenderer {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(parseTree, options) {
    this.buffer = "";
    this.classPrefix = options.classPrefix;
    parseTree.walk(this);
  }

  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(text) {
    this.buffer += escapeHTML(text);
  }

  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(node) {
    if (!emitsWrappingTags(node)) return;

    let className = node.kind;
    if (!node.sublanguage) {
      className = `${this.classPrefix}${className}`;
    }
    this.span(className);
  }

  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(node) {
    if (!emitsWrappingTags(node)) return;

    this.buffer += SPAN_CLOSE;
  }

  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }

  // helpers

  /**
   * Builds a span element
   *
   * @param {string} className */
  span(className) {
    this.buffer += `<span class="${className}">`;
  }
}

/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */
/**  */

class TokenTree {
  constructor() {
    /** @type DataNode */
    this.rootNode = { children: [] };
    this.stack = [this.rootNode];
  }

  get top() {
    return this.stack[this.stack.length - 1];
  }

  get root() { return this.rootNode; }

  /** @param {Node} node */
  add(node) {
    this.top.children.push(node);
  }

  /** @param {string} kind */
  openNode(kind) {
    /** @type Node */
    const node = { kind, children: [] };
    this.add(node);
    this.stack.push(node);
  }

  closeNode() {
    if (this.stack.length > 1) {
      return this.stack.pop();
    }
    // eslint-disable-next-line no-undefined
    return undefined;
  }

  closeAllNodes() {
    while (this.closeNode());
  }

  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }

  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(builder) {
    // this does not
    return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
  }

  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(builder, node) {
    if (typeof node === "string") {
      builder.addText(node);
    } else if (node.children) {
      builder.openNode(node);
      node.children.forEach((child) => this._walk(builder, child));
      builder.closeNode(node);
    }
    return builder;
  }

  /**
   * @param {Node} node
   */
  static _collapse(node) {
    if (typeof node === "string") return;
    if (!node.children) return;

    if (node.children.every(el => typeof el === "string")) {
      // node.text = node.children.join("");
      // delete node.children;
      node.children = [node.children.join("")];
    } else {
      node.children.forEach((child) => {
        TokenTree._collapse(child);
      });
    }
  }
}

/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/

/**
 * @implements {Emitter}
 */
class TokenTreeEmitter extends TokenTree {
  /**
   * @param {*} options
   */
  constructor(options) {
    super();
    this.options = options;
  }

  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(text, kind) {
    if (text === "") { return; }

    this.openNode(kind);
    this.addText(text);
    this.closeNode();
  }

  /**
   * @param {string} text
   */
  addText(text) {
    if (text === "") { return; }

    this.add(text);
  }

  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(emitter, name) {
    /** @type DataNode */
    const node = emitter.root;
    node.kind = name;
    node.sublanguage = true;
    this.add(node);
  }

  toHTML() {
    const renderer = new HTMLRenderer(this, this.options);
    return renderer.value();
  }

  finalize() {
    return true;
  }
}

/**
 * @param {string} value
 * @returns {RegExp}
 * */
function tiptap_extension_code_block_lowlight_esm_escape(value) {
  return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'm');
}

/**
 * @param {RegExp | string } re
 * @returns {string}
 */
function tiptap_extension_code_block_lowlight_esm_source(re) {
  if (!re) return null;
  if (typeof re === "string") return re;

  return re.source;
}

/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */
function concat(...args) {
  const joined = args.map((x) => tiptap_extension_code_block_lowlight_esm_source(x)).join("");
  return joined;
}

/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */
function either(...args) {
  const joined = '(' + args.map((x) => tiptap_extension_code_block_lowlight_esm_source(x)).join("|") + ")";
  return joined;
}

/**
 * @param {RegExp} re
 * @returns {number}
 */
function countMatchGroups(re) {
  return (new RegExp(re.toString() + '|')).exec('').length - 1;
}

/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */
function startsWith(re, lexeme) {
  const match = re && re.exec(lexeme);
  return match && match.index === 0;
}

// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {string} separator
 * @returns {string}
 */
function join(regexps, separator = "|") {
  let numCaptures = 0;

  return regexps.map((regex) => {
    numCaptures += 1;
    const offset = numCaptures;
    let re = tiptap_extension_code_block_lowlight_esm_source(regex);
    let out = '';

    while (re.length > 0) {
      const match = BACKREF_RE.exec(re);
      if (!match) {
        out += re;
        break;
      }
      out += re.substring(0, match.index);
      re = re.substring(match.index + match[0].length);
      if (match[0][0] === '\\' && match[1]) {
        // Adjust the backreference.
        out += '\\' + String(Number(match[1]) + offset);
      } else {
        out += match[0];
        if (match[0] === '(') {
          numCaptures++;
        }
      }
    }
    return out;
  }).map(re => `(${re})`).join(separator);
}

// Common regexps
const MATCH_NOTHING_RE = /\b\B/;
const IDENT_RE = '[a-zA-Z]\\w*';
const UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
const NUMBER_RE = '\\b\\d+(\\.\\d+)?';
const C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
const BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
const RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/
const SHEBANG = (opts = {}) => {
  const beginShebang = /^#![ ]*\//;
  if (opts.binary) {
    opts.begin = concat(
      beginShebang,
      /.*\b/,
      opts.binary,
      /\b.*/);
  }
  return inherit({
    className: 'meta',
    begin: beginShebang,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (m, resp) => {
      if (m.index !== 0) resp.ignoreMatch();
    }
  }, opts);
};

// Common modes
const BACKSLASH_ESCAPE = {
  begin: '\\\\[\\s\\S]', relevance: 0
};
const APOS_STRING_MODE = {
  className: 'string',
  begin: '\'',
  end: '\'',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const QUOTE_STRING_MODE = {
  className: 'string',
  begin: '"',
  end: '"',
  illegal: '\\n',
  contains: [BACKSLASH_ESCAPE]
};
const PHRASAL_WORDS_MODE = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */
const COMMENT = function(begin, end, modeOptions = {}) {
  const mode = inherit(
    {
      className: 'comment',
      begin,
      end,
      contains: []
    },
    modeOptions
  );
  mode.contains.push(PHRASAL_WORDS_MODE);
  mode.contains.push({
    className: 'doctag',
    begin: '(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):',
    relevance: 0
  });
  return mode;
};
const C_LINE_COMMENT_MODE = COMMENT('//', '$');
const C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
const HASH_COMMENT_MODE = COMMENT('#', '$');
const NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE,
  relevance: 0
};
const C_NUMBER_MODE = {
  className: 'number',
  begin: C_NUMBER_RE,
  relevance: 0
};
const BINARY_NUMBER_MODE = {
  className: 'number',
  begin: BINARY_NUMBER_RE,
  relevance: 0
};
const CSS_NUMBER_MODE = {
  className: 'number',
  begin: NUMBER_RE + '(' +
    '%|em|ex|ch|rem' +
    '|vw|vh|vmin|vmax' +
    '|cm|mm|in|pt|pc|px' +
    '|deg|grad|rad|turn' +
    '|s|ms' +
    '|Hz|kHz' +
    '|dpi|dpcm|dppx' +
    ')?',
  relevance: 0
};
const REGEXP_MODE = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: 'regexp',
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      BACKSLASH_ESCAPE,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [BACKSLASH_ESCAPE]
      }
    ]
  }]
};
const TITLE_MODE = {
  className: 'title',
  begin: IDENT_RE,
  relevance: 0
};
const UNDERSCORE_TITLE_MODE = {
  className: 'title',
  begin: UNDERSCORE_IDENT_RE,
  relevance: 0
};
const METHOD_GUARD = {
  // excludes method names from keyword processing
  begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
  relevance: 0
};

/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */
const END_SAME_AS_BEGIN = function(mode) {
  return Object.assign(mode,
    {
      /** @type {ModeCallback} */
      'on:begin': (m, resp) => { resp.data._beginMatch = m[1]; },
      /** @type {ModeCallback} */
      'on:end': (m, resp) => { if (resp.data._beginMatch !== m[1]) resp.ignoreMatch(); }
    });
};

var MODES = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: MATCH_NOTHING_RE,
    IDENT_RE: IDENT_RE,
    UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
    NUMBER_RE: NUMBER_RE,
    C_NUMBER_RE: C_NUMBER_RE,
    BINARY_NUMBER_RE: BINARY_NUMBER_RE,
    RE_STARTERS_RE: RE_STARTERS_RE,
    SHEBANG: SHEBANG,
    BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
    APOS_STRING_MODE: APOS_STRING_MODE,
    QUOTE_STRING_MODE: QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
    COMMENT: COMMENT,
    C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE: HASH_COMMENT_MODE,
    NUMBER_MODE: NUMBER_MODE,
    C_NUMBER_MODE: C_NUMBER_MODE,
    BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
    CSS_NUMBER_MODE: CSS_NUMBER_MODE,
    REGEXP_MODE: REGEXP_MODE,
    TITLE_MODE: TITLE_MODE,
    UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE,
    METHOD_GUARD: METHOD_GUARD,
    END_SAME_AS_BEGIN: END_SAME_AS_BEGIN
});

// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833

// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.

// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.

// ------

// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */
function skipIfhasPrecedingDot(match, response) {
  const before = match.input[match.index - 1];
  if (before === ".") {
    response.ignoreMatch();
  }
}


/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */
function beginKeywords(mode, parent) {
  if (!parent) return;
  if (!mode.beginKeywords) return;

  // for languages with keywords that include non-word characters checking for
  // a word boundary is not sufficient, so instead we check for a word boundary
  // or whitespace - this does no harm in any case since our keyword engine
  // doesn't allow spaces in keywords anyways and we still check for the boundary
  // first
  mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
  mode.__beforeBegin = skipIfhasPrecedingDot;
  mode.keywords = mode.keywords || mode.beginKeywords;
  delete mode.beginKeywords;

  // prevents double relevance, the keywords themselves provide
  // relevance, the mode doesn't need to double it
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 0;
}

/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */
function compileIllegal(mode, _parent) {
  if (!Array.isArray(mode.illegal)) return;

  mode.illegal = either(...mode.illegal);
}

/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */
function compileMatch(mode, _parent) {
  if (!mode.match) return;
  if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");

  mode.begin = mode.match;
  delete mode.match;
}

/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */
function compileRelevance(mode, _parent) {
  // eslint-disable-next-line no-undefined
  if (mode.relevance === undefined) mode.relevance = 1;
}

// keywords that should have no default relevance value
const COMMON_KEYWORDS = [
  'of',
  'and',
  'for',
  'in',
  'not',
  'or',
  'if',
  'then',
  'parent', // common variable name
  'list', // common variable name
  'value' // common variable name
];

const DEFAULT_KEYWORD_CLASSNAME = "keyword";

/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */
function compileKeywords(rawKeywords, caseInsensitive, className = DEFAULT_KEYWORD_CLASSNAME) {
  /** @type KeywordDict */
  const compiledKeywords = {};

  // input can be a string of keywords, an array of keywords, or a object with
  // named keys representing className (which can then point to a string or array)
  if (typeof rawKeywords === 'string') {
    compileList(className, rawKeywords.split(" "));
  } else if (Array.isArray(rawKeywords)) {
    compileList(className, rawKeywords);
  } else {
    Object.keys(rawKeywords).forEach(function(className) {
      // collapse all our objects back into the parent object
      Object.assign(
        compiledKeywords,
        compileKeywords(rawKeywords[className], caseInsensitive, className)
      );
    });
  }
  return compiledKeywords;

  // ---

  /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} className
   * @param {Array<string>} keywordList
   */
  function compileList(className, keywordList) {
    if (caseInsensitive) {
      keywordList = keywordList.map(x => x.toLowerCase());
    }
    keywordList.forEach(function(keyword) {
      const pair = keyword.split('|');
      compiledKeywords[pair[0]] = [className, scoreForKeyword(pair[0], pair[1])];
    });
  }
}

/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */
function scoreForKeyword(keyword, providedScore) {
  // manual scores always win over common keywords
  // so you can force a score of 1 if you really insist
  if (providedScore) {
    return Number(providedScore);
  }

  return commonKeyword(keyword) ? 0 : 1;
}

/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */
function commonKeyword(keyword) {
  return COMMON_KEYWORDS.includes(keyword.toLowerCase());
}

// compilation

/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @param {{plugins: HLJSPlugin[]}} opts
 * @returns {CompiledLanguage}
 */
function compileLanguage(language, { plugins }) {
  /**
   * Builds a regex with the case sensativility of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */
  function langRe(value, global) {
    return new RegExp(
      tiptap_extension_code_block_lowlight_esm_source(value),
      'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
    );
  }

  /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */
  class MultiRegex {
    constructor() {
      this.matchIndexes = {};
      // @ts-ignore
      this.regexes = [];
      this.matchAt = 1;
      this.position = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      opts.position = this.position++;
      // @ts-ignore
      this.matchIndexes[this.matchAt] = opts;
      this.regexes.push([opts, re]);
      this.matchAt += countMatchGroups(re) + 1;
    }

    compile() {
      if (this.regexes.length === 0) {
        // avoids the need to check length every time exec is called
        // @ts-ignore
        this.exec = () => null;
      }
      const terminators = this.regexes.map(el => el[1]);
      this.matcherRe = langRe(join(terminators), true);
      this.lastIndex = 0;
    }

    /** @param {string} s */
    exec(s) {
      this.matcherRe.lastIndex = this.lastIndex;
      const match = this.matcherRe.exec(s);
      if (!match) { return null; }

      // eslint-disable-next-line no-undefined
      const i = match.findIndex((el, i) => i > 0 && el !== undefined);
      // @ts-ignore
      const matchData = this.matchIndexes[i];
      // trim off any earlier non-relevant match groups (ie, the other regex
      // match groups that make up the multi-matcher)
      match.splice(0, i);

      return Object.assign(match, matchData);
    }
  }

  /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */
  class ResumableMultiRegex {
    constructor() {
      // @ts-ignore
      this.rules = [];
      // @ts-ignore
      this.multiRegexes = [];
      this.count = 0;

      this.lastIndex = 0;
      this.regexIndex = 0;
    }

    // @ts-ignore
    getMatcher(index) {
      if (this.multiRegexes[index]) return this.multiRegexes[index];

      const matcher = new MultiRegex();
      this.rules.slice(index).forEach(([re, opts]) => matcher.addRule(re, opts));
      matcher.compile();
      this.multiRegexes[index] = matcher;
      return matcher;
    }

    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }

    considerAll() {
      this.regexIndex = 0;
    }

    // @ts-ignore
    addRule(re, opts) {
      this.rules.push([re, opts]);
      if (opts.type === "begin") this.count++;
    }

    /** @param {string} s */
    exec(s) {
      const m = this.getMatcher(this.regexIndex);
      m.lastIndex = this.lastIndex;
      let result = m.exec(s);

      // The following is because we have no easy way to say "resume scanning at the
      // existing position but also skip the current rule ONLY". What happens is
      // all prior rules are also skipped which can result in matching the wrong
      // thing. Example of matching "booger":

      // our matcher is [string, "booger", number]
      //
      // ....booger....

      // if "booger" is ignored then we'd really need a regex to scan from the
      // SAME position for only: [string, number] but ignoring "booger" (if it
      // was the first match), a simple resume would scan ahead who knows how
      // far looking only for "number", ignoring potential string matches (or
      // future "booger" matches that might be valid.)

      // So what we do: We execute two matchers, one resuming at the same
      // position, but the second full matcher starting at the position after:

      //     /--- resume first regex match here (for [number])
      //     |/---- full match here for [string, "booger", number]
      //     vv
      // ....booger....

      // Which ever results in a match first is then used. So this 3-4 step
      // process essentially allows us to say "match at this position, excluding
      // a prior rule that was ignored".
      //
      // 1. Match "booger" first, ignore. Also proves that [string] does non match.
      // 2. Resume matching for [number]
      // 3. Match at index + 1 for [string, "booger", number]
      // 4. If #2 and #3 result in matches, which came first?
      if (this.resumingScanAtSamePosition()) {
        if (result && result.index === this.lastIndex) ; else { // use the second matcher result
          const m2 = this.getMatcher(0);
          m2.lastIndex = this.lastIndex + 1;
          result = m2.exec(s);
        }
      }

      if (result) {
        this.regexIndex += result.position + 1;
        if (this.regexIndex === this.count) {
          // wrap-around to considering all matches again
          this.considerAll();
        }
      }

      return result;
    }
  }

  /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */
  function buildModeRegex(mode) {
    const mm = new ResumableMultiRegex();

    mode.contains.forEach(term => mm.addRule(term.begin, { rule: term, type: "begin" }));

    if (mode.terminatorEnd) {
      mm.addRule(mode.terminatorEnd, { type: "end" });
    }
    if (mode.illegal) {
      mm.addRule(mode.illegal, { type: "illegal" });
    }

    return mm;
  }

  /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */

  /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */
  function compileMode(mode, parent) {
    const cmode = /** @type CompiledMode */ (mode);
    if (mode.isCompiled) return cmode;

    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      compileMatch
    ].forEach(ext => ext(mode, parent));

    language.compilerExtensions.forEach(ext => ext(mode, parent));

    // __beforeBegin is considered private API, internal use only
    mode.__beforeBegin = null;

    [
      beginKeywords,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      compileIllegal,
      // default to 1 relevance if not specified
      compileRelevance
    ].forEach(ext => ext(mode, parent));

    mode.isCompiled = true;

    let keywordPattern = null;
    if (typeof mode.keywords === "object") {
      keywordPattern = mode.keywords.$pattern;
      delete mode.keywords.$pattern;
    }

    if (mode.keywords) {
      mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
    }

    // both are not allowed
    if (mode.lexemes && keywordPattern) {
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    }

    // `mode.lexemes` was the old standard before we added and now recommend
    // using `keywords.$pattern` to pass the keyword pattern
    keywordPattern = keywordPattern || mode.lexemes || /\w+/;
    cmode.keywordPatternRe = langRe(keywordPattern, true);

    if (parent) {
      if (!mode.begin) mode.begin = /\B|\b/;
      cmode.beginRe = langRe(mode.begin);
      if (mode.endSameAsBegin) mode.end = mode.begin;
      if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
      if (mode.end) cmode.endRe = langRe(mode.end);
      cmode.terminatorEnd = tiptap_extension_code_block_lowlight_esm_source(mode.end) || '';
      if (mode.endsWithParent && parent.terminatorEnd) {
        cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
      }
    }
    if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ (mode.illegal));
    if (!mode.contains) mode.contains = [];

    mode.contains = [].concat(...mode.contains.map(function(c) {
      return expandOrCloneMode(c === 'self' ? mode : c);
    }));
    mode.contains.forEach(function(c) { compileMode(/** @type Mode */ (c), cmode); });

    if (mode.starts) {
      compileMode(mode.starts, parent);
    }

    cmode.matcher = buildModeRegex(cmode);
    return cmode;
  }

  if (!language.compilerExtensions) language.compilerExtensions = [];

  // self is not valid at the top-level
  if (language.contains && language.contains.includes('self')) {
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  }

  // we need a null object, which inherit will guarantee
  language.classNameAliases = inherit(language.classNameAliases || {});

  return compileMode(/** @type Mode */ (language));
}

/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */
function dependencyOnParent(mode) {
  if (!mode) return false;

  return mode.endsWithParent || dependencyOnParent(mode.starts);
}

/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */
function expandOrCloneMode(mode) {
  if (mode.variants && !mode.cachedVariants) {
    mode.cachedVariants = mode.variants.map(function(variant) {
      return inherit(mode, { variants: null }, variant);
    });
  }

  // EXPAND
  // if we have variants then essentially "replace" the mode with the variants
  // this happens in compileMode, where this function is called from
  if (mode.cachedVariants) {
    return mode.cachedVariants;
  }

  // CLONE
  // if we have dependencies on parents then we need a unique
  // instance of ourselves, so we can be reused with many
  // different parents without issue
  if (dependencyOnParent(mode)) {
    return inherit(mode, { starts: mode.starts ? inherit(mode.starts) : null });
  }

  if (Object.isFrozen(mode)) {
    return inherit(mode);
  }

  // no special dependency issues, just return ourselves
  return mode;
}

var tiptap_extension_code_block_lowlight_esm_version = "10.7.3";

// @ts-nocheck

function hasValueOrEmptyAttribute(value) {
  return Boolean(value || value === "");
}

function BuildVuePlugin(hljs) {
  const Component = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: false
      };
    },
    computed: {
      className() {
        if (this.unknownLanguage) return "";

        return "hljs " + this.detectedLanguage;
      },
      highlighted() {
        // no idea what language to use, return raw code
        if (!this.autoDetect && !hljs.getLanguage(this.language)) {
          console.warn(`The language "${this.language}" you specified could not be found.`);
          this.unknownLanguage = true;
          return escapeHTML(this.code);
        }

        let result = {};
        if (this.autoDetect) {
          result = hljs.highlightAuto(this.code);
          this.detectedLanguage = result.language;
        } else {
          result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
          this.detectedLanguage = this.language;
        }
        return result.value;
      },
      autoDetect() {
        return !this.language || hasValueOrEmptyAttribute(this.autodetect);
      },
      ignoreIllegals() {
        return true;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(createElement) {
      return createElement("pre", {}, [
        createElement("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };

  const VuePlugin = {
    install(Vue) {
      Vue.component('highlightjs', Component);
    }
  };

  return { Component, VuePlugin };
}

/* plugin itself */

/** @type {HLJSPlugin} */
const mergeHTMLPlugin = {
  "after:highlightElement": ({ el, result, text }) => {
    const originalStream = nodeStream(el);
    if (!originalStream.length) return;

    const resultNode = document.createElement('div');
    resultNode.innerHTML = result.value;
    result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
  }
};

/* Stream merging support functions */

/**
 * @typedef Event
 * @property {'start'|'stop'} event
 * @property {number} offset
 * @property {Node} node
 */

/**
 * @param {Node} node
 */
function tag(node) {
  return node.nodeName.toLowerCase();
}

/**
 * @param {Node} node
 */
function nodeStream(node) {
  /** @type Event[] */
  const result = [];
  (function _nodeStream(node, offset) {
    for (let child = node.firstChild; child; child = child.nextSibling) {
      if (child.nodeType === 3) {
        offset += child.nodeValue.length;
      } else if (child.nodeType === 1) {
        result.push({
          event: 'start',
          offset: offset,
          node: child
        });
        offset = _nodeStream(child, offset);
        // Prevent void elements from having an end tag that would actually
        // double them in the output. There are more void elements in HTML
        // but we list only those realistically expected in code display.
        if (!tag(child).match(/br|hr|img|input/)) {
          result.push({
            event: 'stop',
            offset: offset,
            node: child
          });
        }
      }
    }
    return offset;
  })(node, 0);
  return result;
}

/**
 * @param {any} original - the original stream
 * @param {any} highlighted - stream of the highlighted source
 * @param {string} value - the original source itself
 */
function mergeStreams(original, highlighted, value) {
  let processed = 0;
  let result = '';
  const nodeStack = [];

  function selectStream() {
    if (!original.length || !highlighted.length) {
      return original.length ? original : highlighted;
    }
    if (original[0].offset !== highlighted[0].offset) {
      return (original[0].offset < highlighted[0].offset) ? original : highlighted;
    }

    /*
    To avoid starting the stream just before it should stop the order is
    ensured that original always starts first and closes last:

    if (event1 == 'start' && event2 == 'start')
      return original;
    if (event1 == 'start' && event2 == 'stop')
      return highlighted;
    if (event1 == 'stop' && event2 == 'start')
      return original;
    if (event1 == 'stop' && event2 == 'stop')
      return highlighted;

    ... which is collapsed to:
    */
    return highlighted[0].event === 'start' ? original : highlighted;
  }

  /**
   * @param {Node} node
   */
  function open(node) {
    /** @param {Attr} attr */
    function attributeString(attr) {
      return ' ' + attr.nodeName + '="' + escapeHTML(attr.value) + '"';
    }
    // @ts-ignore
    result += '<' + tag(node) + [].map.call(node.attributes, attributeString).join('') + '>';
  }

  /**
   * @param {Node} node
   */
  function close(node) {
    result += '</' + tag(node) + '>';
  }

  /**
   * @param {Event} event
   */
  function render(event) {
    (event.event === 'start' ? open : close)(event.node);
  }

  while (original.length || highlighted.length) {
    let stream = selectStream();
    result += escapeHTML(value.substring(processed, stream[0].offset));
    processed = stream[0].offset;
    if (stream === original) {
      /*
      On any opening or closing tag of the original markup we first close
      the entire highlighted node stack, then render the original tag along
      with all the following original tags at the same offset and then
      reopen all the tags on the highlighted stack.
      */
      nodeStack.reverse().forEach(close);
      do {
        render(stream.splice(0, 1)[0]);
        stream = selectStream();
      } while (stream === original && stream.length && stream[0].offset === processed);
      nodeStack.reverse().forEach(open);
    } else {
      if (stream[0].event === 'start') {
        nodeStack.push(stream[0].node);
      } else {
        nodeStack.pop();
      }
      render(stream.splice(0, 1)[0]);
    }
  }
  return result + escapeHTML(value.substr(processed));
}

/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/

/**
 * @type {Record<string, boolean>}
 */
const seenDeprecations = {};

/**
 * @param {string} message
 */
const tiptap_extension_code_block_lowlight_esm_error = (message) => {
  console.error(message);
};

/**
 * @param {string} message
 * @param {any} args
 */
const tiptap_extension_code_block_lowlight_esm_warn = (message, ...args) => {
  console.log(`WARN: ${message}`, ...args);
};

/**
 * @param {string} version
 * @param {string} message
 */
const deprecated = (version, message) => {
  if (seenDeprecations[`${version}/${message}`]) return;

  console.log(`Deprecated as of ${version}. ${message}`);
  seenDeprecations[`${version}/${message}`] = true;
};

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

const escape$1 = escapeHTML;
const inherit$1 = inherit;
const NO_MATCH = Symbol("nomatch");

/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */
const HLJS = function(hljs) {
  // Global internal variables used within the highlight.js library.
  /** @type {Record<string, Language>} */
  const languages = Object.create(null);
  /** @type {Record<string, string>} */
  const aliases = Object.create(null);
  /** @type {HLJSPlugin[]} */
  const plugins = [];

  // safe/production mode - swallows more errors, tries to keep running
  // even if a single syntax or parse hits a fatal error
  let SAFE_MODE = true;
  const fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
  const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
  /** @type {Language} */
  const PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: 'Plain text', contains: [] };

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  /** @type HLJSOptions */
  let options = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: TokenTreeEmitter
  };

  /* Utility functions */

  /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */
  function shouldNotHighlight(languageName) {
    return options.noHighlightRe.test(languageName);
  }

  /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */
  function blockLanguage(block) {
    let classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    const match = options.languageDetectRe.exec(classes);
    if (match) {
      const language = getLanguage(match[1]);
      if (!language) {
        tiptap_extension_code_block_lowlight_esm_warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
        tiptap_extension_code_block_lowlight_esm_warn("Falling back to no-highlight mode for this block.", block);
      }
      return language ? match[1] : 'no-highlight';
    }

    return classes
      .split(/\s+/)
      .find((_class) => shouldNotHighlight(_class) || getLanguage(_class));
  }

  /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrlanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode} [continuation] - current continuation mode, if any
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */
  function highlight(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
    let code = "";
    let languageName = "";
    if (typeof optionsOrCode === "object") {
      code = codeOrlanguageName;
      ignoreIllegals = optionsOrCode.ignoreIllegals;
      languageName = optionsOrCode.language;
      // continuation not supported at all via the new API
      // eslint-disable-next-line no-undefined
      continuation = undefined;
    } else {
      // old API
      deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
      deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
      languageName = codeOrlanguageName;
      code = optionsOrCode;
    }

    /** @type {BeforeHighlightContext} */
    const context = {
      code,
      language: languageName
    };
    // the plugin can change the desired language or the code to be highlighted
    // just be changing the object it was passed
    fire("before:highlight", context);

    // a before plugin can usurp the result completely by providing it's own
    // in which case we don't even need to call highlight
    const result = context.result
      ? context.result
      : _highlight(context.language, context.code, ignoreIllegals, continuation);

    result.code = context.code;
    // the plugin can change anything in result to suite it
    fire("after:highlight", result);

    return result;
  }

  /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */
  function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
    /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {RegExpMatchArray} match - regexp match data
     * @returns {KeywordData | false}
     */
    function keywordData(mode, match) {
      const matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
    }

    function processKeywords() {
      if (!top.keywords) {
        emitter.addText(modeBuffer);
        return;
      }

      let lastIndex = 0;
      top.keywordPatternRe.lastIndex = 0;
      let match = top.keywordPatternRe.exec(modeBuffer);
      let buf = "";

      while (match) {
        buf += modeBuffer.substring(lastIndex, match.index);
        const data = keywordData(top, match);
        if (data) {
          const [kind, keywordRelevance] = data;
          emitter.addText(buf);
          buf = "";

          relevance += keywordRelevance;
          if (kind.startsWith("_")) {
            // _ implied for relevance only, do not highlight
            // by applying a class name
            buf += match[0];
          } else {
            const cssClass = language.classNameAliases[kind] || kind;
            emitter.addKeyword(match[0], cssClass);
          }
        } else {
          buf += match[0];
        }
        lastIndex = top.keywordPatternRe.lastIndex;
        match = top.keywordPatternRe.exec(modeBuffer);
      }
      buf += modeBuffer.substr(lastIndex);
      emitter.addText(buf);
    }

    function processSubLanguage() {
      if (modeBuffer === "") return;
      /** @type HighlightResult */
      let result = null;

      if (typeof top.subLanguage === 'string') {
        if (!languages[top.subLanguage]) {
          emitter.addText(modeBuffer);
          return;
        }
        result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
        continuations[top.subLanguage] = /** @type {CompiledMode} */ (result.top);
      } else {
        result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
      }

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Use case in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      emitter.addSublanguage(result.emitter, result.language);
    }

    function processBuffer() {
      if (top.subLanguage != null) {
        processSubLanguage();
      } else {
        processKeywords();
      }
      modeBuffer = '';
    }

    /**
     * @param {Mode} mode - new mode to start
     */
    function startNewMode(mode) {
      if (mode.className) {
        emitter.openNode(language.classNameAliases[mode.className] || mode.className);
      }
      top = Object.create(mode, { parent: { value: top } });
      return top;
    }

    /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */
    function endOfMode(mode, match, matchPlusRemainder) {
      let matched = startsWith(mode.endRe, matchPlusRemainder);

      if (matched) {
        if (mode["on:end"]) {
          const resp = new Response(mode);
          mode["on:end"](match, resp);
          if (resp.isMatchIgnored) matched = false;
        }

        if (matched) {
          while (mode.endsParent && mode.parent) {
            mode = mode.parent;
          }
          return mode;
        }
      }
      // even if on:end fires an `ignore` it's still possible
      // that we might trigger the end node because of a parent mode
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, match, matchPlusRemainder);
      }
    }

    /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */
    function doIgnore(lexeme) {
      if (top.matcher.regexIndex === 0) {
        // no more regexs to potentially match here, so we move the cursor forward one
        // space
        modeBuffer += lexeme[0];
        return 1;
      } else {
        // no need to move the cursor, we still have additional regexes to try and
        // match at this very spot
        resumeScanAtSamePosition = true;
        return 0;
      }
    }

    /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */
    function doBeginMatch(match) {
      const lexeme = match[0];
      const newMode = match.rule;

      const resp = new Response(newMode);
      // first internal before callbacks, then the public ones
      const beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
      for (const cb of beforeCallbacks) {
        if (!cb) continue;
        cb(match, resp);
        if (resp.isMatchIgnored) return doIgnore(lexeme);
      }

      if (newMode && newMode.endSameAsBegin) {
        newMode.endRe = tiptap_extension_code_block_lowlight_esm_escape(lexeme);
      }

      if (newMode.skip) {
        modeBuffer += lexeme;
      } else {
        if (newMode.excludeBegin) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (!newMode.returnBegin && !newMode.excludeBegin) {
          modeBuffer = lexeme;
        }
      }
      startNewMode(newMode);
      // if (mode["after:begin"]) {
      //   let resp = new Response(mode);
      //   mode["after:begin"](match, resp);
      // }
      return newMode.returnBegin ? 0 : lexeme.length;
    }

    /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */
    function doEndMatch(match) {
      const lexeme = match[0];
      const matchPlusRemainder = codeToHighlight.substr(match.index);

      const endMode = endOfMode(top, match, matchPlusRemainder);
      if (!endMode) { return NO_MATCH; }

      const origin = top;
      if (origin.skip) {
        modeBuffer += lexeme;
      } else {
        if (!(origin.returnEnd || origin.excludeEnd)) {
          modeBuffer += lexeme;
        }
        processBuffer();
        if (origin.excludeEnd) {
          modeBuffer = lexeme;
        }
      }
      do {
        if (top.className) {
          emitter.closeNode();
        }
        if (!top.skip && !top.subLanguage) {
          relevance += top.relevance;
        }
        top = top.parent;
      } while (top !== endMode.parent);
      if (endMode.starts) {
        if (endMode.endSameAsBegin) {
          endMode.starts.endRe = endMode.endRe;
        }
        startNewMode(endMode.starts);
      }
      return origin.returnEnd ? 0 : lexeme.length;
    }

    function processContinuations() {
      const list = [];
      for (let current = top; current !== language; current = current.parent) {
        if (current.className) {
          list.unshift(current.className);
        }
      }
      list.forEach(item => emitter.openNode(item));
    }

    /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
    let lastMatch = {};

    /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceeding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */
    function processLexeme(textBeforeMatch, match) {
      const lexeme = match && match[0];

      // add non-matched text to the current mode buffer
      modeBuffer += textBeforeMatch;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      // we've found a 0 width match and we're stuck, so we need to advance
      // this happens when we have badly behaved rules that have optional matchers to the degree that
      // sometimes they can end up matching nothing at all
      // Ref: https://github.com/highlightjs/highlight.js/issues/2140
      if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
        // spit the "skipped" character that our regex choked on back into the output sequence
        modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
        if (!SAFE_MODE) {
          /** @type {AnnotatedError} */
          const err = new Error('0 width match regex');
          err.languageName = languageName;
          err.badRule = lastMatch.rule;
          throw err;
        }
        return 1;
      }
      lastMatch = match;

      if (match.type === "begin") {
        return doBeginMatch(match);
      } else if (match.type === "illegal" && !ignoreIllegals) {
        // illegal match, we do not continue processing
        /** @type {AnnotatedError} */
        const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
        err.mode = top;
        throw err;
      } else if (match.type === "end") {
        const processed = doEndMatch(match);
        if (processed !== NO_MATCH) {
          return processed;
        }
      }

      // edge case for when illegal matches $ (end of line) which is technically
      // a 0 width match but not a begin/end match so it's not caught by the
      // first handler (when ignoreIllegals is true)
      if (match.type === "illegal" && lexeme === "") {
        // advance so we aren't stuck in an infinite loop
        return 1;
      }

      // infinite loops are BAD, this is a last ditch catch all. if we have a
      // decent number of iterations yet our index (cursor position in our
      // parsing) still 3x behind our index then something is very wrong
      // so we bail
      if (iterations > 100000 && iterations > match.index * 3) {
        const err = new Error('potential infinite loop, way more iterations than matches');
        throw err;
      }

      /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */

      modeBuffer += lexeme;
      return lexeme.length;
    }

    const language = getLanguage(languageName);
    if (!language) {
      tiptap_extension_code_block_lowlight_esm_error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
      throw new Error('Unknown language: "' + languageName + '"');
    }

    const md = compileLanguage(language, { plugins });
    let result = '';
    /** @type {CompiledMode} */
    let top = continuation || md;
    /** @type Record<string,CompiledMode> */
    const continuations = {}; // keep continuations for sub-languages
    const emitter = new options.__emitter(options);
    processContinuations();
    let modeBuffer = '';
    let relevance = 0;
    let index = 0;
    let iterations = 0;
    let resumeScanAtSamePosition = false;

    try {
      top.matcher.considerAll();

      for (;;) {
        iterations++;
        if (resumeScanAtSamePosition) {
          // only regexes not matched previously will now be
          // considered for a potential match
          resumeScanAtSamePosition = false;
        } else {
          top.matcher.considerAll();
        }
        top.matcher.lastIndex = index;

        const match = top.matcher.exec(codeToHighlight);
        // console.log("match", match[0], match.rule && match.rule.begin)

        if (!match) break;

        const beforeMatch = codeToHighlight.substring(index, match.index);
        const processedCount = processLexeme(beforeMatch, match);
        index = match.index + processedCount;
      }
      processLexeme(codeToHighlight.substr(index));
      emitter.closeAllNodes();
      emitter.finalize();
      result = emitter.toHTML();

      return {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(relevance),
        value: result,
        language: languageName,
        illegal: false,
        emitter: emitter,
        top: top
      };
    } catch (err) {
      if (err.message && err.message.includes('Illegal')) {
        return {
          illegal: true,
          illegalBy: {
            msg: err.message,
            context: codeToHighlight.slice(index - 100, index + 100),
            mode: err.mode
          },
          sofar: result,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter
        };
      } else if (SAFE_MODE) {
        return {
          illegal: false,
          relevance: 0,
          value: escape$1(codeToHighlight),
          emitter: emitter,
          language: languageName,
          top: top,
          errorRaised: err
        };
      } else {
        throw err;
      }
    }
  }

  /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */
  function justTextHighlightResult(code) {
    const result = {
      relevance: 0,
      emitter: new options.__emitter(options),
      value: escape$1(code),
      illegal: false,
      top: PLAINTEXT_LANGUAGE
    };
    result.emitter.addText(code);
    return result;
  }

  /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */
  function highlightAuto(code, languageSubset) {
    languageSubset = languageSubset || options.languages || Object.keys(languages);
    const plaintext = justTextHighlightResult(code);

    const results = languageSubset.filter(getLanguage).filter(autoDetection).map(name =>
      _highlight(name, code, false)
    );
    results.unshift(plaintext); // plaintext is always an option

    const sorted = results.sort((a, b) => {
      // sort base on relevance
      if (a.relevance !== b.relevance) return b.relevance - a.relevance;

      // always award the tie to the base language
      // ie if C++ and Arduino are tied, it's more likely to be C++
      if (a.language && b.language) {
        if (getLanguage(a.language).supersetOf === b.language) {
          return 1;
        } else if (getLanguage(b.language).supersetOf === a.language) {
          return -1;
        }
      }

      // otherwise say they are equal, which has the effect of sorting on
      // relevance while preserving the original ordering - which is how ties
      // have historically been settled, ie the language that comes first always
      // wins in the case of a tie
      return 0;
    });

    const [best, secondBest] = sorted;

    /** @type {AutoHighlightResult} */
    const result = best;
    result.second_best = secondBest;

    return result;
  }

  /**
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

    @param {string} html
    @returns {string}
  */
  function fixMarkup(html) {
    if (!(options.tabReplace || options.useBR)) {
      return html;
    }

    return html.replace(fixMarkupRe, match => {
      if (match === '\n') {
        return options.useBR ? '<br>' : match;
      } else if (options.tabReplace) {
        return match.replace(/\t/g, options.tabReplace);
      }
      return match;
    });
  }

  /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */
  function updateClassName(element, currentLang, resultLang) {
    const language = currentLang ? aliases[currentLang] : resultLang;

    element.classList.add("hljs");
    if (language) element.classList.add(language);
  }

  /** @type {HLJSPlugin} */
  const brPlugin = {
    "before:highlightElement": ({ el }) => {
      if (options.useBR) {
        el.innerHTML = el.innerHTML.replace(/\n/g, '').replace(/<br[ /]*>/g, '\n');
      }
    },
    "after:highlightElement": ({ result }) => {
      if (options.useBR) {
        result.value = result.value.replace(/\n/g, "<br>");
      }
    }
  };

  const TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
  /** @type {HLJSPlugin} */
  const tabReplacePlugin = {
    "after:highlightElement": ({ result }) => {
      if (options.tabReplace) {
        result.value = result.value.replace(TAB_REPLACE_RE, (m) =>
          m.replace(/\t/g, options.tabReplace)
        );
      }
    }
  };

  /**
   * Applies highlighting to a DOM node containing code. Accepts a DOM node and
   * two optional parameters for fixMarkup.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */
  function highlightElement(element) {
    /** @type HTMLElement */
    let node = null;
    const language = blockLanguage(element);

    if (shouldNotHighlight(language)) return;

    // support for v10 API
    fire("before:highlightElement",
      { el: element, language: language });

    node = element;
    const text = node.textContent;
    const result = language ? highlight(text, { language, ignoreIllegals: true }) : highlightAuto(text);

    // support for v10 API
    fire("after:highlightElement", { el: element, result, text });

    element.innerHTML = result.value;
    updateClassName(element, language, result.language);
    element.result = {
      language: result.language,
      // TODO: remove with version 11.0
      re: result.relevance,
      relavance: result.relevance
    };
    if (result.second_best) {
      element.second_best = {
        language: result.second_best.language,
        // TODO: remove with version 11.0
        re: result.second_best.relevance,
        relavance: result.second_best.relevance
      };
    }
  }

  /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */
  function configure(userOptions) {
    if (userOptions.useBR) {
      deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
      deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
    }
    options = inherit$1(options, userOptions);
  }

  /**
   * Highlights to all <pre><code> blocks on a page
   *
   * @type {Function & {called?: boolean}}
   */
  // TODO: remove v12, deprecated
  const initHighlighting = () => {
    if (initHighlighting.called) return;
    initHighlighting.called = true;

    deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  };

  // Higlights all when DOMContentLoaded fires
  // TODO: remove v12, deprecated
  function initHighlightingOnLoad() {
    deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
    wantsHighlight = true;
  }

  let wantsHighlight = false;

  /**
   * auto-highlights all pre>code elements on the page
   */
  function highlightAll() {
    // if we are called too early in the loading process
    if (document.readyState === "loading") {
      wantsHighlight = true;
      return;
    }

    const blocks = document.querySelectorAll('pre code');
    blocks.forEach(highlightElement);
  }

  function boot() {
    // if a highlight was requested before DOM was loaded, do now
    if (wantsHighlight) highlightAll();
  }

  // make sure we are in the browser environment
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('DOMContentLoaded', boot, false);
  }

  /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */
  function registerLanguage(languageName, languageDefinition) {
    let lang = null;
    try {
      lang = languageDefinition(hljs);
    } catch (error$1) {
      tiptap_extension_code_block_lowlight_esm_error("Language definition for '{}' could not be registered.".replace("{}", languageName));
      // hard or soft error
      if (!SAFE_MODE) { throw error$1; } else { tiptap_extension_code_block_lowlight_esm_error(error$1); }
      // languages that have serious errors are replaced with essentially a
      // "plaintext" stand-in so that the code blocks will still get normal
      // css classes applied to them - and one bad language won't break the
      // entire highlighter
      lang = PLAINTEXT_LANGUAGE;
    }
    // give it a temporary name if it doesn't have one in the meta-data
    if (!lang.name) lang.name = languageName;
    languages[languageName] = lang;
    lang.rawDefinition = languageDefinition.bind(null, hljs);

    if (lang.aliases) {
      registerAliases(lang.aliases, { languageName });
    }
  }

  /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */
  function unregisterLanguage(languageName) {
    delete languages[languageName];
    for (const alias of Object.keys(aliases)) {
      if (aliases[alias] === languageName) {
        delete aliases[alias];
      }
    }
  }

  /**
   * @returns {string[]} List of language internal names
   */
  function listLanguages() {
    return Object.keys(languages);
  }

  /**
    intended usage: When one language truly requires another

    Unlike `getLanguage`, this will throw when the requested language
    is not available.

    @param {string} name - name of the language to fetch/require
    @returns {Language | never}
  */
  function requireLanguage(name) {
    deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
    deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");

    const lang = getLanguage(name);
    if (lang) { return lang; }

    const err = new Error('The \'{}\' language is required, but not loaded.'.replace('{}', name));
    throw err;
  }

  /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */
  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */
  function registerAliases(aliasList, { languageName }) {
    if (typeof aliasList === 'string') {
      aliasList = [aliasList];
    }
    aliasList.forEach(alias => { aliases[alias.toLowerCase()] = languageName; });
  }

  /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */
  function autoDetection(name) {
    const lang = getLanguage(name);
    return lang && !lang.disableAutodetect;
  }

  /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */
  function upgradePluginAPI(plugin) {
    // TODO: remove with v12
    if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
      plugin["before:highlightElement"] = (data) => {
        plugin["before:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
    if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
      plugin["after:highlightElement"] = (data) => {
        plugin["after:highlightBlock"](
          Object.assign({ block: data.el }, data)
        );
      };
    }
  }

  /**
   * @param {HLJSPlugin} plugin
   */
  function addPlugin(plugin) {
    upgradePluginAPI(plugin);
    plugins.push(plugin);
  }

  /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */
  function fire(event, args) {
    const cb = event;
    plugins.forEach(function(plugin) {
      if (plugin[cb]) {
        plugin[cb](args);
      }
    });
  }

  /**
  Note: fixMarkup is deprecated and will be removed entirely in v11

  @param {string} arg
  @returns {string}
  */
  function deprecateFixMarkup(arg) {
    deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
    deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");

    return fixMarkup(arg);
  }

  /**
   *
   * @param {HighlightedHTMLElement} el
   */
  function deprecateHighlightBlock(el) {
    deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
    deprecated("10.7.0", "Please use highlightElement now.");

    return highlightElement(el);
  }

  /* Interface definition */
  Object.assign(hljs, {
    highlight,
    highlightAuto,
    highlightAll,
    fixMarkup: deprecateFixMarkup,
    highlightElement,
    // TODO: Remove with v12 API
    highlightBlock: deprecateHighlightBlock,
    configure,
    initHighlighting,
    initHighlightingOnLoad,
    registerLanguage,
    unregisterLanguage,
    listLanguages,
    getLanguage,
    registerAliases,
    requireLanguage,
    autoDetection,
    inherit: inherit$1,
    addPlugin,
    // plugins for frameworks
    vuePlugin: BuildVuePlugin(hljs).VuePlugin
  });

  hljs.debugMode = function() { SAFE_MODE = false; };
  hljs.safeMode = function() { SAFE_MODE = true; };
  hljs.versionString = tiptap_extension_code_block_lowlight_esm_version;

  for (const key in MODES) {
    // @ts-ignore
    if (typeof MODES[key] === "object") {
      // @ts-ignore
      deepFreezeEs6(MODES[key]);
    }
  }

  // merge all the modes/regexs into our main object
  Object.assign(hljs, MODES);

  // built-in plugins, likely to be moved out of core in the future
  hljs.addPlugin(brPlugin); // slated to be removed in v11
  hljs.addPlugin(mergeHTMLPlugin);
  hljs.addPlugin(tabReplacePlugin);
  return hljs;
};

// export an "instance" of the highlighter
var highlight$1 = HLJS({});

var core = highlight$1;

var format = {exports: {}};

(function (module) {
(function() {

  //// Export the API
  var namespace;

  // CommonJS / Node module
  {
    namespace = module.exports = format;
  }

  namespace.format = format;
  namespace.vsprintf = vsprintf;

  if (typeof console !== 'undefined' && typeof console.log === 'function') {
    namespace.printf = printf;
  }

  function printf(/* ... */) {
    console.log(format.apply(null, arguments));
  }

  function vsprintf(fmt, replacements) {
    return format.apply(null, [fmt].concat(replacements));
  }

  function format(fmt) {
    var argIndex = 1 // skip initial format argument
      , args = [].slice.call(arguments)
      , i = 0
      , n = fmt.length
      , result = ''
      , c
      , escaped = false
      , arg
      , tmp
      , leadingZero = false
      , precision
      , nextArg = function() { return args[argIndex++]; }
      , slurpNumber = function() {
          var digits = '';
          while (/\d/.test(fmt[i])) {
            digits += fmt[i++];
            c = fmt[i];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        }
      ;
    for (; i < n; ++i) {
      c = fmt[i];
      if (escaped) {
        escaped = false;
        if (c == '.') {
          leadingZero = false;
          c = fmt[++i];
        }
        else if (c == '0' && fmt[i + 1] == '.') {
          leadingZero = true;
          i += 2;
          c = fmt[i];
        }
        else {
          leadingZero = true;
        }
        precision = slurpNumber();
        switch (c) {
        case 'b': // number in binary
          result += parseInt(nextArg(), 10).toString(2);
          break;
        case 'c': // character
          arg = nextArg();
          if (typeof arg === 'string' || arg instanceof String)
            result += arg;
          else
            result += String.fromCharCode(parseInt(arg, 10));
          break;
        case 'd': // number in decimal
          result += parseInt(nextArg(), 10);
          break;
        case 'f': // floating point number
          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
          result += leadingZero ? tmp : tmp.replace(/^0/, '');
          break;
        case 'j': // JSON
          result += JSON.stringify(nextArg());
          break;
        case 'o': // number in octal
          result += '0' + parseInt(nextArg(), 10).toString(8);
          break;
        case 's': // string
          result += nextArg();
          break;
        case 'x': // lowercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16);
          break;
        case 'X': // uppercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
          break;
        default:
          result += c;
          break;
        }
      } else if (c === '%') {
        escaped = true;
      } else {
        result += c;
      }
    }
    return result;
  }

}());
}(format));

var formatter = format.exports;

var fault$1 = tiptap_extension_code_block_lowlight_esm_create(Error);

var fault_1 = fault$1;

fault$1.eval = tiptap_extension_code_block_lowlight_esm_create(EvalError);
fault$1.range = tiptap_extension_code_block_lowlight_esm_create(RangeError);
fault$1.reference = tiptap_extension_code_block_lowlight_esm_create(ReferenceError);
fault$1.syntax = tiptap_extension_code_block_lowlight_esm_create(SyntaxError);
fault$1.type = tiptap_extension_code_block_lowlight_esm_create(TypeError);
fault$1.uri = tiptap_extension_code_block_lowlight_esm_create(URIError);

fault$1.create = tiptap_extension_code_block_lowlight_esm_create;

// Create a new `EConstructor`, with the formatted `format` as a first argument.
function tiptap_extension_code_block_lowlight_esm_create(EConstructor) {
  FormattedError.displayName = EConstructor.displayName || EConstructor.name;

  return FormattedError

  function FormattedError(format) {
    if (format) {
      format = formatter.apply(null, arguments);
    }

    return new EConstructor(format)
  }
}

var high = core;
var fault = fault_1;

core$1.highlight = highlight;
core$1.highlightAuto = highlightAuto;
core$1.registerLanguage = registerLanguage;
core$1.listLanguages = listLanguages;
core$1.registerAlias = registerAlias;

Emitter.prototype.addText = tiptap_extension_code_block_lowlight_esm_text;
Emitter.prototype.addKeyword = addKeyword;
Emitter.prototype.addSublanguage = addSublanguage;
Emitter.prototype.openNode = tiptap_extension_code_block_lowlight_esm_open;
Emitter.prototype.closeNode = tiptap_extension_code_block_lowlight_esm_close;
Emitter.prototype.closeAllNodes = tiptap_extension_code_block_lowlight_esm_noop;
Emitter.prototype.finalize = tiptap_extension_code_block_lowlight_esm_noop;
Emitter.prototype.toHTML = toHtmlNoop;

var defaultPrefix = 'hljs-';

// Highlighting `value` in the language `name`.
function highlight(name, value, options) {
  var before = high.configure({});
  var settings = options || {};
  var prefix = settings.prefix;
  var result;

  if (typeof name !== 'string') {
    throw fault('Expected `string` for name, got `%s`', name)
  }

  if (!high.getLanguage(name)) {
    throw fault('Unknown language: `%s` is not registered', name)
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix;
  }

  high.configure({__emitter: Emitter, classPrefix: prefix});

  result = high.highlight(value, {language: name, ignoreIllegals: true});

  high.configure(before || {});

  /* istanbul ignore if - Highlight.js seems to use this (currently) for broken
   * grammars, so let’s keep it in there just to be sure. */
  if (result.errorRaised) {
    throw result.errorRaised
  }

  return {
    relevance: result.relevance,
    language: result.language,
    value: result.emitter.rootNode.children
  }
}

function highlightAuto(value, options) {
  var settings = options || {};
  var subset = settings.subset || high.listLanguages();
  settings.prefix;
  var length = subset.length;
  var index = -1;
  var result;
  var secondBest;
  var current;
  var name;

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  secondBest = {relevance: 0, language: null, value: []};
  result = {relevance: 0, language: null, value: []};

  while (++index < length) {
    name = subset[index];

    if (!high.getLanguage(name)) {
      continue
    }

    current = highlight(name, value, options);
    current.language = name;

    if (current.relevance > secondBest.relevance) {
      secondBest = current;
    }

    if (current.relevance > result.relevance) {
      secondBest = result;
      result = current;
    }
  }

  if (secondBest.language) {
    result.secondBest = secondBest;
  }

  return result
}

// Register a language.
function registerLanguage(name, syntax) {
  high.registerLanguage(name, syntax);
}

// Get a list of all registered languages.
function listLanguages() {
  return high.listLanguages()
}

// Register more aliases for an already registered language.
function registerAlias(name, alias) {
  var map = name;
  var key;

  if (alias) {
    map = {};
    map[name] = alias;
  }

  for (key in map) {
    high.registerAliases(map[key], {languageName: key});
  }
}

function Emitter(options) {
  this.options = options;
  this.rootNode = {children: []};
  this.stack = [this.rootNode];
}

function addKeyword(value, name) {
  this.openNode(name);
  this.addText(value);
  this.closeNode();
}

function addSublanguage(other, name) {
  var stack = this.stack;
  var current = stack[stack.length - 1];
  var results = other.rootNode.children;
  var node = name
    ? {
        type: 'element',
        tagName: 'span',
        properties: {className: [name]},
        children: results
      }
    : results;

  current.children = current.children.concat(node);
}

function tiptap_extension_code_block_lowlight_esm_text(value) {
  var stack = this.stack;
  var current;
  var tail;

  if (value === '') return

  current = stack[stack.length - 1];
  tail = current.children[current.children.length - 1];

  if (tail && tail.type === 'text') {
    tail.value += value;
  } else {
    current.children.push({type: 'text', value: value});
  }
}

function tiptap_extension_code_block_lowlight_esm_open(name) {
  var stack = this.stack;
  var className = this.options.classPrefix + name;
  var current = stack[stack.length - 1];
  var child = {
    type: 'element',
    tagName: 'span',
    properties: {className: [className]},
    children: []
  };

  current.children.push(child);
  stack.push(child);
}

function tiptap_extension_code_block_lowlight_esm_close() {
  this.stack.pop();
}

function toHtmlNoop() {
  return ''
}

function tiptap_extension_code_block_lowlight_esm_noop() {}

function parseNodes(nodes, className = []) {
    return nodes
        .map(node => {
        const classes = [
            ...className,
            ...node.properties
                ? node.properties.className
                : [],
        ];
        if (node.children) {
            return parseNodes(node.children, classes);
        }
        return {
            text: node.value,
            classes,
        };
    })
        .flat();
}
function getHighlightNodes(result) {
    // `.value` for lowlight v1, `.children` for lowlight v2
    return result.value || result.children || [];
}
function getDecorations({ doc, name, lowlight, defaultLanguage, }) {
    const decorations = [];
    findChildren(doc, node => node.type.name === name)
        .forEach(block => {
        let from = block.pos + 1;
        const language = block.node.attrs.language || defaultLanguage;
        const languages = lowlight.listLanguages();
        const nodes = language && languages.includes(language)
            ? getHighlightNodes(lowlight.highlight(language, block.node.textContent))
            : getHighlightNodes(lowlight.highlightAuto(block.node.textContent));
        parseNodes(nodes).forEach(node => {
            const to = from + node.text.length;
            if (node.classes.length) {
                const decoration = Decoration.inline(from, to, {
                    class: node.classes.join(' '),
                });
                decorations.push(decoration);
            }
            from = to;
        });
    });
    return DecorationSet.create(doc, decorations);
}
function LowlightPlugin({ name, lowlight, defaultLanguage }) {
    return new Plugin({
        key: new PluginKey('lowlight'),
        state: {
            init: (_, { doc }) => getDecorations({
                doc,
                name,
                lowlight,
                defaultLanguage,
            }),
            apply: (transaction, decorationSet, oldState, newState) => {
                const oldNodeName = oldState.selection.$head.parent.type.name;
                const newNodeName = newState.selection.$head.parent.type.name;
                const oldNodes = findChildren(oldState.doc, node => node.type.name === name);
                const newNodes = findChildren(newState.doc, node => node.type.name === name);
                if (transaction.docChanged
                    // Apply decorations if:
                    && (
                    // selection includes named node,
                    [oldNodeName, newNodeName].includes(name)
                        // OR transaction adds/removes named node,
                        || newNodes.length !== oldNodes.length
                        // OR transaction has changes that completely encapsulte a node
                        // (for example, a transaction that affects the entire document).
                        // Such transactions can happen during collab syncing via y-prosemirror, for example.
                        || transaction.steps.some(step => {
                            // @ts-ignore
                            return step.from !== undefined
                                // @ts-ignore
                                && step.to !== undefined
                                && oldNodes.some(node => {
                                    // @ts-ignore
                                    return node.pos >= step.from
                                        // @ts-ignore
                                        && node.pos + node.node.nodeSize <= step.to;
                                });
                        }))) {
                    return getDecorations({
                        doc: transaction.doc,
                        name,
                        lowlight,
                        defaultLanguage,
                    });
                }
                return decorationSet.map(transaction.mapping, transaction.doc);
            },
        },
        props: {
            decorations(state) {
                return this.getState(state);
            },
        },
    });
}

const CodeBlockLowlight = CodeBlock.extend({
    addOptions() {
        var _a;
        return {
            ...(_a = this.parent) === null || _a === void 0 ? void 0 : _a.call(this),
            lowlight: core$1,
            defaultLanguage: null,
        };
    },
    addProseMirrorPlugins() {
        var _a;
        return [
            ...((_a = this.parent) === null || _a === void 0 ? void 0 : _a.call(this)) || [],
            LowlightPlugin({
                name: this.name,
                lowlight: this.options.lowlight,
                defaultLanguage: this.options.defaultLanguage,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-code-block-lowlight.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-horizontal-rule/dist/tiptap-extension-horizontal-rule.esm.js



const HorizontalRule = tiptap_core_esm_Node.create({
    name: 'horizontalRule',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    parseHTML() {
        return [
            { tag: 'hr' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['hr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands() {
        return {
            setHorizontalRule: () => ({ chain }) => {
                return chain()
                    .insertContent({ type: this.name })
                    // set cursor after horizontal rule
                    .command(({ tr, dispatch }) => {
                    var _a;
                    if (dispatch) {
                        const { $to } = tr.selection;
                        const posAfter = $to.end();
                        if ($to.nodeAfter) {
                            tr.setSelection(index_es_TextSelection.create(tr.doc, $to.pos));
                        }
                        else {
                            // add node after horizontal rule if it’s the end of the document
                            const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                            if (node) {
                                tr.insert(posAfter, node);
                                tr.setSelection(index_es_TextSelection.create(tr.doc, posAfter));
                            }
                        }
                        tr.scrollIntoView();
                    }
                    return true;
                })
                    .run();
            },
        };
    },
    addInputRules() {
        return [
            nodeInputRule({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-horizontal-rule.esm.js.map

// CONCATENATED MODULE: ./src/extensions/Divider.ts








 // $grey-3-mayday

var defaultDividerColor = "#dee2e6";
var Divider_key = new PluginKey("dividerHighlighter");
var Divider = HorizontalRule.extend({
  name: "divider",
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this$parent;

    var plugins = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)) || [];
    return [].concat(_toConsumableArray(plugins), [new Plugin({
      key: Divider_key,
      state: {
        init: function init() {
          return {
            isHighlighted: false
          };
        },
        apply: function apply(tr, prev) {
          return Object.assign({}, prev, tr.getMeta(Divider_key));
        }
      },
      props: {
        decorations: function decorations(state) {
          var selection = state.selection;

          var _this$getState = this.getState(state),
              isHighlighted = _this$getState.isHighlighted;

          var isDivider = isNodeSelection(selection) && selection.node.type.name === "divider";

          if (isDivider && isHighlighted) {
            return DecorationSet.create(state.doc, [Decoration.node(selection.from, selection.to, {
              class: "highlight"
            })]);
          }

          return DecorationSet.empty;
        }
      }
    })]);
  },
  addAttributes: function addAttributes() {
    var _this$parent2;

    return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
      color: {
        default: defaultDividerColor,
        parseHTML: function parseHTML(element) {
          return element.getAttribute("data-color");
        },
        renderHTML: function renderHTML(attributes) {
          return {
            "data-color": attributes.color,
            style: "--divider-color: ".concat(attributes.color)
          };
        }
      }
    });
  },
  addCommands: function addCommands() {
    var _this$parent3;

    var highlightDivider = function highlightDivider(shouldHighlight) {
      return function (_ref) {
        var dispatch = _ref.dispatch,
            tr = _ref.tr;

        if (dispatch != null) {
          dispatch(tr.setMeta(Divider_key, {
            isHighlighted: shouldHighlight
          }));
          return true;
        }

        return false;
      };
    };

    return _objectSpread2(_objectSpread2({}, (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)), {}, {
      highlightDivider: highlightDivider
    });
  }
});
/* harmony default export */ var extensions_Divider = (Divider);
// CONCATENATED MODULE: ./node_modules/prosemirror-tables/dist/index.es.js






// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.

var readFromCache, addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap != "undefined") {
  var cache = new WeakMap;
  readFromCache = function (key) { return cache.get(key); };
  addToCache = function (key, value) {
    cache.set(key, value);
    return value
  };
} else {
  var cache$1 = [], cacheSize = 10, cachePos = 0;
  readFromCache = function (key) {
    for (var i = 0; i < cache$1.length; i += 2)
      { if (cache$1[i] == key) { return cache$1[i + 1] } }
  };
  addToCache = function (key, value) {
    if (cachePos == cacheSize) { cachePos = 0; }
    cache$1[cachePos++] = key;
    return cache$1[cachePos++] = value
  };
}

var Rect = function Rect(left, top, right, bottom) {
  this.left = left; this.top = top; this.right = right; this.bottom = bottom;
};

// ::- A table map describes the structore of a given table. To avoid
// recomputing them all the time, they are cached per table node. To
// be able to do that, positions saved in the map are relative to the
// start of the table, rather than the start of the document.
var TableMap = function TableMap(width, height, map, problems) {
  // :: number The width of the table
  this.width = width;
  // :: number The table's height
  this.height = height;
  // :: [number] A width * height array with the start position of
  // the cell covering that part of the table in each slot
  this.map = map;
  // An optional array of problems (cell overlap or non-rectangular
  // shape) for the table, used by the table normalizer.
  this.problems = problems;
};

// :: (number) → Rect
// Find the dimensions of the cell at the given position.
TableMap.prototype.findCell = function findCell (pos) {
  for (var i = 0; i < this.map.length; i++) {
    var curPos = this.map[i];
    if (curPos != pos) { continue }
    var left = i % this.width, top = (i / this.width) | 0;
    var right = left + 1, bottom = top + 1;
    for (var j = 1; right < this.width && this.map[i + j] == curPos; j++) { right++; }
    for (var j$1 = 1; bottom < this.height && this.map[i + (this.width * j$1)] == curPos; j$1++) { bottom++; }
    return new Rect(left, top, right, bottom)
  }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number) → number
// Find the left side of the cell at the given position.
TableMap.prototype.colCount = function colCount (pos) {
  for (var i = 0; i < this.map.length; i++)
    { if (this.map[i] == pos) { return i % this.width } }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number, string, number) → ?number
// Find the next cell in the given direction, starting from the cell
// at `pos`, if any.
TableMap.prototype.nextCell = function nextCell (pos, axis, dir) {
  var ref = this.findCell(pos);
    var left = ref.left;
    var right = ref.right;
    var top = ref.top;
    var bottom = ref.bottom;
  if (axis == "horiz") {
    if (dir < 0 ? left == 0 : right == this.width) { return null }
    return this.map[top * this.width + (dir < 0 ? left - 1 : right)]
  } else {
    if (dir < 0 ? top == 0 : bottom == this.height) { return null }
    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)]
  }
};

// :: (number, number) → Rect
// Get the rectangle spanning the two given cells.
TableMap.prototype.rectBetween = function rectBetween (a, b) {
  var ref = this.findCell(a);
    var leftA = ref.left;
    var rightA = ref.right;
    var topA = ref.top;
    var bottomA = ref.bottom;
  var ref$1 = this.findCell(b);
    var leftB = ref$1.left;
    var rightB = ref$1.right;
    var topB = ref$1.top;
    var bottomB = ref$1.bottom;
  return new Rect(Math.min(leftA, leftB), Math.min(topA, topB),
                  Math.max(rightA, rightB), Math.max(bottomA, bottomB))
};

// :: (Rect) → [number]
// Return the position of all cells that have the top left corner in
// the given rectangle.
TableMap.prototype.cellsInRect = function cellsInRect (rect) {
  var result = [], seen = {};
  for (var row = rect.top; row < rect.bottom; row++) {
    for (var col = rect.left; col < rect.right; col++) {
      var index = row * this.width + col, pos = this.map[index];
      if (seen[pos]) { continue }
      seen[pos] = true;
      if ((col != rect.left || !col || this.map[index - 1] != pos) &&
          (row != rect.top || !row || this.map[index - this.width] != pos))
        { result.push(pos); }
    }
  }
  return result
};

// :: (number, number, Node) → number
// Return the position at which the cell at the given row and column
// starts, or would start, if a cell started there.
TableMap.prototype.positionAt = function positionAt (row, col, table) {
  for (var i = 0, rowStart = 0;; i++) {
    var rowEnd = rowStart + table.child(i).nodeSize;
    if (i == row) {
      var index = col + row * this.width, rowEndIndex = (row + 1) * this.width;
      // Skip past cells from previous rows (via rowspan)
      while (index < rowEndIndex && this.map[index] < rowStart) { index++; }
      return index == rowEndIndex ? rowEnd - 1 : this.map[index]
    }
    rowStart = rowEnd;
  }
};

// :: (Node) → TableMap
// Find the table map for the given table node.
TableMap.get = function get (table) {
  return readFromCache(table) || addToCache(table, computeMap(table))
};

// Compute a table map.
function computeMap(table) {
  if (table.type.spec.tableRole != "table") { throw new RangeError("Not a table node: " + table.type.name) }
  var width = findWidth(table), height = table.childCount;
  var map = [], mapPos = 0, problems = null, colWidths = [];
  for (var i = 0, e = width * height; i < e; i++) { map[i] = 0; }

  for (var row = 0, pos = 0; row < height; row++) {
    var rowNode = table.child(row);
    pos++;
    for (var i$1 = 0;; i$1++) {
      while (mapPos < map.length && map[mapPos] != 0) { mapPos++; }
      if (i$1 == rowNode.childCount) { break }
      var cellNode = rowNode.child(i$1);
      var ref = cellNode.attrs;
      var colspan = ref.colspan;
      var rowspan = ref.rowspan;
      var colwidth = ref.colwidth;
      for (var h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({type: "overlong_rowspan", pos: pos, n: rowspan - h});
          break
        }
        var start = mapPos + (h * width);
        for (var w = 0; w < colspan; w++) {
          if (map[start + w] == 0)
            { map[start + w] = pos; }
          else
            { (problems || (problems = [])).push({type: "collision", row: row, pos: pos, n: colspan - w}); }
          var colW = colwidth && colwidth[w];
          if (colW) {
            var widthIndex = ((start + w) % width) * 2, prev = colWidths[widthIndex];
            if (prev == null || (prev != colW && colWidths[widthIndex + 1] == 1)) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }
      mapPos += colspan;
      pos += cellNode.nodeSize;
    }
    var expectedPos = (row + 1) * width, missing = 0;
    while (mapPos < expectedPos) { if (map[mapPos++] == 0) { missing++; } }
    if (missing) { (problems || (problems = [])).push({type: "missing", row: row, n: missing}); }
    pos++;
  }

  var tableMap = new TableMap(width, height, map, problems), badWidths = false;

  // For columns that have defined widths, but whose widths disagree
  // between rows, fix up the cells whose width doesn't match the
  // computed one.
  for (var i$2 = 0; !badWidths && i$2 < colWidths.length; i$2 += 2)
    { if (colWidths[i$2] != null && colWidths[i$2 + 1] < height) { badWidths = true; } }
  if (badWidths) { findBadColWidths(tableMap, colWidths, table); }

  return tableMap
}

function findWidth(table) {
  var width = -1, hasRowSpan = false;
  for (var row = 0; row < table.childCount; row++) {
    var rowNode = table.child(row), rowWidth = 0;
    if (hasRowSpan) { for (var j = 0; j < row; j++) {
      var prevRow = table.child(j);
      for (var i = 0; i < prevRow.childCount; i++) {
        var cell = prevRow.child(i);
        if (j + cell.attrs.rowspan > row) { rowWidth += cell.attrs.colspan; }
      }
    } }
    for (var i$1 = 0; i$1 < rowNode.childCount; i$1++) {
      var cell$1 = rowNode.child(i$1);
      rowWidth += cell$1.attrs.colspan;
      if (cell$1.attrs.rowspan > 1) { hasRowSpan = true; }
    }
    if (width == -1)
      { width = rowWidth; }
    else if (width != rowWidth)
      { width = Math.max(width, rowWidth); }
  }
  return width
}

function findBadColWidths(map, colWidths, table) {
  if (!map.problems) { map.problems = []; }
  for (var i = 0, seen = {}; i < map.map.length; i++) {
    var pos = map.map[i];
    if (seen[pos]) { continue }
    seen[pos] = true;
    var node = table.nodeAt(pos), updated = null;
    for (var j = 0; j < node.attrs.colspan; j++) {
      var col = (i + j) % map.width, colWidth = colWidths[col * 2];
      if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] != colWidth))
        { (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth; }
    }
    if (updated) { map.problems.unshift({type: "colwidth mismatch", pos: pos, colwidth: updated}); }
  }
}

function freshColWidth(attrs) {
  if (attrs.colwidth) { return attrs.colwidth.slice() }
  var result = [];
  for (var i = 0; i < attrs.colspan; i++) { result.push(0); }
  return result
}

// Helper for creating a schema that supports tables.

function getCellAttrs(dom, extraAttrs) {
  var widthAttr = dom.getAttribute("data-colwidth");
  var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function (s) { return Number(s); }) : null;
  var colspan = Number(dom.getAttribute("colspan") || 1);
  var result = {
    colspan: colspan,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };
  for (var prop in extraAttrs) {
    var getter = extraAttrs[prop].getFromDOM;
    var value = getter && getter(dom);
    if (value != null) { result[prop] = value; }
  }
  return result
}

function setCellAttrs(node, extraAttrs) {
  var attrs = {};
  if (node.attrs.colspan != 1) { attrs.colspan = node.attrs.colspan; }
  if (node.attrs.rowspan != 1) { attrs.rowspan = node.attrs.rowspan; }
  if (node.attrs.colwidth)
    { attrs["data-colwidth"] = node.attrs.colwidth.join(","); }
  for (var prop in extraAttrs) {
    var setter = extraAttrs[prop].setDOMAttr;
    if (setter) { setter(node.attrs[prop], attrs); }
  }
  return attrs
}

// :: (Object) → Object
//
// This function creates a set of [node
// specs](http://prosemirror.net/docs/ref/#model.SchemaSpec.nodes) for
// `table`, `table_row`, and `table_cell` nodes types as used by this
// module. The result can then be added to the set of nodes when
// creating a a schema.
//
//   options::- The following options are understood:
//
//     tableGroup:: ?string
//     A group name (something like `"block"`) to add to the table
//     node type.
//
//     cellContent:: string
//     The content expression for table cells.
//
//     cellAttributes:: ?Object
//     Additional attributes to add to cells. Maps attribute names to
//     objects with the following properties:
//
//       default:: any
//       The attribute's default value.
//
//       getFromDOM:: ?(dom.Node) → any
//       A function to read the attribute's value from a DOM node.
//
//       setDOMAttr:: ?(value: any, attrs: Object)
//       A function to add the attribute's value to an attribute
//       object that's used to render the cell's DOM.
function tableNodes(options) {
  var extraAttrs = options.cellAttributes || {};
  var cellAttrs = {
    colspan: {default: 1},
    rowspan: {default: 1},
    colwidth: {default: null}
  };
  for (var prop in extraAttrs)
    { cellAttrs[prop] = {default: extraAttrs[prop].default}; }

  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: true,
      group: options.tableGroup,
      parseDOM: [{tag: "table"}],
      toDOM: function toDOM() { return ["table", ["tbody", 0]] }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{tag: "tr"}],
      toDOM: function toDOM() { return ["tr", 0] }
    },
    table_cell: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "cell",
      isolating: true,
      parseDOM: [{tag: "td", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["td", setCellAttrs(node, extraAttrs), 0] }
    },
    table_header: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "header_cell",
      isolating: true,
      parseDOM: [{tag: "th", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["th", setCellAttrs(node, extraAttrs), 0] }
    }
  }
}

function tableNodeTypes(schema) {
  var result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (var name in schema.nodes) {
      var type = schema.nodes[name], role = type.spec.tableRole;
      if (role) { result[role] = type; }
    }
  }
  return result
}

// Various helper function for working with tables

var dist_index_es_key = new PluginKey("selectingCells");

function cellAround($pos) {
  for (var d = $pos.depth - 1; d > 0; d--)
    { if ($pos.node(d).type.spec.tableRole == "row") { return $pos.node(0).resolve($pos.before(d + 1)) } }
  return null
}

function cellWrapping($pos) {
  for (var d = $pos.depth; d > 0; d--) { // Sometimes the cell can be in the same depth.
    var role = $pos.node(d).type.spec.tableRole;
    if (role === "cell" || role === 'header_cell') { return $pos.node(d) }
  }
  return null
}

function isInTable(state) {
  var $head = state.selection.$head;
  for (var d = $head.depth; d > 0; d--) { if ($head.node(d).type.spec.tableRole == "row") { return true } }
  return false
}

function selectionCell(state) {
  var sel = state.selection;
  if (sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if (sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor
  }
  return cellAround(sel.$head) || cellNear(sel.$head)
}

function cellNear($pos) {
  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    var role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") { return $pos.doc.resolve(pos) }
  }
  for (var before = $pos.nodeBefore, pos$1 = $pos.pos; before; before = before.lastChild, pos$1--) {
    var role$1 = before.type.spec.tableRole;
    if (role$1 == "cell" || role$1 == "header_cell") { return $pos.doc.resolve(pos$1 - before.nodeSize) }
  }
}

function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && $pos.nodeAfter
}

function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize)
}

function inSameTable($a, $b) {
  return $a.depth == $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1)
}

function findCell($pos) {
  return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1))
}

function colCount($pos) {
  return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1))
}

function nextCell($pos, axis, dir) {
  var start = $pos.start(-1), map = TableMap.get($pos.node(-1));
  var moved = map.nextCell($pos.pos - start, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(start + moved)
}

function setAttr(attrs, name, value) {
  var result = {};
  for (var prop in attrs) { result[prop] = attrs[prop]; }
  result[name] = value;
  return result
}

function removeColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan - n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(function (w) { return w > 0; })) { result.colwidth = null; }
  }
  return result
}

function addColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan + n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    for (var i = 0; i < n; i++) { result.colwidth.splice(pos, 0, 0); }
  }
  return result
}

function columnIsHeader(map, table, col) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var row = 0; row < map.height; row++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

// This file defines a ProseMirror selection subclass that models

// ::- A [`Selection`](http://prosemirror.net/docs/ref/#state.Selection)
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.
var index_es_CellSelection = /*@__PURE__*/(function (Selection) {
  function CellSelection($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var table = $anchorCell.node(-1), map = TableMap.get(table), start = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function (p) { return p != $headCell.pos - start; });
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    var ranges = cells.map(function (pos) {
      var cell = table.nodeAt(pos), from = pos + start + 1;
      return new SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size))
    });
    Selection.call(this, ranges[0].$from, ranges[0].$to, ranges);
    // :: ResolvedPos
    // A resolved position pointing _in front of_ the anchor cell (the one
    // that doesn't move when extending the selection).
    this.$anchorCell = $anchorCell;
    // :: ResolvedPos
    // A resolved position pointing in front of the head cell (the one
    // moves when extending the selection).
    this.$headCell = $headCell;
  }

  if ( Selection ) CellSelection.__proto__ = Selection;
  CellSelection.prototype = Object.create( Selection && Selection.prototype );
  CellSelection.prototype.constructor = CellSelection;

  CellSelection.prototype.map = function map (doc, mapping) {
    var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
    var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      var tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
      if (tableChanged && this.isRowSelection())
        { return CellSelection.rowSelection($anchorCell, $headCell) }
      else if (tableChanged && this.isColSelection())
        { return CellSelection.colSelection($anchorCell, $headCell) }
      else
        { return new CellSelection($anchorCell, $headCell) }
    }
    return index_es_TextSelection.between($anchorCell, $headCell)
  };

  // :: () → Slice
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  CellSelection.prototype.content = function content () {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
    var seen = {}, rows = [];
    for (var row = rect.top; row < rect.bottom; row++) {
      var rowContent = [];
      for (var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
        var pos = map.map[index];
        if (!seen[pos]) {
          seen[pos] = true;
          var cellRect = map.findCell(pos), cell = table.nodeAt(pos);
          var extraLeft = rect.left - cellRect.left, extraRight = cellRect.right - rect.right;
          if (extraLeft > 0 || extraRight > 0) {
            var attrs = cell.attrs;
            if (extraLeft > 0) { attrs = removeColSpan(attrs, 0, extraLeft); }
            if (extraRight > 0) { attrs = removeColSpan(attrs, attrs.colspan - extraRight, extraRight); }
            if (cellRect.left < rect.left) { cell = cell.type.createAndFill(attrs); }
            else { cell = cell.type.create(attrs, cell.content); }
          }
          if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
            var attrs$1 = setAttr(cell.attrs, "rowspan", Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
            if (cellRect.top < rect.top) { cell = cell.type.createAndFill(attrs$1); }
            else { cell = cell.type.create(attrs$1, cell.content); }
          }
          rowContent.push(cell);
        }
      }
      rows.push(table.child(row).copy(Fragment.from(rowContent)));
    }

    var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
    return new Slice(Fragment.from(fragment), 1, 1)
  };

  CellSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = Slice.empty;

    var mapFrom = tr.steps.length, ranges = this.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
      tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content);
    }
    var sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
    if (sel) { tr.setSelection(sel); }
  };

  CellSelection.prototype.replaceWith = function replaceWith (tr, node) {
    this.replace(tr, new Slice(Fragment.from(node), 0, 0));
  };

  CellSelection.prototype.forEachCell = function forEachCell (f) {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
    for (var i = 0; i < cells.length; i++)
      { f(table.nodeAt(cells[i]), start + cells[i]); }
  };

  // :: () → bool
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  CellSelection.prototype.isColSelection = function isColSelection () {
    var anchorTop = this.$anchorCell.index(-1), headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) { return false }
    var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan,
        headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBot, headBot) == this.$headCell.node(-1).childCount
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  CellSelection.colSelection = function colSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.left]); }
      if (headRect.bottom < map.height)
        { $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]); }
    } else {
      if (headRect.top > 0)
        { $headCell = doc.resolve(start + map.map[headRect.left]); }
      if (anchorRect.bottom < map.height)
        { $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  // :: () → bool
  // True if this selection goes all the way from the left to the
  // right of the table.
  CellSelection.prototype.isRowSelection = function isRowSelection () {
    var map = TableMap.get(this.$anchorCell.node(-1)), start = this.$anchorCell.start(-1);
    var anchorLeft = map.colCount(this.$anchorCell.pos - start),
        headLeft = map.colCount(this.$headCell.pos - start);
    if (Math.min(anchorLeft, headLeft) > 0) { return false }
    var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan,
        headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map.width
  };

  CellSelection.prototype.eq = function eq (other) {
    return other instanceof CellSelection && other.$anchorCell.pos == this.$anchorCell.pos &&
      other.$headCell.pos == this.$headCell.pos
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  CellSelection.rowSelection = function rowSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]); }
      if (headRect.right < map.width)
        { $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]); }
    } else {
      if (headRect.left > 0)
        { $headCell = doc.resolve(start + map.map[headRect.top * map.width]); }
      if (anchorRect.right < map.width)
        { $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  CellSelection.prototype.toJSON = function toJSON () {
    return {type: "cell", anchor: this.$anchorCell.pos, head: this.$headCell.pos}
  };

  CellSelection.fromJSON = function fromJSON (doc, json) {
    return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → CellSelection
  CellSelection.create = function create (doc, anchorCell, headCell) {
    if ( headCell === void 0 ) headCell = anchorCell;

    return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell))
  };

  CellSelection.prototype.getBookmark = function getBookmark () { return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos) };

  return CellSelection;
}(index_es_Selection));

index_es_CellSelection.prototype.visible = false;

index_es_Selection.jsonID("cell", index_es_CellSelection);

var CellBookmark = function CellBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
CellBookmark.prototype.map = function map (mapping) {
  return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
CellBookmark.prototype.resolve = function resolve (doc) {
  var $anchorCell = doc.resolve(this.anchor), $headCell = doc.resolve(this.head);
  if ($anchorCell.parent.type.spec.tableRole == "row" &&
      $headCell.parent.type.spec.tableRole == "row" &&
      $anchorCell.index() < $anchorCell.parent.childCount &&
      $headCell.index() < $headCell.parent.childCount &&
      inSameTable($anchorCell, $headCell))
    { return new index_es_CellSelection($anchorCell, $headCell) }
  else
    { return index_es_Selection.near($headCell, 1) }
};

function drawCellSelection(state) {
  if (!(state.selection instanceof index_es_CellSelection)) { return null }
  var cells = [];
  state.selection.forEachCell(function (node, pos) {
    cells.push(Decoration.node(pos, pos + node.nodeSize, {class: "selectedCell"}));
  });
  return DecorationSet.create(state.doc, cells)
}

function isCellBoundarySelection(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  if ($from.pos == $to.pos || $from.pos < $from.pos - 6) { return false } // Cheap elimination
  var afterFrom = $from.pos, beforeTo = $to.pos, depth = $from.depth;
  for (; depth >= 0; depth--, afterFrom++)
    { if ($from.after(depth + 1) < $from.end(depth)) { break } }
  for (var d = $to.depth; d >= 0; d--, beforeTo--)
    { if ($to.before(d + 1) > $to.start(d)) { break } }
  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole)
}

function isTextSelectionAcrossCells(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  var fromCellBoundaryNode;
  var toCellBoundaryNode;

  for (var i = $from.depth; i > 0; i--) {
    var node = $from.node(i);
    if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
      fromCellBoundaryNode = node;
      break;
    }
  }

  for (var i$1 = $to.depth; i$1 > 0; i$1--) {
    var node$1 = $to.node(i$1);
    if (node$1.type.spec.tableRole === 'cell' || node$1.type.spec.tableRole === 'header_cell') {
      toCellBoundaryNode = node$1;
      break;
    }
  }

  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0
}

function normalizeSelection(state, tr, allowTableNodeSelection) {
  var sel = (tr || state).selection, doc = (tr || state).doc, normalize, role;
  if (sel instanceof index_es_NodeSelection && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize = index_es_CellSelection.create(doc, sel.from);
    } else if (role == "row") {
      var $cell = doc.resolve(sel.from + 1);
      normalize = index_es_CellSelection.rowSelection($cell, $cell);
    } else if (!allowTableNodeSelection) {
      var map = TableMap.get(sel.node), start = sel.from + 1;
      var lastCell = start + map.map[map.width * map.height - 1];
      normalize = index_es_CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof index_es_TextSelection && isCellBoundarySelection(sel)) {
    normalize = index_es_TextSelection.create(doc, sel.from);
  } else if (sel instanceof index_es_TextSelection && isTextSelectionAcrossCells(sel)) {
    normalize = index_es_TextSelection.create(doc, sel.$from.start(), sel.$from.end());
  }
  if (normalize)
    { (tr || (tr = state.tr)).setSelection(normalize); }
  return tr
}

// Utilities used for copy/paste handling.

// Utilities to help with copying and pasting table cells

// : (Slice) → ?{width: number, height: number, rows: [Fragment]}
// Get a rectangular area of cells from a slice, or null if the outer
// nodes of the slice aren't table cells or rows.
function pastedCells(slice) {
  if (!slice.size) { return null }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (content.childCount == 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content = content.firstChild.content;
  }
  var first = content.firstChild, role = first.type.spec.tableRole;
  var schema = first.type.schema, rows = [];
  if (role == "row") {
    for (var i = 0; i < content.childCount; i++) {
      var cells = content.child(i).content;
      var left = i ? 0 : Math.max(0, openStart - 1);
      var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right) { cells = fitSlice(tableNodeTypes(schema).row, new Slice(cells, left, right)).content; }
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(openStart || openEnd ? fitSlice(tableNodeTypes(schema).row, new Slice(content, openStart, openEnd)).content : content);
  } else {
    return null
  }
  return ensureRectangular(schema, rows)
}

// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function ensureRectangular(schema, rows) {
  var widths = [];
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    for (var j = row.childCount - 1; j >= 0; j--) {
      var ref = row.child(j).attrs;
      var rowspan = ref.rowspan;
      var colspan = ref.colspan;
      for (var r = i; r < i + rowspan; r++)
        { widths[r] = (widths[r] || 0) + colspan; }
    }
  }
  var width = 0;
  for (var r$1 = 0; r$1 < widths.length; r$1++) { width = Math.max(width, widths[r$1]); }
  for (var r$2 = 0; r$2 < widths.length; r$2++) {
    if (r$2 >= rows.length) { rows.push(Fragment.empty); }
    if (widths[r$2] < width) {
      var empty = tableNodeTypes(schema).cell.createAndFill(), cells = [];
      for (var i$1 = widths[r$2]; i$1 < width; i$1++) { cells.push(empty); }
      rows[r$2] = rows[r$2].append(Fragment.from(cells));
    }
  }
  return {height: rows.length, width: width, rows: rows}
}

function fitSlice(nodeType, slice) {
  var node = nodeType.createAndFill();
  var tr = new index_es_Transform(node).replace(0, node.content.size, slice);
  return tr.doc
}

// : ({width: number, height: number, rows: [Fragment]}, number, number) → {width: number, height: number, rows: [Fragment]}
// Clip or extend (repeat) the given set of cells to cover the given
// width and height. Will clip rowspan/colspan cells at the edges when
// they stick out.
function clipCells(ref, newWidth, newHeight) {
  var width = ref.width;
  var height = ref.height;
  var rows = ref.rows;

  if (width != newWidth) {
    var added = [], newRows = [];
    for (var row = 0; row < rows.length; row++) {
      var frag = rows[row], cells = [];
      for (var col = added[row] || 0, i = 0; col < newWidth; i++) {
        var cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth)
          { cell = cell.type.create(removeColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content); }
        cells.push(cell);
        col += cell.attrs.colspan;
        for (var j = 1; j < cell.attrs.rowspan; j++)
          { added[row + j] = (added[row + j] || 0) + cell.attrs.colspan; }
      }
      newRows.push(Fragment.from(cells));
    }
    rows = newRows;
    width = newWidth;
  }

  if (height != newHeight) {
    var newRows$1 = [];
    for (var row$1 = 0, i$1 = 0; row$1 < newHeight; row$1++, i$1++) {
      var cells$1 = [], source = rows[i$1 % height];
      for (var j$1 = 0; j$1 < source.childCount; j$1++) {
        var cell$1 = source.child(j$1);
        if (row$1 + cell$1.attrs.rowspan > newHeight)
          { cell$1 = cell$1.type.create(setAttr(cell$1.attrs, "rowspan", Math.max(1, newHeight - cell$1.attrs.rowspan)), cell$1.content); }
        cells$1.push(cell$1);
      }
      newRows$1.push(Fragment.from(cells$1));
    }
    rows = newRows$1;
    height = newHeight;
  }

  return {width: width, height: height, rows: rows}
}

// Make sure a table has at least the given width and height. Return
// true if something was changed.
function growTable(tr, map, table, start, width, height, mapFrom) {
  var schema = tr.doc.type.schema, types = tableNodeTypes(schema), empty, emptyHead;
  if (width > map.width) {
    for (var row = 0, rowEnd = 0; row < map.height; row++) {
      var rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      var cells = [], add = (void 0);
      if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell)
        { add = empty || (empty = types.cell.createAndFill()); }
      else
        { add = emptyHead || (emptyHead = types.header_cell.createAndFill()); }
      for (var i = map.width; i < width; i++) { cells.push(add); }
      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }
  if (height > map.height) {
    var cells$1 = [];
    for (var i$1 = 0, start$1 = (map.height - 1) * map.width; i$1 < Math.max(map.width, width); i$1++) {
      var header = i$1 >= map.width ? false :
          table.nodeAt(map.map[start$1 + i$1]).type == types.header_cell;
      cells$1.push(header
                 ? (emptyHead || (emptyHead = types.header_cell.createAndFill()))
                 : (empty || (empty = types.cell.createAndFill())));
    }

    var emptyRow = types.row.create(null, Fragment.from(cells$1)), rows = [];
    for (var i$2 = map.height; i$2 < height; i$2++) { rows.push(emptyRow); }
    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
  }
  return !!(empty || emptyHead)
}

// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top == 0 || top == map.height) { return false }
  var found = false;
  for (var col = left; col < right; col++) {
    var index = top * map.width + col, pos = map.map[index];
    if (map.map[index - map.width] == pos) {
      found = true;
      var cell = table.nodeAt(pos);
      var ref = map.findCell(pos);
      var cellTop = ref.top;
      var cellLeft = ref.left;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, "rowspan", top - cellTop));
      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)),
                cell.type.createAndFill(setAttr(cell.attrs, "rowspan", (cellTop + cell.attrs.rowspan) - top)));
      col += cell.attrs.colspan - 1;
    }
  }
  return found
}

// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left == 0 || left == map.width) { return false }
  var found = false;
  for (var row = top; row < bottom; row++) {
    var index = row * map.width + left, pos = map.map[index];
    if (map.map[index - 1] == pos) {
      found = true;
      var cell = table.nodeAt(pos), cellLeft = map.colCount(pos);
      var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(updatePos, null, removeColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(removeColSpan(cell.attrs, 0, left - cellLeft)));
      row += cell.attrs.rowspan - 1;
    }
  }
  return found
}

// Insert the given set of cells (as returned by `pastedCells`) into a
// table, at the position pointed at by rect.
function insertCells(state, dispatch, tableStart, rect, cells) {
  var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc, map = TableMap.get(table);
  var top = rect.top;
  var left = rect.left;
  var right = left + cells.width, bottom = top + cells.height;
  var tr = state.tr, mapFrom = 0;
  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
  }
  // Prepare the table to be large enough and not have any cells
  // crossing the boundaries of the rectangle that we want to
  // insert into. If anything about it changes, recompute the table
  // map so that subsequent operations can see the current shape.
  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) { recomp(); }

  for (var row = top; row < bottom; row++) {
    var from = map.positionAt(row, left, table), to = map.positionAt(row, right, table);
    tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart),
               new Slice(cells.rows[row - top], 0, 0));
  }
  recomp();
  tr.setSelection(new index_es_CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)),
                                    tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
  dispatch(tr);
}

// This file defines a number of helpers for wiring up user input to

var index_es_handleKeyDown = keydownHandler({
  "ArrowLeft": dist_index_es_arrow("horiz", -1),
  "ArrowRight": dist_index_es_arrow("horiz", 1),
  "ArrowUp": dist_index_es_arrow("vert", -1),
  "ArrowDown": dist_index_es_arrow("vert", 1),

  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),

  "Backspace": deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  "Delete": deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});

function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) { return false }
  if (dispatch) { dispatch(state.tr.setSelection(selection).scrollIntoView()); }
  return true
}

function dist_index_es_arrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (sel instanceof index_es_CellSelection) {
      return maybeSetSelection(state, dispatch, index_es_Selection.near(sel.$headCell, dir))
    }
    if (axis != "horiz" && !sel.empty) { return false }
    var end = atEndOfCell(view, axis, dir);
    if (end == null) { return false }
    if (axis == "horiz") {
      return maybeSetSelection(state, dispatch, index_es_Selection.near(state.doc.resolve(sel.head + dir), dir))
    } else {
      var $cell = state.doc.resolve(end), $next = nextCell($cell, axis, dir), newSel;
      if ($next) { newSel = index_es_Selection.near($next, 1); }
      else if (dir < 0) { newSel = index_es_Selection.near(state.doc.resolve($cell.before(-1)), -1); }
      else { newSel = index_es_Selection.near(state.doc.resolve($cell.after(-1)), 1); }
      return maybeSetSelection(state, dispatch, newSel)
    }
  }
}

function shiftArrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (!(sel instanceof index_es_CellSelection)) {
      var end = atEndOfCell(view, axis, dir);
      if (end == null) { return false }
      sel = new index_es_CellSelection(state.doc.resolve(end));
    }
    var $head = nextCell(sel.$headCell, axis, dir);
    if (!$head) { return false }
    return maybeSetSelection(state, dispatch, new index_es_CellSelection(sel.$anchorCell, $head))
  }
}

function deleteCellSelection(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof index_es_CellSelection)) { return false }
  if (dispatch) {
    var tr = state.tr, baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell(function (cell, pos) {
      if (!cell.content.eq(baseContent))
        { tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1),
                   new Slice(baseContent, 0, 0)); }
    });
    if (tr.docChanged) { dispatch(tr); }
  }
  return true
}

function index_es_handleTripleClick(view, pos) {
  var doc = view.state.doc, $cell = cellAround(doc.resolve(pos));
  if (!$cell) { return false }
  view.dispatch(view.state.tr.setSelection(new index_es_CellSelection($cell)));
  return true
}

function handlePaste(view, _, slice) {
  if (!isInTable(view.state)) { return false }
  var cells = pastedCells(slice), sel = view.state.selection;
  if (sel instanceof index_es_CellSelection) {
    if (!cells) { cells = {width: 1, height: 1, rows: [Fragment.from(fitSlice(tableNodeTypes(view.state.schema).cell, slice))]}; }
    var table = sel.$anchorCell.node(-1), start = sel.$anchorCell.start(-1);
    var rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells);
    return true
  } else if (cells) {
    var $cell = selectionCell(view.state), start$1 = $cell.start(-1);
    insertCells(view.state, view.dispatch, start$1, TableMap.get($cell.node(-1)).findCell($cell.pos - start$1), cells);
    return true
  } else {
    return false
  }
}

function handleMouseDown(view, startEvent) {
  if (startEvent.ctrlKey || startEvent.metaKey) { return }

  var startDOMCell = domInCell(view, startEvent.target), $anchor;
  if (startEvent.shiftKey && (view.state.selection instanceof index_es_CellSelection)) {
    // Adding to an existing cell selection
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell &&
             ($anchor = cellAround(view.state.selection.$anchor)) != null &&
             cellUnderMouse(view, startEvent).pos != $anchor.pos) {
    // Adding to a selection that starts in another cell (causing a
    // cell selection to be created).
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    // Not in a cell, let the default behavior happen.
    return
  }

  // Create and dispatch a cell selection between the given anchor and
  // the position under the mouse.
  function setCellSelection($anchor, event) {
    var $head = cellUnderMouse(view, event);
    var starting = dist_index_es_key.getState(view.state) == null;
    if (!$head || !inSameTable($anchor, $head)) {
      if (starting) { $head = $anchor; }
      else { return }
    }
    var selection = new index_es_CellSelection($anchor, $head);
    if (starting || !view.state.selection.eq(selection)) {
      var tr = view.state.tr.setSelection(selection);
      if (starting) { tr.setMeta(dist_index_es_key, $anchor.pos); }
      view.dispatch(tr);
    }
  }

  // Stop listening to mouse motion events.
  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move);
    if (dist_index_es_key.getState(view.state) != null) { view.dispatch(view.state.tr.setMeta(dist_index_es_key, -1)); }
  }

  function move(event) {
    var anchor = dist_index_es_key.getState(view.state), $anchor;
    if (anchor != null) {
      // Continuing an existing cross-cell selection
      $anchor = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      // Moving out of the initial cell -- start a new cell selection
      $anchor = cellUnderMouse(view, startEvent);
      if (!$anchor) { return stop() }
    }
    if ($anchor) { setCellSelection($anchor, event); }
  }
  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move);
}

// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof index_es_TextSelection)) { return null }
  var ref = view.state.selection;
  var $head = ref.$head;
  for (var d = $head.depth - 1; d >= 0; d--) {
    var parent = $head.node(d), index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) { return null }
    if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
      var cellPos = $head.before(d);
      var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
      return view.endOfTextblock(dirStr) ? cellPos : null
    }
  }
  return null
}

function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode)
    { if (dom.nodeName == "TD" || dom.nodeName == "TH") { return dom } }
}

function cellUnderMouse(view, event) {
  var mousePos = view.posAtCoords({left: event.clientX, top: event.clientY});
  if (!mousePos) { return null }
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null
}

// This file defines helpers for normalizing tables, making sure no

var fixTablesKey = new PluginKey("fix-tables");

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function changedDescendants(old, cur, offset, f) {
  var oldSize = old.childCount, curSize = cur.childCount;
  outer: for (var i = 0, j = 0; i < curSize; i++) {
    var child = cur.child(i);
    for (var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer
      }
    }
    f(child, offset);
    if (j < oldSize && old.child(j).sameMarkup(child))
      { changedDescendants(old.child(j), child, offset + 1, f); }
    else
      { child.nodesBetween(0, child.content.size, f, offset + 1); }
    offset += child.nodeSize;
  }
}

// :: (EditorState, ?EditorState) → ?Transaction
// Inspect all tables in the given state's document and return a
// transaction that fixes them, if necessary. If `oldState` was
// provided, that is assumed to hold a previous, known-good state,
// which will be used to avoid re-scanning unchanged parts of the
// document.
function fixTables(state, oldState) {
  var tr, check = function (node, pos) {
    if (node.type.spec.tableRole == "table") { tr = fixTable(state, node, pos, tr); }
  };
  if (!oldState) { state.doc.descendants(check); }
  else if (oldState.doc != state.doc) { changedDescendants(oldState.doc, state.doc, 0, check); }
  return tr
}

// : (EditorState, Node, number, ?Transaction) → ?Transaction
// Fix the given table, if necessary. Will append to the transaction
// it was given, if non-null, or create a new one if necessary.
function fixTable(state, table, tablePos, tr) {
  var map = TableMap.get(table);
  if (!map.problems) { return tr }
  if (!tr) { tr = state.tr; }

  // Track which rows we must add cells to, so that we can adjust that
  // when fixing collisions.
  var mustAdd = [];
  for (var i = 0; i < map.height; i++) { mustAdd.push(0); }
  for (var i$1 = 0; i$1 < map.problems.length; i$1++) {
    var prob = map.problems[i$1];
    if (prob.type == "collision") {
      var cell = table.nodeAt(prob.pos);
      for (var j = 0; j < cell.attrs.rowspan; j++) { mustAdd[prob.row + j] += prob.n; }
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, removeColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      var cell$1 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$1.attrs, "rowspan", cell$1.attrs.rowspan - prob.n));
    } else if (prob.type == "colwidth mismatch") {
      var cell$2 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$2.attrs, "colwidth", prob.colwidth));
    }
  }
  var first, last;
  for (var i$2 = 0; i$2 < mustAdd.length; i$2++) { if (mustAdd[i$2]) {
    if (first == null) { first = i$2; }
    last = i$2;
  } }
  // Add the necessary cells, using a heuristic for whether to add the
  // cells at the start or end of the rows (if it looks like a 'bite'
  // was taken out of the table, add cells at the start of the row
  // after the bite. Otherwise add them at the end).
  for (var i$3 = 0, pos = tablePos + 1; i$3 < map.height; i$3++) {
    var row = table.child(i$3);
    var end = pos + row.nodeSize;
    var add = mustAdd[i$3];
    if (add > 0) {
      var tableNodeType = 'cell';
      if (row.firstChild) {
        tableNodeType = row.firstChild.type.spec.tableRole;
      }
      var nodes = [];
      for (var j$1 = 0; j$1 < add; j$1++)
        { nodes.push(tableNodeTypes(state.schema)[tableNodeType].createAndFill()); }
      var side = (i$3 == 0 || first == i$3 - 1) && last == i$3 ? pos + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }
    pos = end;
  }
  return tr.setMeta(fixTablesKey, { fixTables: true })
}

// This file defines a number of table-related commands.

// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
function selectedRect(state) {
  var sel = state.selection, $pos = selectionCell(state);
  var table = $pos.node(-1), tableStart = $pos.start(-1), map = TableMap.get(table);
  var rect;
  if (sel instanceof index_es_CellSelection)
    { rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart); }
  else
    { rect = map.findCell($pos.pos - tableStart); }
  rect.tableStart = tableStart;
  rect.map = map;
  rect.table = table;
  return rect
}

// Add a column at the given position in a table.
function addColumn(tr, ref, col) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map, table, col + refColumn))
    { refColumn = col == 0 || col == map.width ? null : 0; }

  for (var row = 0; row < map.height; row++) {
    var index = row * map.width + col;
    // If this position falls inside a col-spanning cell
    if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
      var pos = map.map[index], cell = table.nodeAt(pos);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null,
                       addColSpan(cell.attrs, col - map.colCount(pos)));
      // Skip ahead if rowspan > 1
      row += cell.attrs.rowspan - 1;
    } else {
      var type = refColumn == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refColumn]).type;
      var pos$1 = map.positionAt(row, col, table);
      tr.insert(tr.mapping.map(tableStart + pos$1), type.createAndFill());
    }
  }
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column before the column with the selection.
function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column after the column with the selection.
function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }
  return true
}

function removeColumn(tr, ref, col) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var mapStart = tr.mapping.maps.length;
  for (var row = 0; row < map.height;) {
    var index = row * map.width + col, pos = map.map[index], cell = table.nodeAt(pos);
    // If this is part of a col-spanning cell
    if ((col > 0 && map.map[index - 1] == pos) || (col < map.width - 1 && map.map[index + 1] == pos)) {
      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null,
                       removeColSpan(cell.attrs, col - map.colCount(pos)));
    } else {
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }
    row += cell.attrs.rowspan;
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command function that removes the selected columns from a table.
function deleteColumn(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) { return false }
    for (var i = rect.right - 1;; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function rowIsHeader(map, table, row) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var col = 0; col < map.width; col++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

function addRow(tr, ref, row) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var rowPos = tableStart;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var cells = [], refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map, table, row + refRow))
    { refRow = row == 0 || row == map.height ? null : 0; }
  for (var col = 0, index = map.width * row; col < map.width; col++, index++) {
    // Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] == map.map[index - map.width]) {
      var pos = map.map[index], attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, "rowspan", attrs.rowspan + 1));
      col += attrs.colspan - 1;
    } else {
      var type = refRow == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refRow * map.width]).type;
      cells.push(type.createAndFill());
    }
  }
  tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row before the selection.
function addRowBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row after the selection.
function addRowAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }
  return true
}

function removeRow(tr, ref, row) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var rowPos = 0;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var nextRow = rowPos + table.child(row).nodeSize;

  var mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);

  for (var col = 0, index = row * map.width; col < map.width; col++, index++) {
    var pos = map.map[index];
    if (row > 0 && pos == map.map[index - map.width]) {
      // If this cell starts in the row above, simply reduce its rowspan
      var attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, "rowspan", attrs.rowspan - 1));
      col += attrs.colspan - 1;
    } else if (row < map.width && pos == map.map[index + map.width]) {
      // Else, if it continues in the row below, it has to be moved down
      var cell = table.nodeAt(pos);
      var copy = cell.type.create(setAttr(cell.attrs, "rowspan", cell.attrs.rowspan - 1), cell.content);
      var newPos = map.positionAt(row + 1, col, table);
      tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
      col += cell.attrs.colspan - 1;
    }
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Remove the selected rows from a table.
function deleteRow(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) { return false }
    for (var i = rect.bottom - 1;; i--) {
      removeRow(tr, rect, i);
      if (i == rect.top) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function index_es_isEmpty(cell) {
  var c = cell.content;
  return c.childCount == 1 && c.firstChild.isTextblock && c.firstChild.childCount == 0
}

function cellsOverlapRectangle(ref, rect) {
  var width = ref.width;
  var height = ref.height;
  var map = ref.map;

  var indexTop = rect.top * width + rect.left, indexLeft = indexTop;
  var indexBottom = (rect.bottom - 1) * width + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
  for (var i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] ||
        rect.right < width && map[indexRight] == map[indexRight + 1]) { return true }
    indexLeft += width; indexRight += width;
  }
  for (var i$1 = rect.left; i$1 < rect.right; i$1++) {
    if (rect.top > 0 && map[indexTop] == map[indexTop - width] ||
        rect.bottom < height && map[indexBottom] == map[indexBottom + width]) { return true }
    indexTop++; indexBottom++;
  }
  return false
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Merge the selected cells into a single cell. Only available when
// the selected cells' outline forms a rectangle.
function mergeCells(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof index_es_CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos) { return false }
  var rect = selectedRect(state);
  var map = rect.map;
  if (cellsOverlapRectangle(map, rect)) { return false }
  if (dispatch) {
    var tr = state.tr, seen = {}, content = Fragment.empty, mergedPos, mergedCell;
    for (var row = rect.top; row < rect.bottom; row++) {
      for (var col = rect.left; col < rect.right; col++) {
        var cellPos = map.map[row * map.width + col], cell = rect.table.nodeAt(cellPos);
        if (seen[cellPos]) { continue }
        seen[cellPos] = true;
        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!index_es_isEmpty(cell)) { content = content.append(cell.content); }
          var mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }
    tr.setNodeMarkup(mergedPos + rect.tableStart, null,
                     setAttr(addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, (rect.right - rect.left) - mergedCell.attrs.colspan),
                             "rowspan", rect.bottom - rect.top));
    if (content.size) {
      var end = mergedPos + 1 + mergedCell.content.size;
      var start = index_es_isEmpty(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }
    tr.setSelection(new index_es_CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
    dispatch(tr);
  }
  return true
}
// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells. Use the first cell type for the new cells.
function splitCell(state, dispatch) {
  var nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(function (ref) {
    var node = ref.node;

    return nodeTypes[node.type.spec.tableRole]
  })(state, dispatch)
}

// :: (getCellType: ({ row: number, col: number, node: Node}) → NodeType) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells with the cell type (th, td) returned by getType function.
function splitCellWithType(getCellType) {
  return function (state, dispatch) {
    var sel = state.selection;
    var cellNode, cellPos;
    if (!(sel instanceof index_es_CellSelection)) {
      cellNode = cellWrapping(sel.$from);
      if (!cellNode) { return false }
      cellPos = cellAround(sel.$from).pos;
    } else {
      if (sel.$anchorCell.pos != sel.$headCell.pos) { return false }
      cellNode = sel.$anchorCell.nodeAfter;
      cellPos = sel.$anchorCell.pos;
    }
    if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {return false}
    if (dispatch) {
      var baseAttrs = cellNode.attrs, attrs = [], colwidth = baseAttrs.colwidth;
      if (baseAttrs.rowspan > 1) { baseAttrs = setAttr(baseAttrs, "rowspan", 1); }
      if (baseAttrs.colspan > 1) { baseAttrs = setAttr(baseAttrs, "colspan", 1); }
      var rect = selectedRect(state), tr = state.tr;
      for (var i = 0; i < rect.right - rect.left; i++)
        { attrs.push(colwidth ? setAttr(baseAttrs, "colwidth", colwidth && colwidth[i] ? [colwidth[i]] : null) : baseAttrs); }
      var lastCell;
      for (var row = rect.top; row < rect.bottom; row++) {
        var pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) { pos += cellNode.nodeSize; }
        for (var col = rect.left, i$1 = 0; col < rect.right; col++, i$1++) {
          if (col == rect.left && row == rect.top) { continue }
          tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), getCellType({ node: cellNode, row: row, col: col}).createAndFill(attrs[i$1]));
        }
      }
      tr.setNodeMarkup(cellPos, getCellType({ node: cellNode, row: rect.top, col: rect.left}), attrs[0]);
      if (sel instanceof index_es_CellSelection)
        { tr.setSelection(new index_es_CellSelection(tr.doc.resolve(sel.$anchorCell.pos),
                                          lastCell && tr.doc.resolve(lastCell))); }
      dispatch(tr);
    }
    return true
  }
}

// :: (string, any) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that sets the given attribute to the given value,
// and is only available when the currently selected cell doesn't
// already have that attribute set to that value.
function setCellAttr(name, value) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name] === value) { return false }
    if (dispatch) {
      var tr = state.tr;
      if (state.selection instanceof index_es_CellSelection)
        { state.selection.forEachCell(function (node, pos) {
          if (node.attrs[name] !== value)
            { tr.setNodeMarkup(pos, null, setAttr(node.attrs, name, value)); }
        }); }
      else
        { tr.setNodeMarkup($cell.pos, null, setAttr($cell.nodeAfter.attrs, name, value)); }
      dispatch(tr);
    }
    return true
  }
}

function deprecated_toggleHeader(type) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state), tr = state.tr;
      var cells = rect.map.cellsInRect(type == "column" ? new Rect(rect.left, 0, rect.right, rect.map.height) :
                                       type == "row" ? new Rect(0, rect.top, rect.map.width, rect.bottom) : rect);
      var nodes = cells.map(function (pos) { return rect.table.nodeAt(pos); });
      for (var i = 0; i < cells.length; i++) // Remove headers, if any
        { if (nodes[i].type == types.header_cell)
          { tr.setNodeMarkup(rect.tableStart + cells[i], types.cell, nodes[i].attrs); } }
      if (tr.steps.length == 0) { for (var i$1 = 0; i$1 < cells.length; i$1++) // No headers removed, add instead
        { tr.setNodeMarkup(rect.tableStart + cells[i$1], types.header_cell, nodes[i$1].attrs); } }
      dispatch(tr);
    }
    return true
  }
}

function isHeaderEnabledByType(type, rect, types) {
  // Get cell positions for first row or first column
  var cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1,
  });

  for (var i = 0; i < cellPositions.length; i++) {
    var cell = rect.table.nodeAt(cellPositions[i]);
    if (cell && cell.type !== types.header_cell) {
      return false
    }
  }

  return true
}

// :: (string, ?{ useDeprecatedLogic: bool }) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles between row/column header and normal cells (Only applies to first row/column).
// For deprecated behavior pass `useDeprecatedLogic` in options with true.
function toggleHeader(type, options) {
  options = options || { useDeprecatedLogic: false };

  if (options.useDeprecatedLogic)
    { return deprecated_toggleHeader(type) }

  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state), tr = state.tr;

      var isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types);
      var isHeaderColumnEnabled = isHeaderEnabledByType("column", rect, types);

      var isHeaderEnabled = type === "column" ? isHeaderRowEnabled :
                            type === "row"    ? isHeaderColumnEnabled : false;

      var selectionStartsAt = isHeaderEnabled ? 1 : 0;

      var cellsRect = type == "column" ? new Rect(0, selectionStartsAt, 1, rect.map.height) :
                      type == "row" ? new Rect(selectionStartsAt, 0, rect.map.width, 1) : rect;

      var newType = type == "column" ? isHeaderColumnEnabled ? types.cell : types.header_cell :
                    type == "row" ? isHeaderRowEnabled ? types.cell : types.header_cell : types.cell;

      rect.map.cellsInRect(cellsRect).forEach(function (relativeCellPos) {
        var cellPos = relativeCellPos + rect.tableStart;
        var cell = tr.doc.nodeAt(cellPos);

        if (cell) {
          tr.setNodeMarkup(cellPos, newType, cell.attrs);
        }
      });

      dispatch(tr);
    }
    return true
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected row contains header cells.
var toggleHeaderRow = toggleHeader("row", { useDeprecatedLogic: true });

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected column contains header cells.
var toggleHeaderColumn = toggleHeader("column", { useDeprecatedLogic: true });

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected cells are header cells.
var toggleHeaderCell = toggleHeader("cell", { useDeprecatedLogic: true });

function findNextCell($cell, dir) {
  if (dir < 0) {
    var before = $cell.nodeBefore;
    if (before) { return $cell.pos - before.nodeSize }
    for (var row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      var rowNode = $cell.node(-1).child(row);
      if (rowNode.childCount) { return rowEnd - 1 - rowNode.lastChild.nodeSize }
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) { return $cell.pos + $cell.nodeAfter.nodeSize }
    var table = $cell.node(-1);
    for (var row$1 = $cell.indexAfter(-1), rowStart = $cell.after(); row$1 < table.childCount; row$1++) {
      var rowNode$1 = table.child(row$1);
      if (rowNode$1.childCount) { return rowStart + 1 }
      rowStart += rowNode$1.nodeSize;
    }
  }
}

// :: (number) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command for selecting the next (direction=1) or previous
// (direction=-1) cell in a table.
function goToNextCell(direction) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var cell = findNextCell(selectionCell(state), direction);
    if (cell == null) { return }
    if (dispatch) {
      var $cell = state.doc.resolve(cell);
      dispatch(state.tr.setSelection(index_es_TextSelection.between($cell, moveCellForward($cell))).scrollIntoView());
    }
    return true
  }
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Deletes the table around the selection, if any.
function deleteTable(state, dispatch) {
  var $pos = state.selection.$anchor;
  for (var d = $pos.depth; d > 0; d--) {
    var node = $pos.node(d);
    if (node.type.spec.tableRole == "table") {
      if (dispatch) { dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView()); }
      return true
    }
  }
  return false
}

var TableView = function TableView(node, cellMinWidth) {
  this.node = node;
  this.cellMinWidth = cellMinWidth;
  this.dom = document.createElement("div");
  this.dom.className = "tableWrapper";
  this.table = this.dom.appendChild(document.createElement("table"));
  this.colgroup = this.table.appendChild(document.createElement("colgroup"));
  updateColumns(node, this.colgroup, this.table, cellMinWidth);
  this.contentDOM = this.table.appendChild(document.createElement("tbody"));
};

TableView.prototype.update = function update (node) {
  if (node.type != this.node.type) { return false }
  this.node = node;
  updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
  return true
};

TableView.prototype.ignoreMutation = function ignoreMutation (record) {
  return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target))
};

function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
  var totalWidth = 0, fixedWidth = true;
  var nextDOM = colgroup.firstChild, row = node.firstChild;
  for (var i = 0, col = 0; i < row.childCount; i++) {
    var ref = row.child(i).attrs;
    var colspan = ref.colspan;
    var colwidth = ref.colwidth;
    for (var j = 0; j < colspan; j++, col++) {
      var hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
      var cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || cellMinWidth;
      if (!hasWidth) { fixedWidth = false; }
      if (!nextDOM) {
        colgroup.appendChild(document.createElement("col")).style.width = cssWidth;
      } else {
        if (nextDOM.style.width != cssWidth) { nextDOM.style.width = cssWidth; }
        nextDOM = nextDOM.nextSibling;
      }
    }
  }

  while (nextDOM) {
    var after = nextDOM.nextSibling;
    nextDOM.parentNode.removeChild(nextDOM);
    nextDOM = after;
  }

  if (fixedWidth) {
    table.style.width = totalWidth + "px";
    table.style.minWidth = "";
  } else {
    table.style.width = "";
    table.style.minWidth = totalWidth + "px";
  }
}

var key$1 = new PluginKey("tableColumnResizing");

function columnResizing(ref) {
  if ( ref === void 0 ) ref = {};
  var handleWidth = ref.handleWidth; if ( handleWidth === void 0 ) handleWidth = 5;
  var cellMinWidth = ref.cellMinWidth; if ( cellMinWidth === void 0 ) cellMinWidth = 25;
  var View = ref.View; if ( View === void 0 ) View = TableView;
  var lastColumnResizable = ref.lastColumnResizable; if ( lastColumnResizable === void 0 ) lastColumnResizable = true;

  var plugin = new Plugin({
    key: key$1,
    state: {
      init: function init(_, state) {
        this.spec.props.nodeViews[tableNodeTypes(state.schema).table.name] =
          function (node, view) { return new View(node, cellMinWidth, view); };
        return new ResizeState(-1, false)
      },
      apply: function apply(tr, prev) {
        return prev.apply(tr)
      }
    },
    props: {
      attributes: function attributes(state) {
        var pluginState = key$1.getState(state);
        return pluginState.activeHandle > -1 ? {class: "resize-cursor"} : null
      },

      handleDOMEvents: {
        mousemove: function mousemove(view, event) { handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable); },
        mouseleave: function mouseleave(view) { handleMouseLeave(view); },
        mousedown: function mousedown(view, event) { handleMouseDown$1(view, event, cellMinWidth); }
      },

      decorations: function decorations(state) {
        var pluginState = key$1.getState(state);
        if (pluginState.activeHandle > -1) { return handleDecorations(state, pluginState.activeHandle) }
      },

      nodeViews: {}
    }
  });
  return plugin
}

var ResizeState = function ResizeState(activeHandle, dragging) {
  this.activeHandle = activeHandle;
  this.dragging = dragging;
};

ResizeState.prototype.apply = function apply (tr) {
  var state = this, action = tr.getMeta(key$1);
  if (action && action.setHandle != null)
    { return new ResizeState(action.setHandle, null) }
  if (action && action.setDragging !== undefined)
    { return new ResizeState(state.activeHandle, action.setDragging) }
  if (state.activeHandle > -1 && tr.docChanged) {
    var handle = tr.mapping.map(state.activeHandle, -1);
    if (!pointsAtCell(tr.doc.resolve(handle))) { handle = null; }
    state = new ResizeState(handle, state.dragging);
  }
  return state
};

function handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable) {
  var pluginState = key$1.getState(view.state);

  if (!pluginState.dragging) {
    var target = domCellAround(event.target), cell = -1;
    if (target) {
      var ref = target.getBoundingClientRect();
      var left = ref.left;
      var right = ref.right;
      if (event.clientX - left <= handleWidth)
        { cell = edgeCell(view, event, "left"); }
      else if (right - event.clientX <= handleWidth)
        { cell = edgeCell(view, event, "right"); }
    }

    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        var $cell = view.state.doc.resolve(cell);
        var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
        var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;

        if (col == map.width - 1) {
          return
        }
      }

      updateHandle(view, cell);
    }
  }
}

function handleMouseLeave(view) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle > -1 && !pluginState.dragging) { updateHandle(view, -1); }
}

function handleMouseDown$1(view, event, cellMinWidth) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle == -1 || pluginState.dragging) { return false }

  var cell = view.state.doc.nodeAt(pluginState.activeHandle);
  var width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(view.state.tr.setMeta(key$1, {setDragging: {startX: event.clientX, startWidth: width}}));

  function finish(event) {
    window.removeEventListener("mouseup", finish);
    window.removeEventListener("mousemove", move);
    var pluginState = key$1.getState(view.state);
    if (pluginState.dragging) {
      updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth));
      view.dispatch(view.state.tr.setMeta(key$1, {setDragging: null}));
    }
  }
  function move(event) {
    if (!event.which) { return finish(event) }
    var pluginState = key$1.getState(view.state);
    var dragged = draggedWidth(pluginState.dragging, event, cellMinWidth);
    displayColumnWidth(view, pluginState.activeHandle, dragged, cellMinWidth);
  }

  window.addEventListener("mouseup", finish);
  window.addEventListener("mousemove", move);
  event.preventDefault();
  return true
}

function currentColWidth(view, cellPos, ref) {
  var colspan = ref.colspan;
  var colwidth = ref.colwidth;

  var width = colwidth && colwidth[colwidth.length - 1];
  if (width) { return width }
  var dom = view.domAtPos(cellPos);
  var node = dom.node.childNodes[dom.offset];
  var domWidth = node.offsetWidth, parts = colspan;
  if (colwidth) { for (var i = 0; i < colspan; i++) { if (colwidth[i]) {
    domWidth -= colwidth[i];
    parts--;
  } } }
  return domWidth / parts
}

function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH")
    { target = target.classList.contains("ProseMirror") ? null : target.parentNode; }
  return target
}

function edgeCell(view, event, side) {
  var found = view.posAtCoords({left: event.clientX, top: event.clientY});
  if (!found) { return -1 }
  var pos = found.pos;
  var $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) { return -1 }
  if (side == "right") { return $cell.pos }
  var map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
  var index = map.map.indexOf($cell.pos - start);
  return index % map.width == 0 ? -1 : start + map.map[index - 1]
}

function draggedWidth(dragging, event, cellMinWidth) {
  var offset = event.clientX - dragging.startX;
  return Math.max(cellMinWidth, dragging.startWidth + offset)
}

function updateHandle(view, value) {
  view.dispatch(view.state.tr.setMeta(key$1, {setHandle: value}));
}

function updateColumnWidth(view, cell, width) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var tr = view.state.tr;
  for (var row = 0; row < map.height; row++) {
    var mapIndex = row * map.width + col;
    // Rowspanning cell that has already been handled
    if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) { continue }
    var pos = map.map[mapIndex];
    var ref = table.nodeAt(pos);
    var attrs = ref.attrs;
    var index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] == width) { continue }
    var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, setAttr(attrs, "colwidth", colwidth));
  }
  if (tr.docChanged) { view.dispatch(tr); }
}

function displayColumnWidth(view, cell, width, cellMinWidth) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), start = $cell.start(-1);
  var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var dom = view.domAtPos($cell.start(-1)).node;
  while (dom.nodeName != "TABLE") { dom = dom.parentNode; }
  updateColumns(table, dom.firstChild, dom, cellMinWidth, col, width);
}

function zeroes(n) {
  var result = [];
  for (var i = 0; i < n; i++) { result.push(0); }
  return result
}

function handleDecorations(state, cell) {
  var decorations = [];
  var $cell = state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
  for (var row = 0; row < map.height; row++) {
    var index = col + row * map.width - 1;
    // For positions that are have either a different cell or the end
    // of the table to their right, and either the top of the table or
    // a different cell above them, add a decoration
    if ((col == map.width || map.map[index] != map.map[index + 1]) &&
        (row == 0 || map.map[index - 1] != map.map[index - 1 - map.width])) {
      var cellPos = map.map[index];
      var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      var dom = document.createElement("div");
      dom.className = "column-resize-handle";
      decorations.push(Decoration.widget(pos, dom));
    }
  }
  return DecorationSet.create(state.doc, decorations)
}

// This file defines a plugin that handles the drawing of cell

// :: () → Plugin
//
// Creates a [plugin](http://prosemirror.net/docs/ref/#state.Plugin)
// that, when added to an editor, enables cell-selection, handles
// cell-based copy/paste, and makes sure tables stay well-formed (each
// row has the same width, and cells don't overlap).
//
// You should probably put this plugin near the end of your array of
// plugins, since it handles mouse and arrow key events in tables
// rather broadly, and other plugins, like the gap cursor or the
// column-width dragging plugin, might want to get a turn first to
// perform more specific behavior.
function tableEditing(ref) {
  if ( ref === void 0 ) ref = {};
  var allowTableNodeSelection = ref.allowTableNodeSelection; if ( allowTableNodeSelection === void 0 ) allowTableNodeSelection = false;

  return new Plugin({
    key: dist_index_es_key,

    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init: function init() { return null },
      apply: function apply(tr, cur) {
        var set = tr.getMeta(dist_index_es_key);
        if (set != null) { return set == -1 ? null : set }
        if (cur == null || !tr.docChanged) { return cur }
        var ref = tr.mapping.mapResult(cur);
        var deleted = ref.deleted;
        var pos = ref.pos;
        return deleted ? null : pos
      }
    },

    props: {
      decorations: drawCellSelection,

      handleDOMEvents: {
        mousedown: handleMouseDown
      },

      createSelectionBetween: function createSelectionBetween(view) {
        if (dist_index_es_key.getState(view.state) != null) { return view.state.selection }
      },

      handleTripleClick: index_es_handleTripleClick,

      handleKeyDown: index_es_handleKeyDown,

      handlePaste: handlePaste
    },

    appendTransaction: function appendTransaction(_, oldState, state) {
      return normalizeSelection(state, fixTables(state, oldState), allowTableNodeSelection)
    }
  })
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-table/dist/tiptap-extension-table.esm.js



function tiptap_extension_table_esm_findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = tiptap_extension_table_esm_findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function tiptap_extension_table_esm_findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = tiptap_extension_table_esm_findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var tiptap_extension_table_esm_Fragment = function Fragment(content, size) {
  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this.size += content[i].nodeSize; } }
};

var tiptap_extension_table_esm_prototypeAccessors$3 = { firstChild: { configurable: true },lastChild: { configurable: true },childCount: { configurable: true } };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
tiptap_extension_table_esm_Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
tiptap_extension_table_esm_Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// :: (number, number, ?string, ?union<string, (leafNode: Node) → string>) → string
// Extract the text between `from` and `to`. See the same method on
// [`Node`](#model.Node.textBetween).
tiptap_extension_table_esm_Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += typeof leafText === 'function' ? leafText(node): leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
tiptap_extension_table_esm_Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new tiptap_extension_table_esm_Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
tiptap_extension_table_esm_Fragment.prototype.cut = function cut (from, to) {
  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new tiptap_extension_table_esm_Fragment(result, size)
};

tiptap_extension_table_esm_Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return tiptap_extension_table_esm_Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new tiptap_extension_table_esm_Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
tiptap_extension_table_esm_Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new tiptap_extension_table_esm_Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
tiptap_extension_table_esm_Fragment.prototype.addToStart = function addToStart (node) {
  return new tiptap_extension_table_esm_Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
tiptap_extension_table_esm_Fragment.prototype.addToEnd = function addToEnd (node) {
  return new tiptap_extension_table_esm_Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
tiptap_extension_table_esm_Fragment.prototype.eq = function eq (other) {
  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
tiptap_extension_table_esm_prototypeAccessors$3.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
tiptap_extension_table_esm_prototypeAccessors$3.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
tiptap_extension_table_esm_prototypeAccessors$3.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
tiptap_extension_table_esm_Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
tiptap_extension_table_esm_Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
tiptap_extension_table_esm_Fragment.prototype.forEach = function forEach (f) {
  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
tiptap_extension_table_esm_Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return tiptap_extension_table_esm_findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
tiptap_extension_table_esm_Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return tiptap_extension_table_esm_findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
tiptap_extension_table_esm_Fragment.prototype.findIndex = function findIndex (pos, round) {
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return tiptap_extension_table_esm_retIndex(0, pos) }
  if (pos == this.size) { return tiptap_extension_table_esm_retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return tiptap_extension_table_esm_retIndex(i + 1, end) }
      return tiptap_extension_table_esm_retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
tiptap_extension_table_esm_Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

tiptap_extension_table_esm_Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
tiptap_extension_table_esm_Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
tiptap_extension_table_esm_Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return tiptap_extension_table_esm_Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new tiptap_extension_table_esm_Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
tiptap_extension_table_esm_Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return tiptap_extension_table_esm_Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new tiptap_extension_table_esm_Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
tiptap_extension_table_esm_Fragment.from = function from (nodes) {
  if (!nodes) { return tiptap_extension_table_esm_Fragment.empty }
  if (nodes instanceof tiptap_extension_table_esm_Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  if (nodes.attrs) { return new tiptap_extension_table_esm_Fragment([nodes], nodes.nodeSize) }
  throw new RangeError("Can not convert " + nodes + " to a Fragment" +
                       (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""))
};

Object.defineProperties( tiptap_extension_table_esm_Fragment.prototype, tiptap_extension_table_esm_prototypeAccessors$3 );

var tiptap_extension_table_esm_found = {index: 0, offset: 0};
function tiptap_extension_table_esm_retIndex(index, offset) {
  tiptap_extension_table_esm_found.index = index;
  tiptap_extension_table_esm_found.offset = offset;
  return tiptap_extension_table_esm_found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
tiptap_extension_table_esm_Fragment.empty = new tiptap_extension_table_esm_Fragment([], 0);

function tiptap_extension_table_esm_compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!tiptap_extension_table_esm_compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !tiptap_extension_table_esm_compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var tiptap_extension_table_esm_Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
tiptap_extension_table_esm_Mark.prototype.addToSet = function addToSet (set) {
  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this.eq(other)) { return set }
    if (this.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
tiptap_extension_table_esm_Mark.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
tiptap_extension_table_esm_Mark.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (this.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
tiptap_extension_table_esm_Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && tiptap_extension_table_esm_compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
tiptap_extension_table_esm_Mark.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
tiptap_extension_table_esm_Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
tiptap_extension_table_esm_Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
tiptap_extension_table_esm_Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return tiptap_extension_table_esm_Mark.none }
  if (marks instanceof tiptap_extension_table_esm_Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
tiptap_extension_table_esm_Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function tiptap_extension_table_esm_ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = tiptap_extension_table_esm_ReplaceError.prototype;
  return err
}

tiptap_extension_table_esm_ReplaceError.prototype = Object.create(Error.prototype);
tiptap_extension_table_esm_ReplaceError.prototype.constructor = tiptap_extension_table_esm_ReplaceError;
tiptap_extension_table_esm_ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var tiptap_extension_table_esm_Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var tiptap_extension_table_esm_prototypeAccessors$1$2 = { size: { configurable: true } };

// :: number
// The size this slice would add when inserted into a document.
tiptap_extension_table_esm_prototypeAccessors$1$2.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

tiptap_extension_table_esm_Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = tiptap_extension_table_esm_insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new tiptap_extension_table_esm_Slice(content, this.openStart, this.openEnd)
};

tiptap_extension_table_esm_Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
tiptap_extension_table_esm_Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

tiptap_extension_table_esm_Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
tiptap_extension_table_esm_Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
tiptap_extension_table_esm_Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return tiptap_extension_table_esm_Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.fromJSON(schema, json.content), openStart, openEnd)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
tiptap_extension_table_esm_Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new tiptap_extension_table_esm_Slice(fragment, openStart, openEnd)
};

Object.defineProperties( tiptap_extension_table_esm_Slice.prototype, tiptap_extension_table_esm_prototypeAccessors$1$2 );

function tiptap_extension_table_esm_removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(tiptap_extension_table_esm_removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function tiptap_extension_table_esm_insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = tiptap_extension_table_esm_insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
tiptap_extension_table_esm_Slice.empty = new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.empty, 0, 0);

function tiptap_extension_table_esm_replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new tiptap_extension_table_esm_ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new tiptap_extension_table_esm_ReplaceError("Inconsistent open depths") }
  return tiptap_extension_table_esm_replaceOuter($from, $to, slice, 0)
}

function tiptap_extension_table_esm_replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = tiptap_extension_table_esm_replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return tiptap_extension_table_esm_close(node, tiptap_extension_table_esm_replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return tiptap_extension_table_esm_close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = tiptap_extension_table_esm_prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return tiptap_extension_table_esm_close(node, tiptap_extension_table_esm_replaceThreeWay($from, start, end, $to, depth))
  }
}

function tiptap_extension_table_esm_checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new tiptap_extension_table_esm_ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function tiptap_extension_table_esm_joinable($before, $after, depth) {
  var node = $before.node(depth);
  tiptap_extension_table_esm_checkJoin(node, $after.node(depth));
  return node
}

function tiptap_extension_table_esm_addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function tiptap_extension_table_esm_addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      tiptap_extension_table_esm_addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { tiptap_extension_table_esm_addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { tiptap_extension_table_esm_addNode($end.nodeBefore, target); }
}

function tiptap_extension_table_esm_close(node, content) {
  if (!node.type.validContent(content))
    { throw new tiptap_extension_table_esm_ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function tiptap_extension_table_esm_replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && tiptap_extension_table_esm_joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && tiptap_extension_table_esm_joinable($end, $to, depth + 1);

  var content = [];
  tiptap_extension_table_esm_addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    tiptap_extension_table_esm_checkJoin(openStart, openEnd);
    tiptap_extension_table_esm_addNode(tiptap_extension_table_esm_close(openStart, tiptap_extension_table_esm_replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { tiptap_extension_table_esm_addNode(tiptap_extension_table_esm_close(openStart, tiptap_extension_table_esm_replaceTwoWay($from, $start, depth + 1)), content); }
    tiptap_extension_table_esm_addRange($start, $end, depth, content);
    if (openEnd)
      { tiptap_extension_table_esm_addNode(tiptap_extension_table_esm_close(openEnd, tiptap_extension_table_esm_replaceTwoWay($end, $to, depth + 1)), content); }
  }
  tiptap_extension_table_esm_addRange($to, null, depth, content);
  return new tiptap_extension_table_esm_Fragment(content)
}

function tiptap_extension_table_esm_replaceTwoWay($from, $to, depth) {
  var content = [];
  tiptap_extension_table_esm_addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = tiptap_extension_table_esm_joinable($from, $to, depth + 1);
    tiptap_extension_table_esm_addNode(tiptap_extension_table_esm_close(type, tiptap_extension_table_esm_replaceTwoWay($from, $to, depth + 1)), content);
  }
  tiptap_extension_table_esm_addRange($to, null, depth, content);
  return new tiptap_extension_table_esm_Fragment(content)
}

function tiptap_extension_table_esm_prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(tiptap_extension_table_esm_Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var tiptap_extension_table_esm_ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$2$1 = { parent: { configurable: true },doc: { configurable: true },textOffset: { configurable: true },nodeAfter: { configurable: true },nodeBefore: { configurable: true } };

tiptap_extension_table_esm_ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$2$1.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$2$1.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
tiptap_extension_table_esm_ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 1 and `p.index(1)` is 2.
tiptap_extension_table_esm_ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
tiptap_extension_table_esm_ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
tiptap_extension_table_esm_ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
tiptap_extension_table_esm_ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `depth` is `this.depth + 1`, the original
// position.
tiptap_extension_table_esm_ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `depth` is `this.depth + 1`.
tiptap_extension_table_esm_ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$2$1.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$2$1.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$2$1.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: (number, ?number) → number
// Get the position at the given index in the parent node at the
// given depth (which defaults to `this.depth`).
tiptap_extension_table_esm_ResolvedPos.prototype.posAtIndex = function posAtIndex (index, depth) {
  depth = this.resolveDepth(depth);
  var node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  for (var i = 0; i < index; i++) { pos += node.child(i).nodeSize; }
  return pos
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
tiptap_extension_table_esm_ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return tiptap_extension_table_esm_Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
tiptap_extension_table_esm_ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
tiptap_extension_table_esm_ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
  for (var depth = this.depth; depth > 0; depth--)
    { if (this.start(depth) <= pos && this.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
tiptap_extension_table_esm_ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
      { return new tiptap_extension_table_esm_NodeRange(this, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
tiptap_extension_table_esm_ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
tiptap_extension_table_esm_ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
tiptap_extension_table_esm_ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

tiptap_extension_table_esm_ResolvedPos.prototype.toString = function toString () {
  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1); }
  return str + ":" + this.parentOffset
};

tiptap_extension_table_esm_ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new tiptap_extension_table_esm_ResolvedPos(pos, path, parentOffset)
};

tiptap_extension_table_esm_ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < tiptap_extension_table_esm_resolveCache.length; i++) {
    var cached = tiptap_extension_table_esm_resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = tiptap_extension_table_esm_resolveCache[tiptap_extension_table_esm_resolveCachePos] = tiptap_extension_table_esm_ResolvedPos.resolve(doc, pos);
  tiptap_extension_table_esm_resolveCachePos = (tiptap_extension_table_esm_resolveCachePos + 1) % tiptap_extension_table_esm_resolveCacheSize;
  return result
};

Object.defineProperties( tiptap_extension_table_esm_ResolvedPos.prototype, prototypeAccessors$2$1 );

var tiptap_extension_table_esm_resolveCache = [], tiptap_extension_table_esm_resolveCachePos = 0, tiptap_extension_table_esm_resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var tiptap_extension_table_esm_NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1$1 = { start: { configurable: true },end: { configurable: true },parent: { configurable: true },startIndex: { configurable: true },endIndex: { configurable: true } };

// :: number The position at the start of the range.
prototypeAccessors$1$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( tiptap_extension_table_esm_NodeRange.prototype, prototypeAccessors$1$1$1 );

var tiptap_extension_table_esm_emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var tiptap_extension_table_esm_Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || tiptap_extension_table_esm_Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || tiptap_extension_table_esm_Mark.none;
};

var prototypeAccessors$3$1 = { nodeSize: { configurable: true },childCount: { configurable: true },textContent: { configurable: true },firstChild: { configurable: true },lastChild: { configurable: true },isBlock: { configurable: true },isTextblock: { configurable: true },inlineContent: { configurable: true },isInline: { configurable: true },isText: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
prototypeAccessors$3$1.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
prototypeAccessors$3$1.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
tiptap_extension_table_esm_Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
tiptap_extension_table_esm_Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
tiptap_extension_table_esm_Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
tiptap_extension_table_esm_Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node, index: number) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
tiptap_extension_table_esm_Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
prototypeAccessors$3$1.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?union<string, ?(leafNode: Node) -> string>) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted to separate text
// from different block nodes. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
tiptap_extension_table_esm_Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
prototypeAccessors$3$1.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
prototypeAccessors$3$1.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
tiptap_extension_table_esm_Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
tiptap_extension_table_esm_Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
tiptap_extension_table_esm_Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    tiptap_extension_table_esm_compareDeep(this.attrs, attrs || type.defaultAttrs || tiptap_extension_table_esm_emptyAttrs) &&
    tiptap_extension_table_esm_Mark.sameSet(this.marks, marks || tiptap_extension_table_esm_Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
tiptap_extension_table_esm_Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
tiptap_extension_table_esm_Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
tiptap_extension_table_esm_Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
tiptap_extension_table_esm_Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return tiptap_extension_table_esm_Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new tiptap_extension_table_esm_Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
tiptap_extension_table_esm_Node.prototype.replace = function replace$1 (from, to, slice) {
  return tiptap_extension_table_esm_replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
tiptap_extension_table_esm_Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
tiptap_extension_table_esm_Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
tiptap_extension_table_esm_Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
tiptap_extension_table_esm_Node.prototype.resolve = function resolve (pos) { return tiptap_extension_table_esm_ResolvedPos.resolveCached(this, pos) };

tiptap_extension_table_esm_Node.prototype.resolveNoCache = function resolveNoCache (pos) { return tiptap_extension_table_esm_ResolvedPos.resolve(this, pos) };

// :: (number, number, union<Mark, MarkType>) → bool
// Test whether a given mark or mark type occurs in this document
// between the two given positions.
tiptap_extension_table_esm_Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
prototypeAccessors$3$1.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
prototypeAccessors$3$1.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node allows inline content.
prototypeAccessors$3$1.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
prototypeAccessors$3$1.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
prototypeAccessors$3$1.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
prototypeAccessors$3$1.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
prototypeAccessors$3$1.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
tiptap_extension_table_esm_Node.prototype.toString = function toString () {
  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return tiptap_extension_table_esm_wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
tiptap_extension_table_esm_Node.prototype.contentMatchAt = function contentMatchAt (index) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
  return match
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
tiptap_extension_table_esm_Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    if ( replacement === void 0 ) replacement = tiptap_extension_table_esm_Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
tiptap_extension_table_esm_Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
tiptap_extension_table_esm_Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
tiptap_extension_table_esm_Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  var copy = tiptap_extension_table_esm_Mark.none;
  for (var i = 0; i < this.marks.length; i++) { copy = this.marks[i].addToSet(copy); }
  if (!tiptap_extension_table_esm_Mark.sameSet(copy, this.marks))
    { throw new RangeError(("Invalid collection of marks for node " + (this.type.name) + ": " + (this.marks.map(function (m) { return m.type.name; })))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
tiptap_extension_table_esm_Node.prototype.toJSON = function toJSON () {
  var obj = {type: this.type.name};
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
tiptap_extension_table_esm_Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = tiptap_extension_table_esm_Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( tiptap_extension_table_esm_Node.prototype, prototypeAccessors$3$1 );

function tiptap_extension_table_esm_wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var tiptap_extension_table_esm_ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var tiptap_extension_table_esm_prototypeAccessors$4 = { inlineContent: { configurable: true },defaultType: { configurable: true },edgeCount: { configurable: true } };

tiptap_extension_table_esm_ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new tiptap_extension_table_esm_TokenStream(string, nodeTypes);
  if (stream.next == null) { return tiptap_extension_table_esm_ContentMatch.empty }
  var expr = tiptap_extension_table_esm_parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = tiptap_extension_table_esm_dfa(tiptap_extension_table_esm_nfa(expr));
  tiptap_extension_table_esm_checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
tiptap_extension_table_esm_ContentMatch.prototype.matchType = function matchType (type) {
  for (var i = 0; i < this.next.length; i += 2)
    { if (this.next[i] == type) { return this.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
tiptap_extension_table_esm_ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

tiptap_extension_table_esm_prototypeAccessors$4.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
tiptap_extension_table_esm_prototypeAccessors$4.defaultType.get = function () {
  for (var i = 0; i < this.next.length; i += 2) {
    var type = this.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

tiptap_extension_table_esm_ContentMatch.prototype.compatible = function compatible (other) {
  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
tiptap_extension_table_esm_ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return tiptap_extension_table_esm_Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
tiptap_extension_table_esm_ContentMatch.prototype.findWrapping = function findWrapping (target) {
  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this.wrapCache[i] == target) { return this.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

tiptap_extension_table_esm_ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
tiptap_extension_table_esm_prototypeAccessors$4.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_​th outgoing edge from this node in the finite
// automaton that describes the content expression.
tiptap_extension_table_esm_ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i >= this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

tiptap_extension_table_esm_ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( tiptap_extension_table_esm_ContentMatch.prototype, tiptap_extension_table_esm_prototypeAccessors$4 );

tiptap_extension_table_esm_ContentMatch.empty = new tiptap_extension_table_esm_ContentMatch(true);

var tiptap_extension_table_esm_TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.shift(); }
};

var prototypeAccessors$1$2$1 = { next: { configurable: true } };

prototypeAccessors$1$2$1.next.get = function () { return this.tokens[this.pos] };

tiptap_extension_table_esm_TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

tiptap_extension_table_esm_TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( tiptap_extension_table_esm_TokenStream.prototype, prototypeAccessors$1$2$1 );

function tiptap_extension_table_esm_parseExpr(stream) {
  var exprs = [];
  do { exprs.push(tiptap_extension_table_esm_parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function tiptap_extension_table_esm_parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(tiptap_extension_table_esm_parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function tiptap_extension_table_esm_parseExprSubscript(stream) {
  var expr = tiptap_extension_table_esm_parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = tiptap_extension_table_esm_parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function tiptap_extension_table_esm_parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function tiptap_extension_table_esm_parseExprRange(stream, expr) {
  var min = tiptap_extension_table_esm_parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = tiptap_extension_table_esm_parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function tiptap_extension_table_esm_resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function tiptap_extension_table_esm_parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = tiptap_extension_table_esm_parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = tiptap_extension_table_esm_resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function tiptap_extension_table_esm_nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function tiptap_extension_table_esm_cmp(a, b) { return b - a }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function tiptap_extension_table_esm_nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(tiptap_extension_table_esm_cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function tiptap_extension_table_esm_dfa(nfa) {
  var labeled = Object.create(null);
  return explore(tiptap_extension_table_esm_nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        tiptap_extension_table_esm_nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new tiptap_extension_table_esm_ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(tiptap_extension_table_esm_cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function tiptap_extension_table_esm_checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function tiptap_extension_table_esm_defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function tiptap_extension_table_esm_computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function tiptap_extension_table_esm_initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new tiptap_extension_table_esm_Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var tiptap_extension_table_esm_NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = tiptap_extension_table_esm_initAttrs(spec.attrs);

  this.defaultAttrs = tiptap_extension_table_esm_defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var tiptap_extension_table_esm_prototypeAccessors$5 = { isInline: { configurable: true },isTextblock: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true },whitespace: { configurable: true } };

// :: bool
// True if this is an inline type.
tiptap_extension_table_esm_prototypeAccessors$5.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
tiptap_extension_table_esm_prototypeAccessors$5.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
tiptap_extension_table_esm_prototypeAccessors$5.isLeaf.get = function () { return this.contentMatch == tiptap_extension_table_esm_ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
tiptap_extension_table_esm_prototypeAccessors$5.isAtom.get = function () { return this.isLeaf || this.spec.atom };

// :: union<"pre", "normal">
// The node type's [whitespace](#view.NodeSpec.whitespace) option.
tiptap_extension_table_esm_prototypeAccessors$5.whitespace.get = function () { return this.spec.whitespace || (this.spec.code ? "pre" : "normal") };

// :: () → bool
// Tells you whether this node type has any required attributes.
tiptap_extension_table_esm_NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs () {
  for (var n in this.attrs) { if (this.attrs[n].isRequired) { return true } }
  return false
};

tiptap_extension_table_esm_NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

tiptap_extension_table_esm_NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return tiptap_extension_table_esm_computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
tiptap_extension_table_esm_NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new tiptap_extension_table_esm_Node(this, this.computeAttrs(attrs), tiptap_extension_table_esm_Fragment.from(content), tiptap_extension_table_esm_Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
tiptap_extension_table_esm_NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = tiptap_extension_table_esm_Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new tiptap_extension_table_esm_Node(this, this.computeAttrs(attrs), content, tiptap_extension_table_esm_Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
tiptap_extension_table_esm_NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = tiptap_extension_table_esm_Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(tiptap_extension_table_esm_Fragment.empty, true);
  if (!after) { return null }
  return new tiptap_extension_table_esm_Node(this, attrs, content.append(after), tiptap_extension_table_esm_Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
tiptap_extension_table_esm_NodeType.prototype.validContent = function validContent (content) {
  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
tiptap_extension_table_esm_NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
tiptap_extension_table_esm_NodeType.prototype.allowsMarks = function allowsMarks (marks) {
  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
tiptap_extension_table_esm_NodeType.prototype.allowedMarks = function allowedMarks (marks) {
  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : tiptap_extension_table_esm_Mark.empty
};

tiptap_extension_table_esm_NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new tiptap_extension_table_esm_NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( tiptap_extension_table_esm_NodeType.prototype, tiptap_extension_table_esm_prototypeAccessors$5 );

// Attribute descriptors

var tiptap_extension_table_esm_Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var tiptap_extension_table_esm_prototypeAccessors$1$3 = { isRequired: { configurable: true } };

tiptap_extension_table_esm_prototypeAccessors$1$3.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( tiptap_extension_table_esm_Attribute.prototype, tiptap_extension_table_esm_prototypeAccessors$1$3 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var tiptap_extension_table_esm_MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = tiptap_extension_table_esm_initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = tiptap_extension_table_esm_defaultAttrs(this.attrs);
  this.instance = defaults && new tiptap_extension_table_esm_Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
tiptap_extension_table_esm_MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new tiptap_extension_table_esm_Mark(this, tiptap_extension_table_esm_computeAttrs(this.attrs, attrs))
};

tiptap_extension_table_esm_MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new tiptap_extension_table_esm_MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
tiptap_extension_table_esm_MarkType.prototype.removeFromSet = function removeFromSet (set) {
  for (var i = 0; i < set.length; i++) { if (set[i].type == this) {
    set = set.slice(0, i).concat(set.slice(i + 1));
    i--;
  } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
tiptap_extension_table_esm_MarkType.prototype.isInSet = function isInSet (set) {
  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
tiptap_extension_table_esm_MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// : Object<bool> The block-level tags in HTML5
var tiptap_extension_table_esm_blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var tiptap_extension_table_esm_ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var tiptap_extension_table_esm_listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var tiptap_extension_table_esm_OPT_PRESERVE_WS = 1, tiptap_extension_table_esm_OPT_PRESERVE_WS_FULL = 2, tiptap_extension_table_esm_OPT_OPEN_LEFT = 4;

function tiptap_extension_table_esm_wsOptionsFor(type, preserveWhitespace, base) {
  if (preserveWhitespace != null) { return (preserveWhitespace ? tiptap_extension_table_esm_OPT_PRESERVE_WS : 0) |
    (preserveWhitespace === "full" ? tiptap_extension_table_esm_OPT_PRESERVE_WS_FULL : 0) }
  return type && type.whitespace == "pre" ? tiptap_extension_table_esm_OPT_PRESERVE_WS | tiptap_extension_table_esm_OPT_PRESERVE_WS_FULL : base & ~tiptap_extension_table_esm_OPT_OPEN_LEFT
}

var tiptap_extension_table_esm_NodeContext = function NodeContext(type, attrs, marks, pendingMarks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & tiptap_extension_table_esm_OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  // Marks applied to this node itself
  this.marks = marks;
  // Marks applied to its children
  this.activeMarks = tiptap_extension_table_esm_Mark.none;
  // Marks that can't apply here, but will be used in children if possible
  this.pendingMarks = pendingMarks;
  // Nested Marks with same type
  this.stashMarks = [];
};

tiptap_extension_table_esm_NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(tiptap_extension_table_esm_Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

tiptap_extension_table_esm_NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & tiptap_extension_table_esm_OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = tiptap_extension_table_esm_Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(tiptap_extension_table_esm_Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

tiptap_extension_table_esm_NodeContext.prototype.popFromStashMark = function popFromStashMark (mark) {
  for (var i = this.stashMarks.length - 1; i >= 0; i--)
    { if (mark.eq(this.stashMarks[i])) { return this.stashMarks.splice(i, 1)[0] } }
};

tiptap_extension_table_esm_NodeContext.prototype.applyPending = function applyPending (nextType) {
  for (var i = 0, pending = this.pendingMarks; i < pending.length; i++) {
    var mark = pending[i];
    if ((this.type ? this.type.allowsMarkType(mark.type) : tiptap_extension_table_esm_markMayApply(mark.type, nextType)) &&
        !mark.isInSet(this.activeMarks)) {
      this.activeMarks = mark.addToSet(this.activeMarks);
      this.pendingMarks = mark.removeFromSet(this.pendingMarks);
    }
  }
};

tiptap_extension_table_esm_NodeContext.prototype.inlineContext = function inlineContext (node) {
  if (this.type) { return this.type.inlineContent }
  if (this.content.length) { return this.content[0].isInline }
  return node.parentNode && !tiptap_extension_table_esm_blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase())
};

var tiptap_extension_table_esm_ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  var topNode = options.topNode, topContext;
  var topOptions = tiptap_extension_table_esm_wsOptionsFor(null, options.preserveWhitespace, 0) | (open ? tiptap_extension_table_esm_OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new tiptap_extension_table_esm_NodeContext(topNode.type, topNode.attrs, tiptap_extension_table_esm_Mark.none, tiptap_extension_table_esm_Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new tiptap_extension_table_esm_NodeContext(null, null, tiptap_extension_table_esm_Mark.none, tiptap_extension_table_esm_Mark.none, true, null, topOptions); }
  else
    { topContext = new tiptap_extension_table_esm_NodeContext(parser.schema.topNodeType, null, tiptap_extension_table_esm_Mark.none, tiptap_extension_table_esm_Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var tiptap_extension_table_esm_prototypeAccessors$6 = { top: { configurable: true },currentPos: { configurable: true } };

tiptap_extension_table_esm_prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
tiptap_extension_table_esm_ParseContext.prototype.addDOM = function addDOM (dom) {
  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks = style ? this.readStyles(tiptap_extension_table_esm_parseStyles(style)) : null, top = this.top;
    if (marks != null) { for (var i = 0; i < marks.length; i++) { this.addPendingMark(marks[i]); } }
    this.addElement(dom);
    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this.removePendingMark(marks[i$1], top); } }
  }
};

tiptap_extension_table_esm_ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if (top.options & tiptap_extension_table_esm_OPT_PRESERVE_WS_FULL ||
      top.inlineContext(dom) ||
      /[^ \t\r\n\u000c]/.test(value)) {
    if (!(top.options & tiptap_extension_table_esm_OPT_PRESERVE_WS)) {
      value = value.replace(/[ \t\r\n\u000c]+/g, " ");
      // If this starts with whitespace, and there is no node before it, or
      // a hard break, or a text node that ends with whitespace, strip the
      // leading space.
      if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore ||
            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
            (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
          { value = value.slice(1); }
      }
    } else if (!(top.options & tiptap_extension_table_esm_OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    } else {
      value = value.replace(/\r\n?/g, "\n");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element, ?ParseRule)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
tiptap_extension_table_esm_ParseContext.prototype.addElement = function addElement (dom, matchAfter) {
  var name = dom.nodeName.toLowerCase(), ruleID;
  if (tiptap_extension_table_esm_listTags.hasOwnProperty(name) && this.parser.normalizeLists) { tiptap_extension_table_esm_normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) ||
      (ruleID = this.parser.matchTag(dom, this, matchAfter));
  if (rule ? rule.ignore : tiptap_extension_table_esm_ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
    this.ignoreFallback(dom);
  } else if (!rule || rule.skip || rule.closeParent) {
    if (rule && rule.closeParent) { this.open = Math.max(0, this.open - 1); }
    else if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
    if (tiptap_extension_table_esm_blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    } else if (!dom.firstChild) {
      this.leafFallback(dom);
      return
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : null);
  }
};

// Called for leaf DOM nodes that would otherwise be ignored
tiptap_extension_table_esm_ParseContext.prototype.leafFallback = function leafFallback (dom) {
  if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
    { this.addTextNode(dom.ownerDocument.createTextNode("\n")); }
};

// Called for ignored nodes
tiptap_extension_table_esm_ParseContext.prototype.ignoreFallback = function ignoreFallback (dom) {
  // Ignored BR nodes should at least create an inline context
  if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
    { this.findPlace(this.parser.schema.text("-")); }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
tiptap_extension_table_esm_ParseContext.prototype.readStyles = function readStyles (styles) {
  var marks = tiptap_extension_table_esm_Mark.none;
  style: for (var i = 0; i < styles.length; i += 2) {
    for (var after = null;;) {
      var rule = this.parser.matchStyle(styles[i], styles[i + 1], this, after);
      if (!rule) { continue style }
      if (rule.ignore) { return null }
      marks = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
      if (rule.consuming === false) { after = rule; }
      else { break }
    }
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
tiptap_extension_table_esm_ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule, continueAfter) {
    var this$1$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (!nodeType.isLeaf) {
      sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace);
    } else if (!this.insertNode(nodeType.create(rule.attrs))) {
      this.leafFallback(dom);
    }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (continueAfter) {
    this.addElement(dom, continueAfter);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark, startIn); }
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
tiptap_extension_table_esm_ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this.findAtPoint(parent, index);
    this.addDOM(dom);
    if (sync && tiptap_extension_table_esm_blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
tiptap_extension_table_esm_ParseContext.prototype.findPlace = function findPlace (node) {
  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
tiptap_extension_table_esm_ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enterInner(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    top.applyPending(node.type);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
    return true
  }
  return false
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
tiptap_extension_table_esm_ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) { this.enterInner(type, attrs, true, preserveWS); }
  return ok
};

// Open a node of the given type
tiptap_extension_table_esm_ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.applyPending(type);
  top.match = top.match && top.match.matchType(type, attrs);
  var options = tiptap_extension_table_esm_wsOptionsFor(type, preserveWS, top.options);
  if ((top.options & tiptap_extension_table_esm_OPT_OPEN_LEFT) && top.content.length == 0) { options |= tiptap_extension_table_esm_OPT_OPEN_LEFT; }
  this.nodes.push(new tiptap_extension_table_esm_NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
tiptap_extension_table_esm_ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

tiptap_extension_table_esm_ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

tiptap_extension_table_esm_ParseContext.prototype.sync = function sync (to) {
  for (var i = this.open; i >= 0; i--) { if (this.nodes[i] == to) {
    this.open = i;
    return
  } }
};

tiptap_extension_table_esm_prototypeAccessors$6.currentPos.get = function () {
  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

tiptap_extension_table_esm_ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == parent && this.find[i].offset == offset)
      { this.find[i].pos = this.currentPos; }
  } }
};

tiptap_extension_table_esm_ParseContext.prototype.findInside = function findInside (parent) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
      { this.find[i].pos = this.currentPos; }
  } }
};

tiptap_extension_table_esm_ParseContext.prototype.findAround = function findAround (parent, content, before) {
  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
      var pos = content.compareDocumentPosition(this.find[i].node);
      if (pos & (before ? 2 : 4))
        { this.find[i].pos = this.currentPos; }
    }
  } }
};

tiptap_extension_table_esm_ParseContext.prototype.findInText = function findInText (textNode) {
  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this.find[i].node == textNode)
      { this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
tiptap_extension_table_esm_ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

tiptap_extension_table_esm_ParseContext.prototype.textblockFromContext = function textblockFromContext () {
  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this.parser.schema.nodes) {
    var type = this.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

tiptap_extension_table_esm_ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  var found = tiptap_extension_table_esm_findSameMarkInSet(mark, this.top.pendingMarks);
  if (found) { this.top.stashMarks.push(found); }
  this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
};

tiptap_extension_table_esm_ParseContext.prototype.removePendingMark = function removePendingMark (mark, upto) {
  for (var depth = this.open; depth >= 0; depth--) {
    var level = this.nodes[depth];
    var found = level.pendingMarks.lastIndexOf(mark);
    if (found > -1) {
      level.pendingMarks = mark.removeFromSet(level.pendingMarks);
    } else {
      level.activeMarks = mark.removeFromSet(level.activeMarks);
      var stashMark = level.popFromStashMark(mark);
      if (stashMark && level.type && level.type.allowsMarkType(stashMark.type))
        { level.activeMarks = stashMark.addToSet(level.activeMarks); }
    }
    if (level == upto) { break }
  }
};

Object.defineProperties( tiptap_extension_table_esm_ParseContext.prototype, tiptap_extension_table_esm_prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function tiptap_extension_table_esm_normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && tiptap_extension_table_esm_listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function tiptap_extension_table_esm_parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function tiptap_extension_table_esm_markMayApply(markType, nodeType) {
  var nodes = nodeType.schema.nodes;
  var loop = function ( name ) {
    var parent = nodes[name];
    if (!parent.allowsMarkType(markType)) { return }
    var seen = [], scan = function (match) {
      seen.push(match);
      for (var i = 0; i < match.edgeCount; i++) {
        var ref = match.edge(i);
        var type = ref.type;
        var next = ref.next;
        if (type == nodeType) { return true }
        if (seen.indexOf(next) < 0 && scan(next)) { return true }
      }
    };
    if (scan(parent.contentMatch)) { return { v: true } }
  };

  for (var name in nodes) {
    var returned = loop( name );

    if ( returned ) return returned.v;
  }
}

function tiptap_extension_table_esm_findSameMarkInSet(mark, set) {
  for (var i = 0; i < set.length; i++) {
    if (mark.eq(set[i])) { return set[i] }
  }
}

// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var tiptap_extension_table_esm_lower16 = 0xffff;
var tiptap_extension_table_esm_factor16 = Math.pow(2, 16);

function tiptap_extension_table_esm_makeRecover(index, offset) { return index + offset * tiptap_extension_table_esm_factor16 }
function tiptap_extension_table_esm_recoverIndex(value) { return value & tiptap_extension_table_esm_lower16 }
function tiptap_extension_table_esm_recoverOffset(value) { return (value - (value & tiptap_extension_table_esm_lower16)) / tiptap_extension_table_esm_factor16 }

// ::- An object representing a mapped position with extra
// information.
var tiptap_extension_table_esm_MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var tiptap_extension_table_esm_StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

tiptap_extension_table_esm_StepMap.prototype.recover = function recover (value) {
  var diff = 0, index = tiptap_extension_table_esm_recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + tiptap_extension_table_esm_recoverOffset(value)
};

// : (number, ?number) → MapResult
tiptap_extension_table_esm_StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
tiptap_extension_table_esm_StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

tiptap_extension_table_esm_StepMap.prototype._map = function _map (pos, assoc, simple) {
  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = pos == (assoc < 0 ? start : end) ? null : tiptap_extension_table_esm_makeRecover(i / 3, pos - start);
      return new tiptap_extension_table_esm_MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new tiptap_extension_table_esm_MapResult(pos + diff)
};

tiptap_extension_table_esm_StepMap.prototype.touches = function touches (pos, recover) {
  var diff = 0, index = tiptap_extension_table_esm_recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i] - (this.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
tiptap_extension_table_esm_StepMap.prototype.forEach = function forEach (f) {
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
tiptap_extension_table_esm_StepMap.prototype.invert = function invert () {
  return new tiptap_extension_table_esm_StepMap(this.ranges, !this.inverted)
};

tiptap_extension_table_esm_StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
tiptap_extension_table_esm_StepMap.offset = function offset (n) {
  return n == 0 ? tiptap_extension_table_esm_StepMap.empty : new tiptap_extension_table_esm_StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

tiptap_extension_table_esm_StepMap.empty = new tiptap_extension_table_esm_StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var tiptap_extension_table_esm_Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
tiptap_extension_table_esm_Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new tiptap_extension_table_esm_Mapping(this.maps, this.mirror, from, to)
};

tiptap_extension_table_esm_Mapping.prototype.copy = function copy () {
  return new tiptap_extension_table_esm_Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
tiptap_extension_table_esm_Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
tiptap_extension_table_esm_Mapping.prototype.appendMapping = function appendMapping (mapping) {
  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
tiptap_extension_table_esm_Mapping.prototype.getMirror = function getMirror (n) {
  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this.mirror[i] == n) { return this.mirror[i + (i % 2 ? -1 : 1)] } } }
};

tiptap_extension_table_esm_Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
tiptap_extension_table_esm_Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// :: () → Mapping
// Create an inverted version of this mapping.
tiptap_extension_table_esm_Mapping.prototype.invert = function invert () {
  var inverse = new tiptap_extension_table_esm_Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
tiptap_extension_table_esm_Mapping.prototype.map = function map (pos, assoc) {
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
tiptap_extension_table_esm_Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

tiptap_extension_table_esm_Mapping.prototype._map = function _map (pos, assoc, simple) {
  var deleted = false;

  for (var i = this.from; i < this.to; i++) {
    var map = this.maps[i], result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this.getMirror(i);
      if (corr != null && corr > i && corr < this.to) {
        i = corr;
        pos = this.maps[corr].recover(result.recover);
        continue
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new tiptap_extension_table_esm_MapResult(pos, deleted)
};

function tiptap_extension_table_esm_TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = tiptap_extension_table_esm_TransformError.prototype;
  return err
}

tiptap_extension_table_esm_TransformError.prototype = Object.create(Error.prototype);
tiptap_extension_table_esm_TransformError.prototype.constructor = tiptap_extension_table_esm_TransformError;
tiptap_extension_table_esm_TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var tiptap_extension_table_esm_Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new tiptap_extension_table_esm_Mapping;
};

var tiptap_extension_table_esm_prototypeAccessors$2 = { before: { configurable: true },docChanged: { configurable: true } };

// :: Node The starting document.
tiptap_extension_table_esm_prototypeAccessors$2.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
tiptap_extension_table_esm_Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new tiptap_extension_table_esm_TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
tiptap_extension_table_esm_Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
tiptap_extension_table_esm_prototypeAccessors$2.docChanged.get = function () {
  return this.steps.length > 0
};

tiptap_extension_table_esm_Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( tiptap_extension_table_esm_Transform.prototype, tiptap_extension_table_esm_prototypeAccessors$2 );

function tiptap_extension_table_esm_mustOverride() { throw new Error("Override me") }

var tiptap_extension_table_esm_stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var tiptap_extension_table_esm_Step = function Step () {};

tiptap_extension_table_esm_Step.prototype.apply = function apply (_doc) { return tiptap_extension_table_esm_mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
tiptap_extension_table_esm_Step.prototype.getMap = function getMap () { return tiptap_extension_table_esm_StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
tiptap_extension_table_esm_Step.prototype.invert = function invert (_doc) { return tiptap_extension_table_esm_mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
tiptap_extension_table_esm_Step.prototype.map = function map (_mapping) { return tiptap_extension_table_esm_mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
tiptap_extension_table_esm_Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
tiptap_extension_table_esm_Step.prototype.toJSON = function toJSON () { return tiptap_extension_table_esm_mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
tiptap_extension_table_esm_Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = tiptap_extension_table_esm_stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
tiptap_extension_table_esm_Step.jsonID = function jsonID (id, stepClass) {
  if (id in tiptap_extension_table_esm_stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  tiptap_extension_table_esm_stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var tiptap_extension_table_esm_StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
tiptap_extension_table_esm_StepResult.ok = function ok (doc) { return new tiptap_extension_table_esm_StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
tiptap_extension_table_esm_StepResult.fail = function fail (message) { return new tiptap_extension_table_esm_StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
tiptap_extension_table_esm_StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return tiptap_extension_table_esm_StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof tiptap_extension_table_esm_ReplaceError) { return tiptap_extension_table_esm_StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var tiptap_extension_table_esm_ReplaceStep = /*@__PURE__*/(function (Step) {
  function ReplaceStep(from, to, slice, structure) {
    Step.call(this);
    // :: number
    // The start position of the replaced range.
    this.from = from;
    // :: number
    // The end position of the replaced range.
    this.to = to;
    // :: Slice
    // The slice to insert.
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceStep.__proto__ = Step;
  ReplaceStep.prototype = Object.create( Step && Step.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && tiptap_extension_table_esm_contentBetween(doc, this.from, this.to))
      { return tiptap_extension_table_esm_StepResult.fail("Structure replace would overwrite content") }
    return tiptap_extension_table_esm_StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new tiptap_extension_table_esm_StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure || this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? tiptap_extension_table_esm_Slice.empty
          : new tiptap_extension_table_esm_Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? tiptap_extension_table_esm_Slice.empty
          : new tiptap_extension_table_esm_Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, tiptap_extension_table_esm_Slice.fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(tiptap_extension_table_esm_Step));

tiptap_extension_table_esm_Step.jsonID("replace", tiptap_extension_table_esm_ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var tiptap_extension_table_esm_ReplaceAroundStep = /*@__PURE__*/(function (Step) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step.call(this);
    // :: number
    // The start position of the replaced range.
    this.from = from;
    // :: number
    // The end position of the replaced range.
    this.to = to;
    // :: number
    // The start of preserved range.
    this.gapFrom = gapFrom;
    // :: number
    // The end of preserved range.
    this.gapTo = gapTo;
    // :: Slice
    // The slice to insert.
    this.slice = slice;
    // :: number
    // The position in the slice where the preserved range should be
    // inserted.
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step ) ReplaceAroundStep.__proto__ = Step;
  ReplaceAroundStep.prototype = Object.create( Step && Step.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (tiptap_extension_table_esm_contentBetween(doc, this.from, this.gapFrom) ||
                           tiptap_extension_table_esm_contentBetween(doc, this.gapTo, this.to)))
      { return tiptap_extension_table_esm_StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return tiptap_extension_table_esm_StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return tiptap_extension_table_esm_StepResult.fail("Content does not fit in gap") }
    return tiptap_extension_table_esm_StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new tiptap_extension_table_esm_StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 tiptap_extension_table_esm_Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(tiptap_extension_table_esm_Step));

tiptap_extension_table_esm_Step.jsonID("replaceAround", tiptap_extension_table_esm_ReplaceAroundStep);

function tiptap_extension_table_esm_contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
tiptap_extension_table_esm_Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = tiptap_extension_table_esm_Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = tiptap_extension_table_esm_Fragment.from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = tiptap_extension_table_esm_Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = tiptap_extension_table_esm_Fragment.from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new tiptap_extension_table_esm_ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new tiptap_extension_table_esm_Slice(before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
tiptap_extension_table_esm_Transform.prototype.wrap = function(range, wrappers) {
  var content = tiptap_extension_table_esm_Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = tiptap_extension_table_esm_Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new tiptap_extension_table_esm_ReplaceAroundStep(start, end, start, end, new tiptap_extension_table_esm_Slice(content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
tiptap_extension_table_esm_Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && tiptap_extension_table_esm_canChangeType(this$1$1.doc, this$1$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1$1.clearIncompatible(this$1$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1$1.step(new tiptap_extension_table_esm_ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function tiptap_extension_table_esm_canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
tiptap_extension_table_esm_Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new tiptap_extension_table_esm_ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.from(newNode), 0, 0), 1, true))
};

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
tiptap_extension_table_esm_Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = tiptap_extension_table_esm_Fragment.empty, after = tiptap_extension_table_esm_Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = tiptap_extension_table_esm_Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = tiptap_extension_table_esm_Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new tiptap_extension_table_esm_ReplaceStep(pos, pos, new tiptap_extension_table_esm_Slice(before.append(after), depth, depth), true))
};

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
tiptap_extension_table_esm_Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new tiptap_extension_table_esm_ReplaceStep(pos - depth, pos + depth, tiptap_extension_table_esm_Slice.empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function tiptap_extension_table_esm_insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

function tiptap_extension_table_esm_mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(tiptap_extension_table_esm_mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return tiptap_extension_table_esm_Fragment.fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var tiptap_extension_table_esm_AddMarkStep = /*@__PURE__*/(function (Step) {
  function AddMarkStep(from, to, mark) {
    Step.call(this);
    // :: number
    // The start of the marked range.
    this.from = from;
    // :: number
    // The end of the marked range.
    this.to = to;
    // :: Mark
    // The mark to add.
    this.mark = mark;
  }

  if ( Step ) AddMarkStep.__proto__ = Step;
  AddMarkStep.prototype = Object.create( Step && Step.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_mapFragment(oldSlice.content, function (node, parent) {
      if (!node.isAtom || !parent.type.allowsMarkType(this$1$1.mark.type)) { return node }
      return node.mark(this$1$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return tiptap_extension_table_esm_StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new tiptap_extension_table_esm_RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(tiptap_extension_table_esm_Step));

tiptap_extension_table_esm_Step.jsonID("addMark", tiptap_extension_table_esm_AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var tiptap_extension_table_esm_RemoveMarkStep = /*@__PURE__*/(function (Step) {
  function RemoveMarkStep(from, to, mark) {
    Step.call(this);
    // :: number
    // The start of the unmarked range.
    this.from = from;
    // :: number
    // The end of the unmarked range.
    this.to = to;
    // :: Mark
    // The mark to remove.
    this.mark = mark;
  }

  if ( Step ) RemoveMarkStep.__proto__ = Step;
  RemoveMarkStep.prototype = Object.create( Step && Step.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return tiptap_extension_table_esm_StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new tiptap_extension_table_esm_AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(tiptap_extension_table_esm_Step));

tiptap_extension_table_esm_Step.jsonID("removeMark", tiptap_extension_table_esm_RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
tiptap_extension_table_esm_Transform.prototype.addMark = function(from, to, mark) {
  var this$1$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new tiptap_extension_table_esm_RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new tiptap_extension_table_esm_AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1$1.step(s); });
  added.forEach(function (s) { return this$1$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
tiptap_extension_table_esm_Transform.prototype.removeMark = function(from, to, mark) {
  var this$1$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof tiptap_extension_table_esm_MarkType) {
      var set = node.marks, found;
      while (found = mark.isInSet(set)) {
(toRemove || (toRemove = [])).push(found);
        set = found.removeFromSet(set);
      }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1$1.step(new tiptap_extension_table_esm_RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
tiptap_extension_table_esm_Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new tiptap_extension_table_esm_ReplaceStep(cur, end, tiptap_extension_table_esm_Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this.step(new tiptap_extension_table_esm_RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(tiptap_extension_table_esm_Fragment.empty, true);
    this.replace(cur, cur, new tiptap_extension_table_esm_Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function tiptap_extension_table_esm_replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = tiptap_extension_table_esm_Slice.empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (tiptap_extension_table_esm_fitsTrivially($from, $to, slice)) { return new tiptap_extension_table_esm_ReplaceStep(from, to, slice) }
  return new tiptap_extension_table_esm_Fitter($from, $to, slice).fit()
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
tiptap_extension_table_esm_Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = tiptap_extension_table_esm_Slice.empty;

  var step = tiptap_extension_table_esm_replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
tiptap_extension_table_esm_Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
tiptap_extension_table_esm_Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, tiptap_extension_table_esm_Slice.empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
tiptap_extension_table_esm_Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};

function tiptap_extension_table_esm_fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
var tiptap_extension_table_esm_Fitter = function Fitter($from, $to, slice) {
  this.$to = $to;
  this.$from = $from;
  this.unplaced = slice;

  this.frontier = [];
  for (var i = 0; i <= $from.depth; i++) {
    var node = $from.node(i);
    this.frontier.push({
      type: node.type,
      match: node.contentMatchAt($from.indexAfter(i))
    });
  }

  this.placed = tiptap_extension_table_esm_Fragment.empty;
  for (var i$1 = $from.depth; i$1 > 0; i$1--)
    { this.placed = tiptap_extension_table_esm_Fragment.from($from.node(i$1).copy(this.placed)); }
};

var tiptap_extension_table_esm_prototypeAccessors$1$1 = { depth: { configurable: true } };

tiptap_extension_table_esm_prototypeAccessors$1$1.depth.get = function () { return this.frontier.length - 1 };

tiptap_extension_table_esm_Fitter.prototype.fit = function fit () {
  // As long as there's unplaced content, try to place some of it.
  // If that fails, either increase the open score of the unplaced
  // slice, or drop nodes from it, and then try again.
  while (this.unplaced.size) {
    var fit = this.findFittable();
    if (fit) { this.placeNodes(fit); }
    else { this.openMore() || this.dropNode(); }
  }
  // When there's inline content directly after the frontier _and_
  // directly after `this.$to`, we must generate a `ReplaceAround`
  // step that pulls that content into the node after the frontier.
  // That means the fitting must be done to the end of the textblock
  // node after `this.$to`, not `this.$to` itself.
  var moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
  var $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
  if (!$to) { return null }

  // If closing to `$to` succeeded, create a step
  var content = this.placed, openStart = $from.depth, openEnd = $to.depth;
  while (openStart && openEnd && content.childCount == 1) { // Normalize by dropping open parent nodes
    content = content.firstChild.content;
    openStart--; openEnd--;
  }
  var slice = new tiptap_extension_table_esm_Slice(content, openStart, openEnd);
  if (moveInline > -1)
    { return new tiptap_extension_table_esm_ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize) }
  if (slice.size || $from.pos != this.$to.pos) // Don't generate no-op steps
    { return new tiptap_extension_table_esm_ReplaceStep($from.pos, $to.pos, slice) }
};

// Find a position on the start spine of `this.unplaced` that has
// content that can be moved somewhere on the frontier. Returns two
// depths, one for the slice and one for the frontier.
tiptap_extension_table_esm_Fitter.prototype.findFittable = function findFittable () {
  // Only try wrapping nodes (pass 2) after finding a place without
  // wrapping failed.
  for (var pass = 1; pass <= 2; pass++) {
    for (var sliceDepth = this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
      var fragment = (void 0), parent = (void 0);
      if (sliceDepth) {
        parent = tiptap_extension_table_esm_contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
        fragment = parent.content;
      } else {
        fragment = this.unplaced.content;
      }
      var first = fragment.firstChild;
      for (var frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
        var ref = this.frontier[frontierDepth];
          var type = ref.type;
          var match = ref.match;
          var wrap = (void 0), inject = (void 0);
        // In pass 1, if the next node matches, or there is no next
        // node but the parents look compatible, we've found a
        // place.
        if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(tiptap_extension_table_esm_Fragment.from(first), false))
                          : type.compatibleContent(parent.type)))
          { return {sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject} }
        // In pass 2, look for a set of wrapping nodes that make
        // `first` fit here.
        else if (pass == 2 && first && (wrap = match.findWrapping(first.type)))
          { return {sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, wrap: wrap} }
        // Don't continue looking further up if the parent node
        // would fit here.
        if (parent && match.matchType(parent.type)) { break }
      }
    }
  }
};

tiptap_extension_table_esm_Fitter.prototype.openMore = function openMore () {
  var ref = this.unplaced;
    var content = ref.content;
    var openStart = ref.openStart;
    var openEnd = ref.openEnd;
  var inner = tiptap_extension_table_esm_contentAt(content, openStart);
  if (!inner.childCount || inner.firstChild.isLeaf) { return false }
  this.unplaced = new tiptap_extension_table_esm_Slice(content, openStart + 1,
                            Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
  return true
};

tiptap_extension_table_esm_Fitter.prototype.dropNode = function dropNode () {
  var ref = this.unplaced;
    var content = ref.content;
    var openStart = ref.openStart;
    var openEnd = ref.openEnd;
  var inner = tiptap_extension_table_esm_contentAt(content, openStart);
  if (inner.childCount <= 1 && openStart > 0) {
    var openAtEnd = content.size - openStart <= openStart + inner.size;
    this.unplaced = new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_dropFromFragment(content, openStart - 1, 1), openStart - 1,
                              openAtEnd ? openStart - 1 : openEnd);
  } else {
    this.unplaced = new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_dropFromFragment(content, openStart, 1), openStart, openEnd);
  }
};

// : ({sliceDepth: number, frontierDepth: number, parent: ?Node, wrap: ?[NodeType], inject: ?Fragment})
// Move content from the unplaced slice at `sliceDepth` to the
// frontier node at `frontierDepth`. Close that frontier node when
// applicable.
tiptap_extension_table_esm_Fitter.prototype.placeNodes = function placeNodes (ref) {
    var sliceDepth = ref.sliceDepth;
    var frontierDepth = ref.frontierDepth;
    var parent = ref.parent;
    var inject = ref.inject;
    var wrap = ref.wrap;

  while (this.depth > frontierDepth) { this.closeFrontierNode(); }
  if (wrap) { for (var i = 0; i < wrap.length; i++) { this.openFrontierNode(wrap[i]); } }

  var slice = this.unplaced, fragment = parent ? parent.content : slice.content;
  var openStart = slice.openStart - sliceDepth;
  var taken = 0, add = [];
  var ref$1 = this.frontier[frontierDepth];
    var match = ref$1.match;
    var type = ref$1.type;
  if (inject) {
    for (var i$1 = 0; i$1 < inject.childCount; i$1++) { add.push(inject.child(i$1)); }
    match = match.matchFragment(inject);
  }
  // Computes the amount of (end) open nodes at the end of the
  // fragment. When 0, the parent is open, but no more. When
  // negative, nothing is open.
  var openEndCount = (fragment.size + sliceDepth) - (slice.content.size - slice.openEnd);
  // Scan over the fragment, fitting as many child nodes as
  // possible.
  while (taken < fragment.childCount) {
    var next = fragment.child(taken), matches = match.matchType(next.type);
    if (!matches) { break }
    taken++;
    if (taken > 1 || openStart == 0 || next.content.size) { // Drop empty open nodes
      match = matches;
      add.push(tiptap_extension_table_esm_closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0,
                              taken == fragment.childCount ? openEndCount : -1));
    }
  }
  var toEnd = taken == fragment.childCount;
  if (!toEnd) { openEndCount = -1; }

  this.placed = tiptap_extension_table_esm_addToFragment(this.placed, frontierDepth, tiptap_extension_table_esm_Fragment.from(add));
  this.frontier[frontierDepth].match = match;

  // If the parent types match, and the entire node was moved, and
  // it's not open, close this frontier node right away.
  if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1)
    { this.closeFrontierNode(); }

  // Add new frontier nodes for any open nodes at the end.
  for (var i$2 = 0, cur = fragment; i$2 < openEndCount; i$2++) {
    var node = cur.lastChild;
    this.frontier.push({type: node.type, match: node.contentMatchAt(node.childCount)});
    cur = node.content;
  }

  // Update `this.unplaced`. Drop the entire node from which we
  // placed it we got to its end, otherwise just drop the placed
  // nodes.
  this.unplaced = !toEnd ? new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd)
    : sliceDepth == 0 ? tiptap_extension_table_esm_Slice.empty
    : new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_dropFromFragment(slice.content, sliceDepth - 1, 1),
                sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
};

tiptap_extension_table_esm_Fitter.prototype.mustMoveInline = function mustMoveInline () {
  if (!this.$to.parent.isTextblock || this.$to.end() == this.$to.pos) { return -1 }
  var top = this.frontier[this.depth], level;
  if (!top.type.isTextblock || !tiptap_extension_table_esm_contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) ||
      (this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth)) { return -1 }

  var ref = this.$to;
    var depth = ref.depth;
    var after = this.$to.after(depth);
  while (depth > 1 && after == this.$to.end(--depth)) { ++after; }
  return after
};

tiptap_extension_table_esm_Fitter.prototype.findCloseLevel = function findCloseLevel ($to) {
  scan: for (var i = Math.min(this.depth, $to.depth); i >= 0; i--) {
    var ref = this.frontier[i];
      var match = ref.match;
      var type = ref.type;
    var dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
    var fit = tiptap_extension_table_esm_contentAfterFits($to, i, type, match, dropInner);
    if (!fit) { continue }
    for (var d = i - 1; d >= 0; d--) {
      var ref$1 = this.frontier[d];
        var match$1 = ref$1.match;
        var type$1 = ref$1.type;
      var matches = tiptap_extension_table_esm_contentAfterFits($to, d, type$1, match$1, true);
      if (!matches || matches.childCount) { continue scan }
    }
    return {depth: i, fit: fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to}
  }
};

tiptap_extension_table_esm_Fitter.prototype.close = function close ($to) {
  var close = this.findCloseLevel($to);
  if (!close) { return null }

  while (this.depth > close.depth) { this.closeFrontierNode(); }
  if (close.fit.childCount) { this.placed = tiptap_extension_table_esm_addToFragment(this.placed, close.depth, close.fit); }
  $to = close.move;
  for (var d = close.depth + 1; d <= $to.depth; d++) {
    var node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
    this.openFrontierNode(node.type, node.attrs, add);
  }
  return $to
};

tiptap_extension_table_esm_Fitter.prototype.openFrontierNode = function openFrontierNode (type, attrs, content) {
  var top = this.frontier[this.depth];
  top.match = top.match.matchType(type);
  this.placed = tiptap_extension_table_esm_addToFragment(this.placed, this.depth, tiptap_extension_table_esm_Fragment.from(type.create(attrs, content)));
  this.frontier.push({type: type, match: type.contentMatch});
};

tiptap_extension_table_esm_Fitter.prototype.closeFrontierNode = function closeFrontierNode () {
  var open = this.frontier.pop();
  var add = open.match.fillBefore(tiptap_extension_table_esm_Fragment.empty, true);
  if (add.childCount) { this.placed = tiptap_extension_table_esm_addToFragment(this.placed, this.frontier.length, add); }
};

Object.defineProperties( tiptap_extension_table_esm_Fitter.prototype, tiptap_extension_table_esm_prototypeAccessors$1$1 );

function tiptap_extension_table_esm_dropFromFragment(fragment, depth, count) {
  if (depth == 0) { return fragment.cutByIndex(count) }
  return fragment.replaceChild(0, fragment.firstChild.copy(tiptap_extension_table_esm_dropFromFragment(fragment.firstChild.content, depth - 1, count)))
}

function tiptap_extension_table_esm_addToFragment(fragment, depth, content) {
  if (depth == 0) { return fragment.append(content) }
  return fragment.replaceChild(fragment.childCount - 1,
                               fragment.lastChild.copy(tiptap_extension_table_esm_addToFragment(fragment.lastChild.content, depth - 1, content)))
}

function tiptap_extension_table_esm_contentAt(fragment, depth) {
  for (var i = 0; i < depth; i++) { fragment = fragment.firstChild.content; }
  return fragment
}

function tiptap_extension_table_esm_closeNodeStart(node, openStart, openEnd) {
  if (openStart <= 0) { return node }
  var frag = node.content;
  if (openStart > 1)
    { frag = frag.replaceChild(0, tiptap_extension_table_esm_closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0)); }
  if (openStart > 0) {
    frag = node.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0) { frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(tiptap_extension_table_esm_Fragment.empty, true)); }
  }
  return node.copy(frag)
}

function tiptap_extension_table_esm_contentAfterFits($to, depth, type, match, open) {
  var node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
  if (index == node.childCount && !type.compatibleContent(node.type)) { return null }
  var fit = match.fillBefore(node.content, true, index);
  return fit && !tiptap_extension_table_esm_invalidMarks(type, node.content, index) ? fit : null
}

function tiptap_extension_table_esm_invalidMarks(type, fragment, start) {
  for (var i = start; i < fragment.childCount; i++)
    { if (!type.allowsMarks(fragment.child(i).marks)) { return true } }
  return false
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
tiptap_extension_table_esm_Transform.prototype.replaceRange = function(from, to, slice) {
  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (tiptap_extension_table_esm_fitsTrivially($from, $to, slice))
    { return this.step(new tiptap_extension_table_esm_ReplaceStep(from, to, slice)) }

  var targetDepths = tiptap_extension_table_esm_coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  var startSteps = this.steps.length;
  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
    this.replace(from, to, slice);
    if (this.steps.length > startSteps) { break }
    var depth = targetDepths[i$2];
    if (depth < 0) { continue }
    from = $from.before(depth); to = $to.after(depth);
  }
  return this
};

function tiptap_extension_table_esm_closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(tiptap_extension_table_esm_closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start = match.fillBefore(fragment).append(fragment);
    fragment = start.append(match.matchFragment(start).fillBefore(tiptap_extension_table_esm_Fragment.empty, true));
  }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
tiptap_extension_table_esm_Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = tiptap_extension_table_esm_insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
tiptap_extension_table_esm_Transform.prototype.deleteRange = function(from, to) {
  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = tiptap_extension_table_esm_coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d)
      { return this.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function tiptap_extension_table_esm_coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d) ||
        (d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent &&
         d && $to.start(d - 1) == start - 1))
      { result.push(d); }
  }
  return result
}

var tiptap_extension_table_esm_classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var tiptap_extension_table_esm_Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new tiptap_extension_table_esm_SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var tiptap_extension_table_esm_prototypeAccessors = { anchor: { configurable: true },head: { configurable: true },from: { configurable: true },to: { configurable: true },$from: { configurable: true },$to: { configurable: true },empty: { configurable: true } };

// :: number
// The selection's anchor, as an unresolved position.
tiptap_extension_table_esm_prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
tiptap_extension_table_esm_prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
tiptap_extension_table_esm_prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
tiptap_extension_table_esm_prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
tiptap_extension_table_esm_prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
tiptap_extension_table_esm_prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
tiptap_extension_table_esm_prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
tiptap_extension_table_esm_Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
tiptap_extension_table_esm_Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = tiptap_extension_table_esm_Slice.empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? tiptap_extension_table_esm_Slice.empty : content);
    if (i$1 == 0)
      { tiptap_extension_table_esm_selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
tiptap_extension_table_esm_Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      tiptap_extension_table_esm_selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
tiptap_extension_table_esm_Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new tiptap_extension_table_esm_TextSelection($pos)
      : tiptap_extension_table_esm_findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? tiptap_extension_table_esm_findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : tiptap_extension_table_esm_findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
tiptap_extension_table_esm_Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new tiptap_extension_table_esm_AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
tiptap_extension_table_esm_Selection.atStart = function atStart (doc) {
  return tiptap_extension_table_esm_findSelectionIn(doc, doc, 0, 0, 1) || new tiptap_extension_table_esm_AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
tiptap_extension_table_esm_Selection.atEnd = function atEnd (doc) {
  return tiptap_extension_table_esm_findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new tiptap_extension_table_esm_AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
tiptap_extension_table_esm_Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = tiptap_extension_table_esm_classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
tiptap_extension_table_esm_Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in tiptap_extension_table_esm_classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  tiptap_extension_table_esm_classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
tiptap_extension_table_esm_Selection.prototype.getBookmark = function getBookmark () {
  return tiptap_extension_table_esm_TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( tiptap_extension_table_esm_Selection.prototype, tiptap_extension_table_esm_prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
tiptap_extension_table_esm_Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var tiptap_extension_table_esm_SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var tiptap_extension_table_esm_TextSelection = /*@__PURE__*/(function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: { configurable: true } };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = tiptap_extension_table_esm_Slice.empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == tiptap_extension_table_esm_Slice.empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new tiptap_extension_table_esm_TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(tiptap_extension_table_esm_Selection));

tiptap_extension_table_esm_Selection.jsonID("text", tiptap_extension_table_esm_TextSelection);

var tiptap_extension_table_esm_TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
tiptap_extension_table_esm_TextBookmark.prototype.map = function map (mapping) {
  return new tiptap_extension_table_esm_TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
tiptap_extension_table_esm_TextBookmark.prototype.resolve = function resolve (doc) {
  return tiptap_extension_table_esm_TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var tiptap_extension_table_esm_NodeSelection = /*@__PURE__*/(function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new tiptap_extension_table_esm_Slice(tiptap_extension_table_esm_Fragment.from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new tiptap_extension_table_esm_NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(tiptap_extension_table_esm_Selection));

tiptap_extension_table_esm_NodeSelection.prototype.visible = false;

tiptap_extension_table_esm_Selection.jsonID("node", tiptap_extension_table_esm_NodeSelection);

var tiptap_extension_table_esm_NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
tiptap_extension_table_esm_NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new tiptap_extension_table_esm_TextBookmark(pos, pos) : new tiptap_extension_table_esm_NodeBookmark(pos)
};
tiptap_extension_table_esm_NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && tiptap_extension_table_esm_NodeSelection.isSelectable(node)) { return new tiptap_extension_table_esm_NodeSelection($pos) }
  return tiptap_extension_table_esm_Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var tiptap_extension_table_esm_AllSelection = /*@__PURE__*/(function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = tiptap_extension_table_esm_Slice.empty;

    if (content == tiptap_extension_table_esm_Slice.empty) {
      tr.delete(0, tr.doc.content.size);
      var sel = Selection.atStart(tr.doc);
      if (!sel.eq(tr.selection)) { tr.setSelection(sel); }
    } else {
      Selection.prototype.replace.call(this, tr, content);
    }
  };

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return tiptap_extension_table_esm_AllBookmark };

  return AllSelection;
}(tiptap_extension_table_esm_Selection));

tiptap_extension_table_esm_Selection.jsonID("all", tiptap_extension_table_esm_AllSelection);

var tiptap_extension_table_esm_AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new tiptap_extension_table_esm_AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function tiptap_extension_table_esm_findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return tiptap_extension_table_esm_TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = tiptap_extension_table_esm_findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && tiptap_extension_table_esm_NodeSelection.isSelectable(child)) {
      return tiptap_extension_table_esm_NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function tiptap_extension_table_esm_selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof tiptap_extension_table_esm_ReplaceStep || step instanceof tiptap_extension_table_esm_ReplaceAroundStep)) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(tiptap_extension_table_esm_Selection.near(tr.doc.resolve(end), bias));
}

var tiptap_extension_table_esm_UPDATED_SEL = 1, tiptap_extension_table_esm_UPDATED_MARKS = 2, tiptap_extension_table_esm_UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var tiptap_extension_table_esm_Transaction = /*@__PURE__*/(function (Transform) {
  function Transaction(state) {
    Transform.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform ) Transaction.__proto__ = Transform;
  Transaction.prototype = Object.create( Transform && Transform.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: { configurable: true },selectionSet: { configurable: true },storedMarksSet: { configurable: true },isGeneric: { configurable: true },scrolledIntoView: { configurable: true } };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    if (selection.$from.doc != this.doc)
      { throw new RangeError("Selection passed to setSelection must point at the current document") }
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | tiptap_extension_table_esm_UPDATED_SEL) & ~tiptap_extension_table_esm_UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & tiptap_extension_table_esm_UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= tiptap_extension_table_esm_UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!tiptap_extension_table_esm_Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & tiptap_extension_table_esm_UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~tiptap_extension_table_esm_UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || tiptap_extension_table_esm_Mark.none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      this.replaceRangeWith(from, to, schema.text(text, marks));
      if (!this.selection.empty) { this.setSelection(tiptap_extension_table_esm_Selection.near(this.selection.$to)); }
      return this
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    for (var _ in this.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= tiptap_extension_table_esm_UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & tiptap_extension_table_esm_UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(tiptap_extension_table_esm_Transform));

function tiptap_extension_table_esm_bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var tiptap_extension_table_esm_FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = tiptap_extension_table_esm_bind(desc.init, self);
  this.apply = tiptap_extension_table_esm_bind(desc.apply, self);
};

var tiptap_extension_table_esm_baseFields = [
  new tiptap_extension_table_esm_FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new tiptap_extension_table_esm_FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || tiptap_extension_table_esm_Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new tiptap_extension_table_esm_FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new tiptap_extension_table_esm_FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var tiptap_extension_table_esm_Configuration = function Configuration(schema, plugins) {
  var this$1$1 = this;

  this.schema = schema;
  this.fields = tiptap_extension_table_esm_baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1$1.plugins.push(plugin);
    this$1$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1$1.fields.push(new tiptap_extension_table_esm_FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var tiptap_extension_table_esm_EditorState = function EditorState(config) {
  this.config = config;
};

var tiptap_extension_table_esm_prototypeAccessors$1 = { schema: { configurable: true },plugins: { configurable: true },tr: { configurable: true } };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
tiptap_extension_table_esm_prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
tiptap_extension_table_esm_prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
tiptap_extension_table_esm_EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → bool
tiptap_extension_table_esm_EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
tiptap_extension_table_esm_EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }

  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
   for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
        var tr = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this, n: 0}); }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
tiptap_extension_table_esm_EditorState.prototype.applyInner = function applyInner (tr) {
  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new tiptap_extension_table_esm_EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
  }
  for (var i$1 = 0; i$1 < tiptap_extension_table_esm_applyListeners.length; i$1++) { tiptap_extension_table_esm_applyListeners[i$1](this, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
tiptap_extension_table_esm_prototypeAccessors$1.tr.get = function () { return new tiptap_extension_table_esm_Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use (only relevant if no `doc` is specified).
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
tiptap_extension_table_esm_EditorState.create = function create (config) {
  var $config = new tiptap_extension_table_esm_Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
  var instance = new tiptap_extension_table_esm_EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   plugins:: [Plugin]
//   New set of active plugins.
tiptap_extension_table_esm_EditorState.prototype.reconfigure = function reconfigure (config) {
  var $config = new tiptap_extension_table_esm_Configuration(this.schema, config.plugins);
  var fields = $config.fields, instance = new tiptap_extension_table_esm_EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
tiptap_extension_table_esm_EditorState.prototype.toJSON = function toJSON (pluginFields) {
  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
tiptap_extension_table_esm_EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new tiptap_extension_table_esm_Configuration(config.schema, config.plugins);
  var instance = new tiptap_extension_table_esm_EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = tiptap_extension_table_esm_Node.fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = tiptap_extension_table_esm_Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
//
// FIXME this is no longer needed as of prosemirror-view 1.9.0,
// though due to backwards-compat we should probably keep it around
// for a while (if only as a no-op)
tiptap_extension_table_esm_EditorState.addApplyListener = function addApplyListener (f) {
  tiptap_extension_table_esm_applyListeners.push(f);
};
tiptap_extension_table_esm_EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = tiptap_extension_table_esm_applyListeners.indexOf(f);
  if (found > -1) { tiptap_extension_table_esm_applyListeners.splice(found, 1); }
};

Object.defineProperties( tiptap_extension_table_esm_EditorState.prototype, tiptap_extension_table_esm_prototypeAccessors$1 );

var tiptap_extension_table_esm_applyListeners = [];

function createCell(cellType, cellContent) {
    if (cellContent) {
        return cellType.createChecked(null, cellContent);
    }
    return cellType.createAndFill();
}

function getTableNodeTypes(schema) {
    if (schema.cached.tableNodeTypes) {
        return schema.cached.tableNodeTypes;
    }
    const roles = {};
    Object.keys(schema.nodes).forEach(type => {
        const nodeType = schema.nodes[type];
        if (nodeType.spec.tableRole) {
            roles[nodeType.spec.tableRole] = nodeType;
        }
    });
    schema.cached.tableNodeTypes = roles;
    return roles;
}

function createTable(schema, rowsCount, colsCount, withHeaderRow, cellContent) {
    const types = getTableNodeTypes(schema);
    const headerCells = [];
    const cells = [];
    for (let index = 0; index < colsCount; index += 1) {
        const cell = createCell(types.cell, cellContent);
        if (cell) {
            cells.push(cell);
        }
        if (withHeaderRow) {
            const headerCell = createCell(types.header_cell, cellContent);
            if (headerCell) {
                headerCells.push(headerCell);
            }
        }
    }
    const rows = [];
    for (let index = 0; index < rowsCount; index += 1) {
        rows.push(types.row.createChecked(null, withHeaderRow && index === 0 ? headerCells : cells));
    }
    return types.table.createChecked(null, rows);
}

function isCellSelection(value) {
    return value instanceof index_es_CellSelection;
}

const deleteTableWhenAllCellsSelected = ({ editor }) => {
    const { selection } = editor.state;
    if (!isCellSelection(selection)) {
        return false;
    }
    let cellCount = 0;
    const table = findParentNodeClosestToPos(selection.ranges[0].$from, node => {
        return node.type.name === 'table';
    });
    table === null || table === void 0 ? void 0 : table.node.descendants(node => {
        if (node.type.name === 'table') {
            return false;
        }
        if (['tableCell', 'tableHeader'].includes(node.type.name)) {
            cellCount += 1;
        }
    });
    const allCellsSelected = cellCount === selection.ranges.length;
    if (!allCellsSelected) {
        return false;
    }
    editor.commands.deleteTable();
    return true;
};

function tiptap_extension_table_esm_updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
    let totalWidth = 0;
    let fixedWidth = true;
    let nextDOM = colgroup.firstChild;
    const row = node.firstChild;
    for (let i = 0, col = 0; i < row.childCount; i += 1) {
        const { colspan, colwidth } = row.child(i).attrs;
        for (let j = 0; j < colspan; j += 1, col += 1) {
            const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j];
            const cssWidth = hasWidth ? `${hasWidth}px` : '';
            totalWidth += hasWidth || cellMinWidth;
            if (!hasWidth) {
                fixedWidth = false;
            }
            if (!nextDOM) {
                colgroup.appendChild(document.createElement('col')).style.width = cssWidth;
            }
            else {
                if (nextDOM.style.width !== cssWidth) {
                    nextDOM.style.width = cssWidth;
                }
                nextDOM = nextDOM.nextSibling;
            }
        }
    }
    while (nextDOM) {
        const after = nextDOM.nextSibling;
        nextDOM.parentNode.removeChild(nextDOM);
        nextDOM = after;
    }
    if (fixedWidth) {
        table.style.width = `${totalWidth}px`;
        table.style.minWidth = '';
    }
    else {
        table.style.width = '';
        table.style.minWidth = `${totalWidth}px`;
    }
}
class tiptap_extension_table_esm_TableView {
    constructor(node, cellMinWidth) {
        this.node = node;
        this.cellMinWidth = cellMinWidth;
        this.dom = document.createElement('div');
        this.dom.className = 'tableWrapper';
        this.table = this.dom.appendChild(document.createElement('table'));
        this.colgroup = this.table.appendChild(document.createElement('colgroup'));
        tiptap_extension_table_esm_updateColumns(node, this.colgroup, this.table, cellMinWidth);
        this.contentDOM = this.table.appendChild(document.createElement('tbody'));
    }
    update(node) {
        if (node.type !== this.node.type) {
            return false;
        }
        this.node = node;
        tiptap_extension_table_esm_updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
        return true;
    }
    ignoreMutation(mutation) {
        return mutation.type === 'attributes' && (mutation.target === this.table || this.colgroup.contains(mutation.target));
    }
}

const Table = tiptap_core_esm_Node.create({
    name: 'table',
    // @ts-ignore
    addOptions() {
        return {
            HTMLAttributes: {},
            resizable: false,
            handleWidth: 5,
            cellMinWidth: 25,
            // TODO: fix
            View: tiptap_extension_table_esm_TableView,
            lastColumnResizable: true,
            allowTableNodeSelection: false,
        };
    },
    content: 'tableRow+',
    tableRole: 'table',
    isolating: true,
    group: 'block',
    parseHTML() {
        return [
            { tag: 'table' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['table', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), ['tbody', 0]];
    },
    addCommands() {
        return {
            insertTable: ({ rows = 3, cols = 3, withHeaderRow = true } = {}) => ({ tr, dispatch, editor }) => {
                const node = createTable(editor.schema, rows, cols, withHeaderRow);
                if (dispatch) {
                    const offset = tr.selection.anchor + 1;
                    tr.replaceSelectionWith(node)
                        .scrollIntoView()
                        .setSelection(tiptap_extension_table_esm_TextSelection.near(tr.doc.resolve(offset)));
                }
                return true;
            },
            addColumnBefore: () => ({ state, dispatch }) => {
                return addColumnBefore(state, dispatch);
            },
            addColumnAfter: () => ({ state, dispatch }) => {
                return addColumnAfter(state, dispatch);
            },
            deleteColumn: () => ({ state, dispatch }) => {
                return deleteColumn(state, dispatch);
            },
            addRowBefore: () => ({ state, dispatch }) => {
                return addRowBefore(state, dispatch);
            },
            addRowAfter: () => ({ state, dispatch }) => {
                return addRowAfter(state, dispatch);
            },
            deleteRow: () => ({ state, dispatch }) => {
                return deleteRow(state, dispatch);
            },
            deleteTable: () => ({ state, dispatch }) => {
                return deleteTable(state, dispatch);
            },
            mergeCells: () => ({ state, dispatch }) => {
                return mergeCells(state, dispatch);
            },
            splitCell: () => ({ state, dispatch }) => {
                return splitCell(state, dispatch);
            },
            toggleHeaderColumn: () => ({ state, dispatch }) => {
                return toggleHeader('column')(state, dispatch);
            },
            toggleHeaderRow: () => ({ state, dispatch }) => {
                return toggleHeader('row')(state, dispatch);
            },
            toggleHeaderCell: () => ({ state, dispatch }) => {
                return toggleHeaderCell(state, dispatch);
            },
            mergeOrSplit: () => ({ state, dispatch }) => {
                if (mergeCells(state, dispatch)) {
                    return true;
                }
                return splitCell(state, dispatch);
            },
            setCellAttribute: (name, value) => ({ state, dispatch }) => {
                return setCellAttr(name, value)(state, dispatch);
            },
            goToNextCell: () => ({ state, dispatch }) => {
                return goToNextCell(1)(state, dispatch);
            },
            goToPreviousCell: () => ({ state, dispatch }) => {
                return goToNextCell(-1)(state, dispatch);
            },
            fixTables: () => ({ state, dispatch }) => {
                if (dispatch) {
                    fixTables(state);
                }
                return true;
            },
            setCellSelection: position => ({ tr, dispatch }) => {
                if (dispatch) {
                    const selection = index_es_CellSelection.create(tr.doc, position.anchorCell, position.headCell);
                    // @ts-ignore
                    tr.setSelection(selection);
                }
                return true;
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            Tab: () => {
                if (this.editor.commands.goToNextCell()) {
                    return true;
                }
                if (!this.editor.can().addRowAfter()) {
                    return false;
                }
                return this.editor
                    .chain()
                    .addRowAfter()
                    .goToNextCell()
                    .run();
            },
            'Shift-Tab': () => this.editor.commands.goToPreviousCell(),
            Backspace: deleteTableWhenAllCellsSelected,
            'Mod-Backspace': deleteTableWhenAllCellsSelected,
            Delete: deleteTableWhenAllCellsSelected,
            'Mod-Delete': deleteTableWhenAllCellsSelected,
        };
    },
    addProseMirrorPlugins() {
        const isResizable = this.options.resizable && this.editor.isEditable;
        return [
            ...(isResizable ? [columnResizing({
                    handleWidth: this.options.handleWidth,
                    cellMinWidth: this.options.cellMinWidth,
                    View: this.options.View,
                    // TODO: PR for @types/prosemirror-tables
                    // @ts-ignore (incorrect type)
                    lastColumnResizable: this.options.lastColumnResizable,
                })] : []),
            tableEditing({
                allowTableNodeSelection: this.options.allowTableNodeSelection,
            }),
        ];
    },
    extendNodeSchema(extension) {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        return {
            tableRole: callOrReturn(getExtensionField(extension, 'tableRole', context)),
        };
    },
});


//# sourceMappingURL=tiptap-extension-table.esm.js.map

// CONCATENATED MODULE: ./src/extensions/CellMenu/key.ts

var key_key = new PluginKey("cellMenu");
/* harmony default export */ var CellMenu_key = (key_key);
// CONCATENATED MODULE: ./src/extensions/Table/key.ts

var Table_key_key = new PluginKey("tableCustom");
/* harmony default export */ var Table_key = (Table_key_key);
// CONCATENATED MODULE: ./src/extensions/Table/commands.ts


 // rows in cell rect (CellSelection or anchor) before deletion

var commands_highlightTableRows = function highlightTableRows(shouldHighlight) {
  return function (_ref) {
    var state = _ref.state,
        dispatch = _ref.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightRow: shouldHighlight
      }));
      return true;
    }

    return false;
  };
}; // all table before deletion

var commands_highlightTable = function highlightTable(shouldHighlight) {
  return function (_ref2) {
    var state = _ref2.state,
        dispatch = _ref2.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightTable: shouldHighlight
      }));
      return true;
    }

    return false;
  };
}; // rows in cell rect when trying to add row before

var commands_highlightRowBefore = function highlightRowBefore(shouldHighlight) {
  return function (_ref3) {
    var state = _ref3.state,
        dispatch = _ref3.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightRowBefore: shouldHighlight
      }));
      return true;
    }

    return false;
  };
}; // rows in cell rect when trying to add row after

var commands_highlightRowAfter = function highlightRowAfter(shouldHighlight) {
  return function (_ref4) {
    var state = _ref4.state,
        dispatch = _ref4.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightRowAfter: shouldHighlight
      }));
      return true;
    }

    return false;
  };
}; // columns in cell rect when tying to add columns before

var commands_highlightColumnBefore = function highlightColumnBefore(shouldHighlight) {
  return function (_ref5) {
    var state = _ref5.state,
        dispatch = _ref5.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightColumnBefore: shouldHighlight
      }));
      return true;
    }

    return false;
  };
}; // columns in cell rect when tying to add columns after

var commands_highlightColumnAfter = function highlightColumnAfter(shouldHighlight) {
  return function (_ref6) {
    var state = _ref6.state,
        dispatch = _ref6.dispatch;

    if (dispatch) {
      dispatch(state.tr.setMeta(CellMenu_key, {
        highlightColumnAfter: shouldHighlight
      }));
      return true;
    }

    return false;
  };
};

var commands_toggleFirstColumnDecoration = function toggleFirstColumnDecoration(isFirstColumnHeader, state, dispatch) {
  if (dispatch) {
    dispatch(state.tr.setMeta(Table_key, {
      isFirstColumnHeader: isFirstColumnHeader
    }));
    return true;
  }

  return false;
};

var commands_toggleHeaderColumn = toggleHeader("column");
var commands_toggleHeaderRow = toggleHeader("row"); // this command don't take into account cell from first row & first column

var toggleNormalizedColumnHeader = function toggleNormalizedColumnHeader(isFirstColumnHeader) {
  return function (_ref7) {
    var state = _ref7.state,
        dispatch = _ref7.dispatch;
    commands_toggleFirstColumnDecoration(isFirstColumnHeader, state, dispatch);
    return commands_toggleHeaderColumn(state, dispatch);
  };
}; // this command don't take into account cell from first row & first column

var toggleNormalizedRowHeader = function toggleNormalizedRowHeader() {
  return function (_ref8) {
    var state = _ref8.state,
        dispatch = _ref8.dispatch;
    return commands_toggleHeaderRow(state, dispatch);
  };
};
// CONCATENATED MODULE: ./src/extensions/Table/decorations.ts






var decorations_computeDecoration = function computeDecoration(start, end, className) {
  return Decoration.node(start, end, {
    class: className
  });
};

var decorations_highlightAllTable = function highlightAllTable(state, decorations) {
  if (!isInTable(state)) return;
  var rect = selectedRect(state),
      tr = state.tr;
  var map = rect.map,
      table = rect.table,
      tableStart = rect.tableStart;
  var maxColIdx = map.width - 1;
  var maxRowIdx = map.height - 1;
  var mapStart = tr.mapping.maps.length;

  for (var row = 0; row <= maxRowIdx;) {
    var _cell5;

    var cell = null;

    for (var col = 0; col <= maxColIdx;) {
      var _cell, _cell2, _cell3, _cell4;

      var index = row * map.width + col;
      var pos = map.map[index];
      cell = table.nodeAt(pos);
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      var end = start + (((_cell = cell) === null || _cell === void 0 ? void 0 : _cell.nodeSize) || 1);
      decorations.push(decorations_computeDecoration(start, end, "highlight-column"));

      if (row === 0) {
        decorations.push(decorations_computeDecoration(start, end, "highlight-column-first-row"));
      }

      if (row === maxRowIdx) {
        decorations.push(decorations_computeDecoration(start, end, "highlight-column-last-row"));
      }

      if (col === 0) {
        decorations.push(decorations_computeDecoration(start, end, "highlight-column-first-column"));
      }

      var isLastColumn = ((_cell2 = cell) === null || _cell2 === void 0 ? void 0 : _cell2.attrs.colspan) !== 1 ? col + ((_cell3 = cell) === null || _cell3 === void 0 ? void 0 : _cell3.attrs.colspan) - 1 === maxColIdx : col === maxColIdx;

      if (isLastColumn) {
        decorations.push(decorations_computeDecoration(start, end, "highlight-column-last-column"));
      }

      col += ((_cell4 = cell) === null || _cell4 === void 0 ? void 0 : _cell4.attrs.colspan) || 1;
    }

    row += ((_cell5 = cell) === null || _cell5 === void 0 ? void 0 : _cell5.attrs.rowspan) || 1;
  }
};

var decorations_highlightRow = function highlightRow(tr, rect, rowsIdx, decorations) {
  var table = rect.table,
      tableStart = rect.tableStart;

  for (var y = 0; y <= rowsIdx.length - 1; y++) {
    var rowIdx = rowsIdx[y];
    var rowPos = 0;

    for (var i = 0; i < rowIdx; i++) {
      rowPos += table.child(i).nodeSize;
    }

    var nextRow = rowPos + table.child(rowIdx).nodeSize;
    var start = tableStart + rowPos,
        end = tableStart + nextRow;
    decorations.push(decorations_computeDecoration(start, end, "highlight-row")); // last row

    if (y === 0) {
      decorations.push(decorations_computeDecoration(start, end, "highlight-row-last"));
    } // first row


    if (y === rowsIdx.length - 1) {
      decorations.push(decorations_computeDecoration(start, end, "highlight-row-first"));
    }
  }
}; // take into account multiple rows in CellSelection


var decorations_highlightRows = function highlightRows(state, decorations) {
  if (!isInTable(state)) return;
  var rect = selectedRect(state),
      tr = state.tr,
      rowsIdx = [];
  if (rect.top == 0 && rect.bottom == rect.map.height) return;

  for (var i = rect.bottom - 1;; i--) {
    rowsIdx.push(i);
    if (i == rect.top) break;
  }

  decorations_highlightRow(tr, rect, rowsIdx, decorations);
};
var decorations_highlightRowCells = function highlightRowCells(state, position, decorations) {
  if (!isInTable(state)) return;
  var rect = selectedRect(state),
      tr = state.tr;
  var map = rect.map,
      table = rect.table,
      tableStart = rect.tableStart;
  var maxColIdx = map.width - 1;
  var mapStart = tr.mapping.maps.length;
  var rowIdx = position === "before" ? rect.top : rect.bottom - 1;
  var cell = null;

  for (var col = 0; col <= maxColIdx;) {
    var _cell6, _cell8;

    var index = rowIdx * map.width + col;
    var pos = map.map[index];
    cell = table.nodeAt(pos);
    var start = tr.mapping.slice(mapStart).map(tableStart + pos);
    var end = start + (((_cell6 = cell) === null || _cell6 === void 0 ? void 0 : _cell6.nodeSize) || 1);
    var rightCell = col < map.width - 1 ? table.nodeAt(map.map[index + 1]) : null;
    decorations.push(decorations_computeDecoration(start, end, "highlight-column"));
    decorations.push(decorations_computeDecoration(start, end, "highlight-column-adding-row"));
    decorations.push(decorations_computeDecoration(start, end, position === "before" ? "highlight-column-first-row" : "highlight-column-last-row")); // skip right cell if it has more than one rowspan

    if (rightCell != null && rightCell.attrs.rowspan > 1) {
      var _cell7;

      col += (((_cell7 = cell) === null || _cell7 === void 0 ? void 0 : _cell7.attrs.colspan) || 1) + rightCell.attrs.colspan;
      continue;
    }

    col += ((_cell8 = cell) === null || _cell8 === void 0 ? void 0 : _cell8.attrs.colspan) || 1;
  }
};
var decorations_highlightColumnCells = function highlightColumnCells(state, position, decorations) {
  if (!isInTable(state)) return;
  var rect = selectedRect(state),
      tr = state.tr;
  var map = rect.map,
      table = rect.table,
      tableStart = rect.tableStart;
  var mapStart = tr.mapping.maps.length;
  var colIdx = position === "before" ? rect.left : rect.right - 1;
  var maxRowIdx = map.height - 1;
  var cell = null;

  for (var row = 0; row <= maxRowIdx;) {
    var _cell9, _cell11;

    var index = row * map.width + colIdx;
    var pos = map.map[index];
    cell = table.nodeAt(pos);
    var start = tr.mapping.slice(mapStart).map(tableStart + pos);
    var end = start + (((_cell9 = cell) === null || _cell9 === void 0 ? void 0 : _cell9.nodeSize) || 1);
    var hasColspan = position === "before" ? colIdx > 0 && map.map[index - 1] == pos : colIdx < map.width - 1 && map.map[index + 1] == pos;

    if (hasColspan) {
      var _cell10;

      row += ((_cell10 = cell) === null || _cell10 === void 0 ? void 0 : _cell10.attrs.rowspan) || 1;
      continue;
    }

    decorations.push(decorations_computeDecoration(start, end, "highlight-column"));
    decorations.push(decorations_computeDecoration(start, end, "highlight-column-adding-column"));
    decorations.push(decorations_computeDecoration(start, end, position === "before" ? "highlight-column-first-column" : "highlight-column-last-column"));
    row += ((_cell11 = cell) === null || _cell11 === void 0 ? void 0 : _cell11.attrs.rowspan) || 1;
  }
};
var decorations_appendFirstColumnSticky = function appendFirstColumnSticky(state, decorations) {
  if (!isInTable(state)) return;
  var rect = selectedRect(state),
      tr = state.tr;
  var map = rect.map,
      table = rect.table,
      tableStart = rect.tableStart;
  var mapStart = tr.mapping.maps.length;
  var pos = map.map[0];
  var cell = table.nodeAt(pos);
  var start = tr.mapping.slice(mapStart).map(tableStart + pos);
  var end = start + ((cell === null || cell === void 0 ? void 0 : cell.nodeSize) || 1);
  decorations.push(decorations_computeDecoration(start, end, "sticky-first-column"));
};
function decorations_highlightColumn(tr, rect, col, decorations) {
  var map = rect.map,
      table = rect.table,
      tableStart = rect.tableStart;
  var mapStart = tr.mapping.maps.length;
  var firstRow = 0;

  for (var row = 0; row < map.height;) {
    var index = row * map.width + col,
        pos = map.map[index],
        cell = table.nodeAt(pos); // If this is part of a col-spanning cell

    if (col > 0 && map.map[index - 1] == pos || col < map.width - 1 && map.map[index + 1] == pos) {
      firstRow++;
      row += (cell === null || cell === void 0 ? void 0 : cell.attrs.rowspan) || 1;
      continue;
    } else {
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      var end = start + ((cell === null || cell === void 0 ? void 0 : cell.nodeSize) || 1);
      decorations.push(Decoration.node(start, end, {
        class: "highlight-column"
      }, {
        highlight: true
      }));

      if (row === firstRow) {
        decorations.push(Decoration.node(start, end, {
          class: "highlight-column-first-row"
        }));
      }

      if (row === map.height - 1) {
        decorations.push(Decoration.node(start, end, {
          class: "highlight-column-last-row"
        }));
      }

      if (col === rect.right - 1) {
        decorations.push(Decoration.node(start, end, {
          class: "highlight-column-last-column"
        }));
      }

      if (col === rect.left) {
        decorations.push(Decoration.node(start, end, {
          class: "highlight-column-first-column"
        }));
      }
    }

    row += (cell === null || cell === void 0 ? void 0 : cell.attrs.rowspan) || 1;
  }
}
function highlightColumns(state, decorations) {
  if (!isInTable(state)) return false;
  var rect = selectedRect(state),
      tr = state.tr;
  if (rect.left == 0 && rect.right == rect.map.width) return false;

  for (var i = rect.right - 1;; i--) {
    decorations_highlightColumn(tr, rect, i, decorations);
    if (i == rect.left) break;
  }

  return true;
}
// CONCATENATED MODULE: ./src/extensions/Table/Table.ts












var CustomTable = Table.extend({
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this$parent;

    var plugins = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)) || [];
    plugins.push(new Plugin({
      key: Table_key,
      state: {
        init: function init() {
          var initState = {
            isFirstColumnHeader: false
          };
          return initState;
        },
        apply: function apply(tr, prev) {
          return Object.assign({}, prev, tr.getMeta(Table_key));
        }
      },
      props: {
        decorations: function decorations(state) {
          var _ref = CellMenu_key.getState(state) || {},
              highlightRow = _ref.highlightRow,
              highlightColumn = _ref.highlightColumn,
              highlightTable = _ref.highlightTable,
              highlightColumnBefore = _ref.highlightColumnBefore,
              highlightColumnAfter = _ref.highlightColumnAfter,
              highlightRowBefore = _ref.highlightRowBefore,
              highlightRowAfter = _ref.highlightRowAfter;

          var _this$getState = this.getState(state),
              isFirstColumnHeader = _this$getState.isFirstColumnHeader;

          if ([highlightColumn, highlightRow, highlightTable, highlightColumnBefore, highlightColumnAfter, highlightRowBefore, highlightRowAfter, isFirstColumnHeader].every(function (val) {
            return !val;
          })) {
            return DecorationSet.empty;
          }

          var decorations = [];

          if (isFirstColumnHeader) {
            decorations_appendFirstColumnSticky(state, decorations);
          }

          if (highlightRow) {
            decorations_highlightRows(state, decorations);
          } // if (highlightColumn) {
          // highlightColumns(state, decorations);
          // }


          if (highlightTable) {
            decorations_highlightAllTable(state, decorations);
          }

          if (highlightRowBefore) {
            decorations_highlightRowCells(state, "before", decorations);
          }

          if (highlightRowAfter) {
            decorations_highlightRowCells(state, "after", decorations);
          }

          if (highlightColumnBefore) {
            decorations_highlightColumnCells(state, "before", decorations);
          }

          if (highlightColumnAfter) {
            decorations_highlightColumnCells(state, "after", decorations);
          }

          return decorations.length ? DecorationSet.create(state.doc, decorations) : DecorationSet.empty;
        }
      }
    }));

    if (!this.editor.isEditable) {
      plugins.push(columnResizing({
        handleWidth: 0,
        cellMinWidth: 25
      }));
    }

    return plugins;
  },
  addCommands: function addCommands() {
    var _this$parent2;

    return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
      highlightTableRows: commands_highlightTableRows,
      highlightTable: commands_highlightTable,
      highlightRowBefore: commands_highlightRowBefore,
      highlightRowAfter: commands_highlightRowAfter,
      highlightColumnBefore: commands_highlightColumnBefore,
      highlightColumnAfter: commands_highlightColumnAfter,
      toggleNormalizedColumnHeader: toggleNormalizedColumnHeader,
      toggleNormalizedRowHeader: toggleNormalizedRowHeader
    });
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this$parent3;

    var parent = ((_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)) || {};

    var inhibitOnListItem = function inhibitOnListItem(commandName, editor) {
      return function () {
        if (editor.isActive("listItem")) {
          return false;
        }

        return parent[commandName]({
          editor: editor
        });
      };
    };

    return _objectSpread2(_objectSpread2({}, parent), {}, {
      Tab: inhibitOnListItem("Tab", this.editor),
      "Shift-Tab": inhibitOnListItem("Shift-Tab", this.editor)
    });
  }
});
/* harmony default export */ var Table_Table = (CustomTable);
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-table-row/dist/tiptap-extension-table-row.esm.js


const TableRow = tiptap_core_esm_Node.create({
    name: 'tableRow',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: '(tableCell | tableHeader)*',
    tableRole: 'row',
    parseHTML() {
        return [
            { tag: 'tr' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['tr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});


//# sourceMappingURL=tiptap-extension-table-row.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-table-header/dist/tiptap-extension-table-header.esm.js


const TableHeader = tiptap_core_esm_Node.create({
    name: 'tableHeader',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    addAttributes() {
        return {
            colspan: {
                default: 1,
            },
            rowspan: {
                default: 1,
            },
            colwidth: {
                default: null,
                parseHTML: element => {
                    const colwidth = element.getAttribute('colwidth');
                    const value = colwidth
                        ? [parseInt(colwidth, 10)]
                        : null;
                    return value;
                },
            },
        };
    },
    tableRole: 'header_cell',
    isolating: true,
    parseHTML() {
        return [
            { tag: 'th' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['th', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});


//# sourceMappingURL=tiptap-extension-table-header.esm.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap/extension-table-cell/dist/tiptap-extension-table-cell.esm.js


const tiptap_extension_table_cell_esm_TableCell = tiptap_core_esm_Node.create({
    name: 'tableCell',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    addAttributes() {
        return {
            colspan: {
                default: 1,
            },
            rowspan: {
                default: 1,
            },
            colwidth: {
                default: null,
                parseHTML: element => {
                    const colwidth = element.getAttribute('colwidth');
                    const value = colwidth
                        ? [parseInt(colwidth, 10)]
                        : null;
                    return value;
                },
            },
        };
    },
    tableRole: 'cell',
    isolating: true,
    parseHTML() {
        return [
            { tag: 'td' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['td', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});


//# sourceMappingURL=tiptap-extension-table-cell.esm.js.map

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/TableCell.vue?vue&type=template&id=2ae3809e&scoped=true&
var TableCellvue_type_template_id_2ae3809e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',_vm._b({staticClass:"mayday-editor__table-cell",style:(_vm.cellStyle),attrs:{"as":"td"}},'node-view-wrapper',_vm.cellAttributes,false),[_c('div',{ref:"menuWrapper",class:_vm.menuWrapperClass,style:(_vm.wrapperVisibilityStyle),attrs:{"contenteditable":"false"},on:{"mousedown":_vm.handleMenuClick}},[_c('font-awesome-icon',{ref:"menuIcon",staticClass:"icon",attrs:{"icon":['fal', 'ellipsis-h']}})],1),_c('node-view-content',{staticClass:"content"})],1)}
var TableCellvue_type_template_id_2ae3809e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/TableCell.vue?vue&type=template&id=2ae3809e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/TableCell.vue?vue&type=script&lang=ts&







var TableCellvue_type_script_lang_ts_excluded = ["backgroundColor"];








var menuWrapperClass = "mayday-editor__table-cell__menu-wrapper";

var TableCellvue_type_script_lang_ts_TableCell = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(TableCell, _BaseNodeView);

  var _super = _createSuper(TableCell);

  function TableCell() {
    var _this;

    _classCallCheck(this, TableCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isCellFocused", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isCellSelectedTo", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "menuWrapperClass", menuWrapperClass);

    return _this;
  }

  _createClass(TableCell, [{
    key: "shouldShowMenuWrapper",
    get: function get() {
      var isCellFocused = this.isCellFocused,
          isCellSelectedTo = this.isCellSelectedTo,
          editor = this.editor;
      return (isCellFocused || isCellSelectedTo) && editor.isEditable;
    }
  }, {
    key: "wrapperVisibilityStyle",
    get: function get() {
      var shouldShowMenuWrapper = this.shouldShowMenuWrapper;
      return {
        opacity: shouldShowMenuWrapper ? 1 : 0,
        visibility: shouldShowMenuWrapper ? "visible" : "hidden"
      };
    }
  }, {
    key: "isMenuInTarget",
    value: function isMenuInTarget(target) {
      var _this$$refs = this.$refs,
          menuWrapper = _this$$refs.menuWrapper,
          menuIcon = _this$$refs.menuIcon;
      var menuElements = [menuWrapper, menuIcon];
      return menuElements.includes(target);
    }
  }, {
    key: "updateCellState",
    value: function updateCellState(target) {
      var shouldCheckMenu = target != null;
      var isCellFocusedFromDecoration = this.decorations.findIndex(function (_ref) {
        var spec = _ref.spec;
        return spec.isCellFocused;
      }) !== -1;
      this.isCellSelectedTo = this.decorations.findIndex(function (_ref2) {
        var spec = _ref2.spec;
        return spec.isCellSelectedTo;
      }) !== -1;
      this.isCellFocused = shouldCheckMenu ? isCellFocusedFromDecoration || this.isMenuInTarget(target) : isCellFocusedFromDecoration;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var target = event.target;
      this.updateCellState(target);
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(event) {
      // prevent CellSelection from being lost when user click on menuWrapper
      // also prevent editor from loosing cell focus
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: "handleShortcut",
    value: function handleShortcut(event) {
      var key = event.key;
      var possibleKeys = ["Tab", "ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp"]; // NOTE: shift key might be hold

      if (possibleKeys.includes(key)) {
        this.updateCellState();
      }
    }
  }, {
    key: "cellAttributes",
    get: function get() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$node$attrs = this.node.attrs,
          backgroundColor = _this$node$attrs.backgroundColor,
          attrs = _objectWithoutProperties(_this$node$attrs, TableCellvue_type_script_lang_ts_excluded);

      return attrs;
    }
  }, {
    key: "cellStyle",
    get: function get() {
      var backgroundColor = this.node.attrs.backgroundColor;

      if (typeof backgroundColor !== "string") {
        return {};
      }

      return {
        backgroundColor: backgroundColor
      };
    }
  }, {
    key: "mounted",
    value: function mounted() {
      document.body.addEventListener("click", this.handleFocus);
      document.body.addEventListener("touchend", this.handleFocus);
      document.body.addEventListener("keyup", this.handleShortcut);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      document.body.removeEventListener("click", this.handleFocus);
      document.body.removeEventListener("touchend", this.handleFocus);
      document.body.removeEventListener("keyup", this.handleShortcut);
    }
  }]);

  return TableCell;
}(nodes_BaseNodeView);

TableCellvue_type_script_lang_ts_TableCell = __decorate([external_vue_property_decorator_["Component"]], TableCellvue_type_script_lang_ts_TableCell);
/* harmony default export */ var TableCellvue_type_script_lang_ts_ = (TableCellvue_type_script_lang_ts_TableCell);
// CONCATENATED MODULE: ./src/components/nodes/TableCell.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_TableCellvue_type_script_lang_ts_ = (TableCellvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/TableCell.vue?vue&type=style&index=0&id=2ae3809e&lang=scss&scoped=true&
var TableCellvue_type_style_index_0_id_2ae3809e_lang_scss_scoped_true_ = __webpack_require__("711f");

// CONCATENATED MODULE: ./src/components/nodes/TableCell.vue






/* normalize component */

var TableCell_component = normalizeComponent(
  nodes_TableCellvue_type_script_lang_ts_,
  TableCellvue_type_template_id_2ae3809e_scoped_true_render,
  TableCellvue_type_template_id_2ae3809e_scoped_true_staticRenderFns,
  false,
  null,
  "2ae3809e",
  null
  
)

/* harmony default export */ var nodes_TableCell = (TableCell_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("18a5");

// CONCATENATED MODULE: ./src/utils/isCellSelection.ts

function isCellSelection_isCellSelection(value) {
  return value instanceof index_es_CellSelection;
}
// CONCATENATED MODULE: ./src/extensions/CellMenu/CellMenuView.ts










var CellMenuView_CellMenuView = /*#__PURE__*/function () {
  function CellMenuView(_ref) {
    var _this = this;

    var editor = _ref.editor,
        element = _ref.element,
        view = _ref.view;

    _classCallCheck(this, CellMenuView);

    Object(defineProperty["a" /* default */])(this, "editor", void 0);

    Object(defineProperty["a" /* default */])(this, "element", void 0);

    Object(defineProperty["a" /* default */])(this, "view", void 0);

    Object(defineProperty["a" /* default */])(this, "preventHide", false);

    Object(defineProperty["a" /* default */])(this, "interactedWithTooltip", false);

    Object(defineProperty["a" /* default */])(this, "lastCellRect", null);

    Object(defineProperty["a" /* default */])(this, "tippy", void 0);

    Object(defineProperty["a" /* default */])(this, "tableCellPredicate", function (_ref2) {
      var type = _ref2.type;
      return type.name === "tableCell";
    });

    Object(defineProperty["a" /* default */])(this, "mousedownHandler", function () {
      _this.preventHide = true;
    });

    Object(defineProperty["a" /* default */])(this, "focusHandler", function () {
      // we use `setTimeout` to make sure `selection` is already updated
      window.setTimeout(function () {
        if (_this.editor) {
          _this.update(_this.editor.view);
        }
      });
    });

    Object(defineProperty["a" /* default */])(this, "blurHandler", function (_ref3) {
      var _this$element$parentN;

      var event = _ref3.event;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if (event !== null && event !== void 0 && event.relatedTarget && (_this$element$parentN = _this.element.parentNode) !== null && _this$element$parentN !== void 0 && _this$element$parentN.contains(event.relatedTarget)) {
        return;
      }

      _this.hide();
    });

    Object(defineProperty["a" /* default */])(this, "scrollHandler", function () {
      var _this$tippy;

      var isShown = ((_this$tippy = _this.tippy) === null || _this$tippy === void 0 ? void 0 : _this$tippy.state.isShown) || false;
      isShown && _this.hide();
    });

    Object(defineProperty["a" /* default */])(this, "handleTooltipMousedown", function () {
      _this.interactedWithTooltip = true;
    });

    Object(defineProperty["a" /* default */])(this, "findParentCell", findParentNode(this.tableCellPredicate));

    this.editor = editor;
    this.element = element;
    this.view = view;
    this.element.addEventListener("mousedown", this.mousedownHandler, {
      capture: true
    });
    this.editor.on("focus", this.focusHandler);
    this.editor.on("blur", this.blurHandler); // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = "visible";
  }

  _createClass(CellMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var _this2 = this;

      if (!this.editor) {
        if (this.tippy) {
          this.tippy.destroy();
        }

        return;
      }

      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy_esm(editorElement, {
        animation: "shift-away",
        duration: [330, 200],
        theme: "bubble-menu",
        maxWidth: 200,
        appendTo: function appendTo() {
          return document.body;
        },
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: "manual",
        placement: "right-start",
        arrow: false,
        sticky: "reference",
        moveTransition: "transform 200ms ease-out",
        plugins: [sticky],
        onShow: function onShow() {
          _this2.element.addEventListener("mousedown", _this2.handleTooltipMousedown);
        },
        onHide: function onHide() {
          _this2.interactedWithTooltip = false;

          _this2.element.removeEventListener("mousedown", _this2.handleTooltipMousedown);
        },
        onClickOutside: function onClickOutside() {
          _this2.hide();
        },
        onShown: function onShown() {
          if (_this2.editor) {
            var _this2$editor = _this2.editor,
                state = _this2$editor.state,
                view = _this2$editor.view;
            view.dispatch(state.tr.setMeta(CellMenu_key, {
              isMenuOpened: true
            }));
          }
        },
        onHidden: function onHidden() {
          if (_this2.editor) {
            var _this2$editor2 = _this2.editor,
                state = _this2$editor2.state,
                view = _this2$editor2.view;
            view.dispatch(state.tr.setMeta(CellMenu_key, {
              isMenuOpened: false
            }));
          }
        }
      });
    }
  }, {
    key: "computeCellPos",
    value: function computeCellPos(selection) {
      var pos = -1;
      var parentCell = this.findParentCell(selection);
      pos = (parentCell === null || parentCell === void 0 ? void 0 : parentCell.pos) || pos;
      return pos;
    }
  }, {
    key: "getCellDom",
    value: function getCellDom(view, selection) {
      var pos = this.computeCellPos(selection);
      var node = view.nodeDOM(pos !== -1 ? pos : selection.anchor);
      return node != null ? node : undefined;
    }
  }, {
    key: "computeIsSelection",
    value: function computeIsSelection(selection) {
      var isSelection = isCellSelection_isCellSelection(selection);

      if (isCellSelection_isCellSelection(selection)) {
        selection.forEachCell(function (_ref4) {
          var type = _ref4.type;

          if (isSelection && type.name === "tableHeader") {
            isSelection = false;
          }
        });
      }

      return isSelection;
    }
  }, {
    key: "computeIsSelectedTo",
    value: function computeIsSelectedTo(selection) {
      return !isCellSelection_isCellSelection(selection) && findParentNodeClosestToPos(selection.$anchor, this.tableCellPredicate) != null;
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _this$tippy3;

      var state = view.state,
          composing = view.composing;
      var doc = state.doc,
          selection = state.selection;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      if (composing || isSame) {
        return;
      }

      this.createTooltip();
      var isSelection = this.computeIsSelection(selection);
      var isFocused = this.computeIsSelectedTo(selection); // register state for rowHighlighter and columnHighlighter

      view.dispatch(state.tr.setMeta(CellMenu_key, {
        isSelection: isSelection,
        isFocused: isFocused
      }));

      if (!isFocused && !isSelection) {
        this.hide();
        return;
      }

      var cellDom = this.getCellDom(view, selection);

      if (cellDom == null) {
        return;
      }

      var reference = cellDom.querySelector(".".concat(menuWrapperClass)); // allow interactive mode to stay on

      if (this.interactedWithTooltip || reference == null) {
        // handle when splitting/merging cells (last cell may have disappears)
        if (reference != null && reference.style.visibility === "hidden") {
          var lastCellRect = this.lastCellRect;

          if (lastCellRect != null) {
            var _this$tippy2;

            (_this$tippy2 = this.tippy) === null || _this$tippy2 === void 0 ? void 0 : _this$tippy2.setProps({
              getReferenceClientRect: function getReferenceClientRect() {
                return lastCellRect;
              }
            });
          }

          this.hide();
        }

        return;
      }

      this.lastCellRect = reference.getBoundingClientRect(); // handle tippy instance

      (_this$tippy3 = this.tippy) === null || _this$tippy3 === void 0 ? void 0 : _this$tippy3.setProps({
        getReferenceClientRect: function getReferenceClientRect() {
          return reference.getBoundingClientRect();
        },
        trigger: "click",
        triggerTarget: reference
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this$tippy4;

      (_this$tippy4 = this.tippy) === null || _this$tippy4 === void 0 ? void 0 : _this$tippy4.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$tippy5;

      (_this$tippy5 = this.tippy) === null || _this$tippy5 === void 0 ? void 0 : _this$tippy5.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$tippy6;

      (_this$tippy6 = this.tippy) === null || _this$tippy6 === void 0 ? void 0 : _this$tippy6.destroy();
      this.element.removeEventListener("mousedown", this.mousedownHandler, {
        capture: true
      });

      if (this.editor) {
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
      }

      this.element.remove();
      this.editor = null;
    }
  }]);

  return CellMenuView;
}();
// CONCATENATED MODULE: ./src/extensions/CellMenu/CellMenuPlugin.ts







 // version with ProseMirror View

var CellMenuPlugin_CellMenuPlugin = function CellMenuPlugin(options) {
  return new Plugin({
    key: CellMenu_key,
    view: function view(_view) {
      return new CellMenuView_CellMenuView(_objectSpread2({
        view: _view
      }, options));
    },
    state: {
      init: function init() {
        var initState = {
          isSelection: false,
          isFocused: false,
          isMenuOpened: false,
          highlightRow: false,
          highlightColumn: false,
          highlightTable: false,
          highlightRowBefore: false,
          highlightRowAfter: false,
          highlightColumnBefore: false,
          highlightColumnAfter: false
        };
        return initState;
      },
      apply: function apply(tr, prev) {
        return Object.assign({}, prev, tr.getMeta(CellMenu_key));
      }
    },
    props: {
      decorations: function decorations(state) {
        var selection = state.selection,
            doc = state.doc;

        var _this$getState = this.getState(state),
            isCellSelectedTo = _this$getState.isSelection,
            isCellFocused = _this$getState.isFocused;

        if (!isCellSelectedTo && !isCellFocused) {
          return DecorationSet.empty;
        }

        var parentCellPos = findParentNode(function (_ref) {
          var type = _ref.type;
          return type.name === "tableCell";
        })(selection);

        if (parentCellPos == null) {
          return DecorationSet.empty;
        }

        var cellPos = [parentCellPos.pos, parentCellPos.pos + parentCellPos.node.nodeSize];
        var className = isCellSelectedTo ? "is-cell-selection" : "is-cell-focused";
        var spec = isCellSelectedTo ? {
          isCellSelectedTo: isCellSelectedTo
        } : {
          isCellFocused: isCellFocused
        };
        var decoration = Decoration.node(cellPos[0], cellPos[1], {
          class: className
        }, spec);
        return DecorationSet.create(doc, [decoration]);
      }
    }
  });
};
// CONCATENATED MODULE: ./src/extensions/TableCell.ts





var cellMenuClass = "mayday-editor__cell-menu";

var TableCell_CustomTableCell = function CustomTableCell(options) {
  return tiptap_extension_table_cell_esm_TableCell.extend({
    addOptions: function addOptions() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), options);
    },
    addAttributes: function addAttributes() {
      var _this$parent2;

      return _objectSpread2(_objectSpread2({}, (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.call(this)), {}, {
        // add background color attribute
        backgroundColor: {
          default: null,
          parseHTML: function parseHTML(element) {
            var color = element.getAttribute("data-background-color"); // old version background-color

            if (!color) {
              color = element.style.backgroundColor;
            }

            return color;
          },
          renderHTML: function renderHTML(attributes) {
            return {
              "data-background-color": attributes.backgroundColor
            };
          }
        },
        colwidth: {
          default: null,
          parseHTML: function parseHTML(element) {
            var colwidth = element.getAttribute("colwidth"); // old version colwidth

            if (!colwidth) {
              colwidth = element.getAttribute("data-colwidth");
            }

            var value = colwidth ? [parseInt(colwidth, 10)] : null;
            return value;
          }
        }
      });
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_TableCell, {
        // allow cell resizing
        stopEvent: function stopEvent() {
          return false;
        }
      });
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var _this$parent3;

      var plugins = ((_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.call(this)) || [];

      if (this.options.element != null) {
        plugins.push(CellMenuPlugin_CellMenuPlugin({
          editor: this.editor,
          element: this.options.element
        }));
      }

      return plugins;
    }
  });
};

var computeCustomTableCellNode = function computeCustomTableCellNode($el, options) {
  var element = $el.querySelector(".".concat(cellMenuClass));
  return TableCell_CustomTableCell({
    element: element,
    HTMLAttributes: (options === null || options === void 0 ? void 0 : options.HTMLAttributes) || {}
  });
};

/* harmony default export */ var extensions_TableCell = (computeCustomTableCellNode);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__("bf19");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Callout.vue?vue&type=template&id=6c4f8964&scoped=true&
var Calloutvue_type_template_id_6c4f8964_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{class:_vm.containerClass,attrs:{"as":"div"}},[_c('div',{class:(_vm.baseClass + "__icon-wrapper"),attrs:{"contenteditable":"false"}},[_c('font-awesome-icon',{staticClass:"icon",class:(_vm.baseClass + "-" + _vm.levelAttribute),attrs:{"icon":['fas', _vm.icon]}})],1),_c('node-view-content',{class:(_vm.baseClass + "__content")})],1)}
var Calloutvue_type_template_id_6c4f8964_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/Callout.vue?vue&type=template&id=6c4f8964&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/Callout.vue?vue&type=script&lang=ts&















var calloutClass = "mayday-editor__callout";

var Calloutvue_type_script_lang_ts_Callout = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(Callout, _BaseNodeView);

  var _super = _createSuper(Callout);

  function Callout() {
    var _this;

    _classCallCheck(this, Callout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "levels", Object.keys(levelTypes));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "icons", levelTypes);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", calloutClass);

    return _this;
  }

  _createClass(Callout, [{
    key: "containerClass",
    get: function get() {
      var _ref;

      var baseClass = this.baseClass,
          levelAttribute = this.levelAttribute;
      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, baseClass, true), Object(defineProperty["a" /* default */])(_ref, "".concat(baseClass, "-").concat(levelAttribute), true), _ref;
    }
  }, {
    key: "levelAttribute",
    get: function get() {
      return this.node.attrs.level;
    }
  }, {
    key: "icon",
    get: function get() {
      var levelAttribute = this.levelAttribute;

      if (!this.levels.find(function (level) {
        return levelAttribute === level;
      })) {
        return "";
      }

      return this.icons[levelAttribute];
    }
  }]);

  return Callout;
}(nodes_BaseNodeView);

Calloutvue_type_script_lang_ts_Callout = __decorate([external_vue_property_decorator_["Component"]], Calloutvue_type_script_lang_ts_Callout);
/* harmony default export */ var Calloutvue_type_script_lang_ts_ = (Calloutvue_type_script_lang_ts_Callout);
// CONCATENATED MODULE: ./src/components/nodes/Callout.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_Calloutvue_type_script_lang_ts_ = (Calloutvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/Callout.vue?vue&type=style&index=0&id=6c4f8964&lang=scss&scoped=true&
var Calloutvue_type_style_index_0_id_6c4f8964_lang_scss_scoped_true_ = __webpack_require__("dda4");

// CONCATENATED MODULE: ./src/components/nodes/Callout.vue






/* normalize component */

var Callout_component = normalizeComponent(
  nodes_Calloutvue_type_script_lang_ts_,
  Calloutvue_type_template_id_6c4f8964_scoped_true_render,
  Calloutvue_type_template_id_6c4f8964_scoped_true_staticRenderFns,
  false,
  null,
  "6c4f8964",
  null
  
)

/* harmony default export */ var nodes_Callout = (Callout_component.exports);
// CONCATENATED MODULE: ./src/extensions/Callout.ts








var levelTypes = {
  info: "info-circle",
  error: "times-circle",
  success: "check-circle",
  danger: "exclamation-triangle"
}; // level attributes map from old editor

var oldLevelTypes = {
  info: "info",
  success: "success",
  danger: "error",
  warning: "danger"
};

var contentHasText = function contentHasText(content) {
  if (!content || !content.length) return false;
  return content.some(function (el) {
    return !!el.text;
  });
};

var Callout_key = new PluginKey("calloutHighlighter");
var Callout_Callout = tiptap_core_esm_Node.create({
  name: "callout",
  group: "block",
  content: "paragraph+",
  // allow all marks
  marks: "_",
  addAttributes: function addAttributes() {
    return {
      level: {
        default: "info",
        parseHTML: function parseHTML(element) {
          return element.getAttribute("data-level");
        },
        renderHTML: function renderHTML(attributes) {
          return {
            "data-level": attributes.level
          };
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    var _this = this;

    return [{
      tag: "div",
      getAttrs: function getAttrs(node) {
        var element = node;

        var hasNodeType = element.hasAttribute("data-node-type") && element.getAttribute("data-node-type") === _this.name;

        if (!hasNodeType) {
          return false;
        }

        return null;
      }
    }, // old editor input
    {
      tag: "div",
      getAttrs: function getAttrs(node) {
        var element = node;
        var isCallout = element.classList.contains(_this.name);

        if (!isCallout) {
          return false;
        }

        var levelAttribute = element.getAttribute("data-type") || "info";
        return {
          level: oldLevelTypes[levelAttribute]
        };
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ["div", mergeAttributes(HTMLAttributes, {
      "data-node-type": this.name
    }), 0];
  },
  addCommands: function addCommands() {
    var name = this.name;
    return {
      setCallout: function setCallout(attributes) {
        return function (_ref2) {
          var chain = _ref2.chain,
              state = _ref2.state;
          var node = state.selection.$anchor.node();
          var content = node.content.toJSON();
          return chain().command(function (_ref3) {
            var tr = _ref3.tr,
                dispatch = _ref3.dispatch;
            var selection = tr.selection;
            var $anchor = selection.$anchor;

            if (!dispatch) {
              return false;
            }

            var from = $anchor.before();
            var to = $anchor.after();
            tr.delete(from, to);
            tr.setSelection(index_es_TextSelection.create(tr.doc, from));
            return true;
          }).insertContent({
            type: name,
            attrs: attributes,
            content: [{
              type: "paragraph",
              content: contentHasText(content) ? content : undefined
            }]
          }).run();
        };
      },
      highlightCallout: function highlightCallout(shouldHighlight) {
        return function (_ref4) {
          var dispatch = _ref4.dispatch,
              tr = _ref4.tr;

          if (dispatch != null) {
            dispatch(tr.setMeta(Callout_key, {
              isHighlighted: shouldHighlight
            }));
            return true;
          }

          return false;
        };
      }
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var type = this.type;
    return [new Plugin({
      key: Callout_key,
      state: {
        init: function init() {
          return {
            isHighlighted: false
          };
        },
        apply: function apply(tr, prev) {
          return Object.assign({}, prev, tr.getMeta(Callout_key));
        }
      },
      props: {
        decorations: function decorations(state) {
          var selection = state.selection,
              doc = state.doc;
          var $anchor = selection.$anchor;

          var _this$getState = this.getState(state),
              isHighlighted = _this$getState.isHighlighted;

          var nodeInSelection = $anchor.node(1);
          var isCallout = nodeInSelection != null && nodeInSelection.type === type;

          if (isCallout && isHighlighted) {
            var $pos = doc.resolve($anchor.start(1));
            return DecorationSet.create(state.doc, [Decoration.node($pos.before(), $pos.after(), {
              class: "highlight"
            })]);
          }

          return DecorationSet.empty;
        }
      }
    })];
  },
  addNodeView: function addNodeView() {
    return VueNodeViewRenderer(nodes_Callout);
  }
});
/* harmony default export */ var extensions_Callout = (Callout_Callout);
// CONCATENATED MODULE: ./src/extensions/SmileyReplacer.ts

var SmileyReplacerExtension = Extension.create({
  name: "smileyReplacer",
  addInputRules: function addInputRules() {
    return [textInputRule({
      find: /-___- $/,
      replace: "😑 "
    }), textInputRule({
      find: /:'-\) $/,
      replace: "😂 "
    }), textInputRule({
      find: /':-\) $/,
      replace: "😅 "
    }), textInputRule({
      find: /':-D $/,
      replace: "😅 "
    }), textInputRule({
      find: />:-\) $/,
      replace: "😆 "
    }), textInputRule({
      find: /-__- $/,
      replace: "😑 "
    }), textInputRule({
      find: /':-\( $/,
      replace: "😓 "
    }), textInputRule({
      find: /:'-\( $/,
      replace: "😢 "
    }), textInputRule({
      find: />:-\( $/,
      replace: "😠 "
    }), textInputRule({
      find: /O:-\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /0:-3 $/,
      replace: "😇 "
    }), textInputRule({
      find: /0:-\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /0;\^\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /O;-\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /0;-\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /O:-3 $/,
      replace: "😇 "
    }), textInputRule({
      find: /:'\) $/,
      replace: "😂 "
    }), textInputRule({
      find: /:-D $/,
      replace: "😃 "
    }), textInputRule({
      find: /':\) $/,
      replace: "😅 "
    }), textInputRule({
      find: /'=\) $/,
      replace: "😅 "
    }), textInputRule({
      find: /':D $/,
      replace: "😅 "
    }), textInputRule({
      find: /'=D $/,
      replace: "😅 "
    }), textInputRule({
      find: />:\) $/,
      replace: "😆 "
    }), textInputRule({
      find: />;\) $/,
      replace: "😆 "
    }), textInputRule({
      find: />=\) $/,
      replace: "😆 "
    }), textInputRule({
      find: /;-\) $/,
      replace: "😉 "
    }), textInputRule({
      find: /\*-\) $/,
      replace: "😉 "
    }), textInputRule({
      find: /;-\] $/,
      replace: "😉 "
    }), textInputRule({
      find: /;\^\) $/,
      replace: "😉 "
    }), textInputRule({
      find: /B-\) $/,
      replace: "😎 "
    }), textInputRule({
      find: /8-\) $/,
      replace: "😎 "
    }), textInputRule({
      find: /B-D $/,
      replace: "😎 "
    }), textInputRule({
      find: /8-D $/,
      replace: "😎 "
    }), textInputRule({
      find: /:-\* $/,
      replace: "😘 "
    }), textInputRule({
      find: /:\^\* $/,
      replace: "😘 "
    }), textInputRule({
      find: /:-\) $/,
      replace: "🙂 "
    }), textInputRule({
      find: /-_- $/,
      replace: "😑 "
    }), textInputRule({
      find: /:-X $/,
      replace: "😶 "
    }), textInputRule({
      find: /:-# $/,
      replace: "😶 "
    }), textInputRule({
      find: /:-x $/,
      replace: "😶 "
    }), textInputRule({
      find: />.< $/,
      replace: "😣 "
    }), textInputRule({
      find: /:-O $/,
      replace: "😮 "
    }), textInputRule({
      find: /:-o $/,
      replace: "😮 "
    }), textInputRule({
      find: /O_O $/,
      replace: "😮 "
    }), textInputRule({
      find: />:O $/,
      replace: "😮 "
    }), textInputRule({
      find: /:-P $/,
      replace: "😛 "
    }), textInputRule({
      find: /:-p $/,
      replace: "😛 "
    }), textInputRule({
      find: /:-Þ $/,
      replace: "😛 "
    }), textInputRule({
      find: /:-þ $/,
      replace: "😛 "
    }), textInputRule({
      find: /:-b $/,
      replace: "😛 "
    }), textInputRule({
      find: />:P $/,
      replace: "😜 "
    }), textInputRule({
      find: /X-P $/,
      replace: "😜 "
    }), textInputRule({
      find: /x-p $/,
      replace: "😜 "
    }), textInputRule({
      find: /':\( $/,
      replace: "😓 "
    }), textInputRule({
      find: /'=\( $/,
      replace: "😓 "
    }), textInputRule({
      find: />:\\ $/,
      replace: "😕 "
    }), textInputRule({
      find: />:\/ $/,
      replace: "😕 "
    }), textInputRule({
      find: /:-\/ $/,
      replace: "😕 "
    }), textInputRule({
      find: /:-. $/,
      replace: "😕 "
    }), textInputRule({
      find: />:\[ $/,
      replace: "😞 "
    }), textInputRule({
      find: /:-\( $/,
      replace: "😞 "
    }), textInputRule({
      find: /:-\[ $/,
      replace: "😞 "
    }), textInputRule({
      find: /:'\( $/,
      replace: "😢 "
    }), textInputRule({
      find: /;-\( $/,
      replace: "😢 "
    }), textInputRule({
      find: /#-\) $/,
      replace: "😵 "
    }), textInputRule({
      find: /%-\) $/,
      replace: "😵 "
    }), textInputRule({
      find: /X-\) $/,
      replace: "😵 "
    }), textInputRule({
      find: />:\( $/,
      replace: "😠 "
    }), textInputRule({
      find: /0:3 $/,
      replace: "😇 "
    }), textInputRule({
      find: /0:\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /O-:\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /O=\) $/,
      replace: "😇 "
    }), textInputRule({
      find: /O:3 $/,
      replace: "😇 "
    }), textInputRule({
      find: /<\/3 $/,
      replace: "💔 "
    }), textInputRule({
      find: /:D $/,
      replace: "😃 "
    }), textInputRule({
      find: /=D $/,
      replace: "😃 "
    }), textInputRule({
      find: /;\) $/,
      replace: "😉 "
    }), textInputRule({
      find: /\*\) $/,
      replace: "😉 "
    }), textInputRule({
      find: /;\] $/,
      replace: "😉 "
    }), textInputRule({
      find: /;D $/,
      replace: "😉 "
    }), textInputRule({
      find: /B\) $/,
      replace: "😎 "
    }), textInputRule({
      find: /8\) $/,
      replace: "😎 "
    }), textInputRule({
      find: /:\* $/,
      replace: "😘 "
    }), textInputRule({
      find: /=\* $/,
      replace: "😘 "
    }), textInputRule({
      find: /:\) $/,
      replace: "🙂 "
    }), textInputRule({
      find: /=\] $/,
      replace: "🙂 "
    }), textInputRule({
      find: /=\) $/,
      replace: "🙂 "
    }), textInputRule({
      find: /:\] $/,
      replace: "🙂 "
    }), textInputRule({
      find: /:X $/,
      replace: "😶 "
    }), textInputRule({
      find: /:# $/,
      replace: "😶 "
    }), textInputRule({
      find: /=X $/,
      replace: "😶 "
    }), textInputRule({
      find: /=x $/,
      replace: "😶 "
    }), textInputRule({
      find: /:x $/,
      replace: "😶 "
    }), textInputRule({
      find: /=# $/,
      replace: "😶 "
    }), textInputRule({
      find: /:O $/,
      replace: "😮 "
    }), textInputRule({
      find: /:o $/,
      replace: "😮 "
    }), textInputRule({
      find: /:P $/,
      replace: "😛 "
    }), textInputRule({
      find: /=P $/,
      replace: "😛 "
    }), textInputRule({
      find: /:p $/,
      replace: "😛  "
    }), textInputRule({
      find: /=p $/,
      replace: "😛 "
    }), textInputRule({
      find: /:Þ $/,
      replace: "😛 "
    }), textInputRule({
      find: /:þ $/,
      replace: "😛 "
    }), textInputRule({
      find: /:b $/,
      replace: "😛 "
    }), textInputRule({
      find: /d-: $/,
      replace: "😛 "
    }), textInputRule({
      find: /:\/ $/,
      replace: "😕 "
    }), textInputRule({
      find: /:\\ $/,
      replace: "😕 "
    }), textInputRule({
      find: /=\/ $/,
      replace: "😕 "
    }), textInputRule({
      find: /=\\ $/,
      replace: "😕 "
    }), textInputRule({
      find: /:L $/,
      replace: "😕 "
    }), textInputRule({
      find: /=L $/,
      replace: "😕 "
    }), textInputRule({
      find: /:\( $/,
      replace: "😞 "
    }), textInputRule({
      find: /:\[ $/,
      replace: "😞 "
    }), textInputRule({
      find: /=\( $/,
      replace: "😞 "
    }), textInputRule({
      find: /;\( $/,
      replace: "😢 "
    }), textInputRule({
      find: /D-: $/,
      replace: "😨 "
    }), textInputRule({
      find: /:\$ $/,
      replace: "😳 "
    }), textInputRule({
      find: /=\$ $/,
      replace: "😳 "
    }), textInputRule({
      find: /#\) $/,
      replace: "😵 "
    }), textInputRule({
      find: /%\) $/,
      replace: "😵 "
    }), textInputRule({
      find: /X\) $/,
      replace: "😵 "
    }), textInputRule({
      find: /:@ $/,
      replace: "😠 "
    }), textInputRule({
      find: /<3 $/,
      replace: "❤️ "
    }), textInputRule({
      find: /:shrug $/,
      replace: "¯\\_(ツ)_/¯"
    }), textInputRule({
      find: /:flip $/,
      replace: "(╯°□°)╯︵ ┻━┻ "
    })];
  }
});
/* harmony default export */ var SmileyReplacer = (SmileyReplacerExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/TextSelectionBubbleMenu.ts


var textSelectionBubbleMenuClass = "mayday-editor__bubble-menu-text-selection";

var TextSelectionBubbleMenu_computeTextSelectionBubbleMenuExtension = function computeTextSelectionBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "textSelectionBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(textSelectionBubbleMenuClass)),
    pluginKey: "textSelectionBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor,
          state = _ref.state,
          from = _ref.from,
          to = _ref.to;
      // if editor is not editable, don't show menus
      if (!editor.isEditable) return false;
      var doc = state.doc,
          selection = state.selection;
      var empty = selection.empty;
      var isTextSelected = isTextSelection(selection); // Sometime check for `empty` is not enough.
      // eg. double click an empty paragraph returns a node size of 2.
      // So we check also for an empty text size.

      var isEmptyTextBlock = isTextSelected && !doc.textBetween(from, to).length;

      if (empty || isEmptyTextBlock) {
        return false;
      }

      return isTextSelected && !editor.isActive("codeBlock") && !editor.isActive("link");
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "top",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none"
    }
  });
};

/* harmony default export */ var BubbleMenu_TextSelectionBubbleMenu = (TextSelectionBubbleMenu_computeTextSelectionBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/TableBubbleMenu/TableBubbleMenuPlugin.ts













var TableBubbleMenuPlugin_TableBubbleMenuView = /*#__PURE__*/function () {
  // default shouldShow, it would'nt be used
  // changes from original version
  function TableBubbleMenuView(_ref) {
    var _this = this;

    var _editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        _ref$tippyOptions = _ref.tippyOptions,
        tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
        shouldShow = _ref.shouldShow;

    _classCallCheck(this, TableBubbleMenuView);

    Object(defineProperty["a" /* default */])(this, "editor", void 0);

    Object(defineProperty["a" /* default */])(this, "element", void 0);

    Object(defineProperty["a" /* default */])(this, "view", void 0);

    Object(defineProperty["a" /* default */])(this, "preventHide", false);

    Object(defineProperty["a" /* default */])(this, "tippy", void 0);

    Object(defineProperty["a" /* default */])(this, "tippyOptions", void 0);

    Object(defineProperty["a" /* default */])(this, "shouldShow", function (_ref2) {
      var editor = _ref2.editor,
          state = _ref2.state,
          from = _ref2.from,
          to = _ref2.to;
      // if editor is not editable, don't show menus
      if (!editor.isEditable) return false;
      var doc = state.doc,
          selection = state.selection;
      var empty = selection.empty; // Sometime check for `empty` is not enough.
      // Double click an empty paragraph returns a node size of 2.
      // So we check also for an empty text size.

      var isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);

      if (empty || isEmptyTextBlock) {
        return false;
      }

      return true;
    });

    Object(defineProperty["a" /* default */])(this, "predicate", function (_ref3) {
      var type = _ref3.type;
      return type.name === "table";
    });

    Object(defineProperty["a" /* default */])(this, "findTable", findParentNode(this.predicate));

    Object(defineProperty["a" /* default */])(this, "isInTable", isInTable);

    Object(defineProperty["a" /* default */])(this, "mousedownHandler", function () {
      _this.preventHide = true;
    });

    Object(defineProperty["a" /* default */])(this, "dragstartHandler", function () {
      _this.hide();
    });

    Object(defineProperty["a" /* default */])(this, "focusHandler", function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    });

    Object(defineProperty["a" /* default */])(this, "blurHandler", function (_ref4) {
      var _this$element$parentN;

      var event = _ref4.event;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if (event !== null && event !== void 0 && event.relatedTarget && (_this$element$parentN = _this.element.parentNode) !== null && _this$element$parentN !== void 0 && _this$element$parentN.contains(event.relatedTarget)) {
        return;
      }

      _this.hide();
    });

    this.editor = _editor;
    this.element = element;
    this.view = view;

    if (shouldShow) {
      this.shouldShow = shouldShow;
    }

    this.element.addEventListener("mousedown", this.mousedownHandler, {
      capture: true
    });
    this.view.dom.addEventListener("dragstart", this.dragstartHandler);
    this.editor.on("focus", this.focusHandler);
    this.editor.on("blur", this.blurHandler);
    this.tippyOptions = tippyOptions; // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = "visible";
  }

  _createClass(TableBubbleMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy_esm(editorElement, _objectSpread2({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: "manual",
        placement: "top",
        hideOnClick: "toggle"
      }, this.tippyOptions));
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _this$shouldShow;

      var state = view.state,
          composing = view.composing;
      var doc = state.doc,
          selection = state.selection;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      var _key$getState = CellMenu_key.getState(state),
          isMenuOpened = _key$getState.isMenuOpened; // changes from original version


      if (isSame && isMenuOpened) {
        this.hide();
        return;
      }

      if (composing) {
        return;
      }

      this.createTooltip(); // support for CellSelections

      var ranges = selection.ranges;
      var from = Math.min.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$from.pos;
      })));
      var to = Math.max.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$to.pos;
      })));
      var shouldShow = (_this$shouldShow = this.shouldShow) === null || _this$shouldShow === void 0 ? void 0 : _this$shouldShow.call(this, {
        editor: this.editor,
        view: view,
        state: state,
        oldState: oldState,
        from: from,
        to: to
      });

      if (!shouldShow) {
        this.hide();
        return;
      } // changes from original version


      var table = this.findTable(state.selection);

      if (this.isInTable(state) && table != null) {
        var _this$tippy;

        var nodeDOM = view.nodeDOM(table.pos);

        if (nodeDOM == null) {
          return;
        }

        (_this$tippy = this.tippy) === null || _this$tippy === void 0 ? void 0 : _this$tippy.setProps({
          getReferenceClientRect: function getReferenceClientRect() {
            return nodeDOM.getBoundingClientRect();
          }
        });
        this.show();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _this$tippy2;

      (_this$tippy2 = this.tippy) === null || _this$tippy2 === void 0 ? void 0 : _this$tippy2.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$tippy3;

      (_this$tippy3 = this.tippy) === null || _this$tippy3 === void 0 ? void 0 : _this$tippy3.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$tippy4;

      (_this$tippy4 = this.tippy) === null || _this$tippy4 === void 0 ? void 0 : _this$tippy4.destroy();
      this.element.removeEventListener("mousedown", this.mousedownHandler, {
        capture: true
      });
      this.view.dom.removeEventListener("dragstart", this.dragstartHandler);
      this.editor.off("focus", this.focusHandler);
      this.editor.off("blur", this.blurHandler);
    }
  }]);

  return TableBubbleMenuView;
}();
var TableBubbleMenuPlugin_TableBubbleMenuPlugin = function TableBubbleMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === "string" ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new TableBubbleMenuPlugin_TableBubbleMenuView(_objectSpread2({
        view: _view
      }, options));
    }
  });
};
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/TableBubbleMenu/TableBubbleMenu.ts


var tableBubbleMenuClass = "mayday-editor__bubble-menu-table";

var TableBubbleMenu_computeTableBubbleMenuExtension = function computeTableBubbleMenuExtension($el) {
  return Extension.create({
    name: "tableBubbleMenu",
    addOptions: function addOptions() {
      return {
        element: null,
        tippyOptions: {},
        pluginKey: "bubbleMenu",
        shouldShow: null
      };
    },
    // replace default plugin with a custom one
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      if (!this.options.element) {
        return [];
      }

      return [TableBubbleMenuPlugin_TableBubbleMenuPlugin({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })];
    }
  }).configure({
    element: $el.querySelector(".".concat(tableBubbleMenuClass)),
    pluginKey: "tableBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("table") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "bottom",
      arrow: false,
      theme: "bubble-menu",
      appendTo: function appendTo() {
        return document.body;
      },
      zIndex: 9998 // default - 1

    }
  });
};

/* harmony default export */ var TableBubbleMenu_TableBubbleMenu = (TableBubbleMenu_computeTableBubbleMenuExtension);
// CONCATENATED MODULE: ./node_modules/@tiptap/suggestion/dist/tiptap-suggestion.esm.js




function findSuggestionMatch(config) {
    const { char, allowSpaces, prefixSpace, startOfLine, $position, } = config;
    const escapedChar = escapeForRegEx(char);
    const suffix = new RegExp(`\\s${escapedChar}$`);
    const prefix = startOfLine ? '^' : '';
    const regexp = allowSpaces
        ? new RegExp(`${prefix}${escapedChar}.*?(?=\\s${escapedChar}|$)`, 'gm')
        : new RegExp(`${prefix}(?:^)?${escapedChar}[^\\s${escapedChar}]*`, 'gm');
    const isTopLevelNode = $position.depth <= 0;
    const textFrom = isTopLevelNode
        ? 0
        : $position.before();
    const textTo = $position.pos;
    const text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');
    const match = Array.from(text.matchAll(regexp)).pop();
    if (!match || match.input === undefined || match.index === undefined) {
        return null;
    }
    // JavaScript doesn't have lookbehinds. This hacks a check that first character
    // is a space or the start of the line
    const matchPrefix = match.input.slice(Math.max(0, match.index - 1), match.index);
    const matchPrefixIsSpace = /^[\s\0]?$/.test(matchPrefix);
    if (prefixSpace && !matchPrefixIsSpace) {
        return null;
    }
    // The absolute position of the match in the document
    const from = match.index + $position.start();
    let to = from + match[0].length;
    // Edge case handling; if spaces are allowed and we're directly in between
    // two triggers
    if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
        match[0] += ' ';
        to += 1;
    }
    // If the $position is located within the matched substring, return that range
    if (from < $position.pos && to >= $position.pos) {
        return {
            range: {
                from,
                to,
            },
            query: match[0].slice(char.length),
            text: match[0],
        };
    }
    return null;
}

const SuggestionPluginKey = new PluginKey('suggestion');
function Suggestion({ pluginKey = SuggestionPluginKey, editor, char = '@', allowSpaces = false, prefixSpace = true, startOfLine = false, decorationTag = 'span', decorationClass = 'suggestion', command = () => null, items = () => [], render = () => ({}), allow = () => true, }) {
    let props;
    const renderer = render === null || render === void 0 ? void 0 : render();
    return new Plugin({
        key: pluginKey,
        view() {
            return {
                update: async (view, prevState) => {
                    var _a, _b, _c, _d, _e;
                    const prev = (_a = this.key) === null || _a === void 0 ? void 0 : _a.getState(prevState);
                    const next = (_b = this.key) === null || _b === void 0 ? void 0 : _b.getState(view.state);
                    // See how the state changed
                    const moved = prev.active && next.active && prev.range.from !== next.range.from;
                    const started = !prev.active && next.active;
                    const stopped = prev.active && !next.active;
                    const changed = !started && !stopped && prev.query !== next.query;
                    const handleStart = started || moved;
                    const handleChange = changed && !moved;
                    const handleExit = stopped || moved;
                    // Cancel when suggestion isn't active
                    if (!handleStart && !handleChange && !handleExit) {
                        return;
                    }
                    const state = handleExit && !handleStart
                        ? prev
                        : next;
                    const decorationNode = document.querySelector(`[data-decoration-id="${state.decorationId}"]`);
                    props = {
                        editor,
                        range: state.range,
                        query: state.query,
                        text: state.text,
                        items: (handleChange || handleStart)
                            ? await items({
                                editor,
                                query: state.query,
                            })
                            : [],
                        command: commandProps => {
                            command({
                                editor,
                                range: state.range,
                                props: commandProps,
                            });
                        },
                        decorationNode,
                        // virtual node for popper.js or tippy.js
                        // this can be used for building popups without a DOM node
                        clientRect: decorationNode
                            ? () => {
                                var _a;
                                // because of `items` can be asynchrounous we’ll search for the current docoration node
                                const { decorationId } = (_a = this.key) === null || _a === void 0 ? void 0 : _a.getState(editor.state);
                                const currentDecorationNode = document.querySelector(`[data-decoration-id="${decorationId}"]`);
                                // @ts-ignore-error
                                return currentDecorationNode.getBoundingClientRect();
                            }
                            : null,
                    };
                    if (handleExit) {
                        (_c = renderer === null || renderer === void 0 ? void 0 : renderer.onExit) === null || _c === void 0 ? void 0 : _c.call(renderer, props);
                    }
                    if (handleChange) {
                        (_d = renderer === null || renderer === void 0 ? void 0 : renderer.onUpdate) === null || _d === void 0 ? void 0 : _d.call(renderer, props);
                    }
                    if (handleStart) {
                        (_e = renderer === null || renderer === void 0 ? void 0 : renderer.onStart) === null || _e === void 0 ? void 0 : _e.call(renderer, props);
                    }
                },
                destroy: () => {
                    var _a;
                    if (!props) {
                        return;
                    }
                    (_a = renderer === null || renderer === void 0 ? void 0 : renderer.onExit) === null || _a === void 0 ? void 0 : _a.call(renderer, props);
                },
            };
        },
        state: {
            // Initialize the plugin's internal state.
            init() {
                return {
                    active: false,
                    range: {},
                    query: null,
                    text: null,
                    composing: false,
                };
            },
            // Apply changes to the plugin state from a view transaction.
            apply(transaction, prev, oldState, state) {
                const { composing } = editor.view;
                const { selection } = transaction;
                const { empty, from } = selection;
                const next = { ...prev };
                next.composing = composing;
                // We can only be suggesting if there is no selection
                // or a composition is active (see: https://github.com/ueberdosis/tiptap/issues/1449)
                if (empty || editor.view.composing) {
                    // Reset active state if we just left the previous suggestion range
                    if ((from < prev.range.from || from > prev.range.to)
                        && !composing
                        && !prev.composing) {
                        next.active = false;
                    }
                    // Try to match against where our cursor currently is
                    const match = findSuggestionMatch({
                        char,
                        allowSpaces,
                        prefixSpace,
                        startOfLine,
                        $position: selection.$from,
                    });
                    const decorationId = `id_${Math.floor(Math.random() * 0xFFFFFFFF)}`;
                    // If we found a match, update the current state to show it
                    if (match && allow({ editor, state, range: match.range })) {
                        next.active = true;
                        next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
                        next.range = match.range;
                        next.query = match.query;
                        next.text = match.text;
                    }
                    else {
                        next.active = false;
                    }
                }
                else {
                    next.active = false;
                }
                // Make sure to empty the range if suggestion is inactive
                if (!next.active) {
                    next.decorationId = null;
                    next.range = {};
                    next.query = null;
                    next.text = null;
                }
                return next;
            },
        },
        props: {
            // Call the keydown hook if suggestion is active.
            handleKeyDown(view, event) {
                var _a;
                const { active, range } = this.getState(view.state);
                if (!active) {
                    return false;
                }
                return ((_a = renderer === null || renderer === void 0 ? void 0 : renderer.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(renderer, { view, event, range })) || false;
            },
            // Setup decorator on the currently active suggestion.
            decorations(state) {
                const { active, range, decorationId } = this.getState(state);
                if (!active) {
                    return null;
                }
                return DecorationSet.create(state.doc, [
                    Decoration.inline(range.from, range.to, {
                        nodeName: decorationTag,
                        class: decorationClass,
                        'data-decoration-id': decorationId,
                    }),
                ]);
            },
        },
    });
}


//# sourceMappingURL=tiptap-suggestion.esm.js.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Slash/SlashMenu.vue?vue&type=template&id=5b77ee18&scoped=true&
var SlashMenuvue_type_template_id_5b77ee18_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__slash-menu"},[(_vm.hasItems)?_c('div',{ref:"slash-menu-items",staticClass:"mayday-editor__slash-menu__items"},_vm._l((_vm.items),function(item,index){return _c('button',{key:("slash-menu-item-" + (item.key) + "-" + index),staticClass:"mayday-editor__slash-menu__items__item-wrapper",class:_vm.computeSelectedClass(index),attrs:{"id":item.key,"disabled":_vm.computeIsDisabled(item)},on:{"click":function($event){return _vm.selectItem(index)},"mouseenter":function($event){return _vm.hoverItem(index)}}},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"icon-wrapper",class:_vm.computeSelectedClass(index)},[_c('font-awesome-icon',{class:['icon', { aiFeature: item.aiFeature }],attrs:{"icon":['fas', item.icon]}})],1),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(item.title)+" "),(item.aiFeature)?_c('AiBadge'):_vm._e()],1),_c('div',{staticClass:"options-icon"},[(item.options)?_c('font-awesome-icon',{attrs:{"icon":['fal', 'chevron-right']}}):_vm._e()],1)])])}),0):_c('div',{staticClass:"mayday-editor__slash-menu__no-items"},[_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.slash.no-results")))])]),_c('div',{staticClass:"mayday-editor__slash-menu__footer"},[(_vm.hasItems)?_c('span',[_vm._v(_vm._s(_vm.$t( ("mayday-editor.menu.slash.footer-description." + (_vm.currentItemForSelection.key)) )))]):_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.slash.footer-description.no-results")))]),_c('span',[_c('a',{staticClass:"help-link",attrs:{"href":_vm.helpLink,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'question-circle']}}),_vm._v(" "+_vm._s(_vm.$t("mayday-editor.menu.slash.footer-description.help")))],1)])]),(_vm.displayOptions)?_c('div',{staticClass:"mayday-editor__slash-menu__options",style:(_vm.optionsPlacement)},_vm._l((_vm.items[_vm.selectedIndex].options),function(option,i){return _c('div',{key:i,staticClass:"item",class:_vm.computeSelectedOptionClass(i),on:{"mouseenter":function($event){return _vm.hoverOption(i)},"click":function($event){return _vm.selectOption(i)}}},[(option.emoji)?_c('div',{staticClass:"item-emoji"},[_vm._v(" "+_vm._s(option.emoji)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(option.title))+" ")])}),0):_vm._e()])}
var SlashMenuvue_type_template_id_5b77ee18_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenu.vue?vue&type=template&id=5b77ee18&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AiBadge.vue?vue&type=template&id=b3155bf4&scoped=true&
var AiBadgevue_type_template_id_b3155bf4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-badge"},[(_vm.displayIcon)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'sparkles']}}):_vm._e(),_vm._v(" AI ")],1)}
var AiBadgevue_type_template_id_b3155bf4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AiBadge.vue?vue&type=template&id=b3155bf4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AiBadge.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */ var AiBadgevue_type_script_lang_js_ = ({
  name: "AiBadge",
  props: {
    displayIcon: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/AiBadge.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AiBadgevue_type_script_lang_js_ = (AiBadgevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/AiBadge.vue?vue&type=style&index=0&id=b3155bf4&scoped=true&lang=scss&
var AiBadgevue_type_style_index_0_id_b3155bf4_scoped_true_lang_scss_ = __webpack_require__("cd11");

// CONCATENATED MODULE: ./src/components/AiBadge.vue






/* normalize component */

var AiBadge_component = normalizeComponent(
  components_AiBadgevue_type_script_lang_js_,
  AiBadgevue_type_template_id_b3155bf4_scoped_true_render,
  AiBadgevue_type_template_id_b3155bf4_scoped_true_staticRenderFns,
  false,
  null,
  "b3155bf4",
  null
  
)

/* harmony default export */ var AiBadge = (AiBadge_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Slash/SlashMenu.vue?vue&type=script&lang=ts&









var SlashMenuvue_type_script_lang_ts_a;







var SlashMenuvue_type_script_lang_ts_SlashMenu = /*#__PURE__*/function (_Vue) {
  _inherits(SlashMenu, _Vue);

  var _super = _createSuper(SlashMenu);

  function SlashMenu() {
    var _this;

    _classCallCheck(this, SlashMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "items", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectedIndex", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectedOptionIndex", null);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "helpLink", "https://changelog.mayday.fr/decouvrez-les-nouveautes-de-mayday/17-02-2022-or-mayday-v2#editeur-de-contenu-v.2.0");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "minimumCharacters", 300);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "optionHeight", 44);

    return _this;
  }

  _createClass(SlashMenu, [{
    key: "currentItemForSelection",
    get: function get() {
      return this.items[this.selectedIndex];
    }
  }, {
    key: "hasItems",
    get: function get() {
      return this.items.length > 0;
    }
  }, {
    key: "optionsPlacement",
    get: function get() {
      if (!this.items[this.selectedIndex]) return "";

      if (this.items[this.selectedIndex].options) {
        var _this$items$this$sele;

        var item = this.$el.querySelector("#".concat(this.items[this.selectedIndex].key));
        var slashMenuItems = this.$refs["slash-menu-items"];
        var optionsHeight = (((_this$items$this$sele = this.items[this.selectedIndex].options) === null || _this$items$this$sele === void 0 ? void 0 : _this$items$this$sele.length) || 0) * this.optionHeight;
        var itemTop = item.getBoundingClientRect().top;
        var slashMenuItemsTop = slashMenuItems.getBoundingClientRect().top;
        var optionsOutOfWindow = itemTop + optionsHeight > window.innerHeight + window.scrollY;

        if (item && slashMenuItems) {
          if (optionsOutOfWindow) {
            return "bottom: ".concat(slashMenuItems.clientHeight - item.clientHeight + this.optionHeight / 2, "px");
          }

          return "top: ".concat(itemTop - slashMenuItemsTop, "px");
        }
      }

      return "";
    }
  }, {
    key: "displayOptions",
    get: function get() {
      if (!this.items[this.selectedIndex]) return false;
      return this.items[this.selectedIndex].options && this.selectedOptionIndex != null;
    }
  }, {
    key: "handleItemsChanged",
    value: function handleItemsChanged() {
      this.selectedIndex = 0;
    }
  }, {
    key: "computeSelectedClass",
    value: function computeSelectedClass(index) {
      return {
        "is-selected": index === this.selectedIndex,
        "is-disabled": this.computeIsDisabled(this.items[index])
      };
    }
  }, {
    key: "computeSelectedOptionClass",
    value: function computeSelectedOptionClass(index) {
      return {
        "is-selected": index === this.selectedOptionIndex
      };
    }
  }, {
    key: "computeIsDisabled",
    value: function computeIsDisabled(item) {
      var _this$editor, _this$editor2, _this$editor3;

      if (!item.aiFeature || !((_this$editor = this.editor) !== null && _this$editor !== void 0 && _this$editor.storage.characterCount)) return false;
      return ((_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.storage.characterCount.characters()) < this.minimumCharacters || ((_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.storage.streamWrapper.streaming);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(_ref) {
      var event = _ref.event;

      if (event.key === "ArrowUp") {
        if (!this.items[this.selectedIndex]) return false;
        this.upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        if (!this.items[this.selectedIndex]) return false;
        this.downHandler();
        return true;
      }

      if (event.key === "ArrowLeft") {
        if (this.selectedOptionIndex != null) {
          this.selectedOptionIndex = null;
          return true;
        }
      }

      if (event.key === "ArrowRight") {
        if (!this.items[this.selectedIndex]) return false;

        if (this.computeIsDisabled(this.items[this.selectedIndex])) {
          return false;
        }

        if (this.items[this.selectedIndex].options && this.selectedOptionIndex == null) {
          this.selectedOptionIndex = 0;
          return true;
        }
      }

      if (event.key === "Enter") {
        if (!this.items[this.selectedIndex]) return false;

        if (this.computeIsDisabled(this.items[this.selectedIndex])) {
          return false;
        }

        this.enterHandler();
        return true;
      }

      return false;
    }
  }, {
    key: "upHandler",
    value: function upHandler() {
      if (!this.items[this.selectedIndex]) return;

      if (this.selectedOptionIndex != null && this.items[this.selectedIndex].options) {
        this.selectedOptionIndex = (this.selectedOptionIndex + this.items[this.selectedIndex].options.length - 1) % this.items[this.selectedIndex].options.length;
      } else {
        this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length;
      }

      this.scrollIntoSelectedItem();
    }
  }, {
    key: "downHandler",
    value: function downHandler() {
      if (!this.items[this.selectedIndex]) return;

      if (this.selectedOptionIndex != null && this.items[this.selectedIndex].options) {
        this.selectedOptionIndex = (this.selectedOptionIndex + 1) % this.items[this.selectedIndex].options.length;
      } else {
        this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
      }

      this.scrollIntoSelectedItem();
    }
  }, {
    key: "scrollIntoSelectedItem",
    value: function scrollIntoSelectedItem() {
      this.$nextTick(function () {
        var el = document.querySelectorAll('[class*="is-selected"]');

        if (el) {
          el[0].scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
        }
      });
    }
  }, {
    key: "hoverItem",
    value: function hoverItem(index) {
      if (!this.items[index]) return;

      if (index !== this.selectedIndex) {
        this.selectedOptionIndex = this.items[index].options ? 0 : null;
        this.selectedIndex = index;
      }
    }
  }, {
    key: "hoverOption",
    value: function hoverOption(index) {
      this.selectedOptionIndex = index;
    }
  }, {
    key: "enterHandler",
    value: function enterHandler() {
      if (this.selectedOptionIndex != null) this.selectOption(this.selectedOptionIndex);else this.selectItem(this.selectedIndex);
    }
  }, {
    key: "selectItem",
    value: function selectItem(index) {
      var item = this.items[index];

      if (item != null) {
        if (item.options) {
          this.selectedOptionIndex = 0;
          return;
        } else {
          this.command(item);
          this.selectedIndex = 0;
        }
      }
    }
  }, {
    key: "selectOption",
    value: function selectOption(index) {
      var item = this.items[this.selectedIndex];

      if (!!item && item.options) {
        var option = item.options[index];
        this.command(_objectSpread2(_objectSpread2({}, item), {}, {
          optionValue: option.value
        }));
        this.selectedIndex = 0;
      }
    }
  }]);

  return SlashMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Array)], SlashMenuvue_type_script_lang_ts_SlashMenu.prototype, "items", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], SlashMenuvue_type_script_lang_ts_SlashMenu.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], SlashMenuvue_type_script_lang_ts_SlashMenu.prototype, "editor", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("items"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SlashMenuvue_type_script_lang_ts_SlashMenu.prototype, "handleItemsChanged", null);

SlashMenuvue_type_script_lang_ts_SlashMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    AiBadge: AiBadge
  },
  props: {
    editor: Object,
    default: function _default() {
      return {};
    }
  }
})], SlashMenuvue_type_script_lang_ts_SlashMenu);
/* harmony default export */ var SlashMenuvue_type_script_lang_ts_ = (SlashMenuvue_type_script_lang_ts_SlashMenu);
// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Slash_SlashMenuvue_type_script_lang_ts_ = (SlashMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Slash/SlashMenu.vue?vue&type=style&index=0&id=5b77ee18&lang=scss&scoped=true&
var SlashMenuvue_type_style_index_0_id_5b77ee18_lang_scss_scoped_true_ = __webpack_require__("f2e2");

// CONCATENATED MODULE: ./src/components/menus/Slash/SlashMenu.vue






/* normalize component */

var SlashMenu_component = normalizeComponent(
  Slash_SlashMenuvue_type_script_lang_ts_,
  SlashMenuvue_type_template_id_5b77ee18_scoped_true_render,
  SlashMenuvue_type_template_id_5b77ee18_scoped_true_staticRenderFns,
  false,
  null,
  "5b77ee18",
  null
  
)

/* harmony default export */ var Slash_SlashMenu = (SlashMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/fuse.js/dist/fuse.esm.js
/**
 * Fuse.js v6.5.3 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2021 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result
}

function fuse_esm_toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function fuse_esm_isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function fuse_esm_isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return fuse_esm_isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = fuse_esm_createKey(key);

      totalWeight += obj.weight;

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function fuse_esm_createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;

  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
  }

  return { path, id, weight, src }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function fuse_esm_get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || fuse_esm_isNumber(value) || isBoolean(value))
      ) {
        list.push(fuse_esm_toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: fuse_esm_get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const fuse_esm_SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(fuse_esm_SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      // console.log(key)
      let value = this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (!isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(fuse_esm_createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && fuse_esm_isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function fuse_esm_parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function fuse_esm_format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      !true
    ) {
      throw new Error(EXTENDED_SEARCH_UNAVAILABLE)
    }

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (fuse_esm_isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return fuse_esm_format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = fuse_esm_parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '6.5.3';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = fuse_esm_parse;
}

{
  register(ExtendedSearch);
}



// CONCATENATED MODULE: ./src/utils/createClickEvent.ts
var createClickEvent = function createClickEvent() {
  var isOldBrowser = typeof MouseEvent === "undefined";
  var event = isOldBrowser ? document.createEvent("MouseEvent") : new MouseEvent("click");

  if (isOldBrowser) {
    event.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
  }

  return event;
};

/* harmony default export */ var utils_createClickEvent = (createClickEvent);
// CONCATENATED MODULE: ./src/utils/slashMenuHandler.ts














var slashMenuHandler_insertAttachment = function insertAttachment(file, editor) {
  var href = file.url,
      name = file.name,
      mimeType = file.mimeType;
  var type = computeAttachmentType(mimeType);
  editor.commands.setAttachment({
    href: href,
    name: name,
    type: type
  });
};

var insertImage = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, editor, minSize) {
    var src, alt, result, width, height;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            src = file.url, alt = file.name;
            _context.next = 3;
            return utils_resolveImage(src, minSize);

          case 3:
            result = _context.sent;
            width = result.width, height = result.height;
            editor.commands.insertImage({
              src: src,
              alt: alt,
              title: alt,
              width: utils_computeNumberToPixels(width),
              height: utils_computeNumberToPixels(height)
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function insertImage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var slashMenuHandler_handler = function handler(editor, range, isFileUploadCallbackProvided, uploadStoreAction) {
  var isAttachment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var minSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var notifyUploadError = arguments.length > 6 ? arguments[6] : undefined;
  var input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("multiple", "multiple");
  input.setAttribute("data-cy", "fileInput");

  if (!isAttachment) {
    input.setAttribute("accept", "image/*");
  } // IE10/11 Addition


  input.style.display = "none";
  input.setAttribute("id", "hidden-file-input");
  document.body.appendChild(input);
  input.addEventListener("change", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _files, files, uploadedFiles;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (isFileUploadCallbackProvided) {
              _context2.next = 3;
              break;
            }

            console.error("[mayday-editor]: Couldn't launch image upload");
            return _context2.abrupt("return");

          case 3:
            _files = input.files;

            if (utils_hasFiles(_files)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return");

          case 6:
            files = isAttachment ? generateAttachmentList_generateAttachmentList(_files) : generateImageList(_files);

            if (!(files.validFiles.length === 0)) {
              _context2.next = 10;
              break;
            }

            notifyUploadError ? notifyUploadError("BAD EXTENSION") : null;
            return _context2.abrupt("return");

          case 10:
            if (!files.nonAuthorizedFiles.length) {
              _context2.next = 13;
              break;
            }

            notifyUploadError ? notifyUploadError("BAD EXTENSION") : null;
            return _context2.abrupt("return");

          case 13:
            _context2.prev = 13;
            _context2.next = 16;
            return uploadStoreAction(files.validFiles);

          case 16:
            uploadedFiles = _context2.sent.filter(function (file) {
              return file != null;
            });

            if (!(uploadedFiles.length === 0)) {
              _context2.next = 20;
              break;
            }

            console.warn("[mayday-editor]: not any uploaded attachment to insert");
            return _context2.abrupt("return");

          case 20:
            editor.chain().focus().deleteRange(range).run();
            uploadedFiles.forEach(function (file) {
              isAttachment ? slashMenuHandler_insertAttachment(file, editor) : insertImage(file, editor, minSize);
            });
            document.body.removeChild(input);
            _context2.next = 29;
            break;

          case 25:
            _context2.prev = 25;
            _context2.t0 = _context2["catch"](13);
            document.body.removeChild(input);
            console.error("[mayday-editor] attachment not inserted because file upload failed");

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[13, 25]]);
  })));
  var event = utils_createClickEvent();
  input.dispatchEvent(event);
};

/* harmony default export */ var slashMenuHandler = (slashMenuHandler_handler);
// CONCATENATED MODULE: ./src/extensions/SlashMenu/SlashMenuCommands.ts


var SlashMenuCommands_computeCommands = function computeCommands(i18nMap, isFileUploadCallbackProvided, uploadStoreAction, allowToc, allowSummary, allowTranslation, allowGrammarCorrection, allowToneImprovement, allowActionItems, notifyUploadError, emit) {
  var commands = [{
    key: "paragraph",
    title: i18nMap.paragraph,
    icon: "paragraph",
    command: function command(_ref) {
      var editor = _ref.editor,
          range = _ref.range;
      editor.chain().focus().deleteRange(range).setNode("paragraph").run();
    }
  }, {
    key: "h1",
    title: i18nMap.h1,
    icon: "h1",
    command: function command(_ref2) {
      var editor = _ref2.editor,
          range = _ref2.range;
      editor.chain().focus().deleteRange(range).setNode("heading", {
        level: 1
      }).run();
    }
  }, {
    key: "h2",
    title: i18nMap.h2,
    icon: "h2",
    command: function command(_ref3) {
      var editor = _ref3.editor,
          range = _ref3.range;
      editor.chain().focus().deleteRange(range).setNode("heading", {
        level: 2
      }).run();
    }
  }, {
    key: "h3",
    title: i18nMap.h3,
    icon: "h3",
    command: function command(_ref4) {
      var editor = _ref4.editor,
          range = _ref4.range;
      editor.chain().focus().deleteRange(range).setNode("heading", {
        level: 3
      }).run();
    }
  }, {
    key: "h4",
    title: i18nMap.h4,
    icon: "h4",
    command: function command(_ref5) {
      var editor = _ref5.editor,
          range = _ref5.range;
      editor.chain().focus().deleteRange(range).setNode("heading", {
        level: 4
      }).run();
    }
  }, {
    key: "emoji",
    title: i18nMap.emoji,
    icon: "grin-alt",
    command: function command(_ref6) {
      var editor = _ref6.editor,
          range = _ref6.range;
      editor.chain().focus().deleteRange(range).insertContent(":a").run();
      editor.chain().focus().deleteRange({
        from: range.from + 1,
        to: range.from + 2
      }).run();
    }
  }, {
    key: "callout",
    title: i18nMap["callout"],
    icon: "lightbulb",
    command: function command(_ref7) {
      var editor = _ref7.editor,
          range = _ref7.range;
      editor.chain().focus().deleteRange(range).setCallout().run();
    }
  }, {
    key: "table",
    title: i18nMap["table"],
    icon: "table",
    command: function command(_ref8) {
      var editor = _ref8.editor,
          range = _ref8.range;
      editor.chain().focus().deleteRange(range).insertTable({
        rows: 3,
        cols: 3,
        withHeaderRow: true
      }).run();
    }
  }, {
    key: "image",
    title: i18nMap.image,
    icon: "image",
    command: function command(_ref9) {
      var editor = _ref9.editor,
          range = _ref9.range;
      var storage = editor.storage.image;
      slashMenuHandler(editor, range, isFileUploadCallbackProvided, uploadStoreAction, false, storage.minSize, notifyUploadError);
    }
  }, {
    key: "attachment",
    title: i18nMap.attachment,
    icon: "paperclip",
    command: function command(_ref10) {
      var editor = _ref10.editor,
          range = _ref10.range;
      slashMenuHandler(editor, range, isFileUploadCallbackProvided, uploadStoreAction, true, undefined, notifyUploadError);
    }
  }, {
    key: "bullet-list",
    title: i18nMap["bullet-list"],
    icon: "list-ul",
    command: function command(_ref11) {
      var editor = _ref11.editor,
          range = _ref11.range;
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
    }
  }, {
    key: "ordered-list",
    title: i18nMap["ordered-list"],
    icon: "list-ol",
    command: function command(_ref12) {
      var editor = _ref12.editor,
          range = _ref12.range;
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
    }
  }, {
    key: "divider",
    title: i18nMap["divider"],
    icon: "horizontal-rule",
    command: function command(_ref13) {
      var editor = _ref13.editor,
          range = _ref13.range;
      editor.chain().focus().deleteRange(range).setHorizontalRule().run();
    }
  }, {
    key: "blockquote",
    title: i18nMap["blockquote"],
    icon: "quote-right",
    command: function command(_ref14) {
      var editor = _ref14.editor,
          range = _ref14.range;
      editor.chain().focus().deleteRange(range).setBlockquote().run();
    }
  }, {
    key: "codeblock",
    title: i18nMap["codeblock"],
    icon: "code",
    command: function command(_ref15) {
      var editor = _ref15.editor,
          range = _ref15.range;
      editor.chain().focus().deleteRange(range).setCodeBlock().run();
    }
  }, {
    key: "inline-content",
    title: i18nMap["inline-content"],
    icon: "external-link",
    command: function command(_ref16) {
      var editor = _ref16.editor,
          range = _ref16.range;
      editor.chain().focus().deleteRange(range).insertContent("@").run();
      editor.chain().focus().insertContent("content:").run();
    }
  }, {
    key: "inline-mention",
    alias: ["user", "utilisateur"],
    title: i18nMap["inline-mention"],
    icon: "at",
    command: function command(_ref17) {
      var editor = _ref17.editor,
          range = _ref17.range;
      editor.chain().focus().deleteRange(range).insertContent("@").run();
      editor.chain().focus().insertContent("user:").run();
    }
  }, {
    key: "details",
    alias: ["toggle"],
    title: i18nMap["details"],
    icon: "compress-alt",
    command: function command(_ref18) {
      var editor = _ref18.editor,
          range = _ref18.range;
      editor.chain().focus().deleteRange(range).setDetails().run();
    }
  }];

  if (allowToc) {
    commands.push({
      key: "toc",
      alias: ["table"],
      title: i18nMap["toc"],
      icon: "file-alt",
      command: function command(_ref19) {
        var editor = _ref19.editor,
            range = _ref19.range;
        editor.chain().focus().deleteRange(range).insertContent({
          type: "toc"
        }).run();
      }
    });
  }

  if (allowSummary) {
    commands.push({
      key: "summary",
      alias: ["generate", "resume"],
      title: i18nMap["summary"],
      icon: "bolt",
      command: function command(_ref20) {
        var editor = _ref20.editor,
            range = _ref20.range,
            option = _ref20.option;
        editor.chain().focus().deleteRange(range).run();
        emit("generate-summary", option);
      },
      aiFeature: true,
      options: [{
        value: false,
        title: "mayday-editor.menu.slash.options.summary.long"
      }, {
        value: true,
        title: "mayday-editor.menu.slash.options.summary.short"
      }]
    });
  }

  if (allowTranslation) {
    commands.push({
      key: "translate",
      alias: ["traduire, traduction, translation"],
      title: i18nMap["translate"],
      icon: "globe-stand",
      command: function command(_ref21) {
        var editor = _ref21.editor,
            range = _ref21.range,
            option = _ref21.option;
        if (editor.storage.streamWrapper.streaming) return;
        editor.storage.streamWrapper.language = option;
        editor.chain().setMeta("preventUpdate", true).focus().deleteRange(range).insertContent({
          type: "translation"
        }).scrollIntoView().run();
      },
      aiFeature: true,
      options: [{
        value: "fr-fr",
        title: "mayday-editor.menu.slash.options.translate.fr-fr",
        emoji: "🇫🇷"
      }, {
        value: "en-us",
        title: "mayday-editor.menu.slash.options.translate.en-us",
        emoji: "🇺🇸"
      }, {
        value: "es-es",
        title: "mayday-editor.menu.slash.options.translate.es-es",
        emoji: "🇪🇸"
      }, {
        value: "de-de",
        title: "mayday-editor.menu.slash.options.translate.de-de",
        emoji: "🇩🇪"
      }, {
        value: "it-it",
        title: "mayday-editor.menu.slash.options.translate.it-it",
        emoji: "🇮🇹"
      }, {
        value: "pt-pt",
        title: "mayday-editor.menu.slash.options.translate.pt-pt",
        emoji: "🇵🇹"
      }, {
        value: "nl-nl",
        title: "mayday-editor.menu.slash.options.translate.nl-nl",
        emoji: "🇳🇱"
      }, {
        value: "zh-cn",
        title: "mayday-editor.menu.slash.options.translate.zh-cn",
        emoji: "🇨🇳"
      }, {
        value: "ru-ru",
        title: "mayday-editor.menu.slash.options.translate.ru-ru",
        emoji: "🇷🇺"
      }]
    });
  }

  if (allowGrammarCorrection) {
    commands.push({
      key: "correct",
      alias: ["correction", "grammar", "orthography"],
      title: i18nMap["correct"],
      icon: "pen-nib",
      command: function command(_ref22) {
        var editor = _ref22.editor,
            range = _ref22.range;
        if (editor.storage.streamWrapper.streaming) return;
        editor.chain().setMeta("preventUpdate", true).focus().deleteRange(range).insertContent({
          type: "grammarCorrector"
        }).run();
      },
      aiFeature: true
    });
  }

  if (allowToneImprovement) {
    commands.push({
      key: "tone",
      alias: ["ton", "tonalité", "tonality", "style"],
      title: i18nMap["tone"],
      icon: "keynote",
      aiFeature: true,
      command: function command(_ref23) {
        var editor = _ref23.editor,
            range = _ref23.range,
            option = _ref23.option;
        if (editor.storage.streamWrapper.streaming) return;
        editor.storage.streamWrapper.tone = option;
        editor.chain().setMeta("preventUpdate", true).focus().deleteRange(range).insertContent({
          type: "toneImprover"
        }).run();
      }
    });
  }

  if (allowActionItems) {
    commands.push({
      key: "action-items",
      alias: ["todo", "tache", "task", "action", "items"],
      title: i18nMap["action-items"],
      icon: "file-check",
      aiFeature: true,
      command: function command(_ref24) {
        var editor = _ref24.editor,
            range = _ref24.range;
        editor.chain().focus().deleteRange(range).run();
        emit("generate-action-items", {});
      }
    });
  }

  return commands;
};
var SlashMenuCommands_computeCommandsFinder = function computeCommandsFinder(commands) {
  return new Fuse(commands, {
    keys: ["key", "title", "icon", "alias", "disabled", "aiFeature"],
    threshold: 0.4
  });
};
// CONCATENATED MODULE: ./src/extensions/SlashMenu/SlashMenuSuggestion.ts
var SlashMenuSuggestion_this = undefined;












var SlashMenuSuggestion_computeSuggestion = function computeSuggestion(i18nMap, isFileUploadCallbackProvided, uploadStoreAction) {
  var allowToc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var allowSummary = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var allowTranslation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var allowGrammarCorrection = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var allowToneImprovement = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var allowActionItems = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var notifyUploadError = arguments.length > 9 ? arguments[9] : undefined;
  var emit = arguments.length > 10 ? arguments[10] : undefined;
  var commands = SlashMenuCommands_computeCommands(i18nMap, isFileUploadCallbackProvided, uploadStoreAction, allowToc, allowSummary, allowTranslation, allowGrammarCorrection, allowToneImprovement, allowActionItems, notifyUploadError, emit);
  var finder = SlashMenuCommands_computeCommandsFinder(commands);
  return {
    items: function items(_ref) {
      var query = _ref.query,
          editor = _ref.editor;

      if (!query.length) {
        return commands;
      }

      var result = finder.search(query).map(function (_ref2) {
        var item = _ref2.item;
        return item;
      });
      return editor.isActive("table") ? result.filter(function (_ref3) {
        var key = _ref3.key;
        return key !== "table";
      }) : result;
    },
    render: function render() {
      var component;
      var popup;
      var lastClientRect;
      return {
        onStart: function onStart(props) {
          var _props$clientRect;

          var editor = props.editor;
          var contentComponent = editor.contentComponent;
          var clientRect = (_props$clientRect = props.clientRect) === null || _props$clientRect === void 0 ? void 0 : _props$clientRect.call(props); // inject contentComponent to make i18n work (probably other vue plugins too)

          component = new tiptap_vue_2_esm_VueRenderer(Slash_SlashMenu, {
            parent: contentComponent != null ? contentComponent : SlashMenuSuggestion_this,
            propsData: props
          });
          popup = tippy_esm(document.body, {
            getReferenceClientRect: props.clientRect,
            appendTo: function appendTo() {
              return document.body;
            },
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
            theme: "bubble-menu",
            animation: "shift-away",
            duration: [330, 200],
            arrow: false,
            onHidden: function onHidden() {
              var storage = editor.storage.slashMenu;
              storage.isSlashMenuOpen = false;
            }
          });

          if (clientRect != null) {
            // save client rect for exit time
            lastClientRect = clientRect; // open slash command button

            if (contentComponent != null && // MaydayEditor element
            contentComponent.$el.parentElement != null) {
              var storage = editor.storage.slashMenu;
              var placeholderStorage = editor.storage.placeholder;
              var editorRect = contentComponent.$el.parentElement.getBoundingClientRect();
              storage.isSlashMenuOpen = true;
              placeholderStorage.top = clientRect.top - editorRect.top + "px";
              placeholderStorage.left = clientRect.left - editorRect.left - SlashMenuCommandButtonvue_type_script_lang_ts_WIDTH - 10 + "px";
            }
          }
        },
        onUpdate: function onUpdate(props) {
          var _props$clientRect2;

          var clientRect = (_props$clientRect2 = props.clientRect) === null || _props$clientRect2 === void 0 ? void 0 : _props$clientRect2.call(props);
          lastClientRect = clientRect != null ? clientRect : lastClientRect;
          component.updateProps(props);
          popup.setProps({
            getReferenceClientRect: props.clientRect
          });
        },
        onKeyDown: function onKeyDown(props) {
          if (props.event.key === "Escape") {
            popup.hide();
            return true;
          }

          return component.ref.onKeyDown(props);
        },
        onExit: function onExit(props) {
          var editor = props.editor;
          var storage = editor.storage.slashMenu;
          popup.setProps({
            // lock menu to its last position and allow close animation to play
            getReferenceClientRect: lastClientRect != null ? function () {
              return lastClientRect;
            } : null,
            onHidden: function onHidden() {
              popup.destroy();
              component.destroy();
            }
          });
          popup.hide();
          storage.isSlashMenuOpen = false;
        }
      };
    }
  };
};

/* harmony default export */ var SlashMenuSuggestion = (SlashMenuSuggestion_computeSuggestion);
// CONCATENATED MODULE: ./src/extensions/SlashMenu/SlashMenu.ts






var SlashMenu_computeSlashMenuExtension = function computeSlashMenuExtension(i18nMap, isFileUploadCallbackProvided, uploadStoreAction, allowToc, allowSummary, allowTranslation, allowGrammarCorrection, allowToneImprovement, allowActionItems, notifyUploadError, emit) {
  return Extension.create({
    name: "slashMenu",
    addStorage: function addStorage() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        isSlashMenuOpen: false
      });
    },
    addOptions: function addOptions() {
      return {
        suggestion: {
          char: "/",
          startOfLine: false,
          command: function command(_ref) {
            var editor = _ref.editor,
                range = _ref.range,
                props = _ref.props;
            props.command({
              editor: editor,
              range: range,
              option: props.optionValue
            });
          }
        }
      };
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      return [Suggestion(_objectSpread2({
        editor: this.editor,
        pluginKey: new PluginKey("slashMenuSuggestion")
      }, this.options.suggestion))];
    }
  }).configure({
    suggestion: SlashMenuSuggestion(i18nMap, isFileUploadCallbackProvided, uploadStoreAction, allowToc, allowSummary, allowTranslation, allowGrammarCorrection, allowToneImprovement, allowActionItems, notifyUploadError, emit)
  });
};

/* harmony default export */ var SlashMenu_SlashMenu = (SlashMenu_computeSlashMenuExtension);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/InlineContentMenu/InlineContentMenu.vue?vue&type=template&id=6583bc96&scoped=true&
var InlineContentMenuvue_type_template_id_6583bc96_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__inline-content-menu"},[(_vm.hasItems)?_c('div',{staticClass:"mayday-editor__inline-content-menu__items"},_vm._l((_vm.itemsWithFlatContents),function(item,typeIndex){return _c('div',{key:item.label},[(item.options.length)?_c('div',{staticClass:"mayday-editor__inline-content-menu__type-text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.categories[item.label]))+" ")]):_vm._e(),_vm._l((item.options),function(item,contentIndex){return _c('button',{key:("inline-content-menu-item-" + (item.entityType) + ":" + (item.entityId) + ":" + (item.lang)),staticClass:"mayday-editor__inline-content-menu__items__item-wrapper",class:_vm.computeSelectedClass(contentIndex, typeIndex),style:(_vm.computeUserStyle(item.label)),on:{"click":function($event){return _vm.selectItem(contentIndex, typeIndex)},"mouseenter":function($event){return _vm.hoverItem(contentIndex, typeIndex)}}},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"icon-wrapper",class:_vm.computeSelectedClass(contentIndex, typeIndex)},[(_vm.contentTypes.includes(item.type))?_c('i',{class:['icon', _vm.computeItemTypeIconClass(item.type)],attrs:{"aria-hidden":"true"}}):_c('div',{staticClass:"icon-initials"},[_vm._v(" "+_vm._s(_vm.computeInitials(item.label))+" ")])]),_c('div',{ref:((item.entityType) + ":" + (item.entityId)),refInFor:true,staticClass:"item-details"},[_c('div',{staticClass:"label"},[_c('span',{staticClass:"label-title",class:{ 'label-title-90': item.lang }},[_vm._v(_vm._s(item.label))]),(item.lang)?_c('div',{staticClass:"flag-title"},[_vm._v(" "+_vm._s(_vm.$t(("mayday-editor.menu.translate.flags." + (item.lang))))+" ")]):_vm._e()]),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.computeDescription(item.description))+" ")])])])])})],2)}),0):_c('div',{staticClass:"mayday-editor__inline-content-menu__no-items"},[_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.inline-content.no-results")))])])])}
var InlineContentMenuvue_type_template_id_6583bc96_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenu.vue?vue&type=template&id=6583bc96&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__("5db7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__("73d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("4e82");

// EXTERNAL MODULE: external "vue-i18n"
var external_vue_i18n_ = __webpack_require__("85b3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/InlineContentMenu/InlineContentMenu.vue?vue&type=script&lang=ts&






























var EntityTypes;

(function (EntityTypes) {
  EntityTypes["CONTENT"] = "Content";
  EntityTypes["USER"] = "User";
  EntityTypes["ROLE"] = "Role";
  EntityTypes["CASE"] = "Case";
})(EntityTypes || (EntityTypes = {}));

var ContentTypes;

(function (ContentTypes) {
  ContentTypes["ARTICLE"] = "Article";
  ContentTypes["DIAGNOSTIC"] = "Diagnostic";
  ContentTypes["STEP"] = "Step";
  ContentTypes["CASE"] = "Case";
  ContentTypes["KEY_STEP"] = "keyStep";
})(ContentTypes || (ContentTypes = {}));

var InlineContentMenuvue_type_script_lang_ts_InlineContentMenu = /*#__PURE__*/function (_Vue) {
  _inherits(InlineContentMenu, _Vue);

  var _super = _createSuper(InlineContentMenu);

  function InlineContentMenu() {
    var _this;

    _classCallCheck(this, InlineContentMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "items", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tippyInstance", null);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectedIndex", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "contentTypes", [ContentTypes.ARTICLE, ContentTypes.DIAGNOSTIC]);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "categories", {
      Content: "mayday-editor.menu.inline-content.types.contents",
      User: "mayday-editor.menu.inline-content.types.users",
      Role: "mayday-editor.menu.inline-content.types.roles",
      Case: "mayday-editor.menu.inline-content.types.cases"
    });

    return _this;
  }

  _createClass(InlineContentMenu, [{
    key: "handleTooltipInstance",
    value: function handleTooltipInstance() {
      if (!this.selectedItem) return;
      var _this$selectedItem = this.selectedItem,
          entityType = _this$selectedItem.entityType,
          entityId = _this$selectedItem.entityId,
          label = _this$selectedItem.label,
          description = _this$selectedItem.description;
      var id = "".concat(entityType, ":").concat(entityId);
      var itemEl = this.$refs[id];
      if (!itemEl || !itemEl.length) return;
      var tippyEl = itemEl[0];
      var labelOverflow = false;
      var children = Array.from(tippyEl.children); // show tooltip even for label or description

      children.forEach(function (el) {
        if (el.scrollWidth > el.clientWidth) {
          labelOverflow = true;
        }
      });

      if (labelOverflow) {
        this.tippyInstance = tippy_esm(tippyEl, {
          content: "".concat(label, "\n").concat(description),
          theme: "bubble-menu-tooltip",
          arrow: ROUND_ARROW,
          animation: "shift-away",
          duration: [200, 150],
          inertia: true
        });
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.handleTooltipInstance();
    }
  }, {
    key: "handleTooltipIndexChanged",
    value: function handleTooltipIndexChanged() {
      this.handleTooltipInstance();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.selectedIndex = -1;

      if (this.tippyInstance) {
        this.tippyInstance.destroy();
        this.tippyInstance = null;
      }
    }
  }, {
    key: "flatItems",
    get: function get() {
      return this.itemsWithFlatContents.flatMap(function (item) {
        return item.options;
      });
    }
  }, {
    key: "itemsWithFlatContents",
    get: function get() {
      return this.items.map(function (item) {
        if (item.label !== EntityTypes.CONTENT && item.label !== EntityTypes.CASE) return item; // Flatten the options array using reduce because
        // explain is an array. We make sure that we have
        // unique values for each lang as explain can have multiple times
        // the same lang but different field

        var reducedOptions = item.options.reduce(function (acc, option, index) {
          var _option$explain;

          if (!((_option$explain = option.explain) !== null && _option$explain !== void 0 && _option$explain.length) || !option.labelTranslations) {
            acc[option.entityId] = _objectSpread2(_objectSpread2({}, option), {}, {
              index: index
            });
            return acc;
          }

          option.explain.forEach(function (explain) {
            if (!explain.lang || !option.labelTranslations[explain.lang]) return;
            acc["".concat(option.entityId, ":").concat(explain.lang)] = _objectSpread2(_objectSpread2({}, option), {}, {
              index: index,
              lang: explain.lang !== "default" ? explain.lang : undefined,
              label: "".concat(option.labelTranslations[explain.lang])
            });
          });
          return acc;
        }, {});
        return _objectSpread2(_objectSpread2({}, item), {}, {
          // Make sure only non null values are returned (in case a lang translation is empty)
          options: Object.values(reducedOptions).filter(function (option) {
            return option === null || option === void 0 ? void 0 : option.label;
          }) // Make sure we preserve the original order
          .sort(function (a, b) {
            return a.index - b.index;
          })
        });
      });
    }
  }, {
    key: "hasItems",
    get: function get() {
      return this.flatItems.length > 0;
    }
  }, {
    key: "offsetIndex",
    value: function offsetIndex(index, indexType) {
      var _this2 = this;

      if (indexType === 0) return index;
      var iter = Array.from(Array(indexType).keys());
      var offset = iter.reduce(function (acc, val) {
        acc += _this2.itemsWithFlatContents[val].options.length;
        return acc;
      }, 0);
      return offset + index;
    }
  }, {
    key: "handleItemsChanged",
    value: function handleItemsChanged() {
      this.selectedIndex = 0;
    }
  }, {
    key: "computeSelectedClass",
    value: function computeSelectedClass(index, indexType) {
      var relativeIndex = this.offsetIndex(index, indexType);
      var item = this.flatItems[relativeIndex];
      return Object(defineProperty["a" /* default */])({}, "is-selected__".concat(item.type.toLowerCase()), relativeIndex === this.selectedIndex);
    }
  }, {
    key: "computeItemTypeIconClass",
    value: function computeItemTypeIconClass(type) {
      return type ? "icon--".concat(type.toLowerCase()) : "icon";
    }
  }, {
    key: "computeDescription",
    value: function computeDescription(description) {
      if (!description || description === "") return this.$t("mayday-editor.menu.inline-content.empty-description");
      return description;
    }
  }, {
    key: "computeInitials",
    value: function computeInitials(username) {
      var _fullName$shift, _fullName$pop, _fullName$shift2, _fullName$shift2$char;

      var fullName = username.split(" ");
      if (fullName.length >= 2) return "".concat((_fullName$shift = fullName.shift()) === null || _fullName$shift === void 0 ? void 0 : _fullName$shift.charAt(0)).concat(fullName === null || fullName === void 0 ? void 0 : (_fullName$pop = fullName.pop()) === null || _fullName$pop === void 0 ? void 0 : _fullName$pop.charAt(0)).toUpperCase() || "NA";
      return (fullName === null || fullName === void 0 ? void 0 : (_fullName$shift2 = fullName.shift()) === null || _fullName$shift2 === void 0 ? void 0 : (_fullName$shift2$char = _fullName$shift2.charAt(0)) === null || _fullName$shift2$char === void 0 ? void 0 : _fullName$shift2$char.toUpperCase()) || "NA";
    }
  }, {
    key: "computeUserStyle",
    value: function computeUserStyle(str) {
      var hash = 0;

      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      var color = "hsl(".concat(h, ",", 70, "%,", 50, "%)");
      return {
        "--custom-color": color
      };
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(_ref2) {
      var event = _ref2.event;

      if (event.key === "ArrowUp") {
        this.upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        this.downHandler();
        return true;
      }

      if (event.key === "Enter") {
        this.enterHandler();
        return !!this.flatItems.length;
      }

      return false;
    }
  }, {
    key: "upHandler",
    value: function upHandler() {
      this.selectedIndex = (this.selectedIndex + this.flatItems.length - 1) % this.flatItems.length;
      this.scrollIntoSelectedItem();
    }
  }, {
    key: "downHandler",
    value: function downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.flatItems.length;
      this.scrollIntoSelectedItem();
    }
  }, {
    key: "scrollIntoSelectedItem",
    value: function scrollIntoSelectedItem() {
      this.$nextTick(function () {
        var el = document.querySelectorAll('[class*="is-selected"]');

        if (el) {
          el[0].scrollIntoView({
            block: "nearest",
            inline: "nearest"
          });
        }
      });
    }
  }, {
    key: "hoverItem",
    value: function hoverItem(index, indexType) {
      var relativeIndex = this.offsetIndex(index, indexType);
      this.selectedIndex = relativeIndex;
    }
  }, {
    key: "selectedItem",
    get: function get() {
      if (this.selectedIndex > -1) return this.flatItems[this.selectedIndex];
      return null;
    }
  }, {
    key: "enterHandler",
    value: function enterHandler() {
      var item = this.flatItems[this.selectedIndex];

      if (item != null) {
        this.command({
          nodeId: item.entityId,
          nodeName: item.entityType,
          nodeType: item.type,
          lang: item.lang
        });
        this.selectedIndex = 0;
      }
    }
  }, {
    key: "selectItem",
    value: function selectItem(index, indexType) {
      var relativeIndex = this.offsetIndex(index, indexType);
      var item = this.flatItems[relativeIndex];

      if (item != null) {
        this.command({
          nodeId: item.entityId,
          nodeName: item.entityType,
          nodeType: item.type,
          lang: item.lang
        });
        this.selectedIndex = 0;
      }
    }
  }]);

  return InlineContentMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Array)], InlineContentMenuvue_type_script_lang_ts_InlineContentMenu.prototype, "items", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], InlineContentMenuvue_type_script_lang_ts_InlineContentMenu.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("selectedIndex"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], InlineContentMenuvue_type_script_lang_ts_InlineContentMenu.prototype, "handleTooltipIndexChanged", null);

InlineContentMenuvue_type_script_lang_ts_InlineContentMenu = __decorate([external_vue_property_decorator_["Component"]], InlineContentMenuvue_type_script_lang_ts_InlineContentMenu);
/* harmony default export */ var InlineContentMenuvue_type_script_lang_ts_ = (InlineContentMenuvue_type_script_lang_ts_InlineContentMenu);
// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var InlineContentMenu_InlineContentMenuvue_type_script_lang_ts_ = (InlineContentMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenu.vue?vue&type=style&index=0&id=6583bc96&lang=scss&scoped=true&
var InlineContentMenuvue_type_style_index_0_id_6583bc96_lang_scss_scoped_true_ = __webpack_require__("46bd");

// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenu.vue






/* normalize component */

var InlineContentMenu_component = normalizeComponent(
  InlineContentMenu_InlineContentMenuvue_type_script_lang_ts_,
  InlineContentMenuvue_type_template_id_6583bc96_scoped_true_render,
  InlineContentMenuvue_type_template_id_6583bc96_scoped_true_staticRenderFns,
  false,
  null,
  "6583bc96",
  null
  
)

/* harmony default export */ var InlineContentMenu_InlineContentMenu = (InlineContentMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue?vue&type=template&id=f5944738&scoped=true&
var InlineContentMenuCommandButtonvue_type_template_id_f5944738_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.containerClasses,style:(_vm.style),on:{"click":_vm.toggleSlashMenu}},[_c('span',{class:_vm.innerContainerClass},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', _vm.icon]}})],1)])}
var InlineContentMenuCommandButtonvue_type_template_id_f5944738_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue?vue&type=template&id=f5944738&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue?vue&type=script&lang=ts&











var InlineContentMenuCommandButtonvue_type_script_lang_ts_WIDTH = 20;
var InlineContentMenuCommandButtonvue_type_script_lang_ts_baseClass = "mayday-editor__inline-content-menu-command-button";

var InlineContentMenuCommandButtonvue_type_script_lang_ts_InlineContentMenuCommandButton = /*#__PURE__*/function (_Vue) {
  _inherits(InlineContentMenuCommandButton, _Vue);

  var _super = _createSuper(InlineContentMenuCommandButton);

  function InlineContentMenuCommandButton() {
    var _this;

    _classCallCheck(this, InlineContentMenuCommandButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "width", "".concat(InlineContentMenuCommandButtonvue_type_script_lang_ts_WIDTH, "px"));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", InlineContentMenuCommandButtonvue_type_script_lang_ts_baseClass);

    return _this;
  }

  _createClass(InlineContentMenuCommandButton, [{
    key: "storage",
    get: function get() {
      var _this$editor;

      var storage = ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.storage) || {};
      var placeholderStorage = storage.placeholder;
      var slashMenuStorage = storage.slashMenu;
      return _objectSpread2(_objectSpread2({}, placeholderStorage), slashMenuStorage);
    }
  }, {
    key: "showCommandButton",
    get: function get() {
      var storage = this.storage;
      return storage.showCommandButton || storage.isInlineContentMenuOpen;
    }
  }, {
    key: "style",
    get: function get() {
      var width = this.width,
          storage = this.storage,
          showCommandButton = this.showCommandButton;
      var top = storage.top,
          left = storage.left;
      return {
        width: width,
        visibility: showCommandButton ? "visible" : "hidden",
        opacity: showCommandButton ? "1" : "0",
        top: top,
        left: left
      };
    }
  }, {
    key: "containerClasses",
    get: function get() {
      var _ref;

      var base = this.baseClass;
      var isInlineContentMenuOpen = this.storage.isInlineContentMenuOpen;
      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, base, true), Object(defineProperty["a" /* default */])(_ref, "".concat(base, "--is-open"), isInlineContentMenuOpen), _ref;
    }
  }, {
    key: "innerContainerClass",
    get: function get() {
      var base = this.baseClass;
      return "".concat(base, "__inner-circle");
    }
  }, {
    key: "icon",
    get: function get() {
      return this.storage.isInlineContentMenuOpen ? "times" : "plus";
    }
  }, {
    key: "toggleSlashMenu",
    value: function toggleSlashMenu() {
      if (this.editor == null) {
        return;
      }

      var isInlineContentMenuOpen = this.storage.isInlineContentMenuOpen;
      var chain = this.editor.chain().focus();

      if (isInlineContentMenuOpen) {
        chain.undo().run();
      } else {
        chain.insertContent("/").run();
      }
    }
  }]);

  return InlineContentMenuCommandButton;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], InlineContentMenuCommandButtonvue_type_script_lang_ts_InlineContentMenuCommandButton.prototype, "editor", void 0);

InlineContentMenuCommandButtonvue_type_script_lang_ts_InlineContentMenuCommandButton = __decorate([external_vue_property_decorator_["Component"]], InlineContentMenuCommandButtonvue_type_script_lang_ts_InlineContentMenuCommandButton);
/* harmony default export */ var InlineContentMenuCommandButtonvue_type_script_lang_ts_ = (InlineContentMenuCommandButtonvue_type_script_lang_ts_InlineContentMenuCommandButton);
// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var InlineContentMenu_InlineContentMenuCommandButtonvue_type_script_lang_ts_ = (InlineContentMenuCommandButtonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue?vue&type=style&index=0&id=f5944738&lang=scss&scoped=true&
var InlineContentMenuCommandButtonvue_type_style_index_0_id_f5944738_lang_scss_scoped_true_ = __webpack_require__("8ec4");

// CONCATENATED MODULE: ./src/components/menus/InlineContentMenu/InlineContentMenuCommandButton.vue






/* normalize component */

var InlineContentMenuCommandButton_component = normalizeComponent(
  InlineContentMenu_InlineContentMenuCommandButtonvue_type_script_lang_ts_,
  InlineContentMenuCommandButtonvue_type_template_id_f5944738_scoped_true_render,
  InlineContentMenuCommandButtonvue_type_template_id_f5944738_scoped_true_staticRenderFns,
  false,
  null,
  "f5944738",
  null
  
)

/* harmony default export */ var InlineContentMenu_InlineContentMenuCommandButton = (InlineContentMenuCommandButton_component.exports);
// CONCATENATED MODULE: ./src/extensions/InlineContentMenu/InlineContentMenuSuggestion.ts
var InlineContentMenuSuggestion_this = undefined;






var InlineContentMenuSuggestion_computeSuggestion = function computeSuggestion(i18nMap, finderStoreAction) {
  return {
    items: function items(_ref) {
      var query = _ref.query;
      return finderStoreAction(query);
    },
    render: function render() {
      var component;
      var popup;
      var lastClientRect;
      return {
        onStart: function onStart(props) {
          var _props$clientRect;

          // Do not trigger again suggestion menu on existing @
          if (props.query) return;
          var editor = props.editor;
          var contentComponent = editor.contentComponent;
          var clientRect = (_props$clientRect = props.clientRect) === null || _props$clientRect === void 0 ? void 0 : _props$clientRect.call(props); // inject contentComponent to make i18n work (probably other vue plugins too)

          component = new tiptap_vue_2_esm_VueRenderer(InlineContentMenu_InlineContentMenu, {
            parent: contentComponent != null ? contentComponent : InlineContentMenuSuggestion_this,
            propsData: props
          });
          popup = tippy_esm(document.body, {
            getReferenceClientRect: props.clientRect,
            appendTo: function appendTo() {
              return document.body;
            },
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
            theme: "bubble-menu",
            animation: "shift-away",
            duration: [330, 200],
            arrow: false,
            onHidden: function onHidden() {
              var storage = editor.storage.inlineContentMenu;
              storage.isInlineContentMenuOpen = false;
            }
          });

          if (clientRect != null) {
            // save client rect for exit time
            lastClientRect = clientRect; // open slash command button

            if (contentComponent != null && // MaydayEditor element
            contentComponent.$el.parentElement != null) {
              var storage = editor.storage.inlineContentMenu;
              var placeholderStorage = editor.storage.placeholder;
              var editorRect = contentComponent.$el.parentElement.getBoundingClientRect();
              storage.isInlineContentMenuOpen = true;
              placeholderStorage.top = clientRect.top - editorRect.top + "px";
              placeholderStorage.left = clientRect.left - editorRect.left - InlineContentMenuCommandButtonvue_type_script_lang_ts_WIDTH - 10 + "px";
            }
          }
        },
        onUpdate: function onUpdate(props) {
          var _props$clientRect2;

          var clientRect = (_props$clientRect2 = props.clientRect) === null || _props$clientRect2 === void 0 ? void 0 : _props$clientRect2.call(props);
          lastClientRect = clientRect != null ? clientRect : lastClientRect;
          component.updateProps(props);
          popup.setProps({
            getReferenceClientRect: props.clientRect
          });
        },
        onKeyDown: function onKeyDown(props) {
          var event = props.event,
              range = props.range;

          if (event.key === "Escape") {
            component.destroy();
            popup.hide();
            popup.disable();
            return true;
          } else if (event.key === "Backspace" && range.to - range.from === 1) {
            if (popup.state.isEnabled) {
              component.destroy();
              popup.hide();
              popup.disable();
              return true;
            }

            return false;
          }

          if (popup.state.isEnabled) {
            return component.ref.onKeyDown(props);
          }

          return false;
        },
        onExit: function onExit(props) {
          var editor = props.editor;
          var storage = editor.storage.inlineContentMenu;
          popup.setProps({
            // lock menu to its last position and allow close animation to play
            getReferenceClientRect: lastClientRect != null ? function () {
              return lastClientRect;
            } : null,
            onHidden: function onHidden() {
              popup.destroy();
              component.destroy();
            }
          });
          popup.hide();
          storage.isInlineContentMenuOpen = false;
        }
      };
    }
  };
};

/* harmony default export */ var InlineContentMenuSuggestion = (InlineContentMenuSuggestion_computeSuggestion);
// CONCATENATED MODULE: ./src/extensions/InlineContentMenu/InlineContentMenu.ts






var InlineContentMenu_computeInlineContentMenuExtension = function computeInlineContentMenuExtension(i18nMap, finderStoreAction) {
  return Extension.create({
    name: "inlineContentMenu",
    addStorage: function addStorage() {
      var _this$parent;

      return _objectSpread2(_objectSpread2({}, (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)), {}, {
        isInlineContentMenuOpen: false
      });
    },
    addOptions: function addOptions() {
      return {
        suggestion: {
          char: "@",
          startOfLine: false,
          allowSpaces: true,
          command: function command(_ref) {
            var editor = _ref.editor,
                range = _ref.range,
                props = _ref.props;
            var extensionType = props.nodeName === "Content" || props.nodeName === "Case" ? "inlineContent" : "inlineMention";
            editor.chain().focus().insertContentAt(range, [{
              type: extensionType,
              attrs: props
            }, {
              type: "text",
              text: " "
            }]).run();
          }
        }
      };
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      return [Suggestion(_objectSpread2({
        editor: this.editor,
        pluginKey: new PluginKey("inlineContentMenuSuggestion")
      }, this.options.suggestion))];
    }
  }).configure({
    suggestion: InlineContentMenuSuggestion(i18nMap, finderStoreAction)
  });
};

/* harmony default export */ var extensions_InlineContentMenu_InlineContentMenu = (InlineContentMenu_computeInlineContentMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/DividerBubbleMenu.ts


var dividerBubbleMenuClass = "mayday-editor__bubble-menu-divider";

var DividerBubbleMenu_computeDividerBubbleMenuExtension = function computeDividerBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "dividerBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(dividerBubbleMenuClass)),
    pluginKey: "dividerBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("divider") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "bottom",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none"
    }
  });
};

/* harmony default export */ var BubbleMenu_DividerBubbleMenu = (DividerBubbleMenu_computeDividerBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/CalloutBubbleMenu/CalloutBubbleMenuPlugin.ts











var CalloutBubbleMenuPlugin_CalloutMenuView = /*#__PURE__*/function () {
  // default shouldShow, it would'nt be used
  // changes from original version
  function CalloutMenuView(_ref) {
    var _this = this;

    var _editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        _ref$tippyOptions = _ref.tippyOptions,
        tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
        shouldShow = _ref.shouldShow;

    _classCallCheck(this, CalloutMenuView);

    Object(defineProperty["a" /* default */])(this, "editor", void 0);

    Object(defineProperty["a" /* default */])(this, "element", void 0);

    Object(defineProperty["a" /* default */])(this, "view", void 0);

    Object(defineProperty["a" /* default */])(this, "preventHide", false);

    Object(defineProperty["a" /* default */])(this, "tippy", void 0);

    Object(defineProperty["a" /* default */])(this, "tippyOptions", void 0);

    Object(defineProperty["a" /* default */])(this, "shouldShow", function (_ref2) {
      var editor = _ref2.editor,
          state = _ref2.state,
          from = _ref2.from,
          to = _ref2.to;
      // if editor is not editable, don't show menus
      if (!editor.isEditable) return false;
      var doc = state.doc,
          selection = state.selection;
      var empty = selection.empty; // Sometime check for `empty` is not enough.
      // Double click an empty paragraph returns a node size of 2.
      // So we check also for an empty text size.

      var isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);

      if (empty || isEmptyTextBlock) {
        return false;
      }

      return true;
    });

    Object(defineProperty["a" /* default */])(this, "predicate", function (_ref3) {
      var type = _ref3.type;
      return type.name === "callout";
    });

    Object(defineProperty["a" /* default */])(this, "findCallout", findParentNode(this.predicate));

    Object(defineProperty["a" /* default */])(this, "mousedownHandler", function () {
      _this.preventHide = true;
    });

    Object(defineProperty["a" /* default */])(this, "dragstartHandler", function () {
      _this.hide();
    });

    Object(defineProperty["a" /* default */])(this, "focusHandler", function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    });

    Object(defineProperty["a" /* default */])(this, "blurHandler", function (_ref4) {
      var _this$element$parentN;

      var event = _ref4.event;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if (event !== null && event !== void 0 && event.relatedTarget && (_this$element$parentN = _this.element.parentNode) !== null && _this$element$parentN !== void 0 && _this$element$parentN.contains(event.relatedTarget)) {
        return;
      }

      _this.hide();
    });

    this.editor = _editor;
    this.element = element;
    this.view = view;

    if (shouldShow) {
      this.shouldShow = shouldShow;
    }

    this.element.addEventListener("mousedown", this.mousedownHandler, {
      capture: true
    });
    this.view.dom.addEventListener("dragstart", this.dragstartHandler);
    this.editor.on("focus", this.focusHandler);
    this.editor.on("blur", this.blurHandler);
    this.tippyOptions = tippyOptions; // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = "visible";
  }

  _createClass(CalloutMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy_esm(editorElement, _objectSpread2({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: "manual",
        placement: "top",
        hideOnClick: "toggle"
      }, this.tippyOptions));
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _this$shouldShow, _this$tippy;

      var state = view.state,
          composing = view.composing;
      var doc = state.doc,
          selection = state.selection;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      if (composing || isSame) {
        return;
      }

      this.createTooltip(); // support for CellSelections

      var ranges = selection.ranges;
      var from = Math.min.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$from.pos;
      })));
      var to = Math.max.apply(Math, _toConsumableArray(ranges.map(function (range) {
        return range.$to.pos;
      })));
      var shouldShow = (_this$shouldShow = this.shouldShow) === null || _this$shouldShow === void 0 ? void 0 : _this$shouldShow.call(this, {
        editor: this.editor,
        view: view,
        state: state,
        oldState: oldState,
        from: from,
        to: to
      });

      if (!shouldShow) {
        this.hide();
        return;
      } // changes from original version


      var node = this.findCallout(selection);

      if (node == null) {
        return;
      }

      var nodeDOM = view.nodeDOM(node === null || node === void 0 ? void 0 : node.pos);
      (_this$tippy = this.tippy) === null || _this$tippy === void 0 ? void 0 : _this$tippy.setProps({
        getReferenceClientRect: function getReferenceClientRect() {
          return nodeDOM.getBoundingClientRect();
        }
      });
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      var _this$tippy2;

      (_this$tippy2 = this.tippy) === null || _this$tippy2 === void 0 ? void 0 : _this$tippy2.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$tippy3;

      (_this$tippy3 = this.tippy) === null || _this$tippy3 === void 0 ? void 0 : _this$tippy3.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$tippy4;

      (_this$tippy4 = this.tippy) === null || _this$tippy4 === void 0 ? void 0 : _this$tippy4.destroy();
      this.element.removeEventListener("mousedown", this.mousedownHandler, {
        capture: true
      });
      this.view.dom.removeEventListener("dragstart", this.dragstartHandler);
      this.editor.off("focus", this.focusHandler);
      this.editor.off("blur", this.blurHandler);
    }
  }]);

  return CalloutMenuView;
}();
var CalloutBubbleMenuPlugin_CalloutBubbleMenuPlugin = function CalloutBubbleMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === "string" ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new CalloutBubbleMenuPlugin_CalloutMenuView(_objectSpread2({
        view: _view
      }, options));
    }
  });
};
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/CalloutBubbleMenu/CalloutBubbleMenu.ts


var calloutBubbleMenuClass = "mayday-editor__bubble-menu-callout";

var CalloutBubbleMenu_computeCalloutBubbleMenuExtension = function computeCalloutBubbleMenuExtension($el) {
  return Extension.create({
    name: "calloutBubbleMenu",
    addOptions: function addOptions() {
      return {
        element: null,
        tippyOptions: {},
        pluginKey: "bubbleMenu",
        shouldShow: null
      };
    },
    // replace default plugin with a custom one
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      if (!this.options.element) {
        return [];
      }

      return [CalloutBubbleMenuPlugin_CalloutBubbleMenuPlugin({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })];
    }
  }).configure({
    element: $el.querySelector(".".concat(calloutBubbleMenuClass)),
    pluginKey: "calloutBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("callout") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "bottom",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none"
    }
  });
};

/* harmony default export */ var CalloutBubbleMenu_CalloutBubbleMenu = (CalloutBubbleMenu_computeCalloutBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/AttachmentBubbleMenu.ts


var attachmentBubbleMenuClass = "mayday-editor__bubble-menu-attachment";

var AttachmentBubbleMenu_computeAttachmentBubbleMenuExtension = function computeAttachmentBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "attachmentBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(attachmentBubbleMenuClass)),
    pluginKey: "attachmentBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("attachment") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "top",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none"
    }
  });
};

/* harmony default export */ var BubbleMenu_AttachmentBubbleMenu = (AttachmentBubbleMenu_computeAttachmentBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/InlineBubbleMenu.ts


var inlineBubbleMenuClass = "mayday-editor__bubble-menu-inline";

var InlineBubbleMenu_computeInlineBubbleMenuExtension = function computeInlineBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "inlineBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(inlineBubbleMenuClass)),
    pluginKey: "inlineBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("inlineContent") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "top",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none"
    }
  });
};

/* harmony default export */ var BubbleMenu_InlineBubbleMenu = (InlineBubbleMenu_computeInlineBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/LinkBubbleMenu.ts


var linkBubbleMenuClass = "mayday-editor__bubble-menu-link";

var LinkBubbleMenu_computeLinkBubbleMenuExtension = function computeLinkBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "linkBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(linkBubbleMenuClass)),
    pluginKey: "linkBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return (editor.isActive("link") || editor.isActive("embed")) && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "top",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none",
      appendTo: function appendTo() {
        return document.body;
      }
    }
  });
};

/* harmony default export */ var BubbleMenu_LinkBubbleMenu = (LinkBubbleMenu_computeLinkBubbleMenuExtension);
// CONCATENATED MODULE: ./src/extensions/BubbleMenu/ImageBubbleMenu.ts


var imageBubbleMenuClass = "mayday-editor__bubble-menu-image";

var ImageBubbleMenu_computeImageBubbleMenuExtension = function computeImageBubbleMenuExtension($el) {
  return BubbleMenu.extend({
    name: "imageBubbleMenu"
  }).configure({
    element: $el.querySelector(".".concat(imageBubbleMenuClass)),
    pluginKey: "imageBubbleMenu",
    shouldShow: function shouldShow(_ref) {
      var editor = _ref.editor;
      return editor.isActive("image") && editor.isEditable;
    },
    tippyOptions: {
      ignoreAttributes: true,
      animation: "perspective-extreme",
      duration: [400, 200],
      placement: "bottom",
      arrow: false,
      theme: "bubble-menu",
      maxWidth: "none",
      appendTo: function appendTo() {
        return document.body;
      }
    }
  });
};

/* harmony default export */ var BubbleMenu_ImageBubbleMenu = (ImageBubbleMenu_computeImageBubbleMenuExtension);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/InlineContent.vue?vue&type=template&id=32c3746c&scoped=true&
var InlineContentvue_type_template_id_32c3746c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{ref:"maydayEditorInlineContent",class:_vm.containerClass,attrs:{"as":"span","contenteditable":"false","data-drag-handle":"","data-node-id":_vm.contentId,"data-node-lang":_vm.lang,"data-node-type":_vm.type}},[(_vm.isDefaultBlock)?_c('span',[(_vm.contentIsLoading)?_c('font-awesome-icon',{staticClass:"spinner-icon",attrs:{"icon":['far', 'spinner'],"pulse":"","size":"xs"}}):_c('i',{class:[_vm.iconClass, _vm.inlineTypeIconClass],attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1):_vm._e(),(_vm.isLink)?_c('span',[(_vm.isEditable)?_c('span',{staticClass:"disabledLink"},[_vm._v(" "+_vm._s(_vm.maydayUrl)+" ")]):_c('span',[_c('i',{class:_vm.inlineTypeIconClass,attrs:{"aria-hidden":"true"}}),_c('a',{attrs:{"href":_vm.maydayUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.maydayUrl))])])]):_vm._e(),(_vm.isEmbed)?_c('div',{class:_vm.iframeWrapperClass},[_c('iframe',_vm._b({class:(_vm.baseClass + "__embed"),attrs:{"allow":"accelerometer; encrypted-media; gyroscope; picture-in-picture"},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},'iframe',_vm.iFrameAttributes,false)),_c('div',[_c('a',{class:(_vm.baseClass + "__iframe-enlarge"),attrs:{"href":_vm.maydayUrl,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'external-link']}}),_c('span',{class:(_vm.baseClass + "__iframe-enlarge-text")},[_vm._v(" "+_vm._s(_vm.$t("mayday-editor.embed.open-in-new-tab"))+" ")])],1)])]):_vm._e()])}
var InlineContentvue_type_template_id_32c3746c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/InlineContent.vue?vue&type=template&id=32c3746c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/InlineContent.vue?vue&type=script&lang=ts&
















var editorModule = bindings_namespace("mayday-editor");
var inlineContentClass = "mayday-editor__inline-content";

var InlineContentvue_type_script_lang_ts_InlineContent = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(InlineContent, _BaseNodeView);

  var _super = _createSuper(InlineContent);

  function InlineContent() {
    var _this;

    _classCallCheck(this, InlineContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", inlineContentClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "content", {});

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "contentIsLoading", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "options", _this.extension.options);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "progress", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fetchInlineContentAction", void 0);

    return _this;
  }

  _createClass(InlineContent, [{
    key: "fetchInlineContent",
    get: function get() {
      var extensionFunction = this.options.fetchInlineContentHandler;
      return extensionFunction || this.fetchInlineContentAction;
    }
  }, {
    key: "isEditable",
    get: function get() {
      return this.options.editable;
    }
  }, {
    key: "inlineContentAttributes",
    get: function get() {
      return this.node.attrs;
    }
  }, {
    key: "isDefaultBlock",
    get: function get() {
      return this.inlineContentAttributes.mode === InlineContent_Mode.DEFAULT;
    }
  }, {
    key: "isLink",
    get: function get() {
      return this.inlineContentAttributes.mode === InlineContent_Mode.LINK;
    }
  }, {
    key: "isEmbed",
    get: function get() {
      return this.inlineContentAttributes.mode === InlineContent_Mode.EMBED;
    }
  }, {
    key: "contentId",
    get: function get() {
      return this.inlineContentAttributes.nodeId;
    }
  }, {
    key: "lang",
    get: function get() {
      return this.inlineContentAttributes.lang || "";
    }
  }, {
    key: "type",
    get: function get() {
      return this.inlineContentAttributes.nodeType || "Content";
    }
  }, {
    key: "maydayUrl",
    get: function get() {
      return "".concat(this.options.subdomain, "/").concat(this.options.isParametric ? "desk/parametric/" : "desk/").concat(this.lang, "/").concat(this.type === "Case" ? "cases" : "contents", "/").concat(this.contentId);
    }
  }, {
    key: "label",
    get: function get() {
      return this.content ? this.content.label : this.$t("mayday-editor.inline-content.missing-content");
    }
  }, {
    key: "contentType",
    get: function get() {
      var contentType = this.content && this.content.type ? this.content.type.toLowerCase() : "unknown";
      return contentType.toLowerCase();
    }
  }, {
    key: "isMissingContent",
    get: function get() {
      return !this.content;
    }
  }, {
    key: "inlineTypeIconClass",
    get: function get() {
      return "".concat(this.iconClass, "--").concat(this.contentType);
    }
  }, {
    key: "iconClass",
    get: function get() {
      return "".concat(this.baseClass, "__icon");
    }
  }, {
    key: "embedUrl",
    get: function get() {
      return "".concat(this.options.subdomain, "/desk/embed/").concat(this.lang, "/contents/").concat(this.contentId);
    }
  }, {
    key: "containerClass",
    get: function get() {
      var _ref, _ref2;

      var selected = this.selected,
          baseClass = this.baseClass,
          isEmbed = this.isEmbed,
          editor = this.editor;
      var showSelectedWrapper = selected && editor.isEditable;
      return isEmbed ? (_ref = {}, Object(defineProperty["a" /* default */])(_ref, "".concat(baseClass, "--embed"), isEmbed), Object(defineProperty["a" /* default */])(_ref, "".concat(baseClass, "--embed--selected"), showSelectedWrapper), _ref) : (_ref2 = {}, Object(defineProperty["a" /* default */])(_ref2, baseClass, true), Object(defineProperty["a" /* default */])(_ref2, "".concat(baseClass, "--").concat(this.contentType), true), Object(defineProperty["a" /* default */])(_ref2, "is-missing", this.isMissingContent), _ref2);
    }
  }, {
    key: "iframeWrapperClass",
    get: function get() {
      var _ref3;

      var selected = this.selected,
          baseClass = this.baseClass,
          editor = this.editor;
      var showSelectedWrapper = selected && editor.isEditable;
      return _ref3 = {}, Object(defineProperty["a" /* default */])(_ref3, "".concat(baseClass, "__iframe-wrapper"), true), Object(defineProperty["a" /* default */])(_ref3, "".concat(baseClass, "__iframe-wrapper--selected"), showSelectedWrapper), _ref3;
    }
  }, {
    key: "iFrameAttributes",
    get: function get() {
      return {
        frameborder: "0",
        allowfullscreen: "true",
        src: this.embedUrl
      };
    }
  }, {
    key: "embedIsReady",
    get: function get() {
      var progress = this.progress;
      return progress === 1;
    }
  }, {
    key: "created",
    value: function () {
      var _created = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var entityType;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.contentIsLoading = true;
                entityType = this.type === "Case" ? "Case" : "Content";
                _context.next = 4;
                return this.fetchInlineContent({
                  contentId: this.contentId,
                  lang: this.lang,
                  type: entityType
                });

              case 4:
                this.content = _context.sent;
                this.contentIsLoading = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var inlineContentContainer = this.$refs["maydayEditorInlineContent"];
      if (!inlineContentContainer || this.options.editable) return;
      inlineContentContainer.$el.addEventListener("click", function () {
        if (!_this2.isMissingContent) {
          _this2.$parent.$emit("click:inline-content", _this2.content);
        }
      }, false);
    }
  }]);

  return InlineContent;
}(nodes_BaseNodeView);

__decorate([editorModule.Action("fetchInlineContent"), __metadata("design:type", Object)], InlineContentvue_type_script_lang_ts_InlineContent.prototype, "fetchInlineContentAction", void 0);

InlineContentvue_type_script_lang_ts_InlineContent = __decorate([external_vue_property_decorator_["Component"]], InlineContentvue_type_script_lang_ts_InlineContent);
/* harmony default export */ var InlineContentvue_type_script_lang_ts_ = (InlineContentvue_type_script_lang_ts_InlineContent);
// CONCATENATED MODULE: ./src/components/nodes/InlineContent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_InlineContentvue_type_script_lang_ts_ = (InlineContentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/InlineContent.vue?vue&type=style&index=0&id=32c3746c&lang=scss&scoped=true&
var InlineContentvue_type_style_index_0_id_32c3746c_lang_scss_scoped_true_ = __webpack_require__("f6c9");

// CONCATENATED MODULE: ./src/components/nodes/InlineContent.vue






/* normalize component */

var InlineContent_component = normalizeComponent(
  nodes_InlineContentvue_type_script_lang_ts_,
  InlineContentvue_type_template_id_32c3746c_scoped_true_render,
  InlineContentvue_type_template_id_32c3746c_scoped_true_staticRenderFns,
  false,
  null,
  "32c3746c",
  null
  
)

/* harmony default export */ var nodes_InlineContent = (InlineContent_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("9911");

// CONCATENATED MODULE: ./src/extensions/InlineContent/commands.ts




var commands_computeSetInlineContentAsDefault = function computeSetInlineContentAsDefault(name) {
  return function () {
    return function (_ref) {
      var commands = _ref.commands;
      return commands.updateAttributes(name, {
        mode: InlineContent_Mode.DEFAULT
      });
    };
  };
};
var computeSetInlineContentAsLink = function computeSetInlineContentAsLink() {
  return function (maydayUrl) {
    return function (_ref2) {
      var dispatch = _ref2.dispatch,
          tr = _ref2.tr,
          editor = _ref2.editor;
      var selection = tr.selection;
      var linkMarkType = editor.schema.marks.link;
      var textNode = editor.schema.text(maydayUrl, [linkMarkType.create({
        href: maydayUrl
      })]);

      if (dispatch != null) {
        tr.replaceRangeWith(selection.from, selection.to, textNode);
        return true;
      }

      return false;
    };
  };
};
var commands_computeSetInlineContentAsEmbed = function computeSetInlineContentAsEmbed(name) {
  return function () {
    return function (_ref3) {
      var commands = _ref3.commands;
      return commands.updateAttributes(name, {
        mode: InlineContent_Mode.EMBED
      });
    };
  };
};
var commands_computeDeleteInlineContent = function computeDeleteInlineContent(type) {
  return function () {
    return function (_ref4) {
      var dispatch = _ref4.dispatch,
          tr = _ref4.tr;
      var selection = tr.selection;

      if (dispatch == null || !isNodeSelection(selection) || selection.node.type !== type) {
        return false;
      }

      dispatch(tr.deleteSelection());
      return true;
    };
  };
};
// CONCATENATED MODULE: ./src/extensions/InlineContent/InlineContent.ts





var InlineContent_Mode;

(function (Mode) {
  Mode[Mode["DEFAULT"] = 1] = "DEFAULT";
  Mode[Mode["LINK"] = 2] = "LINK";
  Mode[Mode["EMBED"] = 3] = "EMBED";
})(InlineContent_Mode || (InlineContent_Mode = {}));

var InlineContent_key = new PluginKey("inlineContent");

var InlineContent_InlineContent = function InlineContent(fetchInlineContentHandler, isParametric, subdomain, editable) {
  return tiptap_core_esm_Node.create({
    name: "inlineContent",
    // block(s) should be wrapped with a paragraph
    inline: true,
    group: "inline",
    selectable: true,
    draggable: true,
    atom: true,
    // disallows all marks
    marks: "",
    addOptions: function addOptions() {
      return {
        HTMLAttributes: {
          class: "linked-node"
        },
        fetchInlineContentHandler: fetchInlineContentHandler,
        isParametric: isParametric,
        subdomain: subdomain,
        editable: editable
      };
    },
    addAttributes: function addAttributes() {
      return {
        nodeId: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("node-id");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "node-id": attrs.nodeId
            };
          }
        },
        nodeType: {
          default: "Content",
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-node-type");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-node-type": attrs.nodeType
            };
          }
        },
        lang: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-node-lang");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-node-lang": attrs.lang
            };
          }
        },
        mode: {
          default: InlineContent_Mode.DEFAULT,
          parseHTML: function parseHTML(element) {
            var attribute = element.getAttribute("data-mode");
            return attribute != null ? parseInt(attribute, 10) : null;
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-mode": attrs.mode
            };
          }
        }
      };
    },
    parseHTML: function parseHTML() {
      return [{
        tag: "span.linked-node",
        getAttrs: function getAttrs(node) {
          var element = node;
          var hasNodeId = !!element.hasAttribute("node-id");

          if (!hasNodeId) {
            return false;
          }

          return null;
        }
      }];
    },
    renderHTML: function renderHTML(_ref) {
      var HTMLAttributes = _ref.HTMLAttributes;
      return ["span", mergeAttributes(HTMLAttributes, this.options.HTMLAttributes)];
    },
    renderText: function renderText(_ref2) {
      var node = _ref2.node;
      return "embed@".concat(node.attrs.src);
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_InlineContent);
    },
    addCommands: function addCommands() {
      var name = this.name,
          type = this.type;
      return {
        setInlineContentAsDefault: commands_computeSetInlineContentAsDefault(name),
        setInlineContentAsLink: computeSetInlineContentAsLink(),
        setInlineContentAsEmbed: commands_computeSetInlineContentAsEmbed(name),
        deleteInlineContent: commands_computeDeleteInlineContent(type)
      };
    }
  });
};

/* harmony default export */ var extensions_InlineContent_InlineContent = (InlineContent_InlineContent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/InlineMention.vue?vue&type=template&id=0451d200&scoped=true&
var InlineMentionvue_type_template_id_0451d200_scoped_true_render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{ref:"maydayEditorInlineMention",class:[
    _vm.baseClass,
    ( _obj = {}, _obj[(_vm.baseClass + "__is-missing")] = !_vm.entity, _obj ),
    ( _obj$1 = {}, _obj$1[(_vm.baseClass + "__selected")] = _vm.isSelected, _obj$1 ),
    ( _obj$2 = {}, _obj$2[(_vm.baseClass + "__is-deleted")] = _vm.entity && _vm.entity.isDeleted, _obj$2 ) ],attrs:{"as":"span","contenteditable":"false","data-drag-handle":"","data-node-id":_vm.entityId}},[(_vm.entityIsLoading)?_c('font-awesome-icon',{class:[(_vm.baseClass + "__is-loading"), (_vm.baseClass + "__icon")],attrs:{"icon":['far', 'spinner'],"pulse":"","size":"xs"}}):(_vm.entity && _vm.entity.isDeleted)?_c('span',[_c('font-awesome-icon',{class:(_vm.baseClass + "__icon"),attrs:{"icon":['far', 'user-times'],"size":"xs"}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1):_c('span',[_vm._v("@"+_vm._s(_vm.label))])],1)}
var InlineMentionvue_type_template_id_0451d200_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/InlineMention.vue?vue&type=template&id=0451d200&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/InlineMention.vue?vue&type=script&lang=ts&















var InlineMentionvue_type_script_lang_ts_editorModule = bindings_namespace("mayday-editor");
var inlineMentionClass = "mayday-editor__inline-mention";

var InlineMentionvue_type_script_lang_ts_InlineMention = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(InlineMention, _BaseNodeView);

  var _super = _createSuper(InlineMention);

  function InlineMention() {
    var _this;

    _classCallCheck(this, InlineMention);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", inlineMentionClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "entity", {});

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "entityIsLoading", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fetchInlineMentionAction", void 0);

    return _this;
  }

  _createClass(InlineMention, [{
    key: "fetchInlineMention",
    get: function get() {
      var options = this.extension.options;
      var extensionFunction = options.fetchInlineMentionHandler;
      return extensionFunction || this.fetchInlineMentionAction;
    }
  }, {
    key: "isSelected",
    get: function get() {
      var editor = this.editor,
          selected = this.selected;
      return selected && editor.isEditable;
    }
  }, {
    key: "inlineMentionAttributes",
    get: function get() {
      return this.node.attrs;
    }
  }, {
    key: "entityId",
    get: function get() {
      return this.inlineMentionAttributes.nodeId;
    }
  }, {
    key: "entityType",
    get: function get() {
      return this.inlineMentionAttributes.nodeType;
    }
  }, {
    key: "label",
    get: function get() {
      if (!this.entity) {
        return this.$t("mayday-editor.inline-mention.missing-".concat(this.entityType.toLowerCase()));
      }

      return this.entity.label;
    }
  }, {
    key: "created",
    value: function () {
      var _created = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.entityIsLoading = true;
                _context.next = 3;
                return this.fetchInlineMention({
                  entityId: this.entityId,
                  entityType: this.entityType
                });

              case 3:
                this.entity = _context.sent;
                this.entityIsLoading = false;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }]);

  return InlineMention;
}(nodes_BaseNodeView);

__decorate([InlineMentionvue_type_script_lang_ts_editorModule.Action("fetchInlineMention"), __metadata("design:type", Object)], InlineMentionvue_type_script_lang_ts_InlineMention.prototype, "fetchInlineMentionAction", void 0);

InlineMentionvue_type_script_lang_ts_InlineMention = __decorate([external_vue_property_decorator_["Component"]], InlineMentionvue_type_script_lang_ts_InlineMention);
/* harmony default export */ var InlineMentionvue_type_script_lang_ts_ = (InlineMentionvue_type_script_lang_ts_InlineMention);
// CONCATENATED MODULE: ./src/components/nodes/InlineMention.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_InlineMentionvue_type_script_lang_ts_ = (InlineMentionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/InlineMention.vue?vue&type=style&index=0&id=0451d200&lang=scss&scoped=true&
var InlineMentionvue_type_style_index_0_id_0451d200_lang_scss_scoped_true_ = __webpack_require__("b0a2");

// CONCATENATED MODULE: ./src/components/nodes/InlineMention.vue






/* normalize component */

var InlineMention_component = normalizeComponent(
  nodes_InlineMentionvue_type_script_lang_ts_,
  InlineMentionvue_type_template_id_0451d200_scoped_true_render,
  InlineMentionvue_type_template_id_0451d200_scoped_true_staticRenderFns,
  false,
  null,
  "0451d200",
  null
  
)

/* harmony default export */ var nodes_InlineMention = (InlineMention_component.exports);
// CONCATENATED MODULE: ./src/extensions/InlineMention.ts



var InlineMention_key = new PluginKey("inlineMention");

var InlineMention_InlineMention = function InlineMention(fetchInlineMentionHandler) {
  return tiptap_core_esm_Node.create({
    name: "inlineMention",
    // block(s) should be wrapped with a paragraph
    inline: true,
    group: "inline",
    selectable: true,
    draggable: true,
    atom: true,
    // disallows all marks
    marks: "",
    addOptions: function addOptions() {
      return {
        HTMLAttributes: {
          class: "inline-mention"
        },
        fetchInlineMentionHandler: fetchInlineMentionHandler
      };
    },
    addAttributes: function addAttributes() {
      return {
        nodeId: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-node-id");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-node-id": attrs.nodeId
            };
          }
        },
        nodeType: {
          default: null,
          parseHTML: function parseHTML(element) {
            return element.getAttribute("data-node-type");
          },
          renderHTML: function renderHTML(attrs) {
            return {
              "data-node-type": attrs.nodeType
            };
          }
        }
      };
    },
    parseHTML: function parseHTML() {
      return [{
        tag: "span.inline-mention",
        getAttrs: function getAttrs(node) {
          var element = node;
          var hasNodeId = !!element.hasAttribute("data-node-id");

          if (!hasNodeId) {
            return false;
          }

          return null;
        }
      }];
    },
    renderHTML: function renderHTML(_ref) {
      var HTMLAttributes = _ref.HTMLAttributes;
      return ["span", mergeAttributes(HTMLAttributes, this.options.HTMLAttributes)];
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_InlineMention);
    }
  });
};

/* harmony default export */ var extensions_InlineMention = (InlineMention_InlineMention);
// CONCATENATED MODULE: ./src/extensions/TrailingNode.ts









 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

function nodeEqualsType(_ref) {
  var types = _ref.types,
      node = _ref.node;
  return Array.isArray(types) && types.includes(node.type) || node.type === types;
}

var TrailingNode = Extension.create({
  name: "trailingNode",
  addOptions: function addOptions() {
    return {
      node: "paragraph",
      notAfter: ["paragraph"]
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this = this;

    var plugin = new PluginKey(this.name);
    var disabledNodes = Object.entries(this.editor.schema.nodes).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[1];

      return value;
    }).filter(function (node) {
      return _this.options.notAfter.includes(node.name);
    });
    return [new Plugin({
      key: plugin,
      appendTransaction: function appendTransaction(_, __, state) {
        var doc = state.doc,
            tr = state.tr,
            schema = state.schema;
        var shouldInsertNodeAtEnd = plugin.getState(state);
        var endPosition = doc.content.size;
        var type = schema.nodes[_this.options.node];

        if (!shouldInsertNodeAtEnd) {
          return;
        }

        return tr.insert(endPosition, type.create());
      },
      state: {
        init: function init(_, state) {
          var lastNode = state.tr.doc.lastChild;
          return !nodeEqualsType({
            node: lastNode,
            types: disabledNodes
          });
        },
        apply: function apply(tr, value) {
          if (!tr.docChanged) {
            return value;
          }

          var lastNode = tr.doc.lastChild;
          return !nodeEqualsType({
            node: lastNode,
            types: disabledNodes
          });
        }
      }
    })];
  }
});
/* harmony default export */ var extensions_TrailingNode = (TrailingNode);
// EXTERNAL MODULE: ./node_modules/lowlight/lib/core.js
var lib_core = __webpack_require__("3ce4");
var core_default = /*#__PURE__*/__webpack_require__.n(lib_core);

// CONCATENATED MODULE: ./node_modules/@tiptap-pro/extension-details/dist/tiptap-extension-details.esm.js




const isNodeVisible = (position, editor) => {
    const node = editor.view.domAtPos(position).node;
    const isOpen = node.offsetParent !== null;
    return isOpen;
};

const tiptap_extension_details_esm_setGapCursor = (editor, direction) => {
    const { state, view, extensionManager } = editor;
    const { schema, selection } = state;
    const { empty, $anchor } = selection;
    const hasGapCursorExtension = !!extensionManager.extensions.find(extension => extension.name === 'gapCursor');
    if (!empty
        || $anchor.parent.type !== schema.nodes.detailsSummary
        || !hasGapCursorExtension) {
        return false;
    }
    if (direction === 'right'
        && $anchor.parentOffset !== ($anchor.parent.nodeSize - 2)) {
        return false;
    }
    const details = findParentNode(node => node.type === schema.nodes.details)(selection);
    if (!details) {
        return false;
    }
    const detailsContent = findChildren(details.node, node => node.type === schema.nodes.detailsContent);
    if (!detailsContent.length) {
        return false;
    }
    const isOpen = isNodeVisible(details.start + detailsContent[0].pos + 1, editor);
    if (isOpen) {
        return false;
    }
    const $position = state.doc.resolve(details.pos + details.node.nodeSize);
    const $validPosition = index_es_GapCursor.findFrom($position, 1, false);
    if (!$validPosition) {
        return false;
    }
    const { tr } = state;
    const gapCursorSelection = new index_es_GapCursor($validPosition, $validPosition);
    tr.setSelection(gapCursorSelection);
    tr.scrollIntoView();
    view.dispatch(tr);
    return true;
};

const findClosestVisibleNode = ($pos, predicate, editor) => {
    for (let i = $pos.depth; i > 0; i -= 1) {
        const node = $pos.node(i);
        const match = predicate(node);
        const isVisible = isNodeVisible($pos.start(i), editor);
        if (match && isVisible) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
};

const Details = tiptap_core_esm_Node.create({
    name: 'details',
    content: 'detailsSummary detailsContent',
    group: 'block',
    defining: true,
    isolating: true,
    allowGapCursor: false,
    addOptions() {
        return {
            persist: false,
            openClassName: 'is-open',
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        if (!this.options.persist) {
            return [];
        }
        return {
            open: {
                default: false,
                parseHTML: element => element.hasAttribute('open'),
                renderHTML: ({ open }) => {
                    if (!open) {
                        return {};
                    }
                    return { open: '' };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'details',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'details',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
    addNodeView() {
        return ({ editor, getPos, node, HTMLAttributes, }) => {
            const dom = document.createElement('div');
            const attributes = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                'data-type': this.name,
            });
            Object.entries(attributes).forEach(([key, value]) => dom.setAttribute(key, value));
            const toggle = document.createElement('button');
            dom.append(toggle);
            const content = document.createElement('div');
            dom.append(content);
            const toggleDetailsContent = () => {
                dom.classList.toggle(this.options.openClassName);
                const event = new Event('toggleDetailsContent');
                const detailsContent = content.querySelector(':scope > div[data-type="detailsContent"]');
                detailsContent === null || detailsContent === void 0 ? void 0 : detailsContent.dispatchEvent(event);
            };
            if (node.attrs.open) {
                setTimeout(toggleDetailsContent);
            }
            toggle.addEventListener('click', () => {
                toggleDetailsContent();
                if (!this.options.persist) {
                    editor.commands.focus();
                    return;
                }
                if (editor.isEditable && typeof getPos === 'function') {
                    editor
                        .chain()
                        .focus()
                        .command(({ tr }) => {
                        const pos = getPos();
                        const currentNode = tr.doc.nodeAt(pos);
                        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) !== this.type) {
                            return false;
                        }
                        tr.setNodeMarkup(pos, undefined, {
                            open: !currentNode.attrs.open,
                        });
                        return true;
                    })
                        .run();
                }
            });
            return {
                dom,
                contentDOM: content,
                ignoreMutation(mutation) {
                    if (mutation.type === 'selection') {
                        return false;
                    }
                    return !dom.contains(mutation.target) || dom === mutation.target;
                },
                update: updatedNode => {
                    if (updatedNode.type !== this.type) {
                        return false;
                    }
                    return true;
                },
            };
        };
    },
    addCommands() {
        return {
            setDetails: () => ({ state, chain }) => {
                var _a;
                const { schema, selection } = state;
                const { $from, $to } = selection;
                const range = $from.blockRange($to);
                if (!range) {
                    return false;
                }
                const slice = state.doc.slice(range.start, range.end);
                const match = schema.nodes.detailsContent.contentMatch.matchFragment(slice.content);
                if (!match) {
                    return false;
                }
                const content = ((_a = slice.toJSON()) === null || _a === void 0 ? void 0 : _a.content) || [];
                return chain()
                    .insertContentAt({ from: range.start, to: range.end }, {
                    type: this.name,
                    content: [
                        {
                            type: 'detailsSummary',
                        },
                        {
                            type: 'detailsContent',
                            content,
                        },
                    ],
                })
                    .setTextSelection(range.start + 2)
                    .run();
            },
            unsetDetails: () => ({ state, chain }) => {
                const { selection, schema } = state;
                const details = findParentNode(node => node.type === this.type)(selection);
                if (!details) {
                    return false;
                }
                const detailsSummaries = findChildren(details.node, node => node.type === schema.nodes.detailsSummary);
                const detailsContents = findChildren(details.node, node => node.type === schema.nodes.detailsContent);
                if (!detailsSummaries.length || !detailsContents.length) {
                    return false;
                }
                const detailsSummary = detailsSummaries[0];
                const detailsContent = detailsContents[0];
                const from = details.pos;
                const $from = state.doc.resolve(from);
                const to = from + details.node.nodeSize;
                const range = { from, to };
                const content = detailsContent.node.content.toJSON() || [];
                const defaultTypeForSummary = $from.parent.type.contentMatch.defaultType;
                // TODO: this may break for some custom schemas
                const summaryContent = defaultTypeForSummary === null || defaultTypeForSummary === void 0 ? void 0 : defaultTypeForSummary.create(null, detailsSummary.node.content).toJSON();
                const mergedContent = [
                    summaryContent,
                    ...content,
                ];
                return chain()
                    .insertContentAt(range, mergedContent)
                    .setTextSelection(from + 1)
                    .run();
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            Backspace: () => {
                const { schema, selection } = this.editor.state;
                const { empty, $anchor } = selection;
                if (!empty || $anchor.parent.type !== schema.nodes.detailsSummary) {
                    return false;
                }
                // for some reason safari removes the whole text content within a `<summary>`tag on backspace
                // so we have to remove the text manually
                // see: https://discuss.prosemirror.net/t/safari-backspace-bug-with-details-tag/4223
                if ($anchor.parentOffset !== 0) {
                    return this.editor.commands.command(({ tr }) => {
                        const from = $anchor.pos - 1;
                        const to = $anchor.pos;
                        tr.delete(from, to);
                        return true;
                    });
                }
                return this.editor.commands.unsetDetails();
            },
            // Creates a new node below it if it is closed.
            // Otherwise inside `DetailsContent`.
            Enter: ({ editor }) => {
                const { state, view } = editor;
                const { schema, selection } = state;
                const { $head } = selection;
                if ($head.parent.type !== schema.nodes.detailsSummary) {
                    return false;
                }
                const isVisible = isNodeVisible($head.after() + 1, editor);
                const above = isVisible
                    ? state.doc.nodeAt($head.after())
                    : $head.node(-2);
                if (!above) {
                    return false;
                }
                const after = isVisible
                    ? 0
                    : $head.indexAfter(-1);
                const type = tiptap_core_esm_defaultBlockAt(above.contentMatchAt(after));
                if (!type || !above.canReplaceWith(after, after, type)) {
                    return false;
                }
                const node = type.createAndFill();
                if (!node) {
                    return false;
                }
                const pos = isVisible
                    ? $head.after() + 1
                    : $head.after(-1);
                const tr = state.tr.replaceWith(pos, pos, node);
                const $pos = tr.doc.resolve(pos);
                const newSelection = index_es_Selection.near($pos, 1);
                tr.setSelection(newSelection);
                tr.scrollIntoView();
                view.dispatch(tr);
                return true;
            },
            // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
            ArrowRight: ({ editor }) => {
                return tiptap_extension_details_esm_setGapCursor(editor, 'right');
            },
            // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
            ArrowDown: ({ editor }) => {
                return tiptap_extension_details_esm_setGapCursor(editor, 'down');
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            // This plugin prevents text selections within the hidden content in `DetailsContent`.
            // The cursor is moved to the next visible position.
            new Plugin({
                key: new PluginKey('detailsSelection'),
                appendTransaction: (transactions, oldState, newState) => {
                    const { editor, type } = this;
                    const selectionSet = transactions.some(transaction => transaction.selectionSet);
                    if (!selectionSet
                        || !oldState.selection.empty
                        || !newState.selection.empty) {
                        return;
                    }
                    const detailsIsActive = tiptap_core_esm_isActive(newState, type.name);
                    if (!detailsIsActive) {
                        return;
                    }
                    const { $from } = newState.selection;
                    const isVisible = isNodeVisible($from.pos, editor);
                    if (isVisible) {
                        return;
                    }
                    const details = findClosestVisibleNode($from, node => node.type === type, editor);
                    if (!details) {
                        return;
                    }
                    const detailsSummaries = findChildren(details.node, node => node.type === newState.schema.nodes.detailsSummary);
                    if (!detailsSummaries.length) {
                        return;
                    }
                    const detailsSummary = detailsSummaries[0];
                    const selectionDirection = oldState.selection.from < newState.selection.from
                        ? 'forward'
                        : 'backward';
                    const correctedPosition = selectionDirection === 'forward'
                        ? details.start + detailsSummary.pos
                        : details.pos + detailsSummary.pos + detailsSummary.node.nodeSize;
                    const selection = index_es_TextSelection.create(newState.doc, correctedPosition);
                    const transaction = newState.tr.setSelection(selection);
                    return transaction;
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-details.esm.js.map

// CONCATENATED MODULE: ./src/extensions/Details/Details.ts














var Details_isNodeVisible = function isNodeVisible(position, editor) {
  var node = editor.view.domAtPos(position).node;
  var isOpen = node.offsetParent !== null;
  return isOpen;
};

var Details_setGapCursor = function setGapCursor(editor, direction) {
  var state = editor.state,
      view = editor.view,
      extensionManager = editor.extensionManager;
  var schema = state.schema,
      selection = state.selection;
  var empty = selection.empty,
      $anchor = selection.$anchor;
  var hasGapCursorExtension = !!extensionManager.extensions.find(function (extension) {
    return extension.name === "gapCursor";
  });

  if (!empty || $anchor.parent.type !== schema.nodes.detailsSummary || !hasGapCursorExtension) {
    return false;
  }

  if (direction === "right" && $anchor.parentOffset !== $anchor.parent.nodeSize - 2) {
    return false;
  }

  var details = findParentNode(function (node) {
    return node.type === schema.nodes.details;
  })(selection);

  if (!details) {
    return false;
  }

  var detailsContent = findChildren(details.node, function (node) {
    return node.type === schema.nodes.detailsContent;
  });

  if (!detailsContent.length) {
    return false;
  }

  var isOpen = Details_isNodeVisible(details.start + detailsContent[0].pos + 1, editor);

  if (isOpen) {
    return false;
  }

  var $position = state.doc.resolve(details.pos + details.node.nodeSize);
  var $validPosition = index_es_GapCursor.findFrom($position, 1, false);

  if (!$validPosition) {
    return false;
  }

  var tr = state.tr;
  var gapCursorSelection = new index_es_GapCursor($validPosition, $validPosition);
  tr.setSelection(gapCursorSelection);
  tr.scrollIntoView();
  view.dispatch(tr);
  return true;
};

var computeCustomDetails = Details.extend({
  addNodeView: function addNodeView() {
    var _this = this;

    return function (_ref) {
      var editor = _ref.editor,
          getPos = _ref.getPos,
          node = _ref.node,
          HTMLAttributes = _ref.HTMLAttributes;
      var dom = document.createElement("div");
      var attributes = mergeAttributes(_this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": _this.name
      });
      Object.entries(attributes).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return dom.setAttribute(key, value);
      });
      var toggle = document.createElement("span");
      dom.append(toggle);
      var content = document.createElement("div");
      dom.append(content);

      var toggleDetailsContent = function toggleDetailsContent() {
        dom.classList.toggle(_this.options.openClassName);
        var event = new Event("toggleDetailsContent");
        var detailsContent = content.querySelector(':scope > div[data-type="detailsContent"]');
        detailsContent === null || detailsContent === void 0 ? void 0 : detailsContent.dispatchEvent(event);
      };

      if (node.attrs.open) {
        setTimeout(toggleDetailsContent);
      }

      toggle.addEventListener("click", function () {
        toggleDetailsContent();

        if (!_this.options.persist) {
          editor.commands.focus();
          return;
        }

        if (editor.isEditable && typeof getPos === "function") {
          editor.chain().command(function (_ref4) {
            var tr = _ref4.tr;
            var pos = getPos();
            var currentNode = tr.doc.nodeAt(pos);

            if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) !== _this.type) {
              return false;
            }

            tr.setNodeMarkup(pos, undefined, {
              open: !(currentNode !== null && currentNode !== void 0 && currentNode.attrs.open)
            });
            return true;
          }).run();
        }
      });
      return {
        dom: dom,
        contentDOM: content,
        ignoreMutation: function ignoreMutation(mutation) {
          if (mutation.type === "selection") {
            return false;
          }

          return !dom.contains(mutation.target) || dom === mutation.target;
        },
        update: function update(updatedNode) {
          if (updatedNode.type !== _this.type) {
            return false;
          }

          return true;
        }
      };
    };
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      setDetails: function setDetails() {
        return function (_ref5) {
          var state = _ref5.state,
              chain = _ref5.chain;

          var _a;

          var schema = state.schema,
              selection = state.selection;
          var $from = selection.$from,
              $to = selection.$to;
          var range = $from.blockRange($to);

          if (!range) {
            return false;
          }

          var slice = state.doc.slice(range.start, range.end);
          var match = schema.nodes.detailsContent.contentMatch.matchFragment(slice.content);

          if (!match) {
            return false;
          }

          var content = ((_a = slice.toJSON()) === null || _a === void 0 ? void 0 : _a.content) || [];
          var summaryHasText = !!content[0].content && content[0].content[0].type !== "hardBreak";
          var summaryContent = summaryHasText ? {
            content: content[0].content
          } : {};
          var selectionOffset = summaryHasText ? content[0].content.reduce(function (acc, val) {
            return acc + val.text.length;
          }, 0) : 0;
          return chain().insertContentAt({
            from: range.start,
            to: range.end
          }, {
            type: _this2.name,
            content: [_objectSpread2({
              type: "detailsSummary"
            }, summaryContent), {
              type: "detailsContent",
              content: [{
                attrs: {
                  textAlign: "left"
                },
                type: "paragraph",
                content: []
              }]
            }]
          }).setTextSelection(range.start + selectionOffset + 1).run();
        };
      },
      unsetDetails: function unsetDetails() {
        return function (_ref6) {
          var state = _ref6.state,
              chain = _ref6.chain;
          var selection = state.selection,
              schema = state.schema;
          var details = findParentNode(function (node) {
            return node.type === _this2.type;
          })(selection);

          if (!details) {
            return false;
          }

          var detailsSummaries = findChildren(details.node, function (node) {
            return node.type === schema.nodes.detailsSummary;
          });
          var detailsContents = findChildren(details.node, function (node) {
            return node.type === schema.nodes.detailsContent;
          });

          if (!detailsSummaries.length || !detailsContents.length) {
            return false;
          }

          var detailsSummary = detailsSummaries[0];
          var detailsContent = detailsContents[0];
          var from = details.pos;
          var $from = state.doc.resolve(from);
          var to = from + details.node.nodeSize;
          var range = {
            from: from,
            to: to
          };
          var content = detailsContent.node.content.toJSON() || [];
          var defaultTypeForSummary = $from.parent.type.contentMatch.defaultType; // TODO: this may break for some custom schemas

          var summaryContent = defaultTypeForSummary === null || defaultTypeForSummary === void 0 ? void 0 : defaultTypeForSummary.create(null, detailsSummary.node.content).toJSON();
          content.unshift(summaryContent);
          return chain().insertContentAt(range, content).setTextSelection(from + 1).run();
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      Backspace: function Backspace() {
        var _this3$editor$state = _this3.editor.state,
            schema = _this3$editor$state.schema,
            selection = _this3$editor$state.selection;
        var empty = selection.empty,
            $anchor = selection.$anchor;

        if (!empty || $anchor.parent.type !== schema.nodes.detailsSummary) {
          return false;
        } // for some reason safari removes the whole text content within a `<summary>`tag on backspace
        // so we have to remove the text manually
        // see: https://discuss.prosemirror.net/t/safari-backspace-bug-with-details-tag/4223


        if ($anchor.parentOffset !== 0) {
          return _this3.editor.commands.command(function (_ref7) {
            var tr = _ref7.tr;
            var from = $anchor.pos - 1;
            var to = $anchor.pos;
            tr.delete(from, to);
            return true;
          });
        }

        return _this3.editor.commands.unsetDetails();
      },
      // Creates a new node below it if it is closed.
      // Otherwise inside `DetailsContent`.
      Enter: function Enter(_ref8) {
        var editor = _ref8.editor;
        var state = editor.state,
            view = editor.view;
        var schema = state.schema,
            selection = state.selection;
        var $head = selection.$head;

        if ($head.parent.type !== schema.nodes.detailsSummary) {
          return false;
        }

        var isVisible = Details_isNodeVisible($head.after() + 1, editor);
        var above = isVisible ? state.doc.nodeAt($head.after()) : $head.node(-2);

        if (!above) {
          return false;
        }

        var after = isVisible ? 0 : $head.indexAfter(-1);
        var type = tiptap_core_esm_defaultBlockAt(above.contentMatchAt(after));

        if (!type || !above.canReplaceWith(after, after, type)) {
          return false;
        }

        var node = type.createAndFill();

        if (!node) {
          return false;
        }

        var pos = isVisible ? $head.after() + 1 : $head.after(-1);
        var tr = state.tr.replaceWith(pos, pos, node);
        var $pos = tr.doc.resolve(pos);
        var newSelection = index_es_Selection.near($pos, 1);
        tr.setSelection(newSelection);
        tr.scrollIntoView();
        view.dispatch(tr);
        if (!isVisible) editor.chain().focus().setDetails().run();
        return true;
      },
      // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
      ArrowRight: function ArrowRight(_ref9) {
        var editor = _ref9.editor;
        return Details_setGapCursor(editor, "right");
      },
      // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
      ArrowDown: function ArrowDown(_ref10) {
        var editor = _ref10.editor;
        return Details_setGapCursor(editor, "down");
      }
    };
  }
});
/* harmony default export */ var Details_Details = (computeCustomDetails);
// CONCATENATED MODULE: ./node_modules/@tiptap-pro/extension-details-summary/dist/tiptap-extension-details-summary.esm.js


const DetailsSummary = tiptap_core_esm_Node.create({
    name: 'detailsSummary',
    content: 'text*',
    defining: true,
    selectable: false,
    isolating: true,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'summary',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'summary',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
});


//# sourceMappingURL=tiptap-extension-details-summary.esm.js.map

// CONCATENATED MODULE: ./src/extensions/Details/DetailsSummary.ts





var DetailsSummary_computeCustomDetailsSummary = function computeCustomDetailsSummary(editable) {
  return DetailsSummary.extend({
    group: "block",
    content: "inline*",
    addOptions: function addOptions() {
      return {
        HTMLAttributes: {
          style: editable ? "" : "cursor: pointer"
        }
      };
    },
    addProseMirrorPlugins: function addProseMirrorPlugins() {
      var _this$parent;

      var plugins = ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)) || [];
      plugins.push(new Plugin({
        key: new PluginKey("handleClickSummary"),
        props: {
          handleClick: function handleClick(view, pos, event) {
            var element = event.target;
            var summary = element.closest("summary");

            if (editable || !element || !summary) {
              return false;
            }

            var parentNode = element.closest(".mayday-editor__content__ProseMirror__details");
            if (!parentNode) return false;
            parentNode.classList.toggle("is-open");
            var newEvent = new Event("toggleDetailsContent");
            var detailsContent = parentNode.querySelector('[data-type="detailsContent"]');
            detailsContent === null || detailsContent === void 0 ? void 0 : detailsContent.dispatchEvent(newEvent);
            return true;
          }
        }
      }));
      return plugins;
    }
  });
};

/* harmony default export */ var Details_DetailsSummary = (DetailsSummary_computeCustomDetailsSummary);
// CONCATENATED MODULE: ./node_modules/@tiptap-pro/extension-details-content/dist/tiptap-extension-details-content.esm.js



const DetailsContent = tiptap_core_esm_Node.create({
    name: 'detailsContent',
    content: 'block+',
    defining: true,
    selectable: false,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { 'data-type': this.name }),
            0,
        ];
    },
    addNodeView() {
        return ({ HTMLAttributes }) => {
            const dom = document.createElement('div');
            const attributes = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                'data-type': this.name,
                hidden: 'hidden',
            });
            Object.entries(attributes).forEach(([key, value]) => dom.setAttribute(key, value));
            dom.addEventListener('toggleDetailsContent', () => {
                dom.toggleAttribute('hidden');
            });
            return {
                dom,
                contentDOM: dom,
                ignoreMutation(mutation) {
                    if (mutation.type === 'selection') {
                        return false;
                    }
                    return !dom.contains(mutation.target) || dom === mutation.target;
                },
                update: updatedNode => {
                    if (updatedNode.type !== this.type) {
                        return false;
                    }
                    return true;
                },
            };
        };
    },
    addKeyboardShortcuts() {
        return {
            // Escape node on double enter
            Enter: ({ editor }) => {
                const { state, view } = editor;
                const { selection } = state;
                const { $from, empty } = selection;
                const detailsContent = findParentNode(node => node.type === this.type)(selection);
                if (!empty || !detailsContent || !detailsContent.node.childCount) {
                    return false;
                }
                const fromIndex = $from.index(detailsContent.depth);
                const { childCount } = detailsContent.node;
                const isAtEnd = childCount === fromIndex + 1;
                if (!isAtEnd) {
                    return false;
                }
                const defaultChildType = detailsContent.node.type.contentMatch.defaultType;
                const defaultChildNode = defaultChildType === null || defaultChildType === void 0 ? void 0 : defaultChildType.createAndFill();
                if (!defaultChildNode) {
                    return false;
                }
                const $childPos = state.doc.resolve(detailsContent.pos + 1);
                const lastChildIndex = childCount - 1;
                const lastChildNode = detailsContent.node.child(lastChildIndex);
                const lastChildPos = $childPos.posAtIndex(lastChildIndex, detailsContent.depth);
                const lastChildNodeIsEmpty = lastChildNode.eq(defaultChildNode);
                if (!lastChildNodeIsEmpty) {
                    return false;
                }
                // get parent of details node
                const above = $from.node(-3);
                if (!above) {
                    return false;
                }
                // get default node type after details node
                const after = $from.indexAfter(-3);
                const type = tiptap_core_esm_defaultBlockAt(above.contentMatchAt(after));
                if (!type || !above.canReplaceWith(after, after, type)) {
                    return false;
                }
                const node = type.createAndFill();
                if (!node) {
                    return false;
                }
                const { tr } = state;
                const pos = $from.after(-2);
                tr.replaceWith(pos, pos, node);
                const $pos = tr.doc.resolve(pos);
                const newSelection = index_es_Selection.near($pos, 1);
                tr.setSelection(newSelection);
                const deleteFrom = lastChildPos;
                const deleteTo = lastChildPos + lastChildNode.nodeSize;
                tr.delete(deleteFrom, deleteTo);
                tr.scrollIntoView();
                view.dispatch(tr);
                return true;
            },
        };
    },
});


//# sourceMappingURL=tiptap-extension-details-content.esm.js.map

// EXTERNAL MODULE: ./node_modules/@tiptap-pro/extension-emoji/node_modules/emoji-regex/index.js
var emoji_regex = __webpack_require__("b648");
var emoji_regex_default = /*#__PURE__*/__webpack_require__.n(emoji_regex);

// CONCATENATED MODULE: ./node_modules/is-emoji-supported/dist/esm/is-emoji-supported.js
/**
 * @var {Object} cache
 */
var is_emoji_supported_cache = new Map();
/**
 * Check if emoji is supported with cache
 *
 * @params {string} unicode
 * @returns {boolean}
 */
function isEmojiSupported(unicode) {
    if (is_emoji_supported_cache.has(unicode)) {
        return is_emoji_supported_cache.get(unicode);
    }
    var supported = is_emoji_supported_isSupported(unicode);
    is_emoji_supported_cache.set(unicode, supported);
    return supported;
}
/**
 * Request to handle cache directly
 *
 * @params {Map} store
 */
function setCacheHandler(store) {
    is_emoji_supported_cache = store;
}
/**
 * Check if the two pixels parts are perfectly the sames
 *
 * @params {string} unicode
 * @returns {boolean}
 */
var is_emoji_supported_isSupported = (function () {
    var ctx = null;
    try {
        ctx = document.createElement('canvas').getContext('2d');
    }
    catch (_a) { }
    // Not in browser env
    if (!ctx) {
        return function () { return false; };
    }
    var CANVAS_HEIGHT = 25;
    var CANVAS_WIDTH = 20;
    var textSize = Math.floor(CANVAS_HEIGHT / 2);
    // Initialize convas context
    ctx.font = textSize + 'px Arial, Sans-Serif';
    ctx.textBaseline = 'top';
    ctx.canvas.width = CANVAS_WIDTH * 2;
    ctx.canvas.height = CANVAS_HEIGHT;
    return function (unicode) {
        ctx.clearRect(0, 0, CANVAS_WIDTH * 2, CANVAS_HEIGHT);
        // Draw in red on the left
        ctx.fillStyle = '#FF0000';
        ctx.fillText(unicode, 0, 22);
        // Draw in blue on right
        ctx.fillStyle = '#0000FF';
        ctx.fillText(unicode, CANVAS_WIDTH, 22);
        var a = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
        var count = a.length;
        var i = 0;
        // Search the first visible pixel
        for (; i < count && !a[i + 3]; i += 4)
            ;
        // No visible pixel
        if (i >= count) {
            return false;
        }
        // Emoji has immutable color, so we check the color of the emoji in two different colors
        // the result show be the same.
        var x = CANVAS_WIDTH + ((i / 4) % CANVAS_WIDTH);
        var y = Math.floor(i / 4 / CANVAS_WIDTH);
        var b = ctx.getImageData(x, y, 1, 1).data;
        if (a[i] !== b[0] || a[i + 2] !== b[2]) {
            return false;
        }
        // Some emojis are a contraction of different ones, so if it's not
        // supported, it will show multiple characters
        if (ctx.measureText(unicode).width >= CANVAS_WIDTH) {
            return false;
        }
        // Supported
        return true;
    };
})();


//# sourceMappingURL=is-emoji-supported.js.map

// CONCATENATED MODULE: ./node_modules/@tiptap-pro/extension-emoji/dist/tiptap-extension-emoji.esm.js






function shortcodeToEmoji(shortcode, emojis) {
    return emojis.find(item => shortcode === item.name || item.shortcodes.includes(shortcode));
}

function removeVariationSelector(value) {
    return value.replace('\u{FE0E}', '').replace('\u{FE0F}', '');
}

function emojiToShortcode(emoji, emojis) {
    var _a;
    return (_a = emojis.find(item => item.emoji === removeVariationSelector(emoji))) === null || _a === void 0 ? void 0 : _a.shortcodes[0];
}

/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function tiptap_extension_emoji_esm_removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

// This is a generated file
const tiptap_extension_emoji_esm_emojis = [
    {
        emoji: '😀',
        name: 'grinning',
        shortcodes: [
            'grinning',
            'grinning_face',
        ],
        tags: [
            'face',
            'grin',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png',
    },
    {
        emoji: '😃',
        name: 'smiley',
        shortcodes: [
            'grinning_face_with_big_eyes',
            'smiley',
        ],
        tags: [
            'face',
            'mouth',
            'open',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f603.png',
    },
    {
        emoji: '😄',
        name: 'smile',
        shortcodes: [
            'grinning_face_with_closed_eyes',
            'smile',
        ],
        tags: [
            'eye',
            'face',
            'mouth',
            'open',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':D',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f604.png',
    },
    {
        emoji: '😁',
        name: 'grin',
        shortcodes: [
            'beaming_face',
            'grin',
        ],
        tags: [
            'eye',
            'face',
            'grin',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f601.png',
    },
    {
        emoji: '😆',
        name: 'laughing',
        shortcodes: [
            'laughing',
            'lol',
            'satisfied',
            'squinting_face',
        ],
        tags: [
            'face',
            'laugh',
            'mouth',
            'satisfied',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'xD',
            'XD',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f606.png',
    },
    {
        emoji: '😅',
        name: 'sweat_smile',
        shortcodes: [
            'grinning_face_with_sweat',
            'sweat_smile',
        ],
        tags: [
            'cold',
            'face',
            'open',
            'smile',
            'sweat',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f605.png',
    },
    {
        emoji: '🤣',
        name: 'rofl',
        shortcodes: [
            'rofl',
        ],
        tags: [
            'face',
            'floor',
            'laugh',
            'rofl',
            'rolling',
            'rotfl',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ":'D",
        ],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f923.png',
    },
    {
        emoji: '😂',
        name: 'joy',
        shortcodes: [
            'joy',
            'lmao',
            'tears_of_joy',
        ],
        tags: [
            'face',
            'joy',
            'laugh',
            'tear',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ":')",
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f602.png',
    },
    {
        emoji: '🙂',
        name: 'slightly_smiling_face',
        shortcodes: [
            'slightly_smiling_face',
        ],
        tags: [
            'face',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':)',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f642.png',
    },
    {
        emoji: '🙃',
        name: 'upside_down_face',
        shortcodes: [
            'upside_down_face',
        ],
        tags: [
            'face',
            'upside-down',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f643.png',
    },
    {
        emoji: '😉',
        name: 'wink',
        shortcodes: [
            'wink',
            'winking_face',
        ],
        tags: [
            'face',
            'wink',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ';)',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f609.png',
    },
    {
        emoji: '😊',
        name: 'blush',
        shortcodes: [
            'blush',
            'smiling_face_with_closed_eyes',
        ],
        tags: [
            'blush',
            'eye',
            'face',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':>',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60a.png',
    },
    {
        emoji: '😇',
        name: 'innocent',
        shortcodes: [
            'halo',
            'innocent',
        ],
        tags: [
            'angel',
            'face',
            'fantasy',
            'halo',
            'innocent',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'o:)',
            'O:)',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f607.png',
    },
    {
        emoji: '🥰',
        name: 'smiling_face_with_three_hearts',
        shortcodes: [
            'smiling_face_with_3_hearts',
        ],
        tags: [
            'adore',
            'crush',
            'hearts',
            'in love',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f970.png',
    },
    {
        emoji: '😍',
        name: 'heart_eyes',
        shortcodes: [
            'heart_eyes',
            'smiling_face_with_heart_eyes',
        ],
        tags: [
            'eye',
            'face',
            'love',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60d.png',
    },
    {
        emoji: '🤩',
        name: 'star_struck',
        shortcodes: [
            'star_struck',
        ],
        tags: [
            'eyes',
            'face',
            'grinning',
            'star',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f929.png',
    },
    {
        emoji: '😘',
        name: 'kissing_heart',
        shortcodes: [
            'blowing_a_kiss',
            'kissing_heart',
        ],
        tags: [
            'face',
            'kiss',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':x',
            ':X',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f618.png',
    },
    {
        emoji: '😗',
        name: 'kissing',
        shortcodes: [
            'kissing',
            'kissing_face',
        ],
        tags: [
            'face',
            'kiss',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f617.png',
    },
    {
        emoji: '☺',
        name: 'relaxed',
        shortcodes: [
            'relaxed',
            'smiling_face',
        ],
        tags: [
            'face',
            'outlined',
            'relaxed',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/263a-fe0f.png',
    },
    {
        emoji: '😚',
        name: 'kissing_closed_eyes',
        shortcodes: [
            'kissing_closed_eyes',
            'kissing_face_with_closed_eyes',
        ],
        tags: [
            'closed',
            'eye',
            'face',
            'kiss',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':*',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61a.png',
    },
    {
        emoji: '😙',
        name: 'kissing_smiling_eyes',
        shortcodes: [
            'kissing_face_with_smiling_eyes',
            'kissing_smiling_eyes',
        ],
        tags: [
            'eye',
            'face',
            'kiss',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f619.png',
    },
    {
        emoji: '🥲',
        name: 'smiling_face_with_tear',
        shortcodes: [
            'smiling_face_with_tear',
        ],
        tags: [
            'grateful',
            'proud',
            'relieved',
            'smiling',
            'tear',
            'touched',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f972.png',
    },
    {
        emoji: '😋',
        name: 'yum',
        shortcodes: [
            'savoring_food',
            'yum',
        ],
        tags: [
            'delicious',
            'face',
            'savouring',
            'smile',
            'yum',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60b.png',
    },
    {
        emoji: '😛',
        name: 'stuck_out_tongue',
        shortcodes: [
            'face_with_tongue',
            'stuck_out_tongue',
        ],
        tags: [
            'face',
            'tongue',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':p',
            ':P',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61b.png',
    },
    {
        emoji: '😜',
        name: 'stuck_out_tongue_winking_eye',
        shortcodes: [
            'stuck_out_tongue_winking_eye',
        ],
        tags: [
            'eye',
            'face',
            'joke',
            'tongue',
            'wink',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ';p',
            ';P',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61c.png',
    },
    {
        emoji: '🤪',
        name: 'zany_face',
        shortcodes: [
            'zany',
            'zany_face',
        ],
        tags: [
            'eye',
            'goofy',
            'large',
            'small',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92a.png',
    },
    {
        emoji: '😝',
        name: 'stuck_out_tongue_closed_eyes',
        shortcodes: [
            'stuck_out_tongue_closed_eyes',
        ],
        tags: [
            'eye',
            'face',
            'horrible',
            'taste',
            'tongue',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'xp',
            'xP',
            'XP',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61d.png',
    },
    {
        emoji: '🤑',
        name: 'money_mouth_face',
        shortcodes: [
            'money_mouth_face',
        ],
        tags: [
            'face',
            'money',
            'mouth',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f911.png',
    },
    {
        emoji: '🤗',
        name: 'hugs',
        shortcodes: [
            'hug',
            'hugging',
            'hugging_face',
        ],
        tags: [
            'face',
            'hug',
            'hugging',
            'open hands',
            'smiling face',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f917.png',
    },
    {
        emoji: '🤭',
        name: 'hand_over_mouth',
        shortcodes: [
            'face_with_hand_over_mouth',
            'hand_over_mouth',
        ],
        tags: [
            'whoops',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92d.png',
    },
    {
        emoji: '🤫',
        name: 'shushing_face',
        shortcodes: [
            'shush',
            'shushing_face',
        ],
        tags: [
            'quiet',
            'shush',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92b.png',
    },
    {
        emoji: '🤔',
        name: 'thinking',
        shortcodes: [
            'thinking',
            'thinking_face',
            'wtf',
        ],
        tags: [
            'face',
            'thinking',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':l',
            ':L',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f914.png',
    },
    {
        emoji: '🤐',
        name: 'zipper_mouth_face',
        shortcodes: [
            'zipper_mouth',
            'zipper_mouth_face',
        ],
        tags: [
            'face',
            'mouth',
            'zipper',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':z',
            ':Z',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f910.png',
    },
    {
        emoji: '🤨',
        name: 'raised_eyebrow',
        shortcodes: [
            'face_with_raised_eyebrow',
            'raised_eyebrow',
        ],
        tags: [
            'distrust',
            'skeptic',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f928.png',
    },
    {
        emoji: '😐',
        name: 'neutral_face',
        shortcodes: [
            'neutral',
            'neutral_face',
        ],
        tags: [
            'deadpan',
            'face',
            'meh',
            'neutral',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':|',
        ],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f610.png',
    },
    {
        emoji: '😑',
        name: 'expressionless',
        shortcodes: [
            'expressionless',
            'expressionless_face',
        ],
        tags: [
            'expressionless',
            'face',
            'inexpressive',
            'meh',
            'unexpressive',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f611.png',
    },
    {
        emoji: '😶',
        name: 'no_mouth',
        shortcodes: [
            'no_mouth',
        ],
        tags: [
            'face',
            'mouth',
            'quiet',
            'silent',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':#',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f636.png',
    },
    {
        emoji: '😶‍🌫',
        name: 'face_in_clouds',
        shortcodes: [
            'in_clouds',
        ],
        tags: [
            'absentminded',
            'face in the fog',
            'head in clouds',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f636-200d-1f32b-fe0f.png',
    },
    {
        emoji: '😏',
        name: 'smirk',
        shortcodes: [
            'smirk',
            'smirking',
            'smirking_face',
        ],
        tags: [
            'face',
            'smirk',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':j',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60f.png',
    },
    {
        emoji: '😒',
        name: 'unamused',
        shortcodes: [
            'unamused',
            'unamused_face',
        ],
        tags: [
            'face',
            'unamused',
            'unhappy',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':?',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f612.png',
    },
    {
        emoji: '🙄',
        name: 'roll_eyes',
        shortcodes: [
            'rolling_eyes',
        ],
        tags: [
            'eyeroll',
            'eyes',
            'face',
            'rolling',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f644.png',
    },
    {
        emoji: '😬',
        name: 'grimacing',
        shortcodes: [
            'grimacing',
            'grimacing_face',
        ],
        tags: [
            'face',
            'grimace',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '8D',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62c.png',
    },
    {
        emoji: '😮‍💨',
        name: 'face_exhaling',
        shortcodes: [
            'exhale',
            'exhaling',
        ],
        tags: [
            'exhale',
            'gasp',
            'groan',
            'relief',
            'whisper',
            'whistle',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62e-200d-1f4a8.png',
    },
    {
        emoji: '🤥',
        name: 'lying_face',
        shortcodes: [
            'lying',
            'lying_face',
        ],
        tags: [
            'face',
            'lie',
            'pinocchio',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f925.png',
    },
    {
        emoji: '😌',
        name: 'relieved',
        shortcodes: [
            'relieved',
            'relieved_face',
        ],
        tags: [
            'face',
            'relieved',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60c.png',
    },
    {
        emoji: '😔',
        name: 'pensive',
        shortcodes: [
            'pensive',
            'pensive_face',
        ],
        tags: [
            'dejected',
            'face',
            'pensive',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f614.png',
    },
    {
        emoji: '😪',
        name: 'sleepy',
        shortcodes: [
            'sleepy',
            'sleepy_face',
        ],
        tags: [
            'face',
            'good night',
            'sleep',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62a.png',
    },
    {
        emoji: '🤤',
        name: 'drooling_face',
        shortcodes: [
            'drooling',
            'drooling_face',
        ],
        tags: [
            'drooling',
            'face',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f924.png',
    },
    {
        emoji: '😴',
        name: 'sleeping',
        shortcodes: [
            'sleeping',
            'sleeping_face',
        ],
        tags: [
            'face',
            'good night',
            'sleep',
            'zzz',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f634.png',
    },
    {
        emoji: '😷',
        name: 'mask',
        shortcodes: [
            'mask',
            'medical_mask',
        ],
        tags: [
            'cold',
            'doctor',
            'face',
            'mask',
            'sick',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f637.png',
    },
    {
        emoji: '🤒',
        name: 'face_with_thermometer',
        shortcodes: [
            'face_with_thermometer',
        ],
        tags: [
            'face',
            'ill',
            'sick',
            'thermometer',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f912.png',
    },
    {
        emoji: '🤕',
        name: 'face_with_head_bandage',
        shortcodes: [
            'face_with_head_bandage',
        ],
        tags: [
            'bandage',
            'face',
            'hurt',
            'injury',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f915.png',
    },
    {
        emoji: '🤢',
        name: 'nauseated_face',
        shortcodes: [
            'nauseated',
            'nauseated_face',
        ],
        tags: [
            'face',
            'nauseated',
            'vomit',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '%(',
        ],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f922.png',
    },
    {
        emoji: '🤮',
        name: 'vomiting_face',
        shortcodes: [
            'face_vomiting',
            'vomiting',
        ],
        tags: [
            'puke',
            'sick',
            'vomit',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92e.png',
    },
    {
        emoji: '🤧',
        name: 'sneezing_face',
        shortcodes: [
            'sneezing',
            'sneezing_face',
        ],
        tags: [
            'face',
            'gesundheit',
            'sneeze',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f927.png',
    },
    {
        emoji: '🥵',
        name: 'hot_face',
        shortcodes: [
            'hot',
            'hot_face',
        ],
        tags: [
            'feverish',
            'heat stroke',
            'hot',
            'red-faced',
            'sweating',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f975.png',
    },
    {
        emoji: '🥶',
        name: 'cold_face',
        shortcodes: [
            'cold',
            'cold_face',
        ],
        tags: [
            'blue-faced',
            'cold',
            'freezing',
            'frostbite',
            'icicles',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f976.png',
    },
    {
        emoji: '🥴',
        name: 'woozy_face',
        shortcodes: [
            'woozy',
            'woozy_face',
        ],
        tags: [
            'dizzy',
            'intoxicated',
            'tipsy',
            'uneven eyes',
            'wavy mouth',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':&',
        ],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f974.png',
    },
    {
        emoji: '😵',
        name: 'dizzy_face',
        shortcodes: [
            'dizzy_face',
            'knocked_out',
        ],
        tags: [
            'crossed-out eyes',
            'dead',
            'face',
            'knocked out',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'xo',
            'XO',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f635.png',
    },
    {
        emoji: '😵‍💫',
        name: 'face_with_spiral_eyes',
        shortcodes: [
            'dizzy_eyes',
        ],
        tags: [
            'dizzy',
            'hypnotized',
            'spiral',
            'trouble',
            'whoa',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f635-200d-1f4ab.png',
    },
    {
        emoji: '🤯',
        name: 'exploding_head',
        shortcodes: [
            'exploding_head',
        ],
        tags: [
            'mind blown',
            'shocked',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92f.png',
    },
    {
        emoji: '🤠',
        name: 'cowboy_hat_face',
        shortcodes: [
            'cowboy',
            'cowboy_face',
        ],
        tags: [
            'cowboy',
            'cowgirl',
            'face',
            'hat',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f920.png',
    },
    {
        emoji: '🥳',
        name: 'partying_face',
        shortcodes: [
            'hooray',
            'partying',
            'partying_face',
        ],
        tags: [
            'celebration',
            'hat',
            'horn',
            'party',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f973.png',
    },
    {
        emoji: '🥸',
        name: 'disguised_face',
        shortcodes: [
            'disguised',
            'disguised_face',
        ],
        tags: [
            'disguise',
            'face',
            'glasses',
            'incognito',
            'nose',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f978.png',
    },
    {
        emoji: '😎',
        name: 'sunglasses',
        shortcodes: [
            'smiling_face_with_sunglasses',
            'sunglasses_cool',
            'too_cool',
        ],
        tags: [
            'bright',
            'cool',
            'face',
            'sun',
            'sunglasses',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '8)',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60e.png',
    },
    {
        emoji: '🤓',
        name: 'nerd_face',
        shortcodes: [
            'nerd',
            'nerd_face',
        ],
        tags: [
            'face',
            'geek',
            'nerd',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':B',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f913.png',
    },
    {
        emoji: '🧐',
        name: 'monocle_face',
        shortcodes: [
            'face_with_monocle',
        ],
        tags: [
            'face',
            'monocle',
            'stuffy',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d0.png',
    },
    {
        emoji: '😕',
        name: 'confused',
        shortcodes: [
            'confused',
            'confused_face',
        ],
        tags: [
            'confused',
            'face',
            'meh',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':/',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f615.png',
    },
    {
        emoji: '😟',
        name: 'worried',
        shortcodes: [
            'worried',
            'worried_face',
        ],
        tags: [
            'face',
            'worried',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61f.png',
    },
    {
        emoji: '🙁',
        name: 'slightly_frowning_face',
        shortcodes: [
            'slightly_frowning_face',
        ],
        tags: [
            'face',
            'frown',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f641.png',
    },
    {
        emoji: '☹',
        name: 'frowning_face',
        shortcodes: [
            'white_frowning_face',
        ],
        tags: [
            'face',
            'frown',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':(',
        ],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2639-fe0f.png',
    },
    {
        emoji: '😮',
        name: 'open_mouth',
        shortcodes: [
            'face_with_open_mouth',
            'open_mouth',
        ],
        tags: [
            'face',
            'mouth',
            'open',
            'sympathy',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62e.png',
    },
    {
        emoji: '😯',
        name: 'hushed',
        shortcodes: [
            'hushed',
            'hushed_face',
        ],
        tags: [
            'face',
            'hushed',
            'stunned',
            'surprised',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62f.png',
    },
    {
        emoji: '😲',
        name: 'astonished',
        shortcodes: [
            'astonished',
            'astonished_face',
        ],
        tags: [
            'astonished',
            'face',
            'shocked',
            'totally',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':o',
            ':O',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f632.png',
    },
    {
        emoji: '😳',
        name: 'flushed',
        shortcodes: [
            'flushed',
            'flushed_face',
        ],
        tags: [
            'dazed',
            'face',
            'flushed',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':$',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f633.png',
    },
    {
        emoji: '🥺',
        name: 'pleading_face',
        shortcodes: [
            'pleading',
            'pleading_face',
        ],
        tags: [
            'begging',
            'mercy',
            'puppy eyes',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97a.png',
    },
    {
        emoji: '😦',
        name: 'frowning',
        shortcodes: [
            'frowning',
            'frowning_face',
        ],
        tags: [
            'face',
            'frown',
            'mouth',
            'open',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f626.png',
    },
    {
        emoji: '😧',
        name: 'anguished',
        shortcodes: [
            'anguished',
            'anguished_face',
        ],
        tags: [
            'anguished',
            'face',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':s',
            ':S',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f627.png',
    },
    {
        emoji: '😨',
        name: 'fearful',
        shortcodes: [
            'fearful',
            'fearful_face',
        ],
        tags: [
            'face',
            'fear',
            'fearful',
            'scared',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f628.png',
    },
    {
        emoji: '😰',
        name: 'cold_sweat',
        shortcodes: [
            'anxious',
            'anxious_face',
            'cold_sweat',
        ],
        tags: [
            'blue',
            'cold',
            'face',
            'rushed',
            'sweat',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f630.png',
    },
    {
        emoji: '😥',
        name: 'disappointed_relieved',
        shortcodes: [
            'disappointed_relieved',
            'sad_relieved_face',
        ],
        tags: [
            'disappointed',
            'face',
            'relieved',
            'whew',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f625.png',
    },
    {
        emoji: '😢',
        name: 'cry',
        shortcodes: [
            'cry',
            'crying_face',
        ],
        tags: [
            'cry',
            'face',
            'sad',
            'tear',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ":'(",
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f622.png',
    },
    {
        emoji: '😭',
        name: 'sob',
        shortcodes: [
            'loudly_crying_face',
            'sob',
        ],
        tags: [
            'cry',
            'face',
            'sad',
            'sob',
            'tear',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ":'o",
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62d.png',
    },
    {
        emoji: '😱',
        name: 'scream',
        shortcodes: [
            'scream',
            'screaming_in_fear',
        ],
        tags: [
            'face',
            'fear',
            'munch',
            'scared',
            'scream',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'Dx',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f631.png',
    },
    {
        emoji: '😖',
        name: 'confounded',
        shortcodes: [
            'confounded',
            'confounded_face',
        ],
        tags: [
            'confounded',
            'face',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'x(',
            'X(',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f616.png',
    },
    {
        emoji: '😣',
        name: 'persevere',
        shortcodes: [
            'persevere',
            'persevering_face',
        ],
        tags: [
            'face',
            'persevere',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f623.png',
    },
    {
        emoji: '😞',
        name: 'disappointed',
        shortcodes: [
            'disappointed',
            'disappointed_face',
        ],
        tags: [
            'disappointed',
            'face',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61e.png',
    },
    {
        emoji: '😓',
        name: 'sweat',
        shortcodes: [
            'downcast_face',
            'sweat',
        ],
        tags: [
            'cold',
            'face',
            'sweat',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':<',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f613.png',
    },
    {
        emoji: '😩',
        name: 'weary',
        shortcodes: [
            'weary',
            'weary_face',
        ],
        tags: [
            'face',
            'tired',
            'weary',
        ],
        group: 'smileys & emotion',
        emoticons: [
            'D:',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f629.png',
    },
    {
        emoji: '😫',
        name: 'tired_face',
        shortcodes: [
            'tired',
            'tired_face',
        ],
        tags: [
            'face',
            'tired',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':c',
            ':C',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62b.png',
    },
    {
        emoji: '🥱',
        name: 'yawning_face',
        shortcodes: [
            'yawn',
            'yawning',
            'yawning_face',
        ],
        tags: [
            'bored',
            'tired',
            'yawn',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f971.png',
    },
    {
        emoji: '😤',
        name: 'triumph',
        shortcodes: [
            'nose_steam',
            'triumph',
        ],
        tags: [
            'face',
            'triumph',
            'won',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f624.png',
    },
    {
        emoji: '😡',
        name: 'pout',
        shortcodes: [
            'pout',
            'pouting_face',
            'rage',
        ],
        tags: [
            'angry',
            'enraged',
            'face',
            'mad',
            'pouting',
            'rage',
            'red',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '>:/',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f621.png',
    },
    {
        emoji: '😠',
        name: 'angry',
        shortcodes: [
            'angry',
            'angry_face',
        ],
        tags: [
            'anger',
            'angry',
            'face',
            'mad',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f620.png',
    },
    {
        emoji: '🤬',
        name: 'cursing_face',
        shortcodes: [
            'censored',
            'face_with_symbols_on_mouth',
        ],
        tags: [
            'swearing',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':@',
        ],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92c.png',
    },
    {
        emoji: '😈',
        name: 'smiling_imp',
        shortcodes: [
            'smiling_imp',
        ],
        tags: [
            'face',
            'fairy tale',
            'fantasy',
            'horns',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '>:)',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f608.png',
    },
    {
        emoji: '👿',
        name: 'imp',
        shortcodes: [
            'angry_imp',
            'imp',
        ],
        tags: [
            'demon',
            'devil',
            'face',
            'fantasy',
            'imp',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '>:(',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47f.png',
    },
    {
        emoji: '💀',
        name: 'skull',
        shortcodes: [
            'skull',
        ],
        tags: [
            'death',
            'face',
            'fairy tale',
            'monster',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f480.png',
    },
    {
        emoji: '☠',
        name: 'skull_and_crossbones',
        shortcodes: [
            'skull_and_crossbones',
        ],
        tags: [
            'crossbones',
            'death',
            'face',
            'monster',
            'skull',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2620-fe0f.png',
    },
    {
        emoji: '💩',
        name: 'hankey',
        shortcodes: [
            'poop',
            'shit',
        ],
        tags: [
            'dung',
            'face',
            'monster',
            'poo',
            'poop',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a9.png',
    },
    {
        emoji: '🤡',
        name: 'clown_face',
        shortcodes: [
            'clown',
            'clown_face',
        ],
        tags: [
            'clown',
            'face',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f921.png',
    },
    {
        emoji: '👹',
        name: 'japanese_ogre',
        shortcodes: [
            'japanese_ogre',
            'ogre',
        ],
        tags: [
            'creature',
            'face',
            'fairy tale',
            'fantasy',
            'monster',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '>0)',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f479.png',
    },
    {
        emoji: '👺',
        name: 'japanese_goblin',
        shortcodes: [
            'goblin',
            'japanese_goblin',
        ],
        tags: [
            'creature',
            'face',
            'fairy tale',
            'fantasy',
            'monster',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47a.png',
    },
    {
        emoji: '👻',
        name: 'ghost',
        shortcodes: [
            'ghost',
        ],
        tags: [
            'creature',
            'face',
            'fairy tale',
            'fantasy',
            'monster',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47b.png',
    },
    {
        emoji: '👽',
        name: 'alien',
        shortcodes: [
            'alien',
        ],
        tags: [
            'creature',
            'extraterrestrial',
            'face',
            'fantasy',
            'ufo',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47d.png',
    },
    {
        emoji: '👾',
        name: 'space_invader',
        shortcodes: [
            'alien_monster',
            'space_invader',
        ],
        tags: [
            'alien',
            'creature',
            'extraterrestrial',
            'face',
            'monster',
            'ufo',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47e.png',
    },
    {
        emoji: '🤖',
        name: 'robot',
        shortcodes: [
            'robot',
            'robot_face',
        ],
        tags: [
            'face',
            'monster',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f916.png',
    },
    {
        emoji: '😺',
        name: 'smiley_cat',
        shortcodes: [
            'grinning_cat',
            'smiley_cat',
        ],
        tags: [
            'cat',
            'face',
            'grinning',
            'mouth',
            'open',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63a.png',
    },
    {
        emoji: '😸',
        name: 'smile_cat',
        shortcodes: [
            'grinning_cat_with_closed_eyes',
            'smile_cat',
        ],
        tags: [
            'cat',
            'eye',
            'face',
            'grin',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f638.png',
    },
    {
        emoji: '😹',
        name: 'joy_cat',
        shortcodes: [
            'joy_cat',
            'tears_of_joy_cat',
        ],
        tags: [
            'cat',
            'face',
            'joy',
            'tear',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f639.png',
    },
    {
        emoji: '😻',
        name: 'heart_eyes_cat',
        shortcodes: [
            'heart_eyes_cat',
            'smiling_cat_with_heart_eyes',
        ],
        tags: [
            'cat',
            'eye',
            'face',
            'heart',
            'love',
            'smile',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63b.png',
    },
    {
        emoji: '😼',
        name: 'smirk_cat',
        shortcodes: [
            'smirk_cat',
            'wry_smile_cat',
        ],
        tags: [
            'cat',
            'face',
            'ironic',
            'smile',
            'wry',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63c.png',
    },
    {
        emoji: '😽',
        name: 'kissing_cat',
        shortcodes: [
            'kissing_cat',
        ],
        tags: [
            'cat',
            'eye',
            'face',
            'kiss',
        ],
        group: 'smileys & emotion',
        emoticons: [
            ':3',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63d.png',
    },
    {
        emoji: '🙀',
        name: 'scream_cat',
        shortcodes: [
            'scream_cat',
            'weary_cat',
        ],
        tags: [
            'cat',
            'face',
            'oh',
            'surprised',
            'weary',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f640.png',
    },
    {
        emoji: '😿',
        name: 'crying_cat_face',
        shortcodes: [
            'crying_cat',
        ],
        tags: [
            'cat',
            'cry',
            'face',
            'sad',
            'tear',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63f.png',
    },
    {
        emoji: '😾',
        name: 'pouting_cat',
        shortcodes: [
            'pouting_cat',
        ],
        tags: [
            'cat',
            'face',
            'pouting',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63e.png',
    },
    {
        emoji: '🙈',
        name: 'see_no_evil',
        shortcodes: [
            'see_no_evil',
        ],
        tags: [
            'evil',
            'face',
            'forbidden',
            'monkey',
            'see',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f648.png',
    },
    {
        emoji: '🙉',
        name: 'hear_no_evil',
        shortcodes: [
            'hear_no_evil',
        ],
        tags: [
            'evil',
            'face',
            'forbidden',
            'hear',
            'monkey',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f649.png',
    },
    {
        emoji: '🙊',
        name: 'speak_no_evil',
        shortcodes: [
            'speak_no_evil',
        ],
        tags: [
            'evil',
            'face',
            'forbidden',
            'monkey',
            'speak',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64a.png',
    },
    {
        emoji: '💋',
        name: 'kiss',
        shortcodes: [
            'kiss',
        ],
        tags: [
            'kiss',
            'lips',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48b.png',
    },
    {
        emoji: '💌',
        name: 'love_letter',
        shortcodes: [
            'love_letter',
        ],
        tags: [
            'heart',
            'letter',
            'love',
            'mail',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48c.png',
    },
    {
        emoji: '💘',
        name: 'cupid',
        shortcodes: [
            'cupid',
            'heart_with_arrow',
        ],
        tags: [
            'arrow',
            'cupid',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f498.png',
    },
    {
        emoji: '💝',
        name: 'gift_heart',
        shortcodes: [
            'gift_heart',
            'heart_with_ribbon',
        ],
        tags: [
            'ribbon',
            'valentine',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49d.png',
    },
    {
        emoji: '💖',
        name: 'sparkling_heart',
        shortcodes: [
            'sparkling_heart',
        ],
        tags: [
            'excited',
            'sparkle',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f496.png',
    },
    {
        emoji: '💗',
        name: 'heartpulse',
        shortcodes: [
            'growing_heart',
            'heartpulse',
        ],
        tags: [
            'excited',
            'growing',
            'nervous',
            'pulse',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f497.png',
    },
    {
        emoji: '💓',
        name: 'heartbeat',
        shortcodes: [
            'beating_heart',
            'heartbeat',
        ],
        tags: [
            'beating',
            'heartbeat',
            'pulsating',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f493.png',
    },
    {
        emoji: '💞',
        name: 'revolving_hearts',
        shortcodes: [
            'revolving_hearts',
        ],
        tags: [
            'revolving',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49e.png',
    },
    {
        emoji: '💕',
        name: 'two_hearts',
        shortcodes: [
            'two_hearts',
        ],
        tags: [
            'love',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f495.png',
    },
    {
        emoji: '💟',
        name: 'heart_decoration',
        shortcodes: [
            'heart_decoration',
        ],
        tags: [
            'heart',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49f.png',
    },
    {
        emoji: '❣',
        name: 'heavy_heart_exclamation',
        shortcodes: [
            'heart_exclamation',
        ],
        tags: [
            'exclamation',
            'mark',
            'punctuation',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2763-fe0f.png',
    },
    {
        emoji: '💔',
        name: 'broken_heart',
        shortcodes: [
            'broken_heart',
        ],
        tags: [
            'break',
            'broken',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '</3',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f494.png',
    },
    {
        emoji: '❤‍🔥',
        name: 'heart_on_fire',
        shortcodes: [
            'heart_on_fire',
        ],
        tags: [
            'burn',
            'heart',
            'love',
            'lust',
            'sacred heart',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f-200d-1f525.png',
    },
    {
        emoji: '❤‍🩹',
        name: 'mending_heart',
        shortcodes: [
            'mending_heart',
        ],
        tags: [
            'healthier',
            'improving',
            'mending',
            'recovering',
            'recuperating',
            'well',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f-200d-1fa79.png',
    },
    {
        emoji: '❤',
        name: 'heart',
        shortcodes: [
            'heart',
            'red_heart',
        ],
        tags: [
            'heart',
        ],
        group: 'smileys & emotion',
        emoticons: [
            '<3',
        ],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f.png',
    },
    {
        emoji: '🧡',
        name: 'orange_heart',
        shortcodes: [
            'orange_heart',
        ],
        tags: [
            'orange',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e1.png',
    },
    {
        emoji: '💛',
        name: 'yellow_heart',
        shortcodes: [
            'yellow_heart',
        ],
        tags: [
            'yellow',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49b.png',
    },
    {
        emoji: '💚',
        name: 'green_heart',
        shortcodes: [
            'green_heart',
        ],
        tags: [
            'green',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49a.png',
    },
    {
        emoji: '💙',
        name: 'blue_heart',
        shortcodes: [
            'blue_heart',
        ],
        tags: [
            'blue',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f499.png',
    },
    {
        emoji: '💜',
        name: 'purple_heart',
        shortcodes: [
            'purple_heart',
        ],
        tags: [
            'purple',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49c.png',
    },
    {
        emoji: '🤎',
        name: 'brown_heart',
        shortcodes: [
            'brown_heart',
        ],
        tags: [
            'brown',
            'heart',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90e.png',
    },
    {
        emoji: '🖤',
        name: 'black_heart',
        shortcodes: [
            'black_heart',
        ],
        tags: [
            'black',
            'evil',
            'wicked',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a4.png',
    },
    {
        emoji: '🤍',
        name: 'white_heart',
        shortcodes: [
            'white_heart',
        ],
        tags: [
            'heart',
            'white',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90d.png',
    },
    {
        emoji: '💯',
        name: '100',
        shortcodes: [
            '100',
        ],
        tags: [
            '100',
            'full',
            'hundred',
            'score',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4af.png',
    },
    {
        emoji: '💢',
        name: 'anger',
        shortcodes: [
            'anger',
        ],
        tags: [
            'angry',
            'comic',
            'mad',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a2.png',
    },
    {
        emoji: '💥',
        name: 'boom',
        shortcodes: [
            'boom',
            'collision',
        ],
        tags: [
            'boom',
            'comic',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a5.png',
    },
    {
        emoji: '💫',
        name: 'dizzy',
        shortcodes: [
            'dizzy',
        ],
        tags: [
            'comic',
            'star',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ab.png',
    },
    {
        emoji: '💦',
        name: 'sweat_drops',
        shortcodes: [
            'sweat_drops',
        ],
        tags: [
            'comic',
            'splashing',
            'sweat',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a6.png',
    },
    {
        emoji: '💨',
        name: 'dash',
        shortcodes: [
            'dash',
            'dashing_away',
        ],
        tags: [
            'comic',
            'dash',
            'running',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a8.png',
    },
    {
        emoji: '🕳',
        name: 'hole',
        shortcodes: [
            'hole',
        ],
        tags: [
            'hole',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f573-fe0f.png',
    },
    {
        emoji: '💣',
        name: 'bomb',
        shortcodes: [
            'bomb',
        ],
        tags: [
            'comic',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a3.png',
    },
    {
        emoji: '💬',
        name: 'speech_balloon',
        shortcodes: [
            'speech_balloon',
        ],
        tags: [
            'balloon',
            'bubble',
            'comic',
            'dialog',
            'speech',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ac.png',
    },
    {
        emoji: '👁‍🗨️',
        name: 'eye_speech_bubble',
        shortcodes: [
            'eye_in_speech_bubble',
        ],
        tags: [
            'balloon',
            'bubble',
            'eye',
            'speech',
            'witness',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f441-fe0f-200d-1f5e8-fe0f.png',
    },
    {
        emoji: '🗨',
        name: 'left_speech_bubble',
        shortcodes: [
            'left_speech_bubble',
        ],
        tags: [
            'balloon',
            'bubble',
            'dialog',
            'speech',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e8-fe0f.png',
    },
    {
        emoji: '🗯',
        name: 'right_anger_bubble',
        shortcodes: [
            'right_anger_bubble',
        ],
        tags: [
            'angry',
            'balloon',
            'bubble',
            'mad',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5ef-fe0f.png',
    },
    {
        emoji: '💭',
        name: 'thought_balloon',
        shortcodes: [
            'thought_balloon',
        ],
        tags: [
            'balloon',
            'bubble',
            'comic',
            'thought',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ad.png',
    },
    {
        emoji: '💤',
        name: 'zzz',
        shortcodes: [
            'zzz',
        ],
        tags: [
            'comic',
            'good night',
            'sleep',
            'zzz',
        ],
        group: 'smileys & emotion',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a4.png',
    },
    {
        emoji: '👋',
        name: 'wave',
        shortcodes: [
            'wave',
            'waving_hand',
        ],
        tags: [
            'hand',
            'wave',
            'waving',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44b.png',
    },
    {
        emoji: '🤚',
        name: 'raised_back_of_hand',
        shortcodes: [
            'raised_back_of_hand',
        ],
        tags: [
            'backhand',
            'raised',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91a.png',
    },
    {
        emoji: '🖐',
        name: 'raised_hand_with_fingers_splayed',
        shortcodes: [
            'raised_hand_with_fingers_splayed',
        ],
        tags: [
            'finger',
            'hand',
            'splayed',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f590-fe0f.png',
    },
    {
        emoji: '✋',
        name: 'hand',
        shortcodes: [
            'high_five',
            'raised_hand',
        ],
        tags: [
            'hand',
            'high 5',
            'high five',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270b.png',
    },
    {
        emoji: '🖖',
        name: 'vulcan_salute',
        shortcodes: [
            'vulcan',
        ],
        tags: [
            'finger',
            'hand',
            'spock',
            'vulcan',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f596.png',
    },
    {
        emoji: '👌',
        name: 'ok_hand',
        shortcodes: [
            'ok_hand',
        ],
        tags: [
            'hand',
            'ok',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44c.png',
    },
    {
        emoji: '🤌',
        name: 'pinched_fingers',
        shortcodes: [
            'pinch',
            'pinched_fingers',
        ],
        tags: [
            'fingers',
            'hand gesture',
            'interrogation',
            'pinched',
            'sarcastic',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90c.png',
    },
    {
        emoji: '🤏',
        name: 'pinching_hand',
        shortcodes: [
            'pinching_hand',
        ],
        tags: [
            'small amount',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90f.png',
    },
    {
        emoji: '✌',
        name: 'v',
        shortcodes: [
            'v',
            'victory',
        ],
        tags: [
            'hand',
            'v',
            'victory',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270c-fe0f.png',
    },
    {
        emoji: '🤞',
        name: 'crossed_fingers',
        shortcodes: [
            'fingers_crossed',
        ],
        tags: [
            'cross',
            'finger',
            'hand',
            'luck',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91e.png',
    },
    {
        emoji: '🤟',
        name: 'love_you_gesture',
        shortcodes: [
            'love_you_gesture',
        ],
        tags: [
            'hand',
            'ily',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91f.png',
    },
    {
        emoji: '🤘',
        name: 'metal',
        shortcodes: [
            'metal',
            'sign_of_the_horns',
        ],
        tags: [
            'finger',
            'hand',
            'horns',
            'rock-on',
        ],
        group: 'people & body',
        emoticons: [
            '\\m/',
            '\\M/',
        ],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f918.png',
    },
    {
        emoji: '🤙',
        name: 'call_me_hand',
        shortcodes: [
            'call_me_hand',
        ],
        tags: [
            'call',
            'hand',
            'hang loose',
            'shaka',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f919.png',
    },
    {
        emoji: '👈',
        name: 'point_left',
        shortcodes: [
            'point_left',
        ],
        tags: [
            'backhand',
            'finger',
            'hand',
            'index',
            'point',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f448.png',
    },
    {
        emoji: '👉',
        name: 'point_right',
        shortcodes: [
            'point_right',
        ],
        tags: [
            'backhand',
            'finger',
            'hand',
            'index',
            'point',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f449.png',
    },
    {
        emoji: '👆',
        name: 'point_up_2',
        shortcodes: [
            'point_up',
        ],
        tags: [
            'backhand',
            'finger',
            'hand',
            'point',
            'up',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f446.png',
    },
    {
        emoji: '🖕',
        name: 'fu',
        shortcodes: [
            'middle_finger',
        ],
        tags: [
            'finger',
            'hand',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f595.png',
    },
    {
        emoji: '👇',
        name: 'point_down',
        shortcodes: [
            'point_down',
        ],
        tags: [
            'backhand',
            'down',
            'finger',
            'hand',
            'point',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f447.png',
    },
    {
        emoji: '☝',
        name: 'point_up',
        shortcodes: [
            'point_up_2',
        ],
        tags: [
            'finger',
            'hand',
            'index',
            'point',
            'up',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/261d-fe0f.png',
    },
    {
        emoji: '👍',
        name: '+1',
        shortcodes: [
            '+1',
            'thumbsup',
            'yes',
        ],
        tags: [
            '+1',
            'hand',
            'thumb',
            'up',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44d.png',
    },
    {
        emoji: '👎',
        name: '-1',
        shortcodes: [
            '-1',
            'no',
            'thumbsdown',
        ],
        tags: [
            '-1',
            'down',
            'hand',
            'thumb',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44e.png',
    },
    {
        emoji: '✊',
        name: 'fist',
        shortcodes: [
            'fist',
        ],
        tags: [
            'clenched',
            'fist',
            'hand',
            'punch',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270a.png',
    },
    {
        emoji: '👊',
        name: 'facepunch',
        shortcodes: [
            'punch',
        ],
        tags: [
            'clenched',
            'fist',
            'hand',
            'punch',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44a.png',
    },
    {
        emoji: '🤛',
        name: 'fist_left',
        shortcodes: [
            'left_facing_fist',
        ],
        tags: [
            'fist',
            'leftwards',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91b.png',
    },
    {
        emoji: '🤜',
        name: 'fist_right',
        shortcodes: [
            'right_facing_fist',
        ],
        tags: [
            'fist',
            'rightwards',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91c.png',
    },
    {
        emoji: '👏',
        name: 'clap',
        shortcodes: [
            'clap',
            'clapping_hands',
        ],
        tags: [
            'clap',
            'hand',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44f.png',
    },
    {
        emoji: '🙌',
        name: 'raised_hands',
        shortcodes: [
            'raised_hands',
        ],
        tags: [
            'celebration',
            'gesture',
            'hand',
            'hooray',
            'raised',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64c.png',
    },
    {
        emoji: '👐',
        name: 'open_hands',
        shortcodes: [
            'open_hands',
        ],
        tags: [
            'hand',
            'open',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f450.png',
    },
    {
        emoji: '🤲',
        name: 'palms_up_together',
        shortcodes: [
            'palms_up_together',
        ],
        tags: [
            'prayer',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f932.png',
    },
    {
        emoji: '🤝',
        name: 'handshake',
        shortcodes: [
            'handshake',
        ],
        tags: [
            'agreement',
            'hand',
            'meeting',
            'shake',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91d.png',
    },
    {
        emoji: '🙏',
        name: 'pray',
        shortcodes: [
            'folded_hands',
            'pray',
        ],
        tags: [
            'ask',
            'hand',
            'high 5',
            'high five',
            'please',
            'pray',
            'thanks',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64f.png',
    },
    {
        emoji: '✍',
        name: 'writing_hand',
        shortcodes: [
            'writing_hand',
        ],
        tags: [
            'hand',
            'write',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270d-fe0f.png',
    },
    {
        emoji: '💅',
        name: 'nail_care',
        shortcodes: [
            'nail_care',
            'nail_polish',
        ],
        tags: [
            'care',
            'cosmetics',
            'manicure',
            'nail',
            'polish',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f485.png',
    },
    {
        emoji: '🤳',
        name: 'selfie',
        shortcodes: [
            'selfie',
        ],
        tags: [
            'camera',
            'phone',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f933.png',
    },
    {
        emoji: '💪',
        name: 'muscle',
        shortcodes: [
            'muscle',
            'right_bicep',
        ],
        tags: [
            'biceps',
            'comic',
            'flex',
            'muscle',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4aa.png',
    },
    {
        emoji: '🦾',
        name: 'mechanical_arm',
        shortcodes: [
            'mechanical_arm',
        ],
        tags: [
            'accessibility',
            'prosthetic',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9be.png',
    },
    {
        emoji: '🦿',
        name: 'mechanical_leg',
        shortcodes: [
            'mechanical_leg',
        ],
        tags: [
            'accessibility',
            'prosthetic',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bf.png',
    },
    {
        emoji: '🦵',
        name: 'leg',
        shortcodes: [
            'leg',
        ],
        tags: [
            'kick',
            'limb',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b5.png',
    },
    {
        emoji: '🦶',
        name: 'foot',
        shortcodes: [
            'foot',
        ],
        tags: [
            'kick',
            'stomp',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b6.png',
    },
    {
        emoji: '👂',
        name: 'ear',
        shortcodes: [
            'ear',
        ],
        tags: [
            'body',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f442.png',
    },
    {
        emoji: '🦻',
        name: 'ear_with_hearing_aid',
        shortcodes: [
            'ear_with_hearing_aid',
            'hearing_aid',
        ],
        tags: [
            'accessibility',
            'hard of hearing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bb.png',
    },
    {
        emoji: '👃',
        name: 'nose',
        shortcodes: [
            'nose',
        ],
        tags: [
            'body',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f443.png',
    },
    {
        emoji: '🧠',
        name: 'brain',
        shortcodes: [
            'brain',
        ],
        tags: [
            'intelligent',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e0.png',
    },
    {
        emoji: '🫀',
        name: 'anatomical_heart',
        shortcodes: [
            'anatomical_heart',
        ],
        tags: [
            'anatomical',
            'cardiology',
            'heart',
            'organ',
            'pulse',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac0.png',
    },
    {
        emoji: '🫁',
        name: 'lungs',
        shortcodes: [
            'lungs',
        ],
        tags: [
            'breath',
            'exhalation',
            'inhalation',
            'organ',
            'respiration',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac1.png',
    },
    {
        emoji: '🦷',
        name: 'tooth',
        shortcodes: [
            'tooth',
        ],
        tags: [
            'dentist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b7.png',
    },
    {
        emoji: '🦴',
        name: 'bone',
        shortcodes: [
            'bone',
        ],
        tags: [
            'skeleton',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b4.png',
    },
    {
        emoji: '👀',
        name: 'eyes',
        shortcodes: [
            'eyes',
        ],
        tags: [
            'eye',
            'face',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f440.png',
    },
    {
        emoji: '👁',
        name: 'eye',
        shortcodes: [
            'eye',
        ],
        tags: [
            'body',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f441-fe0f.png',
    },
    {
        emoji: '👅',
        name: 'tongue',
        shortcodes: [
            'tongue',
        ],
        tags: [
            'body',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f445.png',
    },
    {
        emoji: '👄',
        name: 'lips',
        shortcodes: [
            'lips',
            'mouth',
        ],
        tags: [
            'lips',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f444.png',
    },
    {
        emoji: '👶',
        name: 'baby',
        shortcodes: [
            'baby',
        ],
        tags: [
            'young',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f476.png',
    },
    {
        emoji: '🧒',
        name: 'child',
        shortcodes: [
            'child',
        ],
        tags: [
            'gender-neutral',
            'unspecified gender',
            'young',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d2.png',
    },
    {
        emoji: '👦',
        name: 'boy',
        shortcodes: [
            'boy',
        ],
        tags: [
            'young',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f466.png',
    },
    {
        emoji: '👧',
        name: 'girl',
        shortcodes: [
            'girl',
        ],
        tags: [
            'virgo',
            'young',
            'zodiac',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f467.png',
    },
    {
        emoji: '🧑',
        name: 'adult',
        shortcodes: [
            'adult',
        ],
        tags: [
            'adult',
            'gender-neutral',
            'unspecified gender',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1.png',
    },
    {
        emoji: '👱',
        name: 'blond_haired_person',
        shortcodes: [
            'blond_haired',
        ],
        tags: [
            'blond',
            'blond-haired person',
            'hair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471.png',
    },
    {
        emoji: '👨',
        name: 'man',
        shortcodes: [
            'man',
        ],
        tags: [
            'adult',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468.png',
    },
    {
        emoji: '🧔',
        name: 'bearded_person',
        shortcodes: [
            'person_bearded',
        ],
        tags: [
            'beard',
            'person',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4.png',
    },
    {
        emoji: '🧔‍♂',
        name: 'man_beard',
        shortcodes: [
            'man_bearded',
        ],
        tags: [
            'beard',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4-200d-2642-fe0f.png',
    },
    {
        emoji: '🧔‍♀',
        name: 'woman_beard',
        shortcodes: [
            'woman_bearded',
        ],
        tags: [
            'beard',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4-200d-2640-fe0f.png',
    },
    {
        emoji: '👨‍🦰',
        name: 'red_haired_man',
        shortcodes: [
            'man_red_haired',
        ],
        tags: [
            'adult',
            'man',
            'red hair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b0.png',
    },
    {
        emoji: '👨‍🦱',
        name: 'curly_haired_man',
        shortcodes: [
            'man_curly_haired',
        ],
        tags: [
            'adult',
            'curly hair',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b1.png',
    },
    {
        emoji: '👨‍🦳',
        name: 'white_haired_man',
        shortcodes: [
            'man_white_haired',
        ],
        tags: [
            'adult',
            'man',
            'white hair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b3.png',
    },
    {
        emoji: '👨‍🦲',
        name: 'bald_man',
        shortcodes: [
            'man_bald',
        ],
        tags: [
            'adult',
            'bald',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b2.png',
    },
    {
        emoji: '👩',
        name: 'woman',
        shortcodes: [
            'woman',
        ],
        tags: [
            'adult',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469.png',
    },
    {
        emoji: '👩‍🦰',
        name: 'red_haired_woman',
        shortcodes: [
            'woman_red_haired',
        ],
        tags: [
            'adult',
            'red hair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b0.png',
    },
    {
        emoji: '🧑‍🦰',
        name: 'person_red_hair',
        shortcodes: [
            'red_haired',
        ],
        tags: [
            'adult',
            'gender-neutral',
            'person',
            'red hair',
            'unspecified gender',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b0.png',
    },
    {
        emoji: '👩‍🦱',
        name: 'curly_haired_woman',
        shortcodes: [
            'woman_curly_haired',
        ],
        tags: [
            'adult',
            'curly hair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b1.png',
    },
    {
        emoji: '🧑‍🦱',
        name: 'person_curly_hair',
        shortcodes: [
            'curly_haired',
        ],
        tags: [
            'adult',
            'curly hair',
            'gender-neutral',
            'person',
            'unspecified gender',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b1.png',
    },
    {
        emoji: '👩‍🦳',
        name: 'white_haired_woman',
        shortcodes: [
            'woman_white_haired',
        ],
        tags: [
            'adult',
            'white hair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b3.png',
    },
    {
        emoji: '🧑‍🦳',
        name: 'person_white_hair',
        shortcodes: [
            'white_haired',
        ],
        tags: [
            'adult',
            'gender-neutral',
            'person',
            'unspecified gender',
            'white hair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b3.png',
    },
    {
        emoji: '👩‍🦲',
        name: 'bald_woman',
        shortcodes: [
            'woman_bald',
        ],
        tags: [
            'adult',
            'bald',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b2.png',
    },
    {
        emoji: '🧑‍🦲',
        name: 'person_bald',
        shortcodes: [
            'bald',
        ],
        tags: [
            'adult',
            'bald',
            'gender-neutral',
            'person',
            'unspecified gender',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b2.png',
    },
    {
        emoji: '👱‍♀',
        name: 'blond_haired_woman',
        shortcodes: [
            'woman_blond_haired',
        ],
        tags: [
            'blond-haired woman',
            'blonde',
            'hair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471-200d-2640-fe0f.png',
    },
    {
        emoji: '👱‍♂',
        name: 'blond_haired_man',
        shortcodes: [
            'man_blond_haired',
        ],
        tags: [
            'blond',
            'blond-haired man',
            'hair',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471-200d-2642-fe0f.png',
    },
    {
        emoji: '🧓',
        name: 'older_adult',
        shortcodes: [
            'older_adult',
        ],
        tags: [
            'adult',
            'gender-neutral',
            'old',
            'unspecified gender',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d3.png',
    },
    {
        emoji: '👴',
        name: 'older_man',
        shortcodes: [
            'older_man',
        ],
        tags: [
            'adult',
            'man',
            'old',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f474.png',
    },
    {
        emoji: '👵',
        name: 'older_woman',
        shortcodes: [
            'older_woman',
        ],
        tags: [
            'adult',
            'old',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f475.png',
    },
    {
        emoji: '🙍',
        name: 'frowning_person',
        shortcodes: [
            'person_frowning',
        ],
        tags: [
            'frown',
            'gesture',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d.png',
    },
    {
        emoji: '🙍‍♂',
        name: 'frowning_man',
        shortcodes: [
            'man_frowning',
        ],
        tags: [
            'frowning',
            'gesture',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d-200d-2642-fe0f.png',
    },
    {
        emoji: '🙍‍♀',
        name: 'frowning_woman',
        shortcodes: [
            'woman_frowning',
        ],
        tags: [
            'frowning',
            'gesture',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d-200d-2640-fe0f.png',
    },
    {
        emoji: '🙎',
        name: 'pouting_face',
        shortcodes: [
            'person_pouting',
            'pouting',
        ],
        tags: [
            'gesture',
            'pouting',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e.png',
    },
    {
        emoji: '🙎‍♂',
        name: 'pouting_man',
        shortcodes: [
            'man_pouting',
        ],
        tags: [
            'gesture',
            'man',
            'pouting',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e-200d-2642-fe0f.png',
    },
    {
        emoji: '🙎‍♀',
        name: 'pouting_woman',
        shortcodes: [
            'woman_pouting',
        ],
        tags: [
            'gesture',
            'pouting',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e-200d-2640-fe0f.png',
    },
    {
        emoji: '🙅',
        name: 'no_good',
        shortcodes: [
            'no_good',
            'person_gesturing_no',
        ],
        tags: [
            'forbidden',
            'gesture',
            'hand',
            'person gesturing no',
            'prohibited',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645.png',
    },
    {
        emoji: '🙅‍♂',
        name: 'ng_man',
        shortcodes: [
            'man_gesturing_no',
        ],
        tags: [
            'forbidden',
            'gesture',
            'hand',
            'man',
            'man gesturing no',
            'prohibited',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645-200d-2642-fe0f.png',
    },
    {
        emoji: '🙅‍♀',
        name: 'ng_woman',
        shortcodes: [
            'woman_gesturing_no',
        ],
        tags: [
            'forbidden',
            'gesture',
            'hand',
            'prohibited',
            'woman',
            'woman gesturing no',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645-200d-2640-fe0f.png',
    },
    {
        emoji: '🙆',
        name: 'ok_person',
        shortcodes: [
            'all_good',
            'person_gesturing_ok',
        ],
        tags: [
            'gesture',
            'hand',
            'ok',
            'person gesturing ok',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646.png',
    },
    {
        emoji: '🙆‍♂',
        name: 'ok_man',
        shortcodes: [
            'man_gesturing_ok',
        ],
        tags: [
            'gesture',
            'hand',
            'man',
            'man gesturing ok',
            'ok',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646-200d-2642-fe0f.png',
    },
    {
        emoji: '🙆‍♀',
        name: 'ok_woman',
        shortcodes: [
            'woman_gesturing_ok',
        ],
        tags: [
            'gesture',
            'hand',
            'ok',
            'woman',
            'woman gesturing ok',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646-200d-2640-fe0f.png',
    },
    {
        emoji: '💁',
        name: 'information_desk_person',
        shortcodes: [
            'person_tipping_hand',
        ],
        tags: [
            'hand',
            'help',
            'information',
            'sassy',
            'tipping',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481.png',
    },
    {
        emoji: '💁‍♂',
        name: 'sassy_man',
        shortcodes: [
            'man_tipping_hand',
        ],
        tags: [
            'man',
            'sassy',
            'tipping hand',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481-200d-2642-fe0f.png',
    },
    {
        emoji: '💁‍♀',
        name: 'sassy_woman',
        shortcodes: [
            'woman_tipping_hand',
        ],
        tags: [
            'sassy',
            'tipping hand',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481-200d-2640-fe0f.png',
    },
    {
        emoji: '🙋',
        name: 'raising_hand',
        shortcodes: [
            'person_raising_hand',
        ],
        tags: [
            'gesture',
            'hand',
            'happy',
            'raised',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b.png',
    },
    {
        emoji: '🙋‍♂',
        name: 'raising_hand_man',
        shortcodes: [
            'man_raising_hand',
        ],
        tags: [
            'gesture',
            'man',
            'raising hand',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b-200d-2642-fe0f.png',
    },
    {
        emoji: '🙋‍♀',
        name: 'raising_hand_woman',
        shortcodes: [
            'woman_raising_hand',
        ],
        tags: [
            'gesture',
            'raising hand',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b-200d-2640-fe0f.png',
    },
    {
        emoji: '🧏',
        name: 'deaf_person',
        shortcodes: [
            'deaf_person',
        ],
        tags: [
            'accessibility',
            'deaf',
            'ear',
            'hear',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf.png',
    },
    {
        emoji: '🧏‍♂',
        name: 'deaf_man',
        shortcodes: [
            'deaf_man',
        ],
        tags: [
            'deaf',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf-200d-2642-fe0f.png',
    },
    {
        emoji: '🧏‍♀',
        name: 'deaf_woman',
        shortcodes: [
            'deaf_woman',
        ],
        tags: [
            'deaf',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf-200d-2640-fe0f.png',
    },
    {
        emoji: '🙇',
        name: 'bow',
        shortcodes: [
            'bow',
            'person_bowing',
        ],
        tags: [
            'apology',
            'bow',
            'gesture',
            'sorry',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647.png',
    },
    {
        emoji: '🙇‍♂',
        name: 'bowing_man',
        shortcodes: [
            'man_bowing',
        ],
        tags: [
            'apology',
            'bowing',
            'favor',
            'gesture',
            'man',
            'sorry',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647-200d-2642-fe0f.png',
    },
    {
        emoji: '🙇‍♀',
        name: 'bowing_woman',
        shortcodes: [
            'woman_bowing',
        ],
        tags: [
            'apology',
            'bowing',
            'favor',
            'gesture',
            'sorry',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647-200d-2640-fe0f.png',
    },
    {
        emoji: '🤦',
        name: 'facepalm',
        shortcodes: [
            'facepalm',
            'person_facepalming',
        ],
        tags: [
            'disbelief',
            'exasperation',
            'face',
            'palm',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926.png',
    },
    {
        emoji: '🤦‍♂',
        name: 'man_facepalming',
        shortcodes: [
            'man_facepalming',
        ],
        tags: [
            'disbelief',
            'exasperation',
            'facepalm',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926-200d-2642-fe0f.png',
    },
    {
        emoji: '🤦‍♀',
        name: 'woman_facepalming',
        shortcodes: [
            'woman_facepalming',
        ],
        tags: [
            'disbelief',
            'exasperation',
            'facepalm',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926-200d-2640-fe0f.png',
    },
    {
        emoji: '🤷',
        name: 'shrug',
        shortcodes: [
            'person_shrugging',
            'shrug',
        ],
        tags: [
            'doubt',
            'ignorance',
            'indifference',
            'shrug',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937.png',
    },
    {
        emoji: '🤷‍♂',
        name: 'man_shrugging',
        shortcodes: [
            'man_shrugging',
        ],
        tags: [
            'doubt',
            'ignorance',
            'indifference',
            'man',
            'shrug',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937-200d-2642-fe0f.png',
    },
    {
        emoji: '🤷‍♀',
        name: 'woman_shrugging',
        shortcodes: [
            'woman_shrugging',
        ],
        tags: [
            'doubt',
            'ignorance',
            'indifference',
            'shrug',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937-200d-2640-fe0f.png',
    },
    {
        emoji: '🧑‍⚕',
        name: 'health_worker',
        shortcodes: [
            'health_worker',
        ],
        tags: [
            'doctor',
            'healthcare',
            'nurse',
            'therapist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2695-fe0f.png',
    },
    {
        emoji: '👨‍⚕',
        name: 'man_health_worker',
        shortcodes: [
            'man_health_worker',
        ],
        tags: [
            'doctor',
            'healthcare',
            'man',
            'nurse',
            'therapist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2695-fe0f.png',
    },
    {
        emoji: '👩‍⚕',
        name: 'woman_health_worker',
        shortcodes: [
            'woman_health_worker',
        ],
        tags: [
            'doctor',
            'healthcare',
            'nurse',
            'therapist',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2695-fe0f.png',
    },
    {
        emoji: '🧑‍🎓',
        name: 'student',
        shortcodes: [
            'student',
        ],
        tags: [
            'graduate',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f393.png',
    },
    {
        emoji: '👨‍🎓',
        name: 'man_student',
        shortcodes: [
            'man_student',
        ],
        tags: [
            'graduate',
            'man',
            'student',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f393.png',
    },
    {
        emoji: '👩‍🎓',
        name: 'woman_student',
        shortcodes: [
            'woman_student',
        ],
        tags: [
            'graduate',
            'student',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f393.png',
    },
    {
        emoji: '🧑‍🏫',
        name: 'teacher',
        shortcodes: [
            'teacher',
        ],
        tags: [
            'instructor',
            'professor',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3eb.png',
    },
    {
        emoji: '👨‍🏫',
        name: 'man_teacher',
        shortcodes: [
            'man_teacher',
        ],
        tags: [
            'instructor',
            'man',
            'professor',
            'teacher',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3eb.png',
    },
    {
        emoji: '👩‍🏫',
        name: 'woman_teacher',
        shortcodes: [
            'woman_teacher',
        ],
        tags: [
            'instructor',
            'professor',
            'teacher',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3eb.png',
    },
    {
        emoji: '🧑‍⚖',
        name: 'judge',
        shortcodes: [
            'judge',
        ],
        tags: [
            'justice',
            'scales',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2696-fe0f.png',
    },
    {
        emoji: '👨‍⚖',
        name: 'man_judge',
        shortcodes: [
            'man_judge',
        ],
        tags: [
            'judge',
            'justice',
            'man',
            'scales',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2696-fe0f.png',
    },
    {
        emoji: '👩‍⚖',
        name: 'woman_judge',
        shortcodes: [
            'woman_judge',
        ],
        tags: [
            'judge',
            'justice',
            'scales',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2696-fe0f.png',
    },
    {
        emoji: '🧑‍🌾',
        name: 'farmer',
        shortcodes: [
            'farmer',
        ],
        tags: [
            'gardener',
            'rancher',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f33e.png',
    },
    {
        emoji: '👨‍🌾',
        name: 'man_farmer',
        shortcodes: [
            'man_farmer',
        ],
        tags: [
            'farmer',
            'gardener',
            'man',
            'rancher',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f33e.png',
    },
    {
        emoji: '👩‍🌾',
        name: 'woman_farmer',
        shortcodes: [
            'woman_farmer',
        ],
        tags: [
            'farmer',
            'gardener',
            'rancher',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f33e.png',
    },
    {
        emoji: '🧑‍🍳',
        name: 'cook',
        shortcodes: [
            'cook',
        ],
        tags: [
            'chef',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f373.png',
    },
    {
        emoji: '👨‍🍳',
        name: 'man_cook',
        shortcodes: [
            'man_cook',
        ],
        tags: [
            'chef',
            'cook',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f373.png',
    },
    {
        emoji: '👩‍🍳',
        name: 'woman_cook',
        shortcodes: [
            'woman_cook',
        ],
        tags: [
            'chef',
            'cook',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f373.png',
    },
    {
        emoji: '🧑‍🔧',
        name: 'mechanic',
        shortcodes: [
            'mechanic',
        ],
        tags: [
            'electrician',
            'plumber',
            'tradesperson',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f527.png',
    },
    {
        emoji: '👨‍🔧',
        name: 'man_mechanic',
        shortcodes: [
            'man_mechanic',
        ],
        tags: [
            'electrician',
            'man',
            'mechanic',
            'plumber',
            'tradesperson',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f527.png',
    },
    {
        emoji: '👩‍🔧',
        name: 'woman_mechanic',
        shortcodes: [
            'woman_mechanic',
        ],
        tags: [
            'electrician',
            'mechanic',
            'plumber',
            'tradesperson',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f527.png',
    },
    {
        emoji: '🧑‍🏭',
        name: 'factory_worker',
        shortcodes: [
            'factory_worker',
        ],
        tags: [
            'assembly',
            'factory',
            'industrial',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3ed.png',
    },
    {
        emoji: '👨‍🏭',
        name: 'man_factory_worker',
        shortcodes: [
            'man_factory_worker',
        ],
        tags: [
            'assembly',
            'factory',
            'industrial',
            'man',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3ed.png',
    },
    {
        emoji: '👩‍🏭',
        name: 'woman_factory_worker',
        shortcodes: [
            'woman_factory_worker',
        ],
        tags: [
            'assembly',
            'factory',
            'industrial',
            'woman',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3ed.png',
    },
    {
        emoji: '🧑‍💼',
        name: 'office_worker',
        shortcodes: [
            'office_worker',
        ],
        tags: [
            'architect',
            'business',
            'manager',
            'white-collar',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f4bc.png',
    },
    {
        emoji: '👨‍💼',
        name: 'man_office_worker',
        shortcodes: [
            'man_office_worker',
        ],
        tags: [
            'architect',
            'business',
            'man',
            'manager',
            'white-collar',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f4bc.png',
    },
    {
        emoji: '👩‍💼',
        name: 'woman_office_worker',
        shortcodes: [
            'woman_office_worker',
        ],
        tags: [
            'architect',
            'business',
            'manager',
            'white-collar',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f4bc.png',
    },
    {
        emoji: '🧑‍🔬',
        name: 'scientist',
        shortcodes: [
            'scientist',
        ],
        tags: [
            'biologist',
            'chemist',
            'engineer',
            'physicist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f52c.png',
    },
    {
        emoji: '👨‍🔬',
        name: 'man_scientist',
        shortcodes: [
            'man_scientist',
        ],
        tags: [
            'biologist',
            'chemist',
            'engineer',
            'man',
            'physicist',
            'scientist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f52c.png',
    },
    {
        emoji: '👩‍🔬',
        name: 'woman_scientist',
        shortcodes: [
            'woman_scientist',
        ],
        tags: [
            'biologist',
            'chemist',
            'engineer',
            'physicist',
            'scientist',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f52c.png',
    },
    {
        emoji: '🧑‍💻',
        name: 'technologist',
        shortcodes: [
            'technologist',
        ],
        tags: [
            'coder',
            'developer',
            'inventor',
            'software',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f4bb.png',
    },
    {
        emoji: '👨‍💻',
        name: 'man_technologist',
        shortcodes: [
            'man_technologist',
        ],
        tags: [
            'coder',
            'developer',
            'inventor',
            'man',
            'software',
            'technologist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f4bb.png',
    },
    {
        emoji: '👩‍💻',
        name: 'woman_technologist',
        shortcodes: [
            'woman_technologist',
        ],
        tags: [
            'coder',
            'developer',
            'inventor',
            'software',
            'technologist',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f4bb.png',
    },
    {
        emoji: '🧑‍🎤',
        name: 'singer',
        shortcodes: [
            'singer',
        ],
        tags: [
            'actor',
            'entertainer',
            'rock',
            'star',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3a4.png',
    },
    {
        emoji: '👨‍🎤',
        name: 'man_singer',
        shortcodes: [
            'man_singer',
        ],
        tags: [
            'actor',
            'entertainer',
            'man',
            'rock',
            'singer',
            'star',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3a4.png',
    },
    {
        emoji: '👩‍🎤',
        name: 'woman_singer',
        shortcodes: [
            'woman_singer',
        ],
        tags: [
            'actor',
            'entertainer',
            'rock',
            'singer',
            'star',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3a4.png',
    },
    {
        emoji: '🧑‍🎨',
        name: 'artist',
        shortcodes: [
            'artist',
        ],
        tags: [
            'palette',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3a8.png',
    },
    {
        emoji: '👨‍🎨',
        name: 'man_artist',
        shortcodes: [
            'man_artist',
        ],
        tags: [
            'artist',
            'man',
            'palette',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3a8.png',
    },
    {
        emoji: '👩‍🎨',
        name: 'woman_artist',
        shortcodes: [
            'woman_artist',
        ],
        tags: [
            'artist',
            'palette',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3a8.png',
    },
    {
        emoji: '🧑‍✈',
        name: 'pilot',
        shortcodes: [
            'pilot',
        ],
        tags: [
            'plane',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2708-fe0f.png',
    },
    {
        emoji: '👨‍✈',
        name: 'man_pilot',
        shortcodes: [
            'man_pilot',
        ],
        tags: [
            'man',
            'pilot',
            'plane',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2708-fe0f.png',
    },
    {
        emoji: '👩‍✈',
        name: 'woman_pilot',
        shortcodes: [
            'woman_pilot',
        ],
        tags: [
            'pilot',
            'plane',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2708-fe0f.png',
    },
    {
        emoji: '🧑‍🚀',
        name: 'astronaut',
        shortcodes: [
            'astronaut',
        ],
        tags: [
            'rocket',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f680.png',
    },
    {
        emoji: '👨‍🚀',
        name: 'man_astronaut',
        shortcodes: [
            'man_astronaut',
        ],
        tags: [
            'astronaut',
            'man',
            'rocket',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f680.png',
    },
    {
        emoji: '👩‍🚀',
        name: 'woman_astronaut',
        shortcodes: [
            'woman_astronaut',
        ],
        tags: [
            'astronaut',
            'rocket',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f680.png',
    },
    {
        emoji: '🧑‍🚒',
        name: 'firefighter',
        shortcodes: [
            'firefighter',
        ],
        tags: [
            'firetruck',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f692.png',
    },
    {
        emoji: '👨‍🚒',
        name: 'man_firefighter',
        shortcodes: [
            'man_firefighter',
        ],
        tags: [
            'firefighter',
            'firetruck',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f692.png',
    },
    {
        emoji: '👩‍🚒',
        name: 'woman_firefighter',
        shortcodes: [
            'woman_firefighter',
        ],
        tags: [
            'firefighter',
            'firetruck',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f692.png',
    },
    {
        emoji: '👮',
        name: 'cop',
        shortcodes: [
            'cop',
            'police_officer',
        ],
        tags: [
            'cop',
            'officer',
            'police',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e.png',
    },
    {
        emoji: '👮‍♂',
        name: 'policeman',
        shortcodes: [
            'man_police_officer',
        ],
        tags: [
            'cop',
            'man',
            'officer',
            'police',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e-200d-2642-fe0f.png',
    },
    {
        emoji: '👮‍♀',
        name: 'policewoman',
        shortcodes: [
            'woman_police_officer',
        ],
        tags: [
            'cop',
            'officer',
            'police',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e-200d-2640-fe0f.png',
    },
    {
        emoji: '🕵',
        name: 'detective',
        shortcodes: [
            'detective',
        ],
        tags: [
            'sleuth',
            'spy',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f.png',
    },
    {
        emoji: '🕵‍♂️',
        name: 'male_detective',
        shortcodes: [
            'man_detective',
        ],
        tags: [
            'detective',
            'man',
            'sleuth',
            'spy',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f-200d-2642-fe0f.png',
    },
    {
        emoji: '🕵‍♀️',
        name: 'female_detective',
        shortcodes: [
            'woman_detective',
        ],
        tags: [
            'detective',
            'sleuth',
            'spy',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f-200d-2640-fe0f.png',
    },
    {
        emoji: '💂',
        name: 'guard',
        shortcodes: [
            'guard',
        ],
        tags: [
            'guard',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482.png',
    },
    {
        emoji: '💂‍♂',
        name: 'guardsman',
        shortcodes: [
            'man_guard',
        ],
        tags: [
            'guard',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482-200d-2642-fe0f.png',
    },
    {
        emoji: '💂‍♀',
        name: 'guardswoman',
        shortcodes: [
            'woman_guard',
        ],
        tags: [
            'guard',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482-200d-2640-fe0f.png',
    },
    {
        emoji: '🥷',
        name: 'ninja',
        shortcodes: [
            'ninja',
        ],
        tags: [
            'fighter',
            'hidden',
            'stealth',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f977.png',
    },
    {
        emoji: '👷',
        name: 'construction_worker',
        shortcodes: [
            'construction_worker',
        ],
        tags: [
            'construction',
            'hat',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477.png',
    },
    {
        emoji: '👷‍♂',
        name: 'construction_worker_man',
        shortcodes: [
            'man_construction_worker',
        ],
        tags: [
            'construction',
            'man',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477-200d-2642-fe0f.png',
    },
    {
        emoji: '👷‍♀',
        name: 'construction_worker_woman',
        shortcodes: [
            'woman_construction_worker',
        ],
        tags: [
            'construction',
            'woman',
            'worker',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477-200d-2640-fe0f.png',
    },
    {
        emoji: '🤴',
        name: 'prince',
        shortcodes: [
            'prince',
        ],
        tags: [
            'prince',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f934.png',
    },
    {
        emoji: '👸',
        name: 'princess',
        shortcodes: [
            'princess',
        ],
        tags: [
            'fairy tale',
            'fantasy',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f478.png',
    },
    {
        emoji: '👳',
        name: 'person_with_turban',
        shortcodes: [
            'person_wearing_turban',
        ],
        tags: [
            'turban',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473.png',
    },
    {
        emoji: '👳‍♂',
        name: 'man_with_turban',
        shortcodes: [
            'man_wearing_turban',
        ],
        tags: [
            'man',
            'turban',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473-200d-2642-fe0f.png',
    },
    {
        emoji: '👳‍♀',
        name: 'woman_with_turban',
        shortcodes: [
            'woman_wearing_turban',
        ],
        tags: [
            'turban',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473-200d-2640-fe0f.png',
    },
    {
        emoji: '👲',
        name: 'man_with_gua_pi_mao',
        shortcodes: [
            'person_with_skullcap',
        ],
        tags: [
            'cap',
            'gua pi mao',
            'hat',
            'person',
            'skullcap',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f472.png',
    },
    {
        emoji: '🧕',
        name: 'woman_with_headscarf',
        shortcodes: [
            'woman_with_headscarf',
        ],
        tags: [
            'headscarf',
            'hijab',
            'mantilla',
            'tichel',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d5.png',
    },
    {
        emoji: '🤵',
        name: 'person_in_tuxedo',
        shortcodes: [
            'person_in_tuxedo',
        ],
        tags: [
            'groom',
            'person',
            'tuxedo',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935.png',
    },
    {
        emoji: '🤵‍♂',
        name: 'man_in_tuxedo',
        shortcodes: [
            'man_in_tuxedo',
        ],
        tags: [
            'man',
            'tuxedo',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935-200d-2642-fe0f.png',
    },
    {
        emoji: '🤵‍♀',
        name: 'woman_in_tuxedo',
        shortcodes: [
            'woman_in_tuxedo',
        ],
        tags: [
            'tuxedo',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935-200d-2640-fe0f.png',
    },
    {
        emoji: '👰',
        name: 'person_with_veil',
        shortcodes: [
            'person_with_veil',
        ],
        tags: [
            'bride',
            'person',
            'veil',
            'wedding',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470.png',
    },
    {
        emoji: '👰‍♂',
        name: 'man_with_veil',
        shortcodes: [
            'man_with_veil',
        ],
        tags: [
            'man',
            'veil',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470-200d-2642-fe0f.png',
    },
    {
        emoji: '👰‍♀',
        name: 'bride_with_veil',
        shortcodes: [
            'woman_with_veil',
        ],
        tags: [
            'veil',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470-200d-2640-fe0f.png',
    },
    {
        emoji: '🤰',
        name: 'pregnant_woman',
        shortcodes: [
            'pregnant_woman',
        ],
        tags: [
            'pregnant',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f930.png',
    },
    {
        emoji: '🤱',
        name: 'breast_feeding',
        shortcodes: [
            'breast_feeding',
        ],
        tags: [
            'baby',
            'breast',
            'nursing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f931.png',
    },
    {
        emoji: '👩‍🍼',
        name: 'woman_feeding_baby',
        shortcodes: [
            'woman_feeding_baby',
        ],
        tags: [
            'baby',
            'feeding',
            'nursing',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f37c.png',
    },
    {
        emoji: '👨‍🍼',
        name: 'man_feeding_baby',
        shortcodes: [
            'man_feeding_baby',
        ],
        tags: [
            'baby',
            'feeding',
            'man',
            'nursing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f37c.png',
    },
    {
        emoji: '🧑‍🍼',
        name: 'person_feeding_baby',
        shortcodes: [
            'person_feeding_baby',
        ],
        tags: [
            'baby',
            'feeding',
            'nursing',
            'person',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f37c.png',
    },
    {
        emoji: '👼',
        name: 'angel',
        shortcodes: [
            'angel',
        ],
        tags: [
            'angel',
            'baby',
            'face',
            'fairy tale',
            'fantasy',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47c.png',
    },
    {
        emoji: '🎅',
        name: 'santa',
        shortcodes: [
            'santa',
        ],
        tags: [
            'celebration',
            'christmas',
            'claus',
            'father',
            'santa',
            'santa claus',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f385.png',
    },
    {
        emoji: '🤶',
        name: 'mrs_claus',
        shortcodes: [
            'mrs_claus',
        ],
        tags: [
            'celebration',
            'christmas',
            'claus',
            'mother',
            'mrs.',
            'mrs. claus',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f936.png',
    },
    {
        emoji: '🧑‍🎄',
        name: 'mx_claus',
        shortcodes: [
            'mx_claus',
        ],
        tags: [
            'claus, christmas',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f384.png',
    },
    {
        emoji: '🦸',
        name: 'superhero',
        shortcodes: [
            'superhero',
        ],
        tags: [
            'good',
            'hero',
            'heroine',
            'superpower',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8.png',
    },
    {
        emoji: '🦸‍♂',
        name: 'superhero_man',
        shortcodes: [
            'man_superhero',
        ],
        tags: [
            'good',
            'hero',
            'man',
            'superpower',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8-200d-2642-fe0f.png',
    },
    {
        emoji: '🦸‍♀',
        name: 'superhero_woman',
        shortcodes: [
            'woman_superhero',
        ],
        tags: [
            'good',
            'hero',
            'heroine',
            'superpower',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8-200d-2640-fe0f.png',
    },
    {
        emoji: '🦹',
        name: 'supervillain',
        shortcodes: [
            'supervillain',
        ],
        tags: [
            'criminal',
            'evil',
            'superpower',
            'villain',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9.png',
    },
    {
        emoji: '🦹‍♂',
        name: 'supervillain_man',
        shortcodes: [
            'man_supervillain',
        ],
        tags: [
            'criminal',
            'evil',
            'man',
            'superpower',
            'villain',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9-200d-2642-fe0f.png',
    },
    {
        emoji: '🦹‍♀',
        name: 'supervillain_woman',
        shortcodes: [
            'woman_supervillain',
        ],
        tags: [
            'criminal',
            'evil',
            'superpower',
            'villain',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9-200d-2640-fe0f.png',
    },
    {
        emoji: '🧙',
        name: 'mage',
        shortcodes: [
            'mage',
        ],
        tags: [
            'sorcerer',
            'sorceress',
            'witch',
            'wizard',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9.png',
    },
    {
        emoji: '🧙‍♂',
        name: 'mage_man',
        shortcodes: [
            'man_mage',
        ],
        tags: [
            'sorcerer',
            'wizard',
        ],
        group: 'people & body',
        emoticons: [
            ':{>',
        ],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9-200d-2642-fe0f.png',
    },
    {
        emoji: '🧙‍♀',
        name: 'mage_woman',
        shortcodes: [
            'woman_mage',
        ],
        tags: [
            'sorceress',
            'witch',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9-200d-2640-fe0f.png',
    },
    {
        emoji: '🧚',
        name: 'fairy',
        shortcodes: [
            'fairy',
        ],
        tags: [
            'oberon',
            'puck',
            'titania',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da.png',
    },
    {
        emoji: '🧚‍♂',
        name: 'fairy_man',
        shortcodes: [
            'man_fairy',
        ],
        tags: [
            'oberon',
            'puck',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da-200d-2642-fe0f.png',
    },
    {
        emoji: '🧚‍♀',
        name: 'fairy_woman',
        shortcodes: [
            'woman_fairy',
        ],
        tags: [
            'titania',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da-200d-2640-fe0f.png',
    },
    {
        emoji: '🧛',
        name: 'vampire',
        shortcodes: [
            'vampire',
        ],
        tags: [
            'dracula',
            'undead',
        ],
        group: 'people & body',
        emoticons: [
            ':E',
        ],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db.png',
    },
    {
        emoji: '🧛‍♂',
        name: 'vampire_man',
        shortcodes: [
            'man_vampire',
        ],
        tags: [
            'dracula',
            'undead',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db-200d-2642-fe0f.png',
    },
    {
        emoji: '🧛‍♀',
        name: 'vampire_woman',
        shortcodes: [
            'woman_vampire',
        ],
        tags: [
            'undead',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db-200d-2640-fe0f.png',
    },
    {
        emoji: '🧜',
        name: 'merperson',
        shortcodes: [
            'merperson',
        ],
        tags: [
            'mermaid',
            'merman',
            'merwoman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc.png',
    },
    {
        emoji: '🧜‍♂',
        name: 'merman',
        shortcodes: [
            'merman',
        ],
        tags: [
            'triton',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc-200d-2642-fe0f.png',
    },
    {
        emoji: '🧜‍♀',
        name: 'mermaid',
        shortcodes: [
            'mermaid',
        ],
        tags: [
            'merwoman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc-200d-2640-fe0f.png',
    },
    {
        emoji: '🧝',
        name: 'elf',
        shortcodes: [
            'elf',
        ],
        tags: [
            'magical',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd.png',
    },
    {
        emoji: '🧝‍♂',
        name: 'elf_man',
        shortcodes: [
            'man_elf',
        ],
        tags: [
            'magical',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd-200d-2642-fe0f.png',
    },
    {
        emoji: '🧝‍♀',
        name: 'elf_woman',
        shortcodes: [
            'woman_elf',
        ],
        tags: [
            'magical',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd-200d-2640-fe0f.png',
    },
    {
        emoji: '🧞',
        name: 'genie',
        shortcodes: [
            'genie',
        ],
        tags: [
            'djinn',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de.png',
    },
    {
        emoji: '🧞‍♂',
        name: 'genie_man',
        shortcodes: [
            'man_genie',
        ],
        tags: [
            'djinn',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de-200d-2642-fe0f.png',
    },
    {
        emoji: '🧞‍♀',
        name: 'genie_woman',
        shortcodes: [
            'woman_genie',
        ],
        tags: [
            'djinn',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de-200d-2640-fe0f.png',
    },
    {
        emoji: '🧟',
        name: 'zombie',
        shortcodes: [
            'zombie',
        ],
        tags: [
            'undead',
            'walking dead',
        ],
        group: 'people & body',
        emoticons: [
            '8#',
        ],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df.png',
    },
    {
        emoji: '🧟‍♂',
        name: 'zombie_man',
        shortcodes: [
            'man_zombie',
        ],
        tags: [
            'undead',
            'walking dead',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df-200d-2642-fe0f.png',
    },
    {
        emoji: '🧟‍♀',
        name: 'zombie_woman',
        shortcodes: [
            'woman_zombie',
        ],
        tags: [
            'undead',
            'walking dead',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df-200d-2640-fe0f.png',
    },
    {
        emoji: '💆',
        name: 'massage',
        shortcodes: [
            'massage',
            'person_getting_massage',
        ],
        tags: [
            'face',
            'massage',
            'salon',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486.png',
    },
    {
        emoji: '💆‍♂',
        name: 'massage_man',
        shortcodes: [
            'man_getting_massage',
        ],
        tags: [
            'face',
            'man',
            'massage',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486-200d-2642-fe0f.png',
    },
    {
        emoji: '💆‍♀',
        name: 'massage_woman',
        shortcodes: [
            'woman_getting_massage',
        ],
        tags: [
            'face',
            'massage',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486-200d-2640-fe0f.png',
    },
    {
        emoji: '💇',
        name: 'haircut',
        shortcodes: [
            'haircut',
            'person_getting_haircut',
        ],
        tags: [
            'barber',
            'beauty',
            'haircut',
            'parlor',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487.png',
    },
    {
        emoji: '💇‍♂',
        name: 'haircut_man',
        shortcodes: [
            'man_getting_haircut',
        ],
        tags: [
            'haircut',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487-200d-2642-fe0f.png',
    },
    {
        emoji: '💇‍♀',
        name: 'haircut_woman',
        shortcodes: [
            'woman_getting_haircut',
        ],
        tags: [
            'haircut',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487-200d-2640-fe0f.png',
    },
    {
        emoji: '🚶',
        name: 'walking',
        shortcodes: [
            'person_walking',
            'walking',
        ],
        tags: [
            'hike',
            'walk',
            'walking',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6.png',
    },
    {
        emoji: '🚶‍♂',
        name: 'walking_man',
        shortcodes: [
            'man_walking',
        ],
        tags: [
            'hike',
            'man',
            'walk',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2642-fe0f.png',
    },
    {
        emoji: '🚶‍♀',
        name: 'walking_woman',
        shortcodes: [
            'woman_walking',
        ],
        tags: [
            'hike',
            'walk',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2640-fe0f.png',
    },
    {
        emoji: '🧍',
        name: 'standing_person',
        shortcodes: [
            'person_standing',
            'standing',
        ],
        tags: [
            'stand',
            'standing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd.png',
    },
    {
        emoji: '🧍‍♂',
        name: 'standing_man',
        shortcodes: [
            'man_standing',
        ],
        tags: [
            'man',
            'standing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd-200d-2642-fe0f.png',
    },
    {
        emoji: '🧍‍♀',
        name: 'standing_woman',
        shortcodes: [
            'woman_standing',
        ],
        tags: [
            'standing',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd-200d-2640-fe0f.png',
    },
    {
        emoji: '🧎',
        name: 'kneeling_person',
        shortcodes: [
            'kneeling',
            'person_kneeling',
        ],
        tags: [
            'kneel',
            'kneeling',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce.png',
    },
    {
        emoji: '🧎‍♂',
        name: 'kneeling_man',
        shortcodes: [
            'man_kneeling',
        ],
        tags: [
            'kneeling',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2642-fe0f.png',
    },
    {
        emoji: '🧎‍♀',
        name: 'kneeling_woman',
        shortcodes: [
            'woman_kneeling',
        ],
        tags: [
            'kneeling',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2640-fe0f.png',
    },
    {
        emoji: '🧑‍🦯',
        name: 'person_with_probing_cane',
        shortcodes: [
            'person_with_probing_cane',
            'person_with_white_cane',
        ],
        tags: [
            'accessibility',
            'blind',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9af.png',
    },
    {
        emoji: '👨‍🦯',
        name: 'man_with_probing_cane',
        shortcodes: [
            'man_with_probing_cane',
            'man_with_white_cane',
        ],
        tags: [
            'accessibility',
            'blind',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9af.png',
    },
    {
        emoji: '👩‍🦯',
        name: 'woman_with_probing_cane',
        shortcodes: [
            'woman_with_probing_cane',
            'woman_with_white_cane',
        ],
        tags: [
            'accessibility',
            'blind',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9af.png',
    },
    {
        emoji: '🧑‍🦼',
        name: 'person_in_motorized_wheelchair',
        shortcodes: [
            'person_in_motorized_wheelchair',
        ],
        tags: [
            'accessibility',
            'wheelchair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bc.png',
    },
    {
        emoji: '👨‍🦼',
        name: 'man_in_motorized_wheelchair',
        shortcodes: [
            'man_in_motorized_wheelchair',
        ],
        tags: [
            'accessibility',
            'man',
            'wheelchair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bc.png',
    },
    {
        emoji: '👩‍🦼',
        name: 'woman_in_motorized_wheelchair',
        shortcodes: [
            'woman_in_motorized_wheelchair',
        ],
        tags: [
            'accessibility',
            'wheelchair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bc.png',
    },
    {
        emoji: '🧑‍🦽',
        name: 'person_in_manual_wheelchair',
        shortcodes: [
            'person_in_manual_wheelchair',
        ],
        tags: [
            'accessibility',
            'wheelchair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12.1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bd.png',
    },
    {
        emoji: '👨‍🦽',
        name: 'man_in_manual_wheelchair',
        shortcodes: [
            'man_in_manual_wheelchair',
        ],
        tags: [
            'accessibility',
            'man',
            'wheelchair',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bd.png',
    },
    {
        emoji: '👩‍🦽',
        name: 'woman_in_manual_wheelchair',
        shortcodes: [
            'woman_in_manual_wheelchair',
        ],
        tags: [
            'accessibility',
            'wheelchair',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bd.png',
    },
    {
        emoji: '🏃',
        name: 'runner',
        shortcodes: [
            'person_running',
            'running',
        ],
        tags: [
            'marathon',
            'running',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3.png',
    },
    {
        emoji: '🏃‍♂',
        name: 'running_man',
        shortcodes: [
            'man_running',
        ],
        tags: [
            'man',
            'marathon',
            'racing',
            'running',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2642-fe0f.png',
    },
    {
        emoji: '🏃‍♀',
        name: 'running_woman',
        shortcodes: [
            'woman_running',
        ],
        tags: [
            'marathon',
            'racing',
            'running',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2640-fe0f.png',
    },
    {
        emoji: '💃',
        name: 'dancer',
        shortcodes: [
            'dancer',
            'woman_dancing',
        ],
        tags: [
            'dance',
            'dancing',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f483.png',
    },
    {
        emoji: '🕺',
        name: 'man_dancing',
        shortcodes: [
            'man_dancing',
        ],
        tags: [
            'dance',
            'dancing',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f57a.png',
    },
    {
        emoji: '🕴',
        name: 'business_suit_levitating',
        shortcodes: [
            'levitate',
            'levitating',
            'person_in_suit_levitating',
        ],
        tags: [
            'business',
            'person',
            'suit',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f574-fe0f.png',
    },
    {
        emoji: '👯',
        name: 'dancers',
        shortcodes: [
            'dancers',
            'people_with_bunny_ears_partying',
        ],
        tags: [
            'bunny ear',
            'dancer',
            'partying',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f.png',
    },
    {
        emoji: '👯‍♂',
        name: 'dancing_men',
        shortcodes: [
            'men_with_bunny_ears_partying',
        ],
        tags: [
            'bunny ear',
            'dancer',
            'men',
            'partying',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f-200d-2642-fe0f.png',
    },
    {
        emoji: '👯‍♀',
        name: 'dancing_women',
        shortcodes: [
            'women_with_bunny_ears_partying',
        ],
        tags: [
            'bunny ear',
            'dancer',
            'partying',
            'women',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f-200d-2640-fe0f.png',
    },
    {
        emoji: '🧖',
        name: 'sauna_person',
        shortcodes: [
            'person_in_steamy_room',
        ],
        tags: [
            'sauna',
            'steam room',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6.png',
    },
    {
        emoji: '🧖‍♂',
        name: 'sauna_man',
        shortcodes: [
            'man_in_steamy_room',
        ],
        tags: [
            'sauna',
            'steam room',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6-200d-2642-fe0f.png',
    },
    {
        emoji: '🧖‍♀',
        name: 'sauna_woman',
        shortcodes: [
            'woman_in_steamy_room',
        ],
        tags: [
            'sauna',
            'steam room',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6-200d-2640-fe0f.png',
    },
    {
        emoji: '🧗',
        name: 'climbing',
        shortcodes: [
            'climbing',
            'person_climbing',
        ],
        tags: [
            'climber',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7.png',
    },
    {
        emoji: '🧗‍♂',
        name: 'climbing_man',
        shortcodes: [
            'man_climbing',
        ],
        tags: [
            'climber',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7-200d-2642-fe0f.png',
    },
    {
        emoji: '🧗‍♀',
        name: 'climbing_woman',
        shortcodes: [
            'woman_climbing',
        ],
        tags: [
            'climber',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7-200d-2640-fe0f.png',
    },
    {
        emoji: '🤺',
        name: 'person_fencing',
        shortcodes: [
            'fencer',
            'fencing',
            'person_fencing',
        ],
        tags: [
            'fencer',
            'fencing',
            'sword',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93a.png',
    },
    {
        emoji: '🏇',
        name: 'horse_racing',
        shortcodes: [
            'horse_racing',
        ],
        tags: [
            'horse',
            'jockey',
            'racehorse',
            'racing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c7.png',
    },
    {
        emoji: '⛷',
        name: 'skier',
        shortcodes: [
            'person_skiing',
            'skier',
            'skiing',
        ],
        tags: [
            'ski',
            'snow',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f7-fe0f.png',
    },
    {
        emoji: '🏂',
        name: 'snowboarder',
        shortcodes: [
            'person_snowboarding',
            'snowboarder',
            'snowboarding',
        ],
        tags: [
            'ski',
            'snow',
            'snowboard',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c2.png',
    },
    {
        emoji: '🏌',
        name: 'golfing',
        shortcodes: [
            'golfer',
            'golfing',
            'person_golfing',
        ],
        tags: [
            'ball',
            'golf',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f.png',
    },
    {
        emoji: '🏌‍♂️',
        name: 'golfing_man',
        shortcodes: [
            'man_golfing',
        ],
        tags: [
            'golf',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f-200d-2642-fe0f.png',
    },
    {
        emoji: '🏌‍♀️',
        name: 'golfing_woman',
        shortcodes: [
            'woman_golfing',
        ],
        tags: [
            'golf',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f-200d-2640-fe0f.png',
    },
    {
        emoji: '🏄',
        name: 'surfer',
        shortcodes: [
            'person_surfing',
            'surfer',
            'surfing',
        ],
        tags: [
            'surfing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4.png',
    },
    {
        emoji: '🏄‍♂',
        name: 'surfing_man',
        shortcodes: [
            'man_surfing',
        ],
        tags: [
            'man',
            'surfing',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4-200d-2642-fe0f.png',
    },
    {
        emoji: '🏄‍♀',
        name: 'surfing_woman',
        shortcodes: [
            'woman_surfing',
        ],
        tags: [
            'surfing',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4-200d-2640-fe0f.png',
    },
    {
        emoji: '🚣',
        name: 'rowboat',
        shortcodes: [
            'person_rowing_boat',
            'rowboat',
        ],
        tags: [
            'boat',
            'rowboat',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3.png',
    },
    {
        emoji: '🚣‍♂',
        name: 'rowing_man',
        shortcodes: [
            'man_rowing_boat',
        ],
        tags: [
            'boat',
            'man',
            'rowboat',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3-200d-2642-fe0f.png',
    },
    {
        emoji: '🚣‍♀',
        name: 'rowing_woman',
        shortcodes: [
            'woman_rowing_boat',
        ],
        tags: [
            'boat',
            'rowboat',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3-200d-2640-fe0f.png',
    },
    {
        emoji: '🏊',
        name: 'swimmer',
        shortcodes: [
            'person_swimming',
            'swimmer',
            'swimming',
        ],
        tags: [
            'swim',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca.png',
    },
    {
        emoji: '🏊‍♂',
        name: 'swimming_man',
        shortcodes: [
            'man_swimming',
        ],
        tags: [
            'man',
            'swim',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca-200d-2642-fe0f.png',
    },
    {
        emoji: '🏊‍♀',
        name: 'swimming_woman',
        shortcodes: [
            'woman_swimming',
        ],
        tags: [
            'swim',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca-200d-2640-fe0f.png',
    },
    {
        emoji: '⛹',
        name: 'bouncing_ball_person',
        shortcodes: [
            'person_bouncing_ball',
        ],
        tags: [
            'ball',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f.png',
    },
    {
        emoji: '⛹‍♂️',
        name: 'basketball_man',
        shortcodes: [
            'man_bouncing_ball',
        ],
        tags: [
            'ball',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f-200d-2642-fe0f.png',
    },
    {
        emoji: '⛹‍♀️',
        name: 'basketball_woman',
        shortcodes: [
            'woman_bouncing_ball',
        ],
        tags: [
            'ball',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f-200d-2640-fe0f.png',
    },
    {
        emoji: '🏋',
        name: 'weight_lifting',
        shortcodes: [
            'person_lifting_weights',
            'weight_lifter',
            'weight_lifting',
        ],
        tags: [
            'lifter',
            'weight',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f.png',
    },
    {
        emoji: '🏋‍♂️',
        name: 'weight_lifting_man',
        shortcodes: [
            'man_lifting_weights',
        ],
        tags: [
            'man',
            'weight lifter',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f-200d-2642-fe0f.png',
    },
    {
        emoji: '🏋‍♀️',
        name: 'weight_lifting_woman',
        shortcodes: [
            'woman_lifting_weights',
        ],
        tags: [
            'weight lifter',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f-200d-2640-fe0f.png',
    },
    {
        emoji: '🚴',
        name: 'bicyclist',
        shortcodes: [
            'bicyclist',
            'biking',
            'person_biking',
        ],
        tags: [
            'bicycle',
            'biking',
            'cyclist',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4.png',
    },
    {
        emoji: '🚴‍♂',
        name: 'biking_man',
        shortcodes: [
            'man_biking',
        ],
        tags: [
            'bicycle',
            'biking',
            'cyclist',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4-200d-2642-fe0f.png',
    },
    {
        emoji: '🚴‍♀',
        name: 'biking_woman',
        shortcodes: [
            'woman_biking',
        ],
        tags: [
            'bicycle',
            'biking',
            'cyclist',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4-200d-2640-fe0f.png',
    },
    {
        emoji: '🚵',
        name: 'mountain_bicyclist',
        shortcodes: [
            'mountain_bicyclist',
            'mountain_biking',
            'person_mountain_biking',
        ],
        tags: [
            'bicycle',
            'bicyclist',
            'bike',
            'cyclist',
            'mountain',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5.png',
    },
    {
        emoji: '🚵‍♂',
        name: 'mountain_biking_man',
        shortcodes: [
            'man_mountain_biking',
        ],
        tags: [
            'bicycle',
            'bike',
            'cyclist',
            'man',
            'mountain',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5-200d-2642-fe0f.png',
    },
    {
        emoji: '🚵‍♀',
        name: 'mountain_biking_woman',
        shortcodes: [
            'woman_mountain_biking',
        ],
        tags: [
            'bicycle',
            'bike',
            'biking',
            'cyclist',
            'mountain',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5-200d-2640-fe0f.png',
    },
    {
        emoji: '🤸',
        name: 'cartwheeling',
        shortcodes: [
            'cartwheeling',
            'person_cartwheel',
        ],
        tags: [
            'cartwheel',
            'gymnastics',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938.png',
    },
    {
        emoji: '🤸‍♂',
        name: 'man_cartwheeling',
        shortcodes: [
            'man_cartwheeling',
        ],
        tags: [
            'cartwheel',
            'gymnastics',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938-200d-2642-fe0f.png',
    },
    {
        emoji: '🤸‍♀',
        name: 'woman_cartwheeling',
        shortcodes: [
            'woman_cartwheeling',
        ],
        tags: [
            'cartwheel',
            'gymnastics',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938-200d-2640-fe0f.png',
    },
    {
        emoji: '🤼',
        name: 'wrestling',
        shortcodes: [
            'people_wrestling',
            'wrestlers',
            'wrestling',
        ],
        tags: [
            'wrestle',
            'wrestler',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c.png',
    },
    {
        emoji: '🤼‍♂',
        name: 'men_wrestling',
        shortcodes: [
            'men_wrestling',
        ],
        tags: [
            'men',
            'wrestle',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c-200d-2642-fe0f.png',
    },
    {
        emoji: '🤼‍♀',
        name: 'women_wrestling',
        shortcodes: [
            'women_wrestling',
        ],
        tags: [
            'women',
            'wrestle',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c-200d-2640-fe0f.png',
    },
    {
        emoji: '🤽',
        name: 'water_polo',
        shortcodes: [
            'person_playing_water_polo',
            'water_polo',
        ],
        tags: [
            'polo',
            'water',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d.png',
    },
    {
        emoji: '🤽‍♂',
        name: 'man_playing_water_polo',
        shortcodes: [
            'man_playing_water_polo',
        ],
        tags: [
            'man',
            'water polo',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d-200d-2642-fe0f.png',
    },
    {
        emoji: '🤽‍♀',
        name: 'woman_playing_water_polo',
        shortcodes: [
            'woman_playing_water_polo',
        ],
        tags: [
            'water polo',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d-200d-2640-fe0f.png',
    },
    {
        emoji: '🤾',
        name: 'handball_person',
        shortcodes: [
            'handball',
            'person_playing_handball',
        ],
        tags: [
            'ball',
            'handball',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e.png',
    },
    {
        emoji: '🤾‍♂',
        name: 'man_playing_handball',
        shortcodes: [
            'man_playing_handball',
        ],
        tags: [
            'handball',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e-200d-2642-fe0f.png',
    },
    {
        emoji: '🤾‍♀',
        name: 'woman_playing_handball',
        shortcodes: [
            'woman_playing_handball',
        ],
        tags: [
            'handball',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e-200d-2640-fe0f.png',
    },
    {
        emoji: '🤹',
        name: 'juggling_person',
        shortcodes: [
            'juggler',
            'juggling',
            'person_juggling',
        ],
        tags: [
            'balance',
            'juggle',
            'multitask',
            'skill',
        ],
        group: 'people & body',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939.png',
    },
    {
        emoji: '🤹‍♂',
        name: 'man_juggling',
        shortcodes: [
            'man_juggling',
        ],
        tags: [
            'juggling',
            'man',
            'multitask',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939-200d-2642-fe0f.png',
    },
    {
        emoji: '🤹‍♀',
        name: 'woman_juggling',
        shortcodes: [
            'woman_juggling',
        ],
        tags: [
            'juggling',
            'multitask',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939-200d-2640-fe0f.png',
    },
    {
        emoji: '🧘',
        name: 'lotus_position',
        shortcodes: [
            'person_in_lotus_position',
        ],
        tags: [
            'meditation',
            'yoga',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8.png',
    },
    {
        emoji: '🧘‍♂',
        name: 'lotus_position_man',
        shortcodes: [
            'man_in_lotus_position',
        ],
        tags: [
            'meditation',
            'yoga',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8-200d-2642-fe0f.png',
    },
    {
        emoji: '🧘‍♀',
        name: 'lotus_position_woman',
        shortcodes: [
            'woman_in_lotus_position',
        ],
        tags: [
            'meditation',
            'yoga',
        ],
        group: 'people & body',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8-200d-2640-fe0f.png',
    },
    {
        emoji: '🛀',
        name: 'bath',
        shortcodes: [
            'bath',
            'person_taking_bath',
        ],
        tags: [
            'bath',
            'bathtub',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c0.png',
    },
    {
        emoji: '🛌',
        name: 'sleeping_bed',
        shortcodes: [
            'person_in_bed',
            'sleeping_accommodation',
        ],
        tags: [
            'good night',
            'hotel',
            'sleep',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cc.png',
    },
    {
        emoji: '🧑‍🤝‍🧑',
        name: 'people_holding_hands',
        shortcodes: [
            'people_holding_hands',
        ],
        tags: [
            'couple',
            'hand',
            'hold',
            'holding hands',
            'person',
        ],
        group: 'people & body',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f91d-200d-1f9d1.png',
    },
    {
        emoji: '👭',
        name: 'two_women_holding_hands',
        shortcodes: [
            'two_women_holding_hands',
        ],
        tags: [
            'couple',
            'hand',
            'holding hands',
            'women',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46d.png',
    },
    {
        emoji: '👫',
        name: 'couple',
        shortcodes: [
            'couple',
        ],
        tags: [
            'couple',
            'hand',
            'hold',
            'holding hands',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46b.png',
    },
    {
        emoji: '👬',
        name: 'two_men_holding_hands',
        shortcodes: [
            'two_men_holding_hands',
        ],
        tags: [
            'couple',
            'gemini',
            'holding hands',
            'man',
            'men',
            'twins',
            'zodiac',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46c.png',
    },
    {
        emoji: '💏',
        name: 'couplekiss',
        shortcodes: [
            'couple_kiss',
            'couplekiss',
        ],
        tags: [
            'couple',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48f.png',
    },
    {
        emoji: '👩‍❤‍💋‍👨',
        name: 'couplekiss_man_woman',
        shortcodes: [
            'kiss_mw',
            'kiss_wm',
        ],
        tags: [
            'couple',
            'kiss',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f48b-200d-1f468.png',
    },
    {
        emoji: '👨‍❤‍💋‍👨',
        name: 'couplekiss_man_man',
        shortcodes: [
            'kiss_mm',
        ],
        tags: [
            'couple',
            'kiss',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2764-fe0f-200d-1f48b-200d-1f468.png',
    },
    {
        emoji: '👩‍❤‍💋‍👩',
        name: 'couplekiss_woman_woman',
        shortcodes: [
            'kiss_ww',
        ],
        tags: [
            'couple',
            'kiss',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f48b-200d-1f469.png',
    },
    {
        emoji: '💑',
        name: 'couple_with_heart',
        shortcodes: [
            'couple_with_heart',
        ],
        tags: [
            'couple',
            'love',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f491.png',
    },
    {
        emoji: '👩‍❤‍👨',
        name: 'couple_with_heart_woman_man',
        shortcodes: [
            'couple_with_heart_mw',
            'couple_with_heart_wm',
        ],
        tags: [
            'couple',
            'couple with heart',
            'love',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f468.png',
    },
    {
        emoji: '👨‍❤‍👨',
        name: 'couple_with_heart_man_man',
        shortcodes: [
            'couple_with_heart_mm',
        ],
        tags: [
            'couple',
            'couple with heart',
            'love',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2764-fe0f-200d-1f468.png',
    },
    {
        emoji: '👩‍❤‍👩',
        name: 'couple_with_heart_woman_woman',
        shortcodes: [
            'couple_with_heart_ww',
        ],
        tags: [
            'couple',
            'couple with heart',
            'love',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f469.png',
    },
    {
        emoji: '👪',
        name: 'family',
        shortcodes: [
            'family',
        ],
        tags: [
            'family',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46a.png',
    },
    {
        emoji: '👨‍👩‍👦',
        name: 'family_man_woman_boy',
        shortcodes: [
            'family_mwb',
        ],
        tags: [
            'boy',
            'family',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f466.png',
    },
    {
        emoji: '👨‍👩‍👧',
        name: 'family_man_woman_girl',
        shortcodes: [
            'family_mwg',
        ],
        tags: [
            'family',
            'girl',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467.png',
    },
    {
        emoji: '👨‍👩‍👧‍👦',
        name: 'family_man_woman_girl_boy',
        shortcodes: [
            'family_mwgb',
        ],
        tags: [
            'boy',
            'family',
            'girl',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467-200d-1f466.png',
    },
    {
        emoji: '👨‍👩‍👦‍👦',
        name: 'family_man_woman_boy_boy',
        shortcodes: [
            'family_mwbb',
        ],
        tags: [
            'boy',
            'family',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f466-200d-1f466.png',
    },
    {
        emoji: '👨‍👩‍👧‍👧',
        name: 'family_man_woman_girl_girl',
        shortcodes: [
            'family_mwgg',
        ],
        tags: [
            'family',
            'girl',
            'man',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467-200d-1f467.png',
    },
    {
        emoji: '👨‍👨‍👦',
        name: 'family_man_man_boy',
        shortcodes: [
            'family_mmb',
        ],
        tags: [
            'boy',
            'family',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f466.png',
    },
    {
        emoji: '👨‍👨‍👧',
        name: 'family_man_man_girl',
        shortcodes: [
            'family_mmg',
        ],
        tags: [
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467.png',
    },
    {
        emoji: '👨‍👨‍👧‍👦',
        name: 'family_man_man_girl_boy',
        shortcodes: [
            'family_mmgb',
        ],
        tags: [
            'boy',
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467-200d-1f466.png',
    },
    {
        emoji: '👨‍👨‍👦‍👦',
        name: 'family_man_man_boy_boy',
        shortcodes: [
            'family_mmbb',
        ],
        tags: [
            'boy',
            'family',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f466-200d-1f466.png',
    },
    {
        emoji: '👨‍👨‍👧‍👧',
        name: 'family_man_man_girl_girl',
        shortcodes: [
            'family_mmgg',
        ],
        tags: [
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467-200d-1f467.png',
    },
    {
        emoji: '👩‍👩‍👦',
        name: 'family_woman_woman_boy',
        shortcodes: [
            'family_wwb',
        ],
        tags: [
            'boy',
            'family',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f466.png',
    },
    {
        emoji: '👩‍👩‍👧',
        name: 'family_woman_woman_girl',
        shortcodes: [
            'family_wwg',
        ],
        tags: [
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467.png',
    },
    {
        emoji: '👩‍👩‍👧‍👦',
        name: 'family_woman_woman_girl_boy',
        shortcodes: [
            'family_wwgb',
        ],
        tags: [
            'boy',
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467-200d-1f466.png',
    },
    {
        emoji: '👩‍👩‍👦‍👦',
        name: 'family_woman_woman_boy_boy',
        shortcodes: [
            'family_wwbb',
        ],
        tags: [
            'boy',
            'family',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f466-200d-1f466.png',
    },
    {
        emoji: '👩‍👩‍👧‍👧',
        name: 'family_woman_woman_girl_girl',
        shortcodes: [
            'family_wwgg',
        ],
        tags: [
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467-200d-1f467.png',
    },
    {
        emoji: '👨‍👦',
        name: 'family_man_boy',
        shortcodes: [
            'family_mb',
        ],
        tags: [
            'boy',
            'family',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f466.png',
    },
    {
        emoji: '👨‍👦‍👦',
        name: 'family_man_boy_boy',
        shortcodes: [
            'family_mbb',
        ],
        tags: [
            'boy',
            'family',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f466-200d-1f466.png',
    },
    {
        emoji: '👨‍👧',
        name: 'family_man_girl',
        shortcodes: [
            'family_mg',
        ],
        tags: [
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467.png',
    },
    {
        emoji: '👨‍👧‍👦',
        name: 'family_man_girl_boy',
        shortcodes: [
            'family_mgb',
        ],
        tags: [
            'boy',
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467-200d-1f466.png',
    },
    {
        emoji: '👨‍👧‍👧',
        name: 'family_man_girl_girl',
        shortcodes: [
            'family_mgg',
        ],
        tags: [
            'family',
            'girl',
            'man',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467-200d-1f467.png',
    },
    {
        emoji: '👩‍👦',
        name: 'family_woman_boy',
        shortcodes: [
            'family_wb',
        ],
        tags: [
            'boy',
            'family',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f466.png',
    },
    {
        emoji: '👩‍👦‍👦',
        name: 'family_woman_boy_boy',
        shortcodes: [
            'family_wbb',
        ],
        tags: [
            'boy',
            'family',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f466-200d-1f466.png',
    },
    {
        emoji: '👩‍👧',
        name: 'family_woman_girl',
        shortcodes: [
            'family_wg',
        ],
        tags: [
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467.png',
    },
    {
        emoji: '👩‍👧‍👦',
        name: 'family_woman_girl_boy',
        shortcodes: [
            'family_wgb',
        ],
        tags: [
            'boy',
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467-200d-1f466.png',
    },
    {
        emoji: '👩‍👧‍👧',
        name: 'family_woman_girl_girl',
        shortcodes: [
            'family_wgg',
        ],
        tags: [
            'family',
            'girl',
            'woman',
        ],
        group: 'people & body',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467-200d-1f467.png',
    },
    {
        emoji: '🗣',
        name: 'speaking_head',
        shortcodes: [
            'speaking_head',
        ],
        tags: [
            'face',
            'head',
            'silhouette',
            'speak',
            'speaking',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e3-fe0f.png',
    },
    {
        emoji: '👤',
        name: 'bust_in_silhouette',
        shortcodes: [
            'bust_in_silhouette',
        ],
        tags: [
            'bust',
            'silhouette',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f464.png',
    },
    {
        emoji: '👥',
        name: 'busts_in_silhouette',
        shortcodes: [
            'busts_in_silhouette',
        ],
        tags: [
            'bust',
            'silhouette',
        ],
        group: 'people & body',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f465.png',
    },
    {
        emoji: '🫂',
        name: 'people_hugging',
        shortcodes: [
            'people_hugging',
        ],
        tags: [
            'goodbye',
            'hello',
            'hug',
            'thanks',
        ],
        group: 'people & body',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac2.png',
    },
    {
        emoji: '👣',
        name: 'footprints',
        shortcodes: [
            'footprints',
        ],
        tags: [
            'clothing',
            'footprint',
            'print',
        ],
        group: 'people & body',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f463.png',
    },
    {
        emoji: '🏻',
        name: 'tone1',
        shortcodes: [
            'tone1',
            'tone_light',
        ],
        tags: [
            'skin tone',
            'type 1–2',
        ],
        group: 'components',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fb.png',
    },
    {
        emoji: '🏼',
        name: 'tone2',
        shortcodes: [
            'tone2',
            'tone_medium_light',
        ],
        tags: [
            'skin tone',
            'type 3',
        ],
        group: 'components',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fc.png',
    },
    {
        emoji: '🏽',
        name: 'tone3',
        shortcodes: [
            'tone3',
            'tone_medium',
        ],
        tags: [
            'skin tone',
            'type 4',
        ],
        group: 'components',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fd.png',
    },
    {
        emoji: '🏾',
        name: 'tone4',
        shortcodes: [
            'tone4',
            'tone_medium_dark',
        ],
        tags: [
            'skin tone',
            'type 5',
        ],
        group: 'components',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fe.png',
    },
    {
        emoji: '🏿',
        name: 'tone5',
        shortcodes: [
            'tone5',
            'tone_dark',
        ],
        tags: [
            'skin tone',
            'type 6',
        ],
        group: 'components',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ff.png',
    },
    {
        emoji: '🦰',
        name: 'red_hair',
        shortcodes: [
            'red_hair',
        ],
        tags: [
            'ginger',
            'redhead',
        ],
        group: 'components',
        emoticons: [],
        version: 11,
    },
    {
        emoji: '🦱',
        name: 'curly_hair',
        shortcodes: [
            'curly_hair',
        ],
        tags: [
            'afro',
            'curly',
            'ringlets',
        ],
        group: 'components',
        emoticons: [],
        version: 11,
    },
    {
        emoji: '🦳',
        name: 'white_hair',
        shortcodes: [
            'white_hair',
        ],
        tags: [
            'gray',
            'hair',
            'old',
            'white',
        ],
        group: 'components',
        emoticons: [],
        version: 11,
    },
    {
        emoji: '🦲',
        name: 'no_hair',
        shortcodes: [
            'no_hair',
        ],
        tags: [
            'chemotherapy',
            'hairless',
            'no hair',
            'shaven',
        ],
        group: 'components',
        emoticons: [],
        version: 11,
    },
    {
        emoji: '🐵',
        name: 'monkey_face',
        shortcodes: [
            'monkey_face',
        ],
        tags: [
            'face',
            'monkey',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f435.png',
    },
    {
        emoji: '🐒',
        name: 'monkey',
        shortcodes: [
            'monkey',
        ],
        tags: [
            'monkey',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f412.png',
    },
    {
        emoji: '🦍',
        name: 'gorilla',
        shortcodes: [
            'gorilla',
        ],
        tags: [
            'gorilla',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98d.png',
    },
    {
        emoji: '🦧',
        name: 'orangutan',
        shortcodes: [
            'orangutan',
        ],
        tags: [
            'ape',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a7.png',
    },
    {
        emoji: '🐶',
        name: 'dog',
        shortcodes: [
            'dog_face',
        ],
        tags: [
            'dog',
            'face',
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f436.png',
    },
    {
        emoji: '🐕',
        name: 'dog2',
        shortcodes: [
            'dog',
        ],
        tags: [
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f415.png',
    },
    {
        emoji: '🦮',
        name: 'guide_dog',
        shortcodes: [
            'guide_dog',
        ],
        tags: [
            'accessibility',
            'blind',
            'guide',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ae.png',
    },
    {
        emoji: '🐕‍🦺',
        name: 'service_dog',
        shortcodes: [
            'service_dog',
        ],
        tags: [
            'accessibility',
            'assistance',
            'dog',
            'service',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f415-200d-1f9ba.png',
    },
    {
        emoji: '🐩',
        name: 'poodle',
        shortcodes: [
            'poodle',
        ],
        tags: [
            'dog',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f429.png',
    },
    {
        emoji: '🐺',
        name: 'wolf',
        shortcodes: [
            'wolf',
            'wolf_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43a.png',
    },
    {
        emoji: '🦊',
        name: 'fox_face',
        shortcodes: [
            'fox',
            'fox_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98a.png',
    },
    {
        emoji: '🦝',
        name: 'raccoon',
        shortcodes: [
            'raccoon',
        ],
        tags: [
            'curious',
            'sly',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99d.png',
    },
    {
        emoji: '🐱',
        name: 'cat',
        shortcodes: [
            'cat_face',
        ],
        tags: [
            'cat',
            'face',
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f431.png',
    },
    {
        emoji: '🐈',
        name: 'cat2',
        shortcodes: [
            'cat',
        ],
        tags: [
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f408.png',
    },
    {
        emoji: '🐈‍⬛',
        name: 'black_cat',
        shortcodes: [
            'black_cat',
        ],
        tags: [
            'black',
            'cat',
            'unlucky',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f408-200d-2b1b.png',
    },
    {
        emoji: '🦁',
        name: 'lion',
        shortcodes: [
            'lion',
            'lion_face',
        ],
        tags: [
            'face',
            'leo',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f981.png',
    },
    {
        emoji: '🐯',
        name: 'tiger',
        shortcodes: [
            'tiger_face',
        ],
        tags: [
            'face',
            'tiger',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42f.png',
    },
    {
        emoji: '🐅',
        name: 'tiger2',
        shortcodes: [
            'tiger',
        ],
        tags: [
            'tiger',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f405.png',
    },
    {
        emoji: '🐆',
        name: 'leopard',
        shortcodes: [
            'leopard',
        ],
        tags: [
            'leopard',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f406.png',
    },
    {
        emoji: '🐴',
        name: 'horse',
        shortcodes: [
            'horse_face',
        ],
        tags: [
            'face',
            'horse',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f434.png',
    },
    {
        emoji: '🐎',
        name: 'racehorse',
        shortcodes: [
            'horse',
            'racehorse',
        ],
        tags: [
            'equestrian',
            'racehorse',
            'racing',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40e.png',
    },
    {
        emoji: '🦄',
        name: 'unicorn',
        shortcodes: [
            'unicorn',
            'unicorn_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f984.png',
    },
    {
        emoji: '🦓',
        name: 'zebra',
        shortcodes: [
            'zebra',
        ],
        tags: [
            'stripe',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f993.png',
    },
    {
        emoji: '🦌',
        name: 'deer',
        shortcodes: [
            'deer',
        ],
        tags: [
            'deer',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98c.png',
    },
    {
        emoji: '🦬',
        name: 'bison',
        shortcodes: [
            'bison',
        ],
        tags: [
            'buffalo',
            'herd',
            'wisent',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ac.png',
    },
    {
        emoji: '🐮',
        name: 'cow',
        shortcodes: [
            'cow_face',
        ],
        tags: [
            'cow',
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42e.png',
    },
    {
        emoji: '🐂',
        name: 'ox',
        shortcodes: [
            'ox',
        ],
        tags: [
            'bull',
            'taurus',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f402.png',
    },
    {
        emoji: '🐃',
        name: 'water_buffalo',
        shortcodes: [
            'water_buffalo',
        ],
        tags: [
            'buffalo',
            'water',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f403.png',
    },
    {
        emoji: '🐄',
        name: 'cow2',
        shortcodes: [
            'cow',
        ],
        tags: [
            'cow',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f404.png',
    },
    {
        emoji: '🐷',
        name: 'pig',
        shortcodes: [
            'pig_face',
        ],
        tags: [
            'face',
            'pig',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f437.png',
    },
    {
        emoji: '🐖',
        name: 'pig2',
        shortcodes: [
            'pig',
        ],
        tags: [
            'sow',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f416.png',
    },
    {
        emoji: '🐗',
        name: 'boar',
        shortcodes: [
            'boar',
        ],
        tags: [
            'pig',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f417.png',
    },
    {
        emoji: '🐽',
        name: 'pig_nose',
        shortcodes: [
            'pig_nose',
        ],
        tags: [
            'face',
            'nose',
            'pig',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43d.png',
    },
    {
        emoji: '🐏',
        name: 'ram',
        shortcodes: [
            'ram',
        ],
        tags: [
            'aries',
            'male',
            'sheep',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40f.png',
    },
    {
        emoji: '🐑',
        name: 'sheep',
        shortcodes: [
            'ewe',
            'sheep',
        ],
        tags: [
            'female',
            'sheep',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f411.png',
    },
    {
        emoji: '🐐',
        name: 'goat',
        shortcodes: [
            'goat',
        ],
        tags: [
            'capricorn',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f410.png',
    },
    {
        emoji: '🐪',
        name: 'dromedary_camel',
        shortcodes: [
            'dromedary_camel',
        ],
        tags: [
            'dromedary',
            'hump',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42a.png',
    },
    {
        emoji: '🐫',
        name: 'camel',
        shortcodes: [
            'camel',
        ],
        tags: [
            'bactrian',
            'camel',
            'hump',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42b.png',
    },
    {
        emoji: '🦙',
        name: 'llama',
        shortcodes: [
            'llama',
        ],
        tags: [
            'alpaca',
            'guanaco',
            'vicuña',
            'wool',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f999.png',
    },
    {
        emoji: '🦒',
        name: 'giraffe',
        shortcodes: [
            'giraffe',
        ],
        tags: [
            'spots',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f992.png',
    },
    {
        emoji: '🐘',
        name: 'elephant',
        shortcodes: [
            'elephant',
        ],
        tags: [
            'elephant',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f418.png',
    },
    {
        emoji: '🦣',
        name: 'mammoth',
        shortcodes: [
            'mammoth',
        ],
        tags: [
            'extinction',
            'large',
            'tusk',
            'woolly',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a3.png',
    },
    {
        emoji: '🦏',
        name: 'rhinoceros',
        shortcodes: [
            'rhino',
            'rhinoceros',
        ],
        tags: [
            'rhinoceros',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98f.png',
    },
    {
        emoji: '🦛',
        name: 'hippopotamus',
        shortcodes: [
            'hippo',
        ],
        tags: [
            'hippo',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99b.png',
    },
    {
        emoji: '🐭',
        name: 'mouse',
        shortcodes: [
            'mouse_face',
        ],
        tags: [
            'face',
            'mouse',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42d.png',
    },
    {
        emoji: '🐁',
        name: 'mouse2',
        shortcodes: [
            'mouse',
        ],
        tags: [
            'mouse',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f401.png',
    },
    {
        emoji: '🐀',
        name: 'rat',
        shortcodes: [
            'rat',
        ],
        tags: [
            'rat',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f400.png',
    },
    {
        emoji: '🐹',
        name: 'hamster',
        shortcodes: [
            'hamster',
            'hamster_face',
        ],
        tags: [
            'face',
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f439.png',
    },
    {
        emoji: '🐰',
        name: 'rabbit',
        shortcodes: [
            'rabbit_face',
        ],
        tags: [
            'bunny',
            'face',
            'pet',
            'rabbit',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f430.png',
    },
    {
        emoji: '🐇',
        name: 'rabbit2',
        shortcodes: [
            'rabbit',
        ],
        tags: [
            'bunny',
            'pet',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f407.png',
    },
    {
        emoji: '🐿',
        name: 'chipmunk',
        shortcodes: [
            'chipmunk',
        ],
        tags: [
            'squirrel',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43f-fe0f.png',
    },
    {
        emoji: '🦫',
        name: 'beaver',
        shortcodes: [
            'beaver',
        ],
        tags: [
            'dam',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ab.png',
    },
    {
        emoji: '🦔',
        name: 'hedgehog',
        shortcodes: [
            'hedgehog',
        ],
        tags: [
            'spiny',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f994.png',
    },
    {
        emoji: '🦇',
        name: 'bat',
        shortcodes: [
            'bat',
        ],
        tags: [
            'vampire',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f987.png',
    },
    {
        emoji: '🐻',
        name: 'bear',
        shortcodes: [
            'bear',
            'bear_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43b.png',
    },
    {
        emoji: '🐻‍❄',
        name: 'polar_bear',
        shortcodes: [
            'polar_bear',
            'polar_bear_face',
        ],
        tags: [
            'arctic',
            'bear',
            'white',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43b-200d-2744-fe0f.png',
    },
    {
        emoji: '🐨',
        name: 'koala',
        shortcodes: [
            'koala',
            'koala_face',
        ],
        tags: [
            'face',
            'marsupial',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f428.png',
    },
    {
        emoji: '🐼',
        name: 'panda_face',
        shortcodes: [
            'panda',
            'panda_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43c.png',
    },
    {
        emoji: '🦥',
        name: 'sloth',
        shortcodes: [
            'sloth',
        ],
        tags: [
            'lazy',
            'slow',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a5.png',
    },
    {
        emoji: '🦦',
        name: 'otter',
        shortcodes: [
            'otter',
        ],
        tags: [
            'fishing',
            'playful',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a6.png',
    },
    {
        emoji: '🦨',
        name: 'skunk',
        shortcodes: [
            'skunk',
        ],
        tags: [
            'stink',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a8.png',
    },
    {
        emoji: '🦘',
        name: 'kangaroo',
        shortcodes: [
            'kangaroo',
        ],
        tags: [
            'australia',
            'joey',
            'jump',
            'marsupial',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f998.png',
    },
    {
        emoji: '🦡',
        name: 'badger',
        shortcodes: [
            'badger',
        ],
        tags: [
            'honey badger',
            'pester',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a1.png',
    },
    {
        emoji: '🐾',
        name: 'feet',
        shortcodes: [
            'paw_prints',
        ],
        tags: [
            'feet',
            'paw',
            'print',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43e.png',
    },
    {
        emoji: '🦃',
        name: 'turkey',
        shortcodes: [
            'turkey',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f983.png',
    },
    {
        emoji: '🐔',
        name: 'chicken',
        shortcodes: [
            'chicken',
            'chicken_face',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f414.png',
    },
    {
        emoji: '🐓',
        name: 'rooster',
        shortcodes: [
            'rooster',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f413.png',
    },
    {
        emoji: '🐣',
        name: 'hatching_chick',
        shortcodes: [
            'hatching_chick',
        ],
        tags: [
            'baby',
            'bird',
            'chick',
            'hatching',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f423.png',
    },
    {
        emoji: '🐤',
        name: 'baby_chick',
        shortcodes: [
            'baby_chick',
        ],
        tags: [
            'baby',
            'bird',
            'chick',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f424.png',
    },
    {
        emoji: '🐥',
        name: 'hatched_chick',
        shortcodes: [
            'hatched_chick',
        ],
        tags: [
            'baby',
            'bird',
            'chick',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f425.png',
    },
    {
        emoji: '🐦',
        name: 'bird',
        shortcodes: [
            'bird',
            'bird_face',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f426.png',
    },
    {
        emoji: '🐧',
        name: 'penguin',
        shortcodes: [
            'penguin',
            'penguin_face',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f427.png',
    },
    {
        emoji: '🕊',
        name: 'dove',
        shortcodes: [
            'dove',
        ],
        tags: [
            'bird',
            'fly',
            'peace',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54a-fe0f.png',
    },
    {
        emoji: '🦅',
        name: 'eagle',
        shortcodes: [
            'eagle',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f985.png',
    },
    {
        emoji: '🦆',
        name: 'duck',
        shortcodes: [
            'duck',
        ],
        tags: [
            'bird',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f986.png',
    },
    {
        emoji: '🦢',
        name: 'swan',
        shortcodes: [
            'swan',
        ],
        tags: [
            'bird',
            'cygnet',
            'ugly duckling',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a2.png',
    },
    {
        emoji: '🦉',
        name: 'owl',
        shortcodes: [
            'owl',
        ],
        tags: [
            'bird',
            'wise',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f989.png',
    },
    {
        emoji: '🦤',
        name: 'dodo',
        shortcodes: [
            'dodo',
        ],
        tags: [
            'extinction',
            'large',
            'mauritius',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a4.png',
    },
    {
        emoji: '🪶',
        name: 'feather',
        shortcodes: [
            'feather',
        ],
        tags: [
            'bird',
            'flight',
            'light',
            'plumage',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab6.png',
    },
    {
        emoji: '🦩',
        name: 'flamingo',
        shortcodes: [
            'flamingo',
        ],
        tags: [
            'flamboyant',
            'tropical',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a9.png',
    },
    {
        emoji: '🦚',
        name: 'peacock',
        shortcodes: [
            'peacock',
        ],
        tags: [
            'bird',
            'ostentatious',
            'peahen',
            'proud',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99a.png',
    },
    {
        emoji: '🦜',
        name: 'parrot',
        shortcodes: [
            'parrot',
        ],
        tags: [
            'bird',
            'pirate',
            'talk',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99c.png',
    },
    {
        emoji: '🐸',
        name: 'frog',
        shortcodes: [
            'frog',
            'frog_face',
        ],
        tags: [
            'face',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f438.png',
    },
    {
        emoji: '🐊',
        name: 'crocodile',
        shortcodes: [
            'crocodile',
        ],
        tags: [
            'crocodile',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40a.png',
    },
    {
        emoji: '🐢',
        name: 'turtle',
        shortcodes: [
            'turtle',
        ],
        tags: [
            'terrapin',
            'tortoise',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f422.png',
    },
    {
        emoji: '🦎',
        name: 'lizard',
        shortcodes: [
            'lizard',
        ],
        tags: [
            'reptile',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98e.png',
    },
    {
        emoji: '🐍',
        name: 'snake',
        shortcodes: [
            'snake',
        ],
        tags: [
            'bearer',
            'ophiuchus',
            'serpent',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40d.png',
    },
    {
        emoji: '🐲',
        name: 'dragon_face',
        shortcodes: [
            'dragon_face',
        ],
        tags: [
            'dragon',
            'face',
            'fairy tale',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f432.png',
    },
    {
        emoji: '🐉',
        name: 'dragon',
        shortcodes: [
            'dragon',
        ],
        tags: [
            'fairy tale',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f409.png',
    },
    {
        emoji: '🦕',
        name: 'sauropod',
        shortcodes: [
            'sauropod',
        ],
        tags: [
            'brachiosaurus',
            'brontosaurus',
            'diplodocus',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f995.png',
    },
    {
        emoji: '🦖',
        name: 't-rex',
        shortcodes: [
            't-rex',
            'trex',
        ],
        tags: [
            't-rex',
            'tyrannosaurus rex',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f996.png',
    },
    {
        emoji: '🐳',
        name: 'whale',
        shortcodes: [
            'spouting_whale',
        ],
        tags: [
            'face',
            'spouting',
            'whale',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f433.png',
    },
    {
        emoji: '🐋',
        name: 'whale2',
        shortcodes: [
            'whale',
        ],
        tags: [
            'whale',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40b.png',
    },
    {
        emoji: '🐬',
        name: 'dolphin',
        shortcodes: [
            'dolphin',
        ],
        tags: [
            'flipper',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42c.png',
    },
    {
        emoji: '🦭',
        name: 'seal',
        shortcodes: [
            'seal',
        ],
        tags: [
            'sea lion',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ad.png',
    },
    {
        emoji: '🐟',
        name: 'fish',
        shortcodes: [
            'fish',
        ],
        tags: [
            'pisces',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41f.png',
    },
    {
        emoji: '🐠',
        name: 'tropical_fish',
        shortcodes: [
            'tropical_fish',
        ],
        tags: [
            'fish',
            'tropical',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f420.png',
    },
    {
        emoji: '🐡',
        name: 'blowfish',
        shortcodes: [
            'blowfish',
        ],
        tags: [
            'fish',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f421.png',
    },
    {
        emoji: '🦈',
        name: 'shark',
        shortcodes: [
            'shark',
        ],
        tags: [
            'fish',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f988.png',
    },
    {
        emoji: '🐙',
        name: 'octopus',
        shortcodes: [
            'octopus',
        ],
        tags: [
            'octopus',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f419.png',
    },
    {
        emoji: '🐚',
        name: 'shell',
        shortcodes: [
            'shell',
        ],
        tags: [
            'shell',
            'spiral',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41a.png',
    },
    {
        emoji: '🐌',
        name: 'snail',
        shortcodes: [
            'snail',
        ],
        tags: [
            'snail',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40c.png',
    },
    {
        emoji: '🦋',
        name: 'butterfly',
        shortcodes: [
            'butterfly',
        ],
        tags: [
            'insect',
            'pretty',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98b.png',
    },
    {
        emoji: '🐛',
        name: 'bug',
        shortcodes: [
            'bug',
        ],
        tags: [
            'insect',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41b.png',
    },
    {
        emoji: '🐜',
        name: 'ant',
        shortcodes: [
            'ant',
        ],
        tags: [
            'insect',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41c.png',
    },
    {
        emoji: '🐝',
        name: 'bee',
        shortcodes: [
            'bee',
        ],
        tags: [
            'bee',
            'insect',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41d.png',
    },
    {
        emoji: '🪲',
        name: 'beetle',
        shortcodes: [
            'beetle',
        ],
        tags: [
            'bug',
            'insect',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab2.png',
    },
    {
        emoji: '🐞',
        name: 'lady_beetle',
        shortcodes: [
            'lady_beetle',
        ],
        tags: [
            'beetle',
            'insect',
            'ladybird',
            'ladybug',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41e.png',
    },
    {
        emoji: '🦗',
        name: 'cricket',
        shortcodes: [
            'cricket',
        ],
        tags: [
            'grasshopper',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f997.png',
    },
    {
        emoji: '🪳',
        name: 'cockroach',
        shortcodes: [
            'cockroach',
        ],
        tags: [
            'insect',
            'pest',
            'roach',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab3.png',
    },
    {
        emoji: '🕷',
        name: 'spider',
        shortcodes: [
            'spider',
        ],
        tags: [
            'insect',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f577-fe0f.png',
    },
    {
        emoji: '🕸',
        name: 'spider_web',
        shortcodes: [
            'spider_web',
        ],
        tags: [
            'spider',
            'web',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f578-fe0f.png',
    },
    {
        emoji: '🦂',
        name: 'scorpion',
        shortcodes: [
            'scorpion',
        ],
        tags: [
            'scorpio',
            'zodiac',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f982.png',
    },
    {
        emoji: '🦟',
        name: 'mosquito',
        shortcodes: [
            'mosquito',
        ],
        tags: [
            'disease',
            'fever',
            'malaria',
            'pest',
            'virus',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99f.png',
    },
    {
        emoji: '🪰',
        name: 'fly',
        shortcodes: [
            'fly',
        ],
        tags: [
            'disease',
            'maggot',
            'pest',
            'rotting',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab0.png',
    },
    {
        emoji: '🪱',
        name: 'worm',
        shortcodes: [
            'worm',
        ],
        tags: [
            'annelid',
            'earthworm',
            'parasite',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab1.png',
    },
    {
        emoji: '🦠',
        name: 'microbe',
        shortcodes: [
            'microbe',
        ],
        tags: [
            'amoeba',
            'bacteria',
            'virus',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a0.png',
    },
    {
        emoji: '💐',
        name: 'bouquet',
        shortcodes: [
            'bouquet',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f490.png',
    },
    {
        emoji: '🌸',
        name: 'cherry_blossom',
        shortcodes: [
            'cherry_blossom',
        ],
        tags: [
            'blossom',
            'cherry',
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f338.png',
    },
    {
        emoji: '💮',
        name: 'white_flower',
        shortcodes: [
            'white_flower',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ae.png',
    },
    {
        emoji: '🏵',
        name: 'rosette',
        shortcodes: [
            'rosette',
        ],
        tags: [
            'plant',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f5-fe0f.png',
    },
    {
        emoji: '🌹',
        name: 'rose',
        shortcodes: [
            'rose',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f339.png',
    },
    {
        emoji: '🥀',
        name: 'wilted_flower',
        shortcodes: [
            'wilted_flower',
        ],
        tags: [
            'flower',
            'wilted',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f940.png',
    },
    {
        emoji: '🌺',
        name: 'hibiscus',
        shortcodes: [
            'hibiscus',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33a.png',
    },
    {
        emoji: '🌻',
        name: 'sunflower',
        shortcodes: [
            'sunflower',
        ],
        tags: [
            'flower',
            'sun',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33b.png',
    },
    {
        emoji: '🌼',
        name: 'blossom',
        shortcodes: [
            'blossom',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33c.png',
    },
    {
        emoji: '🌷',
        name: 'tulip',
        shortcodes: [
            'tulip',
        ],
        tags: [
            'flower',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f337.png',
    },
    {
        emoji: '🌱',
        name: 'seedling',
        shortcodes: [
            'seedling',
        ],
        tags: [
            'young',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f331.png',
    },
    {
        emoji: '🪴',
        name: 'potted_plant',
        shortcodes: [
            'potted_plant',
        ],
        tags: [
            'boring',
            'grow',
            'house',
            'nurturing',
            'plant',
            'useless',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab4.png',
    },
    {
        emoji: '🌲',
        name: 'evergreen_tree',
        shortcodes: [
            'evergreen_tree',
        ],
        tags: [
            'tree',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f332.png',
    },
    {
        emoji: '🌳',
        name: 'deciduous_tree',
        shortcodes: [
            'deciduous_tree',
        ],
        tags: [
            'deciduous',
            'shedding',
            'tree',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f333.png',
    },
    {
        emoji: '🌴',
        name: 'palm_tree',
        shortcodes: [
            'palm_tree',
        ],
        tags: [
            'palm',
            'tree',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f334.png',
    },
    {
        emoji: '🌵',
        name: 'cactus',
        shortcodes: [
            'cactus',
        ],
        tags: [
            'plant',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f335.png',
    },
    {
        emoji: '🌾',
        name: 'ear_of_rice',
        shortcodes: [
            'ear_of_rice',
            'sheaf_of_rice',
        ],
        tags: [
            'ear',
            'grain',
            'rice',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33e.png',
    },
    {
        emoji: '🌿',
        name: 'herb',
        shortcodes: [
            'herb',
        ],
        tags: [
            'leaf',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33f.png',
    },
    {
        emoji: '☘',
        name: 'shamrock',
        shortcodes: [
            'shamrock',
        ],
        tags: [
            'plant',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2618-fe0f.png',
    },
    {
        emoji: '🍀',
        name: 'four_leaf_clover',
        shortcodes: [
            'four_leaf_clover',
        ],
        tags: [
            '4',
            'clover',
            'four',
            'four-leaf clover',
            'leaf',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f340.png',
    },
    {
        emoji: '🍁',
        name: 'maple_leaf',
        shortcodes: [
            'maple_leaf',
        ],
        tags: [
            'falling',
            'leaf',
            'maple',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f341.png',
    },
    {
        emoji: '🍂',
        name: 'fallen_leaf',
        shortcodes: [
            'fallen_leaf',
        ],
        tags: [
            'falling',
            'leaf',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f342.png',
    },
    {
        emoji: '🍃',
        name: 'leaves',
        shortcodes: [
            'leaves',
        ],
        tags: [
            'blow',
            'flutter',
            'leaf',
            'wind',
        ],
        group: 'animals & nature',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f343.png',
    },
    {
        emoji: '🍇',
        name: 'grapes',
        shortcodes: [
            'grapes',
        ],
        tags: [
            'fruit',
            'grape',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f347.png',
    },
    {
        emoji: '🍈',
        name: 'melon',
        shortcodes: [
            'melon',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f348.png',
    },
    {
        emoji: '🍉',
        name: 'watermelon',
        shortcodes: [
            'watermelon',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f349.png',
    },
    {
        emoji: '🍊',
        name: 'mandarin',
        shortcodes: [
            'orange',
            'tangerine',
        ],
        tags: [
            'fruit',
            'orange',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34a.png',
    },
    {
        emoji: '🍋',
        name: 'lemon',
        shortcodes: [
            'lemon',
        ],
        tags: [
            'citrus',
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34b.png',
    },
    {
        emoji: '🍌',
        name: 'banana',
        shortcodes: [
            'banana',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34c.png',
    },
    {
        emoji: '🍍',
        name: 'pineapple',
        shortcodes: [
            'pineapple',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34d.png',
    },
    {
        emoji: '🥭',
        name: 'mango',
        shortcodes: [
            'mango',
        ],
        tags: [
            'fruit',
            'tropical',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96d.png',
    },
    {
        emoji: '🍎',
        name: 'apple',
        shortcodes: [
            'apple',
            'red_apple',
        ],
        tags: [
            'apple',
            'fruit',
            'red',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34e.png',
    },
    {
        emoji: '🍏',
        name: 'green_apple',
        shortcodes: [
            'green_apple',
        ],
        tags: [
            'apple',
            'fruit',
            'green',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34f.png',
    },
    {
        emoji: '🍐',
        name: 'pear',
        shortcodes: [
            'pear',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f350.png',
    },
    {
        emoji: '🍑',
        name: 'peach',
        shortcodes: [
            'peach',
        ],
        tags: [
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f351.png',
    },
    {
        emoji: '🍒',
        name: 'cherries',
        shortcodes: [
            'cherries',
        ],
        tags: [
            'berries',
            'cherry',
            'fruit',
            'red',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f352.png',
    },
    {
        emoji: '🍓',
        name: 'strawberry',
        shortcodes: [
            'strawberry',
        ],
        tags: [
            'berry',
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f353.png',
    },
    {
        emoji: '🫐',
        name: 'blueberries',
        shortcodes: [
            'blueberries',
        ],
        tags: [
            'berry',
            'bilberry',
            'blue',
            'blueberry',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad0.png',
    },
    {
        emoji: '🥝',
        name: 'kiwi_fruit',
        shortcodes: [
            'kiwi',
        ],
        tags: [
            'food',
            'fruit',
            'kiwi',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95d.png',
    },
    {
        emoji: '🍅',
        name: 'tomato',
        shortcodes: [
            'tomato',
        ],
        tags: [
            'fruit',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f345.png',
    },
    {
        emoji: '🫒',
        name: 'olive',
        shortcodes: [
            'olive',
        ],
        tags: [
            'food',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad2.png',
    },
    {
        emoji: '🥥',
        name: 'coconut',
        shortcodes: [
            'coconut',
        ],
        tags: [
            'palm',
            'piña colada',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f965.png',
    },
    {
        emoji: '🥑',
        name: 'avocado',
        shortcodes: [
            'avocado',
        ],
        tags: [
            'food',
            'fruit',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f951.png',
    },
    {
        emoji: '🍆',
        name: 'eggplant',
        shortcodes: [
            'eggplant',
        ],
        tags: [
            'aubergine',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f346.png',
    },
    {
        emoji: '🥔',
        name: 'potato',
        shortcodes: [
            'potato',
        ],
        tags: [
            'food',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f954.png',
    },
    {
        emoji: '🥕',
        name: 'carrot',
        shortcodes: [
            'carrot',
        ],
        tags: [
            'food',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f955.png',
    },
    {
        emoji: '🌽',
        name: 'corn',
        shortcodes: [
            'corn',
            'ear_of_corn',
        ],
        tags: [
            'corn',
            'ear',
            'maize',
            'maze',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33d.png',
    },
    {
        emoji: '🌶',
        name: 'hot_pepper',
        shortcodes: [
            'hot_pepper',
        ],
        tags: [
            'hot',
            'pepper',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f336-fe0f.png',
    },
    {
        emoji: '🫑',
        name: 'bell_pepper',
        shortcodes: [
            'bell_pepper',
        ],
        tags: [
            'capsicum',
            'pepper',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad1.png',
    },
    {
        emoji: '🥒',
        name: 'cucumber',
        shortcodes: [
            'cucumber',
        ],
        tags: [
            'food',
            'pickle',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f952.png',
    },
    {
        emoji: '🥬',
        name: 'leafy_green',
        shortcodes: [
            'leafy_green',
        ],
        tags: [
            'bok choy',
            'cabbage',
            'kale',
            'lettuce',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96c.png',
    },
    {
        emoji: '🥦',
        name: 'broccoli',
        shortcodes: [
            'broccoli',
        ],
        tags: [
            'wild cabbage',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f966.png',
    },
    {
        emoji: '🧄',
        name: 'garlic',
        shortcodes: [
            'garlic',
        ],
        tags: [
            'flavoring',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c4.png',
    },
    {
        emoji: '🧅',
        name: 'onion',
        shortcodes: [
            'onion',
        ],
        tags: [
            'flavoring',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c5.png',
    },
    {
        emoji: '🍄',
        name: 'mushroom',
        shortcodes: [
            'mushroom',
        ],
        tags: [
            'toadstool',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f344.png',
    },
    {
        emoji: '🥜',
        name: 'peanuts',
        shortcodes: [
            'peanuts',
        ],
        tags: [
            'food',
            'nut',
            'peanut',
            'vegetable',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95c.png',
    },
    {
        emoji: '🌰',
        name: 'chestnut',
        shortcodes: [
            'chestnut',
        ],
        tags: [
            'plant',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f330.png',
    },
    {
        emoji: '🍞',
        name: 'bread',
        shortcodes: [
            'bread',
        ],
        tags: [
            'loaf',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35e.png',
    },
    {
        emoji: '🥐',
        name: 'croissant',
        shortcodes: [
            'croissant',
        ],
        tags: [
            'bread',
            'breakfast',
            'food',
            'french',
            'roll',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f950.png',
    },
    {
        emoji: '🥖',
        name: 'baguette_bread',
        shortcodes: [
            'baguette_bread',
        ],
        tags: [
            'baguette',
            'bread',
            'food',
            'french',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f956.png',
    },
    {
        emoji: '🫓',
        name: 'flatbread',
        shortcodes: [
            'flatbread',
        ],
        tags: [
            'arepa',
            'lavash',
            'naan',
            'pita',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad3.png',
    },
    {
        emoji: '🥨',
        name: 'pretzel',
        shortcodes: [
            'pretzel',
        ],
        tags: [
            'twisted',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f968.png',
    },
    {
        emoji: '🥯',
        name: 'bagel',
        shortcodes: [
            'bagel',
        ],
        tags: [
            'bakery',
            'breakfast',
            'schmear',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96f.png',
    },
    {
        emoji: '🥞',
        name: 'pancakes',
        shortcodes: [
            'pancakes',
        ],
        tags: [
            'breakfast',
            'crêpe',
            'food',
            'hotcake',
            'pancake',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95e.png',
    },
    {
        emoji: '🧇',
        name: 'waffle',
        shortcodes: [
            'waffle',
        ],
        tags: [
            'breakfast',
            'indecisive',
            'iron',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c7.png',
    },
    {
        emoji: '🧀',
        name: 'cheese',
        shortcodes: [
            'cheese',
        ],
        tags: [
            'cheese',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c0.png',
    },
    {
        emoji: '🍖',
        name: 'meat_on_bone',
        shortcodes: [
            'meat_on_bone',
        ],
        tags: [
            'bone',
            'meat',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f356.png',
    },
    {
        emoji: '🍗',
        name: 'poultry_leg',
        shortcodes: [
            'poultry_leg',
        ],
        tags: [
            'bone',
            'chicken',
            'drumstick',
            'leg',
            'poultry',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f357.png',
    },
    {
        emoji: '🥩',
        name: 'cut_of_meat',
        shortcodes: [
            'cut_of_meat',
        ],
        tags: [
            'chop',
            'lambchop',
            'porkchop',
            'steak',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f969.png',
    },
    {
        emoji: '🥓',
        name: 'bacon',
        shortcodes: [
            'bacon',
        ],
        tags: [
            'breakfast',
            'food',
            'meat',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f953.png',
    },
    {
        emoji: '🍔',
        name: 'hamburger',
        shortcodes: [
            'hamburger',
        ],
        tags: [
            'burger',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f354.png',
    },
    {
        emoji: '🍟',
        name: 'fries',
        shortcodes: [
            'french_fries',
            'fries',
        ],
        tags: [
            'french',
            'fries',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35f.png',
    },
    {
        emoji: '🍕',
        name: 'pizza',
        shortcodes: [
            'pizza',
        ],
        tags: [
            'cheese',
            'slice',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f355.png',
    },
    {
        emoji: '🌭',
        name: 'hotdog',
        shortcodes: [
            'hotdog',
        ],
        tags: [
            'frankfurter',
            'hotdog',
            'sausage',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32d.png',
    },
    {
        emoji: '🥪',
        name: 'sandwich',
        shortcodes: [
            'sandwich',
        ],
        tags: [
            'bread',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96a.png',
    },
    {
        emoji: '🌮',
        name: 'taco',
        shortcodes: [
            'taco',
        ],
        tags: [
            'mexican',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32e.png',
    },
    {
        emoji: '🌯',
        name: 'burrito',
        shortcodes: [
            'burrito',
        ],
        tags: [
            'mexican',
            'wrap',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32f.png',
    },
    {
        emoji: '🫔',
        name: 'tamale',
        shortcodes: [
            'tamale',
        ],
        tags: [
            'mexican',
            'wrapped',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad4.png',
    },
    {
        emoji: '🥙',
        name: 'stuffed_flatbread',
        shortcodes: [
            'stuffed_flatbread',
        ],
        tags: [
            'falafel',
            'flatbread',
            'food',
            'gyro',
            'kebab',
            'stuffed',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f959.png',
    },
    {
        emoji: '🧆',
        name: 'falafel',
        shortcodes: [
            'falafel',
        ],
        tags: [
            'chickpea',
            'meatball',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c6.png',
    },
    {
        emoji: '🥚',
        name: 'egg',
        shortcodes: [
            'egg',
        ],
        tags: [
            'breakfast',
            'food',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95a.png',
    },
    {
        emoji: '🍳',
        name: 'fried_egg',
        shortcodes: [
            'cooking',
            'fried_egg',
        ],
        tags: [
            'breakfast',
            'egg',
            'frying',
            'pan',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f373.png',
    },
    {
        emoji: '🥘',
        name: 'shallow_pan_of_food',
        shortcodes: [
            'shallow_pan_of_food',
        ],
        tags: [
            'casserole',
            'food',
            'paella',
            'pan',
            'shallow',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f958.png',
    },
    {
        emoji: '🍲',
        name: 'stew',
        shortcodes: [
            'pot_of_food',
            'stew',
        ],
        tags: [
            'pot',
            'stew',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f372.png',
    },
    {
        emoji: '🫕',
        name: 'fondue',
        shortcodes: [
            'fondue',
        ],
        tags: [
            'cheese',
            'chocolate',
            'melted',
            'pot',
            'swiss',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad5.png',
    },
    {
        emoji: '🥣',
        name: 'bowl_with_spoon',
        shortcodes: [
            'bowl_with_spoon',
        ],
        tags: [
            'breakfast',
            'cereal',
            'congee',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f963.png',
    },
    {
        emoji: '🥗',
        name: 'green_salad',
        shortcodes: [
            'green_salad',
            'salad',
        ],
        tags: [
            'food',
            'green',
            'salad',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f957.png',
    },
    {
        emoji: '🍿',
        name: 'popcorn',
        shortcodes: [
            'popcorn',
        ],
        tags: [
            'popcorn',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37f.png',
    },
    {
        emoji: '🧈',
        name: 'butter',
        shortcodes: [
            'butter',
        ],
        tags: [
            'dairy',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c8.png',
    },
    {
        emoji: '🧂',
        name: 'salt',
        shortcodes: [
            'salt',
        ],
        tags: [
            'condiment',
            'shaker',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c2.png',
    },
    {
        emoji: '🥫',
        name: 'canned_food',
        shortcodes: [
            'canned_food',
        ],
        tags: [
            'can',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96b.png',
    },
    {
        emoji: '🍱',
        name: 'bento',
        shortcodes: [
            'bento',
            'bento_box',
        ],
        tags: [
            'bento',
            'box',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f371.png',
    },
    {
        emoji: '🍘',
        name: 'rice_cracker',
        shortcodes: [
            'rice_cracker',
        ],
        tags: [
            'cracker',
            'rice',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f358.png',
    },
    {
        emoji: '🍙',
        name: 'rice_ball',
        shortcodes: [
            'rice_ball',
        ],
        tags: [
            'ball',
            'japanese',
            'rice',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f359.png',
    },
    {
        emoji: '🍚',
        name: 'rice',
        shortcodes: [
            'cooked_rice',
            'rice',
        ],
        tags: [
            'cooked',
            'rice',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35a.png',
    },
    {
        emoji: '🍛',
        name: 'curry',
        shortcodes: [
            'curry',
            'curry_rice',
        ],
        tags: [
            'curry',
            'rice',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35b.png',
    },
    {
        emoji: '🍜',
        name: 'ramen',
        shortcodes: [
            'ramen',
            'steaming_bowl',
        ],
        tags: [
            'bowl',
            'noodle',
            'ramen',
            'steaming',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35c.png',
    },
    {
        emoji: '🍝',
        name: 'spaghetti',
        shortcodes: [
            'spaghetti',
        ],
        tags: [
            'pasta',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35d.png',
    },
    {
        emoji: '🍠',
        name: 'sweet_potato',
        shortcodes: [
            'sweet_potato',
        ],
        tags: [
            'potato',
            'roasted',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f360.png',
    },
    {
        emoji: '🍢',
        name: 'oden',
        shortcodes: [
            'oden',
        ],
        tags: [
            'kebab',
            'seafood',
            'skewer',
            'stick',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f362.png',
    },
    {
        emoji: '🍣',
        name: 'sushi',
        shortcodes: [
            'sushi',
        ],
        tags: [
            'sushi',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f363.png',
    },
    {
        emoji: '🍤',
        name: 'fried_shrimp',
        shortcodes: [
            'fried_shrimp',
        ],
        tags: [
            'fried',
            'prawn',
            'shrimp',
            'tempura',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f364.png',
    },
    {
        emoji: '🍥',
        name: 'fish_cake',
        shortcodes: [
            'fish_cake',
        ],
        tags: [
            'cake',
            'fish',
            'pastry',
            'swirl',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f365.png',
    },
    {
        emoji: '🥮',
        name: 'moon_cake',
        shortcodes: [
            'moon_cake',
        ],
        tags: [
            'autumn',
            'festival',
            'yuèbǐng',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96e.png',
    },
    {
        emoji: '🍡',
        name: 'dango',
        shortcodes: [
            'dango',
        ],
        tags: [
            'dessert',
            'japanese',
            'skewer',
            'stick',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f361.png',
    },
    {
        emoji: '🥟',
        name: 'dumpling',
        shortcodes: [
            'dumpling',
        ],
        tags: [
            'empanada',
            'gyōza',
            'jiaozi',
            'pierogi',
            'potsticker',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95f.png',
    },
    {
        emoji: '🥠',
        name: 'fortune_cookie',
        shortcodes: [
            'fortune_cookie',
        ],
        tags: [
            'prophecy',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f960.png',
    },
    {
        emoji: '🥡',
        name: 'takeout_box',
        shortcodes: [
            'takeout_box',
        ],
        tags: [
            'oyster pail',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f961.png',
    },
    {
        emoji: '🦀',
        name: 'crab',
        shortcodes: [
            'crab',
        ],
        tags: [
            'cancer',
            'zodiac',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f980.png',
    },
    {
        emoji: '🦞',
        name: 'lobster',
        shortcodes: [
            'lobster',
        ],
        tags: [
            'bisque',
            'claws',
            'seafood',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99e.png',
    },
    {
        emoji: '🦐',
        name: 'shrimp',
        shortcodes: [
            'shrimp',
        ],
        tags: [
            'food',
            'shellfish',
            'small',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f990.png',
    },
    {
        emoji: '🦑',
        name: 'squid',
        shortcodes: [
            'squid',
        ],
        tags: [
            'food',
            'molusc',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f991.png',
    },
    {
        emoji: '🦪',
        name: 'oyster',
        shortcodes: [
            'oyster',
        ],
        tags: [
            'diving',
            'pearl',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9aa.png',
    },
    {
        emoji: '🍦',
        name: 'icecream',
        shortcodes: [
            'icecream',
            'soft_serve',
        ],
        tags: [
            'cream',
            'dessert',
            'ice',
            'icecream',
            'soft',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f366.png',
    },
    {
        emoji: '🍧',
        name: 'shaved_ice',
        shortcodes: [
            'shaved_ice',
        ],
        tags: [
            'dessert',
            'ice',
            'shaved',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f367.png',
    },
    {
        emoji: '🍨',
        name: 'ice_cream',
        shortcodes: [
            'ice_cream',
        ],
        tags: [
            'cream',
            'dessert',
            'ice',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f368.png',
    },
    {
        emoji: '🍩',
        name: 'doughnut',
        shortcodes: [
            'doughnut',
        ],
        tags: [
            'breakfast',
            'dessert',
            'donut',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f369.png',
    },
    {
        emoji: '🍪',
        name: 'cookie',
        shortcodes: [
            'cookie',
        ],
        tags: [
            'dessert',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36a.png',
    },
    {
        emoji: '🎂',
        name: 'birthday',
        shortcodes: [
            'birthday',
            'birthday_cake',
        ],
        tags: [
            'birthday',
            'cake',
            'celebration',
            'dessert',
            'pastry',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f382.png',
    },
    {
        emoji: '🍰',
        name: 'cake',
        shortcodes: [
            'cake',
            'shortcake',
        ],
        tags: [
            'cake',
            'dessert',
            'pastry',
            'slice',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f370.png',
    },
    {
        emoji: '🧁',
        name: 'cupcake',
        shortcodes: [
            'cupcake',
        ],
        tags: [
            'bakery',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c1.png',
    },
    {
        emoji: '🥧',
        name: 'pie',
        shortcodes: [
            'pie',
        ],
        tags: [
            'filling',
            'pastry',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f967.png',
    },
    {
        emoji: '🍫',
        name: 'chocolate_bar',
        shortcodes: [
            'chocolate_bar',
        ],
        tags: [
            'bar',
            'chocolate',
            'dessert',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36b.png',
    },
    {
        emoji: '🍬',
        name: 'candy',
        shortcodes: [
            'candy',
        ],
        tags: [
            'dessert',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36c.png',
    },
    {
        emoji: '🍭',
        name: 'lollipop',
        shortcodes: [
            'lollipop',
        ],
        tags: [
            'candy',
            'dessert',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36d.png',
    },
    {
        emoji: '🍮',
        name: 'custard',
        shortcodes: [
            'custard',
        ],
        tags: [
            'dessert',
            'pudding',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36e.png',
    },
    {
        emoji: '🍯',
        name: 'honey_pot',
        shortcodes: [
            'honey_pot',
        ],
        tags: [
            'honey',
            'honeypot',
            'pot',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36f.png',
    },
    {
        emoji: '🍼',
        name: 'baby_bottle',
        shortcodes: [
            'baby_bottle',
        ],
        tags: [
            'baby',
            'bottle',
            'drink',
            'milk',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37c.png',
    },
    {
        emoji: '🥛',
        name: 'milk_glass',
        shortcodes: [
            'glass_of_milk',
            'milk',
        ],
        tags: [
            'drink',
            'glass',
            'milk',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95b.png',
    },
    {
        emoji: '☕',
        name: 'coffee',
        shortcodes: [
            'coffee',
        ],
        tags: [
            'beverage',
            'coffee',
            'drink',
            'hot',
            'steaming',
            'tea',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2615.png',
    },
    {
        emoji: '🫖',
        name: 'teapot',
        shortcodes: [
            'teapot',
        ],
        tags: [
            'drink',
            'pot',
            'tea',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad6.png',
    },
    {
        emoji: '🍵',
        name: 'tea',
        shortcodes: [
            'tea',
        ],
        tags: [
            'beverage',
            'cup',
            'drink',
            'tea',
            'teacup',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f375.png',
    },
    {
        emoji: '🍶',
        name: 'sake',
        shortcodes: [
            'sake',
        ],
        tags: [
            'bar',
            'beverage',
            'bottle',
            'cup',
            'drink',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f376.png',
    },
    {
        emoji: '🍾',
        name: 'champagne',
        shortcodes: [
            'champagne',
        ],
        tags: [
            'bar',
            'bottle',
            'cork',
            'drink',
            'popping',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37e.png',
    },
    {
        emoji: '🍷',
        name: 'wine_glass',
        shortcodes: [
            'wine_glass',
        ],
        tags: [
            'bar',
            'beverage',
            'drink',
            'glass',
            'wine',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f377.png',
    },
    {
        emoji: '🍸',
        name: 'cocktail',
        shortcodes: [
            'cocktail',
        ],
        tags: [
            'bar',
            'cocktail',
            'drink',
            'glass',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f378.png',
    },
    {
        emoji: '🍹',
        name: 'tropical_drink',
        shortcodes: [
            'tropical_drink',
        ],
        tags: [
            'bar',
            'drink',
            'tropical',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f379.png',
    },
    {
        emoji: '🍺',
        name: 'beer',
        shortcodes: [
            'beer',
        ],
        tags: [
            'bar',
            'beer',
            'drink',
            'mug',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37a.png',
    },
    {
        emoji: '🍻',
        name: 'beers',
        shortcodes: [
            'beers',
        ],
        tags: [
            'bar',
            'beer',
            'clink',
            'drink',
            'mug',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37b.png',
    },
    {
        emoji: '🥂',
        name: 'clinking_glasses',
        shortcodes: [
            'clinking_glasses',
        ],
        tags: [
            'celebrate',
            'clink',
            'drink',
            'glass',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f942.png',
    },
    {
        emoji: '🥃',
        name: 'tumbler_glass',
        shortcodes: [
            'tumbler_glass',
            'whisky',
        ],
        tags: [
            'glass',
            'liquor',
            'shot',
            'tumbler',
            'whisky',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f943.png',
    },
    {
        emoji: '🥤',
        name: 'cup_with_straw',
        shortcodes: [
            'cup_with_straw',
        ],
        tags: [
            'juice',
            'soda',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f964.png',
    },
    {
        emoji: '🧋',
        name: 'bubble_tea',
        shortcodes: [
            'boba_drink',
            'bubble_tea',
        ],
        tags: [
            'bubble',
            'milk',
            'pearl',
            'tea',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cb.png',
    },
    {
        emoji: '🧃',
        name: 'beverage_box',
        shortcodes: [
            'beverage_box',
            'juice_box',
        ],
        tags: [
            'beverage',
            'box',
            'juice',
            'straw',
            'sweet',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c3.png',
    },
    {
        emoji: '🧉',
        name: 'mate',
        shortcodes: [
            'mate',
        ],
        tags: [
            'drink',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c9.png',
    },
    {
        emoji: '🧊',
        name: 'ice_cube',
        shortcodes: [
            'ice',
            'ice_cube',
        ],
        tags: [
            'cold',
            'ice cube',
            'iceberg',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ca.png',
    },
    {
        emoji: '🥢',
        name: 'chopsticks',
        shortcodes: [
            'chopsticks',
        ],
        tags: [
            'hashi',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f962.png',
    },
    {
        emoji: '🍽',
        name: 'plate_with_cutlery',
        shortcodes: [
            'fork_knife_plate',
        ],
        tags: [
            'cooking',
            'fork',
            'knife',
            'plate',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37d-fe0f.png',
    },
    {
        emoji: '🍴',
        name: 'fork_and_knife',
        shortcodes: [
            'fork_and_knife',
        ],
        tags: [
            'cooking',
            'cutlery',
            'fork',
            'knife',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f374.png',
    },
    {
        emoji: '🥄',
        name: 'spoon',
        shortcodes: [
            'spoon',
        ],
        tags: [
            'tableware',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f944.png',
    },
    {
        emoji: '🔪',
        name: 'hocho',
        shortcodes: [
            'knife',
        ],
        tags: [
            'cooking',
            'hocho',
            'knife',
            'tool',
            'weapon',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52a.png',
    },
    {
        emoji: '🏺',
        name: 'amphora',
        shortcodes: [
            'amphora',
        ],
        tags: [
            'aquarius',
            'cooking',
            'drink',
            'jug',
            'zodiac',
        ],
        group: 'food & drink',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fa.png',
    },
    {
        emoji: '🌍',
        name: 'earth_africa',
        shortcodes: [
            'earth_africa',
            'earth_europe',
        ],
        tags: [
            'africa',
            'earth',
            'europe',
            'globe',
            'globe showing europe-africa',
            'world',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30d.png',
    },
    {
        emoji: '🌎',
        name: 'earth_americas',
        shortcodes: [
            'earth_americas',
        ],
        tags: [
            'americas',
            'earth',
            'globe',
            'globe showing americas',
            'world',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30e.png',
    },
    {
        emoji: '🌏',
        name: 'earth_asia',
        shortcodes: [
            'earth_asia',
        ],
        tags: [
            'asia',
            'australia',
            'earth',
            'globe',
            'globe showing asia-australia',
            'world',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30f.png',
    },
    {
        emoji: '🌐',
        name: 'globe_with_meridians',
        shortcodes: [
            'globe_with_meridians',
        ],
        tags: [
            'earth',
            'globe',
            'meridians',
            'world',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f310.png',
    },
    {
        emoji: '🗺',
        name: 'world_map',
        shortcodes: [
            'world_map',
        ],
        tags: [
            'map',
            'world',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fa-fe0f.png',
    },
    {
        emoji: '🗾',
        name: 'japan',
        shortcodes: [
            'japan_map',
        ],
        tags: [
            'japan',
            'map',
            'map of japan',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fe.png',
    },
    {
        emoji: '🧭',
        name: 'compass',
        shortcodes: [
            'compass',
        ],
        tags: [
            'magnetic',
            'navigation',
            'orienteering',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ed.png',
    },
    {
        emoji: '🏔',
        name: 'mountain_snow',
        shortcodes: [
            'mountain_snow',
        ],
        tags: [
            'cold',
            'mountain',
            'snow',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d4-fe0f.png',
    },
    {
        emoji: '⛰',
        name: 'mountain',
        shortcodes: [
            'mountain',
        ],
        tags: [
            'mountain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f0-fe0f.png',
    },
    {
        emoji: '🌋',
        name: 'volcano',
        shortcodes: [
            'volcano',
        ],
        tags: [
            'eruption',
            'mountain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30b.png',
    },
    {
        emoji: '🗻',
        name: 'mount_fuji',
        shortcodes: [
            'mount_fuji',
        ],
        tags: [
            'fuji',
            'mountain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fb.png',
    },
    {
        emoji: '🏕',
        name: 'camping',
        shortcodes: [
            'camping',
        ],
        tags: [
            'camping',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d5-fe0f.png',
    },
    {
        emoji: '🏖',
        name: 'beach_umbrella',
        shortcodes: [
            'beach',
            'beach_with_umbrella',
        ],
        tags: [
            'beach',
            'umbrella',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d6-fe0f.png',
    },
    {
        emoji: '🏜',
        name: 'desert',
        shortcodes: [
            'desert',
        ],
        tags: [
            'desert',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3dc-fe0f.png',
    },
    {
        emoji: '🏝',
        name: 'desert_island',
        shortcodes: [
            'desert_island',
            'island',
        ],
        tags: [
            'desert',
            'island',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3dd-fe0f.png',
    },
    {
        emoji: '🏞',
        name: 'national_park',
        shortcodes: [
            'national_park',
        ],
        tags: [
            'park',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3de-fe0f.png',
    },
    {
        emoji: '🏟',
        name: 'stadium',
        shortcodes: [
            'stadium',
        ],
        tags: [
            'stadium',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3df-fe0f.png',
    },
    {
        emoji: '🏛',
        name: 'classical_building',
        shortcodes: [
            'classical_building',
        ],
        tags: [
            'classical',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3db-fe0f.png',
    },
    {
        emoji: '🏗',
        name: 'building_construction',
        shortcodes: [
            'building_construction',
            'construction_site',
        ],
        tags: [
            'construction',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d7-fe0f.png',
    },
    {
        emoji: '🧱',
        name: 'bricks',
        shortcodes: [
            'bricks',
        ],
        tags: [
            'bricks',
            'clay',
            'mortar',
            'wall',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f1.png',
    },
    {
        emoji: '🪨',
        name: 'rock',
        shortcodes: [
            'rock',
        ],
        tags: [
            'boulder',
            'heavy',
            'solid',
            'stone',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa8.png',
    },
    {
        emoji: '🪵',
        name: 'wood',
        shortcodes: [
            'wood',
        ],
        tags: [
            'log',
            'lumber',
            'timber',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab5.png',
    },
    {
        emoji: '🛖',
        name: 'hut',
        shortcodes: [
            'hut',
        ],
        tags: [
            'house',
            'roundhouse',
            'yurt',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d6.png',
    },
    {
        emoji: '🏘',
        name: 'houses',
        shortcodes: [
            'homes',
            'houses',
        ],
        tags: [
            'houses',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d8-fe0f.png',
    },
    {
        emoji: '🏚',
        name: 'derelict_house',
        shortcodes: [
            'derelict_house',
            'house_abandoned',
        ],
        tags: [
            'derelict',
            'house',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3da-fe0f.png',
    },
    {
        emoji: '🏠',
        name: 'house',
        shortcodes: [
            'house',
        ],
        tags: [
            'home',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e0.png',
    },
    {
        emoji: '🏡',
        name: 'house_with_garden',
        shortcodes: [
            'house_with_garden',
        ],
        tags: [
            'garden',
            'home',
            'house',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e1.png',
    },
    {
        emoji: '🏢',
        name: 'office',
        shortcodes: [
            'office',
        ],
        tags: [
            'building',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e2.png',
    },
    {
        emoji: '🏣',
        name: 'post_office',
        shortcodes: [
            'post_office',
        ],
        tags: [
            'japanese',
            'japanese post office',
            'post',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e3.png',
    },
    {
        emoji: '🏤',
        name: 'european_post_office',
        shortcodes: [
            'european_post_office',
        ],
        tags: [
            'european',
            'post',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e4.png',
    },
    {
        emoji: '🏥',
        name: 'hospital',
        shortcodes: [
            'hospital',
        ],
        tags: [
            'doctor',
            'medicine',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e5.png',
    },
    {
        emoji: '🏦',
        name: 'bank',
        shortcodes: [
            'bank',
        ],
        tags: [
            'building',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e6.png',
    },
    {
        emoji: '🏨',
        name: 'hotel',
        shortcodes: [
            'hotel',
        ],
        tags: [
            'building',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e8.png',
    },
    {
        emoji: '🏩',
        name: 'love_hotel',
        shortcodes: [
            'love_hotel',
        ],
        tags: [
            'hotel',
            'love',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e9.png',
    },
    {
        emoji: '🏪',
        name: 'convenience_store',
        shortcodes: [
            'convenience_store',
        ],
        tags: [
            'convenience',
            'store',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ea.png',
    },
    {
        emoji: '🏫',
        name: 'school',
        shortcodes: [
            'school',
        ],
        tags: [
            'building',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3eb.png',
    },
    {
        emoji: '🏬',
        name: 'department_store',
        shortcodes: [
            'department_store',
        ],
        tags: [
            'department',
            'store',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ec.png',
    },
    {
        emoji: '🏭',
        name: 'factory',
        shortcodes: [
            'factory',
        ],
        tags: [
            'building',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ed.png',
    },
    {
        emoji: '🏯',
        name: 'japanese_castle',
        shortcodes: [
            'japanese_castle',
        ],
        tags: [
            'castle',
            'japanese',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ef.png',
    },
    {
        emoji: '🏰',
        name: 'european_castle',
        shortcodes: [
            'castle',
            'european_castle',
        ],
        tags: [
            'european',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f0.png',
    },
    {
        emoji: '💒',
        name: 'wedding',
        shortcodes: [
            'wedding',
        ],
        tags: [
            'chapel',
            'romance',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f492.png',
    },
    {
        emoji: '🗼',
        name: 'tokyo_tower',
        shortcodes: [
            'tokyo_tower',
        ],
        tags: [
            'tokyo',
            'tower',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fc.png',
    },
    {
        emoji: '🗽',
        name: 'statue_of_liberty',
        shortcodes: [
            'statue_of_liberty',
        ],
        tags: [
            'liberty',
            'statue',
            'statue of liberty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fd.png',
    },
    {
        emoji: '⛪',
        name: 'church',
        shortcodes: [
            'church',
        ],
        tags: [
            'christian',
            'cross',
            'religion',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ea.png',
    },
    {
        emoji: '🕌',
        name: 'mosque',
        shortcodes: [
            'mosque',
        ],
        tags: [
            'islam',
            'muslim',
            'religion',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54c.png',
    },
    {
        emoji: '🛕',
        name: 'hindu_temple',
        shortcodes: [
            'hindu_temple',
        ],
        tags: [
            'hindu',
            'temple',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d5.png',
    },
    {
        emoji: '🕍',
        name: 'synagogue',
        shortcodes: [
            'synagogue',
        ],
        tags: [
            'jew',
            'jewish',
            'religion',
            'temple',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54d.png',
    },
    {
        emoji: '⛩',
        name: 'shinto_shrine',
        shortcodes: [
            'shinto_shrine',
        ],
        tags: [
            'religion',
            'shinto',
            'shrine',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26e9-fe0f.png',
    },
    {
        emoji: '🕋',
        name: 'kaaba',
        shortcodes: [
            'kaaba',
        ],
        tags: [
            'islam',
            'muslim',
            'religion',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54b.png',
    },
    {
        emoji: '⛲',
        name: 'fountain',
        shortcodes: [
            'fountain',
        ],
        tags: [
            'fountain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f2.png',
    },
    {
        emoji: '⛺',
        name: 'tent',
        shortcodes: [
            'tent',
        ],
        tags: [
            'camping',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26fa.png',
    },
    {
        emoji: '🌁',
        name: 'foggy',
        shortcodes: [
            'foggy',
        ],
        tags: [
            'fog',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f301.png',
    },
    {
        emoji: '🌃',
        name: 'night_with_stars',
        shortcodes: [
            'night_with_stars',
        ],
        tags: [
            'night',
            'star',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f303.png',
    },
    {
        emoji: '🏙',
        name: 'cityscape',
        shortcodes: [
            'cityscape',
        ],
        tags: [
            'city',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d9-fe0f.png',
    },
    {
        emoji: '🌄',
        name: 'sunrise_over_mountains',
        shortcodes: [
            'sunrise_over_mountains',
        ],
        tags: [
            'morning',
            'mountain',
            'sun',
            'sunrise',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f304.png',
    },
    {
        emoji: '🌅',
        name: 'sunrise',
        shortcodes: [
            'sunrise',
        ],
        tags: [
            'morning',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f305.png',
    },
    {
        emoji: '🌆',
        name: 'city_sunset',
        shortcodes: [
            'city_dusk',
        ],
        tags: [
            'city',
            'dusk',
            'evening',
            'landscape',
            'sunset',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f306.png',
    },
    {
        emoji: '🌇',
        name: 'city_sunrise',
        shortcodes: [
            'city_sunrise',
            'city_sunset',
        ],
        tags: [
            'dusk',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f307.png',
    },
    {
        emoji: '🌉',
        name: 'bridge_at_night',
        shortcodes: [
            'bridge_at_night',
        ],
        tags: [
            'bridge',
            'night',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f309.png',
    },
    {
        emoji: '♨',
        name: 'hotsprings',
        shortcodes: [
            'hotsprings',
        ],
        tags: [
            'hot',
            'hotsprings',
            'springs',
            'steaming',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2668-fe0f.png',
    },
    {
        emoji: '🎠',
        name: 'carousel_horse',
        shortcodes: [
            'carousel_horse',
        ],
        tags: [
            'carousel',
            'horse',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a0.png',
    },
    {
        emoji: '🎡',
        name: 'ferris_wheel',
        shortcodes: [
            'ferris_wheel',
        ],
        tags: [
            'amusement park',
            'ferris',
            'wheel',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a1.png',
    },
    {
        emoji: '🎢',
        name: 'roller_coaster',
        shortcodes: [
            'roller_coaster',
        ],
        tags: [
            'amusement park',
            'coaster',
            'roller',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a2.png',
    },
    {
        emoji: '💈',
        name: 'barber',
        shortcodes: [
            'barber',
            'barber_pole',
        ],
        tags: [
            'barber',
            'haircut',
            'pole',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f488.png',
    },
    {
        emoji: '🎪',
        name: 'circus_tent',
        shortcodes: [
            'circus_tent',
        ],
        tags: [
            'circus',
            'tent',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3aa.png',
    },
    {
        emoji: '🚂',
        name: 'steam_locomotive',
        shortcodes: [
            'steam_locomotive',
        ],
        tags: [
            'engine',
            'railway',
            'steam',
            'train',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f682.png',
    },
    {
        emoji: '🚃',
        name: 'railway_car',
        shortcodes: [
            'railway_car',
        ],
        tags: [
            'car',
            'electric',
            'railway',
            'train',
            'tram',
            'trolleybus',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f683.png',
    },
    {
        emoji: '🚄',
        name: 'bullettrain_side',
        shortcodes: [
            'bullettrain_side',
        ],
        tags: [
            'railway',
            'shinkansen',
            'speed',
            'train',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f684.png',
    },
    {
        emoji: '🚅',
        name: 'bullettrain_front',
        shortcodes: [
            'bullettrain_front',
        ],
        tags: [
            'bullet',
            'railway',
            'shinkansen',
            'speed',
            'train',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f685.png',
    },
    {
        emoji: '🚆',
        name: 'train2',
        shortcodes: [
            'train',
        ],
        tags: [
            'railway',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f686.png',
    },
    {
        emoji: '🚇',
        name: 'metro',
        shortcodes: [
            'metro',
        ],
        tags: [
            'subway',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f687.png',
    },
    {
        emoji: '🚈',
        name: 'light_rail',
        shortcodes: [
            'light_rail',
        ],
        tags: [
            'railway',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f688.png',
    },
    {
        emoji: '🚉',
        name: 'station',
        shortcodes: [
            'station',
        ],
        tags: [
            'railway',
            'train',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f689.png',
    },
    {
        emoji: '🚊',
        name: 'tram',
        shortcodes: [
            'tram',
        ],
        tags: [
            'trolleybus',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68a.png',
    },
    {
        emoji: '🚝',
        name: 'monorail',
        shortcodes: [
            'monorail',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69d.png',
    },
    {
        emoji: '🚞',
        name: 'mountain_railway',
        shortcodes: [
            'mountain_railway',
        ],
        tags: [
            'car',
            'mountain',
            'railway',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69e.png',
    },
    {
        emoji: '🚋',
        name: 'train',
        shortcodes: [
            'tram_car',
        ],
        tags: [
            'car',
            'tram',
            'trolleybus',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68b.png',
    },
    {
        emoji: '🚌',
        name: 'bus',
        shortcodes: [
            'bus',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68c.png',
    },
    {
        emoji: '🚍',
        name: 'oncoming_bus',
        shortcodes: [
            'oncoming_bus',
        ],
        tags: [
            'bus',
            'oncoming',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68d.png',
    },
    {
        emoji: '🚎',
        name: 'trolleybus',
        shortcodes: [
            'trolleybus',
        ],
        tags: [
            'bus',
            'tram',
            'trolley',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68e.png',
    },
    {
        emoji: '🚐',
        name: 'minibus',
        shortcodes: [
            'minibus',
        ],
        tags: [
            'bus',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f690.png',
    },
    {
        emoji: '🚑',
        name: 'ambulance',
        shortcodes: [
            'ambulance',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f691.png',
    },
    {
        emoji: '🚒',
        name: 'fire_engine',
        shortcodes: [
            'fire_engine',
        ],
        tags: [
            'engine',
            'fire',
            'truck',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f692.png',
    },
    {
        emoji: '🚓',
        name: 'police_car',
        shortcodes: [
            'police_car',
        ],
        tags: [
            'car',
            'patrol',
            'police',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f693.png',
    },
    {
        emoji: '🚔',
        name: 'oncoming_police_car',
        shortcodes: [
            'oncoming_police_car',
        ],
        tags: [
            'car',
            'oncoming',
            'police',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f694.png',
    },
    {
        emoji: '🚕',
        name: 'taxi',
        shortcodes: [
            'taxi',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f695.png',
    },
    {
        emoji: '🚖',
        name: 'oncoming_taxi',
        shortcodes: [
            'oncoming_taxi',
        ],
        tags: [
            'oncoming',
            'taxi',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f696.png',
    },
    {
        emoji: '🚗',
        name: 'car',
        shortcodes: [
            'car',
            'red_car',
        ],
        tags: [
            'car',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f697.png',
    },
    {
        emoji: '🚘',
        name: 'oncoming_automobile',
        shortcodes: [
            'oncoming_automobile',
        ],
        tags: [
            'automobile',
            'car',
            'oncoming',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f698.png',
    },
    {
        emoji: '🚙',
        name: 'blue_car',
        shortcodes: [
            'blue_car',
            'suv',
        ],
        tags: [
            'recreational',
            'sport utility',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f699.png',
    },
    {
        emoji: '🛻',
        name: 'pickup_truck',
        shortcodes: [
            'pickup_truck',
        ],
        tags: [
            'pick-up',
            'pickup',
            'truck',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fb.png',
    },
    {
        emoji: '🚚',
        name: 'truck',
        shortcodes: [
            'delivery_truck',
            'truck',
        ],
        tags: [
            'delivery',
            'truck',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69a.png',
    },
    {
        emoji: '🚛',
        name: 'articulated_lorry',
        shortcodes: [
            'articulated_lorry',
        ],
        tags: [
            'lorry',
            'semi',
            'truck',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69b.png',
    },
    {
        emoji: '🚜',
        name: 'tractor',
        shortcodes: [
            'tractor',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69c.png',
    },
    {
        emoji: '🏎',
        name: 'racing_car',
        shortcodes: [
            'racing_car',
        ],
        tags: [
            'car',
            'racing',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ce-fe0f.png',
    },
    {
        emoji: '🏍',
        name: 'motorcycle',
        shortcodes: [
            'motorcycle',
        ],
        tags: [
            'racing',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cd-fe0f.png',
    },
    {
        emoji: '🛵',
        name: 'motor_scooter',
        shortcodes: [
            'motor_scooter',
        ],
        tags: [
            'motor',
            'scooter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f5.png',
    },
    {
        emoji: '🦽',
        name: 'manual_wheelchair',
        shortcodes: [
            'manual_wheelchair',
        ],
        tags: [
            'accessibility',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bd.png',
    },
    {
        emoji: '🦼',
        name: 'motorized_wheelchair',
        shortcodes: [
            'motorized_wheelchair',
        ],
        tags: [
            'accessibility',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bc.png',
    },
    {
        emoji: '🛺',
        name: 'auto_rickshaw',
        shortcodes: [
            'auto_rickshaw',
        ],
        tags: [
            'tuk tuk',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fa.png',
    },
    {
        emoji: '🚲',
        name: 'bike',
        shortcodes: [
            'bicycle',
            'bike',
        ],
        tags: [
            'bike',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b2.png',
    },
    {
        emoji: '🛴',
        name: 'kick_scooter',
        shortcodes: [
            'scooter',
        ],
        tags: [
            'kick',
            'scooter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f4.png',
    },
    {
        emoji: '🛹',
        name: 'skateboard',
        shortcodes: [
            'skateboard',
        ],
        tags: [
            'board',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f9.png',
    },
    {
        emoji: '🛼',
        name: 'roller_skate',
        shortcodes: [
            'roller_skate',
        ],
        tags: [
            'roller',
            'skate',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fc.png',
    },
    {
        emoji: '🚏',
        name: 'busstop',
        shortcodes: [
            'busstop',
        ],
        tags: [
            'bus',
            'stop',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68f.png',
    },
    {
        emoji: '🛣',
        name: 'motorway',
        shortcodes: [
            'motorway',
        ],
        tags: [
            'highway',
            'road',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e3-fe0f.png',
    },
    {
        emoji: '🛤',
        name: 'railway_track',
        shortcodes: [
            'railway_track',
        ],
        tags: [
            'railway',
            'train',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e4-fe0f.png',
    },
    {
        emoji: '🛢',
        name: 'oil_drum',
        shortcodes: [
            'oil_drum',
        ],
        tags: [
            'drum',
            'oil',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e2-fe0f.png',
    },
    {
        emoji: '⛽',
        name: 'fuelpump',
        shortcodes: [
            'fuelpump',
        ],
        tags: [
            'diesel',
            'fuel',
            'fuelpump',
            'gas',
            'pump',
            'station',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26fd.png',
    },
    {
        emoji: '🚨',
        name: 'rotating_light',
        shortcodes: [
            'rotating_light',
        ],
        tags: [
            'beacon',
            'car',
            'light',
            'police',
            'revolving',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a8.png',
    },
    {
        emoji: '🚥',
        name: 'traffic_light',
        shortcodes: [
            'traffic_light',
        ],
        tags: [
            'light',
            'signal',
            'traffic',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a5.png',
    },
    {
        emoji: '🚦',
        name: 'vertical_traffic_light',
        shortcodes: [
            'vertical_traffic_light',
        ],
        tags: [
            'light',
            'signal',
            'traffic',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a6.png',
    },
    {
        emoji: '🛑',
        name: 'stop_sign',
        shortcodes: [
            'octagonal_sign',
            'stop_sign',
        ],
        tags: [
            'octagonal',
            'sign',
            'stop',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d1.png',
    },
    {
        emoji: '🚧',
        name: 'construction',
        shortcodes: [
            'construction',
        ],
        tags: [
            'barrier',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a7.png',
    },
    {
        emoji: '⚓',
        name: 'anchor',
        shortcodes: [
            'anchor',
        ],
        tags: [
            'ship',
            'tool',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2693.png',
    },
    {
        emoji: '⛵',
        name: 'boat',
        shortcodes: [
            'sailboat',
        ],
        tags: [
            'boat',
            'resort',
            'sea',
            'yacht',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f5.png',
    },
    {
        emoji: '🛶',
        name: 'canoe',
        shortcodes: [
            'canoe',
        ],
        tags: [
            'boat',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f6.png',
    },
    {
        emoji: '🚤',
        name: 'speedboat',
        shortcodes: [
            'speedboat',
        ],
        tags: [
            'boat',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a4.png',
    },
    {
        emoji: '🛳',
        name: 'passenger_ship',
        shortcodes: [
            'cruise_ship',
            'passenger_ship',
        ],
        tags: [
            'passenger',
            'ship',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f3-fe0f.png',
    },
    {
        emoji: '⛴',
        name: 'ferry',
        shortcodes: [
            'ferry',
        ],
        tags: [
            'boat',
            'passenger',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f4-fe0f.png',
    },
    {
        emoji: '🛥',
        name: 'motor_boat',
        shortcodes: [
            'motorboat',
        ],
        tags: [
            'boat',
            'motorboat',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e5-fe0f.png',
    },
    {
        emoji: '🚢',
        name: 'ship',
        shortcodes: [
            'ship',
        ],
        tags: [
            'boat',
            'passenger',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a2.png',
    },
    {
        emoji: '✈',
        name: 'airplane',
        shortcodes: [
            'airplane',
        ],
        tags: [
            'aeroplane',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2708-fe0f.png',
    },
    {
        emoji: '🛩',
        name: 'small_airplane',
        shortcodes: [
            'small_airplane',
        ],
        tags: [
            'aeroplane',
            'airplane',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e9-fe0f.png',
    },
    {
        emoji: '🛫',
        name: 'flight_departure',
        shortcodes: [
            'airplane_departure',
        ],
        tags: [
            'aeroplane',
            'airplane',
            'check-in',
            'departure',
            'departures',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6eb.png',
    },
    {
        emoji: '🛬',
        name: 'flight_arrival',
        shortcodes: [
            'airplane_arriving',
        ],
        tags: [
            'aeroplane',
            'airplane',
            'arrivals',
            'arriving',
            'landing',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ec.png',
    },
    {
        emoji: '🪂',
        name: 'parachute',
        shortcodes: [
            'parachute',
        ],
        tags: [
            'hang-glide',
            'parasail',
            'skydive',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa82.png',
    },
    {
        emoji: '💺',
        name: 'seat',
        shortcodes: [
            'seat',
        ],
        tags: [
            'chair',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ba.png',
    },
    {
        emoji: '🚁',
        name: 'helicopter',
        shortcodes: [
            'helicopter',
        ],
        tags: [
            'vehicle',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f681.png',
    },
    {
        emoji: '🚟',
        name: 'suspension_railway',
        shortcodes: [
            'suspension_railway',
        ],
        tags: [
            'railway',
            'suspension',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69f.png',
    },
    {
        emoji: '🚠',
        name: 'mountain_cableway',
        shortcodes: [
            'mountain_cableway',
        ],
        tags: [
            'cable',
            'gondola',
            'mountain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a0.png',
    },
    {
        emoji: '🚡',
        name: 'aerial_tramway',
        shortcodes: [
            'aerial_tramway',
        ],
        tags: [
            'aerial',
            'cable',
            'car',
            'gondola',
            'tramway',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a1.png',
    },
    {
        emoji: '🛰',
        name: 'artificial_satellite',
        shortcodes: [
            'satellite',
        ],
        tags: [
            'space',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f0-fe0f.png',
    },
    {
        emoji: '🚀',
        name: 'rocket',
        shortcodes: [
            'rocket',
        ],
        tags: [
            'space',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f680.png',
    },
    {
        emoji: '🛸',
        name: 'flying_saucer',
        shortcodes: [
            'flying_saucer',
        ],
        tags: [
            'ufo',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f8.png',
    },
    {
        emoji: '🛎',
        name: 'bellhop_bell',
        shortcodes: [
            'bellhop',
        ],
        tags: [
            'bell',
            'bellhop',
            'hotel',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ce-fe0f.png',
    },
    {
        emoji: '🧳',
        name: 'luggage',
        shortcodes: [
            'luggage',
        ],
        tags: [
            'packing',
            'travel',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f3.png',
    },
    {
        emoji: '⌛',
        name: 'hourglass',
        shortcodes: [
            'hourglass',
        ],
        tags: [
            'sand',
            'timer',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/231b.png',
    },
    {
        emoji: '⏳',
        name: 'hourglass_flowing_sand',
        shortcodes: [
            'hourglass_flowing_sand',
        ],
        tags: [
            'hourglass',
            'sand',
            'timer',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f3.png',
    },
    {
        emoji: '⌚',
        name: 'watch',
        shortcodes: [
            'watch',
        ],
        tags: [
            'clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/231a.png',
    },
    {
        emoji: '⏰',
        name: 'alarm_clock',
        shortcodes: [
            'alarm_clock',
        ],
        tags: [
            'alarm',
            'clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f0.png',
    },
    {
        emoji: '⏱',
        name: 'stopwatch',
        shortcodes: [
            'stopwatch',
        ],
        tags: [
            'clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f1-fe0f.png',
    },
    {
        emoji: '⏲',
        name: 'timer_clock',
        shortcodes: [
            'timer_clock',
        ],
        tags: [
            'clock',
            'timer',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f2-fe0f.png',
    },
    {
        emoji: '🕰',
        name: 'mantelpiece_clock',
        shortcodes: [
            'clock',
        ],
        tags: [
            'clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f570-fe0f.png',
    },
    {
        emoji: '🕛',
        name: 'clock12',
        shortcodes: [
            'clock12',
        ],
        tags: [
            '00',
            '12',
            '12:00',
            'clock',
            'o’clock',
            'twelve',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55b.png',
    },
    {
        emoji: '🕧',
        name: 'clock1230',
        shortcodes: [
            'clock1230',
        ],
        tags: [
            '12',
            '12:30',
            'clock',
            'thirty',
            'twelve',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f567.png',
    },
    {
        emoji: '🕐',
        name: 'clock1',
        shortcodes: [
            'clock1',
        ],
        tags: [
            '00',
            '1',
            '1:00',
            'clock',
            'one',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f550.png',
    },
    {
        emoji: '🕜',
        name: 'clock130',
        shortcodes: [
            'clock130',
        ],
        tags: [
            '1',
            '1:30',
            'clock',
            'one',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55c.png',
    },
    {
        emoji: '🕑',
        name: 'clock2',
        shortcodes: [
            'clock2',
        ],
        tags: [
            '00',
            '2',
            '2:00',
            'clock',
            'o’clock',
            'two',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f551.png',
    },
    {
        emoji: '🕝',
        name: 'clock230',
        shortcodes: [
            'clock230',
        ],
        tags: [
            '2',
            '2:30',
            'clock',
            'thirty',
            'two',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55d.png',
    },
    {
        emoji: '🕒',
        name: 'clock3',
        shortcodes: [
            'clock3',
        ],
        tags: [
            '00',
            '3',
            '3:00',
            'clock',
            'o’clock',
            'three',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f552.png',
    },
    {
        emoji: '🕞',
        name: 'clock330',
        shortcodes: [
            'clock330',
        ],
        tags: [
            '3',
            '3:30',
            'clock',
            'thirty',
            'three',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55e.png',
    },
    {
        emoji: '🕓',
        name: 'clock4',
        shortcodes: [
            'clock4',
        ],
        tags: [
            '00',
            '4',
            '4:00',
            'clock',
            'four',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f553.png',
    },
    {
        emoji: '🕟',
        name: 'clock430',
        shortcodes: [
            'clock430',
        ],
        tags: [
            '4',
            '4:30',
            'clock',
            'four',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55f.png',
    },
    {
        emoji: '🕔',
        name: 'clock5',
        shortcodes: [
            'clock5',
        ],
        tags: [
            '00',
            '5',
            '5:00',
            'clock',
            'five',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f554.png',
    },
    {
        emoji: '🕠',
        name: 'clock530',
        shortcodes: [
            'clock530',
        ],
        tags: [
            '5',
            '5:30',
            'clock',
            'five',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f560.png',
    },
    {
        emoji: '🕕',
        name: 'clock6',
        shortcodes: [
            'clock6',
        ],
        tags: [
            '00',
            '6',
            '6:00',
            'clock',
            'o’clock',
            'six',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f555.png',
    },
    {
        emoji: '🕡',
        name: 'clock630',
        shortcodes: [
            'clock630',
        ],
        tags: [
            '6',
            '6:30',
            'clock',
            'six',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f561.png',
    },
    {
        emoji: '🕖',
        name: 'clock7',
        shortcodes: [
            'clock7',
        ],
        tags: [
            '00',
            '7',
            '7:00',
            'clock',
            'o’clock',
            'seven',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f556.png',
    },
    {
        emoji: '🕢',
        name: 'clock730',
        shortcodes: [
            'clock730',
        ],
        tags: [
            '7',
            '7:30',
            'clock',
            'seven',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f562.png',
    },
    {
        emoji: '🕗',
        name: 'clock8',
        shortcodes: [
            'clock8',
        ],
        tags: [
            '00',
            '8',
            '8:00',
            'clock',
            'eight',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f557.png',
    },
    {
        emoji: '🕣',
        name: 'clock830',
        shortcodes: [
            'clock830',
        ],
        tags: [
            '8',
            '8:30',
            'clock',
            'eight',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f563.png',
    },
    {
        emoji: '🕘',
        name: 'clock9',
        shortcodes: [
            'clock9',
        ],
        tags: [
            '00',
            '9',
            '9:00',
            'clock',
            'nine',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f558.png',
    },
    {
        emoji: '🕤',
        name: 'clock930',
        shortcodes: [
            'clock930',
        ],
        tags: [
            '9',
            '9:30',
            'clock',
            'nine',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f564.png',
    },
    {
        emoji: '🕙',
        name: 'clock10',
        shortcodes: [
            'clock10',
        ],
        tags: [
            '00',
            '10',
            '10:00',
            'clock',
            'o’clock',
            'ten',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f559.png',
    },
    {
        emoji: '🕥',
        name: 'clock1030',
        shortcodes: [
            'clock1030',
        ],
        tags: [
            '10',
            '10:30',
            'clock',
            'ten',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f565.png',
    },
    {
        emoji: '🕚',
        name: 'clock11',
        shortcodes: [
            'clock11',
        ],
        tags: [
            '00',
            '11',
            '11:00',
            'clock',
            'eleven',
            'o’clock',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55a.png',
    },
    {
        emoji: '🕦',
        name: 'clock1130',
        shortcodes: [
            'clock1130',
        ],
        tags: [
            '11',
            '11:30',
            'clock',
            'eleven',
            'thirty',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f566.png',
    },
    {
        emoji: '🌑',
        name: 'new_moon',
        shortcodes: [
            'new_moon',
        ],
        tags: [
            'dark',
            'moon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f311.png',
    },
    {
        emoji: '🌒',
        name: 'waxing_crescent_moon',
        shortcodes: [
            'waxing_crescent_moon',
        ],
        tags: [
            'crescent',
            'moon',
            'waxing',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f312.png',
    },
    {
        emoji: '🌓',
        name: 'first_quarter_moon',
        shortcodes: [
            'first_quarter_moon',
        ],
        tags: [
            'moon',
            'quarter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f313.png',
    },
    {
        emoji: '🌔',
        name: 'moon',
        shortcodes: [
            'waxing_gibbous_moon',
        ],
        tags: [
            'gibbous',
            'moon',
            'waxing',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f314.png',
    },
    {
        emoji: '🌕',
        name: 'full_moon',
        shortcodes: [
            'full_moon',
        ],
        tags: [
            'full',
            'moon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f315.png',
    },
    {
        emoji: '🌖',
        name: 'waning_gibbous_moon',
        shortcodes: [
            'waning_gibbous_moon',
        ],
        tags: [
            'gibbous',
            'moon',
            'waning',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f316.png',
    },
    {
        emoji: '🌗',
        name: 'last_quarter_moon',
        shortcodes: [
            'last_quarter_moon',
        ],
        tags: [
            'moon',
            'quarter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f317.png',
    },
    {
        emoji: '🌘',
        name: 'waning_crescent_moon',
        shortcodes: [
            'waning_crescent_moon',
        ],
        tags: [
            'crescent',
            'moon',
            'waning',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f318.png',
    },
    {
        emoji: '🌙',
        name: 'crescent_moon',
        shortcodes: [
            'crescent_moon',
        ],
        tags: [
            'crescent',
            'moon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f319.png',
    },
    {
        emoji: '🌚',
        name: 'new_moon_with_face',
        shortcodes: [
            'new_moon_with_face',
        ],
        tags: [
            'face',
            'moon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31a.png',
    },
    {
        emoji: '🌛',
        name: 'first_quarter_moon_with_face',
        shortcodes: [
            'first_quarter_moon_with_face',
        ],
        tags: [
            'face',
            'moon',
            'quarter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31b.png',
    },
    {
        emoji: '🌜',
        name: 'last_quarter_moon_with_face',
        shortcodes: [
            'last_quarter_moon_with_face',
        ],
        tags: [
            'face',
            'moon',
            'quarter',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31c.png',
    },
    {
        emoji: '🌡',
        name: 'thermometer',
        shortcodes: [
            'thermometer',
        ],
        tags: [
            'weather',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f321-fe0f.png',
    },
    {
        emoji: '☀',
        name: 'sunny',
        shortcodes: [
            'sun',
        ],
        tags: [
            'bright',
            'rays',
            'sunny',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2600-fe0f.png',
    },
    {
        emoji: '🌝',
        name: 'full_moon_with_face',
        shortcodes: [
            'full_moon_with_face',
        ],
        tags: [
            'bright',
            'face',
            'full',
            'moon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31d.png',
    },
    {
        emoji: '🌞',
        name: 'sun_with_face',
        shortcodes: [
            'sun_with_face',
        ],
        tags: [
            'bright',
            'face',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31e.png',
    },
    {
        emoji: '🪐',
        name: 'ringed_planet',
        shortcodes: [
            'ringed_planet',
            'saturn',
        ],
        tags: [
            'saturn',
            'saturnine',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa90.png',
    },
    {
        emoji: '⭐',
        name: 'star',
        shortcodes: [
            'star',
        ],
        tags: [
            'star',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b50.png',
    },
    {
        emoji: '🌟',
        name: 'star2',
        shortcodes: [
            'glowing_star',
            'star2',
        ],
        tags: [
            'glittery',
            'glow',
            'shining',
            'sparkle',
            'star',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31f.png',
    },
    {
        emoji: '🌠',
        name: 'stars',
        shortcodes: [
            'shooting_star',
            'stars',
        ],
        tags: [
            'falling',
            'shooting',
            'star',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f320.png',
    },
    {
        emoji: '🌌',
        name: 'milky_way',
        shortcodes: [
            'milky_way',
        ],
        tags: [
            'space',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30c.png',
    },
    {
        emoji: '☁',
        name: 'cloud',
        shortcodes: [
            'cloud',
        ],
        tags: [
            'weather',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2601-fe0f.png',
    },
    {
        emoji: '⛅',
        name: 'partly_sunny',
        shortcodes: [
            'partly_sunny',
            'sun_behind_cloud',
        ],
        tags: [
            'cloud',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c5.png',
    },
    {
        emoji: '⛈',
        name: 'cloud_with_lightning_and_rain',
        shortcodes: [
            'stormy',
            'thunder_cloud_and_rain',
        ],
        tags: [
            'cloud',
            'rain',
            'thunder',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c8-fe0f.png',
    },
    {
        emoji: '🌤',
        name: 'sun_behind_small_cloud',
        shortcodes: [
            'sun_behind_small_cloud',
            'sunny',
        ],
        tags: [
            'cloud',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f324-fe0f.png',
    },
    {
        emoji: '🌥',
        name: 'sun_behind_large_cloud',
        shortcodes: [
            'cloudy',
            'sun_behind_large_cloud',
        ],
        tags: [
            'cloud',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f325-fe0f.png',
    },
    {
        emoji: '🌦',
        name: 'sun_behind_rain_cloud',
        shortcodes: [
            'sun_and_rain',
            'sun_behind_rain_cloud',
        ],
        tags: [
            'cloud',
            'rain',
            'sun',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f326-fe0f.png',
    },
    {
        emoji: '🌧',
        name: 'cloud_with_rain',
        shortcodes: [
            'cloud_with_rain',
            'rainy',
        ],
        tags: [
            'cloud',
            'rain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f327-fe0f.png',
    },
    {
        emoji: '🌨',
        name: 'cloud_with_snow',
        shortcodes: [
            'cloud_with_snow',
            'snowy',
        ],
        tags: [
            'cloud',
            'cold',
            'snow',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f328-fe0f.png',
    },
    {
        emoji: '🌩',
        name: 'cloud_with_lightning',
        shortcodes: [
            'cloud_with_lightning',
            'lightning',
        ],
        tags: [
            'cloud',
            'lightning',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f329-fe0f.png',
    },
    {
        emoji: '🌪',
        name: 'tornado',
        shortcodes: [
            'tornado',
        ],
        tags: [
            'cloud',
            'whirlwind',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32a-fe0f.png',
    },
    {
        emoji: '🌫',
        name: 'fog',
        shortcodes: [
            'fog',
        ],
        tags: [
            'cloud',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32b-fe0f.png',
    },
    {
        emoji: '🌬',
        name: 'wind_face',
        shortcodes: [
            'wind_blowing_face',
        ],
        tags: [
            'blow',
            'cloud',
            'face',
            'wind',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32c-fe0f.png',
    },
    {
        emoji: '🌀',
        name: 'cyclone',
        shortcodes: [
            'cyclone',
        ],
        tags: [
            'dizzy',
            'hurricane',
            'twister',
            'typhoon',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f300.png',
    },
    {
        emoji: '🌈',
        name: 'rainbow',
        shortcodes: [
            'rainbow',
        ],
        tags: [
            'rain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f308.png',
    },
    {
        emoji: '🌂',
        name: 'closed_umbrella',
        shortcodes: [
            'closed_umbrella',
        ],
        tags: [
            'clothing',
            'rain',
            'umbrella',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f302.png',
    },
    {
        emoji: '☂',
        name: 'open_umbrella',
        shortcodes: [
            'umbrella',
        ],
        tags: [
            'clothing',
            'rain',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2602-fe0f.png',
    },
    {
        emoji: '☔',
        name: 'umbrella',
        shortcodes: [
            'umbrella_with_rain',
        ],
        tags: [
            'clothing',
            'drop',
            'rain',
            'umbrella',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2614.png',
    },
    {
        emoji: '⛱',
        name: 'parasol_on_ground',
        shortcodes: [
            'beach_umbrella',
            'umbrella_on_ground',
        ],
        tags: [
            'rain',
            'sun',
            'umbrella',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f1-fe0f.png',
    },
    {
        emoji: '⚡',
        name: 'zap',
        shortcodes: [
            'high_voltage',
            'zap',
        ],
        tags: [
            'danger',
            'electric',
            'lightning',
            'voltage',
            'zap',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a1.png',
    },
    {
        emoji: '❄',
        name: 'snowflake',
        shortcodes: [
            'snowflake',
        ],
        tags: [
            'cold',
            'snow',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2744-fe0f.png',
    },
    {
        emoji: '☃',
        name: 'snowman_with_snow',
        shortcodes: [
            'snowman2',
        ],
        tags: [
            'cold',
            'snow',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2603-fe0f.png',
    },
    {
        emoji: '⛄',
        name: 'snowman',
        shortcodes: [
            'snowman',
        ],
        tags: [
            'cold',
            'snow',
            'snowman',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c4.png',
    },
    {
        emoji: '☄',
        name: 'comet',
        shortcodes: [
            'comet',
        ],
        tags: [
            'space',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2604-fe0f.png',
    },
    {
        emoji: '🔥',
        name: 'fire',
        shortcodes: [
            'fire',
        ],
        tags: [
            'flame',
            'tool',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f525.png',
    },
    {
        emoji: '💧',
        name: 'droplet',
        shortcodes: [
            'droplet',
        ],
        tags: [
            'cold',
            'comic',
            'drop',
            'sweat',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a7.png',
    },
    {
        emoji: '🌊',
        name: 'ocean',
        shortcodes: [
            'ocean',
            'water_wave',
        ],
        tags: [
            'ocean',
            'water',
            'wave',
        ],
        group: 'travel & places',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30a.png',
    },
    {
        emoji: '🎃',
        name: 'jack_o_lantern',
        shortcodes: [
            'jack_o_lantern',
        ],
        tags: [
            'celebration',
            'halloween',
            'jack',
            'lantern',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f383.png',
    },
    {
        emoji: '🎄',
        name: 'christmas_tree',
        shortcodes: [
            'christmas_tree',
        ],
        tags: [
            'celebration',
            'christmas',
            'tree',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f384.png',
    },
    {
        emoji: '🎆',
        name: 'fireworks',
        shortcodes: [
            'fireworks',
        ],
        tags: [
            'celebration',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f386.png',
    },
    {
        emoji: '🎇',
        name: 'sparkler',
        shortcodes: [
            'sparkler',
        ],
        tags: [
            'celebration',
            'fireworks',
            'sparkle',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f387.png',
    },
    {
        emoji: '🧨',
        name: 'firecracker',
        shortcodes: [
            'firecracker',
        ],
        tags: [
            'dynamite',
            'explosive',
            'fireworks',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e8.png',
    },
    {
        emoji: '✨',
        name: 'sparkles',
        shortcodes: [
            'sparkles',
        ],
        tags: [
            '*',
            'sparkle',
            'star',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2728.png',
    },
    {
        emoji: '🎈',
        name: 'balloon',
        shortcodes: [
            'balloon',
        ],
        tags: [
            'celebration',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f388.png',
    },
    {
        emoji: '🎉',
        name: 'tada',
        shortcodes: [
            'party',
            'party_popper',
            'tada',
        ],
        tags: [
            'celebration',
            'party',
            'popper',
            'tada',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f389.png',
    },
    {
        emoji: '🎊',
        name: 'confetti_ball',
        shortcodes: [
            'confetti_ball',
        ],
        tags: [
            'ball',
            'celebration',
            'confetti',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38a.png',
    },
    {
        emoji: '🎋',
        name: 'tanabata_tree',
        shortcodes: [
            'tanabata_tree',
        ],
        tags: [
            'banner',
            'celebration',
            'japanese',
            'tree',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38b.png',
    },
    {
        emoji: '🎍',
        name: 'bamboo',
        shortcodes: [
            'bamboo',
        ],
        tags: [
            'bamboo',
            'celebration',
            'japanese',
            'pine',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38d.png',
    },
    {
        emoji: '🎎',
        name: 'dolls',
        shortcodes: [
            'dolls',
        ],
        tags: [
            'celebration',
            'doll',
            'festival',
            'japanese',
            'japanese dolls',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38e.png',
    },
    {
        emoji: '🎏',
        name: 'flags',
        shortcodes: [
            'carp_streamer',
            'flags',
        ],
        tags: [
            'carp',
            'celebration',
            'streamer',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38f.png',
    },
    {
        emoji: '🎐',
        name: 'wind_chime',
        shortcodes: [
            'wind_chime',
        ],
        tags: [
            'bell',
            'celebration',
            'chime',
            'wind',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f390.png',
    },
    {
        emoji: '🎑',
        name: 'rice_scene',
        shortcodes: [
            'moon_ceremony',
            'rice_scene',
        ],
        tags: [
            'celebration',
            'ceremony',
            'moon',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f391.png',
    },
    {
        emoji: '🧧',
        name: 'red_envelope',
        shortcodes: [
            'red_envelope',
        ],
        tags: [
            'gift',
            'good luck',
            'hóngbāo',
            'lai see',
            'money',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e7.png',
    },
    {
        emoji: '🎀',
        name: 'ribbon',
        shortcodes: [
            'ribbon',
        ],
        tags: [
            'celebration',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f380.png',
    },
    {
        emoji: '🎁',
        name: 'gift',
        shortcodes: [
            'gift',
        ],
        tags: [
            'box',
            'celebration',
            'gift',
            'present',
            'wrapped',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f381.png',
    },
    {
        emoji: '🎗',
        name: 'reminder_ribbon',
        shortcodes: [
            'reminder_ribbon',
        ],
        tags: [
            'celebration',
            'reminder',
            'ribbon',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f397-fe0f.png',
    },
    {
        emoji: '🎟',
        name: 'tickets',
        shortcodes: [
            'admission_tickets',
            'tickets',
        ],
        tags: [
            'admission',
            'ticket',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39f-fe0f.png',
    },
    {
        emoji: '🎫',
        name: 'ticket',
        shortcodes: [
            'ticket',
        ],
        tags: [
            'admission',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ab.png',
    },
    {
        emoji: '🎖',
        name: 'medal_military',
        shortcodes: [
            'military_medal',
        ],
        tags: [
            'celebration',
            'medal',
            'military',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f396-fe0f.png',
    },
    {
        emoji: '🏆',
        name: 'trophy',
        shortcodes: [
            'trophy',
        ],
        tags: [
            'prize',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c6.png',
    },
    {
        emoji: '🏅',
        name: 'medal_sports',
        shortcodes: [
            'sports_medal',
        ],
        tags: [
            'medal',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c5.png',
    },
    {
        emoji: '🥇',
        name: '1st_place_medal',
        shortcodes: [
            '1st',
            'first_place_medal',
        ],
        tags: [
            'first',
            'gold',
            'medal',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f947.png',
    },
    {
        emoji: '🥈',
        name: '2nd_place_medal',
        shortcodes: [
            '2nd',
            'second_place_medal',
        ],
        tags: [
            'medal',
            'second',
            'silver',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f948.png',
    },
    {
        emoji: '🥉',
        name: '3rd_place_medal',
        shortcodes: [
            '3rd',
            'third_place_medal',
        ],
        tags: [
            'bronze',
            'medal',
            'third',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f949.png',
    },
    {
        emoji: '⚽',
        name: 'soccer',
        shortcodes: [
            'soccer',
        ],
        tags: [
            'ball',
            'football',
            'soccer',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26bd.png',
    },
    {
        emoji: '⚾',
        name: 'baseball',
        shortcodes: [
            'baseball',
        ],
        tags: [
            'ball',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26be.png',
    },
    {
        emoji: '🥎',
        name: 'softball',
        shortcodes: [
            'softball',
        ],
        tags: [
            'ball',
            'glove',
            'underarm',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94e.png',
    },
    {
        emoji: '🏀',
        name: 'basketball',
        shortcodes: [
            'basketball',
        ],
        tags: [
            'ball',
            'hoop',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c0.png',
    },
    {
        emoji: '🏐',
        name: 'volleyball',
        shortcodes: [
            'volleyball',
        ],
        tags: [
            'ball',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d0.png',
    },
    {
        emoji: '🏈',
        name: 'football',
        shortcodes: [
            'football',
        ],
        tags: [
            'american',
            'ball',
            'football',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c8.png',
    },
    {
        emoji: '🏉',
        name: 'rugby_football',
        shortcodes: [
            'rugby_football',
        ],
        tags: [
            'ball',
            'football',
            'rugby',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c9.png',
    },
    {
        emoji: '🎾',
        name: 'tennis',
        shortcodes: [
            'tennis',
        ],
        tags: [
            'ball',
            'racquet',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3be.png',
    },
    {
        emoji: '🥏',
        name: 'flying_disc',
        shortcodes: [
            'flying_disc',
        ],
        tags: [
            'ultimate',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94f.png',
    },
    {
        emoji: '🎳',
        name: 'bowling',
        shortcodes: [
            'bowling',
        ],
        tags: [
            'ball',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b3.png',
    },
    {
        emoji: '🏏',
        name: 'cricket_game',
        shortcodes: [
            'cricket_game',
        ],
        tags: [
            'ball',
            'bat',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cf.png',
    },
    {
        emoji: '🏑',
        name: 'field_hockey',
        shortcodes: [
            'field_hockey',
        ],
        tags: [
            'ball',
            'field',
            'game',
            'hockey',
            'stick',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d1.png',
    },
    {
        emoji: '🏒',
        name: 'ice_hockey',
        shortcodes: [
            'hockey',
        ],
        tags: [
            'game',
            'hockey',
            'ice',
            'puck',
            'stick',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d2.png',
    },
    {
        emoji: '🥍',
        name: 'lacrosse',
        shortcodes: [
            'lacrosse',
        ],
        tags: [
            'ball',
            'goal',
            'stick',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94d.png',
    },
    {
        emoji: '🏓',
        name: 'ping_pong',
        shortcodes: [
            'ping_pong',
        ],
        tags: [
            'ball',
            'bat',
            'game',
            'paddle',
            'table tennis',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d3.png',
    },
    {
        emoji: '🏸',
        name: 'badminton',
        shortcodes: [
            'badminton',
        ],
        tags: [
            'birdie',
            'game',
            'racquet',
            'shuttlecock',
        ],
        group: 'activities',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f8.png',
    },
    {
        emoji: '🥊',
        name: 'boxing_glove',
        shortcodes: [
            'boxing_glove',
        ],
        tags: [
            'boxing',
            'glove',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94a.png',
    },
    {
        emoji: '🥋',
        name: 'martial_arts_uniform',
        shortcodes: [
            'martial_arts_uniform',
        ],
        tags: [
            'judo',
            'karate',
            'martial arts',
            'taekwondo',
            'uniform',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94b.png',
    },
    {
        emoji: '🥅',
        name: 'goal_net',
        shortcodes: [
            'goal_net',
        ],
        tags: [
            'goal',
            'net',
        ],
        group: 'activities',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f945.png',
    },
    {
        emoji: '⛳',
        name: 'golf',
        shortcodes: [
            'golf',
        ],
        tags: [
            'golf',
            'hole',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f3.png',
    },
    {
        emoji: '⛸',
        name: 'ice_skate',
        shortcodes: [
            'ice_skate',
        ],
        tags: [
            'ice',
            'skate',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f8-fe0f.png',
    },
    {
        emoji: '🎣',
        name: 'fishing_pole_and_fish',
        shortcodes: [
            'fishing_pole',
            'fishing_pole_and_fish',
        ],
        tags: [
            'fish',
            'pole',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a3.png',
    },
    {
        emoji: '🤿',
        name: 'diving_mask',
        shortcodes: [
            'diving_mask',
        ],
        tags: [
            'diving',
            'scuba',
            'snorkeling',
        ],
        group: 'activities',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93f.png',
    },
    {
        emoji: '🎽',
        name: 'running_shirt_with_sash',
        shortcodes: [
            'running_shirt',
            'running_shirt_with_sash',
        ],
        tags: [
            'athletics',
            'running',
            'sash',
            'shirt',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bd.png',
    },
    {
        emoji: '🎿',
        name: 'ski',
        shortcodes: [
            'ski',
        ],
        tags: [
            'ski',
            'snow',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bf.png',
    },
    {
        emoji: '🛷',
        name: 'sled',
        shortcodes: [
            'sled',
        ],
        tags: [
            'sledge',
            'sleigh',
        ],
        group: 'activities',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f7.png',
    },
    {
        emoji: '🥌',
        name: 'curling_stone',
        shortcodes: [
            'curling_stone',
        ],
        tags: [
            'game',
            'rock',
        ],
        group: 'activities',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94c.png',
    },
    {
        emoji: '🎯',
        name: 'dart',
        shortcodes: [
            'bullseye',
            'dart',
            'direct_hit',
        ],
        tags: [
            'dart',
            'direct hit',
            'game',
            'hit',
            'target',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3af.png',
    },
    {
        emoji: '🪀',
        name: 'yo_yo',
        shortcodes: [
            'yo_yo',
        ],
        tags: [
            'fluctuate',
            'toy',
        ],
        group: 'activities',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa80.png',
    },
    {
        emoji: '🪁',
        name: 'kite',
        shortcodes: [
            'kite',
        ],
        tags: [
            'fly',
            'soar',
        ],
        group: 'activities',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa81.png',
    },
    {
        emoji: '🎱',
        name: '8ball',
        shortcodes: [
            '8ball',
            'billiards',
        ],
        tags: [
            '8',
            'ball',
            'billiard',
            'eight',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b1.png',
    },
    {
        emoji: '🔮',
        name: 'crystal_ball',
        shortcodes: [
            'crystal_ball',
        ],
        tags: [
            'ball',
            'crystal',
            'fairy tale',
            'fantasy',
            'fortune',
            'tool',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52e.png',
    },
    {
        emoji: '🪄',
        name: 'magic_wand',
        shortcodes: [
            'magic_wand',
        ],
        tags: [
            'magic',
            'witch',
            'wizard',
        ],
        group: 'activities',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa84.png',
    },
    {
        emoji: '🧿',
        name: 'nazar_amulet',
        shortcodes: [
            'nazar_amulet',
        ],
        tags: [
            'bead',
            'charm',
            'evil-eye',
            'nazar',
            'talisman',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ff.png',
    },
    {
        emoji: '🎮',
        name: 'video_game',
        shortcodes: [
            'controller',
            'video_game',
        ],
        tags: [
            'controller',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ae.png',
    },
    {
        emoji: '🕹',
        name: 'joystick',
        shortcodes: [
            'joystick',
        ],
        tags: [
            'game',
            'video game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f579-fe0f.png',
    },
    {
        emoji: '🎰',
        name: 'slot_machine',
        shortcodes: [
            'slot_machine',
        ],
        tags: [
            'game',
            'slot',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b0.png',
    },
    {
        emoji: '🎲',
        name: 'game_die',
        shortcodes: [
            'game_die',
        ],
        tags: [
            'dice',
            'die',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b2.png',
    },
    {
        emoji: '🧩',
        name: 'jigsaw',
        shortcodes: [
            'jigsaw',
            'puzzle_piece',
        ],
        tags: [
            'clue',
            'interlocking',
            'jigsaw',
            'piece',
            'puzzle',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e9.png',
    },
    {
        emoji: '🧸',
        name: 'teddy_bear',
        shortcodes: [
            'teddy_bear',
        ],
        tags: [
            'plaything',
            'plush',
            'stuffed',
            'toy',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f8.png',
    },
    {
        emoji: '🪅',
        name: 'pinata',
        shortcodes: [
            'pinata',
        ],
        tags: [
            'celebration',
            'party',
        ],
        group: 'activities',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa85.png',
    },
    {
        emoji: '🪆',
        name: 'nesting_dolls',
        shortcodes: [
            'nesting_dolls',
        ],
        tags: [
            'doll',
            'nesting',
            'russia',
        ],
        group: 'activities',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa86.png',
    },
    {
        emoji: '♠',
        name: 'spades',
        shortcodes: [
            'spades',
        ],
        tags: [
            'card',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2660-fe0f.png',
    },
    {
        emoji: '♥',
        name: 'hearts',
        shortcodes: [
            'hearts',
        ],
        tags: [
            'card',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2665-fe0f.png',
    },
    {
        emoji: '♦',
        name: 'diamonds',
        shortcodes: [
            'diamonds',
        ],
        tags: [
            'card',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2666-fe0f.png',
    },
    {
        emoji: '♣',
        name: 'clubs',
        shortcodes: [
            'clubs',
        ],
        tags: [
            'card',
            'game',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2663-fe0f.png',
    },
    {
        emoji: '♟',
        name: 'chess_pawn',
        shortcodes: [
            'chess_pawn',
        ],
        tags: [
            'chess',
            'dupe',
            'expendable',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/265f-fe0f.png',
    },
    {
        emoji: '🃏',
        name: 'black_joker',
        shortcodes: [
            'black_joker',
        ],
        tags: [
            'card',
            'game',
            'wildcard',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f0cf.png',
    },
    {
        emoji: '🀄',
        name: 'mahjong',
        shortcodes: [
            'mahjong',
        ],
        tags: [
            'game',
            'mahjong',
            'red',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f004.png',
    },
    {
        emoji: '🎴',
        name: 'flower_playing_cards',
        shortcodes: [
            'flower_playing_cards',
        ],
        tags: [
            'card',
            'flower',
            'game',
            'japanese',
            'playing',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b4.png',
    },
    {
        emoji: '🎭',
        name: 'performing_arts',
        shortcodes: [
            'performing_arts',
        ],
        tags: [
            'art',
            'mask',
            'performing',
            'theater',
            'theatre',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ad.png',
    },
    {
        emoji: '🖼',
        name: 'framed_picture',
        shortcodes: [
            'frame_with_picture',
            'framed_picture',
        ],
        tags: [
            'art',
            'frame',
            'museum',
            'painting',
            'picture',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5bc-fe0f.png',
    },
    {
        emoji: '🎨',
        name: 'art',
        shortcodes: [
            'art',
            'palette',
        ],
        tags: [
            'art',
            'museum',
            'painting',
            'palette',
        ],
        group: 'activities',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a8.png',
    },
    {
        emoji: '🧵',
        name: 'thread',
        shortcodes: [
            'thread',
        ],
        tags: [
            'needle',
            'sewing',
            'spool',
            'string',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f5.png',
    },
    {
        emoji: '🪡',
        name: 'sewing_needle',
        shortcodes: [
            'sewing_needle',
        ],
        tags: [
            'embroidery',
            'needle',
            'sewing',
            'stitches',
            'sutures',
            'tailoring',
        ],
        group: 'activities',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa1.png',
    },
    {
        emoji: '🧶',
        name: 'yarn',
        shortcodes: [
            'yarn',
        ],
        tags: [
            'ball',
            'crochet',
            'knit',
        ],
        group: 'activities',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f6.png',
    },
    {
        emoji: '🪢',
        name: 'knot',
        shortcodes: [
            'knot',
        ],
        tags: [
            'rope',
            'tangled',
            'tie',
            'twine',
            'twist',
        ],
        group: 'activities',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa2.png',
    },
    {
        emoji: '👓',
        name: 'eyeglasses',
        shortcodes: [
            'eyeglasses',
            'glasses',
        ],
        tags: [
            'clothing',
            'eye',
            'eyeglasses',
            'eyewear',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f453.png',
    },
    {
        emoji: '🕶',
        name: 'dark_sunglasses',
        shortcodes: [
            'sunglasses',
        ],
        tags: [
            'dark',
            'eye',
            'eyewear',
            'glasses',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f576-fe0f.png',
    },
    {
        emoji: '🥽',
        name: 'goggles',
        shortcodes: [
            'goggles',
        ],
        tags: [
            'eye protection',
            'swimming',
            'welding',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97d.png',
    },
    {
        emoji: '🥼',
        name: 'lab_coat',
        shortcodes: [
            'lab_coat',
        ],
        tags: [
            'doctor',
            'experiment',
            'scientist',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97c.png',
    },
    {
        emoji: '🦺',
        name: 'safety_vest',
        shortcodes: [
            'safety_vest',
        ],
        tags: [
            'emergency',
            'safety',
            'vest',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ba.png',
    },
    {
        emoji: '👔',
        name: 'necktie',
        shortcodes: [
            'necktie',
        ],
        tags: [
            'clothing',
            'tie',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f454.png',
    },
    {
        emoji: '👕',
        name: 'shirt',
        shortcodes: [
            'shirt',
        ],
        tags: [
            'clothing',
            'shirt',
            'tshirt',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f455.png',
    },
    {
        emoji: '👖',
        name: 'jeans',
        shortcodes: [
            'jeans',
        ],
        tags: [
            'clothing',
            'pants',
            'trousers',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f456.png',
    },
    {
        emoji: '🧣',
        name: 'scarf',
        shortcodes: [
            'scarf',
        ],
        tags: [
            'neck',
        ],
        group: 'objects',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e3.png',
    },
    {
        emoji: '🧤',
        name: 'gloves',
        shortcodes: [
            'gloves',
        ],
        tags: [
            'hand',
        ],
        group: 'objects',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e4.png',
    },
    {
        emoji: '🧥',
        name: 'coat',
        shortcodes: [
            'coat',
        ],
        tags: [
            'jacket',
        ],
        group: 'objects',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e5.png',
    },
    {
        emoji: '🧦',
        name: 'socks',
        shortcodes: [
            'socks',
        ],
        tags: [
            'stocking',
        ],
        group: 'objects',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e6.png',
    },
    {
        emoji: '👗',
        name: 'dress',
        shortcodes: [
            'dress',
        ],
        tags: [
            'clothing',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f457.png',
    },
    {
        emoji: '👘',
        name: 'kimono',
        shortcodes: [
            'kimono',
        ],
        tags: [
            'clothing',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f458.png',
    },
    {
        emoji: '🥻',
        name: 'sari',
        shortcodes: [
            'sari',
        ],
        tags: [
            'clothing',
            'dress',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97b.png',
    },
    {
        emoji: '🩱',
        name: 'one_piece_swimsuit',
        shortcodes: [
            'one_piece_swimsuit',
        ],
        tags: [
            'bathing suit',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa71.png',
    },
    {
        emoji: '🩲',
        name: 'swim_brief',
        shortcodes: [
            'briefs',
        ],
        tags: [
            'bathing suit',
            'one-piece',
            'swimsuit',
            'underwear',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa72.png',
    },
    {
        emoji: '🩳',
        name: 'shorts',
        shortcodes: [
            'shorts',
        ],
        tags: [
            'bathing suit',
            'pants',
            'underwear',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa73.png',
    },
    {
        emoji: '👙',
        name: 'bikini',
        shortcodes: [
            'bikini',
        ],
        tags: [
            'clothing',
            'swim',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f459.png',
    },
    {
        emoji: '👚',
        name: 'womans_clothes',
        shortcodes: [
            'womans_clothes',
        ],
        tags: [
            'clothing',
            'woman',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45a.png',
    },
    {
        emoji: '👛',
        name: 'purse',
        shortcodes: [
            'purse',
        ],
        tags: [
            'clothing',
            'coin',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45b.png',
    },
    {
        emoji: '👜',
        name: 'handbag',
        shortcodes: [
            'handbag',
        ],
        tags: [
            'bag',
            'clothing',
            'purse',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45c.png',
    },
    {
        emoji: '👝',
        name: 'pouch',
        shortcodes: [
            'clutch_bag',
            'pouch',
        ],
        tags: [
            'bag',
            'clothing',
            'pouch',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45d.png',
    },
    {
        emoji: '🛍',
        name: 'shopping',
        shortcodes: [
            'shopping_bags',
        ],
        tags: [
            'bag',
            'hotel',
            'shopping',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cd-fe0f.png',
    },
    {
        emoji: '🎒',
        name: 'school_satchel',
        shortcodes: [
            'backpack',
            'school_satchel',
        ],
        tags: [
            'bag',
            'rucksack',
            'satchel',
            'school',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f392.png',
    },
    {
        emoji: '🩴',
        name: 'thong_sandal',
        shortcodes: [
            'thong_sandal',
        ],
        tags: [
            'beach sandals',
            'sandals',
            'thong sandals',
            'thongs',
            'zōri',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa74.png',
    },
    {
        emoji: '👞',
        name: 'mans_shoe',
        shortcodes: [
            'mans_shoe',
        ],
        tags: [
            'clothing',
            'man',
            'shoe',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45e.png',
    },
    {
        emoji: '👟',
        name: 'athletic_shoe',
        shortcodes: [
            'athletic_shoe',
            'sneaker',
        ],
        tags: [
            'athletic',
            'clothing',
            'shoe',
            'sneaker',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45f.png',
    },
    {
        emoji: '🥾',
        name: 'hiking_boot',
        shortcodes: [
            'hiking_boot',
        ],
        tags: [
            'backpacking',
            'boot',
            'camping',
            'hiking',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97e.png',
    },
    {
        emoji: '🥿',
        name: 'flat_shoe',
        shortcodes: [
            'flat_shoe',
            'womans_flat_shoe',
        ],
        tags: [
            'ballet flat',
            'slip-on',
            'slipper',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97f.png',
    },
    {
        emoji: '👠',
        name: 'high_heel',
        shortcodes: [
            'high_heel',
        ],
        tags: [
            'clothing',
            'heel',
            'shoe',
            'woman',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f460.png',
    },
    {
        emoji: '👡',
        name: 'sandal',
        shortcodes: [
            'sandal',
        ],
        tags: [
            'clothing',
            'sandal',
            'shoe',
            'woman',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f461.png',
    },
    {
        emoji: '🩰',
        name: 'ballet_shoes',
        shortcodes: [
            'ballet_shoes',
        ],
        tags: [
            'ballet',
            'dance',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa70.png',
    },
    {
        emoji: '👢',
        name: 'boot',
        shortcodes: [
            'boot',
        ],
        tags: [
            'boot',
            'clothing',
            'shoe',
            'woman',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f462.png',
    },
    {
        emoji: '👑',
        name: 'crown',
        shortcodes: [
            'crown',
        ],
        tags: [
            'clothing',
            'king',
            'queen',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f451.png',
    },
    {
        emoji: '👒',
        name: 'womans_hat',
        shortcodes: [
            'womans_hat',
        ],
        tags: [
            'clothing',
            'hat',
            'woman',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f452.png',
    },
    {
        emoji: '🎩',
        name: 'tophat',
        shortcodes: [
            'top_hat',
            'tophat',
        ],
        tags: [
            'clothing',
            'hat',
            'top',
            'tophat',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a9.png',
    },
    {
        emoji: '🎓',
        name: 'mortar_board',
        shortcodes: [
            'graduation_cap',
            'mortar_board',
        ],
        tags: [
            'cap',
            'celebration',
            'clothing',
            'graduation',
            'hat',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f393.png',
    },
    {
        emoji: '🧢',
        name: 'billed_cap',
        shortcodes: [
            'billed_cap',
        ],
        tags: [
            'baseball cap',
        ],
        group: 'objects',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e2.png',
    },
    {
        emoji: '🪖',
        name: 'military_helmet',
        shortcodes: [
            'military_helmet',
        ],
        tags: [
            'army',
            'helmet',
            'military',
            'soldier',
            'warrior',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa96.png',
    },
    {
        emoji: '⛑',
        name: 'rescue_worker_helmet',
        shortcodes: [
            'helmet_with_cross',
            'rescue_worker_helmet',
        ],
        tags: [
            'aid',
            'cross',
            'face',
            'hat',
            'helmet',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d1-fe0f.png',
    },
    {
        emoji: '📿',
        name: 'prayer_beads',
        shortcodes: [
            'prayer_beads',
        ],
        tags: [
            'beads',
            'clothing',
            'necklace',
            'prayer',
            'religion',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ff.png',
    },
    {
        emoji: '💄',
        name: 'lipstick',
        shortcodes: [
            'lipstick',
        ],
        tags: [
            'cosmetics',
            'makeup',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f484.png',
    },
    {
        emoji: '💍',
        name: 'ring',
        shortcodes: [
            'ring',
        ],
        tags: [
            'diamond',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48d.png',
    },
    {
        emoji: '💎',
        name: 'gem',
        shortcodes: [
            'gem',
        ],
        tags: [
            'diamond',
            'gem',
            'jewel',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48e.png',
    },
    {
        emoji: '🔇',
        name: 'mute',
        shortcodes: [
            'mute',
            'no_sound',
        ],
        tags: [
            'mute',
            'quiet',
            'silent',
            'speaker',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f507.png',
    },
    {
        emoji: '🔈',
        name: 'speaker',
        shortcodes: [
            'low_volume',
            'quiet_sound',
            'speaker',
        ],
        tags: [
            'soft',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f508.png',
    },
    {
        emoji: '🔉',
        name: 'sound',
        shortcodes: [
            'medium_volumne',
            'sound',
        ],
        tags: [
            'medium',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f509.png',
    },
    {
        emoji: '🔊',
        name: 'loud_sound',
        shortcodes: [
            'high_volume',
            'loud_sound',
        ],
        tags: [
            'loud',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50a.png',
    },
    {
        emoji: '📢',
        name: 'loudspeaker',
        shortcodes: [
            'loudspeaker',
        ],
        tags: [
            'loud',
            'public address',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e2.png',
    },
    {
        emoji: '📣',
        name: 'mega',
        shortcodes: [
            'mega',
            'megaphone',
        ],
        tags: [
            'cheering',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e3.png',
    },
    {
        emoji: '📯',
        name: 'postal_horn',
        shortcodes: [
            'postal_horn',
        ],
        tags: [
            'horn',
            'post',
            'postal',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ef.png',
    },
    {
        emoji: '🔔',
        name: 'bell',
        shortcodes: [
            'bell',
        ],
        tags: [
            'bell',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f514.png',
    },
    {
        emoji: '🔕',
        name: 'no_bell',
        shortcodes: [
            'no_bell',
        ],
        tags: [
            'bell',
            'forbidden',
            'mute',
            'quiet',
            'silent',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f515.png',
    },
    {
        emoji: '🎼',
        name: 'musical_score',
        shortcodes: [
            'musical_score',
        ],
        tags: [
            'music',
            'score',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bc.png',
    },
    {
        emoji: '🎵',
        name: 'musical_note',
        shortcodes: [
            'musical_note',
        ],
        tags: [
            'music',
            'note',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b5.png',
    },
    {
        emoji: '🎶',
        name: 'notes',
        shortcodes: [
            'musical_notes',
            'notes',
        ],
        tags: [
            'music',
            'note',
            'notes',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b6.png',
    },
    {
        emoji: '🎙',
        name: 'studio_microphone',
        shortcodes: [
            'studio_microphone',
        ],
        tags: [
            'mic',
            'microphone',
            'music',
            'studio',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f399-fe0f.png',
    },
    {
        emoji: '🎚',
        name: 'level_slider',
        shortcodes: [
            'level_slider',
        ],
        tags: [
            'level',
            'music',
            'slider',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39a-fe0f.png',
    },
    {
        emoji: '🎛',
        name: 'control_knobs',
        shortcodes: [
            'control_knobs',
        ],
        tags: [
            'control',
            'knobs',
            'music',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39b-fe0f.png',
    },
    {
        emoji: '🎤',
        name: 'microphone',
        shortcodes: [
            'microphone',
        ],
        tags: [
            'karaoke',
            'mic',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a4.png',
    },
    {
        emoji: '🎧',
        name: 'headphones',
        shortcodes: [
            'headphones',
        ],
        tags: [
            'earbud',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a7.png',
    },
    {
        emoji: '📻',
        name: 'radio',
        shortcodes: [
            'radio',
        ],
        tags: [
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fb.png',
    },
    {
        emoji: '🎷',
        name: 'saxophone',
        shortcodes: [
            'saxophone',
        ],
        tags: [
            'instrument',
            'music',
            'sax',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b7.png',
    },
    {
        emoji: '🪗',
        name: 'accordion',
        shortcodes: [
            'accordion',
        ],
        tags: [
            'concertina',
            'squeeze box',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa97.png',
    },
    {
        emoji: '🎸',
        name: 'guitar',
        shortcodes: [
            'guitar',
        ],
        tags: [
            'instrument',
            'music',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b8.png',
    },
    {
        emoji: '🎹',
        name: 'musical_keyboard',
        shortcodes: [
            'musical_keyboard',
        ],
        tags: [
            'instrument',
            'keyboard',
            'music',
            'piano',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b9.png',
    },
    {
        emoji: '🎺',
        name: 'trumpet',
        shortcodes: [
            'trumpet',
        ],
        tags: [
            'instrument',
            'music',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ba.png',
    },
    {
        emoji: '🎻',
        name: 'violin',
        shortcodes: [
            'violin',
        ],
        tags: [
            'instrument',
            'music',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bb.png',
    },
    {
        emoji: '🪕',
        name: 'banjo',
        shortcodes: [
            'banjo',
        ],
        tags: [
            'music',
            'stringed',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa95.png',
    },
    {
        emoji: '🥁',
        name: 'drum',
        shortcodes: [
            'drum',
        ],
        tags: [
            'drumsticks',
            'music',
        ],
        group: 'objects',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f941.png',
    },
    {
        emoji: '🪘',
        name: 'long_drum',
        shortcodes: [
            'long_drum',
        ],
        tags: [
            'beat',
            'conga',
            'drum',
            'rhythm',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa98.png',
    },
    {
        emoji: '📱',
        name: 'iphone',
        shortcodes: [
            'android',
            'iphone',
            'mobile_phone',
        ],
        tags: [
            'cell',
            'mobile',
            'phone',
            'telephone',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f1.png',
    },
    {
        emoji: '📲',
        name: 'calling',
        shortcodes: [
            'calling',
            'mobile_phone_arrow',
        ],
        tags: [
            'arrow',
            'cell',
            'mobile',
            'phone',
            'receive',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f2.png',
    },
    {
        emoji: '☎',
        name: 'phone',
        shortcodes: [
            'telephone',
        ],
        tags: [
            'phone',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/260e-fe0f.png',
    },
    {
        emoji: '📞',
        name: 'telephone_receiver',
        shortcodes: [
            'telephone_receiver',
        ],
        tags: [
            'phone',
            'receiver',
            'telephone',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4de.png',
    },
    {
        emoji: '📟',
        name: 'pager',
        shortcodes: [
            'pager',
        ],
        tags: [
            'pager',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4df.png',
    },
    {
        emoji: '📠',
        name: 'fax',
        shortcodes: [
            'fax',
            'fax_machine',
        ],
        tags: [
            'fax',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e0.png',
    },
    {
        emoji: '🔋',
        name: 'battery',
        shortcodes: [
            'battery',
        ],
        tags: [
            'battery',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50b.png',
    },
    {
        emoji: '🔌',
        name: 'electric_plug',
        shortcodes: [
            'electric_plug',
        ],
        tags: [
            'electric',
            'electricity',
            'plug',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50c.png',
    },
    {
        emoji: '💻',
        name: 'computer',
        shortcodes: [
            'laptop',
        ],
        tags: [
            'computer',
            'pc',
            'personal',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bb.png',
    },
    {
        emoji: '🖥',
        name: 'desktop_computer',
        shortcodes: [
            'computer',
            'desktop_computer',
        ],
        tags: [
            'computer',
            'desktop',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a5-fe0f.png',
    },
    {
        emoji: '🖨',
        name: 'printer',
        shortcodes: [
            'printer',
        ],
        tags: [
            'computer',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a8-fe0f.png',
    },
    {
        emoji: '⌨',
        name: 'keyboard',
        shortcodes: [
            'keyboard',
        ],
        tags: [
            'computer',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2328-fe0f.png',
    },
    {
        emoji: '🖱',
        name: 'computer_mouse',
        shortcodes: [
            'computer_mouse',
        ],
        tags: [
            'computer',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5b1-fe0f.png',
    },
    {
        emoji: '🖲',
        name: 'trackball',
        shortcodes: [
            'trackball',
        ],
        tags: [
            'computer',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5b2-fe0f.png',
    },
    {
        emoji: '💽',
        name: 'minidisc',
        shortcodes: [
            'computer_disk',
            'minidisc',
        ],
        tags: [
            'computer',
            'disk',
            'minidisk',
            'optical',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bd.png',
    },
    {
        emoji: '💾',
        name: 'floppy_disk',
        shortcodes: [
            'floppy_disk',
        ],
        tags: [
            'computer',
            'disk',
            'floppy',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4be.png',
    },
    {
        emoji: '💿',
        name: 'cd',
        shortcodes: [
            'cd',
            'optical_disk',
        ],
        tags: [
            'cd',
            'computer',
            'disk',
            'optical',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bf.png',
    },
    {
        emoji: '📀',
        name: 'dvd',
        shortcodes: [
            'dvd',
        ],
        tags: [
            'blu-ray',
            'computer',
            'disk',
            'optical',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c0.png',
    },
    {
        emoji: '🧮',
        name: 'abacus',
        shortcodes: [
            'abacus',
        ],
        tags: [
            'calculation',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ee.png',
    },
    {
        emoji: '🎥',
        name: 'movie_camera',
        shortcodes: [
            'movie_camera',
        ],
        tags: [
            'camera',
            'cinema',
            'movie',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a5.png',
    },
    {
        emoji: '🎞',
        name: 'film_strip',
        shortcodes: [
            'film_frames',
        ],
        tags: [
            'cinema',
            'film',
            'frames',
            'movie',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39e-fe0f.png',
    },
    {
        emoji: '📽',
        name: 'film_projector',
        shortcodes: [
            'film_projector',
        ],
        tags: [
            'cinema',
            'film',
            'movie',
            'projector',
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fd-fe0f.png',
    },
    {
        emoji: '🎬',
        name: 'clapper',
        shortcodes: [
            'clapper',
        ],
        tags: [
            'clapper',
            'movie',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ac.png',
    },
    {
        emoji: '📺',
        name: 'tv',
        shortcodes: [
            'tv',
        ],
        tags: [
            'tv',
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fa.png',
    },
    {
        emoji: '📷',
        name: 'camera',
        shortcodes: [
            'camera',
        ],
        tags: [
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f7.png',
    },
    {
        emoji: '📸',
        name: 'camera_flash',
        shortcodes: [
            'camera_with_flash',
        ],
        tags: [
            'camera',
            'flash',
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f8.png',
    },
    {
        emoji: '📹',
        name: 'video_camera',
        shortcodes: [
            'video_camera',
        ],
        tags: [
            'camera',
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f9.png',
    },
    {
        emoji: '📼',
        name: 'vhs',
        shortcodes: [
            'vhs',
            'videocassette',
        ],
        tags: [
            'tape',
            'vhs',
            'video',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fc.png',
    },
    {
        emoji: '🔍',
        name: 'mag',
        shortcodes: [
            'mag',
        ],
        tags: [
            'glass',
            'magnifying',
            'search',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50d.png',
    },
    {
        emoji: '🔎',
        name: 'mag_right',
        shortcodes: [
            'mag_right',
        ],
        tags: [
            'glass',
            'magnifying',
            'search',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50e.png',
    },
    {
        emoji: '🕯',
        name: 'candle',
        shortcodes: [
            'candle',
        ],
        tags: [
            'light',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f56f-fe0f.png',
    },
    {
        emoji: '💡',
        name: 'bulb',
        shortcodes: [
            'bulb',
            'light_bulb',
        ],
        tags: [
            'bulb',
            'comic',
            'electric',
            'idea',
            'light',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a1.png',
    },
    {
        emoji: '🔦',
        name: 'flashlight',
        shortcodes: [
            'flashlight',
        ],
        tags: [
            'electric',
            'light',
            'tool',
            'torch',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f526.png',
    },
    {
        emoji: '🏮',
        name: 'izakaya_lantern',
        shortcodes: [
            'izakaya_lantern',
            'red_paper_lantern',
        ],
        tags: [
            'bar',
            'lantern',
            'light',
            'red',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ee.png',
    },
    {
        emoji: '🪔',
        name: 'diya_lamp',
        shortcodes: [
            'diya_lamp',
        ],
        tags: [
            'diya',
            'lamp',
            'oil',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa94.png',
    },
    {
        emoji: '📔',
        name: 'notebook_with_decorative_cover',
        shortcodes: [
            'notebook_with_decorative_cover',
        ],
        tags: [
            'book',
            'cover',
            'decorated',
            'notebook',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d4.png',
    },
    {
        emoji: '📕',
        name: 'closed_book',
        shortcodes: [
            'closed_book',
        ],
        tags: [
            'book',
            'closed',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d5.png',
    },
    {
        emoji: '📖',
        name: 'book',
        shortcodes: [
            'book',
            'open_book',
        ],
        tags: [
            'book',
            'open',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d6.png',
    },
    {
        emoji: '📗',
        name: 'green_book',
        shortcodes: [
            'green_book',
        ],
        tags: [
            'book',
            'green',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d7.png',
    },
    {
        emoji: '📘',
        name: 'blue_book',
        shortcodes: [
            'blue_book',
        ],
        tags: [
            'blue',
            'book',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d8.png',
    },
    {
        emoji: '📙',
        name: 'orange_book',
        shortcodes: [
            'orange_book',
        ],
        tags: [
            'book',
            'orange',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d9.png',
    },
    {
        emoji: '📚',
        name: 'books',
        shortcodes: [
            'books',
        ],
        tags: [
            'book',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4da.png',
    },
    {
        emoji: '📓',
        name: 'notebook',
        shortcodes: [
            'notebook',
        ],
        tags: [
            'notebook',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d3.png',
    },
    {
        emoji: '📒',
        name: 'ledger',
        shortcodes: [
            'ledger',
        ],
        tags: [
            'notebook',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d2.png',
    },
    {
        emoji: '📃',
        name: 'page_with_curl',
        shortcodes: [
            'page_with_curl',
        ],
        tags: [
            'curl',
            'document',
            'page',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c3.png',
    },
    {
        emoji: '📜',
        name: 'scroll',
        shortcodes: [
            'scroll',
        ],
        tags: [
            'paper',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4dc.png',
    },
    {
        emoji: '📄',
        name: 'page_facing_up',
        shortcodes: [
            'page_facing_up',
        ],
        tags: [
            'document',
            'page',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c4.png',
    },
    {
        emoji: '📰',
        name: 'newspaper',
        shortcodes: [
            'newspaper',
        ],
        tags: [
            'news',
            'paper',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f0.png',
    },
    {
        emoji: '🗞',
        name: 'newspaper_roll',
        shortcodes: [
            'rolled_up_newspaper',
        ],
        tags: [
            'news',
            'newspaper',
            'paper',
            'rolled',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5de-fe0f.png',
    },
    {
        emoji: '📑',
        name: 'bookmark_tabs',
        shortcodes: [
            'bookmark_tabs',
        ],
        tags: [
            'bookmark',
            'mark',
            'marker',
            'tabs',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d1.png',
    },
    {
        emoji: '🔖',
        name: 'bookmark',
        shortcodes: [
            'bookmark',
        ],
        tags: [
            'mark',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f516.png',
    },
    {
        emoji: '🏷',
        name: 'label',
        shortcodes: [
            'label',
        ],
        tags: [
            'label',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f7-fe0f.png',
    },
    {
        emoji: '💰',
        name: 'moneybag',
        shortcodes: [
            'moneybag',
        ],
        tags: [
            'bag',
            'dollar',
            'money',
            'moneybag',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b0.png',
    },
    {
        emoji: '🪙',
        name: 'coin',
        shortcodes: [
            'coin',
        ],
        tags: [
            'gold',
            'metal',
            'money',
            'silver',
            'treasure',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa99.png',
    },
    {
        emoji: '💴',
        name: 'yen',
        shortcodes: [
            'yen',
        ],
        tags: [
            'banknote',
            'bill',
            'currency',
            'money',
            'note',
            'yen',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b4.png',
    },
    {
        emoji: '💵',
        name: 'dollar',
        shortcodes: [
            'dollar',
        ],
        tags: [
            'banknote',
            'bill',
            'currency',
            'dollar',
            'money',
            'note',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b5.png',
    },
    {
        emoji: '💶',
        name: 'euro',
        shortcodes: [
            'euro',
        ],
        tags: [
            'banknote',
            'bill',
            'currency',
            'euro',
            'money',
            'note',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b6.png',
    },
    {
        emoji: '💷',
        name: 'pound',
        shortcodes: [
            'pound',
        ],
        tags: [
            'banknote',
            'bill',
            'currency',
            'money',
            'note',
            'pound',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b7.png',
    },
    {
        emoji: '💸',
        name: 'money_with_wings',
        shortcodes: [
            'money_with_wings',
        ],
        tags: [
            'banknote',
            'bill',
            'fly',
            'money',
            'wings',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b8.png',
    },
    {
        emoji: '💳',
        name: 'credit_card',
        shortcodes: [
            'credit_card',
        ],
        tags: [
            'card',
            'credit',
            'money',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b3.png',
    },
    {
        emoji: '🧾',
        name: 'receipt',
        shortcodes: [
            'receipt',
        ],
        tags: [
            'accounting',
            'bookkeeping',
            'evidence',
            'proof',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fe.png',
    },
    {
        emoji: '💹',
        name: 'chart',
        shortcodes: [
            'chart',
        ],
        tags: [
            'chart',
            'graph',
            'growth',
            'money',
            'yen',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b9.png',
    },
    {
        emoji: '✉',
        name: 'envelope',
        shortcodes: [
            'envelope',
        ],
        tags: [
            'email',
            'letter',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2709-fe0f.png',
    },
    {
        emoji: '📧',
        name: 'e-mail',
        shortcodes: [
            'e-mail',
            'email',
        ],
        tags: [
            'email',
            'letter',
            'mail',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e7.png',
    },
    {
        emoji: '📨',
        name: 'incoming_envelope',
        shortcodes: [
            'incoming_envelope',
        ],
        tags: [
            'e-mail',
            'email',
            'envelope',
            'incoming',
            'letter',
            'receive',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e8.png',
    },
    {
        emoji: '📩',
        name: 'envelope_with_arrow',
        shortcodes: [
            'envelope_with_arrow',
        ],
        tags: [
            'arrow',
            'e-mail',
            'email',
            'envelope',
            'outgoing',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e9.png',
    },
    {
        emoji: '📤',
        name: 'outbox_tray',
        shortcodes: [
            'outbox_tray',
        ],
        tags: [
            'box',
            'letter',
            'mail',
            'outbox',
            'sent',
            'tray',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e4.png',
    },
    {
        emoji: '📥',
        name: 'inbox_tray',
        shortcodes: [
            'inbox_tray',
        ],
        tags: [
            'box',
            'inbox',
            'letter',
            'mail',
            'receive',
            'tray',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e5.png',
    },
    {
        emoji: '📦',
        name: 'package',
        shortcodes: [
            'package',
        ],
        tags: [
            'box',
            'parcel',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e6.png',
    },
    {
        emoji: '📫',
        name: 'mailbox',
        shortcodes: [
            'mailbox',
        ],
        tags: [
            'closed',
            'mail',
            'mailbox',
            'postbox',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4eb.png',
    },
    {
        emoji: '📪',
        name: 'mailbox_closed',
        shortcodes: [
            'mailbox_closed',
        ],
        tags: [
            'closed',
            'lowered',
            'mail',
            'mailbox',
            'postbox',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ea.png',
    },
    {
        emoji: '📬',
        name: 'mailbox_with_mail',
        shortcodes: [
            'mailbox_with_mail',
        ],
        tags: [
            'mail',
            'mailbox',
            'open',
            'postbox',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ec.png',
    },
    {
        emoji: '📭',
        name: 'mailbox_with_no_mail',
        shortcodes: [
            'mailbox_with_no_mail',
        ],
        tags: [
            'lowered',
            'mail',
            'mailbox',
            'open',
            'postbox',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ed.png',
    },
    {
        emoji: '📮',
        name: 'postbox',
        shortcodes: [
            'postbox',
        ],
        tags: [
            'mail',
            'mailbox',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ee.png',
    },
    {
        emoji: '🗳',
        name: 'ballot_box',
        shortcodes: [
            'ballot_box',
        ],
        tags: [
            'ballot',
            'box',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5f3-fe0f.png',
    },
    {
        emoji: '✏',
        name: 'pencil2',
        shortcodes: [
            'pencil',
        ],
        tags: [
            'pencil',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270f-fe0f.png',
    },
    {
        emoji: '✒',
        name: 'black_nib',
        shortcodes: [
            'black_nib',
        ],
        tags: [
            'nib',
            'pen',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2712-fe0f.png',
    },
    {
        emoji: '🖋',
        name: 'fountain_pen',
        shortcodes: [
            'fountain_pen',
        ],
        tags: [
            'fountain',
            'pen',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58b-fe0f.png',
    },
    {
        emoji: '🖊',
        name: 'pen',
        shortcodes: [
            'pen',
        ],
        tags: [
            'ballpoint',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58a-fe0f.png',
    },
    {
        emoji: '🖌',
        name: 'paintbrush',
        shortcodes: [
            'paintbrush',
        ],
        tags: [
            'painting',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58c-fe0f.png',
    },
    {
        emoji: '🖍',
        name: 'crayon',
        shortcodes: [
            'crayon',
        ],
        tags: [
            'crayon',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58d-fe0f.png',
    },
    {
        emoji: '📝',
        name: 'memo',
        shortcodes: [
            'memo',
        ],
        tags: [
            'pencil',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4dd.png',
    },
    {
        emoji: '💼',
        name: 'briefcase',
        shortcodes: [
            'briefcase',
        ],
        tags: [
            'briefcase',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bc.png',
    },
    {
        emoji: '📁',
        name: 'file_folder',
        shortcodes: [
            'file_folder',
        ],
        tags: [
            'file',
            'folder',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c1.png',
    },
    {
        emoji: '📂',
        name: 'open_file_folder',
        shortcodes: [
            'open_file_folder',
        ],
        tags: [
            'file',
            'folder',
            'open',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c2.png',
    },
    {
        emoji: '🗂',
        name: 'card_index_dividers',
        shortcodes: [
            'card_index_dividers',
        ],
        tags: [
            'card',
            'dividers',
            'index',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c2-fe0f.png',
    },
    {
        emoji: '📅',
        name: 'date',
        shortcodes: [
            'date',
        ],
        tags: [
            'date',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c5.png',
    },
    {
        emoji: '📆',
        name: 'calendar',
        shortcodes: [
            'calendar',
        ],
        tags: [
            'calendar',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c6.png',
    },
    {
        emoji: '🗒',
        name: 'spiral_notepad',
        shortcodes: [
            'notepad_spiral',
        ],
        tags: [
            'note',
            'pad',
            'spiral',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d2-fe0f.png',
    },
    {
        emoji: '🗓',
        name: 'spiral_calendar',
        shortcodes: [
            'calendar_spiral',
        ],
        tags: [
            'calendar',
            'pad',
            'spiral',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d3-fe0f.png',
    },
    {
        emoji: '📇',
        name: 'card_index',
        shortcodes: [
            'card_index',
        ],
        tags: [
            'card',
            'index',
            'rolodex',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c7.png',
    },
    {
        emoji: '📈',
        name: 'chart_with_upwards_trend',
        shortcodes: [
            'chart_increasing',
            'chart_with_upwards_trend',
        ],
        tags: [
            'chart',
            'graph',
            'growth',
            'trend',
            'upward',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c8.png',
    },
    {
        emoji: '📉',
        name: 'chart_with_downwards_trend',
        shortcodes: [
            'chart_decreasing',
            'chart_with_downwards_trend',
        ],
        tags: [
            'chart',
            'down',
            'graph',
            'trend',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c9.png',
    },
    {
        emoji: '📊',
        name: 'bar_chart',
        shortcodes: [
            'bar_chart',
        ],
        tags: [
            'bar',
            'chart',
            'graph',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ca.png',
    },
    {
        emoji: '📋',
        name: 'clipboard',
        shortcodes: [
            'clipboard',
        ],
        tags: [
            'clipboard',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cb.png',
    },
    {
        emoji: '📌',
        name: 'pushpin',
        shortcodes: [
            'pushpin',
        ],
        tags: [
            'pin',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cc.png',
    },
    {
        emoji: '📍',
        name: 'round_pushpin',
        shortcodes: [
            'round_pushpin',
        ],
        tags: [
            'pin',
            'pushpin',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cd.png',
    },
    {
        emoji: '📎',
        name: 'paperclip',
        shortcodes: [
            'paperclip',
        ],
        tags: [
            'paperclip',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ce.png',
    },
    {
        emoji: '🖇',
        name: 'paperclips',
        shortcodes: [
            'paperclips',
        ],
        tags: [
            'link',
            'paperclip',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f587-fe0f.png',
    },
    {
        emoji: '📏',
        name: 'straight_ruler',
        shortcodes: [
            'straight_ruler',
        ],
        tags: [
            'ruler',
            'straight edge',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cf.png',
    },
    {
        emoji: '📐',
        name: 'triangular_ruler',
        shortcodes: [
            'triangular_ruler',
        ],
        tags: [
            'ruler',
            'set',
            'triangle',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d0.png',
    },
    {
        emoji: '✂',
        name: 'scissors',
        shortcodes: [
            'scissors',
        ],
        tags: [
            'cutting',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2702-fe0f.png',
    },
    {
        emoji: '🗃',
        name: 'card_file_box',
        shortcodes: [
            'card_file_box',
        ],
        tags: [
            'box',
            'card',
            'file',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c3-fe0f.png',
    },
    {
        emoji: '🗄',
        name: 'file_cabinet',
        shortcodes: [
            'file_cabinet',
        ],
        tags: [
            'cabinet',
            'file',
            'filing',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c4-fe0f.png',
    },
    {
        emoji: '🗑',
        name: 'wastebasket',
        shortcodes: [
            'trashcan',
            'wastebasket',
        ],
        tags: [
            'wastebasket',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d1-fe0f.png',
    },
    {
        emoji: '🔒',
        name: 'lock',
        shortcodes: [
            'lock',
            'locked',
        ],
        tags: [
            'closed',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f512.png',
    },
    {
        emoji: '🔓',
        name: 'unlock',
        shortcodes: [
            'unlock',
            'unlocked',
        ],
        tags: [
            'lock',
            'open',
            'unlock',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f513.png',
    },
    {
        emoji: '🔏',
        name: 'lock_with_ink_pen',
        shortcodes: [
            'lock_with_ink_pen',
            'locked_with_pen',
        ],
        tags: [
            'ink',
            'lock',
            'nib',
            'pen',
            'privacy',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50f.png',
    },
    {
        emoji: '🔐',
        name: 'closed_lock_with_key',
        shortcodes: [
            'closed_lock_with_key',
            'locked_with_key',
        ],
        tags: [
            'closed',
            'key',
            'lock',
            'secure',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f510.png',
    },
    {
        emoji: '🔑',
        name: 'key',
        shortcodes: [
            'key',
        ],
        tags: [
            'lock',
            'password',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f511.png',
    },
    {
        emoji: '🗝',
        name: 'old_key',
        shortcodes: [
            'old_key',
        ],
        tags: [
            'clue',
            'key',
            'lock',
            'old',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5dd-fe0f.png',
    },
    {
        emoji: '🔨',
        name: 'hammer',
        shortcodes: [
            'hammer',
        ],
        tags: [
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f528.png',
    },
    {
        emoji: '🪓',
        name: 'axe',
        shortcodes: [
            'axe',
        ],
        tags: [
            'chop',
            'hatchet',
            'split',
            'wood',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa93.png',
    },
    {
        emoji: '⛏',
        name: 'pick',
        shortcodes: [
            'pick',
        ],
        tags: [
            'mining',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26cf-fe0f.png',
    },
    {
        emoji: '⚒',
        name: 'hammer_and_pick',
        shortcodes: [
            'hammer_and_pick',
        ],
        tags: [
            'hammer',
            'pick',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2692-fe0f.png',
    },
    {
        emoji: '🛠',
        name: 'hammer_and_wrench',
        shortcodes: [
            'hammer_and_wrench',
        ],
        tags: [
            'hammer',
            'spanner',
            'tool',
            'wrench',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e0-fe0f.png',
    },
    {
        emoji: '🗡',
        name: 'dagger',
        shortcodes: [
            'dagger',
        ],
        tags: [
            'knife',
            'weapon',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e1-fe0f.png',
    },
    {
        emoji: '⚔',
        name: 'crossed_swords',
        shortcodes: [
            'crossed_swords',
        ],
        tags: [
            'crossed',
            'swords',
            'weapon',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2694-fe0f.png',
    },
    {
        emoji: '🔫',
        name: 'gun',
        shortcodes: [
            'gun',
            'pistol',
        ],
        tags: [
            'gun',
            'handgun',
            'pistol',
            'revolver',
            'tool',
            'water',
            'weapon',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52b.png',
    },
    {
        emoji: '🪃',
        name: 'boomerang',
        shortcodes: [
            'boomerang',
        ],
        tags: [
            'australia',
            'rebound',
            'repercussion',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa83.png',
    },
    {
        emoji: '🏹',
        name: 'bow_and_arrow',
        shortcodes: [
            'bow_and_arrow',
        ],
        tags: [
            'archer',
            'arrow',
            'bow',
            'sagittarius',
            'zodiac',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f9.png',
    },
    {
        emoji: '🛡',
        name: 'shield',
        shortcodes: [
            'shield',
        ],
        tags: [
            'weapon',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e1-fe0f.png',
    },
    {
        emoji: '🪚',
        name: 'carpentry_saw',
        shortcodes: [
            'carpentry_saw',
        ],
        tags: [
            'carpenter',
            'lumber',
            'saw',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9a.png',
    },
    {
        emoji: '🔧',
        name: 'wrench',
        shortcodes: [
            'wrench',
        ],
        tags: [
            'spanner',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f527.png',
    },
    {
        emoji: '🪛',
        name: 'screwdriver',
        shortcodes: [
            'screwdriver',
        ],
        tags: [
            'screw',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9b.png',
    },
    {
        emoji: '🔩',
        name: 'nut_and_bolt',
        shortcodes: [
            'nut_and_bolt',
        ],
        tags: [
            'bolt',
            'nut',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f529.png',
    },
    {
        emoji: '⚙',
        name: 'gear',
        shortcodes: [
            'gear',
        ],
        tags: [
            'cog',
            'cogwheel',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2699-fe0f.png',
    },
    {
        emoji: '🗜',
        name: 'clamp',
        shortcodes: [
            'clamp',
            'compression',
        ],
        tags: [
            'compress',
            'tool',
            'vice',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5dc-fe0f.png',
    },
    {
        emoji: '⚖',
        name: 'balance_scale',
        shortcodes: [
            'scales',
        ],
        tags: [
            'balance',
            'justice',
            'libra',
            'scale',
            'zodiac',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2696-fe0f.png',
    },
    {
        emoji: '🦯',
        name: 'probing_cane',
        shortcodes: [
            'probing_cane',
            'white_cane',
        ],
        tags: [
            'accessibility',
            'blind',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9af.png',
    },
    {
        emoji: '🔗',
        name: 'link',
        shortcodes: [
            'link',
        ],
        tags: [
            'link',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f517.png',
    },
    {
        emoji: '⛓',
        name: 'chains',
        shortcodes: [
            'chains',
        ],
        tags: [
            'chain',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d3-fe0f.png',
    },
    {
        emoji: '🪝',
        name: 'hook',
        shortcodes: [
            'hook',
        ],
        tags: [
            'catch',
            'crook',
            'curve',
            'ensnare',
            'selling point',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9d.png',
    },
    {
        emoji: '🧰',
        name: 'toolbox',
        shortcodes: [
            'toolbox',
        ],
        tags: [
            'chest',
            'mechanic',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f0.png',
    },
    {
        emoji: '🧲',
        name: 'magnet',
        shortcodes: [
            'magnet',
        ],
        tags: [
            'attraction',
            'horseshoe',
            'magnetic',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f2.png',
    },
    {
        emoji: '🪜',
        name: 'ladder',
        shortcodes: [
            'ladder',
        ],
        tags: [
            'climb',
            'rung',
            'step',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9c.png',
    },
    {
        emoji: '⚗',
        name: 'alembic',
        shortcodes: [
            'alembic',
        ],
        tags: [
            'chemistry',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2697-fe0f.png',
    },
    {
        emoji: '🧪',
        name: 'test_tube',
        shortcodes: [
            'test_tube',
        ],
        tags: [
            'chemist',
            'chemistry',
            'experiment',
            'lab',
            'science',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ea.png',
    },
    {
        emoji: '🧫',
        name: 'petri_dish',
        shortcodes: [
            'petri_dish',
        ],
        tags: [
            'bacteria',
            'biologist',
            'biology',
            'culture',
            'lab',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9eb.png',
    },
    {
        emoji: '🧬',
        name: 'dna',
        shortcodes: [
            'dna',
            'double_helix',
        ],
        tags: [
            'biologist',
            'evolution',
            'gene',
            'genetics',
            'life',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ec.png',
    },
    {
        emoji: '🔬',
        name: 'microscope',
        shortcodes: [
            'microscope',
        ],
        tags: [
            'science',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52c.png',
    },
    {
        emoji: '🔭',
        name: 'telescope',
        shortcodes: [
            'telescope',
        ],
        tags: [
            'science',
            'tool',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52d.png',
    },
    {
        emoji: '📡',
        name: 'satellite',
        shortcodes: [
            'satellite_antenna',
        ],
        tags: [
            'antenna',
            'dish',
            'satellite',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e1.png',
    },
    {
        emoji: '💉',
        name: 'syringe',
        shortcodes: [
            'syringe',
        ],
        tags: [
            'medicine',
            'needle',
            'shot',
            'sick',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f489.png',
    },
    {
        emoji: '🩸',
        name: 'drop_of_blood',
        shortcodes: [
            'drop_of_blood',
        ],
        tags: [
            'bleed',
            'blood donation',
            'injury',
            'medicine',
            'menstruation',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa78.png',
    },
    {
        emoji: '💊',
        name: 'pill',
        shortcodes: [
            'pill',
        ],
        tags: [
            'doctor',
            'medicine',
            'sick',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48a.png',
    },
    {
        emoji: '🩹',
        name: 'adhesive_bandage',
        shortcodes: [
            'adhesive_bandage',
            'bandaid',
        ],
        tags: [
            'bandage',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa79.png',
    },
    {
        emoji: '🩺',
        name: 'stethoscope',
        shortcodes: [
            'stethoscope',
        ],
        tags: [
            'doctor',
            'heart',
            'medicine',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa7a.png',
    },
    {
        emoji: '🚪',
        name: 'door',
        shortcodes: [
            'door',
        ],
        tags: [
            'door',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6aa.png',
    },
    {
        emoji: '🛗',
        name: 'elevator',
        shortcodes: [
            'elevator',
        ],
        tags: [
            'accessibility',
            'hoist',
            'lift',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d7.png',
    },
    {
        emoji: '🪞',
        name: 'mirror',
        shortcodes: [
            'mirror',
        ],
        tags: [
            'reflection',
            'reflector',
            'speculum',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9e.png',
    },
    {
        emoji: '🪟',
        name: 'window',
        shortcodes: [
            'window',
        ],
        tags: [
            'frame',
            'fresh air',
            'opening',
            'transparent',
            'view',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9f.png',
    },
    {
        emoji: '🛏',
        name: 'bed',
        shortcodes: [
            'bed',
        ],
        tags: [
            'hotel',
            'sleep',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cf-fe0f.png',
    },
    {
        emoji: '🛋',
        name: 'couch_and_lamp',
        shortcodes: [
            'couch_and_lamp',
        ],
        tags: [
            'couch',
            'hotel',
            'lamp',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cb-fe0f.png',
    },
    {
        emoji: '🪑',
        name: 'chair',
        shortcodes: [
            'chair',
        ],
        tags: [
            'seat',
            'sit',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa91.png',
    },
    {
        emoji: '🚽',
        name: 'toilet',
        shortcodes: [
            'toilet',
        ],
        tags: [
            'toilet',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bd.png',
    },
    {
        emoji: '🪠',
        name: 'plunger',
        shortcodes: [
            'plunger',
        ],
        tags: [
            'force cup',
            'plumber',
            'suction',
            'toilet',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa0.png',
    },
    {
        emoji: '🚿',
        name: 'shower',
        shortcodes: [
            'shower',
        ],
        tags: [
            'water',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bf.png',
    },
    {
        emoji: '🛁',
        name: 'bathtub',
        shortcodes: [
            'bathtub',
        ],
        tags: [
            'bath',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c1.png',
    },
    {
        emoji: '🪤',
        name: 'mouse_trap',
        shortcodes: [
            'mouse_trap',
        ],
        tags: [
            'bait',
            'mousetrap',
            'snare',
            'trap',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa4.png',
    },
    {
        emoji: '🪒',
        name: 'razor',
        shortcodes: [
            'razor',
        ],
        tags: [
            'sharp',
            'shave',
        ],
        group: 'objects',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa92.png',
    },
    {
        emoji: '🧴',
        name: 'lotion_bottle',
        shortcodes: [
            'lotion_bottle',
        ],
        tags: [
            'lotion',
            'moisturizer',
            'shampoo',
            'sunscreen',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f4.png',
    },
    {
        emoji: '🧷',
        name: 'safety_pin',
        shortcodes: [
            'safety_pin',
        ],
        tags: [
            'diaper',
            'punk rock',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f7.png',
    },
    {
        emoji: '🧹',
        name: 'broom',
        shortcodes: [
            'broom',
        ],
        tags: [
            'cleaning',
            'sweeping',
            'witch',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f9.png',
    },
    {
        emoji: '🧺',
        name: 'basket',
        shortcodes: [
            'basket',
        ],
        tags: [
            'farming',
            'laundry',
            'picnic',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fa.png',
    },
    {
        emoji: '🧻',
        name: 'roll_of_paper',
        shortcodes: [
            'roll_of_paper',
            'toilet_paper',
        ],
        tags: [
            'paper towels',
            'toilet paper',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fb.png',
    },
    {
        emoji: '🪣',
        name: 'bucket',
        shortcodes: [
            'bucket',
        ],
        tags: [
            'cask',
            'pail',
            'vat',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa3.png',
    },
    {
        emoji: '🧼',
        name: 'soap',
        shortcodes: [
            'soap',
        ],
        tags: [
            'bar',
            'bathing',
            'cleaning',
            'lather',
            'soapdish',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fc.png',
    },
    {
        emoji: '🪥',
        name: 'toothbrush',
        shortcodes: [
            'toothbrush',
        ],
        tags: [
            'bathroom',
            'brush',
            'clean',
            'dental',
            'hygiene',
            'teeth',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa5.png',
    },
    {
        emoji: '🧽',
        name: 'sponge',
        shortcodes: [
            'sponge',
        ],
        tags: [
            'absorbing',
            'cleaning',
            'porous',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fd.png',
    },
    {
        emoji: '🧯',
        name: 'fire_extinguisher',
        shortcodes: [
            'fire_extinguisher',
        ],
        tags: [
            'extinguish',
            'fire',
            'quench',
        ],
        group: 'objects',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ef.png',
    },
    {
        emoji: '🛒',
        name: 'shopping_cart',
        shortcodes: [
            'shopping_cart',
        ],
        tags: [
            'cart',
            'shopping',
            'trolley',
        ],
        group: 'objects',
        emoticons: [],
        version: 3,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d2.png',
    },
    {
        emoji: '🚬',
        name: 'smoking',
        shortcodes: [
            'cigarette',
            'smoking',
        ],
        tags: [
            'smoking',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ac.png',
    },
    {
        emoji: '⚰',
        name: 'coffin',
        shortcodes: [
            'coffin',
        ],
        tags: [
            'death',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26b0-fe0f.png',
    },
    {
        emoji: '🪦',
        name: 'headstone',
        shortcodes: [
            'headstone',
        ],
        tags: [
            'cemetery',
            'grave',
            'graveyard',
            'tombstone',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa6.png',
    },
    {
        emoji: '⚱',
        name: 'funeral_urn',
        shortcodes: [
            'funeral_urn',
        ],
        tags: [
            'ashes',
            'death',
            'funeral',
            'urn',
        ],
        group: 'objects',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26b1-fe0f.png',
    },
    {
        emoji: '🗿',
        name: 'moyai',
        shortcodes: [
            'moai',
            'moyai',
        ],
        tags: [
            'face',
            'moyai',
            'statue',
        ],
        group: 'objects',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5ff.png',
    },
    {
        emoji: '🪧',
        name: 'placard',
        shortcodes: [
            'placard',
        ],
        tags: [
            'demonstration',
            'picket',
            'protest',
            'sign',
        ],
        group: 'objects',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa7.png',
    },
    {
        emoji: '🏧',
        name: 'atm',
        shortcodes: [
            'atm',
        ],
        tags: [
            'atm',
            'atm sign',
            'automated',
            'bank',
            'teller',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e7.png',
    },
    {
        emoji: '🚮',
        name: 'put_litter_in_its_place',
        shortcodes: [
            'litter_bin',
            'put_litter_in_its_place',
        ],
        tags: [
            'litter',
            'litter bin',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ae.png',
    },
    {
        emoji: '🚰',
        name: 'potable_water',
        shortcodes: [
            'potable_water',
        ],
        tags: [
            'drinking',
            'potable',
            'water',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b0.png',
    },
    {
        emoji: '♿',
        name: 'wheelchair',
        shortcodes: [
            'handicapped',
            'wheelchair',
        ],
        tags: [
            'access',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267f.png',
    },
    {
        emoji: '🚹',
        name: 'mens',
        shortcodes: [
            'mens',
        ],
        tags: [
            'bathroom',
            'lavatory',
            'man',
            'restroom',
            'toilet',
            'wc',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b9.png',
    },
    {
        emoji: '🚺',
        name: 'womens',
        shortcodes: [
            'womens',
        ],
        tags: [
            'bathroom',
            'lavatory',
            'restroom',
            'toilet',
            'wc',
            'woman',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ba.png',
    },
    {
        emoji: '🚻',
        name: 'restroom',
        shortcodes: [
            'bathroom',
            'restroom',
        ],
        tags: [
            'bathroom',
            'lavatory',
            'toilet',
            'wc',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bb.png',
    },
    {
        emoji: '🚼',
        name: 'baby_symbol',
        shortcodes: [
            'baby_symbol',
        ],
        tags: [
            'baby',
            'changing',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bc.png',
    },
    {
        emoji: '🚾',
        name: 'wc',
        shortcodes: [
            'water_closet',
            'wc',
        ],
        tags: [
            'bathroom',
            'closet',
            'lavatory',
            'restroom',
            'toilet',
            'water',
            'wc',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6be.png',
    },
    {
        emoji: '🛂',
        name: 'passport_control',
        shortcodes: [
            'passport_control',
        ],
        tags: [
            'control',
            'passport',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c2.png',
    },
    {
        emoji: '🛃',
        name: 'customs',
        shortcodes: [
            'customs',
        ],
        tags: [
            'customs',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c3.png',
    },
    {
        emoji: '🛄',
        name: 'baggage_claim',
        shortcodes: [
            'baggage_claim',
        ],
        tags: [
            'baggage',
            'claim',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c4.png',
    },
    {
        emoji: '🛅',
        name: 'left_luggage',
        shortcodes: [
            'left_luggage',
        ],
        tags: [
            'baggage',
            'locker',
            'luggage',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c5.png',
    },
    {
        emoji: '⚠',
        name: 'warning',
        shortcodes: [
            'warning',
        ],
        tags: [
            'warning',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a0-fe0f.png',
    },
    {
        emoji: '🚸',
        name: 'children_crossing',
        shortcodes: [
            'children_crossing',
        ],
        tags: [
            'child',
            'crossing',
            'pedestrian',
            'traffic',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b8.png',
    },
    {
        emoji: '⛔',
        name: 'no_entry',
        shortcodes: [
            'no_entry',
        ],
        tags: [
            'entry',
            'forbidden',
            'no',
            'not',
            'prohibited',
            'traffic',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d4.png',
    },
    {
        emoji: '🚫',
        name: 'no_entry_sign',
        shortcodes: [
            'no_entry_sign',
        ],
        tags: [
            'entry',
            'forbidden',
            'no',
            'not',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ab.png',
    },
    {
        emoji: '🚳',
        name: 'no_bicycles',
        shortcodes: [
            'no_bicycles',
        ],
        tags: [
            'bicycle',
            'bike',
            'forbidden',
            'no',
            'prohibited',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b3.png',
    },
    {
        emoji: '🚭',
        name: 'no_smoking',
        shortcodes: [
            'no_smoking',
        ],
        tags: [
            'forbidden',
            'no',
            'not',
            'prohibited',
            'smoking',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ad.png',
    },
    {
        emoji: '🚯',
        name: 'do_not_litter',
        shortcodes: [
            'do_not_litter',
            'no_littering',
        ],
        tags: [
            'forbidden',
            'litter',
            'no',
            'not',
            'prohibited',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6af.png',
    },
    {
        emoji: '🚱',
        name: 'non-potable_water',
        shortcodes: [
            'non-potable_water',
        ],
        tags: [
            'non-drinking',
            'non-potable',
            'water',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b1.png',
    },
    {
        emoji: '🚷',
        name: 'no_pedestrians',
        shortcodes: [
            'no_pedestrians',
        ],
        tags: [
            'forbidden',
            'no',
            'not',
            'pedestrian',
            'prohibited',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b7.png',
    },
    {
        emoji: '📵',
        name: 'no_mobile_phones',
        shortcodes: [
            'no_mobile_phones',
        ],
        tags: [
            'cell',
            'forbidden',
            'mobile',
            'no',
            'phone',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f5.png',
    },
    {
        emoji: '🔞',
        name: 'underage',
        shortcodes: [
            'no_one_under_18',
            'underage',
        ],
        tags: [
            '18',
            'age restriction',
            'eighteen',
            'prohibited',
            'underage',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51e.png',
    },
    {
        emoji: '☢',
        name: 'radioactive',
        shortcodes: [
            'radioactive',
        ],
        tags: [
            'sign',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2622-fe0f.png',
    },
    {
        emoji: '☣',
        name: 'biohazard',
        shortcodes: [
            'biohazard',
        ],
        tags: [
            'sign',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2623-fe0f.png',
    },
    {
        emoji: '⬆',
        name: 'arrow_up',
        shortcodes: [
            'arrow_up',
        ],
        tags: [
            'arrow',
            'cardinal',
            'direction',
            'north',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b06-fe0f.png',
    },
    {
        emoji: '↗',
        name: 'arrow_upper_right',
        shortcodes: [
            'arrow_upper_right',
        ],
        tags: [
            'arrow',
            'direction',
            'intercardinal',
            'northeast',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2197-fe0f.png',
    },
    {
        emoji: '➡',
        name: 'arrow_right',
        shortcodes: [
            'arrow_right',
        ],
        tags: [
            'arrow',
            'cardinal',
            'direction',
            'east',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27a1-fe0f.png',
    },
    {
        emoji: '↘',
        name: 'arrow_lower_right',
        shortcodes: [
            'arrow_lower_right',
        ],
        tags: [
            'arrow',
            'direction',
            'intercardinal',
            'southeast',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2198-fe0f.png',
    },
    {
        emoji: '⬇',
        name: 'arrow_down',
        shortcodes: [
            'arrow_down',
        ],
        tags: [
            'arrow',
            'cardinal',
            'direction',
            'down',
            'south',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b07-fe0f.png',
    },
    {
        emoji: '↙',
        name: 'arrow_lower_left',
        shortcodes: [
            'arrow_lower_left',
        ],
        tags: [
            'arrow',
            'direction',
            'intercardinal',
            'southwest',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2199-fe0f.png',
    },
    {
        emoji: '⬅',
        name: 'arrow_left',
        shortcodes: [
            'arrow_left',
        ],
        tags: [
            'arrow',
            'cardinal',
            'direction',
            'west',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b05-fe0f.png',
    },
    {
        emoji: '↖',
        name: 'arrow_upper_left',
        shortcodes: [
            'arrow_upper_left',
        ],
        tags: [
            'arrow',
            'direction',
            'intercardinal',
            'northwest',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2196-fe0f.png',
    },
    {
        emoji: '↕',
        name: 'arrow_up_down',
        shortcodes: [
            'arrow_up_down',
        ],
        tags: [
            'arrow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2195-fe0f.png',
    },
    {
        emoji: '↔',
        name: 'left_right_arrow',
        shortcodes: [
            'left_right_arrow',
        ],
        tags: [
            'arrow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2194-fe0f.png',
    },
    {
        emoji: '↩',
        name: 'leftwards_arrow_with_hook',
        shortcodes: [
            'arrow_left_hook',
            'leftwards_arrow_with_hook',
        ],
        tags: [
            'arrow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/21a9-fe0f.png',
    },
    {
        emoji: '↪',
        name: 'arrow_right_hook',
        shortcodes: [
            'arrow_right_hook',
            'rightwards_arrow_with_hook',
        ],
        tags: [
            'arrow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/21aa-fe0f.png',
    },
    {
        emoji: '⤴',
        name: 'arrow_heading_up',
        shortcodes: [
            'arrow_heading_up',
        ],
        tags: [
            'arrow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2934-fe0f.png',
    },
    {
        emoji: '⤵',
        name: 'arrow_heading_down',
        shortcodes: [
            'arrow_heading_down',
        ],
        tags: [
            'arrow',
            'down',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2935-fe0f.png',
    },
    {
        emoji: '🔃',
        name: 'arrows_clockwise',
        shortcodes: [
            'arrows_clockwise',
            'clockwise',
        ],
        tags: [
            'arrow',
            'clockwise',
            'reload',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f503.png',
    },
    {
        emoji: '🔄',
        name: 'arrows_counterclockwise',
        shortcodes: [
            'arrows_counterclockwise',
            'counterclockwise',
        ],
        tags: [
            'anticlockwise',
            'arrow',
            'counterclockwise',
            'withershins',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f504.png',
    },
    {
        emoji: '🔙',
        name: 'back',
        shortcodes: [
            'back',
        ],
        tags: [
            'arrow',
            'back',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f519.png',
    },
    {
        emoji: '🔚',
        name: 'end',
        shortcodes: [
            'end',
        ],
        tags: [
            'arrow',
            'end',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51a.png',
    },
    {
        emoji: '🔛',
        name: 'on',
        shortcodes: [
            'on',
        ],
        tags: [
            'arrow',
            'mark',
            'on',
            'on!',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51b.png',
    },
    {
        emoji: '🔜',
        name: 'soon',
        shortcodes: [
            'soon',
        ],
        tags: [
            'arrow',
            'soon',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51c.png',
    },
    {
        emoji: '🔝',
        name: 'top',
        shortcodes: [
            'top',
        ],
        tags: [
            'arrow',
            'top',
            'up',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51d.png',
    },
    {
        emoji: '🛐',
        name: 'place_of_worship',
        shortcodes: [
            'place_of_worship',
        ],
        tags: [
            'religion',
            'worship',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d0.png',
    },
    {
        emoji: '⚛',
        name: 'atom_symbol',
        shortcodes: [
            'atom',
            'atom_symbol',
        ],
        tags: [
            'atheist',
            'atom',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/269b-fe0f.png',
    },
    {
        emoji: '🕉',
        name: 'om',
        shortcodes: [
            'om',
        ],
        tags: [
            'hindu',
            'religion',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f549-fe0f.png',
    },
    {
        emoji: '✡',
        name: 'star_of_david',
        shortcodes: [
            'star_of_david',
        ],
        tags: [
            'david',
            'jew',
            'jewish',
            'religion',
            'star',
            'star of david',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2721-fe0f.png',
    },
    {
        emoji: '☸',
        name: 'wheel_of_dharma',
        shortcodes: [
            'wheel_of_dharma',
        ],
        tags: [
            'buddhist',
            'dharma',
            'religion',
            'wheel',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2638-fe0f.png',
    },
    {
        emoji: '☯',
        name: 'yin_yang',
        shortcodes: [
            'yin_yang',
        ],
        tags: [
            'religion',
            'tao',
            'taoist',
            'yang',
            'yin',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262f-fe0f.png',
    },
    {
        emoji: '✝',
        name: 'latin_cross',
        shortcodes: [
            'latin_cross',
        ],
        tags: [
            'christian',
            'cross',
            'religion',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/271d-fe0f.png',
    },
    {
        emoji: '☦',
        name: 'orthodox_cross',
        shortcodes: [
            'orthodox_cross',
        ],
        tags: [
            'christian',
            'cross',
            'religion',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2626-fe0f.png',
    },
    {
        emoji: '☪',
        name: 'star_and_crescent',
        shortcodes: [
            'star_and_crescent',
        ],
        tags: [
            'islam',
            'muslim',
            'religion',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262a-fe0f.png',
    },
    {
        emoji: '☮',
        name: 'peace_symbol',
        shortcodes: [
            'peace',
            'peace_symbol',
        ],
        tags: [
            'peace',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262e-fe0f.png',
    },
    {
        emoji: '🕎',
        name: 'menorah',
        shortcodes: [
            'menorah',
        ],
        tags: [
            'candelabrum',
            'candlestick',
            'religion',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54e.png',
    },
    {
        emoji: '🔯',
        name: 'six_pointed_star',
        shortcodes: [
            'six_pointed_star',
        ],
        tags: [
            'fortune',
            'star',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52f.png',
    },
    {
        emoji: '♈',
        name: 'aries',
        shortcodes: [
            'aries',
        ],
        tags: [
            'aries',
            'ram',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2648.png',
    },
    {
        emoji: '♉',
        name: 'taurus',
        shortcodes: [
            'taurus',
        ],
        tags: [
            'bull',
            'ox',
            'taurus',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2649.png',
    },
    {
        emoji: '♊',
        name: 'gemini',
        shortcodes: [
            'gemini',
        ],
        tags: [
            'gemini',
            'twins',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264a.png',
    },
    {
        emoji: '♋',
        name: 'cancer',
        shortcodes: [
            'cancer',
        ],
        tags: [
            'cancer',
            'crab',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264b.png',
    },
    {
        emoji: '♌',
        name: 'leo',
        shortcodes: [
            'leo',
        ],
        tags: [
            'leo',
            'lion',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264c.png',
    },
    {
        emoji: '♍',
        name: 'virgo',
        shortcodes: [
            'virgo',
        ],
        tags: [
            'virgo',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264d.png',
    },
    {
        emoji: '♎',
        name: 'libra',
        shortcodes: [
            'libra',
        ],
        tags: [
            'balance',
            'justice',
            'libra',
            'scales',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264e.png',
    },
    {
        emoji: '♏',
        name: 'scorpius',
        shortcodes: [
            'scorpius',
        ],
        tags: [
            'scorpio',
            'scorpion',
            'scorpius',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264f.png',
    },
    {
        emoji: '♐',
        name: 'sagittarius',
        shortcodes: [
            'sagittarius',
        ],
        tags: [
            'archer',
            'sagittarius',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2650.png',
    },
    {
        emoji: '♑',
        name: 'capricorn',
        shortcodes: [
            'capricorn',
        ],
        tags: [
            'capricorn',
            'goat',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2651.png',
    },
    {
        emoji: '♒',
        name: 'aquarius',
        shortcodes: [
            'aquarius',
        ],
        tags: [
            'aquarius',
            'bearer',
            'water',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2652.png',
    },
    {
        emoji: '♓',
        name: 'pisces',
        shortcodes: [
            'pisces',
        ],
        tags: [
            'fish',
            'pisces',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2653.png',
    },
    {
        emoji: '⛎',
        name: 'ophiuchus',
        shortcodes: [
            'ophiuchus',
        ],
        tags: [
            'bearer',
            'ophiuchus',
            'serpent',
            'snake',
            'zodiac',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ce.png',
    },
    {
        emoji: '🔀',
        name: 'twisted_rightwards_arrows',
        shortcodes: [
            'shuffle',
            'twisted_rightwards_arrows',
        ],
        tags: [
            'arrow',
            'crossed',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f500.png',
    },
    {
        emoji: '🔁',
        name: 'repeat',
        shortcodes: [
            'repeat',
        ],
        tags: [
            'arrow',
            'clockwise',
            'repeat',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f501.png',
    },
    {
        emoji: '🔂',
        name: 'repeat_one',
        shortcodes: [
            'repeat_one',
        ],
        tags: [
            'arrow',
            'clockwise',
            'once',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f502.png',
    },
    {
        emoji: '▶',
        name: 'arrow_forward',
        shortcodes: [
            'arrow_forward',
            'play',
        ],
        tags: [
            'arrow',
            'play',
            'right',
            'triangle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25b6-fe0f.png',
    },
    {
        emoji: '⏩',
        name: 'fast_forward',
        shortcodes: [
            'fast_forward',
        ],
        tags: [
            'arrow',
            'double',
            'fast',
            'forward',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23e9.png',
    },
    {
        emoji: '⏭',
        name: 'next_track_button',
        shortcodes: [
            'next_track',
        ],
        tags: [
            'arrow',
            'next scene',
            'next track',
            'triangle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ed-fe0f.png',
    },
    {
        emoji: '⏯',
        name: 'play_or_pause_button',
        shortcodes: [
            'play_pause',
        ],
        tags: [
            'arrow',
            'pause',
            'play',
            'right',
            'triangle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ef-fe0f.png',
    },
    {
        emoji: '◀',
        name: 'arrow_backward',
        shortcodes: [
            'arrow_backward',
            'reverse',
        ],
        tags: [
            'arrow',
            'left',
            'reverse',
            'triangle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25c0-fe0f.png',
    },
    {
        emoji: '⏪',
        name: 'rewind',
        shortcodes: [
            'fast_reverse',
            'rewind',
        ],
        tags: [
            'arrow',
            'double',
            'rewind',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ea.png',
    },
    {
        emoji: '⏮',
        name: 'previous_track_button',
        shortcodes: [
            'previous_track',
        ],
        tags: [
            'arrow',
            'previous scene',
            'previous track',
            'triangle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ee-fe0f.png',
    },
    {
        emoji: '🔼',
        name: 'arrow_up_small',
        shortcodes: [
            'arrow_up_small',
            'up',
        ],
        tags: [
            'arrow',
            'button',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53c.png',
    },
    {
        emoji: '⏫',
        name: 'arrow_double_up',
        shortcodes: [
            'arrow_double_up',
            'fast_up',
        ],
        tags: [
            'arrow',
            'double',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23eb.png',
    },
    {
        emoji: '🔽',
        name: 'arrow_down_small',
        shortcodes: [
            'arrow_down_small',
            'down',
        ],
        tags: [
            'arrow',
            'button',
            'down',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53d.png',
    },
    {
        emoji: '⏬',
        name: 'arrow_double_down',
        shortcodes: [
            'arrow_double_down',
            'fast_down',
        ],
        tags: [
            'arrow',
            'double',
            'down',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ec.png',
    },
    {
        emoji: '⏸',
        name: 'pause_button',
        shortcodes: [
            'pause',
        ],
        tags: [
            'bar',
            'double',
            'pause',
            'vertical',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f8-fe0f.png',
    },
    {
        emoji: '⏹',
        name: 'stop_button',
        shortcodes: [
            'stop',
        ],
        tags: [
            'square',
            'stop',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f9-fe0f.png',
    },
    {
        emoji: '⏺',
        name: 'record_button',
        shortcodes: [
            'record',
        ],
        tags: [
            'circle',
            'record',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23fa-fe0f.png',
    },
    {
        emoji: '⏏',
        name: 'eject_button',
        shortcodes: [
            'eject',
        ],
        tags: [
            'eject',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23cf-fe0f.png',
    },
    {
        emoji: '🎦',
        name: 'cinema',
        shortcodes: [
            'cinema',
        ],
        tags: [
            'camera',
            'film',
            'movie',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a6.png',
    },
    {
        emoji: '🔅',
        name: 'low_brightness',
        shortcodes: [
            'dim_button',
            'low_brightness',
        ],
        tags: [
            'brightness',
            'dim',
            'low',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f505.png',
    },
    {
        emoji: '🔆',
        name: 'high_brightness',
        shortcodes: [
            'bright_button',
            'high_brightness',
        ],
        tags: [
            'bright',
            'brightness',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f506.png',
    },
    {
        emoji: '📶',
        name: 'signal_strength',
        shortcodes: [
            'antenna_bars',
            'signal_strength',
        ],
        tags: [
            'antenna',
            'bar',
            'cell',
            'mobile',
            'phone',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f6.png',
    },
    {
        emoji: '📳',
        name: 'vibration_mode',
        shortcodes: [
            'vibration_mode',
        ],
        tags: [
            'cell',
            'mobile',
            'mode',
            'phone',
            'telephone',
            'vibration',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f3.png',
    },
    {
        emoji: '📴',
        name: 'mobile_phone_off',
        shortcodes: [
            'mobile_phone_off',
        ],
        tags: [
            'cell',
            'mobile',
            'off',
            'phone',
            'telephone',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f4.png',
    },
    {
        emoji: '♀',
        name: 'female_sign',
        shortcodes: [
            'female',
            'female_sign',
        ],
        tags: [
            'woman',
        ],
        group: 'symbols',
        emoticons: [],
        version: 4,
    },
    {
        emoji: '♂',
        name: 'male_sign',
        shortcodes: [
            'male',
            'male_sign',
        ],
        tags: [
            'man',
        ],
        group: 'symbols',
        emoticons: [],
        version: 4,
    },
    {
        emoji: '⚧',
        name: 'transgender_symbol',
        shortcodes: [
            'transgender_symbol',
        ],
        tags: [
            'transgender',
        ],
        group: 'symbols',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a7-fe0f.png',
    },
    {
        emoji: '✖',
        name: 'heavy_multiplication_x',
        shortcodes: [
            'multiplication',
            'multiply',
        ],
        tags: [
            'cancel',
            'multiplication',
            'sign',
            'x',
            '×',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2716-fe0f.png',
    },
    {
        emoji: '➕',
        name: 'heavy_plus_sign',
        shortcodes: [
            'plus',
        ],
        tags: [
            '+',
            'math',
            'sign',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2795.png',
    },
    {
        emoji: '➖',
        name: 'heavy_minus_sign',
        shortcodes: [
            'minus',
        ],
        tags: [
            '-',
            'math',
            'sign',
            '−',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2796.png',
    },
    {
        emoji: '➗',
        name: 'heavy_division_sign',
        shortcodes: [
            'divide',
            'division',
        ],
        tags: [
            'division',
            'math',
            'sign',
            '÷',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2797.png',
    },
    {
        emoji: '♾',
        name: 'infinity',
        shortcodes: [
            'infinity',
        ],
        tags: [
            'forever',
            'unbounded',
            'universal',
        ],
        group: 'symbols',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267e-fe0f.png',
    },
    {
        emoji: '‼',
        name: 'bangbang',
        shortcodes: [
            'bangbang',
            'double_exclamation',
        ],
        tags: [
            '!',
            '!!',
            'bangbang',
            'exclamation',
            'mark',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/203c-fe0f.png',
    },
    {
        emoji: '⁉',
        name: 'interrobang',
        shortcodes: [
            'exclamation_question',
            'interrobang',
        ],
        tags: [
            '!',
            '!?',
            '?',
            'exclamation',
            'interrobang',
            'mark',
            'punctuation',
            'question',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2049-fe0f.png',
    },
    {
        emoji: '❓',
        name: 'question',
        shortcodes: [
            'question',
        ],
        tags: [
            '?',
            'mark',
            'punctuation',
            'question',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2753.png',
    },
    {
        emoji: '❔',
        name: 'grey_question',
        shortcodes: [
            'white_question',
        ],
        tags: [
            '?',
            'mark',
            'outlined',
            'punctuation',
            'question',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2754.png',
    },
    {
        emoji: '❕',
        name: 'grey_exclamation',
        shortcodes: [
            'white_exclamation',
        ],
        tags: [
            '!',
            'exclamation',
            'mark',
            'outlined',
            'punctuation',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2755.png',
    },
    {
        emoji: '❗',
        name: 'exclamation',
        shortcodes: [
            'exclamation',
        ],
        tags: [
            '!',
            'exclamation',
            'mark',
            'punctuation',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2757.png',
    },
    {
        emoji: '〰',
        name: 'wavy_dash',
        shortcodes: [
            'wavy_dash',
        ],
        tags: [
            'dash',
            'punctuation',
            'wavy',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3030-fe0f.png',
    },
    {
        emoji: '💱',
        name: 'currency_exchange',
        shortcodes: [
            'currency_exchange',
        ],
        tags: [
            'bank',
            'currency',
            'exchange',
            'money',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b1.png',
    },
    {
        emoji: '💲',
        name: 'heavy_dollar_sign',
        shortcodes: [
            'heavy_dollar_sign',
        ],
        tags: [
            'currency',
            'dollar',
            'money',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b2.png',
    },
    {
        emoji: '⚕',
        name: 'medical_symbol',
        shortcodes: [
            'medical',
            'medical_symbol',
        ],
        tags: [
            'aesculapius',
            'medicine',
            'staff',
        ],
        group: 'symbols',
        emoticons: [],
        version: 4,
    },
    {
        emoji: '♻',
        name: 'recycle',
        shortcodes: [
            'recycle',
            'recycling_symbol',
        ],
        tags: [
            'recycle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267b-fe0f.png',
    },
    {
        emoji: '⚜',
        name: 'fleur_de_lis',
        shortcodes: [
            'fleur-de-lis',
        ],
        tags: [
            'fleur-de-lis',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/269c-fe0f.png',
    },
    {
        emoji: '🔱',
        name: 'trident',
        shortcodes: [
            'trident',
        ],
        tags: [
            'anchor',
            'emblem',
            'ship',
            'tool',
            'trident',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f531.png',
    },
    {
        emoji: '📛',
        name: 'name_badge',
        shortcodes: [
            'name_badge',
        ],
        tags: [
            'badge',
            'name',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4db.png',
    },
    {
        emoji: '🔰',
        name: 'beginner',
        shortcodes: [
            'beginner',
        ],
        tags: [
            'beginner',
            'chevron',
            'japanese',
            'japanese symbol for beginner',
            'leaf',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f530.png',
    },
    {
        emoji: '⭕',
        name: 'o',
        shortcodes: [
            'hollow_red_circle',
            'red_o',
        ],
        tags: [
            'circle',
            'large',
            'o',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b55.png',
    },
    {
        emoji: '✅',
        name: 'white_check_mark',
        shortcodes: [
            'check_mark_button',
            'white_check_mark',
        ],
        tags: [
            'button',
            'check',
            'mark',
            '✓',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2705.png',
    },
    {
        emoji: '☑',
        name: 'ballot_box_with_check',
        shortcodes: [
            'ballot_box_with_check',
        ],
        tags: [
            'box',
            'check',
            '✓',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2611-fe0f.png',
    },
    {
        emoji: '✔',
        name: 'heavy_check_mark',
        shortcodes: [
            'check_mark',
            'heavy_check_mark',
        ],
        tags: [
            'check',
            'mark',
            '✓',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2714-fe0f.png',
    },
    {
        emoji: '❌',
        name: 'x',
        shortcodes: [
            'cross_mark',
            'x',
        ],
        tags: [
            'cancel',
            'cross',
            'mark',
            'multiplication',
            'multiply',
            'x',
            '×',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/274c.png',
    },
    {
        emoji: '❎',
        name: 'negative_squared_cross_mark',
        shortcodes: [
            'cross_mark_button',
            'negative_squared_cross_mark',
        ],
        tags: [
            'mark',
            'square',
            'x',
            '×',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/274e.png',
    },
    {
        emoji: '➰',
        name: 'curly_loop',
        shortcodes: [
            'curly_loop',
        ],
        tags: [
            'curl',
            'loop',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27b0.png',
    },
    {
        emoji: '➿',
        name: 'loop',
        shortcodes: [
            'double_curly_loop',
            'loop',
        ],
        tags: [
            'curl',
            'double',
            'loop',
        ],
        group: 'symbols',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27bf.png',
    },
    {
        emoji: '〽',
        name: 'part_alternation_mark',
        shortcodes: [
            'part_alternation_mark',
        ],
        tags: [
            'mark',
            'part',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/303d-fe0f.png',
    },
    {
        emoji: '✳',
        name: 'eight_spoked_asterisk',
        shortcodes: [
            'eight_spoked_asterisk',
        ],
        tags: [
            '*',
            'asterisk',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2733-fe0f.png',
    },
    {
        emoji: '✴',
        name: 'eight_pointed_black_star',
        shortcodes: [
            'eight_pointed_black_star',
        ],
        tags: [
            '*',
            'star',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2734-fe0f.png',
    },
    {
        emoji: '❇',
        name: 'sparkle',
        shortcodes: [
            'sparkle',
        ],
        tags: [
            '*',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2747-fe0f.png',
    },
    {
        emoji: '©',
        name: 'copyright',
        shortcodes: [
            'copyright',
        ],
        tags: [
            'c',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/00a9-fe0f.png',
    },
    {
        emoji: '®',
        name: 'registered',
        shortcodes: [
            'registered',
        ],
        tags: [
            'r',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/00ae-fe0f.png',
    },
    {
        emoji: '™',
        name: 'tm',
        shortcodes: [
            'tm',
            'trade_mark',
        ],
        tags: [
            'mark',
            'tm',
            'trademark',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2122-fe0f.png',
    },
    {
        emoji: '#⃣',
        name: 'hash',
        shortcodes: [
            'hash',
            'number_sign',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0023-fe0f-20e3.png',
    },
    {
        emoji: '*⃣',
        name: 'asterisk',
        shortcodes: [
            'asterisk',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/002a-fe0f-20e3.png',
    },
    {
        emoji: '0⃣',
        name: 'zero',
        shortcodes: [
            'zero',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0030-fe0f-20e3.png',
    },
    {
        emoji: '1⃣',
        name: 'one',
        shortcodes: [
            'one',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0031-fe0f-20e3.png',
    },
    {
        emoji: '2⃣',
        name: 'two',
        shortcodes: [
            'two',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0032-fe0f-20e3.png',
    },
    {
        emoji: '3⃣',
        name: 'three',
        shortcodes: [
            'three',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0033-fe0f-20e3.png',
    },
    {
        emoji: '4⃣',
        name: 'four',
        shortcodes: [
            'four',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0034-fe0f-20e3.png',
    },
    {
        emoji: '5⃣',
        name: 'five',
        shortcodes: [
            'five',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0035-fe0f-20e3.png',
    },
    {
        emoji: '6⃣',
        name: 'six',
        shortcodes: [
            'six',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0036-fe0f-20e3.png',
    },
    {
        emoji: '7⃣',
        name: 'seven',
        shortcodes: [
            'seven',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0037-fe0f-20e3.png',
    },
    {
        emoji: '8⃣',
        name: 'eight',
        shortcodes: [
            'eight',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0038-fe0f-20e3.png',
    },
    {
        emoji: '9⃣',
        name: 'nine',
        shortcodes: [
            'nine',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0039-fe0f-20e3.png',
    },
    {
        emoji: '🔟',
        name: 'keycap_ten',
        shortcodes: [
            'ten',
        ],
        tags: [
            'keycap',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51f.png',
    },
    {
        emoji: '🔠',
        name: 'capital_abcd',
        shortcodes: [
            'capital_abcd',
        ],
        tags: [
            'abcd',
            'input',
            'latin',
            'letters',
            'uppercase',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f520.png',
    },
    {
        emoji: '🔡',
        name: 'abcd',
        shortcodes: [
            'abcd',
        ],
        tags: [
            'abcd',
            'input',
            'latin',
            'letters',
            'lowercase',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f521.png',
    },
    {
        emoji: '🔢',
        name: '1234',
        shortcodes: [
            '1234',
        ],
        tags: [
            '1234',
            'input',
            'numbers',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f522.png',
    },
    {
        emoji: '🔣',
        name: 'symbols',
        shortcodes: [
            'symbols',
        ],
        tags: [
            'input',
            '〒♪&%',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f523.png',
    },
    {
        emoji: '🔤',
        name: 'abc',
        shortcodes: [
            'abc',
        ],
        tags: [
            'abc',
            'alphabet',
            'input',
            'latin',
            'letters',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f524.png',
    },
    {
        emoji: '🅰',
        name: 'a',
        shortcodes: [
            'a',
            'a_blood',
        ],
        tags: [
            'a',
            'a button (blood type)',
            'blood type',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f170-fe0f.png',
    },
    {
        emoji: '🆎',
        name: 'ab',
        shortcodes: [
            'ab',
            'ab_blood',
        ],
        tags: [
            'ab',
            'ab button (blood type)',
            'blood type',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f18e.png',
    },
    {
        emoji: '🅱',
        name: 'b',
        shortcodes: [
            'b',
            'b_blood',
        ],
        tags: [
            'b',
            'b button (blood type)',
            'blood type',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f171-fe0f.png',
    },
    {
        emoji: '🆑',
        name: 'cl',
        shortcodes: [
            'cl',
        ],
        tags: [
            'cl',
            'cl button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f191.png',
    },
    {
        emoji: '🆒',
        name: 'cool',
        shortcodes: [
            'cool',
        ],
        tags: [
            'cool',
            'cool button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f192.png',
    },
    {
        emoji: '🆓',
        name: 'free',
        shortcodes: [
            'free',
        ],
        tags: [
            'free',
            'free button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f193.png',
    },
    {
        emoji: 'ℹ',
        name: 'information_source',
        shortcodes: [
            'info',
            'information_source',
        ],
        tags: [
            'i',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2139-fe0f.png',
    },
    {
        emoji: '🆔',
        name: 'id',
        shortcodes: [
            'id',
        ],
        tags: [
            'id',
            'id button',
            'identity',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f194.png',
    },
    {
        emoji: 'Ⓜ',
        name: 'm',
        shortcodes: [
            'm',
        ],
        tags: [
            'circle',
            'circled m',
            'm',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/24c2-fe0f.png',
    },
    {
        emoji: '🆕',
        name: 'new',
        shortcodes: [
            'new',
        ],
        tags: [
            'new',
            'new button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f195.png',
    },
    {
        emoji: '🆖',
        name: 'ng',
        shortcodes: [
            'ng',
        ],
        tags: [
            'ng',
            'ng button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f196.png',
    },
    {
        emoji: '🅾',
        name: 'o2',
        shortcodes: [
            'o',
            'o_blood',
        ],
        tags: [
            'blood type',
            'o',
            'o button (blood type)',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f17e-fe0f.png',
    },
    {
        emoji: '🆗',
        name: 'ok',
        shortcodes: [
            'ok',
        ],
        tags: [
            'ok',
            'ok button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f197.png',
    },
    {
        emoji: '🅿',
        name: 'parking',
        shortcodes: [
            'parking',
        ],
        tags: [
            'p',
            'p button',
            'parking',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f17f-fe0f.png',
    },
    {
        emoji: '🆘',
        name: 'sos',
        shortcodes: [
            'sos',
        ],
        tags: [
            'help',
            'sos',
            'sos button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f198.png',
    },
    {
        emoji: '🆙',
        name: 'up',
        shortcodes: [
            'up2',
        ],
        tags: [
            'mark',
            'up',
            'up!',
            'up! button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f199.png',
    },
    {
        emoji: '🆚',
        name: 'vs',
        shortcodes: [
            'vs',
        ],
        tags: [
            'versus',
            'vs',
            'vs button',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f19a.png',
    },
    {
        emoji: '🈁',
        name: 'koko',
        shortcodes: [
            'ja_here',
            'koko',
        ],
        tags: [
            'japanese',
            'japanese “here” button',
            'katakana',
            '“here”',
            'ココ',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f201.png',
    },
    {
        emoji: '🈂',
        name: 'sa',
        shortcodes: [
            'ja_service_charge',
        ],
        tags: [
            'japanese',
            'japanese “service charge” button',
            'katakana',
            '“service charge”',
            'サ',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f202-fe0f.png',
    },
    {
        emoji: '🈷',
        name: 'u6708',
        shortcodes: [
            'ja_monthly_amount',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “monthly amount” button',
            '“monthly amount”',
            '月',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f237-fe0f.png',
    },
    {
        emoji: '🈶',
        name: 'u6709',
        shortcodes: [
            'ja_not_free_of_carge',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “not free of charge” button',
            '“not free of charge”',
            '有',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f236.png',
    },
    {
        emoji: '🈯',
        name: 'u6307',
        shortcodes: [
            'ja_reserved',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “reserved” button',
            '“reserved”',
            '指',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f22f.png',
    },
    {
        emoji: '🉐',
        name: 'ideograph_advantage',
        shortcodes: [
            'ideograph_advantage',
            'ja_bargain',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “bargain” button',
            '“bargain”',
            '得',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f250.png',
    },
    {
        emoji: '🈹',
        name: 'u5272',
        shortcodes: [
            'ja_discount',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “discount” button',
            '“discount”',
            '割',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f239.png',
    },
    {
        emoji: '🈚',
        name: 'u7121',
        shortcodes: [
            'ja_free_of_charge',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “free of charge” button',
            '“free of charge”',
            '無',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f21a.png',
    },
    {
        emoji: '🈲',
        name: 'u7981',
        shortcodes: [
            'ja_prohibited',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “prohibited” button',
            '“prohibited”',
            '禁',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f232.png',
    },
    {
        emoji: '🉑',
        name: 'accept',
        shortcodes: [
            'accept',
            'ja_acceptable',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “acceptable” button',
            '“acceptable”',
            '可',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f251.png',
    },
    {
        emoji: '🈸',
        name: 'u7533',
        shortcodes: [
            'ja_application',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “application” button',
            '“application”',
            '申',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f238.png',
    },
    {
        emoji: '🈴',
        name: 'u5408',
        shortcodes: [
            'ja_passing_grade',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “passing grade” button',
            '“passing grade”',
            '合',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f234.png',
    },
    {
        emoji: '🈳',
        name: 'u7a7a',
        shortcodes: [
            'ja_vacancy',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “vacancy” button',
            '“vacancy”',
            '空',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f233.png',
    },
    {
        emoji: '㊗',
        name: 'congratulations',
        shortcodes: [
            'congratulations',
            'ja_congratulations',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “congratulations” button',
            '“congratulations”',
            '祝',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3297-fe0f.png',
    },
    {
        emoji: '㊙',
        name: 'secret',
        shortcodes: [
            'ja_secret',
            'secret',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “secret” button',
            '“secret”',
            '秘',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3299-fe0f.png',
    },
    {
        emoji: '🈺',
        name: 'u55b6',
        shortcodes: [
            'ja_open_for_business',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “open for business” button',
            '“open for business”',
            '営',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f23a.png',
    },
    {
        emoji: '🈵',
        name: 'u6e80',
        shortcodes: [
            'ja_no_vacancy',
        ],
        tags: [
            'ideograph',
            'japanese',
            'japanese “no vacancy” button',
            '“no vacancy”',
            '満',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f235.png',
    },
    {
        emoji: '🔴',
        name: 'red_circle',
        shortcodes: [
            'red_circle',
        ],
        tags: [
            'circle',
            'geometric',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f534.png',
    },
    {
        emoji: '🟠',
        name: 'orange_circle',
        shortcodes: [
            'orange_circle',
        ],
        tags: [
            'circle',
            'orange',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e0.png',
    },
    {
        emoji: '🟡',
        name: 'yellow_circle',
        shortcodes: [
            'yellow_circle',
        ],
        tags: [
            'circle',
            'yellow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e1.png',
    },
    {
        emoji: '🟢',
        name: 'green_circle',
        shortcodes: [
            'green_circle',
        ],
        tags: [
            'circle',
            'green',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e2.png',
    },
    {
        emoji: '🔵',
        name: 'large_blue_circle',
        shortcodes: [
            'blue_circle',
        ],
        tags: [
            'blue',
            'circle',
            'geometric',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f535.png',
    },
    {
        emoji: '🟣',
        name: 'purple_circle',
        shortcodes: [
            'purple_circle',
        ],
        tags: [
            'circle',
            'purple',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e3.png',
    },
    {
        emoji: '🟤',
        name: 'brown_circle',
        shortcodes: [
            'brown_circle',
        ],
        tags: [
            'brown',
            'circle',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e4.png',
    },
    {
        emoji: '⚫',
        name: 'black_circle',
        shortcodes: [
            'black_circle',
        ],
        tags: [
            'circle',
            'geometric',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ab.png',
    },
    {
        emoji: '⚪',
        name: 'white_circle',
        shortcodes: [
            'white_circle',
        ],
        tags: [
            'circle',
            'geometric',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26aa.png',
    },
    {
        emoji: '🟥',
        name: 'red_square',
        shortcodes: [
            'red_square',
        ],
        tags: [
            'red',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e5.png',
    },
    {
        emoji: '🟧',
        name: 'orange_square',
        shortcodes: [
            'orange_square',
        ],
        tags: [
            'orange',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e7.png',
    },
    {
        emoji: '🟨',
        name: 'yellow_square',
        shortcodes: [
            'yellow_square',
        ],
        tags: [
            'square',
            'yellow',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e8.png',
    },
    {
        emoji: '🟩',
        name: 'green_square',
        shortcodes: [
            'green_square',
        ],
        tags: [
            'green',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e9.png',
    },
    {
        emoji: '🟦',
        name: 'blue_square',
        shortcodes: [
            'blue_square',
        ],
        tags: [
            'blue',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e6.png',
    },
    {
        emoji: '🟪',
        name: 'purple_square',
        shortcodes: [
            'purple_square',
        ],
        tags: [
            'purple',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7ea.png',
    },
    {
        emoji: '🟫',
        name: 'brown_square',
        shortcodes: [
            'brown_square',
        ],
        tags: [
            'brown',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 12,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7eb.png',
    },
    {
        emoji: '⬛',
        name: 'black_large_square',
        shortcodes: [
            'black_large_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b1b.png',
    },
    {
        emoji: '⬜',
        name: 'white_large_square',
        shortcodes: [
            'white_large_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b1c.png',
    },
    {
        emoji: '◼',
        name: 'black_medium_square',
        shortcodes: [
            'black_medium_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fc-fe0f.png',
    },
    {
        emoji: '◻',
        name: 'white_medium_square',
        shortcodes: [
            'white_medium_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fb-fe0f.png',
    },
    {
        emoji: '◾',
        name: 'black_medium_small_square',
        shortcodes: [
            'black_medium_small_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fe.png',
    },
    {
        emoji: '◽',
        name: 'white_medium_small_square',
        shortcodes: [
            'white_medium_small_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fd.png',
    },
    {
        emoji: '▪',
        name: 'black_small_square',
        shortcodes: [
            'black_small_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25aa-fe0f.png',
    },
    {
        emoji: '▫',
        name: 'white_small_square',
        shortcodes: [
            'white_small_square',
        ],
        tags: [
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25ab-fe0f.png',
    },
    {
        emoji: '🔶',
        name: 'large_orange_diamond',
        shortcodes: [
            'large_orange_diamond',
        ],
        tags: [
            'diamond',
            'geometric',
            'orange',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f536.png',
    },
    {
        emoji: '🔷',
        name: 'large_blue_diamond',
        shortcodes: [
            'large_blue_diamond',
        ],
        tags: [
            'blue',
            'diamond',
            'geometric',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f537.png',
    },
    {
        emoji: '🔸',
        name: 'small_orange_diamond',
        shortcodes: [
            'small_orange_diamond',
        ],
        tags: [
            'diamond',
            'geometric',
            'orange',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f538.png',
    },
    {
        emoji: '🔹',
        name: 'small_blue_diamond',
        shortcodes: [
            'small_blue_diamond',
        ],
        tags: [
            'blue',
            'diamond',
            'geometric',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f539.png',
    },
    {
        emoji: '🔺',
        name: 'small_red_triangle',
        shortcodes: [
            'small_red_triangle',
        ],
        tags: [
            'geometric',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53a.png',
    },
    {
        emoji: '🔻',
        name: 'small_red_triangle_down',
        shortcodes: [
            'small_red_triangle_down',
        ],
        tags: [
            'down',
            'geometric',
            'red',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53b.png',
    },
    {
        emoji: '💠',
        name: 'diamond_shape_with_a_dot_inside',
        shortcodes: [
            'diamond_shape_with_a_dot_inside',
            'diamond_with_a_dot',
        ],
        tags: [
            'comic',
            'diamond',
            'geometric',
            'inside',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a0.png',
    },
    {
        emoji: '🔘',
        name: 'radio_button',
        shortcodes: [
            'radio_button',
        ],
        tags: [
            'button',
            'geometric',
            'radio',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f518.png',
    },
    {
        emoji: '🔳',
        name: 'white_square_button',
        shortcodes: [
            'white_square_button',
        ],
        tags: [
            'button',
            'geometric',
            'outlined',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f533.png',
    },
    {
        emoji: '🔲',
        name: 'black_square_button',
        shortcodes: [
            'black_square_button',
        ],
        tags: [
            'button',
            'geometric',
            'square',
        ],
        group: 'symbols',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f532.png',
    },
    {
        emoji: '🏁',
        name: 'checkered_flag',
        shortcodes: [
            'checkered_flag',
        ],
        tags: [
            'checkered',
            'chequered',
            'racing',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c1.png',
    },
    {
        emoji: '🚩',
        name: 'triangular_flag_on_post',
        shortcodes: [
            'triangular_flag',
            'triangular_flag_on_post',
        ],
        tags: [
            'post',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a9.png',
    },
    {
        emoji: '🎌',
        name: 'crossed_flags',
        shortcodes: [
            'crossed_flags',
        ],
        tags: [
            'celebration',
            'cross',
            'crossed',
            'japanese',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38c.png',
    },
    {
        emoji: '🏴',
        name: 'black_flag',
        shortcodes: [
            'black_flag',
        ],
        tags: [
            'waving',
        ],
        group: 'flags',
        emoticons: [],
        version: 1,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4.png',
    },
    {
        emoji: '🏳',
        name: 'white_flag',
        shortcodes: [
            'white_flag',
        ],
        tags: [
            'waving',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.7,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f.png',
    },
    {
        emoji: '🏳‍🌈',
        name: 'rainbow_flag',
        shortcodes: [
            'rainbow_flag',
        ],
        tags: [
            'pride',
            'rainbow',
        ],
        group: 'flags',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f-200d-1f308.png',
    },
    {
        emoji: '🏳‍⚧️',
        name: 'transgender_flag',
        shortcodes: [
            'transgender_flag',
        ],
        tags: [
            'flag',
            'light blue',
            'pink',
            'transgender',
            'white',
        ],
        group: 'flags',
        emoticons: [],
        version: 13,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f-200d-26a7-fe0f.png',
    },
    {
        emoji: '🏴‍☠',
        name: 'pirate_flag',
        shortcodes: [
            'jolly_roger',
            'pirate_flag',
        ],
        tags: [
            'jolly roger',
            'pirate',
            'plunder',
            'treasure',
        ],
        group: 'flags',
        emoticons: [],
        version: 11,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-200d-2620-fe0f.png',
    },
    {
        emoji: '🇦🇨',
        name: 'ascension_island',
        shortcodes: [
            'ascension_island',
            'flag_ac',
        ],
        tags: [
            'AC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1e8.png',
    },
    {
        emoji: '🇦🇩',
        name: 'andorra',
        shortcodes: [
            'andorra',
            'flag_ad',
        ],
        tags: [
            'AD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1e9.png',
    },
    {
        emoji: '🇦🇪',
        name: 'united_arab_emirates',
        shortcodes: [
            'flag_ae',
            'united_arab_emirates',
        ],
        tags: [
            'AE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ea.png',
    },
    {
        emoji: '🇦🇫',
        name: 'afghanistan',
        shortcodes: [
            'afghanistan',
            'flag_af',
        ],
        tags: [
            'AF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1eb.png',
    },
    {
        emoji: '🇦🇬',
        name: 'antigua_barbuda',
        shortcodes: [
            'antigua_barbuda',
            'flag_ag',
        ],
        tags: [
            'AG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ec.png',
    },
    {
        emoji: '🇦🇮',
        name: 'anguilla',
        shortcodes: [
            'anguilla',
            'flag_ai',
        ],
        tags: [
            'AI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ee.png',
    },
    {
        emoji: '🇦🇱',
        name: 'albania',
        shortcodes: [
            'albania',
            'flag_al',
        ],
        tags: [
            'AL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f1.png',
    },
    {
        emoji: '🇦🇲',
        name: 'armenia',
        shortcodes: [
            'armenia',
            'flag_am',
        ],
        tags: [
            'AM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f2.png',
    },
    {
        emoji: '🇦🇴',
        name: 'angola',
        shortcodes: [
            'angola',
            'flag_ao',
        ],
        tags: [
            'AO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f4.png',
    },
    {
        emoji: '🇦🇶',
        name: 'antarctica',
        shortcodes: [
            'antarctica',
            'flag_aq',
        ],
        tags: [
            'AQ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f6.png',
    },
    {
        emoji: '🇦🇷',
        name: 'argentina',
        shortcodes: [
            'argentina',
            'flag_ar',
        ],
        tags: [
            'AR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f7.png',
    },
    {
        emoji: '🇦🇸',
        name: 'american_samoa',
        shortcodes: [
            'american_samoa',
            'flag_as',
        ],
        tags: [
            'AS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f8.png',
    },
    {
        emoji: '🇦🇹',
        name: 'austria',
        shortcodes: [
            'austria',
            'flag_at',
        ],
        tags: [
            'AT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f9.png',
    },
    {
        emoji: '🇦🇺',
        name: 'australia',
        shortcodes: [
            'australia',
            'flag_au',
        ],
        tags: [
            'AU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fa.png',
    },
    {
        emoji: '🇦🇼',
        name: 'aruba',
        shortcodes: [
            'aruba',
            'flag_aw',
        ],
        tags: [
            'AW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fc.png',
    },
    {
        emoji: '🇦🇽',
        name: 'aland_islands',
        shortcodes: [
            'aland_islands',
            'flag_ax',
        ],
        tags: [
            'AX',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fd.png',
    },
    {
        emoji: '🇦🇿',
        name: 'azerbaijan',
        shortcodes: [
            'azerbaijan',
            'flag_az',
        ],
        tags: [
            'AZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ff.png',
    },
    {
        emoji: '🇧🇦',
        name: 'bosnia_herzegovina',
        shortcodes: [
            'bosnia_herzegovina',
            'flag_ba',
        ],
        tags: [
            'BA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e6.png',
    },
    {
        emoji: '🇧🇧',
        name: 'barbados',
        shortcodes: [
            'barbados',
            'flag_bb',
        ],
        tags: [
            'BB',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e7.png',
    },
    {
        emoji: '🇧🇩',
        name: 'bangladesh',
        shortcodes: [
            'bangladesh',
            'flag_bd',
        ],
        tags: [
            'BD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e9.png',
    },
    {
        emoji: '🇧🇪',
        name: 'belgium',
        shortcodes: [
            'belgium',
            'flag_be',
        ],
        tags: [
            'BE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ea.png',
    },
    {
        emoji: '🇧🇫',
        name: 'burkina_faso',
        shortcodes: [
            'burkina_faso',
            'flag_bf',
        ],
        tags: [
            'BF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1eb.png',
    },
    {
        emoji: '🇧🇬',
        name: 'bulgaria',
        shortcodes: [
            'bulgaria',
            'flag_bg',
        ],
        tags: [
            'BG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ec.png',
    },
    {
        emoji: '🇧🇭',
        name: 'bahrain',
        shortcodes: [
            'bahrain',
            'flag_bh',
        ],
        tags: [
            'BH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ed.png',
    },
    {
        emoji: '🇧🇮',
        name: 'burundi',
        shortcodes: [
            'burundi',
            'flag_bi',
        ],
        tags: [
            'BI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ee.png',
    },
    {
        emoji: '🇧🇯',
        name: 'benin',
        shortcodes: [
            'benin',
            'flag_bj',
        ],
        tags: [
            'BJ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ef.png',
    },
    {
        emoji: '🇧🇱',
        name: 'st_barthelemy',
        shortcodes: [
            'flag_bl',
            'st_barthelemy',
        ],
        tags: [
            'BL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f1.png',
    },
    {
        emoji: '🇧🇲',
        name: 'bermuda',
        shortcodes: [
            'bermuda',
            'flag_bm',
        ],
        tags: [
            'BM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f2.png',
    },
    {
        emoji: '🇧🇳',
        name: 'brunei',
        shortcodes: [
            'brunei',
            'flag_bn',
        ],
        tags: [
            'BN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f3.png',
    },
    {
        emoji: '🇧🇴',
        name: 'bolivia',
        shortcodes: [
            'bolivia',
            'flag_bo',
        ],
        tags: [
            'BO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f4.png',
    },
    {
        emoji: '🇧🇶',
        name: 'caribbean_netherlands',
        shortcodes: [
            'caribbean_netherlands',
            'flag_bq',
        ],
        tags: [
            'BQ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f6.png',
    },
    {
        emoji: '🇧🇷',
        name: 'brazil',
        shortcodes: [
            'brazil',
            'flag_br',
        ],
        tags: [
            'BR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f7.png',
    },
    {
        emoji: '🇧🇸',
        name: 'bahamas',
        shortcodes: [
            'bahamas',
            'flag_bs',
        ],
        tags: [
            'BS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f8.png',
    },
    {
        emoji: '🇧🇹',
        name: 'bhutan',
        shortcodes: [
            'bhutan',
            'flag_bt',
        ],
        tags: [
            'BT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f9.png',
    },
    {
        emoji: '🇧🇻',
        name: 'bouvet_island',
        shortcodes: [
            'bouvet_island',
            'flag_bv',
        ],
        tags: [
            'BV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fb.png',
    },
    {
        emoji: '🇧🇼',
        name: 'botswana',
        shortcodes: [
            'botswana',
            'flag_bw',
        ],
        tags: [
            'BW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fc.png',
    },
    {
        emoji: '🇧🇾',
        name: 'belarus',
        shortcodes: [
            'belarus',
            'flag_by',
        ],
        tags: [
            'BY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fe.png',
    },
    {
        emoji: '🇧🇿',
        name: 'belize',
        shortcodes: [
            'belize',
            'flag_bz',
        ],
        tags: [
            'BZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ff.png',
    },
    {
        emoji: '🇨🇦',
        name: 'canada',
        shortcodes: [
            'canada',
            'flag_ca',
        ],
        tags: [
            'CA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e6.png',
    },
    {
        emoji: '🇨🇨',
        name: 'cocos_islands',
        shortcodes: [
            'cocos_islands',
            'flag_cc',
        ],
        tags: [
            'CC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e8.png',
    },
    {
        emoji: '🇨🇩',
        name: 'congo_kinshasa',
        shortcodes: [
            'congo_kinshasa',
            'flag_cd',
        ],
        tags: [
            'CD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e9.png',
    },
    {
        emoji: '🇨🇫',
        name: 'central_african_republic',
        shortcodes: [
            'central_african_republic',
            'flag_cf',
        ],
        tags: [
            'CF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1eb.png',
    },
    {
        emoji: '🇨🇬',
        name: 'congo_brazzaville',
        shortcodes: [
            'congo_brazzaville',
            'flag_cg',
        ],
        tags: [
            'CG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ec.png',
    },
    {
        emoji: '🇨🇭',
        name: 'switzerland',
        shortcodes: [
            'flag_ch',
            'switzerland',
        ],
        tags: [
            'CH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ed.png',
    },
    {
        emoji: '🇨🇮',
        name: 'cote_divoire',
        shortcodes: [
            'cote_divoire',
            'flag_ci',
        ],
        tags: [
            'CI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ee.png',
    },
    {
        emoji: '🇨🇰',
        name: 'cook_islands',
        shortcodes: [
            'cook_islands',
            'flag_ck',
        ],
        tags: [
            'CK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f0.png',
    },
    {
        emoji: '🇨🇱',
        name: 'chile',
        shortcodes: [
            'chile',
            'flag_cl',
        ],
        tags: [
            'CL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f1.png',
    },
    {
        emoji: '🇨🇲',
        name: 'cameroon',
        shortcodes: [
            'cameroon',
            'flag_cm',
        ],
        tags: [
            'CM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f2.png',
    },
    {
        emoji: '🇨🇳',
        name: 'cn',
        shortcodes: [
            'china',
            'flag_cn',
        ],
        tags: [
            'CN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f3.png',
    },
    {
        emoji: '🇨🇴',
        name: 'colombia',
        shortcodes: [
            'colombia',
            'flag_co',
        ],
        tags: [
            'CO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f4.png',
    },
    {
        emoji: '🇨🇵',
        name: 'clipperton_island',
        shortcodes: [
            'clipperton_island',
            'flag_cp',
        ],
        tags: [
            'CP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f5.png',
    },
    {
        emoji: '🇨🇷',
        name: 'costa_rica',
        shortcodes: [
            'costa_rica',
            'flag_cr',
        ],
        tags: [
            'CR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f7.png',
    },
    {
        emoji: '🇨🇺',
        name: 'cuba',
        shortcodes: [
            'cuba',
            'flag_cu',
        ],
        tags: [
            'CU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fa.png',
    },
    {
        emoji: '🇨🇻',
        name: 'cape_verde',
        shortcodes: [
            'cape_verde',
            'flag_cv',
        ],
        tags: [
            'CV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fb.png',
    },
    {
        emoji: '🇨🇼',
        name: 'curacao',
        shortcodes: [
            'curacao',
            'flag_cw',
        ],
        tags: [
            'CW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fc.png',
    },
    {
        emoji: '🇨🇽',
        name: 'christmas_island',
        shortcodes: [
            'christmas_island',
            'flag_cx',
        ],
        tags: [
            'CX',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fd.png',
    },
    {
        emoji: '🇨🇾',
        name: 'cyprus',
        shortcodes: [
            'cyprus',
            'flag_cy',
        ],
        tags: [
            'CY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fe.png',
    },
    {
        emoji: '🇨🇿',
        name: 'czech_republic',
        shortcodes: [
            'czech_republic',
            'czechia',
            'flag_cz',
        ],
        tags: [
            'CZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ff.png',
    },
    {
        emoji: '🇩🇪',
        name: 'de',
        shortcodes: [
            'flag_de',
            'germany',
        ],
        tags: [
            'DE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ea.png',
    },
    {
        emoji: '🇩🇬',
        name: 'diego_garcia',
        shortcodes: [
            'diego_garcia',
            'flag_dg',
        ],
        tags: [
            'DG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ec.png',
    },
    {
        emoji: '🇩🇯',
        name: 'djibouti',
        shortcodes: [
            'djibouti',
            'flag_dj',
        ],
        tags: [
            'DJ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ef.png',
    },
    {
        emoji: '🇩🇰',
        name: 'denmark',
        shortcodes: [
            'denmark',
            'flag_dk',
        ],
        tags: [
            'DK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f0.png',
    },
    {
        emoji: '🇩🇲',
        name: 'dominica',
        shortcodes: [
            'dominica',
            'flag_dm',
        ],
        tags: [
            'DM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f2.png',
    },
    {
        emoji: '🇩🇴',
        name: 'dominican_republic',
        shortcodes: [
            'dominican_republic',
            'flag_do',
        ],
        tags: [
            'DO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f4.png',
    },
    {
        emoji: '🇩🇿',
        name: 'algeria',
        shortcodes: [
            'algeria',
            'flag_dz',
        ],
        tags: [
            'DZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ff.png',
    },
    {
        emoji: '🇪🇦',
        name: 'ceuta_melilla',
        shortcodes: [
            'ceuta_melilla',
            'flag_ea',
        ],
        tags: [
            'EA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1e6.png',
    },
    {
        emoji: '🇪🇨',
        name: 'ecuador',
        shortcodes: [
            'ecuador',
            'flag_ec',
        ],
        tags: [
            'EC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1e8.png',
    },
    {
        emoji: '🇪🇪',
        name: 'estonia',
        shortcodes: [
            'estonia',
            'flag_ee',
        ],
        tags: [
            'EE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ea.png',
    },
    {
        emoji: '🇪🇬',
        name: 'egypt',
        shortcodes: [
            'egypt',
            'flag_eg',
        ],
        tags: [
            'EG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ec.png',
    },
    {
        emoji: '🇪🇭',
        name: 'western_sahara',
        shortcodes: [
            'flag_eh',
            'western_sahara',
        ],
        tags: [
            'EH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ed.png',
    },
    {
        emoji: '🇪🇷',
        name: 'eritrea',
        shortcodes: [
            'eritrea',
            'flag_er',
        ],
        tags: [
            'ER',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f7.png',
    },
    {
        emoji: '🇪🇸',
        name: 'es',
        shortcodes: [
            'flag_es',
            'spain',
        ],
        tags: [
            'ES',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f8.png',
    },
    {
        emoji: '🇪🇹',
        name: 'ethiopia',
        shortcodes: [
            'ethiopia',
            'flag_et',
        ],
        tags: [
            'ET',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f9.png',
    },
    {
        emoji: '🇪🇺',
        name: 'eu',
        shortcodes: [
            'european_union',
            'flag_eu',
        ],
        tags: [
            'EU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1fa.png',
    },
    {
        emoji: '🇫🇮',
        name: 'finland',
        shortcodes: [
            'finland',
            'flag_fi',
        ],
        tags: [
            'FI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1ee.png',
    },
    {
        emoji: '🇫🇯',
        name: 'fiji',
        shortcodes: [
            'fiji',
            'flag_fj',
        ],
        tags: [
            'FJ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1ef.png',
    },
    {
        emoji: '🇫🇰',
        name: 'falkland_islands',
        shortcodes: [
            'falkland_islands',
            'flag_fk',
        ],
        tags: [
            'FK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f0.png',
    },
    {
        emoji: '🇫🇲',
        name: 'micronesia',
        shortcodes: [
            'flag_fm',
            'micronesia',
        ],
        tags: [
            'FM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f2.png',
    },
    {
        emoji: '🇫🇴',
        name: 'faroe_islands',
        shortcodes: [
            'faroe_islands',
            'flag_fo',
        ],
        tags: [
            'FO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f4.png',
    },
    {
        emoji: '🇫🇷',
        name: 'fr',
        shortcodes: [
            'flag_fr',
            'france',
        ],
        tags: [
            'FR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f7.png',
    },
    {
        emoji: '🇬🇦',
        name: 'gabon',
        shortcodes: [
            'flag_ga',
            'gabon',
        ],
        tags: [
            'GA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e6.png',
    },
    {
        emoji: '🇬🇧',
        name: 'gb',
        shortcodes: [
            'flag_gb',
            'uk',
            'united_kingdom',
        ],
        tags: [
            'GB',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e7.png',
    },
    {
        emoji: '🇬🇩',
        name: 'grenada',
        shortcodes: [
            'flag_gd',
            'grenada',
        ],
        tags: [
            'GD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e9.png',
    },
    {
        emoji: '🇬🇪',
        name: 'georgia',
        shortcodes: [
            'flag_ge',
            'georgia',
        ],
        tags: [
            'GE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ea.png',
    },
    {
        emoji: '🇬🇫',
        name: 'french_guiana',
        shortcodes: [
            'flag_gf',
            'french_guiana',
        ],
        tags: [
            'GF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1eb.png',
    },
    {
        emoji: '🇬🇬',
        name: 'guernsey',
        shortcodes: [
            'flag_gg',
            'guernsey',
        ],
        tags: [
            'GG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ec.png',
    },
    {
        emoji: '🇬🇭',
        name: 'ghana',
        shortcodes: [
            'flag_gh',
            'ghana',
        ],
        tags: [
            'GH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ed.png',
    },
    {
        emoji: '🇬🇮',
        name: 'gibraltar',
        shortcodes: [
            'flag_gi',
            'gibraltar',
        ],
        tags: [
            'GI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ee.png',
    },
    {
        emoji: '🇬🇱',
        name: 'greenland',
        shortcodes: [
            'flag_gl',
            'greenland',
        ],
        tags: [
            'GL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f1.png',
    },
    {
        emoji: '🇬🇲',
        name: 'gambia',
        shortcodes: [
            'flag_gm',
            'gambia',
        ],
        tags: [
            'GM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f2.png',
    },
    {
        emoji: '🇬🇳',
        name: 'guinea',
        shortcodes: [
            'flag_gn',
            'guinea',
        ],
        tags: [
            'GN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f3.png',
    },
    {
        emoji: '🇬🇵',
        name: 'guadeloupe',
        shortcodes: [
            'flag_gp',
            'guadeloupe',
        ],
        tags: [
            'GP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f5.png',
    },
    {
        emoji: '🇬🇶',
        name: 'equatorial_guinea',
        shortcodes: [
            'equatorial_guinea',
            'flag_gq',
        ],
        tags: [
            'GQ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f6.png',
    },
    {
        emoji: '🇬🇷',
        name: 'greece',
        shortcodes: [
            'flag_gr',
            'greece',
        ],
        tags: [
            'GR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f7.png',
    },
    {
        emoji: '🇬🇸',
        name: 'south_georgia_south_sandwich_islands',
        shortcodes: [
            'flag_gs',
            'south_georgia_south_sandwich_islands',
        ],
        tags: [
            'GS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f8.png',
    },
    {
        emoji: '🇬🇹',
        name: 'guatemala',
        shortcodes: [
            'flag_gt',
            'guatemala',
        ],
        tags: [
            'GT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f9.png',
    },
    {
        emoji: '🇬🇺',
        name: 'guam',
        shortcodes: [
            'flag_gu',
            'guam',
        ],
        tags: [
            'GU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fa.png',
    },
    {
        emoji: '🇬🇼',
        name: 'guinea_bissau',
        shortcodes: [
            'flag_gw',
            'guinea_bissau',
        ],
        tags: [
            'GW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fc.png',
    },
    {
        emoji: '🇬🇾',
        name: 'guyana',
        shortcodes: [
            'flag_gy',
            'guyana',
        ],
        tags: [
            'GY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fe.png',
    },
    {
        emoji: '🇭🇰',
        name: 'hong_kong',
        shortcodes: [
            'flag_hk',
            'hong_kong',
        ],
        tags: [
            'HK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f0.png',
    },
    {
        emoji: '🇭🇲',
        name: 'heard_mcdonald_islands',
        shortcodes: [
            'flag_hm',
            'heard_mcdonald_islands',
        ],
        tags: [
            'HM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f2.png',
    },
    {
        emoji: '🇭🇳',
        name: 'honduras',
        shortcodes: [
            'flag_hn',
            'honduras',
        ],
        tags: [
            'HN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f3.png',
    },
    {
        emoji: '🇭🇷',
        name: 'croatia',
        shortcodes: [
            'croatia',
            'flag_hr',
        ],
        tags: [
            'HR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f7.png',
    },
    {
        emoji: '🇭🇹',
        name: 'haiti',
        shortcodes: [
            'flag_ht',
            'haiti',
        ],
        tags: [
            'HT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f9.png',
    },
    {
        emoji: '🇭🇺',
        name: 'hungary',
        shortcodes: [
            'flag_hu',
            'hungary',
        ],
        tags: [
            'HU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1fa.png',
    },
    {
        emoji: '🇮🇨',
        name: 'canary_islands',
        shortcodes: [
            'canary_islands',
            'flag_ic',
        ],
        tags: [
            'IC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1e8.png',
    },
    {
        emoji: '🇮🇩',
        name: 'indonesia',
        shortcodes: [
            'flag_id',
            'indonesia',
        ],
        tags: [
            'ID',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1e9.png',
    },
    {
        emoji: '🇮🇪',
        name: 'ireland',
        shortcodes: [
            'flag_ie',
            'ireland',
        ],
        tags: [
            'IE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1ea.png',
    },
    {
        emoji: '🇮🇱',
        name: 'israel',
        shortcodes: [
            'flag_il',
            'israel',
        ],
        tags: [
            'IL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f1.png',
    },
    {
        emoji: '🇮🇲',
        name: 'isle_of_man',
        shortcodes: [
            'flag_im',
            'isle_of_man',
        ],
        tags: [
            'IM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f2.png',
    },
    {
        emoji: '🇮🇳',
        name: 'india',
        shortcodes: [
            'flag_in',
            'india',
        ],
        tags: [
            'IN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f3.png',
    },
    {
        emoji: '🇮🇴',
        name: 'british_indian_ocean_territory',
        shortcodes: [
            'british_indian_ocean_territory',
            'flag_io',
        ],
        tags: [
            'IO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f4.png',
    },
    {
        emoji: '🇮🇶',
        name: 'iraq',
        shortcodes: [
            'flag_iq',
            'iraq',
        ],
        tags: [
            'IQ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f6.png',
    },
    {
        emoji: '🇮🇷',
        name: 'iran',
        shortcodes: [
            'flag_ir',
            'iran',
        ],
        tags: [
            'IR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f7.png',
    },
    {
        emoji: '🇮🇸',
        name: 'iceland',
        shortcodes: [
            'flag_is',
            'iceland',
        ],
        tags: [
            'IS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f8.png',
    },
    {
        emoji: '🇮🇹',
        name: 'it',
        shortcodes: [
            'flag_it',
            'italy',
        ],
        tags: [
            'IT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f9.png',
    },
    {
        emoji: '🇯🇪',
        name: 'jersey',
        shortcodes: [
            'flag_je',
            'jersey',
        ],
        tags: [
            'JE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1ea.png',
    },
    {
        emoji: '🇯🇲',
        name: 'jamaica',
        shortcodes: [
            'flag_jm',
            'jamaica',
        ],
        tags: [
            'JM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f2.png',
    },
    {
        emoji: '🇯🇴',
        name: 'jordan',
        shortcodes: [
            'flag_jo',
            'jordan',
        ],
        tags: [
            'JO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f4.png',
    },
    {
        emoji: '🇯🇵',
        name: 'jp',
        shortcodes: [
            'flag_jp',
            'japan',
        ],
        tags: [
            'JP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f5.png',
    },
    {
        emoji: '🇰🇪',
        name: 'kenya',
        shortcodes: [
            'flag_ke',
            'kenya',
        ],
        tags: [
            'KE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ea.png',
    },
    {
        emoji: '🇰🇬',
        name: 'kyrgyzstan',
        shortcodes: [
            'flag_kg',
            'kyrgyzstan',
        ],
        tags: [
            'KG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ec.png',
    },
    {
        emoji: '🇰🇭',
        name: 'cambodia',
        shortcodes: [
            'cambodia',
            'flag_kh',
        ],
        tags: [
            'KH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ed.png',
    },
    {
        emoji: '🇰🇮',
        name: 'kiribati',
        shortcodes: [
            'flag_ki',
            'kiribati',
        ],
        tags: [
            'KI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ee.png',
    },
    {
        emoji: '🇰🇲',
        name: 'comoros',
        shortcodes: [
            'comoros',
            'flag_km',
        ],
        tags: [
            'KM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f2.png',
    },
    {
        emoji: '🇰🇳',
        name: 'st_kitts_nevis',
        shortcodes: [
            'flag_kn',
            'st_kitts_nevis',
        ],
        tags: [
            'KN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f3.png',
    },
    {
        emoji: '🇰🇵',
        name: 'north_korea',
        shortcodes: [
            'flag_kp',
            'north_korea',
        ],
        tags: [
            'KP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f5.png',
    },
    {
        emoji: '🇰🇷',
        name: 'kr',
        shortcodes: [
            'flag_kr',
            'south_korea',
        ],
        tags: [
            'KR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f7.png',
    },
    {
        emoji: '🇰🇼',
        name: 'kuwait',
        shortcodes: [
            'flag_kw',
            'kuwait',
        ],
        tags: [
            'KW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1fc.png',
    },
    {
        emoji: '🇰🇾',
        name: 'cayman_islands',
        shortcodes: [
            'cayman_islands',
            'flag_ky',
        ],
        tags: [
            'KY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1fe.png',
    },
    {
        emoji: '🇰🇿',
        name: 'kazakhstan',
        shortcodes: [
            'flag_kz',
            'kazakhstan',
        ],
        tags: [
            'KZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ff.png',
    },
    {
        emoji: '🇱🇦',
        name: 'laos',
        shortcodes: [
            'flag_la',
            'laos',
        ],
        tags: [
            'LA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e6.png',
    },
    {
        emoji: '🇱🇧',
        name: 'lebanon',
        shortcodes: [
            'flag_lb',
            'lebanon',
        ],
        tags: [
            'LB',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e7.png',
    },
    {
        emoji: '🇱🇨',
        name: 'st_lucia',
        shortcodes: [
            'flag_lc',
            'st_lucia',
        ],
        tags: [
            'LC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e8.png',
    },
    {
        emoji: '🇱🇮',
        name: 'liechtenstein',
        shortcodes: [
            'flag_li',
            'liechtenstein',
        ],
        tags: [
            'LI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1ee.png',
    },
    {
        emoji: '🇱🇰',
        name: 'sri_lanka',
        shortcodes: [
            'flag_lk',
            'sri_lanka',
        ],
        tags: [
            'LK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f0.png',
    },
    {
        emoji: '🇱🇷',
        name: 'liberia',
        shortcodes: [
            'flag_lr',
            'liberia',
        ],
        tags: [
            'LR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f7.png',
    },
    {
        emoji: '🇱🇸',
        name: 'lesotho',
        shortcodes: [
            'flag_ls',
            'lesotho',
        ],
        tags: [
            'LS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f8.png',
    },
    {
        emoji: '🇱🇹',
        name: 'lithuania',
        shortcodes: [
            'flag_lt',
            'lithuania',
        ],
        tags: [
            'LT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f9.png',
    },
    {
        emoji: '🇱🇺',
        name: 'luxembourg',
        shortcodes: [
            'flag_lu',
            'luxembourg',
        ],
        tags: [
            'LU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fa.png',
    },
    {
        emoji: '🇱🇻',
        name: 'latvia',
        shortcodes: [
            'flag_lv',
            'latvia',
        ],
        tags: [
            'LV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fb.png',
    },
    {
        emoji: '🇱🇾',
        name: 'libya',
        shortcodes: [
            'flag_ly',
            'libya',
        ],
        tags: [
            'LY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fe.png',
    },
    {
        emoji: '🇲🇦',
        name: 'morocco',
        shortcodes: [
            'flag_ma',
            'morocco',
        ],
        tags: [
            'MA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e6.png',
    },
    {
        emoji: '🇲🇨',
        name: 'monaco',
        shortcodes: [
            'flag_mc',
            'monaco',
        ],
        tags: [
            'MC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e8.png',
    },
    {
        emoji: '🇲🇩',
        name: 'moldova',
        shortcodes: [
            'flag_md',
            'moldova',
        ],
        tags: [
            'MD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e9.png',
    },
    {
        emoji: '🇲🇪',
        name: 'montenegro',
        shortcodes: [
            'flag_me',
            'montenegro',
        ],
        tags: [
            'ME',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ea.png',
    },
    {
        emoji: '🇲🇫',
        name: 'st_martin',
        shortcodes: [
            'flag_mf',
            'st_martin',
        ],
        tags: [
            'MF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1eb.png',
    },
    {
        emoji: '🇲🇬',
        name: 'madagascar',
        shortcodes: [
            'flag_mg',
            'madagascar',
        ],
        tags: [
            'MG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ec.png',
    },
    {
        emoji: '🇲🇭',
        name: 'marshall_islands',
        shortcodes: [
            'flag_mh',
            'marshall_islands',
        ],
        tags: [
            'MH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ed.png',
    },
    {
        emoji: '🇲🇰',
        name: 'macedonia',
        shortcodes: [
            'flag_mk',
            'macedonia',
        ],
        tags: [
            'MK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f0.png',
    },
    {
        emoji: '🇲🇱',
        name: 'mali',
        shortcodes: [
            'flag_ml',
            'mali',
        ],
        tags: [
            'ML',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f1.png',
    },
    {
        emoji: '🇲🇲',
        name: 'myanmar',
        shortcodes: [
            'burma',
            'flag_mm',
            'myanmar',
        ],
        tags: [
            'MM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f2.png',
    },
    {
        emoji: '🇲🇳',
        name: 'mongolia',
        shortcodes: [
            'flag_mn',
            'mongolia',
        ],
        tags: [
            'MN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f3.png',
    },
    {
        emoji: '🇲🇴',
        name: 'macau',
        shortcodes: [
            'flag_mo',
            'macao',
            'macau',
        ],
        tags: [
            'MO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f4.png',
    },
    {
        emoji: '🇲🇵',
        name: 'northern_mariana_islands',
        shortcodes: [
            'flag_mp',
            'northern_mariana_islands',
        ],
        tags: [
            'MP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f5.png',
    },
    {
        emoji: '🇲🇶',
        name: 'martinique',
        shortcodes: [
            'flag_mq',
            'martinique',
        ],
        tags: [
            'MQ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f6.png',
    },
    {
        emoji: '🇲🇷',
        name: 'mauritania',
        shortcodes: [
            'flag_mr',
            'mauritania',
        ],
        tags: [
            'MR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f7.png',
    },
    {
        emoji: '🇲🇸',
        name: 'montserrat',
        shortcodes: [
            'flag_ms',
            'montserrat',
        ],
        tags: [
            'MS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f8.png',
    },
    {
        emoji: '🇲🇹',
        name: 'malta',
        shortcodes: [
            'flag_mt',
            'malta',
        ],
        tags: [
            'MT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f9.png',
    },
    {
        emoji: '🇲🇺',
        name: 'mauritius',
        shortcodes: [
            'flag_mu',
            'mauritius',
        ],
        tags: [
            'MU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fa.png',
    },
    {
        emoji: '🇲🇻',
        name: 'maldives',
        shortcodes: [
            'flag_mv',
            'maldives',
        ],
        tags: [
            'MV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fb.png',
    },
    {
        emoji: '🇲🇼',
        name: 'malawi',
        shortcodes: [
            'flag_mw',
            'malawi',
        ],
        tags: [
            'MW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fc.png',
    },
    {
        emoji: '🇲🇽',
        name: 'mexico',
        shortcodes: [
            'flag_mx',
            'mexico',
        ],
        tags: [
            'MX',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fd.png',
    },
    {
        emoji: '🇲🇾',
        name: 'malaysia',
        shortcodes: [
            'flag_my',
            'malaysia',
        ],
        tags: [
            'MY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fe.png',
    },
    {
        emoji: '🇲🇿',
        name: 'mozambique',
        shortcodes: [
            'flag_mz',
            'mozambique',
        ],
        tags: [
            'MZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ff.png',
    },
    {
        emoji: '🇳🇦',
        name: 'namibia',
        shortcodes: [
            'flag_na',
            'namibia',
        ],
        tags: [
            'NA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1e6.png',
    },
    {
        emoji: '🇳🇨',
        name: 'new_caledonia',
        shortcodes: [
            'flag_nc',
            'new_caledonia',
        ],
        tags: [
            'NC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1e8.png',
    },
    {
        emoji: '🇳🇪',
        name: 'niger',
        shortcodes: [
            'flag_ne',
            'niger',
        ],
        tags: [
            'NE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ea.png',
    },
    {
        emoji: '🇳🇫',
        name: 'norfolk_island',
        shortcodes: [
            'flag_nf',
            'norfolk_island',
        ],
        tags: [
            'NF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1eb.png',
    },
    {
        emoji: '🇳🇬',
        name: 'nigeria',
        shortcodes: [
            'flag_ng',
            'nigeria',
        ],
        tags: [
            'NG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ec.png',
    },
    {
        emoji: '🇳🇮',
        name: 'nicaragua',
        shortcodes: [
            'flag_ni',
            'nicaragua',
        ],
        tags: [
            'NI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ee.png',
    },
    {
        emoji: '🇳🇱',
        name: 'netherlands',
        shortcodes: [
            'flag_nl',
            'netherlands',
        ],
        tags: [
            'NL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f1.png',
    },
    {
        emoji: '🇳🇴',
        name: 'norway',
        shortcodes: [
            'flag_no',
            'norway',
        ],
        tags: [
            'NO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f4.png',
    },
    {
        emoji: '🇳🇵',
        name: 'nepal',
        shortcodes: [
            'flag_np',
            'nepal',
        ],
        tags: [
            'NP',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f5.png',
    },
    {
        emoji: '🇳🇷',
        name: 'nauru',
        shortcodes: [
            'flag_nr',
            'nauru',
        ],
        tags: [
            'NR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f7.png',
    },
    {
        emoji: '🇳🇺',
        name: 'niue',
        shortcodes: [
            'flag_nu',
            'niue',
        ],
        tags: [
            'NU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1fa.png',
    },
    {
        emoji: '🇳🇿',
        name: 'new_zealand',
        shortcodes: [
            'flag_nz',
            'new_zealand',
        ],
        tags: [
            'NZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ff.png',
    },
    {
        emoji: '🇴🇲',
        name: 'oman',
        shortcodes: [
            'flag_om',
            'oman',
        ],
        tags: [
            'OM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f4-1f1f2.png',
    },
    {
        emoji: '🇵🇦',
        name: 'panama',
        shortcodes: [
            'flag_pa',
            'panama',
        ],
        tags: [
            'PA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1e6.png',
    },
    {
        emoji: '🇵🇪',
        name: 'peru',
        shortcodes: [
            'flag_pe',
            'peru',
        ],
        tags: [
            'PE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ea.png',
    },
    {
        emoji: '🇵🇫',
        name: 'french_polynesia',
        shortcodes: [
            'flag_pf',
            'french_polynesia',
        ],
        tags: [
            'PF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1eb.png',
    },
    {
        emoji: '🇵🇬',
        name: 'papua_new_guinea',
        shortcodes: [
            'flag_pg',
            'papua_new_guinea',
        ],
        tags: [
            'PG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ec.png',
    },
    {
        emoji: '🇵🇭',
        name: 'philippines',
        shortcodes: [
            'flag_ph',
            'philippines',
        ],
        tags: [
            'PH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ed.png',
    },
    {
        emoji: '🇵🇰',
        name: 'pakistan',
        shortcodes: [
            'flag_pk',
            'pakistan',
        ],
        tags: [
            'PK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f0.png',
    },
    {
        emoji: '🇵🇱',
        name: 'poland',
        shortcodes: [
            'flag_pl',
            'poland',
        ],
        tags: [
            'PL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f1.png',
    },
    {
        emoji: '🇵🇲',
        name: 'st_pierre_miquelon',
        shortcodes: [
            'flag_pm',
            'st_pierre_miquelon',
        ],
        tags: [
            'PM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f2.png',
    },
    {
        emoji: '🇵🇳',
        name: 'pitcairn_islands',
        shortcodes: [
            'flag_pn',
            'pitcairn_islands',
        ],
        tags: [
            'PN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f3.png',
    },
    {
        emoji: '🇵🇷',
        name: 'puerto_rico',
        shortcodes: [
            'flag_pr',
            'puerto_rico',
        ],
        tags: [
            'PR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f7.png',
    },
    {
        emoji: '🇵🇸',
        name: 'palestinian_territories',
        shortcodes: [
            'flag_ps',
            'palestinian_territories',
        ],
        tags: [
            'PS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f8.png',
    },
    {
        emoji: '🇵🇹',
        name: 'portugal',
        shortcodes: [
            'flag_pt',
            'portugal',
        ],
        tags: [
            'PT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f9.png',
    },
    {
        emoji: '🇵🇼',
        name: 'palau',
        shortcodes: [
            'flag_pw',
            'palau',
        ],
        tags: [
            'PW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1fc.png',
    },
    {
        emoji: '🇵🇾',
        name: 'paraguay',
        shortcodes: [
            'flag_py',
            'paraguay',
        ],
        tags: [
            'PY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1fe.png',
    },
    {
        emoji: '🇶🇦',
        name: 'qatar',
        shortcodes: [
            'flag_qa',
            'qatar',
        ],
        tags: [
            'QA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f6-1f1e6.png',
    },
    {
        emoji: '🇷🇪',
        name: 'reunion',
        shortcodes: [
            'flag_re',
            'reunion',
        ],
        tags: [
            'RE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1ea.png',
    },
    {
        emoji: '🇷🇴',
        name: 'romania',
        shortcodes: [
            'flag_ro',
            'romania',
        ],
        tags: [
            'RO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1f4.png',
    },
    {
        emoji: '🇷🇸',
        name: 'serbia',
        shortcodes: [
            'flag_rs',
            'serbia',
        ],
        tags: [
            'RS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1f8.png',
    },
    {
        emoji: '🇷🇺',
        name: 'ru',
        shortcodes: [
            'flag_ru',
            'russia',
        ],
        tags: [
            'RU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1fa.png',
    },
    {
        emoji: '🇷🇼',
        name: 'rwanda',
        shortcodes: [
            'flag_rw',
            'rwanda',
        ],
        tags: [
            'RW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1fc.png',
    },
    {
        emoji: '🇸🇦',
        name: 'saudi_arabia',
        shortcodes: [
            'flag_sa',
            'saudi_arabia',
        ],
        tags: [
            'SA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e6.png',
    },
    {
        emoji: '🇸🇧',
        name: 'solomon_islands',
        shortcodes: [
            'flag_sb',
            'solomon_islands',
        ],
        tags: [
            'SB',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e7.png',
    },
    {
        emoji: '🇸🇨',
        name: 'seychelles',
        shortcodes: [
            'flag_sc',
            'seychelles',
        ],
        tags: [
            'SC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e8.png',
    },
    {
        emoji: '🇸🇩',
        name: 'sudan',
        shortcodes: [
            'flag_sd',
            'sudan',
        ],
        tags: [
            'SD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e9.png',
    },
    {
        emoji: '🇸🇪',
        name: 'sweden',
        shortcodes: [
            'flag_se',
            'sweden',
        ],
        tags: [
            'SE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ea.png',
    },
    {
        emoji: '🇸🇬',
        name: 'singapore',
        shortcodes: [
            'flag_sg',
            'singapore',
        ],
        tags: [
            'SG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ec.png',
    },
    {
        emoji: '🇸🇭',
        name: 'st_helena',
        shortcodes: [
            'flag_sh',
            'st_helena',
        ],
        tags: [
            'SH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ed.png',
    },
    {
        emoji: '🇸🇮',
        name: 'slovenia',
        shortcodes: [
            'flag_si',
            'slovenia',
        ],
        tags: [
            'SI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ee.png',
    },
    {
        emoji: '🇸🇯',
        name: 'svalbard_jan_mayen',
        shortcodes: [
            'flag_sj',
            'svalbard_jan_mayen',
        ],
        tags: [
            'SJ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ef.png',
    },
    {
        emoji: '🇸🇰',
        name: 'slovakia',
        shortcodes: [
            'flag_sk',
            'slovakia',
        ],
        tags: [
            'SK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f0.png',
    },
    {
        emoji: '🇸🇱',
        name: 'sierra_leone',
        shortcodes: [
            'flag_sl',
            'sierra_leone',
        ],
        tags: [
            'SL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f1.png',
    },
    {
        emoji: '🇸🇲',
        name: 'san_marino',
        shortcodes: [
            'flag_sm',
            'san_marino',
        ],
        tags: [
            'SM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f2.png',
    },
    {
        emoji: '🇸🇳',
        name: 'senegal',
        shortcodes: [
            'flag_sn',
            'senegal',
        ],
        tags: [
            'SN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f3.png',
    },
    {
        emoji: '🇸🇴',
        name: 'somalia',
        shortcodes: [
            'flag_so',
            'somalia',
        ],
        tags: [
            'SO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f4.png',
    },
    {
        emoji: '🇸🇷',
        name: 'suriname',
        shortcodes: [
            'flag_sr',
            'suriname',
        ],
        tags: [
            'SR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f7.png',
    },
    {
        emoji: '🇸🇸',
        name: 'south_sudan',
        shortcodes: [
            'flag_ss',
            'south_sudan',
        ],
        tags: [
            'SS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f8.png',
    },
    {
        emoji: '🇸🇹',
        name: 'sao_tome_principe',
        shortcodes: [
            'flag_st',
            'sao_tome_principe',
        ],
        tags: [
            'ST',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f9.png',
    },
    {
        emoji: '🇸🇻',
        name: 'el_salvador',
        shortcodes: [
            'el_salvador',
            'flag_sv',
        ],
        tags: [
            'SV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fb.png',
    },
    {
        emoji: '🇸🇽',
        name: 'sint_maarten',
        shortcodes: [
            'flag_sx',
            'sint_maarten',
        ],
        tags: [
            'SX',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fd.png',
    },
    {
        emoji: '🇸🇾',
        name: 'syria',
        shortcodes: [
            'flag_sy',
            'syria',
        ],
        tags: [
            'SY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fe.png',
    },
    {
        emoji: '🇸🇿',
        name: 'swaziland',
        shortcodes: [
            'eswatini',
            'flag_sz',
            'swaziland',
        ],
        tags: [
            'SZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ff.png',
    },
    {
        emoji: '🇹🇦',
        name: 'tristan_da_cunha',
        shortcodes: [
            'flag_ta',
            'tristan_da_cunha',
        ],
        tags: [
            'TA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e6.png',
    },
    {
        emoji: '🇹🇨',
        name: 'turks_caicos_islands',
        shortcodes: [
            'flag_tc',
            'turks_caicos_islands',
        ],
        tags: [
            'TC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e8.png',
    },
    {
        emoji: '🇹🇩',
        name: 'chad',
        shortcodes: [
            'chad',
            'flag_td',
        ],
        tags: [
            'TD',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e9.png',
    },
    {
        emoji: '🇹🇫',
        name: 'french_southern_territories',
        shortcodes: [
            'flag_tf',
            'french_southern_territories',
        ],
        tags: [
            'TF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1eb.png',
    },
    {
        emoji: '🇹🇬',
        name: 'togo',
        shortcodes: [
            'flag_tg',
            'togo',
        ],
        tags: [
            'TG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ec.png',
    },
    {
        emoji: '🇹🇭',
        name: 'thailand',
        shortcodes: [
            'flag_th',
            'thailand',
        ],
        tags: [
            'TH',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ed.png',
    },
    {
        emoji: '🇹🇯',
        name: 'tajikistan',
        shortcodes: [
            'flag_tj',
            'tajikistan',
        ],
        tags: [
            'TJ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ef.png',
    },
    {
        emoji: '🇹🇰',
        name: 'tokelau',
        shortcodes: [
            'flag_tk',
            'tokelau',
        ],
        tags: [
            'TK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f0.png',
    },
    {
        emoji: '🇹🇱',
        name: 'timor_leste',
        shortcodes: [
            'flag_tl',
            'timor_leste',
        ],
        tags: [
            'TL',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f1.png',
    },
    {
        emoji: '🇹🇲',
        name: 'turkmenistan',
        shortcodes: [
            'flag_tm',
            'turkmenistan',
        ],
        tags: [
            'TM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f2.png',
    },
    {
        emoji: '🇹🇳',
        name: 'tunisia',
        shortcodes: [
            'flag_tn',
            'tunisia',
        ],
        tags: [
            'TN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f3.png',
    },
    {
        emoji: '🇹🇴',
        name: 'tonga',
        shortcodes: [
            'flag_to',
            'tonga',
        ],
        tags: [
            'TO',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f4.png',
    },
    {
        emoji: '🇹🇷',
        name: 'tr',
        shortcodes: [
            'flag_tr',
            'turkey_tr',
        ],
        tags: [
            'TR',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f7.png',
    },
    {
        emoji: '🇹🇹',
        name: 'trinidad_tobago',
        shortcodes: [
            'flag_tt',
            'trinidad_tobago',
        ],
        tags: [
            'TT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f9.png',
    },
    {
        emoji: '🇹🇻',
        name: 'tuvalu',
        shortcodes: [
            'flag_tv',
            'tuvalu',
        ],
        tags: [
            'TV',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1fb.png',
    },
    {
        emoji: '🇹🇼',
        name: 'taiwan',
        shortcodes: [
            'flag_tw',
            'taiwan',
        ],
        tags: [
            'TW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1fc.png',
    },
    {
        emoji: '🇹🇿',
        name: 'tanzania',
        shortcodes: [
            'flag_tz',
            'tanzania',
        ],
        tags: [
            'TZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ff.png',
    },
    {
        emoji: '🇺🇦',
        name: 'ukraine',
        shortcodes: [
            'flag_ua',
            'ukraine',
        ],
        tags: [
            'UA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1e6.png',
    },
    {
        emoji: '🇺🇬',
        name: 'uganda',
        shortcodes: [
            'flag_ug',
            'uganda',
        ],
        tags: [
            'UG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1ec.png',
    },
    {
        emoji: '🇺🇲',
        name: 'us_outlying_islands',
        shortcodes: [
            'flag_um',
            'us_outlying_islands',
        ],
        tags: [
            'UM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f2.png',
    },
    {
        emoji: '🇺🇳',
        name: 'united_nations',
        shortcodes: [
            'flag_un',
            'un',
            'united_nations',
        ],
        tags: [
            'UN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 4,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f3.png',
    },
    {
        emoji: '🇺🇸',
        name: 'us',
        shortcodes: [
            'flag_us',
            'united_states',
            'usa',
        ],
        tags: [
            'US',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 0.6,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f8.png',
    },
    {
        emoji: '🇺🇾',
        name: 'uruguay',
        shortcodes: [
            'flag_uy',
            'uruguay',
        ],
        tags: [
            'UY',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1fe.png',
    },
    {
        emoji: '🇺🇿',
        name: 'uzbekistan',
        shortcodes: [
            'flag_uz',
            'uzbekistan',
        ],
        tags: [
            'UZ',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1ff.png',
    },
    {
        emoji: '🇻🇦',
        name: 'vatican_city',
        shortcodes: [
            'flag_va',
            'vatican_city',
        ],
        tags: [
            'VA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1e6.png',
    },
    {
        emoji: '🇻🇨',
        name: 'st_vincent_grenadines',
        shortcodes: [
            'flag_vc',
            'st_vincent_grenadines',
        ],
        tags: [
            'VC',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1e8.png',
    },
    {
        emoji: '🇻🇪',
        name: 'venezuela',
        shortcodes: [
            'flag_ve',
            'venezuela',
        ],
        tags: [
            'VE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ea.png',
    },
    {
        emoji: '🇻🇬',
        name: 'british_virgin_islands',
        shortcodes: [
            'british_virgin_islands',
            'flag_vg',
        ],
        tags: [
            'VG',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ec.png',
    },
    {
        emoji: '🇻🇮',
        name: 'us_virgin_islands',
        shortcodes: [
            'flag_vi',
            'us_virgin_islands',
        ],
        tags: [
            'VI',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ee.png',
    },
    {
        emoji: '🇻🇳',
        name: 'vietnam',
        shortcodes: [
            'flag_vn',
            'vietnam',
        ],
        tags: [
            'VN',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1f3.png',
    },
    {
        emoji: '🇻🇺',
        name: 'vanuatu',
        shortcodes: [
            'flag_vu',
            'vanuatu',
        ],
        tags: [
            'VU',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1fa.png',
    },
    {
        emoji: '🇼🇫',
        name: 'wallis_futuna',
        shortcodes: [
            'flag_wf',
            'wallis_futuna',
        ],
        tags: [
            'WF',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fc-1f1eb.png',
    },
    {
        emoji: '🇼🇸',
        name: 'samoa',
        shortcodes: [
            'flag_ws',
            'samoa',
        ],
        tags: [
            'WS',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fc-1f1f8.png',
    },
    {
        emoji: '🇽🇰',
        name: 'kosovo',
        shortcodes: [
            'flag_xk',
            'kosovo',
        ],
        tags: [
            'XK',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fd-1f1f0.png',
    },
    {
        emoji: '🇾🇪',
        name: 'yemen',
        shortcodes: [
            'flag_ye',
            'yemen',
        ],
        tags: [
            'YE',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fe-1f1ea.png',
    },
    {
        emoji: '🇾🇹',
        name: 'mayotte',
        shortcodes: [
            'flag_yt',
            'mayotte',
        ],
        tags: [
            'YT',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fe-1f1f9.png',
    },
    {
        emoji: '🇿🇦',
        name: 'south_africa',
        shortcodes: [
            'flag_za',
            'south_africa',
        ],
        tags: [
            'ZA',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1e6.png',
    },
    {
        emoji: '🇿🇲',
        name: 'zambia',
        shortcodes: [
            'flag_zm',
            'zambia',
        ],
        tags: [
            'ZM',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1f2.png',
    },
    {
        emoji: '🇿🇼',
        name: 'zimbabwe',
        shortcodes: [
            'flag_zw',
            'zimbabwe',
        ],
        tags: [
            'ZW',
            'flag',
        ],
        group: 'flags',
        emoticons: [],
        version: 2,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1fc.png',
    },
    {
        emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
        name: 'england',
        shortcodes: [
            'england',
            'flag_gbeng',
        ],
        tags: [
            'flag',
            'gbeng',
        ],
        group: 'flags',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0065-e006e-e0067-e007f.png',
    },
    {
        emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
        name: 'scotland',
        shortcodes: [
            'flag_gbsct',
            'scotland',
        ],
        tags: [
            'flag',
            'gbsct',
        ],
        group: 'flags',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0073-e0063-e0074-e007f.png',
    },
    {
        emoji: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
        name: 'wales',
        shortcodes: [
            'flag_gbwls',
            'wales',
        ],
        tags: [
            'flag',
            'gbwls',
        ],
        group: 'flags',
        emoticons: [],
        version: 5,
        fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0077-e006c-e0073-e007f.png',
    },
];
const gitHubCustomEmojis = [
    {
        name: 'atom',
        shortcodes: [
            'atom',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/atom.png',
    },
    {
        name: 'basecamp',
        shortcodes: [
            'basecamp',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/basecamp.png',
    },
    {
        name: 'basecampy',
        shortcodes: [
            'basecampy',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/basecampy.png',
    },
    {
        name: 'bowtie',
        shortcodes: [
            'bowtie',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/bowtie.png',
    },
    {
        name: 'electron',
        shortcodes: [
            'electron',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/electron.png',
    },
    {
        name: 'feelsgood',
        shortcodes: [
            'feelsgood',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/feelsgood.png',
    },
    {
        name: 'finnadie',
        shortcodes: [
            'finnadie',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/finnadie.png',
    },
    {
        name: 'goberserk',
        shortcodes: [
            'goberserk',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/goberserk.png',
    },
    {
        name: 'godmode',
        shortcodes: [
            'godmode',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/godmode.png',
    },
    {
        name: 'hurtrealbad',
        shortcodes: [
            'hurtrealbad',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/hurtrealbad.png',
    },
    {
        name: 'neckbeard',
        shortcodes: [
            'neckbeard',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/neckbeard.png',
    },
    {
        name: 'octocat',
        shortcodes: [
            'octocat',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/octocat.png',
    },
    {
        name: 'rage1',
        shortcodes: [
            'rage1',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage1.png',
    },
    {
        name: 'rage2',
        shortcodes: [
            'rage2',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage2.png',
    },
    {
        name: 'rage3',
        shortcodes: [
            'rage3',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage3.png',
    },
    {
        name: 'rage4',
        shortcodes: [
            'rage4',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage4.png',
    },
    {
        name: 'shipit',
        shortcodes: [
            'shipit',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/shipit.png',
    },
    {
        name: 'suspect',
        shortcodes: [
            'suspect',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/suspect.png',
    },
    {
        name: 'trollface',
        shortcodes: [
            'trollface',
        ],
        tags: [],
        group: 'GitHub',
        fallbackImage: 'https://github.githubassets.com/images/icons/emoji/trollface.png',
    },
];
const gitHubEmojis = [...tiptap_extension_emoji_esm_emojis, ...gitHubCustomEmojis];

const EmojiSuggestionPluginKey = new PluginKey('emojiSuggestion');
const tiptap_extension_emoji_esm_inputRegex = /:([a-zA-Z0-9_+-]+):$/;
const tiptap_extension_emoji_esm_pasteRegex = /:([a-zA-Z0-9_+-]+):/g;
const Emoji = tiptap_core_esm_Node.create({
    name: 'emoji',
    inline: true,
    group: 'inline',
    selectable: false,
    addOptions() {
        return {
            HTMLAttributes: {},
            emojis: tiptap_extension_emoji_esm_emojis,
            enableEmoticons: false,
            forceFallbackImages: false,
            suggestion: {
                char: ':',
                pluginKey: EmojiSuggestionPluginKey,
                command: ({ editor, range, props }) => {
                    var _a;
                    // increase range.to by one when the next node is of type "text"
                    // and starts with a space character
                    const nodeAfter = editor.view.state.selection.$to.nodeAfter;
                    const overrideSpace = (_a = nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.text) === null || _a === void 0 ? void 0 : _a.startsWith(' ');
                    if (overrideSpace) {
                        range.to += 1;
                    }
                    editor
                        .chain()
                        .focus()
                        .insertContentAt(range, [
                        {
                            type: this.name,
                            attrs: props,
                        },
                        {
                            type: 'text',
                            text: ' ',
                        },
                    ])
                        .run();
                },
                allow: ({ state, range }) => {
                    const $from = state.doc.resolve(range.from);
                    const type = state.schema.nodes[this.name];
                    const allow = !!$from.parent.type.contentMatch.matchType(type);
                    return allow;
                },
            },
        };
    },
    addStorage() {
        const { emojis } = this.options;
        const supportMap = tiptap_extension_emoji_esm_removeDuplicates(emojis.map(item => item.version))
            .filter(version => typeof version === 'number')
            .reduce((versions, version) => {
            const emoji = emojis.find(item => item.version === version && item.emoji);
            return {
                ...versions,
                [version]: emoji
                    ? isEmojiSupported(emoji.emoji)
                    : false,
            };
        }, {});
        return {
            emojis: this.options.emojis,
            isSupported: emojiItem => {
                return emojiItem.version
                    ? supportMap[emojiItem.version]
                    : false;
            },
        };
    },
    addAttributes() {
        return {
            name: {
                default: null,
                parseHTML: element => element.dataset.name,
                renderHTML: attributes => ({
                    'data-name': attributes.name,
                }),
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: `span[data-type="${this.name}"]`,
            },
        ];
    },
    renderHTML({ HTMLAttributes, node }) {
        const emojiItem = shortcodeToEmoji(node.attrs.name, this.options.emojis);
        const attributes = mergeAttributes(HTMLAttributes, this.options.HTMLAttributes, { 'data-type': this.name });
        if (!emojiItem) {
            return [
                'span',
                attributes,
                `:${node.attrs.name}:`,
            ];
        }
        const isSupported = this.storage.isSupported(emojiItem);
        const hasEmoji = !!(emojiItem === null || emojiItem === void 0 ? void 0 : emojiItem.emoji);
        const hasFallbackImage = !!(emojiItem === null || emojiItem === void 0 ? void 0 : emojiItem.fallbackImage);
        const renderFallbackImage = !hasEmoji
            || (this.options.forceFallbackImages && hasFallbackImage)
            || (!isSupported && hasFallbackImage);
        return [
            'span',
            attributes,
            renderFallbackImage
                ? [
                    'img',
                    {
                        src: emojiItem.fallbackImage,
                        draggable: 'false',
                        loading: 'lazy',
                        align: 'absmiddle',
                    },
                ]
                : emojiItem.emoji,
        ];
    },
    renderText({ node }) {
        const emojiItem = shortcodeToEmoji(node.attrs.name, this.options.emojis);
        return (emojiItem === null || emojiItem === void 0 ? void 0 : emojiItem.emoji) || `:${node.attrs.name}:`;
    },
    addCommands() {
        return {
            setEmoji: shortcode => ({ commands }) => {
                const emojiItem = shortcodeToEmoji(shortcode, this.options.emojis);
                if (!emojiItem) {
                    return false;
                }
                return commands.insertContent({
                    type: this.name,
                    attrs: {
                        name: emojiItem.name,
                    },
                });
            },
        };
    },
    addInputRules() {
        const inputRules = [];
        inputRules.push(new InputRule({
            find: tiptap_extension_emoji_esm_inputRegex,
            handler: ({ range, match, commands }) => {
                const name = match[1];
                if (!shortcodeToEmoji(name, this.options.emojis)) {
                    return;
                }
                commands.insertContentAt(range, {
                    type: this.name,
                    attrs: {
                        name,
                    },
                });
            },
        }));
        if (this.options.enableEmoticons) {
            // get the list of supported emoticons
            const emoticons = this.options.emojis
                .map(item => item.emoticons)
                .flat()
                .filter(item => item);
            const emoticonRegex = new RegExp(`(?:^|\\s)(${emoticons.map(item => escapeForRegEx(item)).join('|')}) $`);
            inputRules.push(nodeInputRule({
                find: emoticonRegex,
                type: this.type,
                getAttributes: match => {
                    const emoji = this.options.emojis.find(item => { var _a; return (_a = item.emoticons) === null || _a === void 0 ? void 0 : _a.includes(match[1]); });
                    if (!emoji) {
                        return;
                    }
                    return {
                        name: emoji.name,
                    };
                },
            }));
        }
        return inputRules;
    },
    addPasteRules() {
        return [
            new PasteRule({
                find: tiptap_extension_emoji_esm_pasteRegex,
                handler: ({ range, match, commands }) => {
                    const name = match[1];
                    if (!shortcodeToEmoji(name, this.options.emojis)) {
                        return;
                    }
                    commands.insertContentAt(range, {
                        type: this.name,
                        attrs: {
                            name,
                        },
                    }, {
                        updateSelection: false,
                    });
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                ...this.options.suggestion,
            }),
            new Plugin({
                key: new PluginKey('emoji'),
                props: {
                    // double click to select emoji doesn’t work by default
                    // that’s why we simulate this behavior
                    handleDoubleClickOn: (view, pos, node) => {
                        if (node.type !== this.type) {
                            return false;
                        }
                        const from = pos;
                        const to = from + node.nodeSize;
                        this.editor.commands.setTextSelection({
                            from,
                            to,
                        });
                        return true;
                    },
                },
                // replace text emojis with emoji node on any change
                appendTransaction: (transactions, oldState, newState) => {
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    if (!docChanges) {
                        return;
                    }
                    const { tr } = newState;
                    const transform = combineTransactionSteps(oldState.doc, transactions);
                    const changes = getChangedRanges(transform);
                    changes.forEach(({ newRange }) => {
                        // we don’t want to add emoji inline nodes within code blocks
                        // because this would split the code block
                        if (newState.doc.resolve(newRange.from).parent.type.spec.code) {
                            return;
                        }
                        const textNodes = findChildrenInRange(newState.doc, newRange, node => node.type.isText);
                        textNodes.forEach(({ node, pos }) => {
                            if (!node.text) {
                                return;
                            }
                            const matches = [...node.text.matchAll(emoji_regex_default()())];
                            matches.forEach(match => {
                                if (match.index === undefined) {
                                    return;
                                }
                                const emoji = match[0];
                                const name = emojiToShortcode(emoji, this.options.emojis);
                                if (!name) {
                                    return;
                                }
                                const from = tr.mapping.map(pos + match.index);
                                const to = from + emoji.length;
                                const emojiNode = this.type.create({
                                    name,
                                });
                                tr.replaceRangeWith(from, to, emojiNode);
                            });
                        });
                    });
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-emoji.esm.js.map

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmojiList.vue?vue&type=template&id=30ab6a7c&scoped=true&
var EmojiListvue_type_template_id_30ab6a7c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-menu"},[_c('div',{staticClass:"emoji-groups"},_vm._l((_vm.items),function(emojis,group){return _c('div',{key:group,staticClass:"emoji-group"},[_c('div',{staticClass:"emoji-group__label"},[_vm._v(" "+_vm._s(_vm.$t(("mayday-editor.menu.emoji." + group)).toUpperCase())+" ")]),_c('div',{staticClass:"items"},_vm._l((emojis),function(item,index){return _c('button',{key:index,staticClass:"item",class:{
            'is-selected': index === _vm.selectedIndex && group === _vm.selectedGroup,
          },on:{"mouseenter":function($event){_vm.selectedIndex = index;
            _vm.selectedGroup = group;},"click":_vm.enterHandler}},[(item.fallbackImage)?_c('img',{attrs:{"src":item.fallbackImage,"align":"absmiddle"}}):[_vm._v(" "+_vm._s(item.emoji)+" ")]],2)}),0)])}),0),_c('div',{staticClass:"emoji-menu__footer"},[(_vm.selectedGroup)?_c('span',[_vm._v(" "+_vm._s(_vm.items[_vm.selectedGroup][_vm.selectedIndex].name)+" ")]):_vm._e(),_c('span',[_c('a',{staticClass:"help-link",attrs:{"href":_vm.helpLink,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'question-circle']}}),_vm._v(" "+_vm._s(_vm.$t("mayday-editor.menu.slash.footer-description.help"))+" ")],1)])])])}
var EmojiListvue_type_template_id_30ab6a7c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/EmojiList.vue?vue&type=template&id=30ab6a7c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmojiList.vue?vue&type=script&lang=ts&










var EmojiListvue_type_script_lang_ts_a;






var EmojiListvue_type_script_lang_ts_EmojiList = /*#__PURE__*/function (_Vue) {
  _inherits(EmojiList, _Vue);

  var _super = _createSuper(EmojiList);

  function EmojiList() {
    var _this;

    _classCallCheck(this, EmojiList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "items", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectedIndex", 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectedGroup", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "helpLink", "https://changelog.mayday.fr/decouvrez-les-nouveautes-de-mayday/17-02-2022-or-mayday-v2#editeur-de-contenu-v.2.0");

    return _this;
  }

  _createClass(EmojiList, [{
    key: "handleItemsChanged",
    value: function handleItemsChanged() {
      this.selectedIndex = 0;
      this.selectedGroup = Object.keys(this.items)[0];
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(_ref) {
      var event = _ref.event;

      if (event.key === "ArrowUp") {
        this.upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        this.downHandler();
        return true;
      }

      if (event.key === "ArrowLeft") {
        this.leftHandler();
        return true;
      }

      if (event.key === "ArrowRight") {
        this.rightHandler();
        return true;
      }

      if (event.key === "Enter") {
        this.enterHandler();
        return true;
      }

      return false;
    }
  }, {
    key: "upHandler",
    value: function upHandler() {
      var emojies = this.items[this.selectedGroup];
      if (!emojies) throw Error();

      if (this.selectedIndex - 10 >= 0) {
        this.selectedIndex -= 10;
      }
    }
  }, {
    key: "downHandler",
    value: function downHandler() {
      var emojies = this.items[this.selectedGroup];
      if (!emojies) throw Error();

      if (this.selectedIndex + 10 < emojies.length) {
        this.selectedIndex += 10;
      }
    }
  }, {
    key: "leftHandler",
    value: function leftHandler() {
      var emojies = this.items[this.selectedGroup];
      if (!emojies) throw Error();
      this.selectedIndex = (this.selectedIndex + emojies.length - 1) % emojies.length;
    }
  }, {
    key: "rightHandler",
    value: function rightHandler() {
      var emojies = this.items[this.selectedGroup];
      if (!emojies) throw Error();
      this.selectedIndex = (this.selectedIndex + 1) % emojies.length;
    }
  }, {
    key: "enterHandler",
    value: function enterHandler() {
      this.selectItem(this.selectedIndex);
    }
  }, {
    key: "selectItem",
    value: function selectItem(index) {
      var emojies = this.items[this.selectedGroup];
      if (!emojies) throw Error();
      var item = emojies[index];

      if (item) {
        this.command({
          name: item.name
        });
      }
    }
  }]);

  return EmojiList;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], EmojiListvue_type_script_lang_ts_EmojiList.prototype, "items", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], EmojiListvue_type_script_lang_ts_EmojiList.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", typeof (EmojiListvue_type_script_lang_ts_a = typeof tiptap_vue_2_esm_Editor !== "undefined" && tiptap_vue_2_esm_Editor) === "function" ? EmojiListvue_type_script_lang_ts_a : Object)], EmojiListvue_type_script_lang_ts_EmojiList.prototype, "editor", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("items"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], EmojiListvue_type_script_lang_ts_EmojiList.prototype, "handleItemsChanged", null);

EmojiListvue_type_script_lang_ts_EmojiList = __decorate([external_vue_property_decorator_["Component"]], EmojiListvue_type_script_lang_ts_EmojiList);
/* harmony default export */ var EmojiListvue_type_script_lang_ts_ = (EmojiListvue_type_script_lang_ts_EmojiList);
// CONCATENATED MODULE: ./src/components/EmojiList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_EmojiListvue_type_script_lang_ts_ = (EmojiListvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/EmojiList.vue?vue&type=style&index=0&id=30ab6a7c&lang=scss&scoped=true&
var EmojiListvue_type_style_index_0_id_30ab6a7c_lang_scss_scoped_true_ = __webpack_require__("18a2");

// CONCATENATED MODULE: ./src/components/EmojiList.vue






/* normalize component */

var EmojiList_component = normalizeComponent(
  components_EmojiListvue_type_script_lang_ts_,
  EmojiListvue_type_template_id_30ab6a7c_scoped_true_render,
  EmojiListvue_type_template_id_30ab6a7c_scoped_true_staticRenderFns,
  false,
  null,
  "30ab6a7c",
  null
  
)

/* harmony default export */ var components_EmojiList = (EmojiList_component.exports);
// CONCATENATED MODULE: ./src/extensions/Emoji/emojiSuggestion.ts
var emojiSuggestion_this = undefined;











var sortByEmojiGroup = function sortByEmojiGroup(items) {
  var groups = {};
  items.forEach(function (item) {
    var group = item.group;

    if (groups[group]) {
      groups[group].push(item);
    } else {
      groups[group] = [item];
    }
  });
  return groups;
};

var emojiSuggestion_computeSuggestion = function computeSuggestion() {
  return {
    items: function items(_ref) {
      var editor = _ref.editor,
          query = _ref.query;
      var items = editor.storage.emoji.emojis.filter(function (_ref2) {
        var shortcodes = _ref2.shortcodes,
            tags = _ref2.tags;
        return shortcodes.find(function (shortcode) {
          return shortcode.startsWith(query.toLowerCase());
        }) || tags.find(function (tag) {
          return tag.startsWith(query.toLowerCase());
        });
      });
      return sortByEmojiGroup(items);
    },
    render: function render() {
      var component;
      var popup;
      return {
        onStart: function onStart(props) {
          var editor = props.editor;
          var contentComponent = editor.contentComponent; // inject contentComponent to make i18n work (probably other vue plugins too)

          component = new tiptap_vue_2_esm_VueRenderer(components_EmojiList, {
            parent: contentComponent != null ? contentComponent : emojiSuggestion_this,
            propsData: props
          });
          popup = tippy_esm(document.body, {
            getReferenceClientRect: props.clientRect,
            appendTo: function appendTo() {
              return document.body;
            },
            content: component.element,
            showOnCreate: !!props.query.length,
            interactive: true,
            trigger: "manual",
            placement: "top-start",
            theme: "emoji",
            animation: "shift-away",
            duration: [330, 200],
            arrow: false
          });
        },
        onUpdate: function onUpdate(props) {
          component.updateProps(props);
          if (Object.keys(props.items).length) popup.show();else popup.hide();
          popup.setProps({
            getReferenceClientRect: props.clientRect
          });
        },
        onKeyDown: function onKeyDown(props) {
          var _component$ref;

          var event = props.event,
              range = props.range;

          if (event.key === "Escape") {
            popup.hide();
            return true;
          } else if (event.key === "Enter" && range.to - range.from === 1) {
            //To allow carriage return directly after semicolon
            return false;
          }

          return (_component$ref = component.ref) === null || _component$ref === void 0 ? void 0 : _component$ref.onKeyDown(props);
        },
        onExit: function onExit() {
          popup.destroy();
          component.destroy();
        }
      };
    }
  };
};

/* harmony default export */ var emojiSuggestion = (emojiSuggestion_computeSuggestion);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var stringify_i = 0; stringify_i < 256; ++stringify_i) {
  byteToHex.push((stringify_i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// CONCATENATED MODULE: ./node_modules/@tiptap-pro/extension-unique-id/dist/tiptap-extension-unique-id.esm.js





/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function tiptap_extension_unique_id_esm_removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

/**
 * Returns a list of duplicated items within an array.
 */
function tiptap_extension_unique_id_esm_findDuplicates(items) {
    const filtered = items.filter((el, index) => items.indexOf(el) !== index);
    const duplicates = tiptap_extension_unique_id_esm_removeDuplicates(filtered);
    return duplicates;
}

const UniqueID = Extension.create({
    name: 'uniqueID',
    // we’ll set a very high priority to make sure this runs first
    // and is compatible with `appendTransaction` hooks of other extensions
    priority: 10000,
    addOptions() {
        return {
            attributeName: 'id',
            types: [],
            generateID: () => esm_browser_v4(),
            filterTransaction: null,
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    [this.options.attributeName]: {
                        default: null,
                        parseHTML: element => element.getAttribute(`data-${this.options.attributeName}`),
                        renderHTML: attributes => {
                            if (!attributes[this.options.attributeName]) {
                                return {};
                            }
                            return {
                                [`data-${this.options.attributeName}`]: attributes[this.options.attributeName],
                            };
                        },
                    },
                },
            },
        ];
    },
    // check initial content for missing ids
    onCreate() {
        // Don’t do this when the collaboration extension is active
        // because this may update the content, so Y.js tries to merge these changes.
        // This leads to empty block nodes.
        // See: https://github.com/ueberdosis/tiptap/issues/2400
        if (this.editor.extensionManager.extensions.find(extension => extension.name === 'collaboration')) {
            return;
        }
        const { view, state } = this.editor;
        const { tr, doc } = state;
        const { types, attributeName, generateID } = this.options;
        const nodesWithoutId = findChildren(doc, node => {
            return types.includes(node.type.name)
                && node.attrs[attributeName] === null;
        });
        nodesWithoutId.forEach(({ node, pos }) => {
            tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                [attributeName]: generateID(),
            });
        });
        tr.setMeta('addToHistory', false);
        view.dispatch(tr);
    },
    addProseMirrorPlugins() {
        let dragSourceElement = null;
        let transformPasted = false;
        return [
            new Plugin({
                key: new PluginKey('uniqueID'),
                appendTransaction: (transactions, oldState, newState) => {
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    const filterTransactions = this.options.filterTransaction
                        && transactions.some(tr => { var _a, _b; return !((_b = (_a = this.options).filterTransaction) === null || _b === void 0 ? void 0 : _b.call(_a, tr)); });
                    if (!docChanges || filterTransactions) {
                        return;
                    }
                    const { tr } = newState;
                    const { types, attributeName, generateID } = this.options;
                    const transform = combineTransactionSteps(oldState.doc, transactions);
                    const { mapping } = transform;
                    // get changed ranges based on the old state
                    const changes = getChangedRanges(transform);
                    changes.forEach(({ newRange }) => {
                        const newNodes = findChildrenInRange(newState.doc, newRange, node => {
                            return types.includes(node.type.name);
                        });
                        const newIds = newNodes
                            .map(({ node }) => node.attrs[attributeName])
                            .filter(id => id !== null);
                        const duplicatedNewIds = tiptap_extension_unique_id_esm_findDuplicates(newIds);
                        newNodes.forEach(({ node, pos }) => {
                            var _a;
                            // instead of checking `node.attrs[attributeName]` directly
                            // we look at the current state of the node within `tr.doc`.
                            // this helps to prevent adding new ids to the same node
                            // if the node changed multiple times within one transaction
                            const id = (_a = tr.doc.nodeAt(pos)) === null || _a === void 0 ? void 0 : _a.attrs[attributeName];
                            if (id === null) {
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    [attributeName]: generateID(),
                                });
                                return;
                            }
                            // check if the node doesn’t exist in the old state
                            const { deleted } = mapping.invert().mapResult(pos);
                            const newNode = deleted && duplicatedNewIds.includes(id);
                            if (newNode) {
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    [attributeName]: generateID(),
                                });
                            }
                        });
                    });
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
                // we register a global drag handler to track the current drag source element
                view(view) {
                    const handleDragstart = (event) => {
                        var _a;
                        dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))
                            ? view.dom.parentElement
                            : null;
                    };
                    window.addEventListener('dragstart', handleDragstart);
                    return {
                        destroy() {
                            window.removeEventListener('dragstart', handleDragstart);
                        },
                    };
                },
                props: {
                    // `handleDOMEvents` is called before `transformPasted`
                    // so we can do some checks before
                    handleDOMEvents: {
                        // only create new ids for dropped content while holding `alt`
                        // or content is dragged from another editor
                        drop: (view, event) => {
                            var _a;
                            if (dragSourceElement !== view.dom.parentElement
                                || ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.effectAllowed) === 'copy') {
                                dragSourceElement = null;
                                transformPasted = true;
                            }
                            return false;
                        },
                        // always create new ids on pasted content
                        paste: () => {
                            transformPasted = true;
                            return false;
                        },
                    },
                    // we’ll remove ids for every pasted node
                    // so we can create a new one within `appendTransaction`
                    transformPasted: slice => {
                        if (!transformPasted) {
                            return slice;
                        }
                        const { types, attributeName } = this.options;
                        const removeId = (fragment) => {
                            const list = [];
                            fragment.forEach(node => {
                                // don’t touch text nodes
                                if (node.isText) {
                                    list.push(node);
                                    return;
                                }
                                // check for any other child nodes
                                if (!types.includes(node.type.name)) {
                                    list.push(node.copy(removeId(node.content)));
                                    return;
                                }
                                // remove id
                                const nodeWithoutId = node.type.create({
                                    ...node.attrs,
                                    [attributeName]: null,
                                }, removeId(node.content), node.marks);
                                list.push(nodeWithoutId);
                            });
                            return Fragment.from(list);
                        };
                        // reset check
                        transformPasted = false;
                        return new Slice(removeId(slice.content), slice.openStart, slice.openEnd);
                    },
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-unique-id.esm.js.map

// CONCATENATED MODULE: ./src/extensions/UniqueID/UniqueID.ts















function UniqueID_removeDuplicates(array) {
  var by = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JSON.stringify;
  var seen = {};
  return array.filter(function (item) {
    var key = by(item);
    return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
  });
}

function UniqueID_findDuplicates(items) {
  var filtered = items.filter(function (el, index) {
    return items.indexOf(el) !== index;
  });
  var duplicates = UniqueID_removeDuplicates(filtered);
  return duplicates;
}

var computeCustomUniqueID = UniqueID.extend({
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this = this;

    var dragSourceElement = null;
    var _transformPasted = false;
    return [new Plugin({
      key: new PluginKey("uniqueID"),
      appendTransaction: function appendTransaction(transactions, oldState, newState) {
        var docChanges = transactions.some(function (transaction) {
          return transaction.docChanged;
        }) && !oldState.doc.eq(newState.doc);
        var filterTransactions = _this.options.filterTransaction && transactions.some(function (tr) {
          var _a, _b;

          return !((_b = (_a = _this.options).filterTransaction) === null || _b === void 0 ? void 0 : _b.call(_a, tr));
        });

        if (!docChanges || filterTransactions) {
          return;
        }

        var tr = newState.tr;
        var _this$options = _this.options,
            types = _this$options.types,
            attributeName = _this$options.attributeName,
            generateID = _this$options.generateID;
        var transform = combineTransactionSteps(oldState.doc, transactions);
        var mapping = transform.mapping; // get changed ranges based on the old state

        var changes = getChangedRanges(transform);
        changes.forEach(function (_ref) {
          var newRange = _ref.newRange;
          var newNodes = findChildrenInRange(newState.doc, newRange, function (node) {
            return types.includes(node.type.name);
          });
          var newIds = newNodes.map(function (_ref2) {
            var node = _ref2.node;
            return node.attrs[attributeName];
          }).filter(function (id) {
            return id !== null;
          });
          var duplicatedNewIds = UniqueID_findDuplicates(newIds);
          newNodes.forEach(function (_ref3) {
            var node = _ref3.node,
                pos = _ref3.pos;

            var _a; // instead of checking `node.attrs[attributeName]` directly
            // we look at the current state of the node within `tr.doc`.
            // this helps to prevent adding new ids to the same node
            // if the node changed multiple times within one transaction


            var id = (_a = tr.doc.nodeAt(pos)) === null || _a === void 0 ? void 0 : _a.attrs[attributeName];

            if (id === null) {
              tr.setNodeMarkup(pos, undefined, _objectSpread2(_objectSpread2({}, node.attrs), {}, Object(defineProperty["a" /* default */])({}, attributeName, generateID())));
              return;
            } // check if the node doesn’t exist in the old state


            var _mapping$invert$mapRe = mapping.invert().mapResult(pos),
                deleted = _mapping$invert$mapRe.deleted;

            var newNode = deleted && duplicatedNewIds.includes(id);

            if (newNode) {
              tr.setNodeMarkup(pos, undefined, _objectSpread2(_objectSpread2({}, node.attrs), {}, Object(defineProperty["a" /* default */])({}, attributeName, generateID())));
            }
          });
        });

        if (!tr.steps.length) {
          return;
        }

        return tr;
      },
      // we register a global drag handler to track the current drag source element
      view: function view(_view) {
        var handleDragstart = function handleDragstart(event) {
          var _a;

          dragSourceElement = ((_a = _view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? _view.dom.parentElement : null;
        };

        window.addEventListener("dragstart", handleDragstart);
        return {
          destroy: function destroy() {
            window.removeEventListener("dragstart", handleDragstart);
          }
        };
      },
      props: {
        // `handleDOMEvents` is called before `transformPasted`
        // so we can do some checks before
        handleDOMEvents: {
          // only create new ids for dropped content while holding `alt`
          // or content is dragged from another editor
          drop: function drop(view, event) {
            var _a;

            if (dragSourceElement !== view.dom.parentElement || ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.effectAllowed) === "copy") {
              dragSourceElement = null;
              _transformPasted = true;
            }

            return false;
          },
          // always create new ids on pasted content
          paste: function paste() {
            _transformPasted = true;
            return false;
          }
        },
        // we’ll remove ids for every pasted node
        // so we can create a new one within `appendTransaction`
        transformPasted: function transformPasted(slice) {
          if (!_transformPasted) {
            return slice;
          }

          var _this$options2 = _this.options,
              types = _this$options2.types,
              attributeName = _this$options2.attributeName;

          var removeId = function removeId(fragment) {
            var list = [];
            fragment.forEach(function (node) {
              // don’t touch text nodes
              if (node.isText) {
                list.push(node);
                return;
              } // check for any other child nodes


              if (!types.includes(node.type.name)) {
                list.push(node.copy(removeId(node.content)));
                return;
              } // remove id


              var nodeWithoutId = node.type.create(_objectSpread2({}, node.attrs), removeId(node.content), node.marks);
              list.push(nodeWithoutId);
            });
            return Fragment.from(list);
          }; // reset check


          _transformPasted = false;
          return new Slice(removeId(slice.content), slice.openStart, slice.openEnd);
        }
      }
    })];
  }
});
/* harmony default export */ var UniqueID_UniqueID = (computeCustomUniqueID);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/StreamWrapper.vue?vue&type=template&id=8ca2b728&scoped=true&
var StreamWrappervue_type_template_id_8ca2b728_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"mayday-editor__stream-wrapper",attrs:{"draggable":false}},[_c('div',{staticClass:"mayday-editor__stream-wrapper__content",attrs:{"draggable":"false"}},[_vm._l((_vm.streamData),function(streamedNode,i){return _c(_vm.getTagFromHTML(streamedNode),{key:i,tag:"component",staticClass:"fade-in",domProps:{"innerHTML":_vm._s(streamedNode)}})}),(_vm.isGenerating)?_c('LoadingBar',{attrs:{"width":90}}):_vm._e(),(_vm.isGenerating)?_c('LoadingBar',{attrs:{"delay":200}}):_vm._e(),(_vm.isGenerating)?_c('LoadingBar',{attrs:{"delay":400,"width":50}}):_vm._e()],2),_c('div',{staticClass:"mayday-editor__stream-wrapper__actions"},[(_vm.isGenerating)?_c('div',[_c('font-awesome-icon',{attrs:{"icon":['fal', 'spinner-third'],"spin":""}}),_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.translate.generating")))])],1):_c('div',[_c('button',{staticClass:"mayday-editor__stream-wrapper__button mayday-editor__stream-wrapper__button--secondary"},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'repeat']}}),_c('span',{on:{"click":_vm.handleReplace}},[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.translate.replace")))])],1)]),(_vm.isGenerating)?_c('div',{on:{"click":_vm.handleCancel}},[_c('button',{staticClass:"mayday-editor__stream-wrapper__button mayday-editor__stream-wrapper__button--primary"},[_vm._v(" "+_vm._s(_vm.$t("mayday-editor.menu.translate.cancel"))+" ")]),_c('button',{staticClass:"mayday-editor__stream-wrapper__button mayday-editor__stream-wrapper__button--secondary"},[_c('span',[_vm._v("esc")])])]):_c('div',[_c('button',{staticClass:"mayday-editor__stream-wrapper__button mayday-editor__stream-wrapper__button--primary",on:{"click":_vm.handleAppend}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'plus']}}),_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.translate.append")))])],1),_c('button',{staticClass:"mayday-editor__stream-wrapper__button mayday-editor__stream-wrapper__button--primary",on:{"click":_vm.handleRemove}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'times']}}),_c('span',[_vm._v(_vm._s(_vm.$t("mayday-editor.menu.translate.cancel")))])],1)])])])}
var StreamWrappervue_type_template_id_8ca2b728_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nodes/StreamWrapper.vue?vue&type=template&id=8ca2b728&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__("b636");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncIterator.js









function _asyncIterator(iterable) {
  var method,
      async,
      sync,
      retry = 2;

  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }

  throw new TypeError("Object is not async iterable");
}

function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }

  return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(value) {
      var ret = this.s["return"];
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    "throw": function _throw(value) {
      var thr = this.s["return"];
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LoadingBar.vue?vue&type=template&id=5de5e56a&scoped=true&
var LoadingBarvue_type_template_id_5de5e56a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"grow"}},[_c('div',{staticClass:"loading-bar",style:(_vm.animationStyle)})])}
var LoadingBarvue_type_template_id_5de5e56a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LoadingBar.vue?vue&type=template&id=5de5e56a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LoadingBar.vue?vue&type=script&lang=js&


//
//
//
//
//
//
/* harmony default export */ var LoadingBarvue_type_script_lang_js_ = ({
  name: "LoadingBar",
  props: {
    width: {
      type: Number,
      default: 100,
      description: "Width of the loading bar in percentage"
    },
    delay: {
      type: Number,
      default: 0,
      description: "Delay before the loading bar starts"
    }
  },
  computed: {
    animationStyle: function animationStyle() {
      return "max-width: ".concat(this.width, "%;animation-delay: ").concat(this.delay, "ms");
    }
  }
});
// CONCATENATED MODULE: ./src/components/LoadingBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_LoadingBarvue_type_script_lang_js_ = (LoadingBarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LoadingBar.vue?vue&type=style&index=0&id=5de5e56a&scoped=true&lang=scss&
var LoadingBarvue_type_style_index_0_id_5de5e56a_scoped_true_lang_scss_ = __webpack_require__("3add");

// CONCATENATED MODULE: ./src/components/LoadingBar.vue






/* normalize component */

var LoadingBar_component = normalizeComponent(
  components_LoadingBarvue_type_script_lang_js_,
  LoadingBarvue_type_template_id_5de5e56a_scoped_true_render,
  LoadingBarvue_type_template_id_5de5e56a_scoped_true_staticRenderFns,
  false,
  null,
  "5de5e56a",
  null
  
)

/* harmony default export */ var LoadingBar = (LoadingBar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nodes/StreamWrapper.vue?vue&type=script&lang=ts&
















 //import "reflect-metadata";





var StreamWrappervue_type_script_lang_ts_key = new PluginKey("streamWrapper");

var StreamWrappervue_type_script_lang_ts_StreamWrapper = /*#__PURE__*/function (_BaseNodeView) {
  _inherits(StreamWrapper, _BaseNodeView);

  var _super = _createSuper(StreamWrapper);

  function StreamWrapper() {
    var _this;

    _classCallCheck(this, StreamWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "startingNodeIndex", null);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "endingNodeIndex", null);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isGenerating", true);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "abortController", new AbortController());

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "streamData", []);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "virtualDocument", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "escapeListener", void 0);

    return _this;
  }

  _createClass(StreamWrapper, [{
    key: "getTagFromHTML",
    value: function getTagFromHTML(html) {
      var tag = html.match(/<\w+/);
      if (tag) return tag[0].slice(1);
      return "";
    }
  }, {
    key: "parseResultChunk",
    value: function parseResultChunk(chunk) {
      switch (chunk.type) {
        case "chunk":
          if (chunk.content !== "\n") {
            var _this$editor$view$dom, _this$editor$view$dom2;

            this.streamData.push(chunk.content);
            (_this$editor$view$dom = this.editor.view.dom.parentElement) === null || _this$editor$view$dom === void 0 ? void 0 : (_this$editor$view$dom2 = _this$editor$view$dom.parentElement) === null || _this$editor$view$dom2 === void 0 ? void 0 : _this$editor$view$dom2.getElementsByClassName("mayday-editor__stream-wrapper")[0].scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
          }

          break;

        case "error":
          this.$store.dispatch("notifyUploadError", "");
          break;
      } //focus at the end of the stream


      return chunk;
    }
  }, {
    key: "created",
    value: function () {
      var _created = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var completeSelection, _this$editor;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.createEscapeListener();
                this.isGenerating = true;
                this.editor.storage.streamWrapper.streaming = true;
                completeSelection = this.getNodeSelection();

                if (!(this.startingNodeIndex !== null && this.endingNodeIndex !== null)) {
                  _context.next = 10;
                  break;
                }

                this.virtualDocument = document.implementation.createHTMLDocument();
                this.virtualDocument.body.innerHTML = (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getHTML(); //remove streamWrapper nodes if complete selection

                if (completeSelection) this.removeStreamWrapperTags();
                _context.next = 10;
                return this.fetchStream();

              case 10:
                this.isGenerating = false;
                if (this.streamData.length < 1) this.handleRemove();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "fetchStream",
    value: function () {
      var _fetchStream = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedNodes, nodes, i, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _this$editor2, chunk;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedNodes = [];
                nodes = this.virtualDocument.body.childNodes;

                if (!(!nodes || this.endingNodeIndex === null || this.startingNodeIndex === null)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                for (i = this.startingNodeIndex; i <= this.endingNodeIndex; i++) {
                  selectedNodes.push(nodes[i].outerHTML);
                }

                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context2.prev = 7;
                _iterator = _asyncIterator(this.node.attrs.streamHandler(selectedNodes.join(""), (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.storage.streamWrapper.language, this.abortController));

              case 9:
                _context2.next = 11;
                return _iterator.next();

              case 11:
                if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                  _context2.next = 21;
                  break;
                }

                chunk = _step.value;

                if (!this.isGenerating) {
                  _context2.next = 17;
                  break;
                }

                this.parseResultChunk(chunk);
                _context2.next = 18;
                break;

              case 17:
                return _context2.abrupt("break", 21);

              case 18:
                _iteratorAbruptCompletion = false;
                _context2.next = 9;
                break;

              case 21:
                _context2.next = 27;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 27:
                _context2.prev = 27;
                _context2.prev = 28;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 32;
                return _iterator.return();

              case 32:
                _context2.prev = 32;

                if (!_didIteratorError) {
                  _context2.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context2.finish(32);

              case 36:
                return _context2.finish(27);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 23, 27, 37], [28,, 32, 36]]);
      }));

      function fetchStream() {
        return _fetchStream.apply(this, arguments);
      }

      return fetchStream;
    }()
  }, {
    key: "getNodeSelection",
    value: function getNodeSelection() {
      var _this$editor3, _this$editor4;

      //if no selection, stream the whole document
      if (((_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.storage.streamWrapper.highlightTo) - ((_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.storage.streamWrapper.highlightFrom) <= 1) {
        var _this$editor5;

        this.startingNodeIndex = 0;
        this.endingNodeIndex = ((_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.state.doc.childCount) - 1;
        return true;
      } else {
        var _this$editor6, _this$editor7;

        this.startingNodeIndex = (_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.storage.streamWrapper.highlightFrom.index(0);
        this.endingNodeIndex = (_this$editor7 = this.editor) === null || _this$editor7 === void 0 ? void 0 : _this$editor7.storage.streamWrapper.highlightTo.index(0);
        return false;
      }
    }
  }, {
    key: "removeStreamWrapperTags",
    value: function removeStreamWrapperTags() {
      var streamWrapperNodes = this.virtualDocument.body.querySelectorAll("streamwrapper");

      for (var i = 0; i < streamWrapperNodes.length; i++) {
        streamWrapperNodes[i].remove();
      }

      if (this.endingNodeIndex !== null) this.endingNodeIndex -= streamWrapperNodes.length;
    }
  }, {
    key: "createEscapeListener",
    value: function createEscapeListener() {
      var _this2 = this;

      this.escapeListener = function (event) {
        if (event.key === "Escape") {
          _this2.handleCancel();
        }
      };

      document.addEventListener("keyup", this.escapeListener);
    }
  }, {
    key: "handleReplace",
    value: function handleReplace() {
      var _this3 = this;

      if (this.startingNodeIndex !== null) {
        for (var i = 0; i < this.streamData.length; i++) {
          this.virtualDocument.body.childNodes[this.startingNodeIndex + i].outerHTML = this.streamData[i];
        }

        var pos = this.getPos();
        var index = this.editor.state.doc.resolve(pos).index(0); //The setContent method does not trigger an update, so we need to trigger it manually after update

        setTimeout(function () {
          _this3.editor.chain().setContent(_this3.virtualDocument.body.innerHTML).run(); //We set the selection to the end of the inserted content


          _this3.editor.state.doc.forEach(function (childNode, childOffset, childIndex) {
            if (childIndex === index) _this3.editor.commands.setTextSelection(childOffset - 1);
          });

          _this3.node.attrs.triggerUpdate(_this3.editor.getHTML());
        }, 10);
        this.handleRemove();
      }
    }
  }, {
    key: "handleAppend",
    value: function handleAppend() {
      //We prevent the native update in order to force the updated content ot pass through the streamWrapper sanitization
      this.editor.chain().setMeta("preventUpdate", true).insertContentAt(this.getPos() + this.node.nodeSize, this.streamData.join("")).run();
      this.node.attrs.triggerUpdate(this.editor.getHTML());
      this.handleRemove();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      this.editor.chain().setMeta("addToHistory", false).setMeta("preventUpdate", true).deleteRange({
        from: this.getPos(),
        to: this.getPos() + this.node.nodeSize
      }).run();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.abortController.abort();
      this.isGenerating = false;
      if (this.streamData.length < 1) this.handleRemove();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var _this$editor$view$dom3, _this$editor$view$dom4, _this$editor8;

      this.abortController.abort();
      var dragHandle = (_this$editor$view$dom3 = this.editor.view.dom.parentElement) === null || _this$editor$view$dom3 === void 0 ? void 0 : (_this$editor$view$dom4 = _this$editor$view$dom3.parentElement) === null || _this$editor$view$dom4 === void 0 ? void 0 : _this$editor$view$dom4.getElementsByClassName("mayday-editor__drag-icon-container")[0];
      if (dragHandle) dragHandle.style.visibility = "hidden";

      if ((_this$editor8 = this.editor) !== null && _this$editor8 !== void 0 && _this$editor8.storage.streamWrapper) {
        this.editor.storage.streamWrapper.highlightFrom = 0;
        this.editor.storage.streamWrapper.highlightTo = 0;
        this.editor.storage.streamWrapper.language = null;
        this.editor.storage.streamWrapper.streaming = false;
      }

      document.removeEventListener("keyup", this.escapeListener);
    }
  }]);

  return StreamWrapper;
}(nodes_BaseNodeView);

StreamWrappervue_type_script_lang_ts_StreamWrapper = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    LoadingBar: LoadingBar
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    editor: {
      type: Object,
      required: true
    },
    deleteNode: {
      type: Function,
      required: true
    }
  }
})], StreamWrappervue_type_script_lang_ts_StreamWrapper);
/* harmony default export */ var StreamWrappervue_type_script_lang_ts_ = (StreamWrappervue_type_script_lang_ts_StreamWrapper);
// CONCATENATED MODULE: ./src/components/nodes/StreamWrapper.vue?vue&type=script&lang=ts&
 /* harmony default export */ var nodes_StreamWrappervue_type_script_lang_ts_ = (StreamWrappervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/nodes/StreamWrapper.vue?vue&type=style&index=0&id=8ca2b728&scoped=true&lang=css&
var StreamWrappervue_type_style_index_0_id_8ca2b728_scoped_true_lang_css_ = __webpack_require__("18e0");

// CONCATENATED MODULE: ./src/components/nodes/StreamWrapper.vue






/* normalize component */

var StreamWrapper_component = normalizeComponent(
  nodes_StreamWrappervue_type_script_lang_ts_,
  StreamWrappervue_type_template_id_8ca2b728_scoped_true_render,
  StreamWrappervue_type_template_id_8ca2b728_scoped_true_staticRenderFns,
  false,
  null,
  "8ca2b728",
  null
  
)

/* harmony default export */ var nodes_StreamWrapper = (StreamWrapper_component.exports);
// CONCATENATED MODULE: ./src/extensions/StreamWrapper.ts







var StreamWrapper_StreamWrapper = function StreamWrapper(editor, fetchStreamHandler) {
  return tiptap_core_esm_Node.create({
    name: "streamWrapper",
    group: "block",
    draggable: false,
    atom: true,
    data: function data() {
      return {
        isGenerating: false
      };
    },
    addStorage: function addStorage() {
      return {
        highlightFrom: 0,
        highlightTo: 0,
        language: null,
        streaming: false
      };
    },
    addOptions: function addOptions() {
      return {
        HTMLAttributes: {
          class: "stream-wrapper"
        },
        fetchStreamHandler: fetchStreamHandler,
        editor: editor
      };
    },
    addNodeView: function addNodeView() {
      return VueNodeViewRenderer(nodes_StreamWrapper);
    },
    renderHTML: function renderHTML() {
      return ["streamWrapper"];
    },
    addAttributes: function addAttributes() {
      return {
        streamHandler: {
          default: fetchStreamHandler
        },
        triggerUpdate: {
          default: function _default(body) {
            var sanitizedBody = body.replace(/<streamwrapper\b[^>]*>[\s\S]*?<\/streamwrapper>/gi, "");
            editor.$emit("update", sanitizedBody);
          }
        }
      };
    }
  });
};

/* harmony default export */ var extensions_StreamWrapper = (StreamWrapper_StreamWrapper);
// CONCATENATED MODULE: ./src/extensions/GrammarCorrector.ts




var GrammarCorrector_GrammarCorrector = function GrammarCorrector(editor, fetchGrammarHandler) {
  return extensions_StreamWrapper(editor, fetchGrammarHandler).extend({
    name: "grammarCorrector"
  });
};

/* harmony default export */ var extensions_GrammarCorrector = (GrammarCorrector_GrammarCorrector);
// CONCATENATED MODULE: ./src/extensions/Translation.ts




var Translation_Translation = function Translation(editor, fetchTranslationHandler) {
  return extensions_StreamWrapper(editor, fetchTranslationHandler).extend({
    name: "translation"
  });
};

/* harmony default export */ var extensions_Translation = (Translation_Translation);
// CONCATENATED MODULE: ./node_modules/@tiptap/extension-character-count/dist/tiptap-extension-character-count.esm.js



const CharacterCount = Extension.create({
    name: 'characterCount',
    addOptions() {
        return {
            limit: null,
            mode: 'textSize',
        };
    },
    addStorage() {
        return {
            characters: () => 0,
            words: () => 0,
        };
    },
    onBeforeCreate() {
        this.storage.characters = options => {
            const node = (options === null || options === void 0 ? void 0 : options.node) || this.editor.state.doc;
            const mode = (options === null || options === void 0 ? void 0 : options.mode) || this.options.mode;
            if (mode === 'textSize') {
                const text = node.textBetween(0, node.content.size, undefined, ' ');
                return text.length;
            }
            return node.nodeSize;
        };
        this.storage.words = options => {
            const node = (options === null || options === void 0 ? void 0 : options.node) || this.editor.state.doc;
            const text = node.textBetween(0, node.content.size, ' ', ' ');
            const words = text
                .split(' ')
                .filter(word => word !== '');
            return words.length;
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('characterCount'),
                filterTransaction: (transaction, state) => {
                    const limit = this.options.limit;
                    // Nothing has changed or no limit is defined. Ignore it.
                    if (!transaction.docChanged || limit === 0 || limit === null || limit === undefined) {
                        return true;
                    }
                    const oldSize = this.storage.characters({ node: state.doc });
                    const newSize = this.storage.characters({ node: transaction.doc });
                    // Everything is in the limit. Good.
                    if (newSize <= limit) {
                        return true;
                    }
                    // The limit has already been exceeded but will be reduced.
                    if (oldSize > limit && newSize > limit && newSize <= oldSize) {
                        return true;
                    }
                    // The limit has already been exceeded and will be increased further.
                    if (oldSize > limit && newSize > limit && newSize > oldSize) {
                        return false;
                    }
                    const isPaste = transaction.getMeta('paste');
                    // Block all exceeding transactions that were not pasted.
                    if (!isPaste) {
                        return false;
                    }
                    // For pasted content, we try to remove the exceeding content.
                    const pos = transaction.selection.$head.pos;
                    const over = newSize - limit;
                    const from = pos - over;
                    const to = pos;
                    // It’s probably a bad idea to mutate transactions within `filterTransaction`
                    // but for now this is working fine.
                    transaction.deleteRange(from, to);
                    // In some situations, the limit will continue to be exceeded after trimming.
                    // This happens e.g. when truncating within a complex node (e.g. table)
                    // and ProseMirror has to close this node again.
                    // If this is the case, we prevent the transaction completely.
                    const updatedSize = this.storage.characters({ node: transaction.doc });
                    if (updatedSize > limit) {
                        return false;
                    }
                    return true;
                },
            }),
        ];
    },
});


//# sourceMappingURL=tiptap-extension-character-count.esm.js.map

// CONCATENATED MODULE: ./src/extensions/ToneImprover.ts




var ToneImprover_ToneImprover = function ToneImprover(editor, fetchToneHandler) {
  return extensions_StreamWrapper(editor, fetchToneHandler).extend({
    name: "toneImprover"
  });
};

/* harmony default export */ var extensions_ToneImprover = (ToneImprover_ToneImprover);
// CONCATENATED MODULE: ./src/utils/computeEditorExtensions.ts
































































var computeEditorExtensions_computeExtensions = function computeExtensions(vm, extensionOptions, maxImageWidth) {
  var extensions = [Document, Paragraph, Text];
  var isParametric = vm.isParametric || false;
  var subdomain = vm.subdomain || "https://app.mayday.fr"; // toc

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowToc) {
    extensions = extensions.concat([extensions_TableOfContents(extensionOptions === null || extensionOptions === void 0 ? void 0 : extensionOptions.tocClickOptions)]);
  } // extraStructurationOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.extraStructurationOptions || !extensionOptions) {
    extensions = extensions.concat([extensions_Heading, extensions_TextAlign]);
  }

  extensions = extensions.concat([Placeholder_Placeholder(vm), HardBreak, TextStyle, History].concat(_toConsumableArray(vm.editable ? [extensions_TrailingNode] : []))); // colorOptions

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.colorOptions || !extensionOptions) {
    extensions = extensions.concat([// BackgroundColor,
    extensions_Highlight.configure({
      multicolor: true
    }), Color]);
  } // fontOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.fontOptions || !extensionOptions) {
    extensions = extensions.concat([Bold, Italic, Underline, Link_Link(vm)].concat(_toConsumableArray(vm.editable ? [BubbleMenu_TextSelectionBubbleMenu(vm.$el)] : [])));
  } // extraFontOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.extraFontOptions || !extensionOptions) {
    extensions = extensions.concat([Strike, Code]);
  } // structurationOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.structurationOptions || !extensionOptions) {
    extensions = extensions.concat([OrderedList, BulletList, ListItem]);
  } // tableOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.tableOptions || !extensionOptions) {
    extensions = extensions.concat([Table_Table.configure({
      resizable: true,
      cellMinWidth: 80
    }), TableRow, TableHeader, extensions_TableCell(vm.$el)].concat(_toConsumableArray(vm.editable ? [TableBubbleMenu_TableBubbleMenu(vm.$el)] : [])));
  } // richOptions


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.richOptions || !extensionOptions) {
    extensions = extensions.concat([extensions_Embed(subdomain), Attachment_Attachment(vm.isFileUploadCallbackProvided, vm.uploadFiles), Typography.configure({
      oneHalf: false,
      oneQuarter: false,
      threeQuarters: false
    }), SmileyReplacer, extensions_Image(vm.isFileUploadCallbackProvided, vm.uploadFiles, maxImageWidth), Gapcursor, Dropcursor.configure({
      class: "mayday-editor__content__ProseMirror__drop-cursor",
      width: 2
    }), Blockquote, CodeBlockLowlight.configure({
      lowlight: core_default.a
    }), extensions_Divider, extensions_Callout, extensions_InlineContent_InlineContent(vm.fetchInlineContentHandler, isParametric, subdomain, vm.editable), extensions_InlineMention(vm.fetchInlineMentionHandler), Details_Details.configure({
      persist: true,
      HTMLAttributes: {
        class: "mayday-editor__content__ProseMirror__details"
      }
    }), Details_DetailsSummary(vm.editable), DetailsContent, Emoji.configure({
      emojis: gitHubEmojis,
      enableEmoticons: true,
      suggestion: emojiSuggestion()
    }), UniqueID_UniqueID.configure({
      attributeName: "uid",
      types: ["paragraph", "heading", "image"]
    })].concat(_toConsumableArray(vm.editable ? [SlashMenu_SlashMenu(vm.$t("mayday-editor.menu.slash.title"), vm.isFileUploadCallbackProvided, vm.uploadFiles, !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowToc), !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowSummary), !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowTranslation), !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowGrammarCorrection), !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowToneImprovement), !!(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowActionItems), vm.notifyUploadError, function (event, params) {
      return vm.$emit(event, params);
    }), extensions_InlineContentMenu_InlineContentMenu(vm.$t("mayday-editor.menu.slash.title"), vm.searchInlineEntity), BubbleMenu_DividerBubbleMenu(vm.$el), CalloutBubbleMenu_CalloutBubbleMenu(vm.$el), BubbleMenu_AttachmentBubbleMenu(vm.$el), BubbleMenu_LinkBubbleMenu(vm.$el), BubbleMenu_ImageBubbleMenu(vm.$el), BubbleMenu_InlineBubbleMenu(vm.$el)] : [])));
  } // 'light' richOptions for comments/messages


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.messageOptions && !(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.richOptions)) {
    extensions = extensions.concat([SmileyReplacer, extensions_InlineMention(vm.fetchInlineMentionHandler), extensions_InlineContent_InlineContent(vm.fetchInlineContentHandler, isParametric, subdomain, vm.editable), Emoji.configure({
      emojis: gitHubEmojis,
      enableEmoticons: true,
      suggestion: emojiSuggestion()
    })].concat(_toConsumableArray(vm.editable ? [BubbleMenu_LinkBubbleMenu(vm.$el), extensions_InlineContentMenu_InlineContentMenu(vm.$t("mayday-editor.menu.slash.title"), vm.searchInlineEntity)] : [])));
  } // 'image' richOptions for actions/macro


  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.imageOptions && !(extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.richOptions)) {
    extensions = extensions.concat([extensions_Image(vm.isFileUploadCallbackProvided, vm.uploadFiles, maxImageWidth)].concat(_toConsumableArray(vm.editable ? [BubbleMenu_ImageBubbleMenu(vm.$el)] : [])));
  }

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowTranslation || extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowGrammarCorrection || extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowToneImprovement) {
    extensions = extensions.concat([CharacterCount, extensions_StreamWrapper(vm, undefined)]);
  }

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowTranslation) {
    extensions = extensions.concat([extensions_Translation(vm, vm.generateTranslation)]);
  }

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowGrammarCorrection) {
    extensions = extensions.concat([extensions_GrammarCorrector(vm, vm.generateGrammar)]);
  }

  if (extensionOptions !== null && extensionOptions !== void 0 && extensionOptions.allowToneImprovement) {
    extensions = extensions.concat([extensions_ToneImprover(vm, vm.generateStyle)]);
  }

  return extensions;
};

/* harmony default export */ var computeEditorExtensions = (computeEditorExtensions_computeExtensions);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/TextSelectionBubbleMenu.vue?vue&type=template&id=09b4f9e1&scoped=true&
var TextSelectionBubbleMenuvue_type_template_id_09b4f9e1_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.textSelectionBubbleMenuClass,staticStyle:{"visibility":"hidden"}},[(_vm.menuOptions.fontOptions)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleBold().run(); },"is-active":_vm.computeCommandIsActive('bold'),"icon":"bold","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.bold')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleItalic().run(); },"is-active":_vm.computeCommandIsActive('italic'),"icon":"italic","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.italic')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleUnderline().run(); },"is-active":_vm.computeCommandIsActive('underline'),"icon":"underline","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.underline')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),(_vm.menuOptions.extraFontOptions)?_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleStrike().run(); },"is-active":_vm.computeCommandIsActive('strike'),"icon":"strikethrough","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.strike')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e(),(_vm.menuOptions.extraFontOptions)?_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleCode().run(); },"is-active":_vm.computeCommandIsActive('code'),"icon":"code","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.code')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e()],1):_vm._e(),(_vm.menuOptions.extraStructurationOptions)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('left').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'left' }),"icon":"align-left","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-left')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('center').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'center' }),"icon":"align-center","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-center')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('right').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'right' }),"icon":"align-right","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-right')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1):_vm._e(),(_vm.menuOptions.structurationOptions)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleBulletList().run(); },"is-active":_vm.computeCommandIsActive('bulletList'),"icon":"list-ul","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.bullet-list')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleOrderedList().run(); },"is-active":_vm.computeCommandIsActive('orderedList'),"icon":"list-ol","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.ordered-list')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1):_vm._e(),(_vm.menuOptions.colorOptions)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[_c('CommandButton',{ref:"highlightCommandButton",attrs:{"command":function () {},"is-active":_vm.isColorPickerShown('highlight') || _vm.computeCommandIsActive('highlight'),"icon":"brush","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.highlight')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{ref:"colorCommandButton",attrs:{"command":function () {},"is-active":_vm.isColorPickerShown('color') || _vm.computeCommandIsActive('textStyle'),"icon":"pen-fancy","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.color')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1):_vm._e(),(_vm.menuOptions.fontOptions)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[_c('LinkMenu',{attrs:{"command":_vm.setLink,"is-active":_vm.computeCommandIsActive('link'),"current-link":_vm.currentLink,"tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.link')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1):_vm._e(),(_vm.displayAiFeatures)?_c('div',{class:(_vm.textSelectionBubbleMenuClass + "__commands-container")},[(_vm.menuOptions.allowToneImprovement)?_c('CommandButton',{ref:"toneCommandButton",attrs:{"command":function () {
          _vm.disableAiFeatures ? null : _vm.handleFetchToneImprovement();
        },"icon":"keynote","ai-feature":true,"tooltip-content":_vm.disableAiFeatures
          ? _vm.$t('mayday-editor.menu.text-selection.tooltip.disabled')
          : _vm.$t('mayday-editor.menu.text-selection.tooltip.tone'),"disabled":_vm.disableAiFeatures},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e(),(_vm.menuOptions.allowTranslation)?_c('CommandButton',{ref:"translationCommandButton",attrs:{"command":function () {},"is-active":_vm.translationPickerOpened || _vm.computeCommandIsActive('TranslationPicker'),"icon":"globe-stand","ai-feature":true,"tooltip-content":_vm.disableAiFeatures
          ? _vm.$t('mayday-editor.menu.text-selection.tooltip.disabled')
          : _vm.$t('mayday-editor.menu.text-selection.tooltip.translation'),"disabled":_vm.disableAiFeatures},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e(),(_vm.menuOptions.allowGrammarCorrection)?_c('CommandButton',{ref:"correctionCommandButton",attrs:{"command":function () {
          _vm.disableAiFeatures ? null : _vm.handleFetchCorrection();
        },"icon":"pen-nib","ai-feature":true,"tooltip-content":_vm.disableAiFeatures
          ? _vm.$t('mayday-editor.menu.text-selection.tooltip.disabled')
          : _vm.$t('mayday-editor.menu.text-selection.tooltip.correction'),"disabled":_vm.disableAiFeatures},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e()],1):_vm._e(),_c('ColorPicker',{ref:"highlightColorPicker",staticStyle:{"display":"none"},attrs:{"editor":_vm.editor,"usage":"highlight","is-active":_vm.isColorActive('highlight')},on:{"color-chosen":_vm.handleColorChosen}}),_c('ColorPicker',{ref:"textColorPicker",staticStyle:{"display":"none"},attrs:{"editor":_vm.editor,"usage":"color","is-active":_vm.isColorActive('color')},on:{"color-chosen":_vm.handleColorChosen}}),(_vm.menuOptions.allowTranslation)?_c('TranslationPicker',{ref:"translationPicker",staticStyle:{"display":"none"},attrs:{"is-active":_vm.translationPickerOpened,"usage":"translation","hidden":_vm.disableAiFeatures},on:{"fetch-translation":_vm.handleFetchTranslation}}):_vm._e()],1)}
var TextSelectionBubbleMenuvue_type_template_id_09b4f9e1_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/TextSelectionBubbleMenu.vue?vue&type=template&id=09b4f9e1&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/ColorPicker.vue?vue&type=template&id=0a5a0448&scoped=true&
var ColorPickervue_type_template_id_0a5a0448_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__bubble-menu-color-picker"},[_c('div',{staticClass:"mayday-editor__bubble-menu-color-picker__commands-container"},_vm._l((_vm.computeColors()),function(ref){
var id = ref[0];
var color = ref[1];
return _c('div',{key:("color-" + id + "-" + color),class:_vm.computePickerClass(Number(id)),on:{"click":function($event){return _vm.handleColorChosen(color)}}})}),0),_c('div',{staticClass:"mayday-editor__bubble-menu-color-picker__commands-container"},_vm._l((Object.entries(_vm.computeBaseColors())),function(ref){
var id = ref[0];
var color = ref[1];
return _c('div',{key:("color-" + id + "-" + color),class:_vm.computePickerClass(Number(id)),on:{"click":function($event){return _vm.handleColorChosen(color)}}})}),0)])}
var ColorPickervue_type_template_id_0a5a0448_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/ColorPicker.vue?vue&type=template&id=0a5a0448&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__("c1f9");

// CONCATENATED MODULE: ./src/utils/omit.ts










var omit_omit = function omit(keys, obj) {
  // Object.entries will convert keys to string
  var toOmit = keys.map(function (key) {
    return String(key);
  });
  return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return !toOmit.includes(key);
  }));
};

/* harmony default export */ var utils_omit = (omit_omit);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/ColorPicker.vue?vue&type=script&lang=ts&








var _Colors, _BaseColors;


















var EColor;

(function (EColor) {
  EColor[EColor["PINK"] = 0] = "PINK";
  EColor[EColor["RED"] = 1] = "RED";
  EColor[EColor["ORANGE"] = 2] = "ORANGE";
  EColor[EColor["YELLOW"] = 3] = "YELLOW";
  EColor[EColor["GREEN"] = 4] = "GREEN";
  EColor[EColor["CYAN"] = 5] = "CYAN";
  EColor[EColor["LIGHT_BLUE"] = 6] = "LIGHT_BLUE";
  EColor[EColor["MAYDAY_BLUE"] = 7] = "MAYDAY_BLUE";
  EColor[EColor["BLUE"] = 8] = "BLUE";
  EColor[EColor["PURPLE"] = 9] = "PURPLE";
  EColor[EColor["LIGHT_PURPLE"] = 10] = "LIGHT_PURPLE";
  EColor[EColor["GREY"] = 11] = "GREY";
  EColor[EColor["BLACK"] = 12] = "BLACK";
  EColor[EColor["WHITE"] = 13] = "WHITE";
})(EColor || (EColor = {})); // see https://caniuse.com/css-rrggbbaa for usage and compatibility


var _alphaHexComponent = "66"; // 40% in hex

var Colors = (_Colors = {}, Object(defineProperty["a" /* default */])(_Colors, EColor.PINK, "#f8286c"), Object(defineProperty["a" /* default */])(_Colors, EColor.RED, "#f53529"), Object(defineProperty["a" /* default */])(_Colors, EColor.ORANGE, "#fe7e57"), Object(defineProperty["a" /* default */])(_Colors, EColor.YELLOW, "#febb25"), Object(defineProperty["a" /* default */])(_Colors, EColor.GREEN, "#67c23a"), Object(defineProperty["a" /* default */])(_Colors, EColor.CYAN, "#1dcfce"), Object(defineProperty["a" /* default */])(_Colors, EColor.LIGHT_BLUE, "#1da0d7"), Object(defineProperty["a" /* default */])(_Colors, EColor.MAYDAY_BLUE, "#0081f9"), Object(defineProperty["a" /* default */])(_Colors, EColor.BLUE, "#195f94"), Object(defineProperty["a" /* default */])(_Colors, EColor.PURPLE, "#8700f8"), Object(defineProperty["a" /* default */])(_Colors, EColor.LIGHT_PURPLE, "#d63da6"), Object(defineProperty["a" /* default */])(_Colors, EColor.GREY, defaultDividerColor), Object(defineProperty["a" /* default */])(_Colors, EColor.BLACK, "#000000"), _Colors);
var BaseColors = (_BaseColors = {}, Object(defineProperty["a" /* default */])(_BaseColors, EColor.BLACK, "#000000"), Object(defineProperty["a" /* default */])(_BaseColors, EColor.WHITE, null), Object(defineProperty["a" /* default */])(_BaseColors, EColor.GREY, defaultDividerColor), _BaseColors);

var ColorPickervue_type_script_lang_ts_ColorPicker = /*#__PURE__*/function (_Vue) {
  _inherits(ColorPicker, _Vue);

  var _super = _createSuper(ColorPicker);

  function ColorPicker() {
    var _this;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "usage", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isActive", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "colors", Colors);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "alphaHexComponent", _alphaHexComponent);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseColors", BaseColors);

    return _this;
  }

  _createClass(ColorPicker, [{
    key: "allColors",
    get: function get() {
      return Object.assign({}, Object.fromEntries(this.computeColors()), this.computeBaseColors());
    }
  }, {
    key: "isBackgroundColor",
    get: function get() {
      return ["highlight", "tableCell"].includes(this.usage);
    }
  }, {
    key: "isDividerColor",
    get: function get() {
      return this.usage === "divider";
    }
  }, {
    key: "activeColor",
    get: function get() {
      var _this2 = this;

      var fallback;
      var activeColor = Object.entries(this.allColors).find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            color = _ref2[1];

        return _this2.isActive(color);
      });

      if (this.isBackgroundColor) {
        fallback = EColor.WHITE;
      } else if (this.isDividerColor) {
        fallback = EColor.GREY;
      } else {
        fallback = EColor.BLACK;
      }

      return activeColor ? Number(activeColor[0]) : fallback;
    }
  }, {
    key: "computeColorName",
    value: function computeColorName(color) {
      var key = EColor[color];
      return key.replace("_", "-").toLowerCase();
    }
  }, {
    key: "computePickerClass",
    value: function computePickerClass(color) {
      var _ref3;

      var className = "color-picker-".concat(this.computeColorName(color));
      return _ref3 = {}, Object(defineProperty["a" /* default */])(_ref3, className, true), Object(defineProperty["a" /* default */])(_ref3, "".concat(className, "--active"), EColor[color] === EColor[this.activeColor]), _ref3;
    }
  }, {
    key: "computeColors",
    value: function computeColors() {
      var isBackgroundColor = this.isBackgroundColor,
          alphaHexComponent = this.alphaHexComponent,
          colors = this.colors;
      return isBackgroundColor ? Object.entries(colors).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            color = _ref5[1];

        return [key, "".concat(color).concat(alphaHexComponent)];
      }) : Object.entries(colors);
    } // Compute base colors according to `usage`

  }, {
    key: "computeBaseColors",
    value: function computeBaseColors() {
      var toOmit;

      if (this.isBackgroundColor) {
        toOmit = [EColor.BLACK, EColor.GREY];
      } else if (this.isDividerColor) {
        toOmit = [EColor.BLACK, EColor.WHITE];
      } else {
        toOmit = [EColor.BLACK, EColor.GREY];
      }

      return utils_omit(toOmit, this.baseColors);
    }
  }, {
    key: "handleColorChosen",
    value: function handleColorChosen(color) {
      var usage = this.usage;
      this.$emit("color-chosen", {
        usage: usage,
        color: color
      });
    }
  }]);

  return ColorPicker;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], ColorPickervue_type_script_lang_ts_ColorPicker.prototype, "editor", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], ColorPickervue_type_script_lang_ts_ColorPicker.prototype, "usage", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], ColorPickervue_type_script_lang_ts_ColorPicker.prototype, "isActive", void 0);

ColorPickervue_type_script_lang_ts_ColorPicker = __decorate([external_vue_property_decorator_["Component"]], ColorPickervue_type_script_lang_ts_ColorPicker);
/* harmony default export */ var ColorPickervue_type_script_lang_ts_ = (ColorPickervue_type_script_lang_ts_ColorPicker);
// CONCATENATED MODULE: ./src/components/menus/ColorPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var menus_ColorPickervue_type_script_lang_ts_ = (ColorPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/ColorPicker.vue?vue&type=style&index=0&id=0a5a0448&lang=scss&scoped=true&
var ColorPickervue_type_style_index_0_id_0a5a0448_lang_scss_scoped_true_ = __webpack_require__("76c9");

// CONCATENATED MODULE: ./src/components/menus/ColorPicker.vue






/* normalize component */

var ColorPicker_component = normalizeComponent(
  menus_ColorPickervue_type_script_lang_ts_,
  ColorPickervue_type_template_id_0a5a0448_scoped_true_render,
  ColorPickervue_type_template_id_0a5a0448_scoped_true_staticRenderFns,
  false,
  null,
  "0a5a0448",
  null
  
)

/* harmony default export */ var menus_ColorPicker = (ColorPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Link/LinkMenu.vue?vue&type=template&id=30fb0561&scoped=true&
var LinkMenuvue_type_template_id_30fb0561_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__link-menu"},[_c('CommandButton',{attrs:{"command":_vm.toggleLinkInput,"isActive":_vm.isActive,"tooltip-content":_vm.buttonTooltipContent},on:{"tooltip-created":function($event){return _vm.$emit('tooltip-created', $event)}}},[(!_vm.isHandlingLink && !_vm.isLoadingFavicon && !_vm.faviconLink.length)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', _vm.linkIcon]}}):_vm._e(),(_vm.isLoadingFavicon || _vm.isHandlingLink)?_c('font-awesome-icon',{staticClass:"icon icon-spinner",attrs:{"icon":['fal', 'circle-notch'],"spin":""}}):(_vm.faviconLink.length)?_c('img',{staticClass:"favicon",attrs:{"src":_vm.faviconLink,"alt":"favicon"}}):_vm._e()],1),(_vm.isInputOpened)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.link),expression:"link"}],ref:"linkInput",staticClass:"link-input",class:_vm.computeInputClass(),attrs:{"type":"text","disabled":_vm.isHandlingLink,"placeholder":"https://www.google.com"},domProps:{"value":(_vm.link)},on:{"keyup":_vm.handleFaviconOnLinkChanged,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleLinkCommand.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.toggleLinkInput.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.link=$event.target.value}}}):_vm._e()],1)}
var LinkMenuvue_type_template_id_30fb0561_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Link/LinkMenu.vue?vue&type=template&id=30fb0561&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("2b3d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__("9861");

// CONCATENATED MODULE: ./src/utils/isSafeUrl.ts


/* harmony default export */ var isSafeUrl = (function (url) {
  // 1. check if is URL compatible
  // Regex for url matching
  var reUrl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.|:[\w.-]+|\/)+([\w\-._~:/?#[\]@!$&'()*+%,;=.]|)+$/i;
  var reHash = /^#[\w-]+$/i;
  var reMailto = /^mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i; // Regex for javascript matching e.g "javascript:alert(1)"

  var reJavascript = /(javascript[:])/i; // Regex for data matching e.g "data:hello"

  var reData = /(data[:])/i;
  return [reUrl.test(url) || reHash.test(url) || reMailto.test(url), !reJavascript.test(url), !reData.test(url)].every(function (el) {
    return el;
  });
});
// EXTERNAL MODULE: ./node_modules/debounce/index.js
var node_modules_debounce = __webpack_require__("b012");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/CommandButton.vue?vue&type=template&id=7bdc44c6&scoped=true&
var CommandButtonvue_type_template_id_7bdc44c6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__bubble-menu-button-wrapper"},[_c('button',_vm._g({ref:"commandButton",staticClass:"mayday-editor__bubble-menu-button-wrapper__command-button",class:_vm.additionalClass,attrs:{"type":"button"},on:{"click":[function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.command.apply(null, arguments)},function($event){if(!$event.metaKey){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey){ return null; }return _vm.handleControlClick.apply(null, arguments)},function($event){if(!$event.ctrlKey){ return null; }if($event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleControlClick.apply(null, arguments)}]}},_vm.$listeners),[_vm._t("default",function(){return [(_vm.icon)?_c('font-awesome-icon',_vm._b({class:['icon', { 'ai-feature': _vm.aiFeature }],attrs:{"icon":[_vm.iconStyle, _vm.icon]}},'font-awesome-icon',_vm.iconFeatures,false)):(_vm.text)?_c('div',{staticClass:"text-icon"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()]})],2)])}
var CommandButtonvue_type_template_id_7bdc44c6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/CommandButton.vue?vue&type=template&id=7bdc44c6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/CommandButton.vue?vue&type=script&lang=ts&








var CommandButtonvue_type_script_lang_ts_a;






var CommandButtonvue_type_script_lang_ts_CommandButton = /*#__PURE__*/function (_Vue) {
  _inherits(CommandButton, _Vue);

  var _super = _createSuper(CommandButton);

  function CommandButton() {
    var _this;

    _classCallCheck(this, CommandButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "commandCtrl", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isActive", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "icon", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "text", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "iconStyle", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "iconFeatures", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "iconHoverType", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tooltipContent", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "disabled", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "aiFeature", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tippyInstance", null);

    return _this;
  }

  _createClass(CommandButton, [{
    key: "additionalClass",
    get: function get() {
      var _ref;

      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, "icon-".concat(this.iconHoverType), true), Object(defineProperty["a" /* default */])(_ref, "is-active", this.isActive), Object(defineProperty["a" /* default */])(_ref, "is-disabled", this.disabled), _ref;
    }
  }, {
    key: "handleControlClick",
    value: function handleControlClick() {
      if (this.commandCtrl) {
        this.commandCtrl();
      } else {
        this.command();
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.tooltipContent.length) {
        this.handleTooltipInstance();
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.tippyInstance != null) {
        this.tippyInstance.destroy();
        this.tippyInstance = null;
      }
    }
  }, {
    key: "handleTooltipContentChanged",
    value: function handleTooltipContentChanged(content) {
      var _this$tippyInstance;

      (_this$tippyInstance = this.tippyInstance) === null || _this$tippyInstance === void 0 ? void 0 : _this$tippyInstance.setContent(content);
    }
  }, {
    key: "handleTooltipInstance",
    value: function handleTooltipInstance() {
      var buttonEl = this.$refs.commandButton;

      if (buttonEl == null) {
        return;
      }

      this.tippyInstance = tippy_esm(buttonEl, {
        content: this.tooltipContent,
        theme: "bubble-menu-tooltip",
        arrow: ROUND_ARROW,
        animation: "shift-away",
        duration: [200, 150],
        inertia: true
      });
      this.$emit("tooltip-created", this.tippyInstance);
    }
  }]);

  return CommandButton;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "commandCtrl", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
}), __metadata("design:type", Boolean)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "isActive", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "icon", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "text", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: "fal"
}), __metadata("design:type", String)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "iconStyle", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: function _default() {
    return {};
  }
}), __metadata("design:type", typeof (CommandButtonvue_type_script_lang_ts_a = typeof Record !== "undefined" && Record) === "function" ? CommandButtonvue_type_script_lang_ts_a : Object)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "iconFeatures", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: "normal"
}), __metadata("design:type", String)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "iconHoverType", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: ""
}), __metadata("design:type", String)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "tooltipContent", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
}), __metadata("design:type", Boolean)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "disabled", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
}), __metadata("design:type", Boolean)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "aiFeature", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("tooltipContent"), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], CommandButtonvue_type_script_lang_ts_CommandButton.prototype, "handleTooltipContentChanged", null);

CommandButtonvue_type_script_lang_ts_CommandButton = __decorate([external_vue_property_decorator_["Component"]], CommandButtonvue_type_script_lang_ts_CommandButton);
/* harmony default export */ var CommandButtonvue_type_script_lang_ts_ = (CommandButtonvue_type_script_lang_ts_CommandButton);
// CONCATENATED MODULE: ./src/components/menus/CommandButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var menus_CommandButtonvue_type_script_lang_ts_ = (CommandButtonvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/CommandButton.vue?vue&type=style&index=0&id=7bdc44c6&lang=scss&scoped=true&
var CommandButtonvue_type_style_index_0_id_7bdc44c6_lang_scss_scoped_true_ = __webpack_require__("6f04");

// CONCATENATED MODULE: ./src/components/menus/CommandButton.vue






/* normalize component */

var CommandButton_component = normalizeComponent(
  menus_CommandButtonvue_type_script_lang_ts_,
  CommandButtonvue_type_template_id_7bdc44c6_scoped_true_render,
  CommandButtonvue_type_template_id_7bdc44c6_scoped_true_staticRenderFns,
  false,
  null,
  "7bdc44c6",
  null
  
)

/* harmony default export */ var menus_CommandButton = (CommandButton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Link/LinkMenu.vue?vue&type=script&lang=ts&




























var LinkMenuvue_type_script_lang_ts_LinkMenu = /*#__PURE__*/function (_Vue) {
  _inherits(LinkMenu, _Vue);

  var _super = _createSuper(LinkMenu);

  function LinkMenu() {
    var _this;

    _classCallCheck(this, LinkMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isActive", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "currentLink", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tooltipContent", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isInputOpened", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isHandlingLink", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isValidLink", true);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "link", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "faviconLink", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isLoadingFavicon", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isClosingInput", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "resolveImage", utils_resolveImage);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "computeFaviconUrl", computeFaviconUrl);

    return _this;
  }

  _createClass(LinkMenu, [{
    key: "buttonTooltipContent",
    get: function get() {
      return this.isInputOpened ? this.$t("mayday-editor.menu.link.close") : this.tooltipContent;
    }
  }, {
    key: "linkIcon",
    get: function get() {
      return this.isInputOpened ? "times-circle" : "link";
    }
  }, {
    key: "handleFaviconOnLinkChanged",
    get: function get() {
      return Object(node_modules_debounce["debounce"])(this.handleLinkChanged, 400);
    }
  }, {
    key: "handleCurrentLink",
    value: function handleCurrentLink(link) {
      if (this.isActive && link !== this.link) {
        this.link = link;
        this.computeFavicon(link);
      } else if (!this.isActive && !link.length) {
        if (this.isInputOpened) {
          this.toggleLinkInput();
        } else {
          this.resetAddingLinkState();
        }
      }
    }
  }, {
    key: "resetAddingLinkState",
    value: function resetAddingLinkState() {
      this.isHandlingLink = false;
      this.isValidLink = true;
      this.faviconLink = "";
      this.link = "";
      this.isClosingInput = false;
      this.isLoadingFavicon = false;
    }
  }, {
    key: "computeFavicon",
    value: function () {
      var _computeFavicon = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(link) {
        var res, faviconLink, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                res = isSafeUrl(link);

                if (res) {
                  _context.next = 4;
                  break;
                }

                throw new Error("INVALID_URL");

              case 4:
                this.isLoadingFavicon = true;
                faviconLink = this.computeFaviconUrl(link);
                _context.next = 8;
                return this.resolveImage(faviconLink);

              case 8:
                result = _context.sent;

                if (result.complete) {
                  this.faviconLink = faviconLink;
                } else {
                  this.faviconLink = "";
                }

                this.isLoadingFavicon = false;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                this.isLoadingFavicon = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function computeFavicon(_x) {
        return _computeFavicon.apply(this, arguments);
      }

      return computeFavicon;
    }()
  }, {
    key: "handleLinkChanged",
    value: function handleLinkChanged(event) {
      var _event$target;

      var link = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;

      if (this.currentLink === link) {
        return;
      }

      this.computeFavicon(link);
    }
  }, {
    key: "handleClosingInput",
    value: function handleClosingInput() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var _this2$$refs$linkInpu;

        (_this2$$refs$linkInpu = _this2.$refs.linkInput) === null || _this2$$refs$linkInpu === void 0 ? void 0 : _this2$$refs$linkInpu.addEventListener("animationend", function () {
          resolve();
        }); // animation is 200ms
        // rejecting just in case handler isn't bounded / triggered for some reason

        window.setTimeout(function () {
          return reject();
        }, 300);
      });
    }
  }, {
    key: "toggleLinkInput",
    value: function () {
      var _toggleLinkInput = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isInputOpened) {
                  _context2.next = 12;
                  break;
                }

                this.isClosingInput = true;
                _context2.prev = 2;
                _context2.next = 5;
                return this.handleClosingInput();

              case 5:
                this.$emit("link-input-closed");
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                this.$emit("link-input-closed");

              case 11:
                this.isHandlingLink = false;

              case 12:
                this.isInputOpened = !this.isInputOpened; // clean adding state on close

                if (this.isInputOpened) {
                  _context2.next = 17;
                  break;
                }

                if (!this.currentLink.length) {
                  this.resetAddingLinkState();
                } else {
                  this.isClosingInput = false;
                }

                _context2.next = 20;
                break;

              case 17:
                _context2.next = 19;
                return this.$nextTick();

              case 19:
                this.$refs.linkInput.focus();

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function toggleLinkInput() {
        return _toggleLinkInput.apply(this, arguments);
      }

      return toggleLinkInput;
    }()
  }, {
    key: "handleLinkCommand",
    value: function () {
      var _handleLinkCommand = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, currentUrl, targetUrl, currentId, targetId;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isHandlingLink = true;
                _context3.next = 3;
                return this.$nextTick();

              case 3:
                _context3.prev = 3;
                res = isSafeUrl(this.link);

                if (res) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("INVALID_URL");

              case 7:
                if (this.link[0] !== "#") {
                  // set hash if urls have the same content id
                  currentUrl = new URL(window.location.href);
                  targetUrl = new URL(this.link);

                  if (currentUrl.origin === targetUrl.origin && targetUrl.hash) {
                    currentId = currentUrl.pathname.split("/").pop();
                    targetId = targetUrl.pathname.split("/").pop();

                    if (currentId === targetId) {
                      this.link = targetUrl.hash; // menu favicon

                      this.computeFavicon(targetUrl.hash); // node favicon

                      this.faviconLink = "https://maydaystatic.blob.core.windows.net/assets/hash-icon.png";
                    }
                  }
                }

                this.command(this.link, this.faviconLink);
                this.toggleLinkInput();
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);
                this.isValidLink = false;
                this.isHandlingLink = false;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 12]]);
      }));

      function handleLinkCommand() {
        return _handleLinkCommand.apply(this, arguments);
      }

      return handleLinkCommand;
    }()
  }, {
    key: "computeInputClass",
    value: function computeInputClass() {
      var isValidLink = this.isValidLink,
          isClosingInput = this.isClosingInput;
      return {
        "is-invalid": !isValidLink,
        "is-closing": isClosingInput
      };
    }
  }, {
    key: "computeActiveIconClass",
    value: function computeActiveIconClass() {
      var isActive = this.isActive;
      return isActive ? "is-active" : "";
    }
  }]);

  return LinkMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], LinkMenuvue_type_script_lang_ts_LinkMenu.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Boolean)], LinkMenuvue_type_script_lang_ts_LinkMenu.prototype, "isActive", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], LinkMenuvue_type_script_lang_ts_LinkMenu.prototype, "currentLink", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], LinkMenuvue_type_script_lang_ts_LinkMenu.prototype, "tooltipContent", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("currentLink", {
  immediate: true
}), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], LinkMenuvue_type_script_lang_ts_LinkMenu.prototype, "handleCurrentLink", null);

LinkMenuvue_type_script_lang_ts_LinkMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    CommandButton: menus_CommandButton
  }
})], LinkMenuvue_type_script_lang_ts_LinkMenu);
/* harmony default export */ var LinkMenuvue_type_script_lang_ts_ = (LinkMenuvue_type_script_lang_ts_LinkMenu);
// CONCATENATED MODULE: ./src/components/menus/Link/LinkMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Link_LinkMenuvue_type_script_lang_ts_ = (LinkMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Link/LinkMenu.vue?vue&type=style&index=0&id=30fb0561&lang=scss&scoped=true&
var LinkMenuvue_type_style_index_0_id_30fb0561_lang_scss_scoped_true_ = __webpack_require__("f853");

// CONCATENATED MODULE: ./src/components/menus/Link/LinkMenu.vue






/* normalize component */

var LinkMenu_component = normalizeComponent(
  Link_LinkMenuvue_type_script_lang_ts_,
  LinkMenuvue_type_template_id_30fb0561_scoped_true_render,
  LinkMenuvue_type_template_id_30fb0561_scoped_true_staticRenderFns,
  false,
  null,
  "30fb0561",
  null
  
)

/* harmony default export */ var Link_LinkMenu = (LinkMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/BaseBubbleMenu.vue?vue&type=script&lang=ts&














var BaseBubbleMenuvue_type_script_lang_ts_BaseBubbleMenu = /*#__PURE__*/function (_Vue) {
  _inherits(BaseBubbleMenu, _Vue);

  var _super = _createSuper(BaseBubbleMenu);

  function BaseBubbleMenu() {
    var _this;

    _classCallCheck(this, BaseBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "commandButtonTippyInstances", []);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "commandButtonTooltipSingleton", createSingleton([], {
      delay: [0, 500],
      // tippy instances will overrides those properties
      overrides: ["animation", "duration", "inertia", "theme"]
    }));

    return _this;
  }

  _createClass(BaseBubbleMenu, [{
    key: "currentSelection",
    get: function get() {
      if (this.editor == null) {
        return null;
      }

      return this.editor.state.selection;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.commandButtonTooltipSingleton.destroy();
    }
  }, {
    key: "getNodeInCurrentSelectionAnchor",
    value: function getNodeInCurrentSelectionAnchor(typeName) {
      if (this.currentSelection == null) {
        return null;
      }

      var node = this.currentSelection.$anchor.node(1);

      if (node == null || node.type.name !== typeName) {
        return null;
      }

      return node;
    }
  }, {
    key: "addCommandButtonTippyInstance",
    value: function addCommandButtonTippyInstance(instance) {
      this.commandButtonTippyInstances.push(instance);
      this.commandButtonTooltipSingleton.setInstances(this.commandButtonTippyInstances);
    }
  }]);

  return BaseBubbleMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], BaseBubbleMenuvue_type_script_lang_ts_BaseBubbleMenu.prototype, "editor", void 0);

BaseBubbleMenuvue_type_script_lang_ts_BaseBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    CommandButton: menus_CommandButton
  }
})], BaseBubbleMenuvue_type_script_lang_ts_BaseBubbleMenu);
/* harmony default export */ var BaseBubbleMenuvue_type_script_lang_ts_ = (BaseBubbleMenuvue_type_script_lang_ts_BaseBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/BaseBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_BaseBubbleMenuvue_type_script_lang_ts_ = (BaseBubbleMenuvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/menus/Bubble/BaseBubbleMenu.vue
var BaseBubbleMenu_render, BaseBubbleMenu_staticRenderFns




/* normalize component */

var BaseBubbleMenu_component = normalizeComponent(
  Bubble_BaseBubbleMenuvue_type_script_lang_ts_,
  BaseBubbleMenu_render,
  BaseBubbleMenu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Bubble_BaseBubbleMenu = (BaseBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/TranslationPicker.vue?vue&type=template&id=c0580934&scoped=true&
var TranslationPickervue_type_template_id_c0580934_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__translation-editor"},[_c('div',{staticClass:"mayday-editor__translation-language-dropdown"},_vm._l((_vm.languages),function(language){return _c('div',{key:language,staticClass:"mayday-editor__translation-language",on:{"click":function($event){return _vm.$emit('fetch-translation', language)}}},[_c('div',[_vm._v(" "+_vm._s(_vm.$t(("mayday-editor.menu.translate.flags." + language)))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t(("mayday-editor.menu.translate.languages." + language)))+" ")])])}),0)])}
var TranslationPickervue_type_template_id_c0580934_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/TranslationPicker.vue?vue&type=template&id=c0580934&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/TranslationPicker.vue?vue&type=script&lang=ts&











var TranslationPickervue_type_script_lang_ts_TranslationPicker = /*#__PURE__*/function (_Vue) {
  _inherits(TranslationPicker, _Vue);

  var _super = _createSuper(TranslationPicker);

  function TranslationPicker() {
    var _this;

    _classCallCheck(this, TranslationPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "languages", ["fr-fr", "en-us", "es-es", "de-de", "it-it", "pt-pt", "nl-nl", "ru-ru", "zh-cn"]);

    return _this;
  }

  return _createClass(TranslationPicker);
}(external_vue_property_decorator_["Vue"]);

TranslationPickervue_type_script_lang_ts_TranslationPicker = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: "TranslationPicker"
})], TranslationPickervue_type_script_lang_ts_TranslationPicker);
/* harmony default export */ var TranslationPickervue_type_script_lang_ts_ = (TranslationPickervue_type_script_lang_ts_TranslationPicker);
// CONCATENATED MODULE: ./src/components/menus/TranslationPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var menus_TranslationPickervue_type_script_lang_ts_ = (TranslationPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/TranslationPicker.vue?vue&type=style&index=0&id=c0580934&lang=scss&scoped=true&
var TranslationPickervue_type_style_index_0_id_c0580934_lang_scss_scoped_true_ = __webpack_require__("03a1");

// CONCATENATED MODULE: ./src/components/menus/TranslationPicker.vue






/* normalize component */

var TranslationPicker_component = normalizeComponent(
  menus_TranslationPickervue_type_script_lang_ts_,
  TranslationPickervue_type_template_id_c0580934_scoped_true_render,
  TranslationPickervue_type_template_id_c0580934_scoped_true_staticRenderFns,
  false,
  null,
  "c0580934",
  null
  
)

/* harmony default export */ var menus_TranslationPicker = (TranslationPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/TextSelectionBubbleMenu.vue?vue&type=script&lang=ts&
















var TextSelectionBubbleMenuvue_type_script_lang_ts_a;












var TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(TextSelectionBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(TextSelectionBubbleMenu);

  function TextSelectionBubbleMenu() {
    var _this;

    _classCallCheck(this, TextSelectionBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "options", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "generateTranslation", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "textSelectionBubbleMenuClass", textSelectionBubbleMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "colorsPickerTippyInstances", []);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "colorPickerSingleton", createSingleton([], {
      trigger: "click",
      animation: "perspective-subtle",
      theme: "bubble-menu",
      maxWidth: "none",
      arrow: false,
      interactive: true,
      appendTo: "parent",
      overrides: ["onShown", "onHidden"]
    }));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "colorPickerOpenedIdx", -1);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "translationPickerOpened", false);

    return _this;
  }

  _createClass(TextSelectionBubbleMenu, [{
    key: "menuOptions",
    get: function get() {
      return this.options || {
        fontOptions: true,
        extraFontOptions: true,
        colorOptions: true,
        structurationOptions: true,
        extraStructurationOptions: true
      };
    }
  }, {
    key: "currentlyStreaming",
    get: function get() {
      var _this$editor;

      return (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.storage.streamWrapper.streaming;
    }
  }, {
    key: "disableAiFeatures",
    get: function get() {
      var _this$editor2, _this$editor3, _this$editor4, _this$editor5, _this$editor6, _this$editor7, _this$editor8, _this$editor9, _this$editor10;

      var selection = (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.state.doc.textBetween((_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.state.selection.from, (_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.state.selection.to, " ");
      var preSelection = (_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.state.doc.textBetween(((_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.state.selection.from) - 1, ((_this$editor7 = this.editor) === null || _this$editor7 === void 0 ? void 0 : _this$editor7.state.selection.from) + 1, " ");
      var postSelection = (_this$editor8 = this.editor) === null || _this$editor8 === void 0 ? void 0 : _this$editor8.state.doc.textBetween(((_this$editor9 = this.editor) === null || _this$editor9 === void 0 ? void 0 : _this$editor9.state.selection.to) - 1, ((_this$editor10 = this.editor) === null || _this$editor10 === void 0 ? void 0 : _this$editor10.state.selection.to) + 1, " "); // handle non-latin characters

      var alphabeticRegex = /^(?=.*[\w]).+$/i;
      var startEndRegex = /^[\w]{2}$/i;
      return this.currentlyStreaming || !alphabeticRegex.test(selection) || startEndRegex.test(preSelection) || startEndRegex.test(postSelection);
    }
  }, {
    key: "displayAiFeatures",
    get: function get() {
      var _this$menuOptions, _this$menuOptions2, _this$menuOptions3;

      return ((_this$menuOptions = this.menuOptions) === null || _this$menuOptions === void 0 ? void 0 : _this$menuOptions.allowToneImprovement) || ((_this$menuOptions2 = this.menuOptions) === null || _this$menuOptions2 === void 0 ? void 0 : _this$menuOptions2.allowTranslation) || ((_this$menuOptions3 = this.menuOptions) === null || _this$menuOptions3 === void 0 ? void 0 : _this$menuOptions3.allowToneImprovement);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$options,
          _this$options2,
          _this2 = this,
          _this$options3,
          _this$options4;

      var _this$$refs = this.$refs,
          highlightColorPicker = _this$$refs.highlightColorPicker,
          highlightCommandButton = _this$$refs.highlightCommandButton,
          textColorPicker = _this$$refs.textColorPicker,
          colorCommandButton = _this$$refs.colorCommandButton,
          translationCommandButton = _this$$refs.translationCommandButton,
          translationPicker = _this$$refs.translationPicker;
      var refs = [];

      if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.colorOptions) {
        refs.push(highlightColorPicker, highlightCommandButton, textColorPicker, colorCommandButton);
      }

      if ((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.allowTranslation) {
        refs.push(translationCommandButton, translationPicker);
      }

      if (refs.some(function (ref) {
        return ref == null;
      })) {
        return;
      }

      var highlightColorPickerEl = highlightColorPicker ? highlightColorPicker.$el : undefined;
      var textColorPickerEl = textColorPicker ? textColorPicker.$el : undefined;
      var translationPickerEl = translationPicker ? translationPicker.$el : undefined;

      var onShown = function onShown(idx) {
        return function () {
          return _this2.handleColorPickerToggled(idx, true);
        };
      };

      var onHidden = function onHidden(idx) {
        return function () {
          return _this2.handleColorPickerToggled(idx, false);
        };
      };

      var tippyInstances = [];

      if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.colorOptions && highlightColorPickerEl) {
        tippyInstances.push({
          target: highlightCommandButton.$el,
          content: highlightColorPickerEl
        }, {
          target: colorCommandButton.$el,
          content: textColorPickerEl
        });
      }

      if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.allowTranslation && translationPickerEl) {
        tippyInstances.push({
          target: translationCommandButton.$el,
          content: translationPickerEl
        });
      }

      if (!tippyInstances.length) return; // creating color pickers tippy instances

      tippyInstances.forEach(function (_ref, idx) {
        var target = _ref.target,
            content = _ref.content;
        _this2.colorsPickerTippyInstances[idx] = tippy_esm(target, {
          content: content,
          onShown: onShown(idx),
          onHidden: onHidden(idx)
        });
        content.style.removeProperty("display");
      }); // link color picker tooltip together

      this.colorPickerSingleton.setInstances(this.colorsPickerTippyInstances);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.colorPickerSingleton.destroy();
      this.colorsPickerTippyInstances.forEach(function (instance) {
        if (instance != null) {
          instance.destroy();
        }
      });
    }
  }, {
    key: "currentLink",
    get: function get() {
      var _this$editor11;

      return this.computeCommandIsActive("link") ? (_this$editor11 = this.editor) === null || _this$editor11 === void 0 ? void 0 : _this$editor11.getAttributes("link").href : "";
    }
  }, {
    key: "computeCommandIsActive",
    value: function computeCommandIsActive(nodeOrMarkNameOrAttributes, attributes) {
      // `editor` is undefined before parent component mounted hook run
      if (this.editor == null) {
        return false;
      }

      return typeof nodeOrMarkNameOrAttributes === "string" ? this.editor.isActive(nodeOrMarkNameOrAttributes, attributes) : this.editor.isActive(nodeOrMarkNameOrAttributes); // only attributes as first parameter
    }
  }, {
    key: "setLink",
    value: function setLink(href, favicon) {
      if (this.editor == null || href.length === 0) {
        return false;
      }

      return this.editor.chain().focus().setLink({
        href: href,
        favicon: favicon
      }).run();
    }
  }, {
    key: "handleColorPickerToggled",
    value: function handleColorPickerToggled(idx, isOpen) {
      this.colorPickerOpenedIdx = isOpen ? idx : -1;
      var fn = isOpen ? "disable" : "enable";
      this.commandButtonTooltipSingleton[fn]();
    }
  }, {
    key: "isColorPickerShown",
    value: function isColorPickerShown(usage) {
      var colorPickerOpenedIdx = this.colorPickerOpenedIdx;
      var idx = usage === "highlight" ? 0 : 1;
      return colorPickerOpenedIdx !== -1 && idx === colorPickerOpenedIdx;
    }
  }, {
    key: "isColorActive",
    value: function isColorActive(usage) {
      var _this3 = this;

      var markName = usage === "highlight" ? usage : "textStyle";
      return function (color) {
        if (_this3.editor == null) {
          return false;
        }

        var isDefaultColor = // highlight default color
        color === BaseColors[EColor.WHITE] || // text default color
        color === BaseColors[EColor.BLACK];
        return isDefaultColor ? // with default color, mark will not be active
        !_this3.editor.isActive(markName) : _this3.editor.isActive(markName, {
          color: color
        });
      };
    }
  }, {
    key: "handleColorChosen",
    value: function handleColorChosen(_ref2) {
      var _this$editor12, _chain5;

      var usage = _ref2.usage,
          color = _ref2.color;
      var name = usage === "highlight" ? usage : "textStyle";
      var isCurrentlyActive = color === null ? !this.computeCommandIsActive(name, {
        color: ""
      }) : this.computeCommandIsActive(name, {
        color: color
      });
      var chain = (_this$editor12 = this.editor) === null || _this$editor12 === void 0 ? void 0 : _this$editor12.chain().focus();

      if (isCurrentlyActive) {
        if (usage === "highlight") {
          var _chain;

          chain = (_chain = chain) === null || _chain === void 0 ? void 0 : _chain.unsetHighlight();
        } else {
          var _chain2;

          chain = (_chain2 = chain) === null || _chain2 === void 0 ? void 0 : _chain2.unsetColor();
        }
      } else {
        if (usage === "highlight") {
          var _chain3;

          chain = (_chain3 = chain) === null || _chain3 === void 0 ? void 0 : _chain3.setHighlight({
            color: color
          });
        } else {
          var _chain4;

          chain = (_chain4 = chain) === null || _chain4 === void 0 ? void 0 : _chain4.setColor(color);
        }
      }

      (_chain5 = chain) === null || _chain5 === void 0 ? void 0 : _chain5.run();
    }
  }, {
    key: "handleFetchTranslation",
    value: function () {
      var _handleFetchTranslation = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(language) {
        var nextNode, _this$editor13, _this$editor16, _this$editor14, _this$editor15;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.currentlyStreaming || !this.editor)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                nextNode = this.nextNode;

                if (nextNode) {
                  if ((_this$editor13 = this.editor) !== null && _this$editor13 !== void 0 && _this$editor13.storage.streamWrapper) {
                    this.editor.storage.streamWrapper.highlightFrom = (_this$editor14 = this.editor) === null || _this$editor14 === void 0 ? void 0 : _this$editor14.state.selection.$from;
                    this.editor.storage.streamWrapper.highlightTo = (_this$editor15 = this.editor) === null || _this$editor15 === void 0 ? void 0 : _this$editor15.state.selection.$to;
                    this.editor.storage.streamWrapper.language = language;
                  }

                  (_this$editor16 = this.editor) === null || _this$editor16 === void 0 ? void 0 : _this$editor16.chain().setMeta("preventUpdate", true).focus().insertContentAt(nextNode, {
                    type: "translation"
                  }).scrollIntoView().run();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleFetchTranslation(_x) {
        return _handleFetchTranslation.apply(this, arguments);
      }

      return handleFetchTranslation;
    }()
  }, {
    key: "handleFetchCorrection",
    value: function () {
      var _handleFetchCorrection = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var nextNode, _this$editor17, _this$editor20, _this$editor18, _this$editor19;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.currentlyStreaming || !this.editor)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                nextNode = this.nextNode;

                if (nextNode) {
                  if ((_this$editor17 = this.editor) !== null && _this$editor17 !== void 0 && _this$editor17.storage.streamWrapper) {
                    this.editor.storage.streamWrapper.highlightFrom = (_this$editor18 = this.editor) === null || _this$editor18 === void 0 ? void 0 : _this$editor18.state.selection.$from;
                    this.editor.storage.streamWrapper.highlightTo = (_this$editor19 = this.editor) === null || _this$editor19 === void 0 ? void 0 : _this$editor19.state.selection.$to;
                  }

                  (_this$editor20 = this.editor) === null || _this$editor20 === void 0 ? void 0 : _this$editor20.chain().setMeta("preventUpdate", true).focus().insertContentAt(nextNode, {
                    type: "grammarCorrector"
                  }).scrollIntoView().run();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFetchCorrection() {
        return _handleFetchCorrection.apply(this, arguments);
      }

      return handleFetchCorrection;
    }()
  }, {
    key: "handleFetchToneImprovement",
    value: function () {
      var _handleFetchToneImprovement = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var nextNode, _this$editor21, _this$editor24, _this$editor22, _this$editor23;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.currentlyStreaming || !this.editor)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                nextNode = this.nextNode;

                if (nextNode) {
                  if ((_this$editor21 = this.editor) !== null && _this$editor21 !== void 0 && _this$editor21.storage.streamWrapper) {
                    this.editor.storage.streamWrapper.highlightFrom = (_this$editor22 = this.editor) === null || _this$editor22 === void 0 ? void 0 : _this$editor22.state.selection.$from;
                    this.editor.storage.streamWrapper.highlightTo = (_this$editor23 = this.editor) === null || _this$editor23 === void 0 ? void 0 : _this$editor23.state.selection.$to;
                  }

                  (_this$editor24 = this.editor) === null || _this$editor24 === void 0 ? void 0 : _this$editor24.chain().focus().insertContentAt(nextNode, {
                    type: "toneImprover"
                  }).setMeta("preventUpdate", true).scrollIntoView().run();
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleFetchToneImprovement() {
        return _handleFetchToneImprovement.apply(this, arguments);
      }

      return handleFetchToneImprovement;
    }()
  }, {
    key: "nextNode",
    get: function get() {
      var _this$editor25, _this$editor26;

      var currentNode = (_this$editor25 = this.editor) === null || _this$editor25 === void 0 ? void 0 : _this$editor25.state.selection.$to;
      if (!currentNode || !currentNode.pos) return undefined;

      if (currentNode.parent.type.name.includes("detail")) {
        return currentNode.path[2] + // this always is the position of the 0 depth p
        currentNode.doc.child(currentNode.index(0)).nodeSize;
      }

      return (_this$editor26 = this.editor) === null || _this$editor26 === void 0 ? void 0 : _this$editor26.state.selection.$to.after();
    }
  }]);

  return TextSelectionBubbleMenu;
}(Bubble_BaseBubbleMenu);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Object
}), __metadata("design:type", typeof (TextSelectionBubbleMenuvue_type_script_lang_ts_a = typeof /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined !== "undefined" && /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined) === "function" ? TextSelectionBubbleMenuvue_type_script_lang_ts_a : Object)], TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu.prototype, "options", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function,
  default: function _default() {
    return "";
  }
}), __metadata("design:type", Function)], TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu.prototype, "generateTranslation", void 0);

TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    TranslationPicker: menus_TranslationPicker,
    ColorPicker: menus_ColorPicker,
    LinkMenu: Link_LinkMenu
  }
})], TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu);
/* harmony default export */ var TextSelectionBubbleMenuvue_type_script_lang_ts_ = (TextSelectionBubbleMenuvue_type_script_lang_ts_TextSelectionBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/TextSelectionBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_TextSelectionBubbleMenuvue_type_script_lang_ts_ = (TextSelectionBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/TextSelectionBubbleMenu.vue?vue&type=style&index=0&id=09b4f9e1&lang=scss&scoped=true&
var TextSelectionBubbleMenuvue_type_style_index_0_id_09b4f9e1_lang_scss_scoped_true_ = __webpack_require__("bc35");

// CONCATENATED MODULE: ./src/components/menus/Bubble/TextSelectionBubbleMenu.vue






/* normalize component */

var TextSelectionBubbleMenu_component = normalizeComponent(
  Bubble_TextSelectionBubbleMenuvue_type_script_lang_ts_,
  TextSelectionBubbleMenuvue_type_template_id_09b4f9e1_scoped_true_render,
  TextSelectionBubbleMenuvue_type_template_id_09b4f9e1_scoped_true_staticRenderFns,
  false,
  null,
  "09b4f9e1",
  null
  
)

/* harmony default export */ var Bubble_TextSelectionBubbleMenu = (TextSelectionBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/TableBubbleMenu.vue?vue&type=template&id=4917586a&scoped=true&
var TableBubbleMenuvue_type_template_id_4917586a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tableBubbleMenuClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.tableBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().toggleNormalizedRowHeader().run(); },"is-active":_vm.firstRowIsHeader,"icon":"th-large","icon-style":"fad","tooltip-content":_vm.toggleHeaderRowTooltipContent},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor
            .chain()
            .focus()
            .toggleNormalizedColumnHeader(!_vm.firstColumnIsHeader)
            .run(); },"is-active":_vm.firstColumnIsHeader,"icon":"th-large","icon-style":"fad","icon-features":{ rotation: 270 },"tooltip-content":_vm.toggleHeaderColumnTooltipContent},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{class:(_vm.tableBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().deleteTable().run(); },"icon":"trash","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.table.tooltip.delete-table')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"mouseenter":function () { return _vm.editor.commands.highlightTable(true); },"mouseleave":function () { return _vm.editor.commands.highlightTable(false); }}})],1)])}
var TableBubbleMenuvue_type_template_id_4917586a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/TableBubbleMenu.vue?vue&type=template&id=4917586a&scoped=true&

// CONCATENATED MODULE: ./src/utils/isHeaderEnabledByType.ts


var isHeaderEnabledByType_isHeaderEnabledByType = function isHeaderEnabledByType(type, rect, types) {
  // Get cell positions for first row or first column
  var cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1
  });

  for (var i = 0; i < cellPositions.length; i++) {
    var cell = rect.table.nodeAt(cellPositions[i]);

    if (cell && cell.type !== types.header_cell) {
      return false;
    }
  }

  return true;
};

/* harmony default export */ var utils_isHeaderEnabledByType = (isHeaderEnabledByType_isHeaderEnabledByType);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/TableBubbleMenu.vue?vue&type=script&lang=ts&















var TableBubbleMenuvue_type_script_lang_ts_TableBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(TableBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(TableBubbleMenu);

  function TableBubbleMenu() {
    var _this;

    _classCallCheck(this, TableBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tableBubbleMenuClass", tableBubbleMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isHeaderEnabledByType", utils_isHeaderEnabledByType);

    return _this;
  }

  _createClass(TableBubbleMenu, [{
    key: "selectedRect",
    get: function get() {
      if (this.editor == null) {
        return null;
      }

      var state = this.editor.state;
      var cellSelection = selectionCell(state);
      return cellSelection != null ? selectedRect(this.editor.state) : null;
    }
  }, {
    key: "tableNodeTypes",
    get: function get() {
      if (this.editor == null) {
        return null;
      }

      return tableNodeTypes(this.editor.state.schema);
    }
  }, {
    key: "firstRowIsHeader",
    get: function get() {
      return this.isHeaderEnabled("row");
    }
  }, {
    key: "firstColumnIsHeader",
    get: function get() {
      return this.isHeaderEnabled("column");
    }
  }, {
    key: "toggleHeaderRowTooltipContent",
    get: function get() {
      return this.computeTooltipContent("row", this.firstRowIsHeader);
    }
  }, {
    key: "toggleHeaderColumnTooltipContent",
    get: function get() {
      return this.computeTooltipContent("column", this.firstColumnIsHeader);
    }
  }, {
    key: "computeTooltipContent",
    value: function computeTooltipContent(type, isActive) {
      var base = "mayday-editor.menu.table.tooltip";
      var key = isActive ? "".concat(base, ".deactivate-header-").concat(type) : "".concat(base, ".activate-header-").concat(type);
      return this.$t(key);
    }
  }, {
    key: "isHeaderEnabled",
    value: function isHeaderEnabled(type) {
      if (this.editor == null || this.selectedRect === null || this.tableNodeTypes === null) {
        return false;
      }

      return this.isHeaderEnabledByType(type, this.selectedRect, this.tableNodeTypes);
    }
  }]);

  return TableBubbleMenu;
}(Bubble_BaseBubbleMenu);

TableBubbleMenuvue_type_script_lang_ts_TableBubbleMenu = __decorate([external_vue_property_decorator_["Component"]], TableBubbleMenuvue_type_script_lang_ts_TableBubbleMenu);
/* harmony default export */ var TableBubbleMenuvue_type_script_lang_ts_ = (TableBubbleMenuvue_type_script_lang_ts_TableBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/TableBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_TableBubbleMenuvue_type_script_lang_ts_ = (TableBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/TableBubbleMenu.vue?vue&type=style&index=0&id=4917586a&lang=scss&scoped=true&
var TableBubbleMenuvue_type_style_index_0_id_4917586a_lang_scss_scoped_true_ = __webpack_require__("4a6b");

// CONCATENATED MODULE: ./src/components/menus/Bubble/TableBubbleMenu.vue






/* normalize component */

var TableBubbleMenu_component = normalizeComponent(
  Bubble_TableBubbleMenuvue_type_script_lang_ts_,
  TableBubbleMenuvue_type_template_id_4917586a_scoped_true_render,
  TableBubbleMenuvue_type_template_id_4917586a_scoped_true_staticRenderFns,
  false,
  null,
  "4917586a",
  null
  
)

/* harmony default export */ var Bubble_TableBubbleMenu = (TableBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/DividerBubbleMenu.vue?vue&type=template&id=3e922b62&scoped=true&
var DividerBubbleMenuvue_type_template_id_3e922b62_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.dividerBubbleMenuClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.dividerBubbleMenuClass + "__commands-container")},[_c('ColorPicker',{attrs:{"editor":_vm.editor,"usage":"divider","is-active":_vm.isColorActive},on:{"color-chosen":_vm.handleColorChosen}})],1),_c('div',{class:(_vm.dividerBubbleMenuClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().deleteSelection().run(); },"icon":"trash","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.divider.delete')},on:{"mouseenter":function () { return _vm.editor.commands.highlightDivider(true); },"mouseleave":function () { return _vm.editor.commands.highlightDivider(false); }}})],1)])}
var DividerBubbleMenuvue_type_template_id_3e922b62_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/DividerBubbleMenu.vue?vue&type=template&id=3e922b62&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/DividerBubbleMenu.vue?vue&type=script&lang=ts&














var DividerBubbleMenuvue_type_script_lang_ts_DividerBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(DividerBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(DividerBubbleMenu);

  function DividerBubbleMenu() {
    var _this;

    _classCallCheck(this, DividerBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "dividerBubbleMenuClass", dividerBubbleMenuClass);

    return _this;
  }

  _createClass(DividerBubbleMenu, [{
    key: "currentDividerAttributes",
    get: // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function get() {
      var _this$editor;

      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getAttributes("divider")) || {};
    }
  }, {
    key: "isColorActive",
    value: function isColorActive(color) {
      return this.currentDividerAttributes.color === color;
    }
  }, {
    key: "handleColorChosen",
    value: function handleColorChosen(_ref) {
      var _this$editor2;

      var color = _ref.color;
      (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.chain().focus().updateAttributes("divider", {
        color: color
      }).run();
    }
  }]);

  return DividerBubbleMenu;
}(Bubble_BaseBubbleMenu);

DividerBubbleMenuvue_type_script_lang_ts_DividerBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    ColorPicker: menus_ColorPicker
  }
})], DividerBubbleMenuvue_type_script_lang_ts_DividerBubbleMenu);
/* harmony default export */ var DividerBubbleMenuvue_type_script_lang_ts_ = (DividerBubbleMenuvue_type_script_lang_ts_DividerBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/DividerBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_DividerBubbleMenuvue_type_script_lang_ts_ = (DividerBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/DividerBubbleMenu.vue?vue&type=style&index=0&id=3e922b62&lang=scss&scoped=true&
var DividerBubbleMenuvue_type_style_index_0_id_3e922b62_lang_scss_scoped_true_ = __webpack_require__("53b2");

// CONCATENATED MODULE: ./src/components/menus/Bubble/DividerBubbleMenu.vue






/* normalize component */

var DividerBubbleMenu_component = normalizeComponent(
  Bubble_DividerBubbleMenuvue_type_script_lang_ts_,
  DividerBubbleMenuvue_type_template_id_3e922b62_scoped_true_render,
  DividerBubbleMenuvue_type_template_id_3e922b62_scoped_true_staticRenderFns,
  false,
  null,
  "3e922b62",
  null
  
)

/* harmony default export */ var Bubble_DividerBubbleMenu = (DividerBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/CalloutBubbleMenu.vue?vue&type=template&id=5caec206&scoped=true&
var CalloutBubbleMenuvue_type_template_id_5caec206_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.baseClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.setLevel('info'),"is-active":_vm.isCurrentLevel('info'),"icon":"info-circle","icon-hover-type":"info","tooltip-content":_vm.$t('mayday-editor.menu.callout.info')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":_vm.setLevel('success'),"is-active":_vm.isCurrentLevel('success'),"icon":"check-circle","icon-hover-type":"success","tooltip-content":_vm.$t('mayday-editor.menu.callout.success')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":_vm.setLevel('danger'),"is-active":_vm.isCurrentLevel('danger'),"icon":"exclamation-triangle","icon-hover-type":"danger","tooltip-content":_vm.$t('mayday-editor.menu.callout.danger')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":_vm.setLevel('error'),"is-active":_vm.isCurrentLevel('error'),"icon":"times-circle","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.callout.error')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.deleteCallout,"icon":"trash","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.callout.delete')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"mouseenter":function () { return _vm.editor.commands.highlightCallout(true); },"mouseleave":function () { return _vm.editor.commands.highlightCallout(false); }}})],1)])}
var CalloutBubbleMenuvue_type_template_id_5caec206_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/CalloutBubbleMenu.vue?vue&type=template&id=5caec206&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/CalloutBubbleMenu.vue?vue&type=script&lang=ts&













var CalloutBubbleMenuvue_type_script_lang_ts_CalloutBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(CalloutBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(CalloutBubbleMenu);

  function CalloutBubbleMenu() {
    var _this;

    _classCallCheck(this, CalloutBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", calloutBubbleMenuClass);

    return _this;
  }

  _createClass(CalloutBubbleMenu, [{
    key: "currentCallout",
    get: function get() {
      return this.getNodeInCurrentSelectionAnchor("callout");
    }
  }, {
    key: "currentLevel",
    get: function get() {
      if (this.currentCallout == null) {
        return null;
      }

      return this.currentCallout.attrs.level;
    }
  }, {
    key: "isCurrentLevel",
    value: function isCurrentLevel(level) {
      return this.currentLevel === level;
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      if (this.editor == null) {
        return function () {
          return false;
        };
      }

      var editor = this.editor;
      return function () {
        return editor.chain().focus().updateAttributes("callout", {
          level: level
        }).run();
      };
    }
  }, {
    key: "deleteCallout",
    value: function deleteCallout() {
      if (this.editor == null) {
        return;
      }

      this.editor.chain().focus().deleteNode("callout").run();
    }
  }]);

  return CalloutBubbleMenu;
}(Bubble_BaseBubbleMenu);

CalloutBubbleMenuvue_type_script_lang_ts_CalloutBubbleMenu = __decorate([external_vue_property_decorator_["Component"]], CalloutBubbleMenuvue_type_script_lang_ts_CalloutBubbleMenu);
/* harmony default export */ var CalloutBubbleMenuvue_type_script_lang_ts_ = (CalloutBubbleMenuvue_type_script_lang_ts_CalloutBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/CalloutBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_CalloutBubbleMenuvue_type_script_lang_ts_ = (CalloutBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/CalloutBubbleMenu.vue?vue&type=style&index=0&id=5caec206&lang=scss&scoped=true&
var CalloutBubbleMenuvue_type_style_index_0_id_5caec206_lang_scss_scoped_true_ = __webpack_require__("bf2b");

// CONCATENATED MODULE: ./src/components/menus/Bubble/CalloutBubbleMenu.vue






/* normalize component */

var CalloutBubbleMenu_component = normalizeComponent(
  Bubble_CalloutBubbleMenuvue_type_script_lang_ts_,
  CalloutBubbleMenuvue_type_template_id_5caec206_scoped_true_render,
  CalloutBubbleMenuvue_type_template_id_5caec206_scoped_true_staticRenderFns,
  false,
  null,
  "5caec206",
  null
  
)

/* harmony default export */ var Bubble_CalloutBubbleMenu = (CalloutBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/AttachmentBubbleMenu.vue?vue&type=template&id=5002d41a&scoped=true&
var AttachmentBubbleMenuvue_type_template_id_5002d41a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.baseClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.baseClass + "__commands-container file-type")},[_c('i',{class:_vm.fileTypeIconClass,attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"file-type-label"},[_vm._v(_vm._s(_vm.fileTypeFullName))])]),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.setAsDefaultBlock,"is-active":_vm.isDefaultBlock,"icon":"bookmark","tooltip-content":_vm.$t('mayday-editor.menu.attachment.set-as-default')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":_vm.setAsInlineLink,"is-active":_vm.isInlineLink,"icon":"link","tooltip-content":_vm.$t('mayday-editor.menu.attachment.set-as-link')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),(_vm.isEmbeddable)?_c('CommandButton',{attrs:{"command":_vm.setAsEmbed,"is-active":_vm.isEmbed,"icon":"window","tooltip-content":_vm.$t('mayday-editor.menu.attachment.set-as-embed')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e()],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEmbed),expression:"!isEmbed"}],class:(_vm.baseClass + "__commands-container")},[_c('LinkTitleMenu',{attrs:{"command":_vm.setAttachmentTitle,"current-title":_vm.attachmentTitle,"tooltip-content":_vm.$t('mayday-editor.menu.attachment.title')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"link-title-input-closed":function () { return _vm.editor.commands.focus(); }}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.downloadAttachment,"icon":"arrow-to-bottom","tooltip-content":_vm.$t('mayday-editor.menu.attachment.download')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.deleteAttachment,"icon":"trash","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.attachment.delete')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"mouseenter":function () { return _vm.editor.commands.highlightAttachment(true); },"mouseleave":function () { return _vm.editor.commands.highlightAttachment(false); }}})],1)])}
var AttachmentBubbleMenuvue_type_template_id_5002d41a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/AttachmentBubbleMenu.vue?vue&type=template&id=5002d41a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Link/LinkTitleMenu.vue?vue&type=template&id=bd0aa9ba&scoped=true&
var LinkTitleMenuvue_type_template_id_bd0aa9ba_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__link-title-menu"},[_c('CommandButton',{attrs:{"command":_vm.toggleLinkTitleInput,"isActive":_vm.isInputOpened,"icon":"text","tooltip-content":_vm.tooltipContent},on:{"tooltip-created":function($event){return _vm.$emit('tooltip-created', $event)}}}),(_vm.isInputOpened)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],ref:"linkTitleInput",staticClass:"link-input",class:_vm.inputClass,attrs:{"type":"text","disabled":_vm.isHandlingTitle,"placeholder":_vm.$t('mayday-editor.menu.link.title-placeholder')},domProps:{"value":(_vm.title)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleLinkTitleCommand.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelTitleChange.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}):_vm._e()],1)}
var LinkTitleMenuvue_type_template_id_bd0aa9ba_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Link/LinkTitleMenu.vue?vue&type=template&id=bd0aa9ba&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Link/LinkTitleMenu.vue?vue&type=script&lang=ts&
















var LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu = /*#__PURE__*/function (_Vue) {
  _inherits(LinkTitleMenu, _Vue);

  var _super = _createSuper(LinkTitleMenu);

  function LinkTitleMenu() {
    var _this;

    _classCallCheck(this, LinkTitleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tooltipContent", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "currentTitle", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "title", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isInputOpened", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isClosingInput", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isHandlingTitle", false);

    return _this;
  }

  _createClass(LinkTitleMenu, [{
    key: "inputClass",
    get: function get() {
      var isClosingInput = this.isClosingInput;
      return {
        "is-closing": isClosingInput
      };
    }
  }, {
    key: "handleCurrentTitleChanged",
    value: function handleCurrentTitleChanged(title) {
      this.title = title;
    }
  }, {
    key: "toggleLinkTitleInput",
    value: function () {
      var _toggleLinkTitleInput = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isInputOpened) {
                  _context.next = 16;
                  break;
                }

                this.isClosingInput = true;
                _context.prev = 2;
                _context.next = 5;
                return this.handleClosingInput();

              case 5:
                this.isClosingInput = false;
                _context.next = 8;
                return this.$nextTick();

              case 8:
                this.$emit("link-title-input-closed");
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                _context.next = 15;
                return this.$nextTick();

              case 15:
                this.$emit("link-title-input-closed");

              case 16:
                this.isInputOpened = !this.isInputOpened; // autofocus

                if (!this.isInputOpened) {
                  _context.next = 21;
                  break;
                }

                _context.next = 20;
                return this.$nextTick();

              case 20:
                this.$refs.linkTitleInput.focus();

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));

      function toggleLinkTitleInput() {
        return _toggleLinkTitleInput.apply(this, arguments);
      }

      return toggleLinkTitleInput;
    }()
  }, {
    key: "handleClosingInput",
    value: function handleClosingInput() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var _this2$$refs$linkTitl;

        (_this2$$refs$linkTitl = _this2.$refs.linkTitleInput) === null || _this2$$refs$linkTitl === void 0 ? void 0 : _this2$$refs$linkTitl.addEventListener("animationend", function () {
          resolve();
        }); // animation is 200ms
        // rejecting just in case handler isn't bounded / triggered for some reason

        window.setTimeout(function () {
          return reject();
        }, 300);
      });
    }
  }, {
    key: "handleLinkTitleCommand",
    value: function () {
      var _handleLinkTitleCommand = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isHandlingTitle = true;
                _context2.next = 3;
                return this.$nextTick();

              case 3:
                this.command(this.title);
                this.isHandlingTitle = false;
                this.toggleLinkTitleInput();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleLinkTitleCommand() {
        return _handleLinkTitleCommand.apply(this, arguments);
      }

      return handleLinkTitleCommand;
    }()
  }, {
    key: "cancelTitleChange",
    value: function cancelTitleChange() {
      this.handleCurrentTitleChanged(this.currentTitle);
      this.toggleLinkTitleInput();
    }
  }]);

  return LinkTitleMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu.prototype, "tooltipContent", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu.prototype, "currentTitle", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("currentTitle", {
  immediate: true
}), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu.prototype, "handleCurrentTitleChanged", null);

LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    CommandButton: menus_CommandButton
  }
})], LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu);
/* harmony default export */ var LinkTitleMenuvue_type_script_lang_ts_ = (LinkTitleMenuvue_type_script_lang_ts_LinkTitleMenu);
// CONCATENATED MODULE: ./src/components/menus/Link/LinkTitleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Link_LinkTitleMenuvue_type_script_lang_ts_ = (LinkTitleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Link/LinkTitleMenu.vue?vue&type=style&index=0&id=bd0aa9ba&lang=scss&scoped=true&
var LinkTitleMenuvue_type_style_index_0_id_bd0aa9ba_lang_scss_scoped_true_ = __webpack_require__("e677");

// CONCATENATED MODULE: ./src/components/menus/Link/LinkTitleMenu.vue






/* normalize component */

var LinkTitleMenu_component = normalizeComponent(
  Link_LinkTitleMenuvue_type_script_lang_ts_,
  LinkTitleMenuvue_type_template_id_bd0aa9ba_scoped_true_render,
  LinkTitleMenuvue_type_template_id_bd0aa9ba_scoped_true_staticRenderFns,
  false,
  null,
  "bd0aa9ba",
  null
  
)

/* harmony default export */ var Link_LinkTitleMenu = (LinkTitleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/AttachmentBubbleMenu.vue?vue&type=script&lang=ts&





















var AttachmentBubbleMenuvue_type_script_lang_ts_AttachmentBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(AttachmentBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(AttachmentBubbleMenu);

  function AttachmentBubbleMenu() {
    var _this;

    _classCallCheck(this, AttachmentBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", attachmentBubbleMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "typeNames", types_typeNames);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "createClickEvent", utils_createClickEvent);

    return _this;
  }

  _createClass(AttachmentBubbleMenu, [{
    key: "currentAttachmentAttributes",
    get: function get() {
      var _this$editor;

      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getAttributes("attachment")) || null;
    }
  }, {
    key: "attachmentTitle",
    get: function get() {
      var _ref = this.currentAttachmentAttributes || {},
          _ref$title = _ref.title,
          title = _ref$title === void 0 ? "" : _ref$title;

      return title;
    }
  }, {
    key: "isDefaultBlock",
    get: function get() {
      var _this$currentAttachme;

      return ((_this$currentAttachme = this.currentAttachmentAttributes) === null || _this$currentAttachme === void 0 ? void 0 : _this$currentAttachme.mode) === Mode.DEFAULT || false;
    }
  }, {
    key: "isInlineLink",
    get: function get() {
      var _this$currentAttachme2;

      return ((_this$currentAttachme2 = this.currentAttachmentAttributes) === null || _this$currentAttachme2 === void 0 ? void 0 : _this$currentAttachme2.mode) === Mode.INLINE || false;
    }
  }, {
    key: "isEmbed",
    get: function get() {
      var _this$currentAttachme3;

      return ((_this$currentAttachme3 = this.currentAttachmentAttributes) === null || _this$currentAttachme3 === void 0 ? void 0 : _this$currentAttachme3.mode) === Mode.EMBED || false;
    }
  }, {
    key: "isEmbeddable",
    get: function get() {
      var _ref2 = this.currentAttachmentAttributes || {},
          type = _ref2.type;

      if (type == null) {
        return false;
      }

      return [Type.PDF, Type.VIDEO, Type.SHEET, Type.DOC, Type.SLIDE].includes(type);
    }
  }, {
    key: "fileType",
    get: function get() {
      var attributes = this.currentAttachmentAttributes;

      if (attributes == null || attributes.type == null) {
        return null;
      }

      return attributes.type;
    }
  }, {
    key: "fileTypeName",
    get: function get() {
      var type = this.fileType,
          typeNames = this.typeNames;

      if (type == null) {
        return null;
      }

      return typeNames[type];
    }
  }, {
    key: "fileTypeFullName",
    get: function get() {
      var fileTypeName = this.fileTypeName;

      if (fileTypeName == null) {
        return "";
      }

      return this.$t("mayday-editor.menu.attachment.type.".concat(fileTypeName));
    }
  }, {
    key: "fileTypeIconClass",
    get: function get() {
      var fileTypeName = this.fileTypeName;
      var baseClass = "file-type-icon";

      var base = Object(defineProperty["a" /* default */])({}, baseClass, true);

      if (fileTypeName != null) {
        Object.assign(base, Object(defineProperty["a" /* default */])({}, "".concat(baseClass, "--").concat(fileTypeName), true));
      }

      return base;
    }
  }, {
    key: "fileTypeTestAttribute",
    get: function get() {
      var fileTypeName = this.fileTypeName;
      return fileTypeName != null ? "file-type-".concat(fileTypeName) : "";
    }
  }, {
    key: "setAsDefaultBlock",
    value: function setAsDefaultBlock() {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().setAttachmentAsDefault();
      this.setSelectionBack(chain);
    }
  }, {
    key: "setAsInlineLink",
    value: function setAsInlineLink() {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().setAttachmentAsInlineLink();
      this.setSelectionBack(chain);
    }
  }, {
    key: "setAsEmbed",
    value: function setAsEmbed() {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().setAttachmentAsEmbed();
      this.setSelectionBack(chain);
    }
  }, {
    key: "setSelectionBack",
    value: function setSelectionBack(command) {
      if (this.editor == null) {
        return;
      }

      var editor = this.editor;
      var state = editor.state;
      var pos = state.selection.$anchor.pos;

      if (command.run()) {
        editor.commands.setNodeSelection(pos);
      }
    }
  }, {
    key: "setAttachmentTitle",
    value: function setAttachmentTitle(title) {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().updateAttributes("attachment", {
        title: title
      });
      this.setSelectionBack(chain);
    }
  }, {
    key: "downloadAttachment",
    value: function downloadAttachment() {
      var _ref3 = this.currentAttachmentAttributes || {},
          href = _ref3.href;

      if (href == null || href.length === 0) {
        return;
      }

      var anchor = document.createElement("a");
      var event = this.createClickEvent();
      anchor.setAttribute("href", href);
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      anchor.dispatchEvent(event);
      document.body.removeChild(anchor);
    }
  }, {
    key: "deleteAttachment",
    value: function deleteAttachment() {
      if (this.editor == null) {
        return;
      }

      this.editor.chain().focus().deleteAttachment().run();
    }
  }]);

  return AttachmentBubbleMenu;
}(Bubble_BaseBubbleMenu);

AttachmentBubbleMenuvue_type_script_lang_ts_AttachmentBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    LinkTitleMenu: Link_LinkTitleMenu
  }
})], AttachmentBubbleMenuvue_type_script_lang_ts_AttachmentBubbleMenu);
/* harmony default export */ var AttachmentBubbleMenuvue_type_script_lang_ts_ = (AttachmentBubbleMenuvue_type_script_lang_ts_AttachmentBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/AttachmentBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_AttachmentBubbleMenuvue_type_script_lang_ts_ = (AttachmentBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/AttachmentBubbleMenu.vue?vue&type=style&index=0&id=5002d41a&lang=scss&scoped=true&
var AttachmentBubbleMenuvue_type_style_index_0_id_5002d41a_lang_scss_scoped_true_ = __webpack_require__("aa24");

// CONCATENATED MODULE: ./src/components/menus/Bubble/AttachmentBubbleMenu.vue






/* normalize component */

var AttachmentBubbleMenu_component = normalizeComponent(
  Bubble_AttachmentBubbleMenuvue_type_script_lang_ts_,
  AttachmentBubbleMenuvue_type_template_id_5002d41a_scoped_true_render,
  AttachmentBubbleMenuvue_type_template_id_5002d41a_scoped_true_staticRenderFns,
  false,
  null,
  "5002d41a",
  null
  
)

/* harmony default export */ var Bubble_AttachmentBubbleMenu = (AttachmentBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/InlineBubbleMenu.vue?vue&type=template&id=6b46fe68&scoped=true&
var InlineBubbleMenuvue_type_template_id_6b46fe68_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.baseClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.setAsDefault,"is-active":_vm.isDefault,"icon":"bookmark","tooltip-content":_vm.$t('mayday-editor.menu.inline-content.tooltip.set-as-default'),"disabled":_vm.isDefault},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),_c('CommandButton',{attrs:{"command":_vm.setAsLink,"is-active":_vm.isLink,"icon":"link","tooltip-content":_vm.$t('mayday-editor.menu.inline-content.tooltip.set-as-link'),"disabled":_vm.isLink},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),(!_vm.isMaydayCase)?_c('CommandButton',{attrs:{"command":_vm.setAsEmbed,"is-active":_vm.isEmbed,"icon":"window","tooltip-content":_vm.$t('mayday-editor.menu.inline-content.tooltip.set-as-embed'),"disabled":_vm.isEmbed},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e()],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.openLink,"command-ctrl":function () { return _vm.openLink(true); },"icon":"external-link","tooltip-content":_vm.$t('mayday-editor.menu.inline-content.tooltip.open-link')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.deleteInlineContent,"icon":"trash","icon-hover-type":"error","tooltip-content":_vm.$t('mayday-editor.menu.inline-content.tooltip.delete')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1)])}
var InlineBubbleMenuvue_type_template_id_6b46fe68_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/InlineBubbleMenu.vue?vue&type=template&id=6b46fe68&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/InlineBubbleMenu.vue?vue&type=script&lang=ts&















var InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(InlineBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(InlineBubbleMenu);

  function InlineBubbleMenu() {
    var _this;

    _classCallCheck(this, InlineBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", inlineBubbleMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "subdomain", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isParametric", void 0);

    return _this;
  }

  _createClass(InlineBubbleMenu, [{
    key: "currentInlineContentAttributes",
    get: function get() {
      var _this$editor;

      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getAttributes("inlineContent")) || null;
    }
  }, {
    key: "isDefault",
    get: function get() {
      var _this$currentInlineCo;

      return ((_this$currentInlineCo = this.currentInlineContentAttributes) === null || _this$currentInlineCo === void 0 ? void 0 : _this$currentInlineCo.mode) === InlineContent_Mode.DEFAULT || false;
    }
  }, {
    key: "isLink",
    get: function get() {
      var _this$currentInlineCo2;

      return ((_this$currentInlineCo2 = this.currentInlineContentAttributes) === null || _this$currentInlineCo2 === void 0 ? void 0 : _this$currentInlineCo2.mode) === InlineContent_Mode.LINK || false;
    }
  }, {
    key: "isEmbed",
    get: function get() {
      var _this$currentInlineCo3;

      return ((_this$currentInlineCo3 = this.currentInlineContentAttributes) === null || _this$currentInlineCo3 === void 0 ? void 0 : _this$currentInlineCo3.mode) === InlineContent_Mode.EMBED || false;
    }
  }, {
    key: "isMaydayCase",
    get: function get() {
      var _this$currentInlineCo4;

      return ((_this$currentInlineCo4 = this.currentInlineContentAttributes) === null || _this$currentInlineCo4 === void 0 ? void 0 : _this$currentInlineCo4.nodeType) === "Case";
    }
  }, {
    key: "nodeId",
    get: function get() {
      var _this$currentInlineCo5;

      return ((_this$currentInlineCo5 = this.currentInlineContentAttributes) === null || _this$currentInlineCo5 === void 0 ? void 0 : _this$currentInlineCo5.nodeId) || "";
    }
  }, {
    key: "lang",
    get: function get() {
      var _this$currentInlineCo6;

      return ((_this$currentInlineCo6 = this.currentInlineContentAttributes) === null || _this$currentInlineCo6 === void 0 ? void 0 : _this$currentInlineCo6.lang) || "default";
    }
  }, {
    key: "openLink",
    value: function openLink(newTab) {
      var _this$currentInlineCo7;

      this.$parent.$emit("click:inline-content", {
        id: this.nodeId,
        lang: this.lang,
        type: (_this$currentInlineCo7 = this.currentInlineContentAttributes) === null || _this$currentInlineCo7 === void 0 ? void 0 : _this$currentInlineCo7.nodeType,
        newTab: newTab
      });
    }
  }, {
    key: "setAsDefault",
    value: function setAsDefault() {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().setInlineContentAsDefault();
      this.setSelectionBack(chain);
    }
  }, {
    key: "setAsLink",
    value: function setAsLink() {
      if (this.editor == null) {
        return;
      }

      var chain = this.editor.chain().focus().setInlineContentAsLink("".concat(this.subdomain, "/").concat(this.isParametric ? "parametric/" : "", "desk/").concat(this.lang, "/").concat(this.isMaydayCase ? "cases" : "contents", "/").concat(this.nodeId));
      this.setSelectionBack(chain);
    }
  }, {
    key: "getInlineContentNodeRange",
    value: function getInlineContentNodeRange(editor) {
      var state = editor.state;
      var selection = state.selection;
      var $from = selection.$from,
          $to = selection.$to;
      var from = $from.pos;
      var to = $to.pos;
      state.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        if (node.type.name === "inlineContent") {
          from = pos;
          to = pos + node.nodeSize;
        }
      });
      return from === to ? null : {
        from: from,
        to: to
      };
    }
  }, {
    key: "setAsEmbed",
    value: function setAsEmbed() {
      if (this.editor == null) {
        return;
      }

      var range = this.getInlineContentNodeRange(this.editor);

      if (!range) {
        return;
      }

      var from = range.from;
      var subdomain = this.subdomain,
          isParametric = this.isParametric;
      var type = isParametric ? "desk/parametric/" : "desk/";
      var lang = this.lang ? "/".concat(this.lang) : "";
      var src = "".concat(subdomain, "/desk/embed").concat(lang, "/contents/").concat(this.nodeId);
      var href = "".concat(subdomain, "/").concat(type).concat(this.lang, "/contents/").concat(this.nodeId);
      this.editor.chain().focus().deleteRange(range).insertContentAt(from, {
        type: "embed",
        attrs: {
          src: src,
          href: href
        }
      }).run();
    }
  }, {
    key: "setSelectionBack",
    value: function setSelectionBack(command) {
      if (this.editor == null) {
        return;
      }

      var editor = this.editor;
      var state = editor.state;
      var pos = state.selection.$anchor.pos;

      if (command.run()) {
        editor.commands.setTextSelection(pos);
      }
    }
  }, {
    key: "deleteInlineContent",
    value: function deleteInlineContent() {
      if (this.editor == null) {
        return;
      }

      this.editor.chain().focus().deleteInlineContent().run();
    }
  }]);

  return InlineBubbleMenu;
}(Bubble_BaseBubbleMenu);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String
}), __metadata("design:type", String)], InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu.prototype, "subdomain", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Boolean
}), __metadata("design:type", Boolean)], InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu.prototype, "isParametric", void 0);

InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({})], InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu);
/* harmony default export */ var InlineBubbleMenuvue_type_script_lang_ts_ = (InlineBubbleMenuvue_type_script_lang_ts_InlineBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/InlineBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_InlineBubbleMenuvue_type_script_lang_ts_ = (InlineBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/InlineBubbleMenu.vue?vue&type=style&index=0&id=6b46fe68&lang=scss&scoped=true&
var InlineBubbleMenuvue_type_style_index_0_id_6b46fe68_lang_scss_scoped_true_ = __webpack_require__("0323");

// CONCATENATED MODULE: ./src/components/menus/Bubble/InlineBubbleMenu.vue






/* normalize component */

var InlineBubbleMenu_component = normalizeComponent(
  Bubble_InlineBubbleMenuvue_type_script_lang_ts_,
  InlineBubbleMenuvue_type_template_id_6b46fe68_scoped_true_render,
  InlineBubbleMenuvue_type_template_id_6b46fe68_scoped_true_staticRenderFns,
  false,
  null,
  "6b46fe68",
  null
  
)

/* harmony default export */ var Bubble_InlineBubbleMenu = (InlineBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/LinkBubbleMenu.vue?vue&type=template&id=4d3ca2c4&scoped=true&
var LinkBubbleMenuvue_type_template_id_4d3ca2c4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.baseClass,staticStyle:{"visibility":"hidden"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLinkActive),expression:"isLinkActive"}],class:(_vm.baseClass + "__commands-container")},[_c('LinkMenu',{attrs:{"command":_vm.setLink,"is-active":_vm.isLinkActive,"current-link":_vm.currentLink,"tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.url')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"link-input-closed":_vm.focusLinkContent}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.openLinkOrEmbed,"icon":"external-link","tooltip-content":_vm.openTooltipContent},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLinkActive),expression:"isLinkActive"}],class:(_vm.baseClass + "__commands-container")},[_c('LinkTitleMenu',{attrs:{"command":_vm.setLinkTitle,"current-title":_vm.currentLinkTitle,"tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.title')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"link-title-input-closed":_vm.focusLinkContent}})],1),(
      _vm.options.richOptions && (_vm.isEmbeddable || _vm.isEmbedActive || _vm.isMaydayCase)
    )?_c('div',{staticClass:"is-embeddable",class:(_vm.baseClass + "__commands-container")},[(_vm.maydayId)?_c('CommandButton',{attrs:{"command":_vm.isEmbedActive ? _vm.transformEmbedIntoInline : _vm.transformLinkIntoInline,"icon":"bookmark","tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.make-inline')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e(),_c('CommandButton',{attrs:{"command":_vm.transformIntoLink,"is-active":_vm.isLinkActive && !_vm.isModalOpening,"icon":"link","tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.make-link'),"disabled":_vm.isLinkActive && !_vm.isModalOpening},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}),(!_vm.isMaydayCase && !_vm.isMaydayOldLink)?_c('CommandButton',{attrs:{"command":_vm.transformLinkIntoEmbed,"is-active":_vm.isEmbedActive,"icon":"window","tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.make-embed'),"disabled":_vm.isEmbedActive},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e(),(!_vm.maydayId)?_c('CommandButton',{attrs:{"command":_vm.transformIntoModalLink,"is-active":_vm.isModalOpening,"icon":"window-maximize","tooltip-content":_vm.$t('mayday-editor.menu.link.tooltip.open-in-modal'),"disabled":_vm.isModalOpening},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}}):_vm._e()],1):_vm._e(),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":_vm.removeLinkOrEmbed,"icon":_vm.isLinkActive ? 'unlink' : 'window-close',"icon-hover-type":"error","tooltip-content":_vm.removeTooltipContent},on:{"tooltip-created":_vm.addCommandButtonTippyInstance,"mouseenter":function () { return _vm.editor.commands.highlightEmbed(true); },"mouseleave":function () { return _vm.editor.commands.highlightEmbed(false); }}})],1)])}
var LinkBubbleMenuvue_type_template_id_4d3ca2c4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/LinkBubbleMenu.vue?vue&type=template&id=4d3ca2c4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/LinkBubbleMenu.vue?vue&type=script&lang=ts&
















var LinkBubbleMenuvue_type_script_lang_ts_a;











var LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(LinkBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(LinkBubbleMenu);

  function LinkBubbleMenu() {
    var _this;

    _classCallCheck(this, LinkBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "options", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "subdomain", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", linkBubbleMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "serviceEmbed", new ServiceEmbed_ServiceEmbed());

    return _this;
  }

  _createClass(LinkBubbleMenu, [{
    key: "isLinkActive",
    get: function get() {
      var _this$editor;

      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.isActive("link")) || false;
    }
  }, {
    key: "isEmbedActive",
    get: function get() {
      var _this$editor2;

      return ((_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.isActive("embed")) || false;
    }
  }, {
    key: "currentLink",
    get: function get() {
      var _this$editor3;

      return this.isLinkActive ? (_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.getAttributes("link").href : "";
    }
  }, {
    key: "currentEmbed",
    get: function get() {
      var _this$editor4;

      return this.isEmbedActive ? (_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.getAttributes("embed").src : "";
    }
  }, {
    key: "isModalOpening",
    get: function get() {
      var _this$editor5, _this$editor6;

      var isModalOpening = ((_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.getAttributes("link").isModalOpening) === "true" || ((_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.getAttributes("link").isModalOpening) === true;
      return this.isLinkActive ? isModalOpening : false;
    }
  }, {
    key: "currentLinkTitle",
    get: function get() {
      var _this2 = this;

      if (!this.isLinkActive || this.editor == null) {
        return "";
      }

      var selection = this.editor.state.selection;
      var $anchor = selection.$anchor;
      var parentNode = $anchor.node();
      var startPos = $anchor.start();
      var title = "";
      parentNode.descendants(function (node, position) {
        if (startPos + position + node.nodeSize < $anchor.pos) {
          return;
        }

        var matchingMark = node.marks.find(function (_ref) {
          var attrs = _ref.attrs;
          return attrs.href === _this2.currentLink;
        });

        if (matchingMark != null) {
          title = node.text || ""; // stop looping throught descendants

          return false;
        }
      });
      return title;
    }
  }, {
    key: "isEmbeddable",
    get: function get() {
      var isLinkActive = this.isLinkActive,
          currentLink = this.currentLink,
          isEmbedActive = this.isEmbedActive;

      if (!isLinkActive && !isEmbedActive || !currentLink.length) {
        return false;
      }

      return isEmbedActive || this.serviceEmbed.find(currentLink, this.subdomain) != null;
    }
  }, {
    key: "openTooltipContent",
    get: function get() {
      var key = this.isLinkActive ? "open-link" : "open-embed";
      return this.$t("mayday-editor.menu.link.tooltip.".concat(key));
    }
  }, {
    key: "removeTooltipContent",
    get: function get() {
      var key = this.isLinkActive ? "remove-link" : "delete-embed";
      return this.$t("mayday-editor.menu.link.tooltip.".concat(key));
    }
  }, {
    key: "focusLinkContent",
    value: function focusLinkContent() {
      var _this$editor7;

      (_this$editor7 = this.editor) === null || _this$editor7 === void 0 ? void 0 : _this$editor7.commands.focus();
    } // set selection range to something containing all of the link mark

  }, {
    key: "getLinkExtendedMarRange",
    value: function getLinkExtendedMarRange(editor) {
      return editor.chain().focus().extendMarkRange("link", {
        href: this.currentLink
      });
    }
  }, {
    key: "setLink",
    value: function setLink(href, favicon) {
      if (this.editor == null || href.length === 0) {
        return false;
      }

      return this.getLinkExtendedMarRange(this.editor).setLink({
        href: href,
        favicon: favicon
      }).run();
    }
  }, {
    key: "openLinkOrEmbed",
    value: function openLinkOrEmbed() {
      var src = this.isLinkActive ? this.currentLink : this.currentEmbed;

      if (this.maydayId) {
        this.$parent.$emit("click:inline-content", {
          id: this.maydayId,
          lang: this.serviceEmbed.getMaydayLang(src),
          type: this.isMaydayCase ? "Case" : "Content"
        });
      } else {
        window.open(src, "_blank");
      }
    } // removes a link or delete an embed

  }, {
    key: "removeLinkOrEmbed",
    value: function removeLinkOrEmbed() {
      var _this$editor8;

      if (this.editor == null) {
        return false;
      }

      if (this.isLinkActive) {
        return this.getLinkExtendedMarRange(this.editor).unsetLink().run();
      }

      var start = this.editor.state.selection.from;
      return (_this$editor8 = this.editor) === null || _this$editor8 === void 0 ? void 0 : _this$editor8.chain().focus().deleteEmbed().setTextSelection(start).run();
    } // change text content containing the current link mark

  }, {
    key: "setLinkTitle",
    value: function setLinkTitle(title) {
      if (this.editor == null || title.length === 0) {
        return false;
      }

      return this.getLinkExtendedMarRange(this.editor).setLinkTitle(this.currentLink, title).run();
    }
  }, {
    key: "maydayId",
    get: function get() {
      var link = this.currentLink;

      if (this.isEmbedActive) {
        link = this.currentEmbed.replace("/embed", "");
      }

      return this.serviceEmbed.getInlineId(link);
    }
  }, {
    key: "isMaydayCase",
    get: function get() {
      return !!this.maydayId && this.currentLink.includes("/case");
    }
  }, {
    key: "isMaydayOldLink",
    get: function get() {
      return !!this.maydayId && this.currentLink.includes("/web/");
    }
  }, {
    key: "inlineContent",
    get: function get() {
      var link = this.isEmbedActive ? this.currentEmbed : this.currentLink;
      return {
        type: "inlineContent",
        attrs: {
          nodeId: this.maydayId,
          nodeType: this.isMaydayCase ? "Case" : "Content",
          lang: this.serviceEmbed.getMaydayLang(link)
        }
      };
    }
  }, {
    key: "transformLinkIntoInline",
    value: function transformLinkIntoInline() {
      var _this3 = this;

      if (!this.editor) return false;
      var state = this.editor.state;
      var _state$selection = state.selection,
          from = _state$selection.from,
          to = _state$selection.to;
      var linkMark = state.schema.marks.link;
      state.doc.nodesBetween(from, to, function (node, pos) {
        if (node.isText && node.marks.some(function (mark) {
          return mark.type === linkMark;
        })) {
          var _this3$editor;

          (_this3$editor = _this3.editor) === null || _this3$editor === void 0 ? void 0 : _this3$editor.chain().focus().deleteRange({
            from: pos,
            to: pos + node.nodeSize
          }).insertContentAt(pos, [_this3.inlineContent, {
            type: "text",
            text: " "
          }]).run();
        }
      });
      return true;
    }
  }, {
    key: "transformEmbedIntoInline",
    value: function transformEmbedIntoInline() {
      var _this4 = this;

      if (!this.editor) return false;
      var state = this.editor.state;
      var _state$selection2 = state.selection,
          from = _state$selection2.from,
          to = _state$selection2.to;
      state.doc.nodesBetween(from, to, function (node, pos) {
        if (node.type.name === "embed") {
          var _this4$editor;

          (_this4$editor = _this4.editor) === null || _this4$editor === void 0 ? void 0 : _this4$editor.chain().focus().deleteRange({
            from: pos,
            to: pos + node.nodeSize
          }).insertContentAt(pos, _this4.inlineContent).run();
        }
      });
      return true;
    } // replace current text with a link mark with an embed node

  }, {
    key: "transformLinkIntoEmbed",
    value: function transformLinkIntoEmbed() {
      if (this.editor == null) {
        return false;
      } // modal opening already host embed url


      var src = this.isModalOpening ? this.currentLink : this.serviceEmbed.generate(this.currentLink, this.subdomain, this.maydayId);

      if (src == null) {
        return false;
      }

      return this.getLinkExtendedMarRange(this.editor).deleteSelection().setEmbed({
        src: src
      }).selectNodeBackward().run();
    } // transform text content/embed node into a text content with link mark
    // activates openInModal attribute

  }, {
    key: "transformIntoModalLink",
    value: function transformIntoModalLink() {
      if (this.editor == null) {
        return false;
      }

      if (this.isEmbedActive) {
        this.transformIntoLink(undefined, true);
        return this.editor.commands.updateAttributes("link", {
          isModalOpening: true
        });
      } // already a link => just update attributes


      return this.getLinkExtendedMarRange(this.editor).updateAttributes("link", {
        isModalOpening: true,
        // modal should open with embed URL
        href: this.serviceEmbed.generate(this.currentLink, this.subdomain)
      }).run();
    } // transform text content/embed node into a text content with link mark

  }, {
    key: "transformIntoLink",
    value: function transformIntoLink(event) {
      var willBeModalLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.editor == null || !this.isEmbedActive && !this.isModalOpening) {
        return false;
      }

      var link = this.maydayId ? this.currentEmbed : this.currentLink;

      if (this.isModalOpening) {
        return this.getLinkExtendedMarRange(this.editor).updateAttributes("link", {
          isModalOpening: false,
          href: this.serviceEmbed.turnBack(link)
        }).run();
      }

      var pos = this.editor.state.selection.from;
      var href = willBeModalLink ? this.currentEmbed : this.serviceEmbed.turnBack(this.currentEmbed) || this.currentEmbed;
      return this.editor.chain().focus().insertContent({
        type: "text",
        text: href,
        marks: [{
          type: "link",
          attrs: {
            href: href
          }
        }]
      }).setTextSelection({
        from: pos,
        to: pos + href.length + 1
      }).run();
    }
  }]);

  return LinkBubbleMenu;
}(Bubble_BaseBubbleMenu);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Object
}), __metadata("design:type", typeof (LinkBubbleMenuvue_type_script_lang_ts_a = typeof /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined !== "undefined" && /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined) === "function" ? LinkBubbleMenuvue_type_script_lang_ts_a : Object)], LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu.prototype, "options", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String
}), __metadata("design:type", String)], LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu.prototype, "subdomain", void 0);

LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    LinkMenu: Link_LinkMenu,
    LinkTitleMenu: Link_LinkTitleMenu
  }
})], LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu);
/* harmony default export */ var LinkBubbleMenuvue_type_script_lang_ts_ = (LinkBubbleMenuvue_type_script_lang_ts_LinkBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/LinkBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_LinkBubbleMenuvue_type_script_lang_ts_ = (LinkBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/LinkBubbleMenu.vue?vue&type=style&index=0&id=4d3ca2c4&lang=scss&scoped=true&
var LinkBubbleMenuvue_type_style_index_0_id_4d3ca2c4_lang_scss_scoped_true_ = __webpack_require__("de2a");

// CONCATENATED MODULE: ./src/components/menus/Bubble/LinkBubbleMenu.vue






/* normalize component */

var LinkBubbleMenu_component = normalizeComponent(
  Bubble_LinkBubbleMenuvue_type_script_lang_ts_,
  LinkBubbleMenuvue_type_template_id_4d3ca2c4_scoped_true_render,
  LinkBubbleMenuvue_type_template_id_4d3ca2c4_scoped_true_staticRenderFns,
  false,
  null,
  "4d3ca2c4",
  null
  
)

/* harmony default export */ var Bubble_LinkBubbleMenu = (LinkBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/ImageBubbleMenu.vue?vue&type=template&id=4bbd8443&scoped=true&
var ImageBubbleMenuvue_type_template_id_4bbd8443_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.baseClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('ImageAltMenu',{attrs:{"command":_vm.setAltAttribute,"current-alt":_vm.currentAlt,"tooltip-content":_vm.$t('mayday-editor.menu.image.alt-tooltip')},on:{"tooltip-created":_vm.addCommandButtonTippyInstance}})],1),_c('div',{class:(_vm.baseClass + "__commands-container")},[_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('left').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'left' }),"icon":"align-left","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-left')}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('center').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'center' }),"icon":"align-center","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-center')}}),_c('CommandButton',{attrs:{"command":function () { return _vm.editor.chain().focus().setTextAlign('right').run(); },"is-active":_vm.computeCommandIsActive({ textAlign: 'right' }),"icon":"align-right","tooltip-content":_vm.$t('mayday-editor.menu.text-selection.tooltip.align-right')}})],1)])}
var ImageBubbleMenuvue_type_template_id_4bbd8443_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/Bubble/ImageBubbleMenu.vue?vue&type=template&id=4bbd8443&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/ImageAltMenu.vue?vue&type=template&id=7fa98356&scoped=true&
var ImageAltMenuvue_type_template_id_7fa98356_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayday-editor__image-alt-menu"},[_c('CommandButton',{attrs:{"command":_vm.toggleImageAltInput,"isActive":_vm.isInputOpened,"text":"Alt","tooltip-content":_vm.tooltipContent},on:{"tooltip-created":function($event){return _vm.$emit('tooltip-created', $event)}}}),(_vm.isInputOpened)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.alt),expression:"alt"}],ref:"imageAltInput",staticClass:"image-input",class:_vm.inputClass,attrs:{"type":"text","disabled":_vm.isHandlingAlt,"placeholder":_vm.$t('mayday-editor.menu.image.alt-placeholder')},domProps:{"value":(_vm.alt)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleImageAltCommand.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelAltChange.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.alt=$event.target.value}}}):_vm._e()],1)}
var ImageAltMenuvue_type_template_id_7fa98356_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/ImageAltMenu.vue?vue&type=template&id=7fa98356&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/ImageAltMenu.vue?vue&type=script&lang=ts&
















var ImageAltMenuvue_type_script_lang_ts_ImageAltMenu = /*#__PURE__*/function (_Vue) {
  _inherits(ImageAltMenu, _Vue);

  var _super = _createSuper(ImageAltMenu);

  function ImageAltMenu() {
    var _this;

    _classCallCheck(this, ImageAltMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "command", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "tooltipContent", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "currentAlt", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "alt", "");

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isInputOpened", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isClosingInput", false);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isHandlingAlt", false);

    return _this;
  }

  _createClass(ImageAltMenu, [{
    key: "inputClass",
    get: function get() {
      var isClosingInput = this.isClosingInput;
      return {
        "is-closing": isClosingInput
      };
    }
  }, {
    key: "handleCurrentAltChanged",
    value: function handleCurrentAltChanged(alt) {
      this.alt = alt;
    }
  }, {
    key: "toggleImageAltInput",
    value: function () {
      var _toggleImageAltInput = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isInputOpened) {
                  _context.next = 14;
                  break;
                }

                this.isClosingInput = true;
                _context.prev = 2;
                _context.next = 5;
                return this.handleClosingInput();

              case 5:
                this.isClosingInput = false;
                _context.next = 8;
                return this.$nextTick();

              case 8:
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                _context.next = 14;
                return this.$nextTick();

              case 14:
                this.isInputOpened = !this.isInputOpened; // autofocus

                if (!this.isInputOpened) {
                  _context.next = 19;
                  break;
                }

                _context.next = 18;
                return this.$nextTick();

              case 18:
                this.$refs.imageAltInput.focus();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function toggleImageAltInput() {
        return _toggleImageAltInput.apply(this, arguments);
      }

      return toggleImageAltInput;
    }()
  }, {
    key: "handleClosingInput",
    value: function handleClosingInput() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var _this2$$refs$imageAlt;

        (_this2$$refs$imageAlt = _this2.$refs.imageAltInput) === null || _this2$$refs$imageAlt === void 0 ? void 0 : _this2$$refs$imageAlt.addEventListener("animationend", function () {
          resolve();
        }); // animation is 200ms
        // rejecting just in case handler isn't bounded / triggered for some reason

        window.setTimeout(function () {
          return reject();
        }, 300);
      });
    }
  }, {
    key: "handleImageAltCommand",
    value: function () {
      var _handleImageAltCommand = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isHandlingAlt = true;
                _context2.next = 3;
                return this.$nextTick();

              case 3:
                this.command(this.alt);
                this.isHandlingAlt = false;
                this.toggleImageAltInput();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleImageAltCommand() {
        return _handleImageAltCommand.apply(this, arguments);
      }

      return handleImageAltCommand;
    }()
  }, {
    key: "cancelAltChange",
    value: function cancelAltChange() {
      this.handleCurrentAltChanged(this.currentAlt);
      this.toggleImageAltInput();
    }
  }]);

  return ImageAltMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Function)], ImageAltMenuvue_type_script_lang_ts_ImageAltMenu.prototype, "command", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], ImageAltMenuvue_type_script_lang_ts_ImageAltMenu.prototype, "tooltipContent", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", String)], ImageAltMenuvue_type_script_lang_ts_ImageAltMenu.prototype, "currentAlt", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("currentAlt", {
  immediate: true
}), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], ImageAltMenuvue_type_script_lang_ts_ImageAltMenu.prototype, "handleCurrentAltChanged", null);

ImageAltMenuvue_type_script_lang_ts_ImageAltMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    CommandButton: menus_CommandButton
  }
})], ImageAltMenuvue_type_script_lang_ts_ImageAltMenu);
/* harmony default export */ var ImageAltMenuvue_type_script_lang_ts_ = (ImageAltMenuvue_type_script_lang_ts_ImageAltMenu);
// CONCATENATED MODULE: ./src/components/menus/ImageAltMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var menus_ImageAltMenuvue_type_script_lang_ts_ = (ImageAltMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/ImageAltMenu.vue?vue&type=style&index=0&id=7fa98356&lang=scss&scoped=true&
var ImageAltMenuvue_type_style_index_0_id_7fa98356_lang_scss_scoped_true_ = __webpack_require__("e217");

// CONCATENATED MODULE: ./src/components/menus/ImageAltMenu.vue






/* normalize component */

var ImageAltMenu_component = normalizeComponent(
  menus_ImageAltMenuvue_type_script_lang_ts_,
  ImageAltMenuvue_type_template_id_7fa98356_scoped_true_render,
  ImageAltMenuvue_type_template_id_7fa98356_scoped_true_staticRenderFns,
  false,
  null,
  "7fa98356",
  null
  
)

/* harmony default export */ var menus_ImageAltMenu = (ImageAltMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/Bubble/ImageBubbleMenu.vue?vue&type=script&lang=ts&















var ImageBubbleMenuvue_type_script_lang_ts_ImageBubbleMenu = /*#__PURE__*/function (_BaseBubbleMenu) {
  _inherits(ImageBubbleMenu, _BaseBubbleMenu);

  var _super = _createSuper(ImageBubbleMenu);

  function ImageBubbleMenu() {
    var _this;

    _classCallCheck(this, ImageBubbleMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "baseClass", imageBubbleMenuClass);

    return _this;
  }

  _createClass(ImageBubbleMenu, [{
    key: "currentImage",
    get: function get() {
      var _this$editor;

      return (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getAttributes("image").src;
    }
  }, {
    key: "currentTextAlign",
    get: function get() {
      var _this$editor2;

      return (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.getAttributes("textalign").src;
    }
  }, {
    key: "currentAlt",
    get: function get() {
      var _this2 = this;

      if (!this.currentImage || this.editor == null) {
        return "";
      }

      var selection = this.editor.state.selection;
      var $anchor = selection.$anchor;
      var parentNode = $anchor.node();
      var startPos = $anchor.start();
      var alt = "";
      parentNode.descendants(function (node, position) {
        if (startPos + position + node.nodeSize < $anchor.pos) {
          return;
        }

        if (node.attrs.src === _this2.currentImage) {
          alt = node.attrs.alt;
          return false;
        }
      });
      return alt;
    }
  }, {
    key: "setAltAttribute",
    value: function setAltAttribute(alt) {
      if (this.editor == null) {
        return false;
      }

      this.editor.chain().focus().setAlt(alt).run();
      return true;
    }
  }, {
    key: "computeCommandIsActive",
    value: function computeCommandIsActive(nodeOrMarkNameOrAttributes, attributes) {
      // `editor` is undefined before parent component mounted hook run
      if (this.editor == null) {
        return false;
      }

      return typeof nodeOrMarkNameOrAttributes === "string" ? this.editor.isActive(nodeOrMarkNameOrAttributes, attributes) : this.editor.isActive(nodeOrMarkNameOrAttributes); // only attributes as first parameter
    }
  }]);

  return ImageBubbleMenu;
}(Bubble_BaseBubbleMenu);

ImageBubbleMenuvue_type_script_lang_ts_ImageBubbleMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    ImageAltMenu: menus_ImageAltMenu,
    CommandButton: menus_CommandButton
  }
})], ImageBubbleMenuvue_type_script_lang_ts_ImageBubbleMenu);
/* harmony default export */ var ImageBubbleMenuvue_type_script_lang_ts_ = (ImageBubbleMenuvue_type_script_lang_ts_ImageBubbleMenu);
// CONCATENATED MODULE: ./src/components/menus/Bubble/ImageBubbleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Bubble_ImageBubbleMenuvue_type_script_lang_ts_ = (ImageBubbleMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/Bubble/ImageBubbleMenu.vue?vue&type=style&index=0&id=4bbd8443&lang=scss&scoped=true&
var ImageBubbleMenuvue_type_style_index_0_id_4bbd8443_lang_scss_scoped_true_ = __webpack_require__("52dc");

// CONCATENATED MODULE: ./src/components/menus/Bubble/ImageBubbleMenu.vue






/* normalize component */

var ImageBubbleMenu_component = normalizeComponent(
  Bubble_ImageBubbleMenuvue_type_script_lang_ts_,
  ImageBubbleMenuvue_type_template_id_4bbd8443_scoped_true_render,
  ImageBubbleMenuvue_type_template_id_4bbd8443_scoped_true_staticRenderFns,
  false,
  null,
  "4bbd8443",
  null
  
)

/* harmony default export */ var Bubble_ImageBubbleMenu = (ImageBubbleMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4ba04716-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/CellMenu.vue?vue&type=template&id=4609cdc8&scoped=true&
var CellMenuvue_type_template_id_4609cdc8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cellMenuClass,staticStyle:{"visibility":"hidden"}},[_c('div',{class:(_vm.cellMenuClass + "__commands-container")},[_c('div',{ref:"colorPickerCommandButton",class:(_vm.cellMenuClass + "__commands-container__command-button")},[_c('div',{staticClass:"color-preview",class:_vm.isDefaultColor ? 'is-default' : '',style:(_vm.currentColorStyle)}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.color")))])])]),(_vm.canMergeOrSplit)?_c('div',{staticClass:"split-merge-command-container",class:(_vm.cellMenuClass + "__commands-container")},[(_vm.canMergeCells)?_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().mergeCells().run()}}},[_c('i',{staticClass:"icon icon-merge-cells",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.merge-cells")))])]):_vm._e(),(_vm.canSplitCell)?_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().splitCell().run()}}},[_c('i',{staticClass:"icon icon-split-cell",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.split-cell")))])]):_vm._e()]):_vm._e(),_c('div',{class:(_vm.cellMenuClass + "__commands-container")},[_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().addRowBefore().run()},"mouseenter":function($event){return _vm.editor.commands.highlightRowBefore(true)},"mouseleave":function($event){return _vm.editor.commands.highlightRowBefore(false)}}},[_c('i',{staticClass:"icon icon-add-row-before",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.add-row-before")))])]),_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().addRowAfter().run()},"mouseenter":function($event){return _vm.editor.commands.highlightRowAfter(true)},"mouseleave":function($event){return _vm.editor.commands.highlightRowAfter(false)}}},[_c('i',{staticClass:"icon icon-add-row-after",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.add-row-after")))])]),_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().addColumnBefore().run()},"mouseenter":function($event){return _vm.editor.commands.highlightColumnBefore(true)},"mouseleave":function($event){return _vm.editor.commands.highlightColumnBefore(false)}}},[_c('i',{staticClass:"icon icon-add-column-before",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.add-column-before")))])]),_c('div',{class:(_vm.cellMenuClass + "__commands-container__command-button"),on:{"click":function($event){_vm.editor.chain().focus().addColumnAfter().run()},"mouseenter":function($event){return _vm.editor.commands.highlightColumnAfter(true)},"mouseleave":function($event){return _vm.editor.commands.highlightColumnAfter(false)}}},[_c('i',{staticClass:"icon icon-add-column-after",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$t("mayday-editor.menu.cell.add-column-after")))])])]),_c('div',{class:(_vm.cellMenuClass + "__commands-container")},[_c('div',{class:_vm.selectionCommandButtonClass,on:{"click":function($event){_vm.editor.chain().focus().deleteRow().run()},"mouseenter":function($event){return _vm.editor.commands.highlightTableRows(true)},"mouseleave":function($event){return _vm.editor.commands.highlightTableRows(false)}}},[_c('i',{staticClass:"icon icon-delete-row",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$tc( "mayday-editor.menu.cell.delete-row", Number(_vm.isCellSelection) )))])]),_c('div',{class:_vm.selectionCommandButtonClass,on:{"click":function($event){_vm.editor.chain().focus().deleteColumn().run()}}},[_c('i',{staticClass:"icon icon-delete-column",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"command-label"},[_vm._v(_vm._s(this.$tc( "mayday-editor.menu.cell.delete-column", Number(_vm.isCellSelection) )))])])]),_c('ColorPicker',{ref:"colorPicker",staticStyle:{"display":"none"},attrs:{"editor":_vm.editor,"usage":"tableCell","is-active":_vm.isColorActive},on:{"color-chosen":_vm.handleColorChosen}})],1)}
var CellMenuvue_type_template_id_4609cdc8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menus/CellMenu.vue?vue&type=template&id=4609cdc8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menus/CellMenu.vue?vue&type=script&lang=ts&















var CellMenuvue_type_script_lang_ts_CellMenu = /*#__PURE__*/function (_Vue) {
  _inherits(CellMenu, _Vue);

  var _super = _createSuper(CellMenu);

  function CellMenu() {
    var _this;

    _classCallCheck(this, CellMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "cellMenuClass", cellMenuClass);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "selectionCommandButtonClass", Object(defineProperty["a" /* default */])({}, "".concat(cellMenuClass, "__commands-container__command-button"), true));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "colorPickerTippyInstance", null);

    return _this;
  }

  _createClass(CellMenu, [{
    key: "currentCellAttributes",
    get: // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function get() {
      var _this$editor;

      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getAttributes("tableCell")) || {};
    }
  }, {
    key: "currentColorStyle",
    get: function get() {
      var _this$currentCellAttr = this.currentCellAttributes.backgroundColor,
          backgroundColor = _this$currentCellAttr === void 0 ? null : _this$currentCellAttr;
      return {
        backgroundColor: backgroundColor
      };
    }
  }, {
    key: "isDefaultColor",
    get: function get() {
      return this.currentColorStyle.backgroundColor === null;
    }
  }, {
    key: "canMergeOrSplit",
    get: function get() {
      var _this$editor2;

      return ((_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.can().mergeOrSplit()) || false;
    }
  }, {
    key: "canMergeCells",
    get: function get() {
      var _this$editor3;

      return ((_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.can().mergeCells()) || false;
    }
  }, {
    key: "canSplitCell",
    get: function get() {
      var _this$editor4;

      return ((_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.can().splitCell()) || false;
    }
  }, {
    key: "isCellSelection",
    get: function get() {
      var _this$editor5;

      var _ref = ((_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.state) || {},
          selection = _ref.selection;

      return selection != null && isCellSelection_isCellSelection(selection);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$$refs = this.$refs,
          colorPickerCommandButton = _this$$refs.colorPickerCommandButton,
          colorPicker = _this$$refs.colorPicker;
      var colorPickerEl = colorPicker.$el;
      this.colorPickerTippyInstance = tippy_esm(colorPickerCommandButton, {
        trigger: "click",
        animation: "perspective-subtle",
        theme: "bubble-menu",
        maxWidth: "none",
        arrow: false,
        interactive: true,
        content: colorPickerEl
      });
      colorPickerEl.style.removeProperty("display"); // box shadow may mask cell color after command

      colorPickerEl.style.boxShadow = "none";
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var _this$colorPickerTipp;

      (_this$colorPickerTipp = this.colorPickerTippyInstance) === null || _this$colorPickerTipp === void 0 ? void 0 : _this$colorPickerTipp.destroy();
    }
  }, {
    key: "handleSelectionChanged",
    value: function handleSelectionChanged(now, before) {
      if (now && before === false) {
        this.selectionCommandButtonClass["selection-changed"] = true;
      } else {
        this.selectionCommandButtonClass["selection-changed"] = false;
      }
    }
  }, {
    key: "isColorActive",
    value: function isColorActive(color) {
      return this.currentCellAttributes.backgroundColor === color;
    }
  }, {
    key: "handleColorChosen",
    value: function handleColorChosen(_ref2) {
      var _this$editor6;

      var color = _ref2.color;
      var finalColor = !this.isColorActive(color) ? color : null;
      (_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.chain().focus().setCellAttribute("backgroundColor", finalColor).run();
    }
  }]);

  return CellMenu;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])(), __metadata("design:type", Object)], CellMenuvue_type_script_lang_ts_CellMenu.prototype, "editor", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("isCellSelection"), __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean, Boolean]), __metadata("design:returntype", void 0)], CellMenuvue_type_script_lang_ts_CellMenu.prototype, "handleSelectionChanged", null);

CellMenuvue_type_script_lang_ts_CellMenu = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    ColorPicker: menus_ColorPicker
  }
})], CellMenuvue_type_script_lang_ts_CellMenu);
/* harmony default export */ var CellMenuvue_type_script_lang_ts_ = (CellMenuvue_type_script_lang_ts_CellMenu);
// CONCATENATED MODULE: ./src/components/menus/CellMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var menus_CellMenuvue_type_script_lang_ts_ = (CellMenuvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/menus/CellMenu.vue?vue&type=style&index=0&id=4609cdc8&lang=scss&scoped=true&
var CellMenuvue_type_style_index_0_id_4609cdc8_lang_scss_scoped_true_ = __webpack_require__("766f");

// CONCATENATED MODULE: ./src/components/menus/CellMenu.vue






/* normalize component */

var CellMenu_component = normalizeComponent(
  menus_CellMenuvue_type_script_lang_ts_,
  CellMenuvue_type_template_id_4609cdc8_scoped_true_render,
  CellMenuvue_type_template_id_4609cdc8_scoped_true_staticRenderFns,
  false,
  null,
  "4609cdc8",
  null
  
)

/* harmony default export */ var menus_CellMenu = (CellMenu_component.exports);
// CONCATENATED MODULE: ./src/extensions/NodeDrag/NodeDragPlugin.ts





var NodeDragPlugin_createPlugin = function createPlugin(editor) {
  var nodeToBeDragged = null;
  var isDraggingTable = false;
  var oldTableMeta = null;
  var dragHandle = helpers_createComponentHandle(editor);
  var dragHandleElement = dragHandle.element;

  var dragStart = function dragStart(event, view) {
    var _nodeToBeDragged, _nodeToBeDragged$attr, _nodeToBeDragged$attr2;

    if (!event.dataTransfer) return;
    if (((_nodeToBeDragged = nodeToBeDragged) === null || _nodeToBeDragged === void 0 ? void 0 : (_nodeToBeDragged$attr = _nodeToBeDragged.attributes) === null || _nodeToBeDragged$attr === void 0 ? void 0 : (_nodeToBeDragged$attr2 = _nodeToBeDragged$attr.getNamedItem("draggable")) === null || _nodeToBeDragged$attr2 === void 0 ? void 0 : _nodeToBeDragged$attr2.value) === "false") return;
    var coords = {
      left: event.clientX + HANDLER_GAP,
      top: event.clientY
    };
    var pos = blockPosAtCoords(coords, view);

    if (pos != null && nodeToBeDragged != null) {
      var state = view.state,
          dispatch = view.dispatch;
      dispatch(state.tr.setSelection(index_es_NodeSelection.create(state.doc, pos)));
      var slice = view.state.selection.content();
      isDraggingTable = isCellSelection_isCellSelection(view.state.selection);
      oldTableMeta = isDraggingTable ? computeOldTableMeta(view, nodeToBeDragged) : null;
      event.dataTransfer.clearData();
      event.dataTransfer.setDragImage(nodeToBeDragged, 10, 10);
      view.dragging = {
        slice: slice,
        move: true
      };
    }
  };

  var handleDragStart = function handleDragStart(view) {
    return function (event) {
      return dragStart(event, view);
    };
  };

  var bindEventsToDragHandle = function bindEventsToDragHandle(view) {
    var _editor$view$dom$pare, _editor$view$dom$pare2;

    var dragIcon = dragHandleElement.firstElementChild;
    dragIcon === null || dragIcon === void 0 ? void 0 : dragIcon.setAttribute("draggable", "true");
    dragIcon === null || dragIcon === void 0 ? void 0 : dragIcon.addEventListener("dragstart", handleDragStart(view));
    dragIcon === null || dragIcon === void 0 ? void 0 : dragIcon.addEventListener("dragend", function () {
      return helpers_replaceSelection(view);
    });
    (_editor$view$dom$pare = editor.view.dom.parentElement) === null || _editor$view$dom$pare === void 0 ? void 0 : (_editor$view$dom$pare2 = _editor$view$dom$pare.parentElement) === null || _editor$view$dom$pare2 === void 0 ? void 0 : _editor$view$dom$pare2.appendChild(dragHandleElement);
  };

  return new Plugin({
    key: new PluginKey("nodeDragHandler"),
    view: function view(editorView) {
      bindEventsToDragHandle(editorView);
      return {
        destroy: function destroy() {
          removeNode(dragHandleElement);
          dragHandle === null || dragHandle === void 0 ? void 0 : dragHandle.destroy();
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: function drop(view, event) {
          window.setTimeout(function () {
            // remove old table if a new one is in view
            if (isDraggingTable && oldTableMeta != null && tableHasBeenMoved(view, oldTableMeta)) {
              deleteOldTable(view, oldTableMeta, event);
              helpers_replaceSelection(view);
            }
          });
          hideDragHandle(dragHandleElement);
          return false;
        },
        mousemove: function mousemove(view, event) {
          var coords = {
            left: event.clientX + HANDLER_GAP,
            top: event.clientY
          };
          var position = view.posAtCoords(coords);
          var nodeDOM = position != null ? view.nodeDOM(position.inside) : null;
          isDraggingTable = false;

          if (position != null && helpers_nodeHasContent(view, position.inside) && nodeDOM != null) {
            nodeToBeDragged = getDirectChild(nodeDOM);

            if (nodeToBeDragged != null && !nodeToBeDragged.classList.contains("ProseMirror")) {
              var _editor$view$dom$pare3, _editor$view$dom$pare4;

              var rect = helpers_createRect(nodeToBeDragged, true);
              var editorRect = ((_editor$view$dom$pare3 = editor.view.dom.parentElement) === null || _editor$view$dom$pare3 === void 0 ? void 0 : (_editor$view$dom$pare4 = _editor$view$dom$pare3.parentElement) === null || _editor$view$dom$pare4 === void 0 ? void 0 : _editor$view$dom$pare4.getBoundingClientRect()) || {
                left: 0,
                top: 0
              };

              if (rect != null) {
                dragHandleElement.style.left = rect.left - editorRect.left - WIDTH - 10 + "px";
                dragHandleElement.style.top = rect.top - editorRect.top + 4 + "px";
                dragHandleElement.style.height = rect.height + "px";
                dragHandleElement.style.visibility = "visible";
                dragHandle.updateProps({
                  nodeDOM: nodeToBeDragged,
                  node: determineFirstLevelNode(view, nodeToBeDragged)
                });
              }
            } else {
              hideDragHandle(dragHandleElement);
            }
          } else {
            nodeToBeDragged = null;
            hideDragHandle(dragHandleElement);
          } // let prosemirror resume its normal operations
          // allow table resize to work


          return false;
        },
        keydown: function keydown() {
          hideDragHandle(dragHandleElement);
          return false;
        }
      }
    }
  });
};

/* harmony default export */ var NodeDragPlugin = (NodeDragPlugin_createPlugin);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--15-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--15-3!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MaydayEditor.vue?vue&type=script&lang=ts&









var MaydayEditorvue_type_script_lang_ts_a;






















var MaydayEditorvue_type_script_lang_ts_editorModule = bindings_namespace("mayday-editor");

var MaydayEditorvue_type_script_lang_ts_MaydayEditor = /*#__PURE__*/function (_Vue) {
  _inherits(MaydayEditor, _Vue);

  var _super = _createSuper(MaydayEditor);

  function MaydayEditor() {
    var _this;

    _classCallCheck(this, MaydayEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editable", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "options", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "placeholder", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isParametric", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "subdomain", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fetchInlineContentHandler", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "fetchInlineMentionHandler", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "generateTranslation", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "generateStyle", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "generateGrammar", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "$refs", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "content", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isLoading", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "isFileUploadCallbackProvided", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "nbFilesUploading", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "filesAreUploading", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "uploadFiles", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "searchInlineEntity", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "notifyUploadError", void 0);

    Object(defineProperty["a" /* default */])(_assertThisInitialized(_this), "editor", null);

    return _this;
  }

  _createClass(MaydayEditor, [{
    key: "menuOptions",
    get: function get() {
      if (!this.editable) return {};
      return this.options || {
        fontOptions: true,
        tableOptions: true,
        richOptions: true,
        allowSummary: false,
        allowTranslation: false,
        allowGrammarCorrection: false,
        allowToneImprovement: false
      };
    }
  }, {
    key: "parseStyleSize",
    value: function parseStyleSize(size) {
      return parseInt(size, 10);
    }
  }, {
    key: "isLoadingLabel",
    get: function get() {
      return this.filesAreUploading ? this.$i18n.tc("mayday-editor.file.uploading", this.nbFilesUploading) : "";
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initClient();
    }
  }, {
    key: "updateEditorEditable",
    value: function updateEditorEditable(now) {
      var _this$editor;

      (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.setEditable(now);

      if (now) {
        var _this$editor2;

        (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.registerPlugin(NodeDragPlugin(this.editor));
      } else {
        var _this$editor3;

        (_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.unregisterPlugin("nodeDragHandler");
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var _this$editor4, _this$editor5;

      (_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.unregisterPlugin("nodeDragHandler");
      (_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.destroy();
    }
  }, {
    key: "handleLinkModalOpening",
    value: function handleLinkModalOpening(link) {
      this.$emit("open-link-in-modal", link);
    }
  }, {
    key: "clearContent",
    value: function clearContent() {
      var _this$editor6;

      (_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.commands.clearContent(true);
    }
  }, {
    key: "insertMentions",
    value: function insertMentions() {
      var _this$editor7, _this$editor8;

      var input = "@";
      var hasText = (((_this$editor7 = this.editor) === null || _this$editor7 === void 0 ? void 0 : _this$editor7.getText().length) || 0) > 0;

      if (hasText) {
        input = " @";
      }

      (_this$editor8 = this.editor) === null || _this$editor8 === void 0 ? void 0 : _this$editor8.chain().focus().insertContent(input).run();
    }
  }, {
    key: "insertEmoji",
    value: function insertEmoji() {
      var _this$editor9, _this$editor10;

      var input = ":a";
      var hasText = (((_this$editor9 = this.editor) === null || _this$editor9 === void 0 ? void 0 : _this$editor9.getText().length) || 0) > 0;

      if (hasText) {
        input = " :a";
      }

      (_this$editor10 = this.editor) === null || _this$editor10 === void 0 ? void 0 : _this$editor10.chain().focus().insertContent(input).run();
    }
  }, {
    key: "setHeadingIds",
    value: function setHeadingIds() {
      if (!this.editor) return [];

      var _generateHeadings = utils_generateHeadings(this.editor),
          headings = _generateHeadings.headings,
          transaction = _generateHeadings.transaction;

      transaction === null || transaction === void 0 ? void 0 : transaction.setMeta("addToHistory", false);
      transaction === null || transaction === void 0 ? void 0 : transaction.setMeta("preventUpdate", true);
      this.editor.view.dispatch(transaction);
      return headings;
    }
  }, {
    key: "clearHistory",
    value: function clearHistory() {
      var _this$editor11;

      (_this$editor11 = this.editor) === null || _this$editor11 === void 0 ? void 0 : _this$editor11.destroy();
      this.initClient();
    }
  }, {
    key: "initClient",
    value: function initClient() {
      var _this2 = this;

      var parseStyleSize = this.parseStyleSize;
      var editorContainer = this.$refs.editorContainer;

      var _editorContainer$getB = editorContainer.getBoundingClientRect(),
          width = _editorContainer$getB.width;

      var _getComputedStyle = getComputedStyle(editorContainer),
          paddingLeft = _getComputedStyle.paddingLeft,
          paddingRight = _getComputedStyle.paddingRight;

      var maxImageWidth = width - parseStyleSize(paddingLeft) - parseStyleSize(paddingRight) - IMAGE_HANDLE_SIZE * 2;
      this.editor = new tiptap_vue_2_esm_Editor({
        extensions: computeEditorExtensions(this, this.options, maxImageWidth),
        content: this.content,
        editable: this.editable,
        onUpdate: function onUpdate(_ref) {
          var editor = _ref.editor;

          _this2.$emit("update", editor.getHTML());
        },
        onCreate: function onCreate(_ref2) {
          var editor = _ref2.editor;

          if (editor.isEditable && !_this2.menuOptions.hideDragHandle) {
            editor.registerPlugin(NodeDragPlugin(editor));
          }
        },
        editorProps: {
          attributes: {
            class: "mayday-editor__content__ProseMirror"
          }
        },
        onFocus: function onFocus() {
          _this2.$emit("focus");
        },
        onBlur: function onBlur() {
          _this2.$emit("blur");
        }
      });
    }
  }]);

  return MaydayEditor;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Boolean,
  default: false
}), __metadata("design:type", Boolean)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "editable", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Object
}), __metadata("design:type", typeof (MaydayEditorvue_type_script_lang_ts_a = typeof /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined !== "undefined" && /* Cannot get final name for export "ExtensionOptions" in "./src/utils/computeEditorExtensions.ts" (known exports: default, known reexports: ) */ undefined) === "function" ? MaydayEditorvue_type_script_lang_ts_a : Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "options", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String
}), __metadata("design:type", String)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "placeholder", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Boolean,
  default: false
}), __metadata("design:type", Boolean)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "isParametric", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: String,
  default: "https://app.mayday.fr"
}), __metadata("design:type", String)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "subdomain", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function
}), __metadata("design:type", Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "fetchInlineContentHandler", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function
}), __metadata("design:type", Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "fetchInlineMentionHandler", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function
}), __metadata("design:type", Function)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "generateTranslation", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function
}), __metadata("design:type", Function)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "generateStyle", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Function
}), __metadata("design:type", Function)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "generateGrammar", void 0);

__decorate([Object(external_vue_property_decorator_["Model"])("update"), __metadata("design:type", String)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "content", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Getter("isLoading"), __metadata("design:type", Boolean)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "isLoading", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Getter("isFileUploadCallbackProvided"), __metadata("design:type", Boolean)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "isFileUploadCallbackProvided", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Getter("nbFilesUploading"), __metadata("design:type", Number)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "nbFilesUploading", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Getter("filesAreUploading"), __metadata("design:type", Boolean)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "filesAreUploading", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Action("uploadFiles"), __metadata("design:type", Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "uploadFiles", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Action("searchInlineEntity"), __metadata("design:type", Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "searchInlineEntity", void 0);

__decorate([MaydayEditorvue_type_script_lang_ts_editorModule.Action("notifyUploadError"), __metadata("design:type", Object)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "notifyUploadError", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("editable"), __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", void 0)], MaydayEditorvue_type_script_lang_ts_MaydayEditor.prototype, "updateEditorEditable", null);

MaydayEditorvue_type_script_lang_ts_MaydayEditor = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    TextSelectionBubbleMenu: Bubble_TextSelectionBubbleMenu,
    TableBubbleMenu: Bubble_TableBubbleMenu,
    DividerBubbleMenu: Bubble_DividerBubbleMenu,
    CalloutBubbleMenu: Bubble_CalloutBubbleMenu,
    AttachmentBubbleMenu: Bubble_AttachmentBubbleMenu,
    InlineBubbleMenu: Bubble_InlineBubbleMenu,
    LinkBubbleMenu: Bubble_LinkBubbleMenu,
    ImageBubbleMenu: Bubble_ImageBubbleMenu,
    CellMenu: menus_CellMenu,
    SlashMenuCommandButton: Slash_SlashMenuCommandButton,
    Loader: components_Loader,
    EditorContent: EditorContent
  }
})], MaydayEditorvue_type_script_lang_ts_MaydayEditor);
/* harmony default export */ var MaydayEditorvue_type_script_lang_ts_ = (MaydayEditorvue_type_script_lang_ts_MaydayEditor);
// CONCATENATED MODULE: ./src/components/MaydayEditor.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_MaydayEditorvue_type_script_lang_ts_ = (MaydayEditorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/MaydayEditor.vue?vue&type=style&index=0&lang=scss&
var MaydayEditorvue_type_style_index_0_lang_scss_ = __webpack_require__("7b09");

// EXTERNAL MODULE: ./src/components/MaydayEditor.vue?vue&type=style&index=1&id=15f57550&lang=scss&scoped=true&
var MaydayEditorvue_type_style_index_1_id_15f57550_lang_scss_scoped_true_ = __webpack_require__("d199");

// CONCATENATED MODULE: ./src/components/MaydayEditor.vue







/* normalize component */

var MaydayEditor_component = normalizeComponent(
  components_MaydayEditorvue_type_script_lang_ts_,
  MaydayEditorvue_type_template_id_15f57550_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "15f57550",
  null
  
)

/* harmony default export */ var components_MaydayEditor = __webpack_exports__["a"] = (MaydayEditor_component.exports);

/***/ }),

/***/ "f5a5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f693":
/***/ (function(module) {

module.exports = JSON.parse("{\"mayday-editor\":{\"placeholder\":{\"editor-is-empty\":\"Écrivez quelque chose...\",\"node-is-empty\":\"Entrez '/' pour insérer un élément\"},\"file\":{\"uploading\":\"Envoi fichier | Envoi fichiers\",\"sizes\":[\"Octets\",\"Ko\",\"Mo\",\"Go\",\"To\",\"Po\",\"Eo\",\"Zo\",\"Yo\"]},\"attachment\":{\"unknown-file-size\":\"NC\",\"embed\":{\"no-support\":\"Votre navigateur ne supporte pas les contenus encapsulés. Merci d'utiliser un navigateur plus moderne tel que Chrome ou Firefox.\",\"download\":\"Télécharger manuellement le fichier\"},\"loader\":\"Chargement en cours ...\"},\"inline-content\":{\"missing-content\":\"CONTENU INCONNU\"},\"inline-mention\":{\"missing-user\":\"Utilisateur introuvable\",\"missing-role\":\"Rôle introuvable\"},\"embed\":{\"open-in-new-tab\":\"Cliquer ici pour agrandir\"},\"toc\":{\"empty\":\"Ajouter des titres à votre document\",\"untitled\":\"Sans titre\"},\"menu\":{\"text-selection\":{\"tooltip\":{\"bold\":\"Texte gras\",\"italic\":\"Texte italique\",\"underline\":\"Texte souligné\",\"strike\":\"Texte barré\",\"code\":\"Code\",\"align-left\":\"Texte à gauche\",\"align-center\":\"Texte centré\",\"align-right\":\"Texte a droite\",\"bullet-list\":\"Liste non ordonnée\",\"ordered-list\":\"Liste ordonnée\",\"highlight\":\"Texte surligné\",\"color\":\"Couleur du texte\",\"link\":\"Lien URL\",\"translation\":\"Traduire le texte sélectionné\",\"correction\":\"Corriger le texte sélectionné\",\"tone\":\"Améliorer le ton du texte sélectionné\",\"disabled\":\"Veuillez sélectionner des mots complets pour utiliser cette fonctionnalité\"}},\"cell\":{\"color\":\"Couleur de la cellule\",\"add-row-before\":\"Ajouter une ligne en haut\",\"add-row-after\":\"Ajouter une ligne en bas\",\"add-column-before\":\"Ajouter une colonne à gauche\",\"add-column-after\":\"Ajouter une colonne à droite\",\"delete-row\":\"Supprimer les lignes | Supprimer la ligne\",\"delete-column\":\"Supprimer les colonnes | Supprimer la colonne\",\"merge-cells\":\"Fusionner les cellules\",\"split-cell\":\"Séparer en cellules\"},\"table\":{\"tooltip\":{\"activate-header-row\":\"Changer la première ligne en entête\",\"activate-header-column\":\"Changer la première colonne en entête\",\"deactivate-header-row\":\"Enlever la première ligne en entête\",\"deactivate-header-column\":\"Enlever la première colonne en entête\",\"delete-table\":\"Supprimer le tableau\"}},\"slash\":{\"no-results\":\"Aucune action possible\",\"title\":{\"paragraph\":\"Paragraphe\",\"image\":\"Image\",\"attachment\":\"Fichier attaché\",\"h1\":\"Titre 1\",\"h2\":\"Titre 2\",\"h3\":\"Titre 3\",\"h4\":\"Titre 4\",\"bullet-list\":\"Liste non-ordonnée\",\"ordered-list\":\"Liste ordonnée\",\"table\":\"Tableau\",\"blockquote\":\"Citation\",\"codeblock\":\"Code\",\"divider\":\"Diviseur\",\"callout\":\"Infobulle\",\"emoji\":\"Emoji\",\"inline-content\":\"Contenu Mayday\",\"inline-mention\":\"Utilisateur Mayday\",\"details\":\"Liste déroulante\",\"toc\":\"Table des matières\",\"summary\":\"Résumer\",\"translate\":\"Traduire\",\"correct\":\"Corriger\",\"tone\":\"Améliorer le ton\",\"action-items\":\"Action items\"},\"options\":{\"translate\":{\"fr-fr\":\"Français\",\"en-us\":\"Anglais\",\"es-es\":\"Espagnol\",\"de-de\":\"Allemand\",\"it-it\":\"Italien\",\"pt-pt\":\"Portugais\",\"nl-nl\":\"Néerlandais\",\"zh-cn\":\"Chinois\",\"ru-ru\":\"Russe\"},\"summary\":{\"short\":\"Résumé court\",\"long\":\"Résumé détaillé\"}},\"footer-description\":{\"paragraph\":\"Rédiger un paragraphe textuel\",\"image\":\"Insérer une image\",\"attachment\":\"Insérer un fichier attaché\",\"h1\":\"Insérer un titre 1\",\"h2\":\"Insérer un titre 2\",\"h3\":\"Insérer un titre 3\",\"h4\":\"Insérer un titre 4\",\"bullet-list\":\"Insérer une liste non ordonnée\",\"ordered-list\":\"Insérer une liste ordonnée\",\"table\":\"Insérer un tableau\",\"blockquote\":\"Insérer une citation\",\"codeblock\":\"Insérer un bloc de code\",\"divider\":\"Insérer un diviseur\",\"callout\":\"Insérer un infobulle\",\"emoji\":\"Insérer un emoji\",\"inline-content\":\"Rediriger vers un contenu Mayday\",\"inline-mention\":\"Mentionner vers un utilisateur Mayday\",\"details\":\"Insérer une liste déroulante\",\"toc\":\"Insérer une table des matières\",\"help\":\"Aide\",\"no-results\":\"Tapper un autre terme de recherche\",\"summary\":\"Générer automatiquement un résumé\",\"translate\":\"Traduire le contenu\",\"correct\":\"Corriger le contenu\",\"tone\":\"Améliorer le ton du contenu\",\"action-items\":\"Générer automatiquement une liste d'action\"}},\"emoji\":{\"smileys & emotion\":\"Émotions\",\"people & body\":\"Personnes\",\"components\":\"Composants\",\"animals & nature\":\"Animaux et nature\",\"food & drink\":\"Nourriture et boisson\",\"travel & places\":\"Voyage et lieux\",\"activities\":\"Activités\",\"objects\":\"Objets\",\"symbols\":\"Symboles\",\"flags\":\"Drapeaux\",\"GitHub\":\"Autres\"},\"inline-content\":{\"no-results\":\"Aucun résultat\",\"empty-description\":\"Attaché à une fiche produit\",\"types\":{\"contents\":\"Contenus\",\"users\":\"Utilisateurs\",\"roles\":\"Rôles\",\"cases\":\"Collections\"},\"tooltip\":{\"set-as-default\":\"Mentionner le contenu\",\"set-as-link\":\"Afficher en lien\",\"set-as-embed\":\"Afficher en encapsulé\",\"open-link\":\"Ouvrir le lien\",\"delete\":\"Supprimer la mention\"}},\"divider\":{\"delete\":\"Supprimer le diviseur\"},\"callout\":{\"info\":\"Info\",\"success\":\"Succès\",\"danger\":\"Danger\",\"error\":\"Erreur\",\"delete\":\"Supprimer l'infobulle\"},\"link\":{\"tooltip\":{\"open-link\":\"Ouvrir le lien\",\"open-embed\":\"Ouvrir la capsule\",\"url\":\"Changer l'adresse URL du lien\",\"title\":\"Changer le titre du lien\",\"make-link\":\"Changer en lien\",\"make-embed\":\"Changer en capsule\",\"open-in-modal\":\"Ouvrir dans une fenêtre\",\"remove-link\":\"Retirer le lien\",\"delete-embed\":\"Supprimer la capsule\",\"make-inline\":\"Mentionner le contenu\"},\"title-placeholder\":\"Titre du lien\",\"close\":\"Fermer\"},\"translate\":{\"close\":\"Fermer\",\"title\":\"Traduction\",\"run\":\"Traduire le texte sélectionné\",\"replace\":\"Remplacer le texte\",\"append\":\"Ajouter à la suite du texte\",\"cancel\":\"Annuler\",\"generating\":\"Génération...\",\"languages\":{\"fr-fr\":\"Français\",\"en-us\":\"Anglais\",\"es-es\":\"Espagnol\",\"de-de\":\"Allemand\",\"it-it\":\"Italien\",\"pt-pt\":\"Portugais\",\"ru-ru\":\"Russe\",\"zh-cn\":\"Chinois\",\"ja-jp\":\"Japonais\",\"nl-nl\":\"Néerlandais\"},\"flags\":{\"fr-fr\":\"🇫🇷\",\"en-gb\":\"🇬🇧\",\"en-us\":\"🇺🇸\",\"es-es\":\"🇪🇸\",\"de-de\":\"🇩🇪\",\"it-it\":\"🇮🇹\",\"pt-pt\":\"🇵🇹\",\"ru-ru\":\"🇷🇺\",\"zh-cn\":\"🇨🇳\",\"ja-jp\":\"🇯🇵\",\"nl-nl\":\"🇳🇱\"}},\"image\":{\"alt-tooltip\":\"Changer attribut alt de l'image\",\"alt-placeholder\":\"Alt de l'image\"},\"attachment\":{\"type\":{\"pdf\":\"PDF\",\"sheet\":\"Excel\",\"video\":\"Vidéo\",\"other\":\"Fichier\",\"doc\":\"Doc\",\"slide\":\"Slide\"},\"set-as-default\":\"Afficher en bloc\",\"set-as-link\":\"Afficher en lien\",\"set-as-embed\":\"Afficher en encapsulé\",\"title\":\"Changer le titre\",\"download\":\"Télécharger\",\"delete\":\"Supprimer le fichier attaché\"},\"options\":{\"copy\":\"Copier le lien vers le bloc\"}}}}");

/***/ }),

/***/ "f6c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContent_vue_vue_type_style_index_0_id_32c3746c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f53a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContent_vue_vue_type_style_index_0_id_32c3746c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineContent_vue_vue_type_style_index_0_id_32c3746c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f853":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkMenu_vue_vue_type_style_index_0_id_30fb0561_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2fb0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkMenu_vue_vue_type_style_index_0_id_30fb0561_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_9_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LinkMenu_vue_vue_type_style_index_0_id_30fb0561_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "editorStore", function() { return /* reexport */ main["b" /* editorStore */]; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/main.ts
var main = __webpack_require__("cd49");

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main["a" /* default */]);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var un$Slice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1da1");
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("96cf");
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e6cf");
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("d81d");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _mutations_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("07cd");









/* harmony default export */ __webpack_exports__["a"] = ({
  uploadFiles: function uploadFiles(_ref, files) {
    return Object(_builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, state, handler, uploadedFiles;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.prev = 1;
              handler = state.callbacks.handleFileUpload;

              if (!(handler == null)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", []);

            case 5:
              commit(_mutations_types__WEBPACK_IMPORTED_MODULE_8__[/* SET_FILES_ARE_UPLOADING */ "a"], true);
              commit(_mutations_types__WEBPACK_IMPORTED_MODULE_8__[/* SET_FILES_NUMBER_UPLOADING */ "b"], files.length);
              _context.next = 9;
              return Promise.all(files.map(function (file) {
                return handler(file);
              }));

            case 9:
              uploadedFiles = _context.sent;
              commit(_mutations_types__WEBPACK_IMPORTED_MODULE_8__[/* SET_FILES_ARE_UPLOADING */ "a"], false);
              return _context.abrupt("return", uploadedFiles);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              commit(_mutations_types__WEBPACK_IMPORTED_MODULE_8__[/* SET_FILES_ARE_UPLOADING */ "a"], false);
              return _context.abrupt("return", [null]);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }))();
  },
  notifyUploadError: function notifyUploadError(_ref2, error) {
    return Object(_builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var state, handler;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref2.state;
              handler = state.callbacks.notifyUploadError;

              if (!(handler == null)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", null);

            case 4:
              handler(error);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  fetchInlineContent: function fetchInlineContent(_ref3, _ref4) {
    return Object(_builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var state, contentId, lang, type, handler;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref3.state;
              contentId = _ref4.contentId, lang = _ref4.lang, type = _ref4.type;
              handler = state.callbacks.handleFetchInlineContent;

              if (!(handler == null)) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return", null);

            case 5:
              return _context3.abrupt("return", handler({
                contentId: contentId,
                lang: lang,
                type: type
              }));

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  fetchInlineMention: function fetchInlineMention(_ref5, _ref6) {
    return Object(_builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var state, entityId, entityType, handler;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref5.state;
              entityId = _ref6.entityId, entityType = _ref6.entityType;
              handler = state.callbacks.handleFetchInlineMention;

              if (!(handler == null)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", null);

            case 5:
              return _context4.abrupt("return", handler({
                entityId: entityId,
                entityType: entityType
              }));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  searchInlineEntity: function searchInlineEntity(_ref7, query) {
    return Object(_builds_getmayday_modules_editor_modules_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var state, handler;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref7.state;
              handler = state.callbacks.handleSearchInlineEntity;

              if (!(handler == null)) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return");

            case 4:
              return _context5.abrupt("return", handler(query));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
});

/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ff58":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ })["default"];
});
//# sourceMappingURL=mayday-editor.umd.js.map